
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c7lrN", function(module, exports) {

$parcel$export(module.exports, "equals", () => equals);
$parcel$export(module.exports, "op_Addition", () => op_Addition);
$parcel$export(module.exports, "fromZero", () => fromZero);
$parcel$export(module.exports, "fromInt32", () => fromInt32);
$parcel$export(module.exports, "fromFloat64", () => fromFloat64);
$parcel$export(module.exports, "fromString", () => fromString);
$parcel$export(module.exports, "toInt64", () => toInt64);
$parcel$export(module.exports, "toUInt64", () => toUInt64);
$parcel$export(module.exports, "toFloat64", () => toFloat64);
$parcel$export(module.exports, "toString", () => toString);
$parcel$export(module.exports, "parse", () => parse);

var $fzAFM = parcelRequire("fzAFM");

var $kRS0m = parcelRequire("kRS0m");
const isBigEndian = false;
BigInt.prototype.toJSON = function() {
    return `${this.toString()}`;
};
const zero = 0n;
const one = 1n;
const two = 2n;
const minusOne = -1n;
function isBigInt(x) {
    return typeof x === "bigint";
}
function hash(x) {
    return (0, $kRS0m.bigintHash)(x);
}
function equals(x, y) {
    return x === y;
}
function compare(x, y) {
    return x < y ? -1 : x > y ? 1 : 0;
}
function abs(x) {
    return x < zero ? -x : x;
}
function sign(x) {
    return x < zero ? -1 : x > zero ? 1 : 0;
}
function max(x, y) {
    return x > y ? x : y;
}
function min(x, y) {
    return x < y ? x : y;
}
function maxMagnitude(x, y) {
    return abs(x) > abs(y) ? x : y;
}
function minMagnitude(x, y) {
    return abs(x) < abs(y) ? x : y;
}
function clamp(x, min, max) {
    return x < min ? min : x > max ? max : x;
}
function add(x, y) {
    return x + y;
}
function subtract(x, y) {
    return x - y;
}
function multiply(x, y) {
    return x * y;
}
function divide(x, y) {
    return x / y;
}
function remainder(x, y) {
    return x % y;
}
function negate(x) {
    return -x;
}
function op_UnaryNegation(x) {
    return -x;
}
function op_LogicalNot(x) {
    return ~x;
}
function op_UnaryPlus(x) {
    return x;
}
function op_Addition(x, y) {
    return x + y;
}
function op_Subtraction(x, y) {
    return x - y;
}
function op_Multiply(x, y) {
    return x * y;
}
function op_Division(x, y) {
    return x / y;
}
function op_Modulus(x, y) {
    return x % y;
}
function op_RightShift(x, n) {
    return x >> BigInt(n);
}
function op_LeftShift(x, n) {
    return x << BigInt(n);
}
function op_BitwiseAnd(x, y) {
    return x & y;
}
function op_BitwiseOr(x, y) {
    return x | y;
}
function op_ExclusiveOr(x, y) {
    return x ^ y;
}
function op_LessThan(x, y) {
    return x < y;
}
function op_LessThanOrEqual(x, y) {
    return x <= y;
}
function op_GreaterThan(x, y) {
    return x > y;
}
function op_GreaterThanOrEqual(x, y) {
    return x >= y;
}
function op_Equality(x, y) {
    return x === y;
}
function op_Inequality(x, y) {
    return x !== y;
}
function get_Zero() {
    return zero;
}
function get_One() {
    return one;
}
function get_MinusOne() {
    return minusOne;
}
function get_IsZero(x) {
    return x === zero;
}
function get_IsOne(x) {
    return x === one;
}
function get_IsEven(x) {
    return isEvenInteger(x);
}
function get_IsPowerOfTwo(x) {
    return isPow2(x);
}
function get_Sign(x) {
    return sign(x);
}
function isNegative(x) {
    return x < zero;
}
function isPositive(x) {
    return x > zero;
}
function isEvenInteger(x) {
    return x % two === zero;
}
function isOddInteger(x) {
    return x % two !== zero;
}
function isPow2(x) {
    return (x & x - one) === zero;
}
function fromZero() {
    return zero;
}
function fromOne() {
    return one;
}
function fromInt8(n) {
    return BigInt(n);
}
function fromUInt8(n) {
    return BigInt(n);
}
function fromInt16(n) {
    return BigInt(n);
}
function fromUInt16(n) {
    return BigInt(n);
}
function fromInt32(n) {
    return BigInt(n);
}
function fromUInt32(n) {
    return BigInt(n);
}
function fromInt64(n) {
    return n;
}
function fromUInt64(n) {
    return n;
}
function fromInt128(n) {
    return n;
}
function fromUInt128(n) {
    return n;
}
function fromNativeInt(n) {
    return n;
}
function fromUNativeInt(n) {
    return n;
}
function fromFloat16(n) {
    return BigInt(Math.trunc(n));
}
function fromFloat32(n) {
    return BigInt(Math.trunc(n));
}
function fromFloat64(n) {
    return BigInt(Math.trunc(n));
}
function fromDecimal(d) {
    return BigInt((0, $fzAFM.truncate)(d).toString());
}
function fromBigInt(x) {
    return x;
}
function fromBoolean(b) {
    return BigInt(b);
}
function fromChar(c) {
    return BigInt(c.charCodeAt(0));
}
function fromString(s) {
    return BigInt(s);
}
function fromByteArray(bytes) {
    return fromSignedBytes(bytes, isBigEndian);
}
function toByteArray(value) {
    return toSignedBytes(value, isBigEndian);
}
function toInt8(x) {
    return Number(BigInt.asIntN(8, x));
}
function toUInt8(x) {
    return Number(BigInt.asUintN(8, x));
}
function toInt16(x) {
    return Number(BigInt.asIntN(16, x));
}
function toUInt16(x) {
    return Number(BigInt.asUintN(16, x));
}
function toInt32(x) {
    return Number(BigInt.asIntN(32, x));
}
function toUInt32(x) {
    return Number(BigInt.asUintN(32, x));
}
function toInt64(x) {
    return BigInt.asIntN(64, x);
}
function toUInt64(x) {
    return BigInt.asUintN(64, x);
}
function toInt128(x) {
    return BigInt.asIntN(128, x);
}
function toUInt128(x) {
    return BigInt.asUintN(128, x);
}
function toNativeInt(x) {
    return BigInt.asIntN(64, x);
}
function toUNativeInt(x) {
    return BigInt.asUintN(64, x);
}
function toFloat16(x) {
    return Number(x);
}
function toFloat32(x) {
    return Number(x);
}
function toFloat64(x) {
    return Number(x);
}
function toDecimal(x) {
    const isNegative = x < zero;
    const bits = abs(x);
    const low = Number(BigInt.asUintN(32, bits));
    const mid = Number(BigInt.asUintN(32, bits >> 32n));
    const high = Number(BigInt.asUintN(32, bits >> 64n));
    const scale = 0;
    return (0, $fzAFM.fromParts)(low, mid, high, isNegative, scale);
}
function toBigInt(x) {
    return x;
}
function toBoolean(x) {
    return x !== zero;
}
function toChar(x) {
    return String.fromCharCode(toUInt16(x));
}
function toString(x) {
    return x.toString();
}
function tryParse(s, res) {
    try {
        res.contents = BigInt(s);
        return true;
    } catch (err) {
        return false;
    }
}
function parse(s) {
    return BigInt(s);
}
function pow(x, n) {
    return x ** BigInt(n);
}
function modPow(x, e, m) {
    return x ** e % m;
}
function divRem(x, y, out) {
    const div = x / y;
    const rem = x % y;
    if (out === void 0) return [
        div,
        rem
    ];
    else {
        out.contents = rem;
        return div;
    }
}
function greatestCommonDivisor(x, y) {
    while(y > zero){
        const q = x / y;
        const r = x - q * y;
        x = y;
        y = r;
    }
    return x;
}
function getBitLength(x) {
    return fromFloat64(x === zero ? 1 : log2(abs(x)) + 1);
}
function log2(x) {
    const n = Number(x);
    if (Number.isFinite(n)) return Math.log2(n); // fast path
    if (x < zero) return Number.NaN;
    let shift = one;
    while(x >= one << shift)shift = shift << one;
    let log = zero;
    while(shift > one){
        shift = shift >> one;
        if (x >= one << shift) {
            log = log + shift;
            x = x >> shift;
        }
    }
    return Number(log);
}
function log10(x) {
    return log2(x) * Math.log10(2);
}
function ln(x) {
    return log2(x) * Math.log(2);
}
function log(x, base) {
    return log2(x) / Math.log2(base);
}
function ilog2(x) {
    return BigInt(log2(x));
}
// export function copySign
// export function createChecked
// export function createSaturating
// export function createTruncating
// export function getByteCount
// export function leadingZeroCount
// export function popCount
// export function rotateLeft
// export function rotateRight
// export function trailingZeroCount
// export function tryFormat
// export function tryWriteBytes
// -------------------------------------------------
// Binary serialization
// -------------------------------------------------
const hexCodes = new Uint8Array([
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    97,
    98,
    99,
    100,
    101,
    102
]);
function fromHexCode(code) {
    if (48 <= code && code <= 57) return code - 48;
    if (97 <= code && code <= 102) return code - 97 + 10;
    if (65 <= code && code <= 70) return code - 65 + 10;
    throw Error(`Invalid hex code: ${code}`);
}
function toSignedBytes(x, isBigEndian) {
    const isNeg = x < 0n;
    if (isNeg) {
        const len = log2(-x);
        const bits = len + (8 - len % 8);
        const pow2 = 1n << BigInt(bits);
        x = x + pow2; // two's complement
    }
    const hex = x.toString(16);
    const len = hex.length;
    const odd = len % 2;
    const first = hex.charCodeAt(0);
    const isLow = 48 <= first && first <= 55; // 0..7
    const start = isNeg && isLow || !isNeg && !isLow ? 1 : 0;
    const bytes = new Uint8Array(start + (len + odd) / 2);
    const inc = isBigEndian ? 1 : -1;
    let pos = isBigEndian ? 0 : bytes.length - 1;
    if (start > 0) {
        bytes[pos] = isNeg ? 255 : 0;
        pos += inc;
    }
    if (odd > 0) {
        bytes[pos] = fromHexCode(first);
        pos += inc;
    }
    for(let i = odd; i < len; i += 2, pos += inc){
        const a = fromHexCode(hex.charCodeAt(i));
        const b = fromHexCode(hex.charCodeAt(i + 1));
        bytes[pos] = a << 4 | b;
    }
    return bytes;
}
function fromSignedBytes(bytes, isBigEndian) {
    if (bytes == null) throw new Error("bytes is null");
    const len = bytes.length;
    const first = isBigEndian ? 0 : len - 1;
    const isNeg = bytes[first] > 127;
    const codes = new Uint16Array(len * 2 + 2);
    codes[0] = 48; // 0
    codes[1] = 120; // x
    const inc = isBigEndian ? 1 : -1;
    let pos = isBigEndian ? 0 : len - 1;
    for(let i = 0; i < bytes.length; i++, pos += inc){
        const byte = bytes[pos];
        codes[2 * i + 2] = hexCodes[byte >> 4];
        codes[2 * i + 3] = hexCodes[byte & 15];
    }
    const str = String.fromCharCode.apply(null, codes);
    let x = BigInt(str);
    if (isNeg) {
        const bits = len * 8;
        const pow2 = 1n << BigInt(bits);
        x = x - pow2; // two's complement
    }
    return x;
}

});
parcelRegister("fzAFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b566925e1796f575$export$2e2bcd8739ae039);
$parcel$export(module.exports, "truncate", () => $b566925e1796f575$export$6a506b36fdea397d);
$parcel$export(module.exports, "op_Addition", () => $b566925e1796f575$export$a5fb1fdca49990a);
$parcel$export(module.exports, "toString", () => $b566925e1796f575$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "tryParse", () => $b566925e1796f575$export$468ff95b83d315e5);
$parcel$export(module.exports, "fromParts", () => $b566925e1796f575$export$4ce09b63b66aecc9);

var $3Nn94 = parcelRequire("3Nn94");

var $5OTL5 = parcelRequire("5OTL5");

var $eATN7 = parcelRequire("eATN7");

var $kRS0m = parcelRequire("kRS0m");
(0, $3Nn94.default).prototype.GetHashCode = function() {
    return (0, $kRS0m.combineHashCodes)([
        this.s,
        this.e
    ].concat(this.c));
};
(0, $3Nn94.default).prototype.Equals = function(x) {
    return !this.cmp(x);
};
(0, $3Nn94.default).prototype.CompareTo = function(x) {
    return this.cmp(x);
};
(0, $3Nn94.default).prototype[0, $5OTL5.symbol] = function() {
    const _this = this;
    return {
        multiply: (y)=>_this.mul(y),
        toPrecision: (sd)=>_this.toPrecision(sd),
        toExponential: (dp)=>_this.toExponential(dp),
        toFixed: (dp)=>_this.toFixed(dp),
        toHex: ()=>(Number(_this) >>> 0).toString(16)
    };
};
var $b566925e1796f575$export$2e2bcd8739ae039 = (0, $3Nn94.default);
const $b566925e1796f575$export$1a6223d840786ec0 = new (0, $3Nn94.default)(0);
const $b566925e1796f575$export$ae43249cd38c8649 = new (0, $3Nn94.default)(1);
const $b566925e1796f575$export$75e2aaa55d56b95a = new (0, $3Nn94.default)(-1);
const $b566925e1796f575$export$67edc40118395795 = new (0, $3Nn94.default)("79228162514264337593543950335");
const $b566925e1796f575$export$8ebb19e07f98fc82 = new (0, $3Nn94.default)("-79228162514264337593543950335");
function $b566925e1796f575$export$398604a469f7de9a(x, y) {
    return x.cmp(y);
}
function $b566925e1796f575$export$e9bab7fafb253603(x, y) {
    return !x.cmp(y);
}
function $b566925e1796f575$export$2335f513bbd82c6d(x) {
    return x.abs();
}
function $b566925e1796f575$export$c5552dfdbc7cec71(x) {
    return x.lt($b566925e1796f575$export$1a6223d840786ec0) ? -1 : x.gt($b566925e1796f575$export$1a6223d840786ec0) ? 1 : 0;
}
function $b566925e1796f575$export$8960430cfd85939f(x, y) {
    return x.gt(y) ? x : y;
}
function $b566925e1796f575$export$96ec731ed4dcb222(x, y) {
    return x.lt(y) ? x : y;
}
function $b566925e1796f575$export$d5c1c11e7369f9ca(x, y) {
    return $b566925e1796f575$export$2335f513bbd82c6d(x).gt($b566925e1796f575$export$2335f513bbd82c6d(y)) ? x : y;
}
function $b566925e1796f575$export$98c4be7bef211208(x, y) {
    return $b566925e1796f575$export$2335f513bbd82c6d(x).lt($b566925e1796f575$export$2335f513bbd82c6d(y)) ? x : y;
}
function $b566925e1796f575$export$7d15b64cf5a3a4c4(x, min, max) {
    return x.lt(min) ? min : x.gt(max) ? max : x;
}
function $b566925e1796f575$export$2077e0241d6afd3c(x, digits = 0) {
    return x.round(digits, 2 /* ROUND_HALF_EVEN */ );
}
function $b566925e1796f575$export$6a506b36fdea397d(x) {
    return x.round(0, 0 /* ROUND_DOWN */ );
}
function $b566925e1796f575$export$1d7d6ea1b95b29ae(x) {
    return x.round(0, x.cmp(0) >= 0 ? 3 /* ROUND_UP */  : 0 /* ROUND_DOWN */ );
}
function $b566925e1796f575$export$a3fe094919f356fd(x) {
    return x.round(0, x.cmp(0) >= 0 ? 0 /* ROUND_DOWN */  : 3 /* ROUND_UP */ );
}
function $b566925e1796f575$export$9c297f60e22e3389(x, n) {
    return x.pow(n);
}
function $b566925e1796f575$export$eba8049fb5020b81(x) {
    return x.sqrt();
}
function $b566925e1796f575$export$a5fb1fdca49990a(x, y) {
    return x.add(y);
}
function $b566925e1796f575$export$1ba572a54983744c(x, y) {
    return x.sub(y);
}
function $b566925e1796f575$export$bef948e98114a357(x, y) {
    return x.mul(y);
}
function $b566925e1796f575$export$a6e41fbebc04a9a6(x, y) {
    return x.div(y);
}
function $b566925e1796f575$export$ded19a969d94df2c(x, y) {
    return x.mod(y);
}
function $b566925e1796f575$export$816012df0c0b827b(x) {
    const x2 = new (0, $3Nn94.default)(x);
    x2.s = -x2.s || 0;
    return x2;
}
function $b566925e1796f575$export$a710d0a415bc2a3f(x) {
    return x;
}
const $b566925e1796f575$export$e16d8520af44a096 = $b566925e1796f575$export$a5fb1fdca49990a;
const $b566925e1796f575$export$4e2d2ead65e5f7e3 = $b566925e1796f575$export$1ba572a54983744c;
const $b566925e1796f575$export$2060d2db72cce88f = $b566925e1796f575$export$bef948e98114a357;
const $b566925e1796f575$export$cd007d971a5a2143 = $b566925e1796f575$export$a6e41fbebc04a9a6;
const $b566925e1796f575$export$159037f780d3415c = $b566925e1796f575$export$ded19a969d94df2c;
const $b566925e1796f575$export$aef51622e549b8b0 = $b566925e1796f575$export$816012df0c0b827b;
function $b566925e1796f575$export$f84e8e69fd4488a5(x) {
    return x.toString();
}
function $b566925e1796f575$export$468ff95b83d315e5(str, defValue) {
    try {
        defValue.contents = new (0, $3Nn94.default)(str.trim());
        return true;
    } catch  {
        return false;
    }
}
function $b566925e1796f575$export$98e6a39c04603d36(str) {
    const defValue = new (0, $eATN7.FSharpRef)($b566925e1796f575$export$1a6223d840786ec0);
    if ($b566925e1796f575$export$468ff95b83d315e5(str, defValue)) return defValue.contents;
    else throw new Error(`The input string ${str} was not in a correct format.`);
}
function $b566925e1796f575$export$a0a81dc3380ce7d3(x) {
    return +x;
}
function $b566925e1796f575$var$decimalToHex(dec, bitSize) {
    const hex = new Uint8Array(bitSize / 4 | 0);
    let hexCount = 1;
    for(let d = 0; d < dec.length; d++){
        let value = dec[d];
        for(let i = 0; i < hexCount; i++){
            const digit = hex[i] * 10 + value | 0;
            hex[i] = digit & 0xF;
            value = digit >> 4;
        }
        if (value !== 0) hex[hexCount++] = value;
    }
    return hex.slice(0, hexCount); // digits in reverse order
}
function $b566925e1796f575$var$hexToDecimal(hex, bitSize) {
    const dec = new Uint8Array(bitSize * 301 / 1000 + 1 | 0);
    let decCount = 1;
    for(let d = hex.length - 1; d >= 0; d--){
        let carry = hex[d];
        for(let i = 0; i < decCount; i++){
            const val = dec[i] * 16 + carry | 0;
            dec[i] = val % 10 | 0;
            carry = val / 10 | 0;
        }
        while(carry > 0){
            dec[decCount++] = carry % 10 | 0;
            carry = carry / 10 | 0;
        }
    }
    return dec.slice(0, decCount); // digits in reverse order
}
function $b566925e1796f575$var$setInt32Bits(hexDigits, bits, offset) {
    for(let i = 0; i < 8; i++)hexDigits[offset + i] = bits >> i * 4 & 0xF;
}
function $b566925e1796f575$var$getInt32Bits(hexDigits, offset) {
    let bits = 0;
    for(let i = 0; i < 8; i++)bits = bits | hexDigits[offset + i] << i * 4;
    return bits;
}
function $b566925e1796f575$export$a2cc8ea05f36c769(bits) {
    return $b566925e1796f575$export$6f511d4f8a01d621(bits[0], bits[1], bits[2], bits[3]);
}
function $b566925e1796f575$export$6f511d4f8a01d621(low, mid, high, signExp) {
    const isNegative = signExp < 0;
    const scale = signExp >> 16 & 0x7F;
    return $b566925e1796f575$export$4ce09b63b66aecc9(low, mid, high, isNegative, scale);
}
function $b566925e1796f575$export$4ce09b63b66aecc9(low, mid, high, isNegative, scale) {
    const bitSize = 96;
    const hexDigits = new Uint8Array(bitSize / 4);
    $b566925e1796f575$var$setInt32Bits(hexDigits, low, 0);
    $b566925e1796f575$var$setInt32Bits(hexDigits, mid, 8);
    $b566925e1796f575$var$setInt32Bits(hexDigits, high, 16);
    const decDigits = $b566925e1796f575$var$hexToDecimal(hexDigits, bitSize);
    scale = scale & 0x7F;
    const big = new (0, $3Nn94.default)(0);
    big.c = Array.from(decDigits.reverse());
    big.e = decDigits.length - scale - 1;
    big.s = isNegative ? -1 : 1;
    const d = new (0, $3Nn94.default)(big);
    return d;
}
function $b566925e1796f575$export$afb88973713cb16a(d) {
    const bitSize = 96;
    const decDigits = Uint8Array.from(d.c);
    const hexDigits = $b566925e1796f575$var$decimalToHex(decDigits, bitSize);
    const low = $b566925e1796f575$var$getInt32Bits(hexDigits, 0);
    const mid = $b566925e1796f575$var$getInt32Bits(hexDigits, 8);
    const high = $b566925e1796f575$var$getInt32Bits(hexDigits, 16);
    const decStr = d.toString();
    const dotPos = decStr.indexOf(".");
    const scale = dotPos < 0 ? 0 : decStr.length - dotPos - 1;
    const signExp = (scale & 0x7F) << 16 | (d.s < 0 ? 0x80000000 : 0);
    return [
        low,
        mid,
        high,
        signExp
    ];
} // export function makeRangeStepFunction(step: Decimal, last: Decimal) {
 //   const stepComparedWithZero = step.cmp(get_Zero);
 //   if (stepComparedWithZero === 0) {
 //     throw new Error("The step of a range cannot be zero");
 //   }
 //   const stepGreaterThanZero = stepComparedWithZero > 0;
 //   return (x: Decimal) => {
 //     const comparedWithLast = x.cmp(last);
 //     if ((stepGreaterThanZero && comparedWithLast <= 0)
 //       || (!stepGreaterThanZero && comparedWithLast >= 0)) {
 //       return [x, op_Addition(x, step)];
 //     } else {
 //       return undefined;
 //     }
 //   };
 // }

});
parcelRegister("3Nn94", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c37e6e19f540083$export$2e2bcd8739ae039);
// Adapted from https://github.com/MikeMcl/big.js/blob/0f94dc9110d55c4f324a47ba6a2e832ce23ac589/big.mjs
var $2c37e6e19f540083$var$P = {};
/*
 *  big.js v6.0.3
 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
 *  Copyright (c) 2020 Michael Mclaughlin
 *  https://github.com/MikeMcl/big.js/LICENCE.md
 */ /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
/*
 * The maximum number of decimal places (DP) of the results of operations involving division:
 * div and sqrt, and pow with negative exponents.
 */ var $2c37e6e19f540083$var$DP = 28, /*
 * The rounding mode (RM) used when rounding to the above decimal places.
 *
 *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
 *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
 *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
 *  3  Away from zero.                                  (ROUND_UP)
 */ $2c37e6e19f540083$var$RM = 1, // The maximum value of DP and Big.DP.
$2c37e6e19f540083$var$MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
$2c37e6e19f540083$var$MAX_POWER = 1E6, /*
 * The negative exponent (NE) at and beneath which toString returns exponential notation.
 * (JavaScript numbers: -7)
 * -1000000 is the minimum recommended exponent value of a Big.
 */ $2c37e6e19f540083$var$NE = -29, /*
 * The positive exponent (PE) at and above which toString returns exponential notation.
 * (JavaScript numbers: 21)
 * 1000000 is the maximum recommended exponent value of a Big, but this limit is not enforced.
 */ $2c37e6e19f540083$var$PE = 29, /*
 * When true, an error will be thrown if a primitive number is passed to the Big constructor,
 * or if valueOf is called, or if toNumber is called on a Big which cannot be converted to a
 * primitive number without a loss of precision.
 */ $2c37e6e19f540083$var$STRICT = false, /**************************************************************************************************/ // Error messages.
$2c37e6e19f540083$var$NAME = '[big.js] ', $2c37e6e19f540083$var$INVALID = $2c37e6e19f540083$var$NAME + 'Invalid ', $2c37e6e19f540083$var$INVALID_DP = $2c37e6e19f540083$var$INVALID + 'decimal places', $2c37e6e19f540083$var$INVALID_RM = $2c37e6e19f540083$var$INVALID + 'rounding mode', $2c37e6e19f540083$var$DIV_BY_ZERO = $2c37e6e19f540083$var$NAME + 'Division by zero', $2c37e6e19f540083$var$UNDEFINED = void 0, $2c37e6e19f540083$var$NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
/*
 * Create and return a Big constructor.
 */ function $2c37e6e19f540083$var$_Big_() {
    /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
        var x = this;
        // Enable constructor usage without new.
        if (!(x instanceof Big)) return n === $2c37e6e19f540083$var$UNDEFINED ? $2c37e6e19f540083$var$_Big_() : new Big(n);
        // Duplicate.
        if (n instanceof Big) {
            x.s = n.s;
            x.e = n.e;
            x.c = n.c.slice();
            $2c37e6e19f540083$var$normalize(x);
        } else {
            if (typeof n !== 'string') {
                if (Big.strict === true) throw TypeError($2c37e6e19f540083$var$INVALID + 'number');
                // Minus zero?
                n = n === 0 && 1 / n < 0 ? '-0' : String(n);
            }
            $2c37e6e19f540083$var$parse(x, n);
        }
        // Retain a reference to this Big constructor.
        // Shadow Big.prototype.constructor which points to Object.
        x.constructor = Big;
    }
    Big.prototype = $2c37e6e19f540083$var$P;
    Big.DP = $2c37e6e19f540083$var$DP;
    Big.RM = $2c37e6e19f540083$var$RM;
    Big.NE = $2c37e6e19f540083$var$NE;
    Big.PE = $2c37e6e19f540083$var$PE;
    Big.strict = $2c37e6e19f540083$var$STRICT;
    return Big;
}
function $2c37e6e19f540083$var$normalize(x) {
    // x = round(x, DP, 0);
    if (x.c.length > 1 && !x.c[0]) {
        let i = x.c.findIndex((x)=>x);
        x.c = x.c.slice(i);
        x.e = x.e - i;
    }
}
/*
 * Parse the number or string value passed to a Big constructor.
 *
 * x {Big} A Big number instance.
 * n {number|string} A numeric value.
 */ function $2c37e6e19f540083$var$parse(x, n) {
    var e, i, nl;
    if (!$2c37e6e19f540083$var$NUMERIC.test(n)) throw Error($2c37e6e19f540083$var$INVALID + 'number');
    // Determine sign.
    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
    // Decimal point?
    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
    // Exponential form?
    if ((i = n.search(/e/i)) > 0) {
        // Determine exponent.
        if (e < 0) e = i;
        e += +n.slice(i + 1);
        n = n.substring(0, i);
    } else if (e < 0) // Integer.
    e = n.length;
    nl = n.length;
    // Determine leading zeros before decimal point.
    for(i = 0; i < e && i < nl && n.charAt(i) == '0';)++i;
    // original version (ignores decimal point).
    // // Determine leading zeros.
    // for (i = 0; i < nl && n.charAt(i) == '0';) ++i;
    if (i == nl) // Zero.
    x.c = [
        x.e = 0
    ];
    else {
        x.e = e - i - 1;
        x.c = [];
        // Convert string to array of digits without leading zeros
        for(e = 0; i < nl;)x.c[e++] = +n.charAt(i++);
    // older version (doesn't keep trailing zeroes).
    // // Determine trailing zeros.
    // for (; nl > 0 && n.charAt(--nl) == '0';);
    // // Convert string to array of digits without leading/trailing zeros.
    // for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
    }
    x = $2c37e6e19f540083$var$round(x, $2c37e6e19f540083$export$721faf8597f6f672.DP + 1, $2c37e6e19f540083$export$721faf8597f6f672.RM);
    return x;
}
/*
 * Round Big x to a maximum of sd significant digits using rounding mode rm.
 *
 * x {Big} The Big to round.
 * sd {number} Significant digits: integer, 0 to MAX_DP inclusive.
 * rm {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 * [more] {boolean} Whether the result of division was truncated.
 */ function $2c37e6e19f540083$var$round(x, sd, rm, more) {
    var xc = x.c;
    if (rm === $2c37e6e19f540083$var$UNDEFINED) rm = $2c37e6e19f540083$export$721faf8597f6f672.RM;
    if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) throw Error($2c37e6e19f540083$var$INVALID_RM);
    if (sd < 1) {
        more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== $2c37e6e19f540083$var$UNDEFINED)));
        xc.length = 1;
        if (more) {
            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            x.e = x.e - sd + 1;
            xc[0] = 1;
        } else // Zero.
        xc[0] = x.e = 0;
    } else if (sd < xc.length) {
        // xc[sd] is the digit after the digit that may be rounded up.
        const isZero = xc.findIndex((xci, idx)=>idx >= sd && xci > 0) < 0;
        more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== $2c37e6e19f540083$var$UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !isZero);
        // Remove any digits after the required precision.
        xc.length = sd--;
        // Round up?
        if (more) // Rounding up may mean the previous digit has to be rounded up.
        for(; ++xc[sd] > 9;){
            xc[sd] = 0;
            if (!sd--) {
                ++x.e;
                xc.unshift(1);
            }
        }
        // Remove trailing zeros.
        for(sd = xc.length; !xc[--sd];)xc.pop();
    }
    return x;
}
/*
 * Return a string representing the value of Big x in normal or exponential notation.
 * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
 */ function $2c37e6e19f540083$var$stringify(x, doExponential, isNonzero) {
    var e = x.e, s = x.c.join(''), n = s.length;
    // Exponential notation?
    if (doExponential) s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
    else if (e < 0) {
        for(; ++e;)s = '0' + s;
        s = '0.' + s;
    } else if (e > 0) {
        if (++e > n) for(e -= n; e--;)s += '0';
        else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
    } else if (n > 1) s = s.charAt(0) + '.' + s.slice(1);
    return x.s < 0 && isNonzero ? '-' + s : s;
}
// Prototype/instance methods
/*
 * Return a new Big whose value is the absolute value of this Big.
 */ $2c37e6e19f540083$var$P.abs = function() {
    var x = new this.constructor(this);
    x.s = 1;
    return x;
};
/*
 * Return 1 if the value of this Big is greater than the value of Big y,
 *       -1 if the value of this Big is less than the value of Big y, or
 *        0 if they have the same value.
 */ $2c37e6e19f540083$var$P.cmp = function(y) {
    var isneg, Big = this.constructor, x = new Big(this), y = new Big(y), xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either zero?
    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    isneg = i < 0;
    // Compare exponents.
    if (k != l) return k > l ^ isneg ? 1 : -1;
    // Compare digit by digit.
    j = Math.max(xc.length, yc.length);
    for(i = 0; i < j; i++){
        k = i < xc.length ? xc[i] : 0;
        l = i < yc.length ? yc[i] : 0;
        if (k != l) return k > l ^ isneg ? 1 : -1;
    }
    return 0;
// original version (doesn't compare well trailing zeroes, e.g. 1.0 with 1.00)
// j = (k = xc.length) < (l = yc.length) ? k : l;
// // Compare digit by digit.
// for (i = -1; ++i < j;) {
//   if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
// }
// // Compare lengths.
// return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};
/*
 * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
 * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */ $2c37e6e19f540083$var$P.div = function(y) {
    var Big = this.constructor, x = new Big(this), y = new Big(y), a = x.c, b = y.c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
    if (dp !== ~~dp || dp < 0 || dp > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID_DP);
    // Divisor is zero?
    if (!b[0]) throw Error($2c37e6e19f540083$var$DIV_BY_ZERO);
    // Dividend is 0? Return +-0.
    if (!a[0]) {
        y.s = k;
        y.c = [
            y.e = 0
        ];
        return y;
    }
    var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1; // precision of the result
    q.s = k;
    k = p < 0 ? 0 : p;
    // Create version of divisor with leading zero.
    bz.unshift(0);
    // Add zeros to make remainder as long as divisor.
    for(; rl++ < bl;)r.push(0);
    do {
        // n is how many times the divisor goes into current remainder.
        for(n = 0; n < 10; n++){
            // Compare divisor and remainder.
            if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
            else {
                for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                    cmp = b[ri] > r[ri] ? 1 : -1;
                    break;
                }
            }
            // If divisor < remainder, subtract divisor from remainder.
            if (cmp < 0) {
                // Remainder can't be more than 1 digit longer than divisor.
                // Equalise lengths using divisor with extra leading zero?
                for(bt = rl == bl ? b : bz; rl;){
                    if (r[--rl] < bt[rl]) {
                        ri = rl;
                        for(; ri && !r[--ri];)r[ri] = 9;
                        --r[ri];
                        r[rl] += 10;
                    }
                    r[rl] -= bt[rl];
                }
                for(; !r[0];)r.shift();
            } else break;
        }
        // Add the digit n to the result array.
        qc[qi++] = cmp ? n : ++n;
        // Update the remainder.
        if (r[0] && cmp) r[rl] = a[ai] || 0;
        else r = [
            a[ai]
        ];
    }while ((ai++ < al || r[0] !== $2c37e6e19f540083$var$UNDEFINED) && k--);
    // Leading zero? Do not remove if result is simply zero (qi == 1).
    if (!qc[0] && qi != 1) {
        // There can't be more than one zero.
        qc.shift();
        q.e--;
        p--;
    }
    // Round?
    if (qi > p) $2c37e6e19f540083$var$round(q, p, Big.RM, r[0] !== $2c37e6e19f540083$var$UNDEFINED);
    return q;
};
/*
 * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
 */ $2c37e6e19f540083$var$P.eq = function(y) {
    return this.cmp(y) === 0;
};
/*
 * Return true if the value of this Big is greater than the value of Big y, otherwise return
 * false.
 */ $2c37e6e19f540083$var$P.gt = function(y) {
    return this.cmp(y) > 0;
};
/*
 * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
 * return false.
 */ $2c37e6e19f540083$var$P.gte = function(y) {
    return this.cmp(y) > -1;
};
/*
 * Return true if the value of this Big is less than the value of Big y, otherwise return false.
 */ $2c37e6e19f540083$var$P.lt = function(y) {
    return this.cmp(y) < 0;
};
/*
 * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
 * return false.
 */ $2c37e6e19f540083$var$P.lte = function(y) {
    return this.cmp(y) < 1;
};
/*
 * Return a new Big whose value is the value of this Big minus the value of Big y.
 */ $2c37e6e19f540083$var$P.minus = $2c37e6e19f540083$var$P.sub = function(y) {
    var i, j, t, xlty, Big = this.constructor, x = new Big(this), y = new Big(y), a = x.s, b = y.s;
    // Signs differ?
    if (a != b) {
        y.s = -b;
        return x.plus(y);
    }
    var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
    // Either zero?
    if (!xc[0] || !yc[0]) {
        if (yc[0]) y.s = -b;
        else if (xc[0]) y = new Big(x);
        else y.s = 1;
        return y;
    }
    // Determine which is the bigger number. Prepend zeros to equalise exponents.
    if (a = xe - ye) {
        if (xlty = a < 0) {
            a = -a;
            t = xc;
        } else {
            ye = xe;
            t = yc;
        }
        t.reverse();
        for(b = a; b--;)t.push(0);
        t.reverse();
    } else {
        // Exponents equal. Check digit by digit.
        j = ((xlty = xc.length < yc.length) ? xc : yc).length;
        for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
            xlty = xc[b] < yc[b];
            break;
        }
    }
    // x < y? Point xc to the array of the bigger number.
    if (xlty) {
        t = xc;
        xc = yc;
        yc = t;
        y.s = -y.s;
    }
    /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
    // Subtract yc from xc.
    for(b = i; j > a;){
        if (xc[--j] < yc[j]) {
            for(i = j; i && !xc[--i];)xc[i] = 9;
            --xc[i];
            xc[j] += 10;
        }
        xc[j] -= yc[j];
    }
    // Remove trailing zeros.
    for(; xc[--b] === 0;)xc.pop();
    // Remove leading zeros and adjust exponent accordingly.
    for(; xc[0] === 0;){
        xc.shift();
        --ye;
    }
    if (!xc[0]) {
        // n - n = +0
        y.s = 1;
        // Result must be zero.
        xc = [
            ye = 0
        ];
    }
    y.c = xc;
    y.e = ye;
    return y;
};
/*
 * Return a new Big whose value is the value of this Big modulo the value of Big y.
 */ $2c37e6e19f540083$var$P.mod = function(y) {
    var ygtx, Big = this.constructor, x = new Big(this), y = new Big(y), a = x.s, b = y.s;
    if (!y.c[0]) throw Error($2c37e6e19f540083$var$DIV_BY_ZERO);
    x.s = y.s = 1;
    ygtx = y.cmp(x) == 1;
    x.s = a;
    y.s = b;
    if (ygtx) return new Big(x);
    a = Big.DP;
    b = Big.RM;
    Big.DP = Big.RM = 0;
    x = x.div(y);
    Big.DP = a;
    Big.RM = b;
    return this.minus(x.times(y));
};
/*
 * Return a new Big whose value is the value of this Big plus the value of Big y.
 */ $2c37e6e19f540083$var$P.plus = $2c37e6e19f540083$var$P.add = function(y) {
    var e, k, t, Big = this.constructor, x = new Big(this), y = new Big(y);
    // Signs differ?
    if (x.s != y.s) {
        y.s = -y.s;
        return x.minus(y);
    }
    var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
    // Either zero?
    if (!xc[0] || !yc[0]) {
        if (!yc[0]) {
            if (xc[0]) y = new Big(x);
            else y.s = x.s;
        }
        return y;
    }
    xc = xc.slice();
    // Prepend zeros to equalise exponents.
    // Note: reverse faster than unshifts.
    if (e = xe - ye) {
        if (e > 0) {
            ye = xe;
            t = yc;
        } else {
            e = -e;
            t = xc;
        }
        t.reverse();
        for(; e--;)t.push(0);
        t.reverse();
    }
    // Point xc to the longer array.
    if (xc.length - yc.length < 0) {
        t = yc;
        yc = xc;
        xc = t;
    }
    e = yc.length;
    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
    for(k = 0; e; xc[e] %= 10)k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    if (k) {
        xc.unshift(k);
        ++ye;
    }
    // Remove trailing zeros.
    for(e = xc.length; xc[--e] === 0;)xc.pop();
    y.c = xc;
    y.e = ye;
    return y;
};
/*
 * Return a Big whose value is the value of this Big raised to the power n.
 * If n is negative, round to a maximum of Big.DP decimal places using rounding
 * mode Big.RM.
 *
 * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
 */ $2c37e6e19f540083$var$P.pow = function(n) {
    var Big = this.constructor, x = new Big(this), y = new Big('1'), one = new Big('1'), isneg = n < 0;
    if (n !== ~~n || n < -$2c37e6e19f540083$var$MAX_POWER || n > $2c37e6e19f540083$var$MAX_POWER) throw Error($2c37e6e19f540083$var$INVALID + 'exponent');
    if (isneg) n = -n;
    for(;;){
        if (n & 1) y = y.times(x);
        n >>= 1;
        if (!n) break;
        x = x.times(x);
    }
    return isneg ? one.div(y) : y;
};
/*
 * Return a new Big whose value is the value of this Big rounded to a maximum precision of sd
 * significant digits using rounding mode rm, or Big.RM if rm is not specified.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $2c37e6e19f540083$var$P.prec = function(sd, rm) {
    if (sd !== ~~sd || sd < 1 || sd > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID + 'precision');
    return $2c37e6e19f540083$var$round(new this.constructor(this), sd, rm);
};
/*
 * Return a new Big whose value is the value of this Big rounded to a maximum of dp decimal places
 * using rounding mode rm, or Big.RM if rm is not specified.
 * If dp is negative, round to an integer which is a multiple of 10**-dp.
 * If dp is not specified, round to 0 decimal places.
 *
 * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $2c37e6e19f540083$var$P.round = function(dp, rm) {
    if (dp === $2c37e6e19f540083$var$UNDEFINED) dp = 0;
    else if (dp !== ~~dp || dp < -$2c37e6e19f540083$var$MAX_DP || dp > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID_DP);
    return $2c37e6e19f540083$var$round(new this.constructor(this), dp + this.e + 1, rm);
};
/*
 * Return a new Big whose value is the square root of the value of this Big, rounded, if
 * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
 */ $2c37e6e19f540083$var$P.sqrt = function() {
    var r, c, t, Big = this.constructor, x = new Big(this), s = x.s, e = x.e, half = new Big('0.5');
    // Zero?
    if (!x.c[0]) return new Big(x);
    // Negative?
    if (s < 0) throw Error($2c37e6e19f540083$var$NAME + 'No square root');
    // Estimate.
    s = Math.sqrt(x + '');
    // Math.sqrt underflow/overflow?
    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
    if (s === 0 || s === 1 / 0) {
        c = x.c.join('');
        if (!(c.length + e & 1)) c += '0';
        s = Math.sqrt(c);
        e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
        r = new Big((s == 1 / 0 ? '5e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
    } else r = new Big(s + '');
    e = r.e + (Big.DP += 4);
    // Newton-Raphson iteration.
    do {
        t = r;
        r = half.times(t.plus(x.div(t)));
    }while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
    return $2c37e6e19f540083$var$round(r, (Big.DP -= 4) + r.e + 1, Big.RM);
};
/*
 * Return a new Big whose value is the value of this Big times the value of Big y.
 */ $2c37e6e19f540083$var$P.times = $2c37e6e19f540083$var$P.mul = function(y) {
    var c, Big = this.constructor, x = new Big(this), y = new Big(y), xc = x.c, yc = y.c, a = xc.length, b = yc.length, i = x.e, j = y.e;
    // Determine sign of result.
    y.s = x.s == y.s ? 1 : -1;
    // Return signed 0 if either 0.
    if (!xc[0] || !yc[0]) {
        y.c = [
            y.e = 0
        ];
        return y;
    }
    // Initialise exponent of result as x.e + y.e.
    y.e = i + j;
    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
    if (a < b) {
        c = xc;
        xc = yc;
        yc = c;
        j = a;
        a = b;
        b = j;
    }
    // Initialise coefficient array of result with zeros.
    for(c = new Array(j = a + b); j--;)c[j] = 0;
    // Multiply.
    // i is initially xc.length.
    for(i = b; i--;){
        b = 0;
        // a is yc.length.
        for(j = a + i; j > i;){
            // Current sum of products at this digit position, plus carry.
            b = c[j] + yc[i] * xc[j - i - 1] + b;
            c[j--] = b % 10;
            // carry
            b = b / 10 | 0;
        }
        c[j] = b;
    }
    // Increment result exponent if there is a final carry, otherwise remove leading zero.
    if (b) ++y.e;
    else c.shift();
    // Remove trailing zeros.
    for(i = c.length; !c[--i];)c.pop();
    y.c = c;
    return y;
};
/*
 * Return a string representing the value of this Big in exponential notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $2c37e6e19f540083$var$P.toExponential = function(dp, rm) {
    var x = this, n = x.c[0];
    if (dp !== $2c37e6e19f540083$var$UNDEFINED) {
        if (dp !== ~~dp || dp < 0 || dp > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID_DP);
        x = $2c37e6e19f540083$var$round(new x.constructor(x), ++dp, rm);
        for(; x.c.length < dp;)x.c.push(0);
    }
    return $2c37e6e19f540083$var$stringify(x, true, !!n);
};
/*
 * Return a string representing the value of this Big in normal notation rounded to dp fixed
 * decimal places using rounding mode rm, or Big.RM if rm is not specified.
 *
 * dp? {number} Decimal places: integer, 0 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 *
 * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
 * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
 */ $2c37e6e19f540083$var$P.toFixed = function(dp, rm) {
    var x = this, n = x.c[0];
    if (dp !== $2c37e6e19f540083$var$UNDEFINED) {
        if (dp !== ~~dp || dp < 0 || dp > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID_DP);
        x = $2c37e6e19f540083$var$round(new x.constructor(x), dp + x.e + 1, rm);
        // x.e may have changed if the value is rounded up.
        for(dp = dp + x.e + 1; x.c.length < dp;)x.c.push(0);
    }
    return $2c37e6e19f540083$var$stringify(x, false, !!n);
};
/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Omit the sign for negative zero.
 */ $2c37e6e19f540083$var$P.toJSON = $2c37e6e19f540083$var$P.toString = function() {
    var x = this, Big = x.constructor;
    return $2c37e6e19f540083$var$stringify(x, x.e <= Big.NE || x.e >= Big.PE, !!x.c[0]);
};
/*
 * Return the value of this Big as a primitve number.
 */ $2c37e6e19f540083$var$P.toNumber = function() {
    var n = Number($2c37e6e19f540083$var$stringify(this, true, true));
    if (this.constructor.strict === true && !this.eq(n.toString())) throw Error($2c37e6e19f540083$var$NAME + 'Imprecise conversion');
    return n;
};
/*
 * Return a string representing the value of this Big rounded to sd significant digits using
 * rounding mode rm, or Big.RM if rm is not specified.
 * Use exponential notation if sd is less than the number of digits necessary to represent
 * the integer part of the value in normal notation.
 *
 * sd {number} Significant digits: integer, 1 to MAX_DP inclusive.
 * rm? {number} Rounding mode: 0 (down), 1 (half-up), 2 (half-even) or 3 (up).
 */ $2c37e6e19f540083$var$P.toPrecision = function(sd, rm) {
    var x = this, Big = x.constructor, n = x.c[0];
    if (sd !== $2c37e6e19f540083$var$UNDEFINED) {
        if (sd !== ~~sd || sd < 1 || sd > $2c37e6e19f540083$var$MAX_DP) throw Error($2c37e6e19f540083$var$INVALID + 'precision');
        x = $2c37e6e19f540083$var$round(new Big(x), sd, rm);
        for(; x.c.length < sd;)x.c.push(0);
    }
    return $2c37e6e19f540083$var$stringify(x, sd <= x.e || x.e <= Big.NE || x.e >= Big.PE, !!n);
};
/*
 * Return a string representing the value of this Big.
 * Return exponential notation if this Big has a positive exponent equal to or greater than
 * Big.PE, or a negative exponent equal to or less than Big.NE.
 * Include the sign for negative zero.
 */ $2c37e6e19f540083$var$P.valueOf = function() {
    var x = this, Big = x.constructor;
    if (Big.strict === true) throw Error($2c37e6e19f540083$var$NAME + 'valueOf disallowed');
    return $2c37e6e19f540083$var$stringify(x, x.e <= Big.NE || x.e >= Big.PE, true);
};
var $2c37e6e19f540083$export$721faf8597f6f672 = $2c37e6e19f540083$var$_Big_();
var /// <reference types="https://raw.githubusercontent.com/DefinitelyTyped/DefinitelyTyped/master/types/big.js/index.d.ts" />
$2c37e6e19f540083$export$2e2bcd8739ae039 = $2c37e6e19f540083$export$721faf8597f6f672;

});

parcelRegister("5OTL5", function(module, exports) {

$parcel$export(module.exports, "symbol", () => $43ccdfbb091dd342$export$8f701197936bc2a6);
$parcel$export(module.exports, "isNumeric", () => $43ccdfbb091dd342$export$e90fb89750dba83f);
$parcel$export(module.exports, "compare", () => $43ccdfbb091dd342$export$398604a469f7de9a);
$parcel$export(module.exports, "multiply", () => $43ccdfbb091dd342$export$2060d2db72cce88f);
$parcel$export(module.exports, "toFixed", () => $43ccdfbb091dd342$export$a81f732198733497);
$parcel$export(module.exports, "toPrecision", () => $43ccdfbb091dd342$export$3e91a10e66078270);
$parcel$export(module.exports, "toExponential", () => $43ccdfbb091dd342$export$888cb08ddc4765be);
$parcel$export(module.exports, "toHex", () => $43ccdfbb091dd342$export$7ea66e3774a60b67);
const $43ccdfbb091dd342$export$8f701197936bc2a6 = Symbol("numeric");
function $43ccdfbb091dd342$export$e90fb89750dba83f(x) {
    return typeof x === "number" || typeof x === "bigint" || x?.[$43ccdfbb091dd342$export$8f701197936bc2a6];
}
function $43ccdfbb091dd342$export$398604a469f7de9a(x, y) {
    if (typeof x === "number") return x < y ? -1 : x > y ? 1 : 0;
    else if (typeof x === "bigint") return x < y ? -1 : x > y ? 1 : 0;
    else return x.CompareTo(y);
}
function $43ccdfbb091dd342$export$2060d2db72cce88f(x, y) {
    if (typeof x === "number") return x * y;
    else if (typeof x === "bigint") return x * BigInt(y);
    else return x[$43ccdfbb091dd342$export$8f701197936bc2a6]().multiply(y);
}
function $43ccdfbb091dd342$export$a81f732198733497(x, dp) {
    if (typeof x === "number") return x.toFixed(dp);
    else if (typeof x === "bigint") return x;
    else return x[$43ccdfbb091dd342$export$8f701197936bc2a6]().toFixed(dp);
}
function $43ccdfbb091dd342$export$3e91a10e66078270(x, sd) {
    if (typeof x === "number") return x.toPrecision(sd);
    else if (typeof x === "bigint") return x;
    else return x[$43ccdfbb091dd342$export$8f701197936bc2a6]().toPrecision(sd);
}
function $43ccdfbb091dd342$export$888cb08ddc4765be(x, dp) {
    if (typeof x === "number") return x.toExponential(dp);
    else if (typeof x === "bigint") return x;
    else return x[$43ccdfbb091dd342$export$8f701197936bc2a6]().toExponential(dp);
}
function $43ccdfbb091dd342$export$7ea66e3774a60b67(x) {
    if (typeof x === "number") return (Number(x) >>> 0).toString(16);
    else if (typeof x === "bigint") // TODO: properly handle other bit sizes
    return BigInt.asUintN(64, x).toString(16);
    else return x[$43ccdfbb091dd342$export$8f701197936bc2a6]().toHex();
}

});

parcelRegister("eATN7", function(module, exports) {

$parcel$export(module.exports, "toString", () => $a9ffb47051c7f50f$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "Union", () => $a9ffb47051c7f50f$export$6cbb4f8fa0c4c986);
$parcel$export(module.exports, "Record", () => $a9ffb47051c7f50f$export$5b163c6d120341e7);
$parcel$export(module.exports, "FSharpRef", () => $a9ffb47051c7f50f$export$be150d1a3c7e94fe);
$parcel$export(module.exports, "Exception", () => $a9ffb47051c7f50f$export$e2f174de097e0bcd);
$parcel$export(module.exports, "ensureErrorOrException", () => $a9ffb47051c7f50f$export$1ad1de0e03fe42fe);

var $kRS0m = parcelRequire("kRS0m");
function $a9ffb47051c7f50f$export$67548df8c961d303(self) {
    let count = 0;
    let str = "[";
    for (const x of self){
        if (count === 0) str += $a9ffb47051c7f50f$export$f84e8e69fd4488a5(x);
        else if (count === 100) {
            str += "; ...";
            break;
        } else str += "; " + $a9ffb47051c7f50f$export$f84e8e69fd4488a5(x);
        count++;
    }
    return str + "]";
}
function $a9ffb47051c7f50f$export$f84e8e69fd4488a5(x, callStack = 0) {
    if (x != null && typeof x === "object") {
        if (typeof x.toString === "function") return x.toString();
        else if (Symbol.iterator in x) return $a9ffb47051c7f50f$export$67548df8c961d303(x);
        else {
            const cons = Object.getPrototypeOf(x)?.constructor;
            return cons === Object && callStack < 10 ? "{ " + Object.entries(x).map(([k, v])=>k + " = " + $a9ffb47051c7f50f$export$f84e8e69fd4488a5(v, callStack + 1)).join("\n  ") + " }" : cons?.name ?? "";
        }
    }
    return String(x);
}
function $a9ffb47051c7f50f$export$19c5b35f73b7bbbc(name, fields) {
    if (fields.length === 0) return name;
    else {
        let fieldStr;
        let withParens = true;
        if (fields.length === 1) {
            fieldStr = $a9ffb47051c7f50f$export$f84e8e69fd4488a5(fields[0]);
            withParens = fieldStr.indexOf(" ") >= 0;
        } else fieldStr = fields.map((x)=>$a9ffb47051c7f50f$export$f84e8e69fd4488a5(x)).join(", ");
        return name + (withParens ? " (" : " ") + fieldStr + (withParens ? ")" : "");
    }
}
class $a9ffb47051c7f50f$export$6cbb4f8fa0c4c986 {
    get name() {
        return this.cases()[this.tag];
    }
    toJSON() {
        return this.fields.length === 0 ? this.name : [
            this.name
        ].concat(this.fields);
    }
    toString() {
        return $a9ffb47051c7f50f$export$19c5b35f73b7bbbc(this.name, this.fields);
    }
    GetHashCode() {
        const hashes = this.fields.map((x)=>(0, $kRS0m.structuralHash)(x));
        hashes.splice(0, 0, (0, $kRS0m.numberHash)(this.tag));
        return (0, $kRS0m.combineHashCodes)(hashes);
    }
    Equals(other) {
        if (this === other) return true;
        else if (!(0, $kRS0m.sameConstructor)(this, other)) return false;
        else if (this.tag === other.tag) return (0, $kRS0m.equalArrays)(this.fields, other.fields);
        else return false;
    }
    CompareTo(other) {
        if (this === other) return 0;
        else if (!(0, $kRS0m.sameConstructor)(this, other)) return -1;
        else if (this.tag === other.tag) return (0, $kRS0m.compareArrays)(this.fields, other.fields);
        else return this.tag < other.tag ? -1 : 1;
    }
}
function $a9ffb47051c7f50f$var$recordToJSON(self) {
    const o = {};
    const keys = Object.keys(self);
    for(let i = 0; i < keys.length; i++)o[keys[i]] = self[keys[i]];
    return o;
}
function $a9ffb47051c7f50f$var$recordToString(self) {
    return "{ " + Object.entries(self).map(([k, v])=>k + " = " + $a9ffb47051c7f50f$export$f84e8e69fd4488a5(v)).join("\n  ") + " }";
}
function $a9ffb47051c7f50f$var$recordGetHashCode(self) {
    const hashes = Object.values(self).map((v)=>(0, $kRS0m.structuralHash)(v));
    return (0, $kRS0m.combineHashCodes)(hashes);
}
function $a9ffb47051c7f50f$var$recordEquals(self, other) {
    if (self === other) return true;
    else if (!(0, $kRS0m.sameConstructor)(self, other)) return false;
    else {
        const thisNames = Object.keys(self);
        for(let i = 0; i < thisNames.length; i++){
            if (!(0, $kRS0m.equals)(self[thisNames[i]], other[thisNames[i]])) return false;
        }
        return true;
    }
}
function $a9ffb47051c7f50f$var$recordCompareTo(self, other) {
    if (self === other) return 0;
    else if (!(0, $kRS0m.sameConstructor)(self, other)) return -1;
    else {
        const thisNames = Object.keys(self);
        for(let i = 0; i < thisNames.length; i++){
            const result = (0, $kRS0m.compare)(self[thisNames[i]], other[thisNames[i]]);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $a9ffb47051c7f50f$export$5b163c6d120341e7 {
    toJSON() {
        return $a9ffb47051c7f50f$var$recordToJSON(this);
    }
    toString() {
        return $a9ffb47051c7f50f$var$recordToString(this);
    }
    GetHashCode() {
        return $a9ffb47051c7f50f$var$recordGetHashCode(this);
    }
    Equals(other) {
        return $a9ffb47051c7f50f$var$recordEquals(this, other);
    }
    CompareTo(other) {
        return $a9ffb47051c7f50f$var$recordCompareTo(this, other);
    }
}
class $a9ffb47051c7f50f$export$be150d1a3c7e94fe {
    get contents() {
        return this.getter();
    }
    set contents(v) {
        this.setter(v);
    }
    constructor(contentsOrGetter, setter){
        if (typeof setter === "function") {
            this.getter = contentsOrGetter;
            this.setter = setter;
        } else {
            this.getter = ()=>contentsOrGetter;
            this.setter = (v)=>{
                contentsOrGetter = v;
            };
        }
    }
}
class $a9ffb47051c7f50f$export$e2f174de097e0bcd {
    constructor(message){
        this.message = message;
    }
}
function $a9ffb47051c7f50f$export$40f07171f4b6ee01(x) {
    return x instanceof $a9ffb47051c7f50f$export$e2f174de097e0bcd || x instanceof Error;
}
function $a9ffb47051c7f50f$export$4369c812aac99591(x) {
    return x instanceof Promise;
}
function $a9ffb47051c7f50f$export$1ad1de0e03fe42fe(e) {
    // Exceptionally admitting promises as errors for compatibility with React.suspense (see #3298)
    return $a9ffb47051c7f50f$export$40f07171f4b6ee01(e) || $a9ffb47051c7f50f$export$4369c812aac99591(e) ? e : new Error(String(e));
}
class $a9ffb47051c7f50f$export$bf6d26922abbea07 extends $a9ffb47051c7f50f$export$e2f174de097e0bcd {
    toJSON() {
        return $a9ffb47051c7f50f$var$recordToJSON(this);
    }
    toString() {
        return $a9ffb47051c7f50f$var$recordToString(this);
    }
    GetHashCode() {
        return $a9ffb47051c7f50f$var$recordGetHashCode(this);
    }
    Equals(other) {
        return $a9ffb47051c7f50f$var$recordEquals(this, other);
    }
    CompareTo(other) {
        return $a9ffb47051c7f50f$var$recordCompareTo(this, other);
    }
}
class $a9ffb47051c7f50f$export$56fde45cb633adea extends $a9ffb47051c7f50f$export$bf6d26922abbea07 {
    constructor(arg1, arg2, arg3){
        super();
        this.arg1 = arg1;
        this.arg2 = arg2 | 0;
        this.arg3 = arg3 | 0;
        this.message = "The match cases were incomplete";
    }
}
class $a9ffb47051c7f50f$export$ab9c25261cd8c720 {
}

});
parcelRegister("kRS0m", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $f312a61f63a521d8$export$1e2f57719e155213);
$parcel$export(module.exports, "isDisposable", () => $f312a61f63a521d8$export$e29d65b7eabdc6dd);
$parcel$export(module.exports, "disposeSafe", () => $f312a61f63a521d8$export$466534c54e60af80);
$parcel$export(module.exports, "defaultOf", () => $f312a61f63a521d8$export$439614834d2d5072);
$parcel$export(module.exports, "sameConstructor", () => $f312a61f63a521d8$export$52febab2880147bb);
$parcel$export(module.exports, "getEnumerator", () => $f312a61f63a521d8$export$a41738691dcd8bea);
$parcel$export(module.exports, "toIterator", () => $f312a61f63a521d8$export$21e0669b7bd01bb4);
$parcel$export(module.exports, "compare", () => $f312a61f63a521d8$export$398604a469f7de9a);
$parcel$export(module.exports, "equals", () => $f312a61f63a521d8$export$e9bab7fafb253603);
$parcel$export(module.exports, "Lazy", () => $f312a61f63a521d8$export$b624eff549462981);
$parcel$export(module.exports, "padWithZeros", () => $f312a61f63a521d8$export$eeb1958fe3944641);
$parcel$export(module.exports, "padLeftAndRightWithZeros", () => $f312a61f63a521d8$export$9251776e912f9733);
$parcel$export(module.exports, "dateOffset", () => $f312a61f63a521d8$export$b4360650442640a0);
$parcel$export(module.exports, "int16ToString", () => $f312a61f63a521d8$export$a3afeaad75c2403e);
$parcel$export(module.exports, "int32ToString", () => $f312a61f63a521d8$export$afbd86327cbebb03);
$parcel$export(module.exports, "stringHash", () => $f312a61f63a521d8$export$b9b095ec8c02760b);
$parcel$export(module.exports, "numberHash", () => $f312a61f63a521d8$export$a9844eb73de0a218);
$parcel$export(module.exports, "bigintHash", () => $f312a61f63a521d8$export$ef8370382c2c5327);
$parcel$export(module.exports, "combineHashCodes", () => $f312a61f63a521d8$export$4a6567c520a28ea3);
$parcel$export(module.exports, "physicalHash", () => $f312a61f63a521d8$export$9657185e7652fc5b);
$parcel$export(module.exports, "arrayHash", () => $f312a61f63a521d8$export$34638350c54b9a1b);
$parcel$export(module.exports, "structuralHash", () => $f312a61f63a521d8$export$2e619f11ca48bee4);
$parcel$export(module.exports, "equalArraysWith", () => $f312a61f63a521d8$export$b9a64d2e4daf3c9f);
$parcel$export(module.exports, "equalArrays", () => $f312a61f63a521d8$export$dc63f52ecf814bf8);
$parcel$export(module.exports, "compareDates", () => $f312a61f63a521d8$export$c4c806e061935577);
$parcel$export(module.exports, "comparePrimitives", () => $f312a61f63a521d8$export$591cc4a8025fba16);
$parcel$export(module.exports, "compareArrays", () => $f312a61f63a521d8$export$fc16749c794bf6ff);
$parcel$export(module.exports, "min", () => $f312a61f63a521d8$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $f312a61f63a521d8$export$8960430cfd85939f);
$parcel$export(module.exports, "createObj", () => $f312a61f63a521d8$export$ad1552835d16e4ca);
$parcel$export(module.exports, "round", () => $f312a61f63a521d8$export$2077e0241d6afd3c);
$parcel$export(module.exports, "clear", () => $f312a61f63a521d8$export$42ffd38884aecdac);
$parcel$export(module.exports, "uncurry2", () => $f312a61f63a521d8$export$495bf678c7ada30a);
$parcel$export(module.exports, "curry2", () => $f312a61f63a521d8$export$6944c5e0a4d7bdd2);
$parcel$export(module.exports, "uncurry3", () => $f312a61f63a521d8$export$6dd46814578720b1);
$parcel$export(module.exports, "curry3", () => $f312a61f63a521d8$export$2ed711877756bc12);
$parcel$export(module.exports, "uncurry4", () => $f312a61f63a521d8$export$75fb6550be126673);
$parcel$export(module.exports, "curry4", () => $f312a61f63a521d8$export$a8e204661557a0e7);
$parcel$export(module.exports, "copyToArray", () => $f312a61f63a521d8$export$b457c8de52d85e65);
function $f312a61f63a521d8$export$1e2f57719e155213(x) {
    return Array.isArray(x) || ArrayBuffer.isView(x);
}
function $f312a61f63a521d8$export$9652023d9040757(x) {
    return x != null && typeof x === "object" && Symbol.iterator in x;
}
function $f312a61f63a521d8$export$8edadf8e974b29dc(x) {
    return x != null && typeof x.GetEnumerator === "function";
}
function $f312a61f63a521d8$export$c3a1405a13c192dc(x) {
    return x != null && typeof x.Compare === "function";
}
function $f312a61f63a521d8$export$a8eb308fbdcb0e9c(x) {
    return x != null && typeof x.CompareTo === "function";
}
function $f312a61f63a521d8$export$a2520bc9aec4b126(x) {
    return x != null && typeof x.Equals === "function";
}
function $f312a61f63a521d8$export$f0284d1eb84ae373(x) {
    return x != null && typeof x.GetHashCode === "function";
}
function $f312a61f63a521d8$export$e29d65b7eabdc6dd(x) {
    return x != null && typeof x.Dispose === "function";
}
function $f312a61f63a521d8$export$466534c54e60af80(x) {
    if ($f312a61f63a521d8$export$e29d65b7eabdc6dd(x)) x.Dispose();
}
function $f312a61f63a521d8$export$439614834d2d5072() {
    return null;
}
function $f312a61f63a521d8$export$52febab2880147bb(x, y) {
    return Object.getPrototypeOf(x)?.constructor === Object.getPrototypeOf(y)?.constructor;
}
class $f312a61f63a521d8$export$37843fd8de917eb4 {
    constructor(en){
        this.en = en;
    }
    GetEnumerator() {
        return this.en;
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        return this.en;
    }
    [Symbol.iterator]() {
        return this;
    }
    next() {
        const hasNext = this.en["System.Collections.IEnumerator.MoveNext"]();
        const current = hasNext ? this.en["System.Collections.Generic.IEnumerator`1.get_Current"]() : undefined;
        return {
            done: !hasNext,
            value: current
        };
    }
}
class $f312a61f63a521d8$export$95c529ba89ee4ce7 {
    constructor(iter){
        this.iter = iter;
        this.current = $f312a61f63a521d8$export$439614834d2d5072();
    }
    ["System.Collections.Generic.IEnumerator`1.get_Current"]() {
        return this.current;
    }
    ["System.Collections.IEnumerator.get_Current"]() {
        return this.current;
    }
    ["System.Collections.IEnumerator.MoveNext"]() {
        const cur = this.iter.next();
        this.current = cur.value;
        return !cur.done;
    }
    ["System.Collections.IEnumerator.Reset"]() {
        throw new Error("JS iterators cannot be reset");
    }
    Dispose() {
        return;
    }
}
function $f312a61f63a521d8$export$9fb89e7387d05511(e) {
    if ($f312a61f63a521d8$export$8edadf8e974b29dc(e)) return e;
    else return new $f312a61f63a521d8$export$37843fd8de917eb4(new $f312a61f63a521d8$export$95c529ba89ee4ce7(e[Symbol.iterator]()));
}
function $f312a61f63a521d8$export$a41738691dcd8bea(e) {
    if ($f312a61f63a521d8$export$8edadf8e974b29dc(e)) return e.GetEnumerator();
    else return new $f312a61f63a521d8$export$95c529ba89ee4ce7(e[Symbol.iterator]());
}
function $f312a61f63a521d8$export$21e0669b7bd01bb4(en) {
    return {
        next () {
            const hasNext = en["System.Collections.IEnumerator.MoveNext"]();
            const current = hasNext ? en["System.Collections.Generic.IEnumerator`1.get_Current"]() : undefined;
            return {
                done: !hasNext,
                value: current
            };
        }
    };
}
function $f312a61f63a521d8$export$3610da1c5de62df(e) {
    return $f312a61f63a521d8$export$21e0669b7bd01bb4($f312a61f63a521d8$export$9fb89e7387d05511(e).GetEnumerator());
}
class $f312a61f63a521d8$export$6f7eded1b7c5be2f {
    constructor(f){
        this.Compare = f || $f312a61f63a521d8$export$398604a469f7de9a;
    }
}
function $f312a61f63a521d8$export$40090773fd11c74c(comparer) {
    // Sometimes IEqualityComparer also implements IComparer
    if ($f312a61f63a521d8$export$c3a1405a13c192dc(comparer)) return new $f312a61f63a521d8$export$6f7eded1b7c5be2f(comparer.Compare);
    else return new $f312a61f63a521d8$export$6f7eded1b7c5be2f((x, y)=>{
        const xhash = comparer.GetHashCode(x);
        const yhash = comparer.GetHashCode(y);
        if (xhash === yhash) return comparer.Equals(x, y) ? 0 : -1;
        else return xhash < yhash ? -1 : 1;
    });
}
function $f312a61f63a521d8$export$27555cdfb0b84a1a(actual, expected, msg) {
    if (!$f312a61f63a521d8$export$e9bab7fafb253603(actual, expected)) throw Object.assign(new Error(msg || `Expected: ${expected} - Actual: ${actual}`), {
        actual: actual,
        expected: expected
    });
}
function $f312a61f63a521d8$export$49eedac51f614f7d(actual, expected, msg) {
    if ($f312a61f63a521d8$export$e9bab7fafb253603(actual, expected)) throw Object.assign(new Error(msg || `Expected: ${expected} - Actual: ${actual}`), {
        actual: actual,
        expected: expected
    });
}
class $f312a61f63a521d8$export$b624eff549462981 {
    constructor(factory){
        this.factory = factory;
        this.isValueCreated = false;
    }
    get Value() {
        if (!this.isValueCreated) {
            this.createdValue = this.factory();
            this.isValueCreated = true;
        }
        return this.createdValue;
    }
    get IsValueCreated() {
        return this.isValueCreated;
    }
}
function $f312a61f63a521d8$export$c5f9bac959aafb6(v) {
    return new $f312a61f63a521d8$export$b624eff549462981(()=>v);
}
function $f312a61f63a521d8$export$eeb1958fe3944641(i, length) {
    return i.toString(10).padStart(length, "0");
}
function $f312a61f63a521d8$export$9251776e912f9733(i, lengthLeft, lengthRight) {
    return i.toString(10).padStart(lengthLeft, "0").padEnd(lengthRight, "0");
}
function $f312a61f63a521d8$export$b4360650442640a0(date) {
    const date1 = date;
    return typeof date1.offset === "number" ? date1.offset : date.kind === 1 /* DateKind.UTC */  ? 0 : date.getTimezoneOffset() * -60000;
}
function $f312a61f63a521d8$export$a3afeaad75c2403e(i, radix) {
    i = i < 0 && radix != null && radix !== 10 ? 0xFFFF + i + 1 : i;
    return i.toString(radix);
}
function $f312a61f63a521d8$export$afbd86327cbebb03(i, radix) {
    i = i < 0 && radix != null && radix !== 10 ? 0xFFFFFFFF + i + 1 : i;
    return i.toString(radix);
}
function $f312a61f63a521d8$export$4012a95a346cab46(i, radix) {
    i = i < 0 && radix != null && radix !== 10 ? 0xffffffffffffffffn + i + 1n : i;
    return i.toString(radix);
}
class $f312a61f63a521d8$export$f3f95c9f1920e9b5 {
    static id(o) {
        if (!$f312a61f63a521d8$export$f3f95c9f1920e9b5.idMap.has(o)) $f312a61f63a521d8$export$f3f95c9f1920e9b5.idMap.set(o, ++$f312a61f63a521d8$export$f3f95c9f1920e9b5.count);
        return $f312a61f63a521d8$export$f3f95c9f1920e9b5.idMap.get(o);
    }
}
$f312a61f63a521d8$export$f3f95c9f1920e9b5.idMap = new WeakMap();
$f312a61f63a521d8$export$f3f95c9f1920e9b5.count = 0;
function $f312a61f63a521d8$export$b9b095ec8c02760b(s) {
    let i = 0;
    let h = 5381;
    const len = s.length;
    while(i < len)h = h * 33 ^ s.charCodeAt(i++);
    return h;
}
function $f312a61f63a521d8$export$a9844eb73de0a218(x) {
    return x * 2654435761 | 0;
}
function $f312a61f63a521d8$export$ef8370382c2c5327(x) {
    return $f312a61f63a521d8$export$b9b095ec8c02760b(x.toString(32));
}
function $f312a61f63a521d8$export$4a6567c520a28ea3(hashes) {
    let h1 = 0;
    const len = hashes.length;
    for(let i = 0; i < len; i++){
        const h2 = hashes[i];
        h1 = (h1 << 5) + h1 ^ h2;
    }
    return h1;
}
function $f312a61f63a521d8$export$9657185e7652fc5b(x) {
    if (x == null) return 0;
    switch(typeof x){
        case "boolean":
            return x ? 1 : 0;
        case "number":
            return $f312a61f63a521d8$export$a9844eb73de0a218(x);
        case "bigint":
            return $f312a61f63a521d8$export$ef8370382c2c5327(x);
        case "string":
            return $f312a61f63a521d8$export$b9b095ec8c02760b(x);
        default:
            return $f312a61f63a521d8$export$a9844eb73de0a218($f312a61f63a521d8$export$f3f95c9f1920e9b5.id(x));
    }
}
function $f312a61f63a521d8$export$66b47a187ef76f1c(x) {
    if ($f312a61f63a521d8$export$f0284d1eb84ae373(x)) return x.GetHashCode();
    else return $f312a61f63a521d8$export$9657185e7652fc5b(x);
}
function $f312a61f63a521d8$export$2e003ac3dfcb70a3(x) {
    return x.getTime();
}
function $f312a61f63a521d8$export$34638350c54b9a1b(x) {
    const len = x.length;
    const hashes = new Array(len);
    for(let i = 0; i < len; i++)hashes[i] = $f312a61f63a521d8$export$2e619f11ca48bee4(x[i]);
    return $f312a61f63a521d8$export$4a6567c520a28ea3(hashes);
}
function $f312a61f63a521d8$export$2e619f11ca48bee4(x) {
    if (x == null) return 0;
    switch(typeof x){
        case "boolean":
            return x ? 1 : 0;
        case "number":
            return $f312a61f63a521d8$export$a9844eb73de0a218(x);
        case "bigint":
            return $f312a61f63a521d8$export$ef8370382c2c5327(x);
        case "string":
            return $f312a61f63a521d8$export$b9b095ec8c02760b(x);
        default:
            if ($f312a61f63a521d8$export$f0284d1eb84ae373(x)) return x.GetHashCode();
            else if ($f312a61f63a521d8$export$1e2f57719e155213(x)) return $f312a61f63a521d8$export$34638350c54b9a1b(x);
            else if (x instanceof Date) return $f312a61f63a521d8$export$2e003ac3dfcb70a3(x);
            else if (Object.getPrototypeOf(x)?.constructor === Object) {
                // TODO: check call-stack to prevent cyclic objects?
                const hashes = Object.values(x).map((v)=>$f312a61f63a521d8$export$2e619f11ca48bee4(v));
                return $f312a61f63a521d8$export$4a6567c520a28ea3(hashes);
            } else // Classes don't implement GetHashCode by default, but must use identity hashing
            return $f312a61f63a521d8$export$a9844eb73de0a218($f312a61f63a521d8$export$f3f95c9f1920e9b5.id(x));
    }
}
function $f312a61f63a521d8$export$2ba04dca110a1015(x) {
    return $f312a61f63a521d8$export$b9b095ec8c02760b(String(x));
}
function $f312a61f63a521d8$export$fed18027a0c1a84b(x) {
    // return x == null ? 0 : isHashable(x) ? x.GetHashCode() : numberHash(ObjectRef.id(x));
    return $f312a61f63a521d8$export$66b47a187ef76f1c(x);
}
function $f312a61f63a521d8$export$b9a64d2e4daf3c9f(x, y, eq) {
    if (x == null) return y == null;
    if (y == null) return false;
    if (x.length !== y.length) return false;
    for(let i = 0; i < x.length; i++){
        if (!eq(x[i], y[i])) return false;
    }
    return true;
}
function $f312a61f63a521d8$export$dc63f52ecf814bf8(x, y) {
    return $f312a61f63a521d8$export$b9a64d2e4daf3c9f(x, y, $f312a61f63a521d8$export$e9bab7fafb253603);
}
function $f312a61f63a521d8$var$equalObjects(x, y) {
    const xKeys = Object.keys(x);
    const yKeys = Object.keys(y);
    if (xKeys.length !== yKeys.length) return false;
    xKeys.sort();
    yKeys.sort();
    for(let i = 0; i < xKeys.length; i++){
        if (xKeys[i] !== yKeys[i] || !$f312a61f63a521d8$export$e9bab7fafb253603(x[xKeys[i]], y[yKeys[i]])) return false;
    }
    return true;
}
function $f312a61f63a521d8$export$97c886f9eb1c7d16(x, y) {
    return x === y;
}
function $f312a61f63a521d8$export$e9bab7fafb253603(x, y) {
    if (x === y) return true;
    else if (x == null) return y == null;
    else if (y == null) return false;
    else if ($f312a61f63a521d8$export$a2520bc9aec4b126(x)) return x.Equals(y);
    else if ($f312a61f63a521d8$export$1e2f57719e155213(x)) return $f312a61f63a521d8$export$1e2f57719e155213(y) && $f312a61f63a521d8$export$dc63f52ecf814bf8(x, y);
    else if (typeof x !== "object") return false;
    else if (x instanceof Date) return y instanceof Date && $f312a61f63a521d8$export$c4c806e061935577(x, y) === 0;
    else return Object.getPrototypeOf(x)?.constructor === Object && $f312a61f63a521d8$var$equalObjects(x, y);
}
function $f312a61f63a521d8$export$c4c806e061935577(x, y) {
    let xtime;
    let ytime;
    // DateTimeOffset and DateTime deals with equality differently.
    if ("offset" in x && "offset" in y) {
        xtime = x.getTime();
        ytime = y.getTime();
    } else {
        xtime = x.getTime() + $f312a61f63a521d8$export$b4360650442640a0(x);
        ytime = y.getTime() + $f312a61f63a521d8$export$b4360650442640a0(y);
    }
    return xtime === ytime ? 0 : xtime < ytime ? -1 : 1;
}
function $f312a61f63a521d8$export$591cc4a8025fba16(x, y) {
    return x === y ? 0 : x < y ? -1 : 1;
}
function $f312a61f63a521d8$export$7b00afb96b8966ce(x, y, comp) {
    if (x == null) return y == null ? 0 : 1;
    if (y == null) return -1;
    if (x.length !== y.length) return x.length < y.length ? -1 : 1;
    for(let i = 0, j = 0; i < x.length; i++){
        j = comp(x[i], y[i]);
        if (j !== 0) return j;
    }
    return 0;
}
function $f312a61f63a521d8$export$fc16749c794bf6ff(x, y) {
    return $f312a61f63a521d8$export$7b00afb96b8966ce(x, y, $f312a61f63a521d8$export$398604a469f7de9a);
}
function $f312a61f63a521d8$var$compareObjects(x, y) {
    const xKeys = Object.keys(x);
    const yKeys = Object.keys(y);
    if (xKeys.length !== yKeys.length) return xKeys.length < yKeys.length ? -1 : 1;
    xKeys.sort();
    yKeys.sort();
    for(let i = 0, j = 0; i < xKeys.length; i++){
        const key = xKeys[i];
        if (key !== yKeys[i]) return key < yKeys[i] ? -1 : 1;
        else {
            j = $f312a61f63a521d8$export$398604a469f7de9a(x[key], y[key]);
            if (j !== 0) return j;
        }
    }
    return 0;
}
function $f312a61f63a521d8$export$398604a469f7de9a(x, y) {
    if (x === y) return 0;
    else if (x == null) return y == null ? 0 : -1;
    else if (y == null) return 1;
    else if ($f312a61f63a521d8$export$a8eb308fbdcb0e9c(x)) return x.CompareTo(y);
    else if ($f312a61f63a521d8$export$1e2f57719e155213(x)) return $f312a61f63a521d8$export$1e2f57719e155213(y) ? $f312a61f63a521d8$export$fc16749c794bf6ff(x, y) : -1;
    else if (typeof x !== "object") return x < y ? -1 : 1;
    else if (x instanceof Date) return y instanceof Date ? $f312a61f63a521d8$export$c4c806e061935577(x, y) : -1;
    else return Object.getPrototypeOf(x)?.constructor === Object ? $f312a61f63a521d8$var$compareObjects(x, y) : -1;
}
function $f312a61f63a521d8$export$96ec731ed4dcb222(comparer, x, y) {
    return comparer(x, y) < 0 ? x : y;
}
function $f312a61f63a521d8$export$8960430cfd85939f(comparer, x, y) {
    return comparer(x, y) > 0 ? x : y;
}
function $f312a61f63a521d8$export$7d15b64cf5a3a4c4(comparer, value, min, max) {
    return comparer(value, min) < 0 ? min : comparer(value, max) > 0 ? max : value;
}
function $f312a61f63a521d8$export$2e17fe64ec9a826e(value) {
    let atom = value;
    return (...args)=>{
        if (args.length === 0) return atom;
        else atom = args[0];
    };
}
function $f312a61f63a521d8$export$ad1552835d16e4ca(fields) {
    const obj = {};
    for (const kv of fields)obj[kv[0]] = kv[1];
    return obj;
}
function $f312a61f63a521d8$export$abe6afec815e60a8(mutator) {
    const opts = {};
    mutator(opts);
    return opts;
}
function $f312a61f63a521d8$export$2077e0241d6afd3c(value, digits = 0) {
    const m = Math.pow(10, digits);
    const n = +(digits ? value * m : value).toFixed(8);
    const i = Math.floor(n);
    const f = n - i;
    const e = 1e-8;
    const r = f > 0.5 - e && f < 0.5 + e ? i % 2 === 0 ? i : i + 1 : Math.round(n);
    return digits ? r / m : r;
}
function $f312a61f63a521d8$export$c5552dfdbc7cec71(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
}
function $f312a61f63a521d8$export$4aad32b45f511863(s) {
    // https://stackoverflow.com/a/4458580/524236
    return decodeURIComponent(s.replace(/\+/g, "%20"));
}
function $f312a61f63a521d8$export$c6a168a6353a7fe6(s) {
    return encodeURIComponent(s).replace(/!/g, "%21").replace(/'/g, "%27").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\*/g, "%2A");
}
function $f312a61f63a521d8$export$a793387c99636443(s) {
    return encodeURI(s);
}
function $f312a61f63a521d8$export$85b9a36db797e02b(col) {
    if ($f312a61f63a521d8$export$1e2f57719e155213(col)) return col.length;
    else {
        let count = 0;
        for (const _ of col)count++;
        return count;
    }
}
function $f312a61f63a521d8$export$42ffd38884aecdac(col) {
    if ($f312a61f63a521d8$export$1e2f57719e155213(col)) col.splice(0);
    else col.clear();
}
const $f312a61f63a521d8$var$curried = new WeakMap();
function $f312a61f63a521d8$export$495bf678c7ada30a(f) {
    if (f == null) return null;
    const f2 = (a1, a2)=>f(a1)(a2);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$6944c5e0a4d7bdd2(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>f(a1, a2));
}
function $f312a61f63a521d8$export$6dd46814578720b1(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3)=>f(a1)(a2)(a3);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$2ed711877756bc12(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>f(a1, a2, a3));
}
function $f312a61f63a521d8$export$75fb6550be126673(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4)=>f(a1)(a2)(a3)(a4);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$a8e204661557a0e7(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>f(a1, a2, a3, a4));
}
function $f312a61f63a521d8$export$a4425868a5bff0ec(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5)=>f(a1)(a2)(a3)(a4)(a5);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$19bdf157e132484e(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>f(a1, a2, a3, a4, a5));
}
function $f312a61f63a521d8$export$50264c9e3152f4e7(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6)=>f(a1)(a2)(a3)(a4)(a5)(a6);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$4c3f1fa36ae21ea2(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>f(a1, a2, a3, a4, a5, a6));
}
function $f312a61f63a521d8$export$291538c41595a785(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$69c3d5a842137507(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>f(a1, a2, a3, a4, a5, a6, a7));
}
function $f312a61f63a521d8$export$110e9d6adab59a3c(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$a0ae61d3d56831e0(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>f(a1, a2, a3, a4, a5, a6, a7, a8));
}
function $f312a61f63a521d8$export$92539c998fe36029(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$a25e348a83e1baa(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9));
}
function $f312a61f63a521d8$export$127a72cb4b8b11d3(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$bb4bc73579e32e25(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10));
}
function $f312a61f63a521d8$export$3bc7eb57965d7cf0(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$64de315c63c5b678(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11));
}
function $f312a61f63a521d8$export$17cd531c09f56cdf(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$2c142431666d5b65(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12));
}
function $f312a61f63a521d8$export$a37c8585594c6e1c(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$8307041aa4f78593(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13));
}
function $f312a61f63a521d8$export$90e84022c730bc90(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$7bde3cf248f1f859(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14));
}
function $f312a61f63a521d8$export$bc0d2c49f5d8a707(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$8f9f96e3dac7f00c(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15));
}
function $f312a61f63a521d8$export$b25105d6aec6a37a(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15)(a16);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$e001d9aaea7abe3b(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>(a16)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16));
}
function $f312a61f63a521d8$export$17fbe267305929ac(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15)(a16)(a17);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$72df03b953d70202(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>(a16)=>(a17)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17));
}
function $f312a61f63a521d8$export$510a9b6d1882a70c(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15)(a16)(a17)(a18);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$d2a33acc8b7eeed(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>(a16)=>(a17)=>(a18)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18));
}
function $f312a61f63a521d8$export$7b8846a843256036(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15)(a16)(a17)(a18)(a19);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$af2ffe64dbb9db3d(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>(a16)=>(a17)=>(a18)=>(a19)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19));
}
function $f312a61f63a521d8$export$85e0ea0e5c7e1a15(f) {
    if (f == null) return null;
    const f2 = (a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19, a20)=>f(a1)(a2)(a3)(a4)(a5)(a6)(a7)(a8)(a9)(a10)(a11)(a12)(a13)(a14)(a15)(a16)(a17)(a18)(a19)(a20);
    $f312a61f63a521d8$var$curried.set(f2, f);
    return f2;
}
function $f312a61f63a521d8$export$5c7d97a8e576cd32(f) {
    return $f312a61f63a521d8$var$curried.get(f) ?? ((a1)=>(a2)=>(a3)=>(a4)=>(a5)=>(a6)=>(a7)=>(a8)=>(a9)=>(a10)=>(a11)=>(a12)=>(a13)=>(a14)=>(a15)=>(a16)=>(a17)=>(a18)=>(a19)=>(a20)=>f(a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17, a18, a19, a20));
}
function $f312a61f63a521d8$export$b457c8de52d85e65(source, sourceIndex, target, targetIndex, count) {
    if (ArrayBuffer.isView(source) && ArrayBuffer.isView(target)) target.set(source.subarray(sourceIndex, sourceIndex + count), targetIndex);
    else for(let i = 0; i < count; ++i)target[targetIndex + i] = source[sourceIndex + i];
}

});




parcelRegister("cc1z1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", () => $8e07d18f487ab700$export$306c0aa65ff9ec16);
$parcel$export(module.exports, "startTransition", () => $8e07d18f487ab700$export$7568632d0d33d16d);
$parcel$export(module.exports, "useDeferredValue", () => $8e07d18f487ab700$export$6a7bc4e911dc01cf);
$parcel$export(module.exports, "useTransition", () => $8e07d18f487ab700$export$7b286972b8d8ccbf);
$parcel$export(module.exports, "useInsertionEffect", () => $8e07d18f487ab700$export$aaabe4eda9ed9969);
$parcel$export(module.exports, "PureComponent", () => $8e07d18f487ab700$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $8e07d18f487ab700$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $8e07d18f487ab700$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $8e07d18f487ab700$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $8e07d18f487ab700$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $8e07d18f487ab700$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $8e07d18f487ab700$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $8e07d18f487ab700$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $8e07d18f487ab700$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $8e07d18f487ab700$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $8e07d18f487ab700$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $8e07d18f487ab700$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $8e07d18f487ab700$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $8e07d18f487ab700$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $8e07d18f487ab700$export$9522e17588c12572);
$parcel$export(module.exports, "isMemo", () => $8e07d18f487ab700$export$56885ab8b9c456ab);
$parcel$export(module.exports, "cloneElement", () => $8e07d18f487ab700$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $8e07d18f487ab700$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $8e07d18f487ab700$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $8e07d18f487ab700$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $8e07d18f487ab700$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $8e07d18f487ab700$export$5f8d39834fd61797);
$parcel$export(module.exports, "isElement", () => $8e07d18f487ab700$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "default", () => $8e07d18f487ab700$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("hURbM")).Component);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("hURbM")).Fragment);
$parcel$export(module.exports, "createContext", () => (parcelRequire("hURbM")).createContext);
$parcel$export(module.exports, "createElement", () => (parcelRequire("hURbM")).createElement);
$parcel$export(module.exports, "createRef", () => (parcelRequire("hURbM")).createRef);

var $hURbM = parcelRequire("hURbM");

var $bNI4e = parcelRequire("bNI4e");
function $8e07d18f487ab700$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $8e07d18f487ab700$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $8e07d18f487ab700$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $bNI4e.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $bNI4e.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $8e07d18f487ab700$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $bNI4e.useEffect)(function() {
        return $8e07d18f487ab700$var$x(u) && o({
            t: u
        }), n(function() {
            $8e07d18f487ab700$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $8e07d18f487ab700$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $8e07d18f487ab700$export$7568632d0d33d16d(n) {
    n();
}
function $8e07d18f487ab700$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $8e07d18f487ab700$export$7b286972b8d8ccbf() {
    return [
        !1,
        $8e07d18f487ab700$export$7568632d0d33d16d
    ];
}
var $8e07d18f487ab700$export$aaabe4eda9ed9969 = (0, $bNI4e.useLayoutEffect);
function $8e07d18f487ab700$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $8e07d18f487ab700$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $8e07d18f487ab700$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $hURbM.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
($8e07d18f487ab700$export$221d75b3f55bb0bd.prototype = new (0, $hURbM.Component)).isPureReactComponent = !0, $8e07d18f487ab700$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $8e07d18f487ab700$var$E(this.props, n) || $8e07d18f487ab700$var$E(this.state, t);
};
var $8e07d18f487ab700$var$T = (0, $hURbM.options).__b;
(0, $hURbM.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $8e07d18f487ab700$var$T && $8e07d18f487ab700$var$T(n);
};
var $8e07d18f487ab700$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $8e07d18f487ab700$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $8e07d18f487ab700$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $8e07d18f487ab700$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $8e07d18f487ab700$var$L = function(n, t) {
    return null == n ? null : (0, $hURbM.toChildArray)((0, $hURbM.toChildArray)(n).map(t));
}, $8e07d18f487ab700$export$dca3b0875bd9a954 = {
    map: $8e07d18f487ab700$var$L,
    forEach: $8e07d18f487ab700$var$L,
    count: function(n) {
        return n ? (0, $hURbM.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $hURbM.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $hURbM.toChildArray)
}, $8e07d18f487ab700$var$F = (0, $hURbM.options).__e;
(0, $hURbM.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $8e07d18f487ab700$var$F(n, t, e, r);
};
var $8e07d18f487ab700$var$U = (0, $hURbM.options).unmount;
function $8e07d18f487ab700$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $8e07d18f487ab700$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $8e07d18f487ab700$var$V(n, t, e);
    })), n;
}
function $8e07d18f487ab700$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $8e07d18f487ab700$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $8e07d18f487ab700$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $8e07d18f487ab700$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $8e07d18f487ab700$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $hURbM.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $8e07d18f487ab700$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $hURbM.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $8e07d18f487ab700$var$U && $8e07d18f487ab700$var$U(n);
}, ($8e07d18f487ab700$export$74bf444e3cd11ea5.prototype = new (0, $hURbM.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $8e07d18f487ab700$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $8e07d18f487ab700$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $8e07d18f487ab700$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $8e07d18f487ab700$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $8e07d18f487ab700$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $hURbM.createElement)((0, $hURbM.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $hURbM.createElement)((0, $hURbM.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $8e07d18f487ab700$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $8e07d18f487ab700$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $8e07d18f487ab700$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $hURbM.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $hURbM.render)((0, $hURbM.createElement)($8e07d18f487ab700$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $8e07d18f487ab700$export$d39a5bbd09211389(n, e) {
    var r = (0, $hURbM.createElement)($8e07d18f487ab700$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($8e07d18f487ab700$export$998bcd577473dd93.prototype = new (0, $hURbM.Component)).__a = function(n) {
    var t = this, e = $8e07d18f487ab700$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $8e07d18f487ab700$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $8e07d18f487ab700$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $hURbM.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $8e07d18f487ab700$export$998bcd577473dd93.prototype.componentDidUpdate = $8e07d18f487ab700$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $8e07d18f487ab700$var$H(n, e, t);
    });
};
var $8e07d18f487ab700$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $8e07d18f487ab700$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $8e07d18f487ab700$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $8e07d18f487ab700$var$K = /[A-Z0-9]/g, $8e07d18f487ab700$var$Q = "undefined" != typeof document, $8e07d18f487ab700$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $8e07d18f487ab700$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $hURbM.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $8e07d18f487ab700$export$fa8d919ba61d84db(n, t, e) {
    return (0, $hURbM.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $hURbM.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $hURbM.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $8e07d18f487ab700$var$en = (0, $hURbM.options).event;
function $8e07d18f487ab700$var$rn() {}
function $8e07d18f487ab700$var$un() {
    return this.cancelBubble;
}
function $8e07d18f487ab700$var$on() {
    return this.defaultPrevented;
}
(0, $hURbM.options).event = function(n) {
    return $8e07d18f487ab700$var$en && (n = $8e07d18f487ab700$var$en(n)), n.persist = $8e07d18f487ab700$var$rn, n.isPropagationStopped = $8e07d18f487ab700$var$un, n.isDefaultPrevented = $8e07d18f487ab700$var$on, n.nativeEvent = n;
};
var $8e07d18f487ab700$var$ln, $8e07d18f487ab700$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $8e07d18f487ab700$var$fn = (0, $hURbM.options).vnode;
(0, $hURbM.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $8e07d18f487ab700$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $8e07d18f487ab700$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $8e07d18f487ab700$var$J.test(i) && (i = c) : c = i = "oninput" : o && $8e07d18f487ab700$var$G.test(i) ? i = i.replace($8e07d18f487ab700$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $hURbM.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $hURbM.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $8e07d18f487ab700$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $8e07d18f487ab700$var$q, $8e07d18f487ab700$var$fn && $8e07d18f487ab700$var$fn(n);
};
var $8e07d18f487ab700$var$an = (0, $hURbM.options).__r;
(0, $hURbM.options).__r = function(n) {
    $8e07d18f487ab700$var$an && $8e07d18f487ab700$var$an(n), $8e07d18f487ab700$var$ln = n.__c;
};
var $8e07d18f487ab700$var$sn = (0, $hURbM.options).diffed;
(0, $hURbM.options).diffed = function(n) {
    $8e07d18f487ab700$var$sn && $8e07d18f487ab700$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $8e07d18f487ab700$var$ln = null;
};
var $8e07d18f487ab700$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $8e07d18f487ab700$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $bNI4e.useCallback),
            useContext: (0, $bNI4e.useContext),
            useDebugValue: (0, $bNI4e.useDebugValue),
            useDeferredValue: $8e07d18f487ab700$export$6a7bc4e911dc01cf,
            useEffect: (0, $bNI4e.useEffect),
            useId: (0, $bNI4e.useId),
            useImperativeHandle: (0, $bNI4e.useImperativeHandle),
            useInsertionEffect: $8e07d18f487ab700$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $bNI4e.useLayoutEffect),
            useMemo: (0, $bNI4e.useMemo),
            useReducer: (0, $bNI4e.useReducer),
            useRef: (0, $bNI4e.useRef),
            useState: (0, $bNI4e.useState),
            useSyncExternalStore: $8e07d18f487ab700$export$306c0aa65ff9ec16,
            useTransition: $8e07d18f487ab700$export$7b286972b8d8ccbf
        }
    }
}, $8e07d18f487ab700$export$83d89fbfd8236492 = "18.3.1";
function $8e07d18f487ab700$export$d38cd72104c1f0e9(n) {
    return (0, $hURbM.createElement).bind(null, n);
}
function $8e07d18f487ab700$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $8e07d18f487ab700$var$q;
}
function $8e07d18f487ab700$export$9522e17588c12572(n) {
    return $8e07d18f487ab700$export$a8257692ac88316c(n) && n.type === (0, $hURbM.Fragment);
}
function $8e07d18f487ab700$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $8e07d18f487ab700$export$e530037191fcd5d7(n) {
    return $8e07d18f487ab700$export$a8257692ac88316c(n) ? (0, $hURbM.cloneElement).apply(null, arguments) : n;
}
function $8e07d18f487ab700$export$502457920280e6be(n) {
    return !!n.__k && ((0, $hURbM.render)(null, n), !0);
}
function $8e07d18f487ab700$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $8e07d18f487ab700$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $8e07d18f487ab700$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $8e07d18f487ab700$export$5f8d39834fd61797 = (0, $hURbM.Fragment), $8e07d18f487ab700$export$45a5e7f76e0caa8d = $8e07d18f487ab700$export$a8257692ac88316c, $8e07d18f487ab700$export$2e2bcd8739ae039 = {
    useState: (0, $bNI4e.useState),
    useId: (0, $bNI4e.useId),
    useReducer: (0, $bNI4e.useReducer),
    useEffect: (0, $bNI4e.useEffect),
    useLayoutEffect: (0, $bNI4e.useLayoutEffect),
    useInsertionEffect: $8e07d18f487ab700$export$aaabe4eda9ed9969,
    useTransition: $8e07d18f487ab700$export$7b286972b8d8ccbf,
    useDeferredValue: $8e07d18f487ab700$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $8e07d18f487ab700$export$306c0aa65ff9ec16,
    startTransition: $8e07d18f487ab700$export$7568632d0d33d16d,
    useRef: (0, $bNI4e.useRef),
    useImperativeHandle: (0, $bNI4e.useImperativeHandle),
    useMemo: (0, $bNI4e.useMemo),
    useCallback: (0, $bNI4e.useCallback),
    useContext: (0, $bNI4e.useContext),
    useDebugValue: (0, $bNI4e.useDebugValue),
    version: "18.3.1",
    Children: $8e07d18f487ab700$export$dca3b0875bd9a954,
    render: $8e07d18f487ab700$export$b3890eb0ae9dca99,
    hydrate: $8e07d18f487ab700$export$fa8d919ba61d84db,
    unmountComponentAtNode: $8e07d18f487ab700$export$502457920280e6be,
    createPortal: $8e07d18f487ab700$export$d39a5bbd09211389,
    createElement: (0, $hURbM.createElement),
    createContext: (0, $hURbM.createContext),
    createFactory: $8e07d18f487ab700$export$d38cd72104c1f0e9,
    cloneElement: $8e07d18f487ab700$export$e530037191fcd5d7,
    createRef: (0, $hURbM.createRef),
    Fragment: (0, $hURbM.Fragment),
    isValidElement: $8e07d18f487ab700$export$a8257692ac88316c,
    isElement: $8e07d18f487ab700$export$45a5e7f76e0caa8d,
    isFragment: $8e07d18f487ab700$export$9522e17588c12572,
    isMemo: $8e07d18f487ab700$export$56885ab8b9c456ab,
    findDOMNode: $8e07d18f487ab700$export$466bfc07425424d5,
    Component: (0, $hURbM.Component),
    PureComponent: $8e07d18f487ab700$export$221d75b3f55bb0bd,
    memo: $8e07d18f487ab700$export$7c73462e0d25e514,
    forwardRef: $8e07d18f487ab700$export$257a8862b851cb5b,
    flushSync: $8e07d18f487ab700$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $8e07d18f487ab700$export$c78a37762a8d58e1,
    StrictMode: $8e07d18f487ab700$export$5f8d39834fd61797,
    Suspense: $8e07d18f487ab700$export$74bf444e3cd11ea5,
    SuspenseList: $8e07d18f487ab700$export$998bcd577473dd93,
    lazy: $8e07d18f487ab700$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $8e07d18f487ab700$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $bNI4e);

});
parcelRegister("hURbM", function(module, exports) {

$parcel$export(module.exports, "options", () => $d0b0ecda483b3b0c$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $d0b0ecda483b3b0c$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $d0b0ecda483b3b0c$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $d0b0ecda483b3b0c$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $d0b0ecda483b3b0c$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $d0b0ecda483b3b0c$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $d0b0ecda483b3b0c$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $d0b0ecda483b3b0c$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $d0b0ecda483b3b0c$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $d0b0ecda483b3b0c$export$fd42f52fd3ae1109);
var $d0b0ecda483b3b0c$var$n, $d0b0ecda483b3b0c$export$41c562ebe57d11e2, $d0b0ecda483b3b0c$var$u, $d0b0ecda483b3b0c$export$a8257692ac88316c, $d0b0ecda483b3b0c$var$i, $d0b0ecda483b3b0c$var$r, $d0b0ecda483b3b0c$var$o, $d0b0ecda483b3b0c$var$e, $d0b0ecda483b3b0c$var$f, $d0b0ecda483b3b0c$var$c, $d0b0ecda483b3b0c$var$s, $d0b0ecda483b3b0c$var$a, $d0b0ecda483b3b0c$var$h, $d0b0ecda483b3b0c$var$p = {}, $d0b0ecda483b3b0c$var$v = [], $d0b0ecda483b3b0c$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $d0b0ecda483b3b0c$var$w = Array.isArray;
function $d0b0ecda483b3b0c$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $d0b0ecda483b3b0c$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $d0b0ecda483b3b0c$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $d0b0ecda483b3b0c$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $d0b0ecda483b3b0c$var$m(l, e, i, r, null);
}
function $d0b0ecda483b3b0c$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$d0b0ecda483b3b0c$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $d0b0ecda483b3b0c$export$41c562ebe57d11e2.vnode && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.vnode(e), e;
}
function $d0b0ecda483b3b0c$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $d0b0ecda483b3b0c$export$ffb0004e005737fa(n) {
    return n.children;
}
function $d0b0ecda483b3b0c$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $d0b0ecda483b3b0c$var$S(n, l) {
    if (null == l) return n.__ ? $d0b0ecda483b3b0c$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $d0b0ecda483b3b0c$var$S(n) : null;
}
function $d0b0ecda483b3b0c$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $d0b0ecda483b3b0c$var$C(n);
    }
}
function $d0b0ecda483b3b0c$var$M(n) {
    (!n.__d && (n.__d = !0) && $d0b0ecda483b3b0c$var$i.push(n) && !$d0b0ecda483b3b0c$var$$.__r++ || $d0b0ecda483b3b0c$var$r != $d0b0ecda483b3b0c$export$41c562ebe57d11e2.debounceRendering) && (($d0b0ecda483b3b0c$var$r = $d0b0ecda483b3b0c$export$41c562ebe57d11e2.debounceRendering) || $d0b0ecda483b3b0c$var$o)($d0b0ecda483b3b0c$var$$);
}
function $d0b0ecda483b3b0c$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $d0b0ecda483b3b0c$var$i.length;)$d0b0ecda483b3b0c$var$i.length > s && $d0b0ecda483b3b0c$var$i.sort($d0b0ecda483b3b0c$var$e), n = $d0b0ecda483b3b0c$var$i.shift(), s = $d0b0ecda483b3b0c$var$i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $d0b0ecda483b3b0c$var$d({}, r)).__v = r.__v + 1, $d0b0ecda483b3b0c$export$41c562ebe57d11e2.vnode && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.vnode(t), $d0b0ecda483b3b0c$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $d0b0ecda483b3b0c$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $d0b0ecda483b3b0c$var$N(f, t, c), r.__e = r.__ = null, t.__e != o && $d0b0ecda483b3b0c$var$C(t)));
    $d0b0ecda483b3b0c$var$$.__r = 0;
}
function $d0b0ecda483b3b0c$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $d0b0ecda483b3b0c$var$v, b = l.length;
    for(f = $d0b0ecda483b3b0c$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $d0b0ecda483b3b0c$var$p : m[y.__i] || $d0b0ecda483b3b0c$var$p, y.__i = a, g = $d0b0ecda483b3b0c$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $d0b0ecda483b3b0c$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $d0b0ecda483b3b0c$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $d0b0ecda483b3b0c$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $d0b0ecda483b3b0c$var$m(null, o, null, null, null) : $d0b0ecda483b3b0c$var$w(o) ? $d0b0ecda483b3b0c$var$m($d0b0ecda483b3b0c$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $d0b0ecda483b3b0c$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $d0b0ecda483b3b0c$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $d0b0ecda483b3b0c$var$S(e)), $d0b0ecda483b3b0c$var$D(e, e));
    return t;
}
function $d0b0ecda483b3b0c$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $d0b0ecda483b3b0c$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $d0b0ecda483b3b0c$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $d0b0ecda483b3b0c$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($d0b0ecda483b3b0c$var$w(n) ? n.some(function(n) {
        $d0b0ecda483b3b0c$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $d0b0ecda483b3b0c$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $d0b0ecda483b3b0c$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $d0b0ecda483b3b0c$var$y.test(l) ? u : u + "px";
}
function $d0b0ecda483b3b0c$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $d0b0ecda483b3b0c$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $d0b0ecda483b3b0c$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($d0b0ecda483b3b0c$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $d0b0ecda483b3b0c$var$c, n.addEventListener(l, r ? $d0b0ecda483b3b0c$var$a : $d0b0ecda483b3b0c$var$s, r)) : n.removeEventListener(l, r ? $d0b0ecda483b3b0c$var$a : $d0b0ecda483b3b0c$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $d0b0ecda483b3b0c$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $d0b0ecda483b3b0c$var$c++;
            else if (u.t < t.u) return;
            return t($d0b0ecda483b3b0c$export$41c562ebe57d11e2.event ? $d0b0ecda483b3b0c$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $d0b0ecda483b3b0c$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $d0b0ecda483b3b0c$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $d0b0ecda483b3b0c$var$E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $d0b0ecda483b3b0c$var$d({}, h.__s)), $d0b0ecda483b3b0c$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $d0b0ecda483b3b0c$var$d($d0b0ecda483b3b0c$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $d0b0ecda483b3b0c$export$ffb0004e005737fa && null == a.key && (L = $d0b0ecda483b3b0c$var$V(a.props.children)), f = $d0b0ecda483b3b0c$var$I(n, $d0b0ecda483b3b0c$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$d0b0ecda483b3b0c$var$g(o[T]);
                $d0b0ecda483b3b0c$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $d0b0ecda483b3b0c$var$z(u);
        $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $d0b0ecda483b3b0c$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $d0b0ecda483b3b0c$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $d0b0ecda483b3b0c$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($d0b0ecda483b3b0c$var$z);
}
function $d0b0ecda483b3b0c$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$d0b0ecda483b3b0c$var$B(t[i], t[++i], t[++i]);
    $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__c && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $d0b0ecda483b3b0c$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $d0b0ecda483b3b0c$var$w(n) ? n.map($d0b0ecda483b3b0c$var$V) : $d0b0ecda483b3b0c$var$d({}, n);
}
function $d0b0ecda483b3b0c$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($d0b0ecda483b3b0c$export$41c562ebe57d11e2.__m && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $d0b0ecda483b3b0c$var$n.call(u.childNodes), b = i.props || $d0b0ecda483b3b0c$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $d0b0ecda483b3b0c$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $d0b0ecda483b3b0c$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $d0b0ecda483b3b0c$var$I("template" == t.type ? u.content : u, $d0b0ecda483b3b0c$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $d0b0ecda483b3b0c$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$d0b0ecda483b3b0c$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $d0b0ecda483b3b0c$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $d0b0ecda483b3b0c$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $d0b0ecda483b3b0c$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $d0b0ecda483b3b0c$var$D(n, u, t) {
    var i, r;
    if ($d0b0ecda483b3b0c$export$41c562ebe57d11e2.unmount && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $d0b0ecda483b3b0c$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $d0b0ecda483b3b0c$var$D(i[r], u, t || "function" != typeof n.type);
    t || $d0b0ecda483b3b0c$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $d0b0ecda483b3b0c$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $d0b0ecda483b3b0c$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__ && $d0b0ecda483b3b0c$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $d0b0ecda483b3b0c$var$O(t, u = (!r && i || t).__k = $d0b0ecda483b3b0c$export$c8a8987d4410bf2d($d0b0ecda483b3b0c$export$ffb0004e005737fa, null, [
        u
    ]), o || $d0b0ecda483b3b0c$var$p, $d0b0ecda483b3b0c$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $d0b0ecda483b3b0c$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $d0b0ecda483b3b0c$var$N(e, u, f);
}
function $d0b0ecda483b3b0c$export$fa8d919ba61d84db(n, l) {
    $d0b0ecda483b3b0c$export$b3890eb0ae9dca99(n, l, $d0b0ecda483b3b0c$export$fa8d919ba61d84db);
}
function $d0b0ecda483b3b0c$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $d0b0ecda483b3b0c$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $d0b0ecda483b3b0c$var$n.call(arguments, 2) : t), $d0b0ecda483b3b0c$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $d0b0ecda483b3b0c$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $d0b0ecda483b3b0c$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $d0b0ecda483b3b0c$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$d0b0ecda483b3b0c$var$n = $d0b0ecda483b3b0c$var$v.slice, $d0b0ecda483b3b0c$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $d0b0ecda483b3b0c$var$u = 0, $d0b0ecda483b3b0c$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $d0b0ecda483b3b0c$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $d0b0ecda483b3b0c$var$d({}, this.state), "function" == typeof n && (n = n($d0b0ecda483b3b0c$var$d({}, u), this.props)), n && $d0b0ecda483b3b0c$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $d0b0ecda483b3b0c$var$M(this));
}, $d0b0ecda483b3b0c$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $d0b0ecda483b3b0c$var$M(this));
}, $d0b0ecda483b3b0c$export$16fa2f45be04daa8.prototype.render = $d0b0ecda483b3b0c$export$ffb0004e005737fa, $d0b0ecda483b3b0c$var$i = [], $d0b0ecda483b3b0c$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $d0b0ecda483b3b0c$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $d0b0ecda483b3b0c$var$$.__r = 0, $d0b0ecda483b3b0c$var$f = /(PointerCapture)$|Capture$/i, $d0b0ecda483b3b0c$var$c = 0, $d0b0ecda483b3b0c$var$s = $d0b0ecda483b3b0c$var$F(!1), $d0b0ecda483b3b0c$var$a = $d0b0ecda483b3b0c$var$F(!0), $d0b0ecda483b3b0c$var$h = 0;

});

parcelRegister("bNI4e", function(module, exports) {

$parcel$export(module.exports, "useState", () => $89767422dc33699f$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $89767422dc33699f$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $89767422dc33699f$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $89767422dc33699f$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $89767422dc33699f$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $89767422dc33699f$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $89767422dc33699f$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $89767422dc33699f$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $89767422dc33699f$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $89767422dc33699f$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $89767422dc33699f$export$c052f6604b7d51fe);
$parcel$export(module.exports, "useId", () => $89767422dc33699f$export$f680877a34711e37);

var $hURbM = parcelRequire("hURbM");
var $89767422dc33699f$var$t, $89767422dc33699f$var$r, $89767422dc33699f$var$u, $89767422dc33699f$var$i, $89767422dc33699f$var$o = 0, $89767422dc33699f$var$f = [], $89767422dc33699f$var$c = (0, $hURbM.options), $89767422dc33699f$var$e = $89767422dc33699f$var$c.__b, $89767422dc33699f$var$a = $89767422dc33699f$var$c.__r, $89767422dc33699f$var$v = $89767422dc33699f$var$c.diffed, $89767422dc33699f$var$l = $89767422dc33699f$var$c.__c, $89767422dc33699f$var$m = $89767422dc33699f$var$c.unmount, $89767422dc33699f$var$s = $89767422dc33699f$var$c.__;
function $89767422dc33699f$var$p(n, t) {
    $89767422dc33699f$var$c.__h && $89767422dc33699f$var$c.__h($89767422dc33699f$var$r, n, $89767422dc33699f$var$o || t), $89767422dc33699f$var$o = 0;
    var u = $89767422dc33699f$var$r.__H || ($89767422dc33699f$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $89767422dc33699f$export$60241385465d0a34(n) {
    return $89767422dc33699f$var$o = 1, $89767422dc33699f$export$13e3392192263954($89767422dc33699f$var$D, n);
}
function $89767422dc33699f$export$13e3392192263954(n, u, i) {
    var o = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $89767422dc33699f$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $89767422dc33699f$var$r, !$89767422dc33699f$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $89767422dc33699f$var$r.__f = !0;
        var c = $89767422dc33699f$var$r.shouldComponentUpdate, e = $89767422dc33699f$var$r.componentWillUpdate;
        $89767422dc33699f$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $89767422dc33699f$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $89767422dc33699f$export$6d9c69b0de29b591(n, u) {
    var i = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 3);
    !$89767422dc33699f$var$c.__s && $89767422dc33699f$var$C(i.__H, u) && (i.__ = n, i.u = u, $89767422dc33699f$var$r.__H.__h.push(i));
}
function $89767422dc33699f$export$e5c5a5f917a5871c(n, u) {
    var i = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 4);
    !$89767422dc33699f$var$c.__s && $89767422dc33699f$var$C(i.__H, u) && (i.__ = n, i.u = u, $89767422dc33699f$var$r.__h.push(i));
}
function $89767422dc33699f$export$b8f5890fc79d6aca(n) {
    return $89767422dc33699f$var$o = 5, $89767422dc33699f$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $89767422dc33699f$export$d5a552a76deda3c2(n, t, r) {
    $89767422dc33699f$var$o = 6, $89767422dc33699f$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $89767422dc33699f$export$1538c33de8887b59(n, r) {
    var u = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 7);
    return $89767422dc33699f$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $89767422dc33699f$export$35808ee640e87ca7(n, t) {
    return $89767422dc33699f$var$o = 8, $89767422dc33699f$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $89767422dc33699f$export$fae74005e78b1a27(n) {
    var u = $89767422dc33699f$var$r.context[n.__c], i = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($89767422dc33699f$var$r)), u.props.value) : n.__;
}
function $89767422dc33699f$export$dc8fbce3eb94dc1e(n, t) {
    $89767422dc33699f$var$c.useDebugValue && $89767422dc33699f$var$c.useDebugValue(t ? t(n) : n);
}
function $89767422dc33699f$export$c052f6604b7d51fe(n) {
    var u = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 10), i = $89767422dc33699f$export$60241385465d0a34();
    return u.__ = n, $89767422dc33699f$var$r.componentDidCatch || ($89767422dc33699f$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $89767422dc33699f$export$f680877a34711e37() {
    var n = $89767422dc33699f$var$p($89767422dc33699f$var$t++, 11);
    if (!n.__) {
        for(var u = $89767422dc33699f$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $89767422dc33699f$var$j() {
    for(var n; n = $89767422dc33699f$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($89767422dc33699f$var$z), n.__H.__h.forEach($89767422dc33699f$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $89767422dc33699f$var$c.__e(t, n.__v);
    }
}
$89767422dc33699f$var$c.__b = function(n) {
    $89767422dc33699f$var$r = null, $89767422dc33699f$var$e && $89767422dc33699f$var$e(n);
}, $89767422dc33699f$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $89767422dc33699f$var$s && $89767422dc33699f$var$s(n, t);
}, $89767422dc33699f$var$c.__r = function(n) {
    $89767422dc33699f$var$a && $89767422dc33699f$var$a(n), $89767422dc33699f$var$t = 0;
    var i = ($89767422dc33699f$var$r = n.__c).__H;
    i && ($89767422dc33699f$var$u === $89767422dc33699f$var$r ? (i.__h = [], $89767422dc33699f$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($89767422dc33699f$var$z), i.__h.forEach($89767422dc33699f$var$B), i.__h = [], $89767422dc33699f$var$t = 0)), $89767422dc33699f$var$u = $89767422dc33699f$var$r;
}, $89767422dc33699f$var$c.diffed = function(n) {
    $89767422dc33699f$var$v && $89767422dc33699f$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $89767422dc33699f$var$f.push(t) && $89767422dc33699f$var$i === $89767422dc33699f$var$c.requestAnimationFrame || (($89767422dc33699f$var$i = $89767422dc33699f$var$c.requestAnimationFrame) || $89767422dc33699f$var$w)($89767422dc33699f$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $89767422dc33699f$var$u = $89767422dc33699f$var$r = null;
}, $89767422dc33699f$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($89767422dc33699f$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $89767422dc33699f$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $89767422dc33699f$var$c.__e(r, n.__v);
        }
    }), $89767422dc33699f$var$l && $89767422dc33699f$var$l(n, t);
}, $89767422dc33699f$var$c.unmount = function(n) {
    $89767422dc33699f$var$m && $89767422dc33699f$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $89767422dc33699f$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $89767422dc33699f$var$c.__e(t, r.__v));
};
var $89767422dc33699f$var$k = "function" == typeof requestAnimationFrame;
function $89767422dc33699f$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $89767422dc33699f$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $89767422dc33699f$var$k && (t = requestAnimationFrame(r));
}
function $89767422dc33699f$var$z(n) {
    var t = $89767422dc33699f$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $89767422dc33699f$var$r = t;
}
function $89767422dc33699f$var$B(n) {
    var t = $89767422dc33699f$var$r;
    n.__c = n.__(), $89767422dc33699f$var$r = t;
}
function $89767422dc33699f$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $89767422dc33699f$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


parcelRegister("dzMiD", function(module, exports) {
// Generated by CoffeeScript 1.8.0
(function() {
    var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;
    floor = Math.floor, min = Math.min;
    /*
  Default comparison function to be used
   */ defaultCmp = function(x, y) {
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
    };
    /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */ insort = function(a, x, lo, hi, cmp) {
        var mid;
        if (lo == null) lo = 0;
        if (cmp == null) cmp = defaultCmp;
        if (lo < 0) throw new Error('lo must be non-negative');
        if (hi == null) hi = a.length;
        while(lo < hi){
            mid = floor((lo + hi) / 2);
            if (cmp(x, a[mid]) < 0) hi = mid;
            else lo = mid + 1;
        }
        return [].splice.apply(a, [
            lo,
            lo - lo
        ].concat(x)), x;
    };
    /*
  Push item onto heap, maintaining the heap invariant.
   */ heappush = function(array, item, cmp) {
        if (cmp == null) cmp = defaultCmp;
        array.push(item);
        return _siftdown(array, 0, array.length - 1, cmp);
    };
    /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */ heappop = function(array, cmp) {
        var lastelt, returnitem;
        if (cmp == null) cmp = defaultCmp;
        lastelt = array.pop();
        if (array.length) {
            returnitem = array[0];
            array[0] = lastelt;
            _siftup(array, 0, cmp);
        } else returnitem = lastelt;
        return returnitem;
    };
    /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */ heapreplace = function(array, item, cmp) {
        var returnitem;
        if (cmp == null) cmp = defaultCmp;
        returnitem = array[0];
        array[0] = item;
        _siftup(array, 0, cmp);
        return returnitem;
    };
    /*
  Fast version of a heappush followed by a heappop.
   */ heappushpop = function(array, item, cmp) {
        var _ref;
        if (cmp == null) cmp = defaultCmp;
        if (array.length && cmp(array[0], item) < 0) {
            _ref = [
                array[0],
                item
            ], item = _ref[0], array[0] = _ref[1];
            _siftup(array, 0, cmp);
        }
        return item;
    };
    /*
  Transform list into a heap, in-place, in O(array.length) time.
   */ heapify = function(array, cmp) {
        var i, _i, _j, _len, _ref, _ref1, _results, _results1;
        if (cmp == null) cmp = defaultCmp;
        _ref1 = (function() {
            _results1 = [];
            for(var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--)_results1.push(_j);
            return _results1;
        }).apply(this).reverse();
        _results = [];
        for(_i = 0, _len = _ref1.length; _i < _len; _i++){
            i = _ref1[_i];
            _results.push(_siftup(array, i, cmp));
        }
        return _results;
    };
    /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */ updateItem = function(array, item, cmp) {
        var pos;
        if (cmp == null) cmp = defaultCmp;
        pos = array.indexOf(item);
        if (pos === -1) return;
        _siftdown(array, 0, pos, cmp);
        return _siftup(array, pos, cmp);
    };
    /*
  Find the n largest elements in a dataset.
   */ nlargest = function(array, n, cmp) {
        var elem, result, _i, _len, _ref;
        if (cmp == null) cmp = defaultCmp;
        result = array.slice(0, n);
        if (!result.length) return result;
        heapify(result, cmp);
        _ref = array.slice(n);
        for(_i = 0, _len = _ref.length; _i < _len; _i++){
            elem = _ref[_i];
            heappushpop(result, elem, cmp);
        }
        return result.sort(cmp).reverse();
    };
    /*
  Find the n smallest elements in a dataset.
   */ nsmallest = function(array, n, cmp) {
        var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
        if (cmp == null) cmp = defaultCmp;
        if (n * 10 <= array.length) {
            result = array.slice(0, n).sort(cmp);
            if (!result.length) return result;
            los = result[result.length - 1];
            _ref = array.slice(n);
            for(_i = 0, _len = _ref.length; _i < _len; _i++){
                elem = _ref[_i];
                if (cmp(elem, los) < 0) {
                    insort(result, elem, 0, null, cmp);
                    result.pop();
                    los = result[result.length - 1];
                }
            }
            return result;
        }
        heapify(array, cmp);
        _results = [];
        for(i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j)_results.push(heappop(array, cmp));
        return _results;
    };
    _siftdown = function(array, startpos, pos, cmp) {
        var newitem, parent, parentpos;
        if (cmp == null) cmp = defaultCmp;
        newitem = array[pos];
        while(pos > startpos){
            parentpos = pos - 1 >> 1;
            parent = array[parentpos];
            if (cmp(newitem, parent) < 0) {
                array[pos] = parent;
                pos = parentpos;
                continue;
            }
            break;
        }
        return array[pos] = newitem;
    };
    _siftup = function(array, pos, cmp) {
        var childpos, endpos, newitem, rightpos, startpos;
        if (cmp == null) cmp = defaultCmp;
        endpos = array.length;
        startpos = pos;
        newitem = array[pos];
        childpos = 2 * pos + 1;
        while(childpos < endpos){
            rightpos = childpos + 1;
            if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) childpos = rightpos;
            array[pos] = array[childpos];
            pos = childpos;
            childpos = 2 * pos + 1;
        }
        array[pos] = newitem;
        return _siftdown(array, startpos, pos, cmp);
    };
    Heap = function() {
        Heap.push = heappush;
        Heap.pop = heappop;
        Heap.replace = heapreplace;
        Heap.pushpop = heappushpop;
        Heap.heapify = heapify;
        Heap.updateItem = updateItem;
        Heap.nlargest = nlargest;
        Heap.nsmallest = nsmallest;
        function Heap(cmp) {
            this.cmp = cmp != null ? cmp : defaultCmp;
            this.nodes = [];
        }
        Heap.prototype.push = function(x) {
            return heappush(this.nodes, x, this.cmp);
        };
        Heap.prototype.pop = function() {
            return heappop(this.nodes, this.cmp);
        };
        Heap.prototype.peek = function() {
            return this.nodes[0];
        };
        Heap.prototype.contains = function(x) {
            return this.nodes.indexOf(x) !== -1;
        };
        Heap.prototype.replace = function(x) {
            return heapreplace(this.nodes, x, this.cmp);
        };
        Heap.prototype.pushpop = function(x) {
            return heappushpop(this.nodes, x, this.cmp);
        };
        Heap.prototype.heapify = function() {
            return heapify(this.nodes, this.cmp);
        };
        Heap.prototype.updateItem = function(x) {
            return updateItem(this.nodes, x, this.cmp);
        };
        Heap.prototype.clear = function() {
            return this.nodes = [];
        };
        Heap.prototype.empty = function() {
            return this.nodes.length === 0;
        };
        Heap.prototype.size = function() {
            return this.nodes.length;
        };
        Heap.prototype.clone = function() {
            var heap;
            heap = new Heap();
            heap.nodes = this.nodes.slice(0);
            return heap;
        };
        Heap.prototype.toArray = function() {
            return this.nodes.slice(0);
        };
        Heap.prototype.insert = Heap.prototype.push;
        Heap.prototype.top = Heap.prototype.peek;
        Heap.prototype.front = Heap.prototype.peek;
        Heap.prototype.has = Heap.prototype.contains;
        Heap.prototype.copy = Heap.prototype.clone;
        return Heap;
    }();
    (function(root, factory) {
        if (typeof define === 'function' && define.amd) return define([], factory);
        else return module.exports = factory();
    })(this, function() {
        return Heap;
    });
}).call(module.exports);

});

parcelRegister("6FHvm", function(module, exports) {

var $joIhc = parcelRequire("joIhc");

var $fVIdZ = parcelRequire("fVIdZ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $joIhc.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fVIdZ;
module.exports = isBuffer;

});
parcelRegister("joIhc", function(module, exports) {

var $3Pfvq = parcelRequire("3Pfvq");
/** Detect free variable `self`. */ var $e1f29a94f3202822$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e1f29a94f3202822$var$root = $3Pfvq || $e1f29a94f3202822$var$freeSelf || Function('return this')();
module.exports = $e1f29a94f3202822$var$root;

});
parcelRegister("3Pfvq", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $2c9229a3504a6578$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $2c9229a3504a6578$var$freeGlobal;

});


parcelRegister("fVIdZ", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b98e7bf473aad82b$var$stubFalse() {
    return false;
}
module.exports = $b98e7bf473aad82b$var$stubFalse;

});


parcelRegister("9f4Zz", function(module, exports) {

var $3Pfvq = parcelRequire("3Pfvq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $3Pfvq.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("4RND8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dflA0"))();

});
parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});



parcelRegister("k7IBq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $ea670f434f582410$var$PropTypes = $ea670f434f582410$var$_interopRequireWildcard((parcelRequire("4RND8")));

var $ea670f434f582410$var$_addClass = $ea670f434f582410$var$_interopRequireDefault((parcelRequire("a0M64")));

var $ea670f434f582410$var$_removeClass = $ea670f434f582410$var$_interopRequireDefault((parcelRequire("6gqRD")));

var $ea670f434f582410$var$_react = $ea670f434f582410$var$_interopRequireDefault((parcelRequire("cc1z1")));

var $ea670f434f582410$var$_Transition = $ea670f434f582410$var$_interopRequireDefault((parcelRequire("iJjgK")));

function $ea670f434f582410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ea670f434f582410$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $ea670f434f582410$var$_extends() {
    $ea670f434f582410$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea670f434f582410$var$_extends.apply(this, arguments);
}
function $ea670f434f582410$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $ea670f434f582410$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $ea670f434f582410$var$_addClass.default)(node, c);
    });
};
var $ea670f434f582410$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $ea670f434f582410$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $ea670f434f582410$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $ea670f434f582410$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'), className = _this$getClassNames.className;
            _this.removeClasses(node, 'exit');
            $ea670f434f582410$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames('appear').doneClassName;
            var enterClassName = _this.getClassNames('enter').doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? 'appear' : 'enter');
            $ea670f434f582410$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames('exit'), className = _this$getClassNames3.className;
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            $ea670f434f582410$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames('exit'), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames('exit'), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, 'exit');
            $ea670f434f582410$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + '-' : '';
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
            var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $ea670f434f582410$var$removeClass(node, className);
        activeClassName && $ea670f434f582410$var$removeClass(node, activeClassName);
        doneClassName && $ea670f434f582410$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $ea670f434f582410$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $ea670f434f582410$var$_extends({}, this.props);
        delete props.classNames;
        return $ea670f434f582410$var$_react.default.createElement($ea670f434f582410$var$_Transition.default, $ea670f434f582410$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($ea670f434f582410$var$_react.default.Component);
$ea670f434f582410$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ea670f434f582410$var$CSSTransition.propTypes = {};
var $ea670f434f582410$var$_default = $ea670f434f582410$var$CSSTransition;
module.exports.default = $ea670f434f582410$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("a0M64", function(module, exports) {
"use strict";

var $9wckY = parcelRequire("9wckY");
module.exports.__esModule = true;
module.exports.default = $749f36841bc9c8c8$var$addClass;

var $749f36841bc9c8c8$var$_hasClass = $9wckY((parcelRequire("dR53a")));
function $749f36841bc9c8c8$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $749f36841bc9c8c8$var$_hasClass.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + ' ' + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("9wckY", function(module, exports) {
function $6ee0ac21c2bcb498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $6ee0ac21c2bcb498$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dR53a", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $a164246f92b2935e$var$hasClass;
function $a164246f92b2935e$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("6gqRD", function(module, exports) {
'use strict';
function $48f9135ed1973e06$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $48f9135ed1973e06$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $48f9135ed1973e06$var$replaceClassName(element.className && element.className.baseVal || '', className));
};

});

parcelRegister("iJjgK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $da2b606daa7cff04$export$1e511d4a378977f5, (v) => $da2b606daa7cff04$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $da2b606daa7cff04$export$2e2bcd8739ae039, (v) => $da2b606daa7cff04$export$2e2bcd8739ae039 = v);
$parcel$export(module.exports, "EXITING", () => $da2b606daa7cff04$export$4aacc83d4d59139f, (v) => $da2b606daa7cff04$export$4aacc83d4d59139f = v);
$parcel$export(module.exports, "ENTERED", () => $da2b606daa7cff04$export$78e9e6e3e014d60a, (v) => $da2b606daa7cff04$export$78e9e6e3e014d60a = v);
$parcel$export(module.exports, "ENTERING", () => $da2b606daa7cff04$export$df38205c966be359, (v) => $da2b606daa7cff04$export$df38205c966be359 = v);
$parcel$export(module.exports, "EXITED", () => $da2b606daa7cff04$export$84cbff306f539230, (v) => $da2b606daa7cff04$export$84cbff306f539230 = v);
$parcel$export(module.exports, "UNMOUNTED", () => $da2b606daa7cff04$export$bb38bb9a1161268, (v) => $da2b606daa7cff04$export$bb38bb9a1161268 = v);
var $da2b606daa7cff04$export$1e511d4a378977f5;
var $da2b606daa7cff04$export$2e2bcd8739ae039;
var $da2b606daa7cff04$export$4aacc83d4d59139f;
var $da2b606daa7cff04$export$78e9e6e3e014d60a;
var $da2b606daa7cff04$export$df38205c966be359;
var $da2b606daa7cff04$export$84cbff306f539230;
var $da2b606daa7cff04$export$bb38bb9a1161268;
"use strict";
$da2b606daa7cff04$export$1e511d4a378977f5 = true;
$da2b606daa7cff04$export$2e2bcd8739ae039 = $da2b606daa7cff04$export$4aacc83d4d59139f = $da2b606daa7cff04$export$78e9e6e3e014d60a = $da2b606daa7cff04$export$df38205c966be359 = $da2b606daa7cff04$export$84cbff306f539230 = $da2b606daa7cff04$export$bb38bb9a1161268 = void 0;

var $da2b606daa7cff04$var$PropTypes = $da2b606daa7cff04$var$_interopRequireWildcard((parcelRequire("4RND8")));

var $da2b606daa7cff04$var$_react = $da2b606daa7cff04$var$_interopRequireDefault((parcelRequire("cc1z1")));

var $da2b606daa7cff04$var$_reactDom = $da2b606daa7cff04$var$_interopRequireDefault((parcelRequire("cc1z1")));

var $71ocU = parcelRequire("71ocU");

function $da2b606daa7cff04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da2b606daa7cff04$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $da2b606daa7cff04$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $da2b606daa7cff04$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $da2b606daa7cff04$var$UNMOUNTED = 'unmounted';
$da2b606daa7cff04$export$bb38bb9a1161268 = $da2b606daa7cff04$var$UNMOUNTED;
var $da2b606daa7cff04$var$EXITED = 'exited';
$da2b606daa7cff04$export$84cbff306f539230 = $da2b606daa7cff04$var$EXITED;
var $da2b606daa7cff04$var$ENTERING = 'entering';
$da2b606daa7cff04$export$df38205c966be359 = $da2b606daa7cff04$var$ENTERING;
var $da2b606daa7cff04$var$ENTERED = 'entered';
$da2b606daa7cff04$export$78e9e6e3e014d60a = $da2b606daa7cff04$var$ENTERED;
var $da2b606daa7cff04$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $da2b606daa7cff04$export$4aacc83d4d59139f = $da2b606daa7cff04$var$EXITING;
var $da2b606daa7cff04$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $da2b606daa7cff04$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $da2b606daa7cff04$var$EXITED;
                _this.appearStatus = $da2b606daa7cff04$var$ENTERING;
            } else initialStatus = $da2b606daa7cff04$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $da2b606daa7cff04$var$UNMOUNTED;
        else initialStatus = $da2b606daa7cff04$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $da2b606daa7cff04$var$UNMOUNTED) return {
            status: $da2b606daa7cff04$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $da2b606daa7cff04$var$ENTERING && status !== $da2b606daa7cff04$var$ENTERED) nextStatus = $da2b606daa7cff04$var$ENTERING;
            } else if (status === $da2b606daa7cff04$var$ENTERING || status === $da2b606daa7cff04$var$ENTERED) nextStatus = $da2b606daa7cff04$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $da2b606daa7cff04$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $da2b606daa7cff04$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $da2b606daa7cff04$var$EXITED) this.setState({
            status: $da2b606daa7cff04$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $da2b606daa7cff04$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $da2b606daa7cff04$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $da2b606daa7cff04$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $da2b606daa7cff04$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $da2b606daa7cff04$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $da2b606daa7cff04$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $da2b606daa7cff04$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $da2b606daa7cff04$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $da2b606daa7cff04$var$_react.default.Children.only(children);
        return $da2b606daa7cff04$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($da2b606daa7cff04$var$_react.default.Component);
$da2b606daa7cff04$var$Transition.contextTypes = {
    transitionGroup: $da2b606daa7cff04$var$PropTypes.object
};
$da2b606daa7cff04$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$da2b606daa7cff04$var$Transition.propTypes = {};
function $da2b606daa7cff04$var$noop() {}
$da2b606daa7cff04$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $da2b606daa7cff04$var$noop,
    onEntering: $da2b606daa7cff04$var$noop,
    onEntered: $da2b606daa7cff04$var$noop,
    onExit: $da2b606daa7cff04$var$noop,
    onExiting: $da2b606daa7cff04$var$noop,
    onExited: $da2b606daa7cff04$var$noop
};
$da2b606daa7cff04$var$Transition.UNMOUNTED = 0;
$da2b606daa7cff04$var$Transition.EXITED = 1;
$da2b606daa7cff04$var$Transition.ENTERING = 2;
$da2b606daa7cff04$var$Transition.ENTERED = 3;
$da2b606daa7cff04$var$Transition.EXITING = 4;
var $da2b606daa7cff04$var$_default = (0, $71ocU.polyfill)($da2b606daa7cff04$var$Transition);
$da2b606daa7cff04$export$2e2bcd8739ae039 = $da2b606daa7cff04$var$_default;

});
parcelRegister("71ocU", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $51cb67738c4a415e$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("gtbYb", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $bfd8a3b2642e81a7$var$_propTypes = $bfd8a3b2642e81a7$var$_interopRequireDefault((parcelRequire("4RND8")));

var $bfd8a3b2642e81a7$var$_react = $bfd8a3b2642e81a7$var$_interopRequireDefault((parcelRequire("cc1z1")));

var $cc1z1 = parcelRequire("cc1z1");

var $bfd8a3b2642e81a7$var$_TransitionGroup = $bfd8a3b2642e81a7$var$_interopRequireDefault((parcelRequire("5EpX4")));
function $bfd8a3b2642e81a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfd8a3b2642e81a7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bfd8a3b2642e81a7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $bfd8a3b2642e81a7$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $bfd8a3b2642e81a7$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $bfd8a3b2642e81a7$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $cc1z1.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $bfd8a3b2642e81a7$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $bfd8a3b2642e81a7$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $bfd8a3b2642e81a7$var$_react.default.createElement($bfd8a3b2642e81a7$var$_TransitionGroup.default, props, inProp ? $bfd8a3b2642e81a7$var$_react.default.cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $bfd8a3b2642e81a7$var$_react.default.cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($bfd8a3b2642e81a7$var$_react.default.Component);
$bfd8a3b2642e81a7$var$ReplaceTransition.propTypes = {};
var $bfd8a3b2642e81a7$var$_default = $bfd8a3b2642e81a7$var$ReplaceTransition;
module.exports.default = $bfd8a3b2642e81a7$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("5EpX4", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $41d4d1a7919a4aad$var$_propTypes = $41d4d1a7919a4aad$var$_interopRequireDefault((parcelRequire("4RND8")));

var $41d4d1a7919a4aad$var$_react = $41d4d1a7919a4aad$var$_interopRequireDefault((parcelRequire("cc1z1")));

var $71ocU = parcelRequire("71ocU");

var $9MzOs = parcelRequire("9MzOs");
function $41d4d1a7919a4aad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $41d4d1a7919a4aad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $41d4d1a7919a4aad$var$_extends() {
    $41d4d1a7919a4aad$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41d4d1a7919a4aad$var$_extends.apply(this, arguments);
}
function $41d4d1a7919a4aad$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $41d4d1a7919a4aad$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $41d4d1a7919a4aad$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $41d4d1a7919a4aad$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
var $41d4d1a7919a4aad$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $41d4d1a7919a4aad$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($41d4d1a7919a4aad$var$_assertThisInitialized($41d4d1a7919a4aad$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $9MzOs.getInitialChildMapping)(nextProps, handleExited) : (0, $9MzOs.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $9MzOs.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $41d4d1a7919a4aad$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $41d4d1a7919a4aad$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $41d4d1a7919a4aad$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $41d4d1a7919a4aad$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($41d4d1a7919a4aad$var$_react.default.Component);
$41d4d1a7919a4aad$var$TransitionGroup.childContextTypes = {
    transitionGroup: $41d4d1a7919a4aad$var$_propTypes.default.object.isRequired
};
$41d4d1a7919a4aad$var$TransitionGroup.propTypes = {};
$41d4d1a7919a4aad$var$TransitionGroup.defaultProps = $41d4d1a7919a4aad$var$defaultProps;
var $41d4d1a7919a4aad$var$_default = (0, $71ocU.polyfill)($41d4d1a7919a4aad$var$TransitionGroup);
module.exports.default = $41d4d1a7919a4aad$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("9MzOs", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $71f46074574a44a7$export$bbc8a025727ea824, (v) => $71f46074574a44a7$export$bbc8a025727ea824 = v);
$parcel$export(module.exports, "getInitialChildMapping", () => $71f46074574a44a7$export$fa71e2345c31d7a2, (v) => $71f46074574a44a7$export$fa71e2345c31d7a2 = v);
$parcel$export(module.exports, "getNextChildMapping", () => $71f46074574a44a7$export$36fd1af28d383ec0, (v) => $71f46074574a44a7$export$36fd1af28d383ec0 = v);
var $71f46074574a44a7$export$1e511d4a378977f5;
var $71f46074574a44a7$export$bbc8a025727ea824;
var $71f46074574a44a7$export$7a874f95ccf533dd;
var $71f46074574a44a7$export$fa71e2345c31d7a2;
var $71f46074574a44a7$export$36fd1af28d383ec0;
"use strict";
$71f46074574a44a7$export$1e511d4a378977f5 = true;
$71f46074574a44a7$export$bbc8a025727ea824 = $71f46074574a44a7$var$getChildMapping;
$71f46074574a44a7$export$7a874f95ccf533dd = $71f46074574a44a7$var$mergeChildMappings;
$71f46074574a44a7$export$fa71e2345c31d7a2 = $71f46074574a44a7$var$getInitialChildMapping;
$71f46074574a44a7$export$36fd1af28d383ec0 = $71f46074574a44a7$var$getNextChildMapping;

var $cc1z1 = parcelRequire("cc1z1");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $71f46074574a44a7$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $cc1z1.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $cc1z1.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $71f46074574a44a7$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $71f46074574a44a7$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $71f46074574a44a7$var$getInitialChildMapping(props, onExited) {
    return $71f46074574a44a7$var$getChildMapping(props.children, function(child) {
        return (0, $cc1z1.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $71f46074574a44a7$var$getProp(child, 'appear', props),
            enter: $71f46074574a44a7$var$getProp(child, 'enter', props),
            exit: $71f46074574a44a7$var$getProp(child, 'exit', props)
        });
    });
}
function $71f46074574a44a7$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $71f46074574a44a7$var$getChildMapping(nextProps.children);
    var children = $71f46074574a44a7$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $cc1z1.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $cc1z1.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $cc1z1.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $71f46074574a44a7$var$getProp(child, 'exit', nextProps),
            enter: $71f46074574a44a7$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $cc1z1.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $cc1z1.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $cc1z1.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $71f46074574a44a7$var$getProp(child, 'exit', nextProps),
            enter: $71f46074574a44a7$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});



parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("dFdXR", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("4FS0Q"));

});
parcelRegister("4FS0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $3674e38b131fe04e$var$_tickFormat.default;
    }
});

var $3674e38b131fe04e$var$_band = $3674e38b131fe04e$var$_interopRequireWildcard((parcelRequire("l1i4k")));

var $3674e38b131fe04e$var$_identity = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("bllFz")));

var $3674e38b131fe04e$var$_linear = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("537RU")));

var $3674e38b131fe04e$var$_log = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("5rmxS")));

var $3674e38b131fe04e$var$_symlog = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("eH6W2")));

var $3674e38b131fe04e$var$_ordinal = $3674e38b131fe04e$var$_interopRequireWildcard((parcelRequire("fGuak")));

var $3674e38b131fe04e$var$_pow = $3674e38b131fe04e$var$_interopRequireWildcard((parcelRequire("fGBFH")));

var $3674e38b131fe04e$var$_radial = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("29xls")));

var $3674e38b131fe04e$var$_quantile = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("ivi4D")));

var $3674e38b131fe04e$var$_quantize = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("hCoKK")));

var $3674e38b131fe04e$var$_threshold = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("a332z")));

var $3674e38b131fe04e$var$_time = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("7hETy")));

var $3674e38b131fe04e$var$_utcTime = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("3BvP9")));

var $3674e38b131fe04e$var$_sequential = $3674e38b131fe04e$var$_interopRequireWildcard((parcelRequire("39AYR")));

var $3674e38b131fe04e$var$_sequentialQuantile = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("5EPak")));

var $3674e38b131fe04e$var$_diverging = $3674e38b131fe04e$var$_interopRequireWildcard((parcelRequire("1enEl")));

var $3674e38b131fe04e$var$_tickFormat = $3674e38b131fe04e$var$_interopRequireDefault((parcelRequire("9ItUs")));
function $3674e38b131fe04e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3674e38b131fe04e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3674e38b131fe04e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3674e38b131fe04e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3674e38b131fe04e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("l1i4k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4d7b511aa1dd9ea$var$band;
module.exports.point = $f4d7b511aa1dd9ea$var$point;

var $jaQ55 = parcelRequire("jaQ55");

var $fb4yo = parcelRequire("fb4yo");

var $f4d7b511aa1dd9ea$var$_ordinal = $f4d7b511aa1dd9ea$var$_interopRequireDefault((parcelRequire("fGuak")));
function $f4d7b511aa1dd9ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f4d7b511aa1dd9ea$var$band() {
    var scale = (0, $f4d7b511aa1dd9ea$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $jaQ55.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $f4d7b511aa1dd9ea$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $fb4yo.initRange.apply(rescale(), arguments);
}
function $f4d7b511aa1dd9ea$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $f4d7b511aa1dd9ea$var$pointish(copy());
    };
    return scale;
}
function $f4d7b511aa1dd9ea$var$point() {
    return $f4d7b511aa1dd9ea$var$pointish($f4d7b511aa1dd9ea$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("jaQ55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $a867v.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $d8wxR.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $d8wxR.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $a867v.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $a867v.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $df5759b4dff75bff$var$_zip.default;
    }
});

var $df5759b4dff75bff$var$_bisect = $df5759b4dff75bff$var$_interopRequireWildcard((parcelRequire("50hsX")));

var $df5759b4dff75bff$var$_ascending = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $df5759b4dff75bff$var$_bisector = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("eJ7lL")));

var $df5759b4dff75bff$var$_count = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("B0FcQ")));

var $df5759b4dff75bff$var$_cross = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("0MPSK")));

var $df5759b4dff75bff$var$_cumsum = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("H2HY9")));

var $df5759b4dff75bff$var$_descending = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("lT1Gn")));

var $df5759b4dff75bff$var$_deviation = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("6R9wc")));

var $df5759b4dff75bff$var$_extent = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("fCeyd")));

var $a867v = parcelRequire("a867v");

var $df5759b4dff75bff$var$_group = $df5759b4dff75bff$var$_interopRequireWildcard((parcelRequire("9SYIs")));

var $df5759b4dff75bff$var$_groupSort = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("h00RI")));

var $df5759b4dff75bff$var$_bin = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("iiDbE")));

var $df5759b4dff75bff$var$_freedmanDiaconis = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("1uW1a")));

var $df5759b4dff75bff$var$_scott = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("lGKgU")));

var $df5759b4dff75bff$var$_sturges = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("adr59")));

var $df5759b4dff75bff$var$_max = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("ce6z6")));

var $df5759b4dff75bff$var$_maxIndex = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("hSJeR")));

var $df5759b4dff75bff$var$_mean = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("iVSVg")));

var $df5759b4dff75bff$var$_median = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("6PJG2")));

var $df5759b4dff75bff$var$_merge = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("4DnlM")));

var $df5759b4dff75bff$var$_min = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("jLkc0")));

var $df5759b4dff75bff$var$_minIndex = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("7F7RN")));

var $df5759b4dff75bff$var$_mode = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("9jCGh")));

var $df5759b4dff75bff$var$_nice = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("3LjTq")));

var $df5759b4dff75bff$var$_pairs = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("66Zpf")));

var $df5759b4dff75bff$var$_permute = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("f3OLU")));

var $df5759b4dff75bff$var$_quantile = $df5759b4dff75bff$var$_interopRequireWildcard((parcelRequire("hOh6k")));

var $df5759b4dff75bff$var$_quickselect = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("iu9vt")));

var $df5759b4dff75bff$var$_range = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("3NGme")));

var $df5759b4dff75bff$var$_rank = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("fUJBh")));

var $df5759b4dff75bff$var$_least = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("1JEk8")));

var $df5759b4dff75bff$var$_leastIndex = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("8rK9T")));

var $df5759b4dff75bff$var$_greatest = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("515Me")));

var $df5759b4dff75bff$var$_greatestIndex = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("1ePGl")));

var $df5759b4dff75bff$var$_scan = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("j4neO")));

var $df5759b4dff75bff$var$_shuffle = $df5759b4dff75bff$var$_interopRequireWildcard((parcelRequire("cXhGa")));

var $df5759b4dff75bff$var$_sum = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("cFUOP")));

var $df5759b4dff75bff$var$_ticks = $df5759b4dff75bff$var$_interopRequireWildcard((parcelRequire("lNqvt")));

var $df5759b4dff75bff$var$_transpose = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("8X8hw")));

var $df5759b4dff75bff$var$_variance = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("3VIXa")));

var $df5759b4dff75bff$var$_zip = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("dfRxN")));

var $df5759b4dff75bff$var$_every = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("8phHQ")));

var $df5759b4dff75bff$var$_some = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("6vEyl")));

var $df5759b4dff75bff$var$_filter = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("1dXRb")));

var $df5759b4dff75bff$var$_map = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("4Qem4")));

var $df5759b4dff75bff$var$_reduce = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("3Dv2I")));

var $df5759b4dff75bff$var$_reverse = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("819Yo")));

var $df5759b4dff75bff$var$_sort = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("8rhWG")));

var $df5759b4dff75bff$var$_difference = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("hiw9m")));

var $df5759b4dff75bff$var$_disjoint = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("805HS")));

var $df5759b4dff75bff$var$_intersection = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("4MhWm")));

var $df5759b4dff75bff$var$_subset = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("9FiNO")));

var $df5759b4dff75bff$var$_superset = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("d1vnx")));

var $df5759b4dff75bff$var$_union = $df5759b4dff75bff$var$_interopRequireDefault((parcelRequire("ixdWC")));

var $d8wxR = parcelRequire("d8wxR");
function $df5759b4dff75bff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df5759b4dff75bff$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($df5759b4dff75bff$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $df5759b4dff75bff$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $df5759b4dff75bff$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("50hsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $3a4a8035b2e35dd7$var$_ascending = $3a4a8035b2e35dd7$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $3a4a8035b2e35dd7$var$_bisector = $3a4a8035b2e35dd7$var$_interopRequireDefault((parcelRequire("eJ7lL")));

var $3a4a8035b2e35dd7$var$_number = $3a4a8035b2e35dd7$var$_interopRequireDefault((parcelRequire("9kSxs")));
function $3a4a8035b2e35dd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3a4a8035b2e35dd7$var$ascendingBisect = (0, $3a4a8035b2e35dd7$var$_bisector.default)($3a4a8035b2e35dd7$var$_ascending.default);
const $3a4a8035b2e35dd7$var$bisectRight = $3a4a8035b2e35dd7$var$ascendingBisect.right;
module.exports.bisectRight = $3a4a8035b2e35dd7$var$bisectRight;
const $3a4a8035b2e35dd7$var$bisectLeft = $3a4a8035b2e35dd7$var$ascendingBisect.left;
module.exports.bisectLeft = $3a4a8035b2e35dd7$var$bisectLeft;
const $3a4a8035b2e35dd7$var$bisectCenter = (0, $3a4a8035b2e35dd7$var$_bisector.default)($3a4a8035b2e35dd7$var$_number.default).center;
module.exports.bisectCenter = $3a4a8035b2e35dd7$var$bisectCenter;
var $3a4a8035b2e35dd7$var$_default = $3a4a8035b2e35dd7$var$bisectRight;
module.exports.default = $3a4a8035b2e35dd7$var$_default;

});
parcelRegister("gSmOd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c49361db91f077b2$var$ascending;
function $c49361db91f077b2$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("eJ7lL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab8af8370503ec26$var$bisector;

var $ab8af8370503ec26$var$_ascending = $ab8af8370503ec26$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $ab8af8370503ec26$var$_descending = $ab8af8370503ec26$var$_interopRequireDefault((parcelRequire("lT1Gn")));
function $ab8af8370503ec26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ab8af8370503ec26$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $ab8af8370503ec26$var$_ascending.default;
        compare2 = (d, x)=>(0, $ab8af8370503ec26$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $ab8af8370503ec26$var$_ascending.default || f === $ab8af8370503ec26$var$_descending.default ? f : $ab8af8370503ec26$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $ab8af8370503ec26$var$zero() {
    return 0;
}

});
parcelRegister("lT1Gn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fef00a2109d15faa$var$descending;
function $fef00a2109d15faa$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("9kSxs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cc0498ee5d08925$var$number;
module.exports.numbers = $6cc0498ee5d08925$var$numbers;
function $6cc0498ee5d08925$var$number(x) {
    return x === null ? NaN : +x;
}
function* $6cc0498ee5d08925$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("B0FcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06f3f89890f0c7c0$var$count;
function $06f3f89890f0c7c0$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("0MPSK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0025e1f9bff2f6b1$var$cross;
function $0025e1f9bff2f6b1$var$length(array) {
    return array.length | 0;
}
function $0025e1f9bff2f6b1$var$empty(length) {
    return !(length > 0);
}
function $0025e1f9bff2f6b1$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $0025e1f9bff2f6b1$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $0025e1f9bff2f6b1$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $0025e1f9bff2f6b1$var$reducer(values.pop());
    values = values.map($0025e1f9bff2f6b1$var$arrayify);
    const lengths = values.map($0025e1f9bff2f6b1$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($0025e1f9bff2f6b1$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("H2HY9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08161e0e3abc7ce7$var$cumsum;
function $08161e0e3abc7ce7$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("6R9wc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fdf137151802604$var$deviation;

var $4fdf137151802604$var$_variance = $4fdf137151802604$var$_interopRequireDefault((parcelRequire("3VIXa")));
function $4fdf137151802604$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4fdf137151802604$var$deviation(values, valueof) {
    const v = (0, $4fdf137151802604$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("3VIXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2dc990bf90cf619d$var$variance;
function $2dc990bf90cf619d$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("fCeyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5e5b12543f9d6ae$var$extent;
function $b5e5b12543f9d6ae$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("a867v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $75ff660a118236fb$var$fcumsum;
module.exports.fsum = $75ff660a118236fb$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $75ff660a118236fb$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $75ff660a118236fb$var$Adder;
function $75ff660a118236fb$var$fsum(values, valueof) {
    const adder = new $75ff660a118236fb$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $75ff660a118236fb$var$fcumsum(values, valueof) {
    const adder = new $75ff660a118236fb$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("9SYIs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73284127dd704d41$var$group;
module.exports.flatGroup = $73284127dd704d41$var$flatGroup;
module.exports.flatRollup = $73284127dd704d41$var$flatRollup;
module.exports.groups = $73284127dd704d41$var$groups;
module.exports.index = $73284127dd704d41$var$index;
module.exports.indexes = $73284127dd704d41$var$indexes;
module.exports.rollup = $73284127dd704d41$var$rollup;
module.exports.rollups = $73284127dd704d41$var$rollups;

var $d8wxR = parcelRequire("d8wxR");

var $73284127dd704d41$var$_identity = $73284127dd704d41$var$_interopRequireDefault((parcelRequire("77gcH")));
function $73284127dd704d41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73284127dd704d41$var$group(values, ...keys) {
    return $73284127dd704d41$var$nest(values, $73284127dd704d41$var$_identity.default, $73284127dd704d41$var$_identity.default, keys);
}
function $73284127dd704d41$var$groups(values, ...keys) {
    return $73284127dd704d41$var$nest(values, Array.from, $73284127dd704d41$var$_identity.default, keys);
}
function $73284127dd704d41$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $73284127dd704d41$var$flatGroup(values, ...keys) {
    return $73284127dd704d41$var$flatten($73284127dd704d41$var$groups(values, ...keys), keys);
}
function $73284127dd704d41$var$flatRollup(values, reduce, ...keys) {
    return $73284127dd704d41$var$flatten($73284127dd704d41$var$rollups(values, reduce, ...keys), keys);
}
function $73284127dd704d41$var$rollup(values, reduce, ...keys) {
    return $73284127dd704d41$var$nest(values, $73284127dd704d41$var$_identity.default, reduce, keys);
}
function $73284127dd704d41$var$rollups(values, reduce, ...keys) {
    return $73284127dd704d41$var$nest(values, Array.from, reduce, keys);
}
function $73284127dd704d41$var$index(values, ...keys) {
    return $73284127dd704d41$var$nest(values, $73284127dd704d41$var$_identity.default, $73284127dd704d41$var$unique, keys);
}
function $73284127dd704d41$var$indexes(values, ...keys) {
    return $73284127dd704d41$var$nest(values, Array.from, $73284127dd704d41$var$unique, keys);
}
function $73284127dd704d41$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $73284127dd704d41$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $d8wxR.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("d8wxR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $9905447aa876b083$var$InternMap extends Map {
    constructor(entries, key = $9905447aa876b083$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($9905447aa876b083$var$intern_get(this, key));
    }
    has(key) {
        return super.has($9905447aa876b083$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($9905447aa876b083$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($9905447aa876b083$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $9905447aa876b083$var$InternMap;
class $9905447aa876b083$var$InternSet extends Set {
    constructor(values, key = $9905447aa876b083$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($9905447aa876b083$var$intern_get(this, value));
    }
    add(value) {
        return super.add($9905447aa876b083$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($9905447aa876b083$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $9905447aa876b083$var$InternSet;
function $9905447aa876b083$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $9905447aa876b083$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $9905447aa876b083$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $9905447aa876b083$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("77gcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52e5c19d70568b80$var$identity;
function $52e5c19d70568b80$var$identity(x) {
    return x;
}

});


parcelRegister("h00RI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6031b95eb1df496$var$groupSort;

var $c6031b95eb1df496$var$_ascending = $c6031b95eb1df496$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $c6031b95eb1df496$var$_group = $c6031b95eb1df496$var$_interopRequireWildcard((parcelRequire("9SYIs")));

var $c6031b95eb1df496$var$_sort = $c6031b95eb1df496$var$_interopRequireDefault((parcelRequire("8rhWG")));
function $c6031b95eb1df496$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c6031b95eb1df496$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c6031b95eb1df496$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c6031b95eb1df496$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c6031b95eb1df496$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c6031b95eb1df496$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $c6031b95eb1df496$var$_sort.default)((0, $c6031b95eb1df496$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $c6031b95eb1df496$var$_ascending.default)(av, bv) || (0, $c6031b95eb1df496$var$_ascending.default)(ak, bk)) : (0, $c6031b95eb1df496$var$_sort.default)((0, $c6031b95eb1df496$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $c6031b95eb1df496$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("8rhWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $624ec3f066e4d6a4$var$ascendingDefined;
module.exports.compareDefined = $624ec3f066e4d6a4$var$compareDefined;
module.exports.default = $624ec3f066e4d6a4$var$sort;

var $624ec3f066e4d6a4$var$_ascending = $624ec3f066e4d6a4$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $624ec3f066e4d6a4$var$_permute = $624ec3f066e4d6a4$var$_interopRequireDefault((parcelRequire("f3OLU")));
function $624ec3f066e4d6a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $624ec3f066e4d6a4$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $624ec3f066e4d6a4$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$624ec3f066e4d6a4$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $624ec3f066e4d6a4$var$_permute.default)(values, index);
    }
    return values.sort($624ec3f066e4d6a4$var$compareDefined(f));
}
function $624ec3f066e4d6a4$var$compareDefined(compare = $624ec3f066e4d6a4$var$_ascending.default) {
    if (compare === $624ec3f066e4d6a4$var$_ascending.default) return $624ec3f066e4d6a4$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $624ec3f066e4d6a4$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("f3OLU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af6e850ad715f8b4$var$permute;
function $af6e850ad715f8b4$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("iiDbE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5284e2502431038$var$bin;

var $7Sjqc = parcelRequire("7Sjqc");

var $d5284e2502431038$var$_bisect = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("50hsX")));

var $d5284e2502431038$var$_constant = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("3Ss8y")));

var $d5284e2502431038$var$_extent = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("fCeyd")));

var $d5284e2502431038$var$_identity = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("77gcH")));

var $d5284e2502431038$var$_nice = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("3LjTq")));

var $d5284e2502431038$var$_ticks = $d5284e2502431038$var$_interopRequireWildcard((parcelRequire("lNqvt")));

var $d5284e2502431038$var$_sturges = $d5284e2502431038$var$_interopRequireDefault((parcelRequire("adr59")));
function $d5284e2502431038$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d5284e2502431038$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d5284e2502431038$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d5284e2502431038$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d5284e2502431038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d5284e2502431038$var$bin() {
    var value = $d5284e2502431038$var$_identity.default, domain = $d5284e2502431038$var$_extent.default, threshold = $d5284e2502431038$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $d5284e2502431038$var$_extent.default) [x0, x1] = (0, $d5284e2502431038$var$_nice.default)(x0, x1, tn);
            tz = (0, $d5284e2502431038$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $d5284e2502431038$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $d5284e2502431038$var$_extent.default) {
                    const step = (0, $d5284e2502431038$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $d5284e2502431038$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $d5284e2502431038$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $d5284e2502431038$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $d5284e2502431038$var$_constant.default)($7Sjqc.slice.call(_)) : (0, $d5284e2502431038$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("7Sjqc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $5bbca4470d269693$var$array = Array.prototype;
var $5bbca4470d269693$var$slice = $5bbca4470d269693$var$array.slice;
module.exports.slice = $5bbca4470d269693$var$slice;
var $5bbca4470d269693$var$map = $5bbca4470d269693$var$array.map;
module.exports.map = $5bbca4470d269693$var$map;

});

parcelRegister("3Ss8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d2c3daf2aa1ffdc$var$constant;
function $2d2c3daf2aa1ffdc$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("3LjTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2bd5313aec6a9c30$var$nice;

var $lNqvt = parcelRequire("lNqvt");
function $2bd5313aec6a9c30$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $lNqvt.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("lNqvt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fde2bc38e4f5afc3$var$ticks;
module.exports.tickIncrement = $fde2bc38e4f5afc3$var$tickIncrement;
module.exports.tickStep = $fde2bc38e4f5afc3$var$tickStep;
var $fde2bc38e4f5afc3$var$e10 = Math.sqrt(50), $fde2bc38e4f5afc3$var$e5 = Math.sqrt(10), $fde2bc38e4f5afc3$var$e2 = Math.sqrt(2);
function $fde2bc38e4f5afc3$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $fde2bc38e4f5afc3$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $fde2bc38e4f5afc3$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $fde2bc38e4f5afc3$var$e10 ? 10 : error >= $fde2bc38e4f5afc3$var$e5 ? 5 : error >= $fde2bc38e4f5afc3$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $fde2bc38e4f5afc3$var$e10 ? 10 : error >= $fde2bc38e4f5afc3$var$e5 ? 5 : error >= $fde2bc38e4f5afc3$var$e2 ? 2 : 1);
}
function $fde2bc38e4f5afc3$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $fde2bc38e4f5afc3$var$e10) step1 *= 10;
    else if (error >= $fde2bc38e4f5afc3$var$e5) step1 *= 5;
    else if (error >= $fde2bc38e4f5afc3$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("adr59", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $770020379dcc9b39$var$thresholdSturges;

var $770020379dcc9b39$var$_count = $770020379dcc9b39$var$_interopRequireDefault((parcelRequire("B0FcQ")));
function $770020379dcc9b39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $770020379dcc9b39$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $770020379dcc9b39$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("1uW1a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $117598ebf77d0fdf$var$thresholdFreedmanDiaconis;

var $117598ebf77d0fdf$var$_count = $117598ebf77d0fdf$var$_interopRequireDefault((parcelRequire("B0FcQ")));

var $117598ebf77d0fdf$var$_quantile = $117598ebf77d0fdf$var$_interopRequireDefault((parcelRequire("hOh6k")));
function $117598ebf77d0fdf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $117598ebf77d0fdf$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $117598ebf77d0fdf$var$_quantile.default)(values, 0.75) - (0, $117598ebf77d0fdf$var$_quantile.default)(values, 0.25)) * Math.pow((0, $117598ebf77d0fdf$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("hOh6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf745f1b5ed9b533$var$quantile;
module.exports.quantileSorted = $cf745f1b5ed9b533$var$quantileSorted;

var $cf745f1b5ed9b533$var$_max = $cf745f1b5ed9b533$var$_interopRequireDefault((parcelRequire("ce6z6")));

var $cf745f1b5ed9b533$var$_min = $cf745f1b5ed9b533$var$_interopRequireDefault((parcelRequire("jLkc0")));

var $cf745f1b5ed9b533$var$_quickselect = $cf745f1b5ed9b533$var$_interopRequireDefault((parcelRequire("iu9vt")));

var $cf745f1b5ed9b533$var$_number = $cf745f1b5ed9b533$var$_interopRequireWildcard((parcelRequire("9kSxs")));
function $cf745f1b5ed9b533$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cf745f1b5ed9b533$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cf745f1b5ed9b533$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cf745f1b5ed9b533$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cf745f1b5ed9b533$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cf745f1b5ed9b533$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $cf745f1b5ed9b533$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $cf745f1b5ed9b533$var$_min.default)(values);
    if (p >= 1) return (0, $cf745f1b5ed9b533$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $cf745f1b5ed9b533$var$_max.default)((0, $cf745f1b5ed9b533$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $cf745f1b5ed9b533$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $cf745f1b5ed9b533$var$quantileSorted(values, p, valueof = $cf745f1b5ed9b533$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("ce6z6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e6be28a33aa3bb7$var$max;
function $8e6be28a33aa3bb7$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("jLkc0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e63211ef9919b23a$var$min;
function $e63211ef9919b23a$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("iu9vt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d75267222512359a$var$quickselect;

var $8rhWG = parcelRequire("8rhWG");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $d75267222512359a$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $8rhWG.ascendingDefined : (0, $8rhWG.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $d75267222512359a$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $d75267222512359a$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $d75267222512359a$var$swap(array, left, right);
        while(i < j){
            $d75267222512359a$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $d75267222512359a$var$swap(array, left, j);
        else ++j, $d75267222512359a$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $d75267222512359a$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("lGKgU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fca169d6acce0181$var$thresholdScott;

var $fca169d6acce0181$var$_count = $fca169d6acce0181$var$_interopRequireDefault((parcelRequire("B0FcQ")));

var $fca169d6acce0181$var$_deviation = $fca169d6acce0181$var$_interopRequireDefault((parcelRequire("6R9wc")));
function $fca169d6acce0181$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fca169d6acce0181$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $fca169d6acce0181$var$_count.default)(values)) / (3.49 * (0, $fca169d6acce0181$var$_deviation.default)(values)));
}

});

parcelRegister("hSJeR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d04a924b4bebcf11$var$maxIndex;
function $d04a924b4bebcf11$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("iVSVg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc88275bd552ee53$var$mean;
function $dc88275bd552ee53$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("6PJG2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4f9af005bc7b83ac$var$median;

var $4f9af005bc7b83ac$var$_quantile = $4f9af005bc7b83ac$var$_interopRequireDefault((parcelRequire("hOh6k")));
function $4f9af005bc7b83ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4f9af005bc7b83ac$var$median(values, valueof) {
    return (0, $4f9af005bc7b83ac$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("4DnlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35fcead95b540d3b$var$merge;
function* $35fcead95b540d3b$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $35fcead95b540d3b$var$merge(arrays) {
    return Array.from($35fcead95b540d3b$var$flatten(arrays));
}

});

parcelRegister("7F7RN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $594276ec57fd172c$var$minIndex;
function $594276ec57fd172c$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("9jCGh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c83e49ed9ad1a21$var$mode;

var $d8wxR = parcelRequire("d8wxR");
function $6c83e49ed9ad1a21$var$mode(values, valueof) {
    const counts = new $d8wxR.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("66Zpf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4732efa313865a37$var$pairs;
module.exports.pair = $4732efa313865a37$var$pair;
function $4732efa313865a37$var$pairs(values, pairof = $4732efa313865a37$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $4732efa313865a37$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("3NGme", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c46ce0a1a43eb38$var$range;
function $2c46ce0a1a43eb38$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("fUJBh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b95f753f2c21ecde$var$rank;

var $b95f753f2c21ecde$var$_ascending = $b95f753f2c21ecde$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $8rhWG = parcelRequire("8rhWG");
function $b95f753f2c21ecde$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b95f753f2c21ecde$var$rank(values, valueof = $b95f753f2c21ecde$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $b95f753f2c21ecde$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $b95f753f2c21ecde$var$_ascending.default ? (i, j)=>(0, $8rhWG.ascendingDefined)(V[i], V[j]) : (0, $8rhWG.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("1JEk8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $143945e186b7444e$var$least;

var $143945e186b7444e$var$_ascending = $143945e186b7444e$var$_interopRequireDefault((parcelRequire("gSmOd")));
function $143945e186b7444e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $143945e186b7444e$var$least(values, compare = $143945e186b7444e$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $143945e186b7444e$var$_ascending.default)(value, minValue) < 0 : (0, $143945e186b7444e$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("8rK9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6264a67808e78b37$var$leastIndex;

var $6264a67808e78b37$var$_ascending = $6264a67808e78b37$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $6264a67808e78b37$var$_minIndex = $6264a67808e78b37$var$_interopRequireDefault((parcelRequire("7F7RN")));
function $6264a67808e78b37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6264a67808e78b37$var$leastIndex(values, compare = $6264a67808e78b37$var$_ascending.default) {
    if (compare.length === 1) return (0, $6264a67808e78b37$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("515Me", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3a7186e6ac711b17$var$greatest;

var $3a7186e6ac711b17$var$_ascending = $3a7186e6ac711b17$var$_interopRequireDefault((parcelRequire("gSmOd")));
function $3a7186e6ac711b17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3a7186e6ac711b17$var$greatest(values, compare = $3a7186e6ac711b17$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $3a7186e6ac711b17$var$_ascending.default)(value, maxValue) > 0 : (0, $3a7186e6ac711b17$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("1ePGl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e6f30335ddfeb4f$var$greatestIndex;

var $0e6f30335ddfeb4f$var$_ascending = $0e6f30335ddfeb4f$var$_interopRequireDefault((parcelRequire("gSmOd")));

var $0e6f30335ddfeb4f$var$_maxIndex = $0e6f30335ddfeb4f$var$_interopRequireDefault((parcelRequire("hSJeR")));
function $0e6f30335ddfeb4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e6f30335ddfeb4f$var$greatestIndex(values, compare = $0e6f30335ddfeb4f$var$_ascending.default) {
    if (compare.length === 1) return (0, $0e6f30335ddfeb4f$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("j4neO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de206a9ae4452b3e$var$scan;

var $de206a9ae4452b3e$var$_leastIndex = $de206a9ae4452b3e$var$_interopRequireDefault((parcelRequire("8rK9T")));
function $de206a9ae4452b3e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $de206a9ae4452b3e$var$scan(values, compare) {
    const index = (0, $de206a9ae4452b3e$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("cXhGa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $96e8b56be4abce01$var$shuffler;
var $96e8b56be4abce01$var$_default = $96e8b56be4abce01$var$shuffler(Math.random);
module.exports.default = $96e8b56be4abce01$var$_default;
function $96e8b56be4abce01$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("cFUOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $93a563672131aacf$var$sum;
function $93a563672131aacf$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("8X8hw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $684a41f91440e3f0$var$transpose;

var $684a41f91440e3f0$var$_min = $684a41f91440e3f0$var$_interopRequireDefault((parcelRequire("jLkc0")));
function $684a41f91440e3f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $684a41f91440e3f0$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $684a41f91440e3f0$var$_min.default)(matrix, $684a41f91440e3f0$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $684a41f91440e3f0$var$length(d) {
    return d.length;
}

});

parcelRegister("dfRxN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a6635cdb11af463$var$zip;

var $9a6635cdb11af463$var$_transpose = $9a6635cdb11af463$var$_interopRequireDefault((parcelRequire("8X8hw")));
function $9a6635cdb11af463$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a6635cdb11af463$var$zip() {
    return (0, $9a6635cdb11af463$var$_transpose.default)(arguments);
}

});

parcelRegister("8phHQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61ee64a0c8a89947$var$every;
function $61ee64a0c8a89947$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("6vEyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4bd5184de2878726$var$some;
function $4bd5184de2878726$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("1dXRb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e456fa2977a93ee$var$filter;
function $0e456fa2977a93ee$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("4Qem4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3867275de0f42d9b$var$map;
function $3867275de0f42d9b$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("3Dv2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a5d1810aaaade27$var$reduce;
function $2a5d1810aaaade27$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("819Yo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d66272d09086d8f$var$reverse;
function $5d66272d09086d8f$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("hiw9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c97d0e6a8ef67244$var$difference;

var $d8wxR = parcelRequire("d8wxR");
function $c97d0e6a8ef67244$var$difference(values, ...others) {
    values = new $d8wxR.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("805HS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d32c011d4e5c3fd$var$disjoint;

var $d8wxR = parcelRequire("d8wxR");
function $5d32c011d4e5c3fd$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $d8wxR.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("4MhWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37a98fb5f3c5764e$var$intersection;

var $d8wxR = parcelRequire("d8wxR");
function $37a98fb5f3c5764e$var$intersection(values, ...others) {
    values = new $d8wxR.InternSet(values);
    others = others.map($37a98fb5f3c5764e$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $37a98fb5f3c5764e$var$set(values) {
    return values instanceof $d8wxR.InternSet ? values : new $d8wxR.InternSet(values);
}

});

parcelRegister("9FiNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $70968723756a3fd5$var$subset;

var $70968723756a3fd5$var$_superset = $70968723756a3fd5$var$_interopRequireDefault((parcelRequire("d1vnx")));
function $70968723756a3fd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $70968723756a3fd5$var$subset(values, other) {
    return (0, $70968723756a3fd5$var$_superset.default)(other, values);
}

});
parcelRegister("d1vnx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97b3b58692bdb4f8$var$superset;
function $97b3b58692bdb4f8$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $97b3b58692bdb4f8$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $97b3b58692bdb4f8$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $97b3b58692bdb4f8$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("ixdWC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $037b7421ad4d4ab6$var$union;

var $d8wxR = parcelRequire("d8wxR");
function $037b7421ad4d4ab6$var$union(...others) {
    const set = new $d8wxR.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("fb4yo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $b0cb6a64ba86d059$var$initInterpolator;
module.exports.initRange = $b0cb6a64ba86d059$var$initRange;
function $b0cb6a64ba86d059$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $b0cb6a64ba86d059$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("fGuak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6b22d856a9b8fd9$var$ordinal;
module.exports.implicit = void 0;

var $jaQ55 = parcelRequire("jaQ55");

var $fb4yo = parcelRequire("fb4yo");
const $b6b22d856a9b8fd9$var$implicit = Symbol("implicit");
module.exports.implicit = $b6b22d856a9b8fd9$var$implicit;
function $b6b22d856a9b8fd9$var$ordinal() {
    var index = new $jaQ55.InternMap(), domain = [], range = [], unknown = $b6b22d856a9b8fd9$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $b6b22d856a9b8fd9$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $jaQ55.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $b6b22d856a9b8fd9$var$ordinal(domain, range).unknown(unknown);
    };
    $fb4yo.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("bllFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84227700f22213cb$var$identity;

var $537RU = parcelRequire("537RU");

var $84227700f22213cb$var$_number = $84227700f22213cb$var$_interopRequireDefault((parcelRequire("hzL4o")));
function $84227700f22213cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84227700f22213cb$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $84227700f22213cb$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $84227700f22213cb$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $84227700f22213cb$var$_number.default) : [
        0,
        1
    ];
    return (0, $537RU.linearish)(scale);
}

});
parcelRegister("537RU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ad3560f3b509adf$var$linear;
module.exports.linearish = $3ad3560f3b509adf$var$linearish;

var $jaQ55 = parcelRequire("jaQ55");

var $3ad3560f3b509adf$var$_continuous = $3ad3560f3b509adf$var$_interopRequireWildcard((parcelRequire("iqqI4")));

var $fb4yo = parcelRequire("fb4yo");

var $3ad3560f3b509adf$var$_tickFormat = $3ad3560f3b509adf$var$_interopRequireDefault((parcelRequire("9ItUs")));
function $3ad3560f3b509adf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ad3560f3b509adf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3ad3560f3b509adf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3ad3560f3b509adf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3ad3560f3b509adf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3ad3560f3b509adf$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $jaQ55.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $3ad3560f3b509adf$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $jaQ55.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $3ad3560f3b509adf$var$linear() {
    var scale = (0, $3ad3560f3b509adf$var$_continuous.default)();
    scale.copy = function() {
        return (0, $3ad3560f3b509adf$var$_continuous.copy)(scale, $3ad3560f3b509adf$var$linear());
    };
    $fb4yo.initRange.apply(scale, arguments);
    return $3ad3560f3b509adf$var$linearish(scale);
}

});
parcelRegister("iqqI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $d69f5fb3ad24f410$var$copy;
module.exports.default = $d69f5fb3ad24f410$var$continuous;
module.exports.identity = $d69f5fb3ad24f410$var$identity;
module.exports.transformer = $d69f5fb3ad24f410$var$transformer;

var $jaQ55 = parcelRequire("jaQ55");

var $fZ8cD = parcelRequire("fZ8cD");

var $d69f5fb3ad24f410$var$_constant = $d69f5fb3ad24f410$var$_interopRequireDefault((parcelRequire("7ydx5")));

var $d69f5fb3ad24f410$var$_number = $d69f5fb3ad24f410$var$_interopRequireDefault((parcelRequire("hzL4o")));
function $d69f5fb3ad24f410$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d69f5fb3ad24f410$var$unit = [
    0,
    1
];
function $d69f5fb3ad24f410$var$identity(x) {
    return x;
}
function $d69f5fb3ad24f410$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $d69f5fb3ad24f410$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $d69f5fb3ad24f410$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $d69f5fb3ad24f410$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $d69f5fb3ad24f410$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $d69f5fb3ad24f410$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $d69f5fb3ad24f410$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $d69f5fb3ad24f410$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $jaQ55.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $d69f5fb3ad24f410$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $d69f5fb3ad24f410$var$transformer() {
    var domain = $d69f5fb3ad24f410$var$unit, range = $d69f5fb3ad24f410$var$unit, interpolate = $fZ8cD.interpolate, transform, untransform, unknown, clamp = $d69f5fb3ad24f410$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $d69f5fb3ad24f410$var$identity) clamp = $d69f5fb3ad24f410$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $d69f5fb3ad24f410$var$polymap : $d69f5fb3ad24f410$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $fZ8cD.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $d69f5fb3ad24f410$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $fZ8cD.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $d69f5fb3ad24f410$var$identity, rescale()) : clamp !== $d69f5fb3ad24f410$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $d69f5fb3ad24f410$var$continuous() {
    return $d69f5fb3ad24f410$var$transformer()($d69f5fb3ad24f410$var$identity, $d69f5fb3ad24f410$var$identity);
}

});
parcelRegister("fZ8cD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $fhxwY.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $fhxwY.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $ba32ea6d000b6c0a$var$_quantize.default;
    }
});

var $ba32ea6d000b6c0a$var$_value = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("0NuDC")));

var $ba32ea6d000b6c0a$var$_array = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("ejwy2")));

var $ba32ea6d000b6c0a$var$_basis = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("bjFnX")));

var $ba32ea6d000b6c0a$var$_basisClosed = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("eQAwj")));

var $ba32ea6d000b6c0a$var$_date = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("9WYqL")));

var $ba32ea6d000b6c0a$var$_discrete = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("cet6d")));

var $ba32ea6d000b6c0a$var$_hue = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("cOvuY")));

var $ba32ea6d000b6c0a$var$_number = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("77Lqb")));

var $ba32ea6d000b6c0a$var$_numberArray = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("9fKPb")));

var $ba32ea6d000b6c0a$var$_object = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("eRksO")));

var $ba32ea6d000b6c0a$var$_round = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("3SrW9")));

var $ba32ea6d000b6c0a$var$_string = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("luTUo")));

var $fhxwY = parcelRequire("fhxwY");

var $ba32ea6d000b6c0a$var$_zoom = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("iAOF9")));

var $ba32ea6d000b6c0a$var$_rgb = $ba32ea6d000b6c0a$var$_interopRequireWildcard((parcelRequire("9Mw47")));

var $ba32ea6d000b6c0a$var$_hsl = $ba32ea6d000b6c0a$var$_interopRequireWildcard((parcelRequire("di2nZ")));

var $ba32ea6d000b6c0a$var$_lab = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("9pG6j")));

var $ba32ea6d000b6c0a$var$_hcl = $ba32ea6d000b6c0a$var$_interopRequireWildcard((parcelRequire("k2tBF")));

var $ba32ea6d000b6c0a$var$_cubehelix = $ba32ea6d000b6c0a$var$_interopRequireWildcard((parcelRequire("37wcE")));

var $ba32ea6d000b6c0a$var$_piecewise = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("lwQ4a")));

var $ba32ea6d000b6c0a$var$_quantize = $ba32ea6d000b6c0a$var$_interopRequireDefault((parcelRequire("3qvS8")));
function $ba32ea6d000b6c0a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ba32ea6d000b6c0a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ba32ea6d000b6c0a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ba32ea6d000b6c0a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ba32ea6d000b6c0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("0NuDC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $00266483556ee94b$var$_default;

var $6DYlb = parcelRequire("6DYlb");

var $00266483556ee94b$var$_rgb = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("9Mw47")));

var $ejwy2 = parcelRequire("ejwy2");

var $00266483556ee94b$var$_date = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("9WYqL")));

var $00266483556ee94b$var$_number = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("77Lqb")));

var $00266483556ee94b$var$_object = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("eRksO")));

var $00266483556ee94b$var$_string = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("luTUo")));

var $00266483556ee94b$var$_constant = $00266483556ee94b$var$_interopRequireDefault((parcelRequire("50oN7")));

var $00266483556ee94b$var$_numberArray = $00266483556ee94b$var$_interopRequireWildcard((parcelRequire("9fKPb")));
function $00266483556ee94b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($00266483556ee94b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $00266483556ee94b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $00266483556ee94b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $00266483556ee94b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $00266483556ee94b$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $00266483556ee94b$var$_constant.default)(b) : (t === "number" ? $00266483556ee94b$var$_number.default : t === "string" ? (c = (0, $6DYlb.color)(b)) ? (b = c, $00266483556ee94b$var$_rgb.default) : $00266483556ee94b$var$_string.default : b instanceof $6DYlb.color ? $00266483556ee94b$var$_rgb.default : b instanceof Date ? $00266483556ee94b$var$_date.default : (0, $00266483556ee94b$var$_numberArray.isNumberArray)(b) ? $00266483556ee94b$var$_numberArray.default : Array.isArray(b) ? $ejwy2.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $00266483556ee94b$var$_object.default : $00266483556ee94b$var$_number.default)(a, b);
}

});
parcelRegister("6DYlb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $4d65310498533aaa$var$_color.rgb;
    }
});

var $4d65310498533aaa$var$_color = $4d65310498533aaa$var$_interopRequireWildcard((parcelRequire("d5OI1")));

var $4d65310498533aaa$var$_lab = $4d65310498533aaa$var$_interopRequireWildcard((parcelRequire("8LMl5")));

var $4d65310498533aaa$var$_cubehelix = $4d65310498533aaa$var$_interopRequireDefault((parcelRequire("hfS5c")));
function $4d65310498533aaa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d65310498533aaa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4d65310498533aaa$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4d65310498533aaa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4d65310498533aaa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("d5OI1", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("llRgm")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("llRgm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8b4e0058b78444a$var$_default;
module.exports.extend = $f8b4e0058b78444a$var$extend;
function $f8b4e0058b78444a$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f8b4e0058b78444a$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("8LMl5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $662835a4acf8e5ef$var$Hcl;
module.exports.Lab = $662835a4acf8e5ef$var$Lab;
module.exports.default = $662835a4acf8e5ef$var$lab;
module.exports.gray = $662835a4acf8e5ef$var$gray;
module.exports.hcl = $662835a4acf8e5ef$var$hcl;
module.exports.lch = $662835a4acf8e5ef$var$lch;

var $662835a4acf8e5ef$var$_define = $662835a4acf8e5ef$var$_interopRequireWildcard((parcelRequire("llRgm")));

var $d5OI1 = parcelRequire("d5OI1");

var $cRCgd = parcelRequire("cRCgd");
function $662835a4acf8e5ef$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($662835a4acf8e5ef$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $662835a4acf8e5ef$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $662835a4acf8e5ef$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $662835a4acf8e5ef$var$K = 18, $662835a4acf8e5ef$var$Xn = 0.96422, $662835a4acf8e5ef$var$Yn = 1, $662835a4acf8e5ef$var$Zn = 0.82521, $662835a4acf8e5ef$var$t0 = 4 / 29, $662835a4acf8e5ef$var$t1 = 6 / 29, $662835a4acf8e5ef$var$t2 = 3 * $662835a4acf8e5ef$var$t1 * $662835a4acf8e5ef$var$t1, $662835a4acf8e5ef$var$t3 = $662835a4acf8e5ef$var$t1 * $662835a4acf8e5ef$var$t1 * $662835a4acf8e5ef$var$t1;
function $662835a4acf8e5ef$var$labConvert(o) {
    if (o instanceof $662835a4acf8e5ef$var$Lab) return new $662835a4acf8e5ef$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $662835a4acf8e5ef$var$Hcl) return $662835a4acf8e5ef$var$hcl2lab(o);
    if (!(o instanceof $d5OI1.Rgb)) o = (0, $d5OI1.rgbConvert)(o);
    var r = $662835a4acf8e5ef$var$rgb2lrgb(o.r), g = $662835a4acf8e5ef$var$rgb2lrgb(o.g), b = $662835a4acf8e5ef$var$rgb2lrgb(o.b), y = $662835a4acf8e5ef$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $662835a4acf8e5ef$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $662835a4acf8e5ef$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $662835a4acf8e5ef$var$Xn);
        z = $662835a4acf8e5ef$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $662835a4acf8e5ef$var$Zn);
    }
    return new $662835a4acf8e5ef$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $662835a4acf8e5ef$var$gray(l, opacity) {
    return new $662835a4acf8e5ef$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $662835a4acf8e5ef$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $662835a4acf8e5ef$var$labConvert(l) : new $662835a4acf8e5ef$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $662835a4acf8e5ef$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $662835a4acf8e5ef$var$_define.default)($662835a4acf8e5ef$var$Lab, $662835a4acf8e5ef$var$lab, (0, $662835a4acf8e5ef$var$_define.extend)($d5OI1.Color, {
    brighter (k) {
        return new $662835a4acf8e5ef$var$Lab(this.l + $662835a4acf8e5ef$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $662835a4acf8e5ef$var$Lab(this.l - $662835a4acf8e5ef$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $662835a4acf8e5ef$var$Xn * $662835a4acf8e5ef$var$lab2xyz(x);
        y = $662835a4acf8e5ef$var$Yn * $662835a4acf8e5ef$var$lab2xyz(y);
        z = $662835a4acf8e5ef$var$Zn * $662835a4acf8e5ef$var$lab2xyz(z);
        return new $d5OI1.Rgb($662835a4acf8e5ef$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $662835a4acf8e5ef$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $662835a4acf8e5ef$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $662835a4acf8e5ef$var$xyz2lab(t) {
    return t > $662835a4acf8e5ef$var$t3 ? Math.pow(t, 1 / 3) : t / $662835a4acf8e5ef$var$t2 + $662835a4acf8e5ef$var$t0;
}
function $662835a4acf8e5ef$var$lab2xyz(t) {
    return t > $662835a4acf8e5ef$var$t1 ? t * t * t : $662835a4acf8e5ef$var$t2 * (t - $662835a4acf8e5ef$var$t0);
}
function $662835a4acf8e5ef$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $662835a4acf8e5ef$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $662835a4acf8e5ef$var$hclConvert(o) {
    if (o instanceof $662835a4acf8e5ef$var$Hcl) return new $662835a4acf8e5ef$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $662835a4acf8e5ef$var$Lab)) o = $662835a4acf8e5ef$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $662835a4acf8e5ef$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $cRCgd.degrees;
    return new $662835a4acf8e5ef$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $662835a4acf8e5ef$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $662835a4acf8e5ef$var$hclConvert(l) : new $662835a4acf8e5ef$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $662835a4acf8e5ef$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $662835a4acf8e5ef$var$hclConvert(h) : new $662835a4acf8e5ef$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $662835a4acf8e5ef$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $662835a4acf8e5ef$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $662835a4acf8e5ef$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $cRCgd.radians;
    return new $662835a4acf8e5ef$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $662835a4acf8e5ef$var$_define.default)($662835a4acf8e5ef$var$Hcl, $662835a4acf8e5ef$var$hcl, (0, $662835a4acf8e5ef$var$_define.extend)($d5OI1.Color, {
    brighter (k) {
        return new $662835a4acf8e5ef$var$Hcl(this.h, this.c, this.l + $662835a4acf8e5ef$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $662835a4acf8e5ef$var$Hcl(this.h, this.c, this.l - $662835a4acf8e5ef$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $662835a4acf8e5ef$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("cRCgd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $95d81d099759b363$var$radians = Math.PI / 180;
module.exports.radians = $95d81d099759b363$var$radians;
const $95d81d099759b363$var$degrees = 180 / Math.PI;
module.exports.degrees = $95d81d099759b363$var$degrees;

});


parcelRegister("hfS5c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $c8fdca1d4948b1a7$var$Cubehelix;
module.exports.default = $c8fdca1d4948b1a7$var$cubehelix;

var $c8fdca1d4948b1a7$var$_define = $c8fdca1d4948b1a7$var$_interopRequireWildcard((parcelRequire("llRgm")));

var $d5OI1 = parcelRequire("d5OI1");

var $cRCgd = parcelRequire("cRCgd");
function $c8fdca1d4948b1a7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c8fdca1d4948b1a7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c8fdca1d4948b1a7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c8fdca1d4948b1a7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c8fdca1d4948b1a7$var$A = -0.14861, $c8fdca1d4948b1a7$var$B = 1.78277, $c8fdca1d4948b1a7$var$C = -0.29227, $c8fdca1d4948b1a7$var$D = -0.90649, $c8fdca1d4948b1a7$var$E = 1.97294, $c8fdca1d4948b1a7$var$ED = $c8fdca1d4948b1a7$var$E * $c8fdca1d4948b1a7$var$D, $c8fdca1d4948b1a7$var$EB = $c8fdca1d4948b1a7$var$E * $c8fdca1d4948b1a7$var$B, $c8fdca1d4948b1a7$var$BC_DA = $c8fdca1d4948b1a7$var$B * $c8fdca1d4948b1a7$var$C - $c8fdca1d4948b1a7$var$D * $c8fdca1d4948b1a7$var$A;
function $c8fdca1d4948b1a7$var$cubehelixConvert(o) {
    if (o instanceof $c8fdca1d4948b1a7$var$Cubehelix) return new $c8fdca1d4948b1a7$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $d5OI1.Rgb)) o = (0, $d5OI1.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($c8fdca1d4948b1a7$var$BC_DA * b + $c8fdca1d4948b1a7$var$ED * r - $c8fdca1d4948b1a7$var$EB * g) / ($c8fdca1d4948b1a7$var$BC_DA + $c8fdca1d4948b1a7$var$ED - $c8fdca1d4948b1a7$var$EB), bl = b - l, k = ($c8fdca1d4948b1a7$var$E * (g - l) - $c8fdca1d4948b1a7$var$C * bl) / $c8fdca1d4948b1a7$var$D, s = Math.sqrt(k * k + bl * bl) / ($c8fdca1d4948b1a7$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $cRCgd.degrees - 120 : NaN;
    return new $c8fdca1d4948b1a7$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $c8fdca1d4948b1a7$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $c8fdca1d4948b1a7$var$cubehelixConvert(h) : new $c8fdca1d4948b1a7$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $c8fdca1d4948b1a7$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $c8fdca1d4948b1a7$var$_define.default)($c8fdca1d4948b1a7$var$Cubehelix, $c8fdca1d4948b1a7$var$cubehelix, (0, $c8fdca1d4948b1a7$var$_define.extend)($d5OI1.Color, {
    brighter (k) {
        k = k == null ? $d5OI1.brighter : Math.pow($d5OI1.brighter, k);
        return new $c8fdca1d4948b1a7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $d5OI1.darker : Math.pow($d5OI1.darker, k);
        return new $c8fdca1d4948b1a7$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $cRCgd.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $d5OI1.Rgb(255 * (l + a * ($c8fdca1d4948b1a7$var$A * cosh + $c8fdca1d4948b1a7$var$B * sinh)), 255 * (l + a * ($c8fdca1d4948b1a7$var$C * cosh + $c8fdca1d4948b1a7$var$D * sinh)), 255 * (l + a * ($c8fdca1d4948b1a7$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("9Mw47", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $6DYlb = parcelRequire("6DYlb");

var $71f1784a82a92927$var$_basis = $71f1784a82a92927$var$_interopRequireDefault((parcelRequire("bjFnX")));

var $71f1784a82a92927$var$_basisClosed = $71f1784a82a92927$var$_interopRequireDefault((parcelRequire("eQAwj")));

var $71f1784a82a92927$var$_color = $71f1784a82a92927$var$_interopRequireWildcard((parcelRequire("9WAdA")));
function $71f1784a82a92927$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($71f1784a82a92927$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $71f1784a82a92927$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $71f1784a82a92927$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $71f1784a82a92927$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $71f1784a82a92927$var$_default = function rgbGamma(y) {
    var color = (0, $71f1784a82a92927$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $6DYlb.rgb)(start)).r, (end = (0, $6DYlb.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $71f1784a82a92927$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $71f1784a82a92927$var$_default;
function $71f1784a82a92927$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $6DYlb.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $71f1784a82a92927$var$rgbBasis = $71f1784a82a92927$var$rgbSpline($71f1784a82a92927$var$_basis.default);
module.exports.rgbBasis = $71f1784a82a92927$var$rgbBasis;
var $71f1784a82a92927$var$rgbBasisClosed = $71f1784a82a92927$var$rgbSpline($71f1784a82a92927$var$_basisClosed.default);
module.exports.rgbBasisClosed = $71f1784a82a92927$var$rgbBasisClosed;

});
parcelRegister("bjFnX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $83d19256d9d548e1$var$basis;
module.exports.default = $83d19256d9d548e1$var$_default;
function $83d19256d9d548e1$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $83d19256d9d548e1$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $83d19256d9d548e1$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("eQAwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $acf24028b6bfd1fb$var$_default;

var $bjFnX = parcelRequire("bjFnX");
function $acf24028b6bfd1fb$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $bjFnX.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("9WAdA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73d5a006830cc9e6$var$nogamma;
module.exports.gamma = $73d5a006830cc9e6$var$gamma;
module.exports.hue = $73d5a006830cc9e6$var$hue;

var $73d5a006830cc9e6$var$_constant = $73d5a006830cc9e6$var$_interopRequireDefault((parcelRequire("50oN7")));
function $73d5a006830cc9e6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $73d5a006830cc9e6$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $73d5a006830cc9e6$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $73d5a006830cc9e6$var$hue(a, b) {
    var d = b - a;
    return d ? $73d5a006830cc9e6$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $73d5a006830cc9e6$var$_constant.default)(isNaN(a) ? b : a);
}
function $73d5a006830cc9e6$var$gamma(y) {
    return (y = +y) === 1 ? $73d5a006830cc9e6$var$nogamma : function(a, b) {
        return b - a ? $73d5a006830cc9e6$var$exponential(a, b, y) : (0, $73d5a006830cc9e6$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $73d5a006830cc9e6$var$nogamma(a, b) {
    var d = b - a;
    return d ? $73d5a006830cc9e6$var$linear(a, d) : (0, $73d5a006830cc9e6$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("50oN7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3a502edb5fb2b836$var$_default = (x)=>()=>x;
module.exports.default = $3a502edb5fb2b836$var$_default;

});



parcelRegister("ejwy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6bc16695dd553e0$var$_default;
module.exports.genericArray = $a6bc16695dd553e0$var$genericArray;

var $a6bc16695dd553e0$var$_value = $a6bc16695dd553e0$var$_interopRequireDefault((parcelRequire("0NuDC")));

var $a6bc16695dd553e0$var$_numberArray = $a6bc16695dd553e0$var$_interopRequireWildcard((parcelRequire("9fKPb")));
function $a6bc16695dd553e0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a6bc16695dd553e0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a6bc16695dd553e0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a6bc16695dd553e0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a6bc16695dd553e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6bc16695dd553e0$var$_default(a, b) {
    return ((0, $a6bc16695dd553e0$var$_numberArray.isNumberArray)(b) ? $a6bc16695dd553e0$var$_numberArray.default : $a6bc16695dd553e0$var$genericArray)(a, b);
}
function $a6bc16695dd553e0$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $a6bc16695dd553e0$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("9fKPb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bc9d62b390f52a4$var$_default;
module.exports.isNumberArray = $6bc9d62b390f52a4$var$isNumberArray;
function $6bc9d62b390f52a4$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $6bc9d62b390f52a4$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("9WYqL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73e8681affe17e8f$var$_default;
function $73e8681affe17e8f$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("77Lqb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52fdf8bfd62deef7$var$_default;
function $52fdf8bfd62deef7$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("eRksO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad15e396e4f1b50b$var$_default;

var $ad15e396e4f1b50b$var$_value = $ad15e396e4f1b50b$var$_interopRequireDefault((parcelRequire("0NuDC")));
function $ad15e396e4f1b50b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ad15e396e4f1b50b$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $ad15e396e4f1b50b$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("luTUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fa67c496d2457b97$var$_default;

var $fa67c496d2457b97$var$_number = $fa67c496d2457b97$var$_interopRequireDefault((parcelRequire("77Lqb")));
function $fa67c496d2457b97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fa67c496d2457b97$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $fa67c496d2457b97$var$reB = new RegExp($fa67c496d2457b97$var$reA.source, "g");
function $fa67c496d2457b97$var$zero(b) {
    return function() {
        return b;
    };
}
function $fa67c496d2457b97$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $fa67c496d2457b97$var$_default(a, b) {
    var bi = $fa67c496d2457b97$var$reA.lastIndex = $fa67c496d2457b97$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $fa67c496d2457b97$var$reA.exec(a)) && (bm = $fa67c496d2457b97$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $fa67c496d2457b97$var$_number.default)(am, bm)
            });
        }
        bi = $fa67c496d2457b97$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $fa67c496d2457b97$var$one(q[0].x) : $fa67c496d2457b97$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("cet6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8e7d5d5488fef9ff$var$_default;
function $8e7d5d5488fef9ff$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("cOvuY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $954296886511d163$var$_default;

var $9WAdA = parcelRequire("9WAdA");
function $954296886511d163$var$_default(a, b) {
    var i = (0, $9WAdA.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("3SrW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2d2c15f4bf0d4684$var$_default;
function $2d2c15f4bf0d4684$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("fhxwY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $b2027417c2c5c33b$var$_number = $b2027417c2c5c33b$var$_interopRequireDefault((parcelRequire("77Lqb")));

var $lsZCB = parcelRequire("lsZCB");
function $b2027417c2c5c33b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b2027417c2c5c33b$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $b2027417c2c5c33b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b2027417c2c5c33b$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $b2027417c2c5c33b$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $b2027417c2c5c33b$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $b2027417c2c5c33b$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b2027417c2c5c33b$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $b2027417c2c5c33b$var$interpolateTransformCss = $b2027417c2c5c33b$var$interpolateTransform($lsZCB.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $b2027417c2c5c33b$var$interpolateTransformCss;
var $b2027417c2c5c33b$var$interpolateTransformSvg = $b2027417c2c5c33b$var$interpolateTransform($lsZCB.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $b2027417c2c5c33b$var$interpolateTransformSvg;

});
parcelRegister("lsZCB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $fa0c03490c3e71b0$var$parseCss;
module.exports.parseSvg = $fa0c03490c3e71b0$var$parseSvg;

var $fa0c03490c3e71b0$var$_decompose = $fa0c03490c3e71b0$var$_interopRequireWildcard((parcelRequire("a0SOq")));
function $fa0c03490c3e71b0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fa0c03490c3e71b0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fa0c03490c3e71b0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fa0c03490c3e71b0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $fa0c03490c3e71b0$var$svgNode;
/* eslint-disable no-undef */ function $fa0c03490c3e71b0$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $fa0c03490c3e71b0$var$_decompose.identity : (0, $fa0c03490c3e71b0$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $fa0c03490c3e71b0$var$parseSvg(value) {
    if (value == null) return $fa0c03490c3e71b0$var$_decompose.identity;
    if (!$fa0c03490c3e71b0$var$svgNode) $fa0c03490c3e71b0$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $fa0c03490c3e71b0$var$svgNode.setAttribute("transform", value);
    if (!(value = $fa0c03490c3e71b0$var$svgNode.transform.baseVal.consolidate())) return $fa0c03490c3e71b0$var$_decompose.identity;
    value = value.matrix;
    return (0, $fa0c03490c3e71b0$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("a0SOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74a46c075db57d1c$var$_default;
module.exports.identity = void 0;
var $74a46c075db57d1c$var$degrees = 180 / Math.PI;
var $74a46c075db57d1c$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $74a46c075db57d1c$var$identity;
function $74a46c075db57d1c$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $74a46c075db57d1c$var$degrees,
        skewX: Math.atan(skewX) * $74a46c075db57d1c$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("iAOF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $d892e35990e50608$var$epsilon2 = 1e-12;
function $d892e35990e50608$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $d892e35990e50608$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $d892e35990e50608$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $d892e35990e50608$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $d892e35990e50608$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $d892e35990e50608$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $d892e35990e50608$var$tanh(rho * s + r0) - $d892e35990e50608$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $d892e35990e50608$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $d892e35990e50608$var$_default;

});

parcelRegister("di2nZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $6DYlb = parcelRequire("6DYlb");

var $9acece9caaef7518$var$_color = $9acece9caaef7518$var$_interopRequireWildcard((parcelRequire("9WAdA")));
function $9acece9caaef7518$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9acece9caaef7518$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9acece9caaef7518$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9acece9caaef7518$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $9acece9caaef7518$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $6DYlb.hsl)(start)).h, (end = (0, $6DYlb.hsl)(end)).h), s = (0, $9acece9caaef7518$var$_color.default)(start.s, end.s), l = (0, $9acece9caaef7518$var$_color.default)(start.l, end.l), opacity = (0, $9acece9caaef7518$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $9acece9caaef7518$var$_default = $9acece9caaef7518$var$hsl($9acece9caaef7518$var$_color.hue);
module.exports.default = $9acece9caaef7518$var$_default;
var $9acece9caaef7518$var$hslLong = $9acece9caaef7518$var$hsl($9acece9caaef7518$var$_color.default);
module.exports.hslLong = $9acece9caaef7518$var$hslLong;

});

parcelRegister("9pG6j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6da71b33206b36ef$var$lab;

var $6DYlb = parcelRequire("6DYlb");

var $6da71b33206b36ef$var$_color = $6da71b33206b36ef$var$_interopRequireDefault((parcelRequire("9WAdA")));
function $6da71b33206b36ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6da71b33206b36ef$var$lab(start, end) {
    var l = (0, $6da71b33206b36ef$var$_color.default)((start = (0, $6DYlb.lab)(start)).l, (end = (0, $6DYlb.lab)(end)).l), a = (0, $6da71b33206b36ef$var$_color.default)(start.a, end.a), b = (0, $6da71b33206b36ef$var$_color.default)(start.b, end.b), opacity = (0, $6da71b33206b36ef$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("k2tBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $6DYlb = parcelRequire("6DYlb");

var $e96af5cf8fac5f87$var$_color = $e96af5cf8fac5f87$var$_interopRequireWildcard((parcelRequire("9WAdA")));
function $e96af5cf8fac5f87$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e96af5cf8fac5f87$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e96af5cf8fac5f87$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e96af5cf8fac5f87$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e96af5cf8fac5f87$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $6DYlb.hcl)(start)).h, (end = (0, $6DYlb.hcl)(end)).h), c = (0, $e96af5cf8fac5f87$var$_color.default)(start.c, end.c), l = (0, $e96af5cf8fac5f87$var$_color.default)(start.l, end.l), opacity = (0, $e96af5cf8fac5f87$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $e96af5cf8fac5f87$var$_default = $e96af5cf8fac5f87$var$hcl($e96af5cf8fac5f87$var$_color.hue);
module.exports.default = $e96af5cf8fac5f87$var$_default;
var $e96af5cf8fac5f87$var$hclLong = $e96af5cf8fac5f87$var$hcl($e96af5cf8fac5f87$var$_color.default);
module.exports.hclLong = $e96af5cf8fac5f87$var$hclLong;

});

parcelRegister("37wcE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $6DYlb = parcelRequire("6DYlb");

var $245b0160a28f364c$var$_color = $245b0160a28f364c$var$_interopRequireWildcard((parcelRequire("9WAdA")));
function $245b0160a28f364c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($245b0160a28f364c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $245b0160a28f364c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $245b0160a28f364c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $245b0160a28f364c$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $6DYlb.cubehelix)(start)).h, (end = (0, $6DYlb.cubehelix)(end)).h), s = (0, $245b0160a28f364c$var$_color.default)(start.s, end.s), l = (0, $245b0160a28f364c$var$_color.default)(start.l, end.l), opacity = (0, $245b0160a28f364c$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $245b0160a28f364c$var$_default = $245b0160a28f364c$var$cubehelix($245b0160a28f364c$var$_color.hue);
module.exports.default = $245b0160a28f364c$var$_default;
var $245b0160a28f364c$var$cubehelixLong = $245b0160a28f364c$var$cubehelix($245b0160a28f364c$var$_color.default);
module.exports.cubehelixLong = $245b0160a28f364c$var$cubehelixLong;

});

parcelRegister("lwQ4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fac4f965c510b89f$var$piecewise;

var $fac4f965c510b89f$var$_value = $fac4f965c510b89f$var$_interopRequireDefault((parcelRequire("0NuDC")));
function $fac4f965c510b89f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fac4f965c510b89f$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $fac4f965c510b89f$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("3qvS8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27ec85ecd6abb85d$var$_default;
function $27ec85ecd6abb85d$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("7ydx5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57f634b4a6e3e1ed$var$constants;
function $57f634b4a6e3e1ed$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("hzL4o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccba37a19fad7052$var$number;
function $ccba37a19fad7052$var$number(x) {
    return +x;
}

});


parcelRegister("9ItUs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $712f6c8af9c65fb0$var$tickFormat;

var $jaQ55 = parcelRequire("jaQ55");

var $gsaHf = parcelRequire("gsaHf");
function $712f6c8af9c65fb0$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $jaQ55.tickStep)(start, stop, count), precision;
    specifier = (0, $gsaHf.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $gsaHf.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $gsaHf.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $gsaHf.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $gsaHf.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $gsaHf.format)(specifier);
}

});
parcelRegister("gsaHf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $bfa78ef4fde7f409$var$_precisionRound.default;
    }
});

var $bfa78ef4fde7f409$var$_defaultLocale = $bfa78ef4fde7f409$var$_interopRequireWildcard((parcelRequire("9tbzB")));

var $bfa78ef4fde7f409$var$_locale = $bfa78ef4fde7f409$var$_interopRequireDefault((parcelRequire("7DrGC")));

var $bfa78ef4fde7f409$var$_formatSpecifier = $bfa78ef4fde7f409$var$_interopRequireWildcard((parcelRequire("kqKhd")));

var $bfa78ef4fde7f409$var$_precisionFixed = $bfa78ef4fde7f409$var$_interopRequireDefault((parcelRequire("7vQeB")));

var $bfa78ef4fde7f409$var$_precisionPrefix = $bfa78ef4fde7f409$var$_interopRequireDefault((parcelRequire("a6X4c")));

var $bfa78ef4fde7f409$var$_precisionRound = $bfa78ef4fde7f409$var$_interopRequireDefault((parcelRequire("b14aq")));
function $bfa78ef4fde7f409$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfa78ef4fde7f409$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bfa78ef4fde7f409$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bfa78ef4fde7f409$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bfa78ef4fde7f409$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("9tbzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e4fccaf21650660$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $6e4fccaf21650660$var$_locale = $6e4fccaf21650660$var$_interopRequireDefault((parcelRequire("7DrGC")));
function $6e4fccaf21650660$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e4fccaf21650660$var$locale;
var $6e4fccaf21650660$var$format;
module.exports.format = $6e4fccaf21650660$var$format;
var $6e4fccaf21650660$var$formatPrefix;
module.exports.formatPrefix = $6e4fccaf21650660$var$formatPrefix;
$6e4fccaf21650660$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $6e4fccaf21650660$var$defaultLocale(definition) {
    $6e4fccaf21650660$var$locale = (0, $6e4fccaf21650660$var$_locale.default)(definition);
    module.exports.format = $6e4fccaf21650660$var$format = $6e4fccaf21650660$var$locale.format;
    module.exports.formatPrefix = $6e4fccaf21650660$var$formatPrefix = $6e4fccaf21650660$var$locale.formatPrefix;
    return $6e4fccaf21650660$var$locale;
}

});
parcelRegister("7DrGC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58f1a6d779ee9fe5$var$_default;

var $58f1a6d779ee9fe5$var$_exponent = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("78kHA")));

var $58f1a6d779ee9fe5$var$_formatGroup = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("kFEuH")));

var $58f1a6d779ee9fe5$var$_formatNumerals = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("bscei")));

var $58f1a6d779ee9fe5$var$_formatSpecifier = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("kqKhd")));

var $58f1a6d779ee9fe5$var$_formatTrim = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("5vtka")));

var $58f1a6d779ee9fe5$var$_formatTypes = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("1hi5X")));

var $6V4z2 = parcelRequire("6V4z2");

var $58f1a6d779ee9fe5$var$_identity = $58f1a6d779ee9fe5$var$_interopRequireDefault((parcelRequire("9E1FL")));
function $58f1a6d779ee9fe5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $58f1a6d779ee9fe5$var$map = Array.prototype.map, $58f1a6d779ee9fe5$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $58f1a6d779ee9fe5$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $58f1a6d779ee9fe5$var$_identity.default : (0, $58f1a6d779ee9fe5$var$_formatGroup.default)($58f1a6d779ee9fe5$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $58f1a6d779ee9fe5$var$_identity.default : (0, $58f1a6d779ee9fe5$var$_formatNumerals.default)($58f1a6d779ee9fe5$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $58f1a6d779ee9fe5$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$58f1a6d779ee9fe5$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $58f1a6d779ee9fe5$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $58f1a6d779ee9fe5$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $58f1a6d779ee9fe5$var$prefixes[8 + $6V4z2.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $58f1a6d779ee9fe5$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $58f1a6d779ee9fe5$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $58f1a6d779ee9fe5$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("78kHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $531956c07686bdf8$var$_default;

var $43jFg = parcelRequire("43jFg");
function $531956c07686bdf8$var$_default(x) {
    return x = (0, $43jFg.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("43jFg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f36b232b575d102$var$_default;
module.exports.formatDecimalParts = $2f36b232b575d102$var$formatDecimalParts;
function $2f36b232b575d102$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $2f36b232b575d102$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("kFEuH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0c70c41efd46d95$var$_default;
function $f0c70c41efd46d95$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("bscei", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $856bcbc1a9d9b32c$var$_default;
function $856bcbc1a9d9b32c$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("kqKhd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $edfa21ebbd778818$var$FormatSpecifier;
module.exports.default = $edfa21ebbd778818$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $edfa21ebbd778818$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $edfa21ebbd778818$var$formatSpecifier(specifier) {
    if (!(match = $edfa21ebbd778818$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $edfa21ebbd778818$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$edfa21ebbd778818$var$formatSpecifier.prototype = $edfa21ebbd778818$var$FormatSpecifier.prototype; // instanceof
function $edfa21ebbd778818$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$edfa21ebbd778818$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("5vtka", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $402698347c0ba044$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $402698347c0ba044$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("1hi5X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ee56a4c02edc91f$var$_formatDecimal = $0ee56a4c02edc91f$var$_interopRequireDefault((parcelRequire("43jFg")));

var $0ee56a4c02edc91f$var$_formatPrefixAuto = $0ee56a4c02edc91f$var$_interopRequireDefault((parcelRequire("6V4z2")));

var $0ee56a4c02edc91f$var$_formatRounded = $0ee56a4c02edc91f$var$_interopRequireDefault((parcelRequire("bD1K6")));
function $0ee56a4c02edc91f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0ee56a4c02edc91f$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $0ee56a4c02edc91f$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $0ee56a4c02edc91f$var$_formatRounded.default)(x * 100, p),
    "r": $0ee56a4c02edc91f$var$_formatRounded.default,
    "s": $0ee56a4c02edc91f$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $0ee56a4c02edc91f$var$_default;

});
parcelRegister("6V4z2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $509b9b46f9a97883$var$_default;
module.exports.prefixExponent = void 0;

var $43jFg = parcelRequire("43jFg");
var $509b9b46f9a97883$var$prefixExponent;
module.exports.prefixExponent = $509b9b46f9a97883$var$prefixExponent;
function $509b9b46f9a97883$var$_default(x, p) {
    var d = (0, $43jFg.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $509b9b46f9a97883$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $43jFg.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("bD1K6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8774b0459eced5a1$var$_default;

var $43jFg = parcelRequire("43jFg");
function $8774b0459eced5a1$var$_default(x, p) {
    var d = (0, $43jFg.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("9E1FL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $705925a33a20b64c$var$_default;
function $705925a33a20b64c$var$_default(x) {
    return x;
}

});



parcelRegister("7vQeB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5783f253e460ddd0$var$_default;

var $5783f253e460ddd0$var$_exponent = $5783f253e460ddd0$var$_interopRequireDefault((parcelRequire("78kHA")));
function $5783f253e460ddd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5783f253e460ddd0$var$_default(step) {
    return Math.max(0, -(0, $5783f253e460ddd0$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("a6X4c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $75c8485365109a55$var$_default;

var $75c8485365109a55$var$_exponent = $75c8485365109a55$var$_interopRequireDefault((parcelRequire("78kHA")));
function $75c8485365109a55$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $75c8485365109a55$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $75c8485365109a55$var$_exponent.default)(value) / 3))) * 3 - (0, $75c8485365109a55$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("b14aq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8053053696542f10$var$_default;

var $8053053696542f10$var$_exponent = $8053053696542f10$var$_interopRequireDefault((parcelRequire("78kHA")));
function $8053053696542f10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8053053696542f10$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $8053053696542f10$var$_exponent.default)(max) - (0, $8053053696542f10$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("5rmxS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f60f66ebbfbe7e5$var$log;
module.exports.loggish = $3f60f66ebbfbe7e5$var$loggish;

var $jaQ55 = parcelRequire("jaQ55");

var $gsaHf = parcelRequire("gsaHf");

var $3f60f66ebbfbe7e5$var$_nice = $3f60f66ebbfbe7e5$var$_interopRequireDefault((parcelRequire("hdmWb")));

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");
function $3f60f66ebbfbe7e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f60f66ebbfbe7e5$var$transformLog(x) {
    return Math.log(x);
}
function $3f60f66ebbfbe7e5$var$transformExp(x) {
    return Math.exp(x);
}
function $3f60f66ebbfbe7e5$var$transformLogn(x) {
    return -Math.log(-x);
}
function $3f60f66ebbfbe7e5$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $3f60f66ebbfbe7e5$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $3f60f66ebbfbe7e5$var$powp(base) {
    return base === 10 ? $3f60f66ebbfbe7e5$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $3f60f66ebbfbe7e5$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $3f60f66ebbfbe7e5$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $3f60f66ebbfbe7e5$var$loggish(transform) {
    const scale = transform($3f60f66ebbfbe7e5$var$transformLog, $3f60f66ebbfbe7e5$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $3f60f66ebbfbe7e5$var$logp(base), pows = $3f60f66ebbfbe7e5$var$powp(base);
        if (domain()[0] < 0) {
            logs = $3f60f66ebbfbe7e5$var$reflect(logs), pows = $3f60f66ebbfbe7e5$var$reflect(pows);
            transform($3f60f66ebbfbe7e5$var$transformLogn, $3f60f66ebbfbe7e5$var$transformExpn);
        } else transform($3f60f66ebbfbe7e5$var$transformLog, $3f60f66ebbfbe7e5$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $jaQ55.ticks)(u, v, n);
        } else z = (0, $jaQ55.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $gsaHf.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $gsaHf.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $3f60f66ebbfbe7e5$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $3f60f66ebbfbe7e5$var$log() {
    const scale = $3f60f66ebbfbe7e5$var$loggish((0, $iqqI4.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $iqqI4.copy)(scale, $3f60f66ebbfbe7e5$var$log()).base(scale.base());
    $fb4yo.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("hdmWb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c885717684c7a8b8$var$nice;
function $c885717684c7a8b8$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("eH6W2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab2a7603c4555b08$var$symlog;
module.exports.symlogish = $ab2a7603c4555b08$var$symlogish;

var $537RU = parcelRequire("537RU");

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");
function $ab2a7603c4555b08$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $ab2a7603c4555b08$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $ab2a7603c4555b08$var$symlogish(transform) {
    var c = 1, scale = transform($ab2a7603c4555b08$var$transformSymlog(c), $ab2a7603c4555b08$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($ab2a7603c4555b08$var$transformSymlog(c = +_), $ab2a7603c4555b08$var$transformSymexp(c)) : c;
    };
    return (0, $537RU.linearish)(scale);
}
function $ab2a7603c4555b08$var$symlog() {
    var scale = $ab2a7603c4555b08$var$symlogish((0, $iqqI4.transformer)());
    scale.copy = function() {
        return (0, $iqqI4.copy)(scale, $ab2a7603c4555b08$var$symlog()).constant(scale.constant());
    };
    return $fb4yo.initRange.apply(scale, arguments);
}

});

parcelRegister("fGBFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b6b8000f031361ec$var$pow;
module.exports.powish = $b6b8000f031361ec$var$powish;
module.exports.sqrt = $b6b8000f031361ec$var$sqrt;

var $537RU = parcelRequire("537RU");

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");
function $b6b8000f031361ec$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $b6b8000f031361ec$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $b6b8000f031361ec$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $b6b8000f031361ec$var$powish(transform) {
    var scale = transform($iqqI4.identity, $iqqI4.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($iqqI4.identity, $iqqI4.identity) : exponent === 0.5 ? transform($b6b8000f031361ec$var$transformSqrt, $b6b8000f031361ec$var$transformSquare) : transform($b6b8000f031361ec$var$transformPow(exponent), $b6b8000f031361ec$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $537RU.linearish)(scale);
}
function $b6b8000f031361ec$var$pow() {
    var scale = $b6b8000f031361ec$var$powish((0, $iqqI4.transformer)());
    scale.copy = function() {
        return (0, $iqqI4.copy)(scale, $b6b8000f031361ec$var$pow()).exponent(scale.exponent());
    };
    $fb4yo.initRange.apply(scale, arguments);
    return scale;
}
function $b6b8000f031361ec$var$sqrt() {
    return $b6b8000f031361ec$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("29xls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $191649aa27052853$var$radial;

var $191649aa27052853$var$_continuous = $191649aa27052853$var$_interopRequireDefault((parcelRequire("iqqI4")));

var $fb4yo = parcelRequire("fb4yo");

var $537RU = parcelRequire("537RU");

var $191649aa27052853$var$_number = $191649aa27052853$var$_interopRequireDefault((parcelRequire("hzL4o")));
function $191649aa27052853$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $191649aa27052853$var$square(x) {
    return Math.sign(x) * x * x;
}
function $191649aa27052853$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $191649aa27052853$var$radial() {
    var squared = (0, $191649aa27052853$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $191649aa27052853$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($191649aa27052853$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $191649aa27052853$var$_number.default)).map($191649aa27052853$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $191649aa27052853$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $fb4yo.initRange.apply(scale, arguments);
    return (0, $537RU.linearish)(scale);
}

});

parcelRegister("ivi4D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d789245646a6684a$var$quantile;

var $jaQ55 = parcelRequire("jaQ55");

var $fb4yo = parcelRequire("fb4yo");
function $d789245646a6684a$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $jaQ55.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $jaQ55.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($jaQ55.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $d789245646a6684a$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $fb4yo.initRange.apply(scale, arguments);
}

});

parcelRegister("hCoKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd392fb2207c58c2$var$quantize;

var $jaQ55 = parcelRequire("jaQ55");

var $537RU = parcelRequire("537RU");

var $fb4yo = parcelRequire("fb4yo");
function $cd392fb2207c58c2$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $jaQ55.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $cd392fb2207c58c2$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $fb4yo.initRange.apply((0, $537RU.linearish)(scale), arguments);
}

});

parcelRegister("a332z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $750c8af2fc5ef564$var$threshold;

var $jaQ55 = parcelRequire("jaQ55");

var $fb4yo = parcelRequire("fb4yo");
function $750c8af2fc5ef564$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $jaQ55.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $750c8af2fc5ef564$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $fb4yo.initRange.apply(scale, arguments);
}

});

parcelRegister("7hETy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $54d9d7d31a39314c$var$calendar;
module.exports.default = $54d9d7d31a39314c$var$time;

var $j8QCl = parcelRequire("j8QCl");

var $gomnW = parcelRequire("gomnW");

var $54d9d7d31a39314c$var$_continuous = $54d9d7d31a39314c$var$_interopRequireWildcard((parcelRequire("iqqI4")));

var $fb4yo = parcelRequire("fb4yo");

var $54d9d7d31a39314c$var$_nice = $54d9d7d31a39314c$var$_interopRequireDefault((parcelRequire("hdmWb")));
function $54d9d7d31a39314c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54d9d7d31a39314c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($54d9d7d31a39314c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $54d9d7d31a39314c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $54d9d7d31a39314c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $54d9d7d31a39314c$var$date(t) {
    return new Date(t);
}
function $54d9d7d31a39314c$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $54d9d7d31a39314c$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $54d9d7d31a39314c$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $54d9d7d31a39314c$var$number)) : domain().map($54d9d7d31a39314c$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $54d9d7d31a39314c$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $54d9d7d31a39314c$var$_continuous.copy)(scale, $54d9d7d31a39314c$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $54d9d7d31a39314c$var$time() {
    return $fb4yo.initRange.apply($54d9d7d31a39314c$var$calendar($j8QCl.timeTicks, $j8QCl.timeTickInterval, $j8QCl.timeYear, $j8QCl.timeMonth, $j8QCl.timeWeek, $j8QCl.timeDay, $j8QCl.timeHour, $j8QCl.timeMinute, $j8QCl.timeSecond, $gomnW.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("j8QCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $8mRu2.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $8mRu2.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $8mRu2.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $8mRu2.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $8mRu2.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $8mRu2.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $8mRu2.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $8mRu2.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $8mRu2.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $8mRu2.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $hi8aN.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $hi8aN.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $8mRu2.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $8mRu2.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $8mRu2.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $8mRu2.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $8mRu2.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $8mRu2.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $hi8aN.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $hi8aN.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $9LVrw.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $def794647e949869$var$_utcYear.utcYears;
    }
});

var $def794647e949869$var$_interval = $def794647e949869$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $def794647e949869$var$_millisecond = $def794647e949869$var$_interopRequireWildcard((parcelRequire("884Bs")));

var $def794647e949869$var$_second = $def794647e949869$var$_interopRequireWildcard((parcelRequire("dBGsr")));

var $def794647e949869$var$_minute = $def794647e949869$var$_interopRequireWildcard((parcelRequire("fy5AE")));

var $def794647e949869$var$_hour = $def794647e949869$var$_interopRequireWildcard((parcelRequire("fDSMI")));

var $def794647e949869$var$_day = $def794647e949869$var$_interopRequireWildcard((parcelRequire("gnQLl")));

var $8mRu2 = parcelRequire("8mRu2");

var $def794647e949869$var$_month = $def794647e949869$var$_interopRequireWildcard((parcelRequire("l18TB")));

var $def794647e949869$var$_year = $def794647e949869$var$_interopRequireWildcard((parcelRequire("iQGef")));

var $def794647e949869$var$_utcMinute = $def794647e949869$var$_interopRequireWildcard((parcelRequire("8BZ33")));

var $def794647e949869$var$_utcHour = $def794647e949869$var$_interopRequireWildcard((parcelRequire("jSs2G")));

var $def794647e949869$var$_utcDay = $def794647e949869$var$_interopRequireWildcard((parcelRequire("aRiOq")));

var $9LVrw = parcelRequire("9LVrw");

var $def794647e949869$var$_utcMonth = $def794647e949869$var$_interopRequireWildcard((parcelRequire("4IyOg")));

var $def794647e949869$var$_utcYear = $def794647e949869$var$_interopRequireWildcard((parcelRequire("drXCr")));

var $hi8aN = parcelRequire("hi8aN");
function $def794647e949869$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($def794647e949869$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $def794647e949869$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $def794647e949869$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $def794647e949869$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hEV6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdb2785cf68729fc$var$newInterval;
var $cdb2785cf68729fc$var$t0 = new Date(), $cdb2785cf68729fc$var$t1 = new Date();
function $cdb2785cf68729fc$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $cdb2785cf68729fc$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $cdb2785cf68729fc$var$t0.setTime(+start), $cdb2785cf68729fc$var$t1.setTime(+end);
            floori($cdb2785cf68729fc$var$t0), floori($cdb2785cf68729fc$var$t1);
            return Math.floor(count($cdb2785cf68729fc$var$t0, $cdb2785cf68729fc$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("884Bs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $5eb2a429ff3dc59f$var$_interval = $5eb2a429ff3dc59f$var$_interopRequireDefault((parcelRequire("hEV6H")));
function $5eb2a429ff3dc59f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5eb2a429ff3dc59f$var$millisecond = (0, $5eb2a429ff3dc59f$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$5eb2a429ff3dc59f$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $5eb2a429ff3dc59f$var$millisecond;
    return (0, $5eb2a429ff3dc59f$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $5eb2a429ff3dc59f$var$_default = $5eb2a429ff3dc59f$var$millisecond;
module.exports.default = $5eb2a429ff3dc59f$var$_default;
var $5eb2a429ff3dc59f$var$milliseconds = $5eb2a429ff3dc59f$var$millisecond.range;
module.exports.milliseconds = $5eb2a429ff3dc59f$var$milliseconds;

});

parcelRegister("dBGsr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $9e7faa4887a9bdcd$var$_interval = $9e7faa4887a9bdcd$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $9e7faa4887a9bdcd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9e7faa4887a9bdcd$var$second = (0, $9e7faa4887a9bdcd$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $8TTgt.durationSecond);
}, function(start, end) {
    return (end - start) / $8TTgt.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $9e7faa4887a9bdcd$var$_default = $9e7faa4887a9bdcd$var$second;
module.exports.default = $9e7faa4887a9bdcd$var$_default;
var $9e7faa4887a9bdcd$var$seconds = $9e7faa4887a9bdcd$var$second.range;
module.exports.seconds = $9e7faa4887a9bdcd$var$seconds;

});
parcelRegister("8TTgt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $67ae543a99105a8a$var$durationSecond = 1000;
module.exports.durationSecond = $67ae543a99105a8a$var$durationSecond;
const $67ae543a99105a8a$var$durationMinute = $67ae543a99105a8a$var$durationSecond * 60;
module.exports.durationMinute = $67ae543a99105a8a$var$durationMinute;
const $67ae543a99105a8a$var$durationHour = $67ae543a99105a8a$var$durationMinute * 60;
module.exports.durationHour = $67ae543a99105a8a$var$durationHour;
const $67ae543a99105a8a$var$durationDay = $67ae543a99105a8a$var$durationHour * 24;
module.exports.durationDay = $67ae543a99105a8a$var$durationDay;
const $67ae543a99105a8a$var$durationWeek = $67ae543a99105a8a$var$durationDay * 7;
module.exports.durationWeek = $67ae543a99105a8a$var$durationWeek;
const $67ae543a99105a8a$var$durationMonth = $67ae543a99105a8a$var$durationDay * 30;
module.exports.durationMonth = $67ae543a99105a8a$var$durationMonth;
const $67ae543a99105a8a$var$durationYear = $67ae543a99105a8a$var$durationDay * 365;
module.exports.durationYear = $67ae543a99105a8a$var$durationYear;

});


parcelRegister("fy5AE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $b51e5e0eec202d97$var$_interval = $b51e5e0eec202d97$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $b51e5e0eec202d97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b51e5e0eec202d97$var$minute = (0, $b51e5e0eec202d97$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $8TTgt.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $8TTgt.durationMinute);
}, function(start, end) {
    return (end - start) / $8TTgt.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $b51e5e0eec202d97$var$_default = $b51e5e0eec202d97$var$minute;
module.exports.default = $b51e5e0eec202d97$var$_default;
var $b51e5e0eec202d97$var$minutes = $b51e5e0eec202d97$var$minute.range;
module.exports.minutes = $b51e5e0eec202d97$var$minutes;

});

parcelRegister("fDSMI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $b634fea64cba3014$var$_interval = $b634fea64cba3014$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $b634fea64cba3014$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b634fea64cba3014$var$hour = (0, $b634fea64cba3014$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $8TTgt.durationSecond - date.getMinutes() * $8TTgt.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $8TTgt.durationHour);
}, function(start, end) {
    return (end - start) / $8TTgt.durationHour;
}, function(date) {
    return date.getHours();
});
var $b634fea64cba3014$var$_default = $b634fea64cba3014$var$hour;
module.exports.default = $b634fea64cba3014$var$_default;
var $b634fea64cba3014$var$hours = $b634fea64cba3014$var$hour.range;
module.exports.hours = $b634fea64cba3014$var$hours;

});

parcelRegister("gnQLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $bed7b8e16a035eec$var$_interval = $bed7b8e16a035eec$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $bed7b8e16a035eec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bed7b8e16a035eec$var$day = (0, $bed7b8e16a035eec$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $8TTgt.durationMinute) / $8TTgt.durationDay, (date)=>date.getDate() - 1);
var $bed7b8e16a035eec$var$_default = $bed7b8e16a035eec$var$day;
module.exports.default = $bed7b8e16a035eec$var$_default;
var $bed7b8e16a035eec$var$days = $bed7b8e16a035eec$var$day.range;
module.exports.days = $bed7b8e16a035eec$var$days;

});

parcelRegister("8mRu2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $6179dd7d475de0d2$var$_interval = $6179dd7d475de0d2$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $6179dd7d475de0d2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6179dd7d475de0d2$var$weekday(i) {
    return (0, $6179dd7d475de0d2$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $8TTgt.durationMinute) / $8TTgt.durationWeek;
    });
}
var $6179dd7d475de0d2$var$sunday = $6179dd7d475de0d2$var$weekday(0);
module.exports.sunday = $6179dd7d475de0d2$var$sunday;
var $6179dd7d475de0d2$var$monday = $6179dd7d475de0d2$var$weekday(1);
module.exports.monday = $6179dd7d475de0d2$var$monday;
var $6179dd7d475de0d2$var$tuesday = $6179dd7d475de0d2$var$weekday(2);
module.exports.tuesday = $6179dd7d475de0d2$var$tuesday;
var $6179dd7d475de0d2$var$wednesday = $6179dd7d475de0d2$var$weekday(3);
module.exports.wednesday = $6179dd7d475de0d2$var$wednesday;
var $6179dd7d475de0d2$var$thursday = $6179dd7d475de0d2$var$weekday(4);
module.exports.thursday = $6179dd7d475de0d2$var$thursday;
var $6179dd7d475de0d2$var$friday = $6179dd7d475de0d2$var$weekday(5);
module.exports.friday = $6179dd7d475de0d2$var$friday;
var $6179dd7d475de0d2$var$saturday = $6179dd7d475de0d2$var$weekday(6);
module.exports.saturday = $6179dd7d475de0d2$var$saturday;
var $6179dd7d475de0d2$var$sundays = $6179dd7d475de0d2$var$sunday.range;
module.exports.sundays = $6179dd7d475de0d2$var$sundays;
var $6179dd7d475de0d2$var$mondays = $6179dd7d475de0d2$var$monday.range;
module.exports.mondays = $6179dd7d475de0d2$var$mondays;
var $6179dd7d475de0d2$var$tuesdays = $6179dd7d475de0d2$var$tuesday.range;
module.exports.tuesdays = $6179dd7d475de0d2$var$tuesdays;
var $6179dd7d475de0d2$var$wednesdays = $6179dd7d475de0d2$var$wednesday.range;
module.exports.wednesdays = $6179dd7d475de0d2$var$wednesdays;
var $6179dd7d475de0d2$var$thursdays = $6179dd7d475de0d2$var$thursday.range;
module.exports.thursdays = $6179dd7d475de0d2$var$thursdays;
var $6179dd7d475de0d2$var$fridays = $6179dd7d475de0d2$var$friday.range;
module.exports.fridays = $6179dd7d475de0d2$var$fridays;
var $6179dd7d475de0d2$var$saturdays = $6179dd7d475de0d2$var$saturday.range;
module.exports.saturdays = $6179dd7d475de0d2$var$saturdays;

});

parcelRegister("l18TB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $f4d09779eff91cb8$var$_interval = $f4d09779eff91cb8$var$_interopRequireDefault((parcelRequire("hEV6H")));
function $f4d09779eff91cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f4d09779eff91cb8$var$month = (0, $f4d09779eff91cb8$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $f4d09779eff91cb8$var$_default = $f4d09779eff91cb8$var$month;
module.exports.default = $f4d09779eff91cb8$var$_default;
var $f4d09779eff91cb8$var$months = $f4d09779eff91cb8$var$month.range;
module.exports.months = $f4d09779eff91cb8$var$months;

});

parcelRegister("iQGef", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $db8dd7128cf98701$var$_interval = $db8dd7128cf98701$var$_interopRequireDefault((parcelRequire("hEV6H")));
function $db8dd7128cf98701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $db8dd7128cf98701$var$year = (0, $db8dd7128cf98701$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$db8dd7128cf98701$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $db8dd7128cf98701$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $db8dd7128cf98701$var$_default = $db8dd7128cf98701$var$year;
module.exports.default = $db8dd7128cf98701$var$_default;
var $db8dd7128cf98701$var$years = $db8dd7128cf98701$var$year.range;
module.exports.years = $db8dd7128cf98701$var$years;

});

parcelRegister("8BZ33", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $64512259aa420bfd$var$_interval = $64512259aa420bfd$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $64512259aa420bfd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $64512259aa420bfd$var$utcMinute = (0, $64512259aa420bfd$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $8TTgt.durationMinute);
}, function(start, end) {
    return (end - start) / $8TTgt.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $64512259aa420bfd$var$_default = $64512259aa420bfd$var$utcMinute;
module.exports.default = $64512259aa420bfd$var$_default;
var $64512259aa420bfd$var$utcMinutes = $64512259aa420bfd$var$utcMinute.range;
module.exports.utcMinutes = $64512259aa420bfd$var$utcMinutes;

});

parcelRegister("jSs2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $e788d0171172c73b$var$_interval = $e788d0171172c73b$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $e788d0171172c73b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e788d0171172c73b$var$utcHour = (0, $e788d0171172c73b$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $8TTgt.durationHour);
}, function(start, end) {
    return (end - start) / $8TTgt.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $e788d0171172c73b$var$_default = $e788d0171172c73b$var$utcHour;
module.exports.default = $e788d0171172c73b$var$_default;
var $e788d0171172c73b$var$utcHours = $e788d0171172c73b$var$utcHour.range;
module.exports.utcHours = $e788d0171172c73b$var$utcHours;

});

parcelRegister("aRiOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $7e7d725f99b7590f$var$_interval = $7e7d725f99b7590f$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $7e7d725f99b7590f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7e7d725f99b7590f$var$utcDay = (0, $7e7d725f99b7590f$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $8TTgt.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $7e7d725f99b7590f$var$_default = $7e7d725f99b7590f$var$utcDay;
module.exports.default = $7e7d725f99b7590f$var$_default;
var $7e7d725f99b7590f$var$utcDays = $7e7d725f99b7590f$var$utcDay.range;
module.exports.utcDays = $7e7d725f99b7590f$var$utcDays;

});

parcelRegister("9LVrw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $71d50fcaf9e8f167$var$_interval = $71d50fcaf9e8f167$var$_interopRequireDefault((parcelRequire("hEV6H")));

var $8TTgt = parcelRequire("8TTgt");
function $71d50fcaf9e8f167$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $71d50fcaf9e8f167$var$utcWeekday(i) {
    return (0, $71d50fcaf9e8f167$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $8TTgt.durationWeek;
    });
}
var $71d50fcaf9e8f167$var$utcSunday = $71d50fcaf9e8f167$var$utcWeekday(0);
module.exports.utcSunday = $71d50fcaf9e8f167$var$utcSunday;
var $71d50fcaf9e8f167$var$utcMonday = $71d50fcaf9e8f167$var$utcWeekday(1);
module.exports.utcMonday = $71d50fcaf9e8f167$var$utcMonday;
var $71d50fcaf9e8f167$var$utcTuesday = $71d50fcaf9e8f167$var$utcWeekday(2);
module.exports.utcTuesday = $71d50fcaf9e8f167$var$utcTuesday;
var $71d50fcaf9e8f167$var$utcWednesday = $71d50fcaf9e8f167$var$utcWeekday(3);
module.exports.utcWednesday = $71d50fcaf9e8f167$var$utcWednesday;
var $71d50fcaf9e8f167$var$utcThursday = $71d50fcaf9e8f167$var$utcWeekday(4);
module.exports.utcThursday = $71d50fcaf9e8f167$var$utcThursday;
var $71d50fcaf9e8f167$var$utcFriday = $71d50fcaf9e8f167$var$utcWeekday(5);
module.exports.utcFriday = $71d50fcaf9e8f167$var$utcFriday;
var $71d50fcaf9e8f167$var$utcSaturday = $71d50fcaf9e8f167$var$utcWeekday(6);
module.exports.utcSaturday = $71d50fcaf9e8f167$var$utcSaturday;
var $71d50fcaf9e8f167$var$utcSundays = $71d50fcaf9e8f167$var$utcSunday.range;
module.exports.utcSundays = $71d50fcaf9e8f167$var$utcSundays;
var $71d50fcaf9e8f167$var$utcMondays = $71d50fcaf9e8f167$var$utcMonday.range;
module.exports.utcMondays = $71d50fcaf9e8f167$var$utcMondays;
var $71d50fcaf9e8f167$var$utcTuesdays = $71d50fcaf9e8f167$var$utcTuesday.range;
module.exports.utcTuesdays = $71d50fcaf9e8f167$var$utcTuesdays;
var $71d50fcaf9e8f167$var$utcWednesdays = $71d50fcaf9e8f167$var$utcWednesday.range;
module.exports.utcWednesdays = $71d50fcaf9e8f167$var$utcWednesdays;
var $71d50fcaf9e8f167$var$utcThursdays = $71d50fcaf9e8f167$var$utcThursday.range;
module.exports.utcThursdays = $71d50fcaf9e8f167$var$utcThursdays;
var $71d50fcaf9e8f167$var$utcFridays = $71d50fcaf9e8f167$var$utcFriday.range;
module.exports.utcFridays = $71d50fcaf9e8f167$var$utcFridays;
var $71d50fcaf9e8f167$var$utcSaturdays = $71d50fcaf9e8f167$var$utcSaturday.range;
module.exports.utcSaturdays = $71d50fcaf9e8f167$var$utcSaturdays;

});

parcelRegister("4IyOg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $36f645f13855b07f$var$_interval = $36f645f13855b07f$var$_interopRequireDefault((parcelRequire("hEV6H")));
function $36f645f13855b07f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $36f645f13855b07f$var$utcMonth = (0, $36f645f13855b07f$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $36f645f13855b07f$var$_default = $36f645f13855b07f$var$utcMonth;
module.exports.default = $36f645f13855b07f$var$_default;
var $36f645f13855b07f$var$utcMonths = $36f645f13855b07f$var$utcMonth.range;
module.exports.utcMonths = $36f645f13855b07f$var$utcMonths;

});

parcelRegister("drXCr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $9cac0b11853014c1$var$_interval = $9cac0b11853014c1$var$_interopRequireDefault((parcelRequire("hEV6H")));
function $9cac0b11853014c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9cac0b11853014c1$var$utcYear = (0, $9cac0b11853014c1$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$9cac0b11853014c1$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $9cac0b11853014c1$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $9cac0b11853014c1$var$_default = $9cac0b11853014c1$var$utcYear;
module.exports.default = $9cac0b11853014c1$var$_default;
var $9cac0b11853014c1$var$utcYears = $9cac0b11853014c1$var$utcYear.range;
module.exports.utcYears = $9cac0b11853014c1$var$utcYears;

});

parcelRegister("hi8aN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $jaQ55 = parcelRequire("jaQ55");

var $8TTgt = parcelRequire("8TTgt");

var $c96a7521c5a77b94$var$_millisecond = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("884Bs")));

var $c96a7521c5a77b94$var$_second = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("dBGsr")));

var $c96a7521c5a77b94$var$_minute = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("fy5AE")));

var $c96a7521c5a77b94$var$_hour = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("fDSMI")));

var $c96a7521c5a77b94$var$_day = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("gnQLl")));

var $8mRu2 = parcelRequire("8mRu2");

var $c96a7521c5a77b94$var$_month = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("l18TB")));

var $c96a7521c5a77b94$var$_year = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("iQGef")));

var $c96a7521c5a77b94$var$_utcMinute = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("8BZ33")));

var $c96a7521c5a77b94$var$_utcHour = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("jSs2G")));

var $c96a7521c5a77b94$var$_utcDay = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("aRiOq")));

var $9LVrw = parcelRequire("9LVrw");

var $c96a7521c5a77b94$var$_utcMonth = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("4IyOg")));

var $c96a7521c5a77b94$var$_utcYear = $c96a7521c5a77b94$var$_interopRequireDefault((parcelRequire("drXCr")));
function $c96a7521c5a77b94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c96a7521c5a77b94$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $c96a7521c5a77b94$var$_second.default,
            1,
            $8TTgt.durationSecond
        ],
        [
            $c96a7521c5a77b94$var$_second.default,
            5,
            5 * $8TTgt.durationSecond
        ],
        [
            $c96a7521c5a77b94$var$_second.default,
            15,
            15 * $8TTgt.durationSecond
        ],
        [
            $c96a7521c5a77b94$var$_second.default,
            30,
            30 * $8TTgt.durationSecond
        ],
        [
            minute,
            1,
            $8TTgt.durationMinute
        ],
        [
            minute,
            5,
            5 * $8TTgt.durationMinute
        ],
        [
            minute,
            15,
            15 * $8TTgt.durationMinute
        ],
        [
            minute,
            30,
            30 * $8TTgt.durationMinute
        ],
        [
            hour,
            1,
            $8TTgt.durationHour
        ],
        [
            hour,
            3,
            3 * $8TTgt.durationHour
        ],
        [
            hour,
            6,
            6 * $8TTgt.durationHour
        ],
        [
            hour,
            12,
            12 * $8TTgt.durationHour
        ],
        [
            day,
            1,
            $8TTgt.durationDay
        ],
        [
            day,
            2,
            2 * $8TTgt.durationDay
        ],
        [
            week,
            1,
            $8TTgt.durationWeek
        ],
        [
            month,
            1,
            $8TTgt.durationMonth
        ],
        [
            month,
            3,
            3 * $8TTgt.durationMonth
        ],
        [
            year,
            1,
            $8TTgt.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $jaQ55.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $jaQ55.tickStep)(start / $8TTgt.durationYear, stop / $8TTgt.durationYear, count));
        if (i === 0) return $c96a7521c5a77b94$var$_millisecond.default.every(Math.max((0, $jaQ55.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$c96a7521c5a77b94$var$utcTicks, $c96a7521c5a77b94$var$utcTickInterval] = $c96a7521c5a77b94$var$ticker($c96a7521c5a77b94$var$_utcYear.default, $c96a7521c5a77b94$var$_utcMonth.default, $9LVrw.utcSunday, $c96a7521c5a77b94$var$_utcDay.default, $c96a7521c5a77b94$var$_utcHour.default, $c96a7521c5a77b94$var$_utcMinute.default);
module.exports.utcTickInterval = $c96a7521c5a77b94$var$utcTickInterval;
module.exports.utcTicks = $c96a7521c5a77b94$var$utcTicks;
const [$c96a7521c5a77b94$var$timeTicks, $c96a7521c5a77b94$var$timeTickInterval] = $c96a7521c5a77b94$var$ticker($c96a7521c5a77b94$var$_year.default, $c96a7521c5a77b94$var$_month.default, $8mRu2.sunday, $c96a7521c5a77b94$var$_day.default, $c96a7521c5a77b94$var$_hour.default, $c96a7521c5a77b94$var$_minute.default);
module.exports.timeTickInterval = $c96a7521c5a77b94$var$timeTickInterval;
module.exports.timeTicks = $c96a7521c5a77b94$var$timeTicks;

});


parcelRegister("gomnW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $bef04078eb5450c2$var$_defaultLocale.utcParse;
    }
});

var $bef04078eb5450c2$var$_defaultLocale = $bef04078eb5450c2$var$_interopRequireWildcard((parcelRequire("jNYJ2")));

var $bef04078eb5450c2$var$_locale = $bef04078eb5450c2$var$_interopRequireDefault((parcelRequire("2CWfb")));

var $bef04078eb5450c2$var$_isoFormat = $bef04078eb5450c2$var$_interopRequireDefault((parcelRequire("kcDwA")));

var $bef04078eb5450c2$var$_isoParse = $bef04078eb5450c2$var$_interopRequireDefault((parcelRequire("jJBCU")));
function $bef04078eb5450c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bef04078eb5450c2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bef04078eb5450c2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bef04078eb5450c2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bef04078eb5450c2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jNYJ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6b1b2b74da70be7$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $e6b1b2b74da70be7$var$_locale = $e6b1b2b74da70be7$var$_interopRequireDefault((parcelRequire("2CWfb")));
function $e6b1b2b74da70be7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e6b1b2b74da70be7$var$locale;
var $e6b1b2b74da70be7$var$timeFormat;
module.exports.timeFormat = $e6b1b2b74da70be7$var$timeFormat;
var $e6b1b2b74da70be7$var$timeParse;
module.exports.timeParse = $e6b1b2b74da70be7$var$timeParse;
var $e6b1b2b74da70be7$var$utcFormat;
module.exports.utcFormat = $e6b1b2b74da70be7$var$utcFormat;
var $e6b1b2b74da70be7$var$utcParse;
module.exports.utcParse = $e6b1b2b74da70be7$var$utcParse;
$e6b1b2b74da70be7$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $e6b1b2b74da70be7$var$defaultLocale(definition) {
    $e6b1b2b74da70be7$var$locale = (0, $e6b1b2b74da70be7$var$_locale.default)(definition);
    module.exports.timeFormat = $e6b1b2b74da70be7$var$timeFormat = $e6b1b2b74da70be7$var$locale.format;
    module.exports.timeParse = $e6b1b2b74da70be7$var$timeParse = $e6b1b2b74da70be7$var$locale.parse;
    module.exports.utcFormat = $e6b1b2b74da70be7$var$utcFormat = $e6b1b2b74da70be7$var$locale.utcFormat;
    module.exports.utcParse = $e6b1b2b74da70be7$var$utcParse = $e6b1b2b74da70be7$var$locale.utcParse;
    return $e6b1b2b74da70be7$var$locale;
}

});
parcelRegister("2CWfb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e9c4f686f3546c0$var$formatLocale;

var $j8QCl = parcelRequire("j8QCl");
function $1e9c4f686f3546c0$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $1e9c4f686f3546c0$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $1e9c4f686f3546c0$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $1e9c4f686f3546c0$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $1e9c4f686f3546c0$var$formatRe(locale_periods), periodLookup = $1e9c4f686f3546c0$var$formatLookup(locale_periods), weekdayRe = $1e9c4f686f3546c0$var$formatRe(locale_weekdays), weekdayLookup = $1e9c4f686f3546c0$var$formatLookup(locale_weekdays), shortWeekdayRe = $1e9c4f686f3546c0$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $1e9c4f686f3546c0$var$formatLookup(locale_shortWeekdays), monthRe = $1e9c4f686f3546c0$var$formatRe(locale_months), monthLookup = $1e9c4f686f3546c0$var$formatLookup(locale_months), shortMonthRe = $1e9c4f686f3546c0$var$formatRe(locale_shortMonths), shortMonthLookup = $1e9c4f686f3546c0$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $1e9c4f686f3546c0$var$formatDayOfMonth,
        "e": $1e9c4f686f3546c0$var$formatDayOfMonth,
        "f": $1e9c4f686f3546c0$var$formatMicroseconds,
        "g": $1e9c4f686f3546c0$var$formatYearISO,
        "G": $1e9c4f686f3546c0$var$formatFullYearISO,
        "H": $1e9c4f686f3546c0$var$formatHour24,
        "I": $1e9c4f686f3546c0$var$formatHour12,
        "j": $1e9c4f686f3546c0$var$formatDayOfYear,
        "L": $1e9c4f686f3546c0$var$formatMilliseconds,
        "m": $1e9c4f686f3546c0$var$formatMonthNumber,
        "M": $1e9c4f686f3546c0$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $1e9c4f686f3546c0$var$formatUnixTimestamp,
        "s": $1e9c4f686f3546c0$var$formatUnixTimestampSeconds,
        "S": $1e9c4f686f3546c0$var$formatSeconds,
        "u": $1e9c4f686f3546c0$var$formatWeekdayNumberMonday,
        "U": $1e9c4f686f3546c0$var$formatWeekNumberSunday,
        "V": $1e9c4f686f3546c0$var$formatWeekNumberISO,
        "w": $1e9c4f686f3546c0$var$formatWeekdayNumberSunday,
        "W": $1e9c4f686f3546c0$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1e9c4f686f3546c0$var$formatYear,
        "Y": $1e9c4f686f3546c0$var$formatFullYear,
        "Z": $1e9c4f686f3546c0$var$formatZone,
        "%": $1e9c4f686f3546c0$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $1e9c4f686f3546c0$var$formatUTCDayOfMonth,
        "e": $1e9c4f686f3546c0$var$formatUTCDayOfMonth,
        "f": $1e9c4f686f3546c0$var$formatUTCMicroseconds,
        "g": $1e9c4f686f3546c0$var$formatUTCYearISO,
        "G": $1e9c4f686f3546c0$var$formatUTCFullYearISO,
        "H": $1e9c4f686f3546c0$var$formatUTCHour24,
        "I": $1e9c4f686f3546c0$var$formatUTCHour12,
        "j": $1e9c4f686f3546c0$var$formatUTCDayOfYear,
        "L": $1e9c4f686f3546c0$var$formatUTCMilliseconds,
        "m": $1e9c4f686f3546c0$var$formatUTCMonthNumber,
        "M": $1e9c4f686f3546c0$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $1e9c4f686f3546c0$var$formatUnixTimestamp,
        "s": $1e9c4f686f3546c0$var$formatUnixTimestampSeconds,
        "S": $1e9c4f686f3546c0$var$formatUTCSeconds,
        "u": $1e9c4f686f3546c0$var$formatUTCWeekdayNumberMonday,
        "U": $1e9c4f686f3546c0$var$formatUTCWeekNumberSunday,
        "V": $1e9c4f686f3546c0$var$formatUTCWeekNumberISO,
        "w": $1e9c4f686f3546c0$var$formatUTCWeekdayNumberSunday,
        "W": $1e9c4f686f3546c0$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $1e9c4f686f3546c0$var$formatUTCYear,
        "Y": $1e9c4f686f3546c0$var$formatUTCFullYear,
        "Z": $1e9c4f686f3546c0$var$formatUTCZone,
        "%": $1e9c4f686f3546c0$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $1e9c4f686f3546c0$var$parseDayOfMonth,
        "e": $1e9c4f686f3546c0$var$parseDayOfMonth,
        "f": $1e9c4f686f3546c0$var$parseMicroseconds,
        "g": $1e9c4f686f3546c0$var$parseYear,
        "G": $1e9c4f686f3546c0$var$parseFullYear,
        "H": $1e9c4f686f3546c0$var$parseHour24,
        "I": $1e9c4f686f3546c0$var$parseHour24,
        "j": $1e9c4f686f3546c0$var$parseDayOfYear,
        "L": $1e9c4f686f3546c0$var$parseMilliseconds,
        "m": $1e9c4f686f3546c0$var$parseMonthNumber,
        "M": $1e9c4f686f3546c0$var$parseMinutes,
        "p": parsePeriod,
        "q": $1e9c4f686f3546c0$var$parseQuarter,
        "Q": $1e9c4f686f3546c0$var$parseUnixTimestamp,
        "s": $1e9c4f686f3546c0$var$parseUnixTimestampSeconds,
        "S": $1e9c4f686f3546c0$var$parseSeconds,
        "u": $1e9c4f686f3546c0$var$parseWeekdayNumberMonday,
        "U": $1e9c4f686f3546c0$var$parseWeekNumberSunday,
        "V": $1e9c4f686f3546c0$var$parseWeekNumberISO,
        "w": $1e9c4f686f3546c0$var$parseWeekdayNumberSunday,
        "W": $1e9c4f686f3546c0$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $1e9c4f686f3546c0$var$parseYear,
        "Y": $1e9c4f686f3546c0$var$parseFullYear,
        "Z": $1e9c4f686f3546c0$var$parseZone,
        "%": $1e9c4f686f3546c0$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $1e9c4f686f3546c0$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $1e9c4f686f3546c0$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $1e9c4f686f3546c0$var$utcDate($1e9c4f686f3546c0$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $j8QCl.utcMonday.ceil(week) : (0, $j8QCl.utcMonday)(week);
                    week = $j8QCl.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $1e9c4f686f3546c0$var$localDate($1e9c4f686f3546c0$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $j8QCl.timeMonday.ceil(week) : (0, $j8QCl.timeMonday)(week);
                    week = $j8QCl.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $1e9c4f686f3546c0$var$utcDate($1e9c4f686f3546c0$var$newDate(d.y, 0, 1)).getUTCDay() : $1e9c4f686f3546c0$var$localDate($1e9c4f686f3546c0$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $1e9c4f686f3546c0$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $1e9c4f686f3546c0$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $1e9c4f686f3546c0$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $1e9c4f686f3546c0$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $1e9c4f686f3546c0$var$numberRe = /^\s*\d+/, // note: ignores next directive
$1e9c4f686f3546c0$var$percentRe = /^%/, $1e9c4f686f3546c0$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $1e9c4f686f3546c0$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $1e9c4f686f3546c0$var$requote(s) {
    return s.replace($1e9c4f686f3546c0$var$requoteRe, "\\$&");
}
function $1e9c4f686f3546c0$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($1e9c4f686f3546c0$var$requote).join("|") + ")", "i");
}
function $1e9c4f686f3546c0$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $1e9c4f686f3546c0$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseWeekNumberSunday(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseWeekNumberISO(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseWeekNumberMonday(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseFullYear(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseYear(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseQuarter(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseMonthNumber(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseDayOfMonth(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseDayOfYear(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseHour24(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseMinutes(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseSeconds(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseMilliseconds(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseMicroseconds(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseLiteralPercent(d, string, i) {
    var n = $1e9c4f686f3546c0$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $1e9c4f686f3546c0$var$parseUnixTimestamp(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $1e9c4f686f3546c0$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $1e9c4f686f3546c0$var$formatDayOfMonth(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getDate(), p, 2);
}
function $1e9c4f686f3546c0$var$formatHour24(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getHours(), p, 2);
}
function $1e9c4f686f3546c0$var$formatHour12(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $1e9c4f686f3546c0$var$formatDayOfYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(1 + $j8QCl.timeDay.count((0, $j8QCl.timeYear)(d), d), p, 3);
}
function $1e9c4f686f3546c0$var$formatMilliseconds(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getMilliseconds(), p, 3);
}
function $1e9c4f686f3546c0$var$formatMicroseconds(d, p) {
    return $1e9c4f686f3546c0$var$formatMilliseconds(d, p) + "000";
}
function $1e9c4f686f3546c0$var$formatMonthNumber(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getMonth() + 1, p, 2);
}
function $1e9c4f686f3546c0$var$formatMinutes(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getMinutes(), p, 2);
}
function $1e9c4f686f3546c0$var$formatSeconds(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getSeconds(), p, 2);
}
function $1e9c4f686f3546c0$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $1e9c4f686f3546c0$var$formatWeekNumberSunday(d, p) {
    return $1e9c4f686f3546c0$var$pad($j8QCl.timeSunday.count((0, $j8QCl.timeYear)(d) - 1, d), p, 2);
}
function $1e9c4f686f3546c0$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $j8QCl.timeThursday)(d) : $j8QCl.timeThursday.ceil(d);
}
function $1e9c4f686f3546c0$var$formatWeekNumberISO(d, p) {
    d = $1e9c4f686f3546c0$var$dISO(d);
    return $1e9c4f686f3546c0$var$pad($j8QCl.timeThursday.count((0, $j8QCl.timeYear)(d), d) + ((0, $j8QCl.timeYear)(d).getDay() === 4), p, 2);
}
function $1e9c4f686f3546c0$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $1e9c4f686f3546c0$var$formatWeekNumberMonday(d, p) {
    return $1e9c4f686f3546c0$var$pad($j8QCl.timeMonday.count((0, $j8QCl.timeYear)(d) - 1, d), p, 2);
}
function $1e9c4f686f3546c0$var$formatYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getFullYear() % 100, p, 2);
}
function $1e9c4f686f3546c0$var$formatYearISO(d, p) {
    d = $1e9c4f686f3546c0$var$dISO(d);
    return $1e9c4f686f3546c0$var$pad(d.getFullYear() % 100, p, 2);
}
function $1e9c4f686f3546c0$var$formatFullYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1e9c4f686f3546c0$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $j8QCl.timeThursday)(d) : $j8QCl.timeThursday.ceil(d);
    return $1e9c4f686f3546c0$var$pad(d.getFullYear() % 10000, p, 4);
}
function $1e9c4f686f3546c0$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $1e9c4f686f3546c0$var$pad(z / 60 | 0, "0", 2) + $1e9c4f686f3546c0$var$pad(z % 60, "0", 2);
}
function $1e9c4f686f3546c0$var$formatUTCDayOfMonth(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCDate(), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCHour24(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCHours(), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCHour12(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCDayOfYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(1 + $j8QCl.utcDay.count((0, $j8QCl.utcYear)(d), d), p, 3);
}
function $1e9c4f686f3546c0$var$formatUTCMilliseconds(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $1e9c4f686f3546c0$var$formatUTCMicroseconds(d, p) {
    return $1e9c4f686f3546c0$var$formatUTCMilliseconds(d, p) + "000";
}
function $1e9c4f686f3546c0$var$formatUTCMonthNumber(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCMinutes(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCMinutes(), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCSeconds(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCSeconds(), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $1e9c4f686f3546c0$var$formatUTCWeekNumberSunday(d, p) {
    return $1e9c4f686f3546c0$var$pad($j8QCl.utcSunday.count((0, $j8QCl.utcYear)(d) - 1, d), p, 2);
}
function $1e9c4f686f3546c0$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $j8QCl.utcThursday)(d) : $j8QCl.utcThursday.ceil(d);
}
function $1e9c4f686f3546c0$var$formatUTCWeekNumberISO(d, p) {
    d = $1e9c4f686f3546c0$var$UTCdISO(d);
    return $1e9c4f686f3546c0$var$pad($j8QCl.utcThursday.count((0, $j8QCl.utcYear)(d), d) + ((0, $j8QCl.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $1e9c4f686f3546c0$var$formatUTCWeekNumberMonday(d, p) {
    return $1e9c4f686f3546c0$var$pad($j8QCl.utcMonday.count((0, $j8QCl.utcYear)(d) - 1, d), p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCYearISO(d, p) {
    d = $1e9c4f686f3546c0$var$UTCdISO(d);
    return $1e9c4f686f3546c0$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $1e9c4f686f3546c0$var$formatUTCFullYear(d, p) {
    return $1e9c4f686f3546c0$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1e9c4f686f3546c0$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $j8QCl.utcThursday)(d) : $j8QCl.utcThursday.ceil(d);
    return $1e9c4f686f3546c0$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $1e9c4f686f3546c0$var$formatUTCZone() {
    return "+0000";
}
function $1e9c4f686f3546c0$var$formatLiteralPercent() {
    return "%";
}
function $1e9c4f686f3546c0$var$formatUnixTimestamp(d) {
    return +d;
}
function $1e9c4f686f3546c0$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("kcDwA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $jNYJ2 = parcelRequire("jNYJ2");
var $eb53966b3f69583c$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $eb53966b3f69583c$var$isoSpecifier;
function $eb53966b3f69583c$var$formatIsoNative(date) {
    return date.toISOString();
}
var $eb53966b3f69583c$var$formatIso = Date.prototype.toISOString ? $eb53966b3f69583c$var$formatIsoNative : (0, $jNYJ2.utcFormat)($eb53966b3f69583c$var$isoSpecifier);
var $eb53966b3f69583c$var$_default = $eb53966b3f69583c$var$formatIso;
module.exports.default = $eb53966b3f69583c$var$_default;

});

parcelRegister("jJBCU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $kcDwA = parcelRequire("kcDwA");

var $jNYJ2 = parcelRequire("jNYJ2");
function $e5df68295bbd88e2$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $e5df68295bbd88e2$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $e5df68295bbd88e2$var$parseIsoNative : (0, $jNYJ2.utcParse)($kcDwA.isoSpecifier);
var $e5df68295bbd88e2$var$_default = $e5df68295bbd88e2$var$parseIso;
module.exports.default = $e5df68295bbd88e2$var$_default;

});



parcelRegister("3BvP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $29fd836866faec6d$var$utcTime;

var $j8QCl = parcelRequire("j8QCl");

var $gomnW = parcelRequire("gomnW");

var $7hETy = parcelRequire("7hETy");

var $fb4yo = parcelRequire("fb4yo");
function $29fd836866faec6d$var$utcTime() {
    return $fb4yo.initRange.apply((0, $7hETy.calendar)($j8QCl.utcTicks, $j8QCl.utcTickInterval, $j8QCl.utcYear, $j8QCl.utcMonth, $j8QCl.utcWeek, $j8QCl.utcDay, $j8QCl.utcHour, $j8QCl.utcMinute, $j8QCl.utcSecond, $gomnW.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("39AYR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $24bee5f5f28acc3e$var$copy;
module.exports.default = $24bee5f5f28acc3e$var$sequential;
module.exports.sequentialLog = $24bee5f5f28acc3e$var$sequentialLog;
module.exports.sequentialPow = $24bee5f5f28acc3e$var$sequentialPow;
module.exports.sequentialSqrt = $24bee5f5f28acc3e$var$sequentialSqrt;
module.exports.sequentialSymlog = $24bee5f5f28acc3e$var$sequentialSymlog;

var $fZ8cD = parcelRequire("fZ8cD");

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");

var $537RU = parcelRequire("537RU");

var $5rmxS = parcelRequire("5rmxS");

var $eH6W2 = parcelRequire("eH6W2");

var $fGBFH = parcelRequire("fGBFH");
function $24bee5f5f28acc3e$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $iqqI4.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($fZ8cD.interpolate);
    scale.rangeRound = range($fZ8cD.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $24bee5f5f28acc3e$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $24bee5f5f28acc3e$var$sequential() {
    var scale = (0, $537RU.linearish)($24bee5f5f28acc3e$var$transformer()($iqqI4.identity));
    scale.copy = function() {
        return $24bee5f5f28acc3e$var$copy(scale, $24bee5f5f28acc3e$var$sequential());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $24bee5f5f28acc3e$var$sequentialLog() {
    var scale = (0, $5rmxS.loggish)($24bee5f5f28acc3e$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $24bee5f5f28acc3e$var$copy(scale, $24bee5f5f28acc3e$var$sequentialLog()).base(scale.base());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $24bee5f5f28acc3e$var$sequentialSymlog() {
    var scale = (0, $eH6W2.symlogish)($24bee5f5f28acc3e$var$transformer());
    scale.copy = function() {
        return $24bee5f5f28acc3e$var$copy(scale, $24bee5f5f28acc3e$var$sequentialSymlog()).constant(scale.constant());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $24bee5f5f28acc3e$var$sequentialPow() {
    var scale = (0, $fGBFH.powish)($24bee5f5f28acc3e$var$transformer());
    scale.copy = function() {
        return $24bee5f5f28acc3e$var$copy(scale, $24bee5f5f28acc3e$var$sequentialPow()).exponent(scale.exponent());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $24bee5f5f28acc3e$var$sequentialSqrt() {
    return $24bee5f5f28acc3e$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5EPak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41e8609c5dd79d30$var$sequentialQuantile;

var $jaQ55 = parcelRequire("jaQ55");

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");
function $41e8609c5dd79d30$var$sequentialQuantile() {
    var domain = [], interpolator = $iqqI4.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $jaQ55.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($jaQ55.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $jaQ55.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $41e8609c5dd79d30$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("1enEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e597195192ffef9$var$diverging;
module.exports.divergingLog = $0e597195192ffef9$var$divergingLog;
module.exports.divergingPow = $0e597195192ffef9$var$divergingPow;
module.exports.divergingSqrt = $0e597195192ffef9$var$divergingSqrt;
module.exports.divergingSymlog = $0e597195192ffef9$var$divergingSymlog;

var $fZ8cD = parcelRequire("fZ8cD");

var $iqqI4 = parcelRequire("iqqI4");

var $fb4yo = parcelRequire("fb4yo");

var $537RU = parcelRequire("537RU");

var $5rmxS = parcelRequire("5rmxS");

var $39AYR = parcelRequire("39AYR");

var $eH6W2 = parcelRequire("eH6W2");

var $fGBFH = parcelRequire("fGBFH");
function $0e597195192ffef9$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $iqqI4.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $fZ8cD.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($fZ8cD.interpolate);
    scale.rangeRound = range($fZ8cD.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $0e597195192ffef9$var$diverging() {
    var scale = (0, $537RU.linearish)($0e597195192ffef9$var$transformer()($iqqI4.identity));
    scale.copy = function() {
        return (0, $39AYR.copy)(scale, $0e597195192ffef9$var$diverging());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $0e597195192ffef9$var$divergingLog() {
    var scale = (0, $5rmxS.loggish)($0e597195192ffef9$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $39AYR.copy)(scale, $0e597195192ffef9$var$divergingLog()).base(scale.base());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $0e597195192ffef9$var$divergingSymlog() {
    var scale = (0, $eH6W2.symlogish)($0e597195192ffef9$var$transformer());
    scale.copy = function() {
        return (0, $39AYR.copy)(scale, $0e597195192ffef9$var$divergingSymlog()).constant(scale.constant());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $0e597195192ffef9$var$divergingPow() {
    var scale = (0, $fGBFH.powish)($0e597195192ffef9$var$transformer());
    scale.copy = function() {
        return (0, $39AYR.copy)(scale, $0e597195192ffef9$var$divergingPow()).exponent(scale.exponent());
    };
    return $fb4yo.initInterpolator.apply(scale, arguments);
}
function $0e597195192ffef9$var$divergingSqrt() {
    return $0e597195192ffef9$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("1NVAl", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("fnfU8"));

});
parcelRegister("fnfU8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $6GXvJ.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $6GXvJ.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $lY9dJ.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $lY9dJ.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $UvLP5.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $UvLP5.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $UvLP5.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $UvLP5.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $b31557443687649b$var$_symbol.symbolsStroke;
    }
});

var $b31557443687649b$var$_arc = $b31557443687649b$var$_interopRequireDefault((parcelRequire("2Wkyo")));

var $b31557443687649b$var$_area = $b31557443687649b$var$_interopRequireDefault((parcelRequire("4JvMy")));

var $b31557443687649b$var$_line = $b31557443687649b$var$_interopRequireDefault((parcelRequire("9A7f4")));

var $b31557443687649b$var$_pie = $b31557443687649b$var$_interopRequireDefault((parcelRequire("2H5MK")));

var $b31557443687649b$var$_areaRadial = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8Q1J8")));

var $b31557443687649b$var$_lineRadial = $b31557443687649b$var$_interopRequireDefault((parcelRequire("k3w6r")));

var $b31557443687649b$var$_pointRadial = $b31557443687649b$var$_interopRequireDefault((parcelRequire("15bV0")));

var $UvLP5 = parcelRequire("UvLP5");

var $b31557443687649b$var$_symbol = $b31557443687649b$var$_interopRequireWildcard((parcelRequire("jt289")));

var $b31557443687649b$var$_asterisk = $b31557443687649b$var$_interopRequireDefault((parcelRequire("a1kLk")));

var $b31557443687649b$var$_circle = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8Pifm")));

var $b31557443687649b$var$_cross = $b31557443687649b$var$_interopRequireDefault((parcelRequire("994h0")));

var $b31557443687649b$var$_diamond = $b31557443687649b$var$_interopRequireDefault((parcelRequire("aWMJb")));

var $b31557443687649b$var$_diamond2 = $b31557443687649b$var$_interopRequireDefault((parcelRequire("i5UoN")));

var $b31557443687649b$var$_plus = $b31557443687649b$var$_interopRequireDefault((parcelRequire("e0q9L")));

var $b31557443687649b$var$_square = $b31557443687649b$var$_interopRequireDefault((parcelRequire("XN9hk")));

var $b31557443687649b$var$_square2 = $b31557443687649b$var$_interopRequireDefault((parcelRequire("86b5U")));

var $b31557443687649b$var$_star = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8DCJr")));

var $b31557443687649b$var$_triangle = $b31557443687649b$var$_interopRequireDefault((parcelRequire("kFpHO")));

var $b31557443687649b$var$_triangle2 = $b31557443687649b$var$_interopRequireDefault((parcelRequire("fibnU")));

var $b31557443687649b$var$_wye = $b31557443687649b$var$_interopRequireDefault((parcelRequire("gJ4P0")));

var $b31557443687649b$var$_x = $b31557443687649b$var$_interopRequireDefault((parcelRequire("1cuVN")));

var $b31557443687649b$var$_basisClosed = $b31557443687649b$var$_interopRequireDefault((parcelRequire("hFjyF")));

var $b31557443687649b$var$_basisOpen = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8sKsF")));

var $b31557443687649b$var$_basis = $b31557443687649b$var$_interopRequireDefault((parcelRequire("j97pr")));

var $6GXvJ = parcelRequire("6GXvJ");

var $b31557443687649b$var$_bundle = $b31557443687649b$var$_interopRequireDefault((parcelRequire("iP30e")));

var $b31557443687649b$var$_cardinalClosed = $b31557443687649b$var$_interopRequireDefault((parcelRequire("cuxyd")));

var $b31557443687649b$var$_cardinalOpen = $b31557443687649b$var$_interopRequireDefault((parcelRequire("4YITs")));

var $b31557443687649b$var$_cardinal = $b31557443687649b$var$_interopRequireDefault((parcelRequire("aKtxc")));

var $b31557443687649b$var$_catmullRomClosed = $b31557443687649b$var$_interopRequireDefault((parcelRequire("gy5Eg")));

var $b31557443687649b$var$_catmullRomOpen = $b31557443687649b$var$_interopRequireDefault((parcelRequire("03s2x")));

var $b31557443687649b$var$_catmullRom = $b31557443687649b$var$_interopRequireDefault((parcelRequire("lnOBO")));

var $b31557443687649b$var$_linearClosed = $b31557443687649b$var$_interopRequireDefault((parcelRequire("6EZe0")));

var $b31557443687649b$var$_linear = $b31557443687649b$var$_interopRequireDefault((parcelRequire("asfCj")));

var $lY9dJ = parcelRequire("lY9dJ");

var $b31557443687649b$var$_natural = $b31557443687649b$var$_interopRequireDefault((parcelRequire("d20Gv")));

var $b31557443687649b$var$_step = $b31557443687649b$var$_interopRequireWildcard((parcelRequire("dJj1m")));

var $b31557443687649b$var$_stack = $b31557443687649b$var$_interopRequireDefault((parcelRequire("ho6Px")));

var $b31557443687649b$var$_expand = $b31557443687649b$var$_interopRequireDefault((parcelRequire("gS501")));

var $b31557443687649b$var$_diverging = $b31557443687649b$var$_interopRequireDefault((parcelRequire("ctjKT")));

var $b31557443687649b$var$_none = $b31557443687649b$var$_interopRequireDefault((parcelRequire("cCsiF")));

var $b31557443687649b$var$_silhouette = $b31557443687649b$var$_interopRequireDefault((parcelRequire("ahzGU")));

var $b31557443687649b$var$_wiggle = $b31557443687649b$var$_interopRequireDefault((parcelRequire("kPTxX")));

var $b31557443687649b$var$_appearance = $b31557443687649b$var$_interopRequireDefault((parcelRequire("lrF5M")));

var $b31557443687649b$var$_ascending = $b31557443687649b$var$_interopRequireDefault((parcelRequire("f0F6C")));

var $b31557443687649b$var$_descending = $b31557443687649b$var$_interopRequireDefault((parcelRequire("2TVNI")));

var $b31557443687649b$var$_insideOut = $b31557443687649b$var$_interopRequireDefault((parcelRequire("cDnpf")));

var $b31557443687649b$var$_none2 = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8lQut")));

var $b31557443687649b$var$_reverse = $b31557443687649b$var$_interopRequireDefault((parcelRequire("8TGph")));
function $b31557443687649b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b31557443687649b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b31557443687649b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b31557443687649b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b31557443687649b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("2Wkyo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2240f11bf00d2705$var$_default;

var $90QEI = parcelRequire("90QEI");

var $2240f11bf00d2705$var$_constant = $2240f11bf00d2705$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $4FbUN = parcelRequire("4FbUN");
function $2240f11bf00d2705$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2240f11bf00d2705$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $2240f11bf00d2705$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $2240f11bf00d2705$var$arcStartAngle(d) {
    return d.startAngle;
}
function $2240f11bf00d2705$var$arcEndAngle(d) {
    return d.endAngle;
}
function $2240f11bf00d2705$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $2240f11bf00d2705$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $4FbUN.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $2240f11bf00d2705$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $4FbUN.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $4FbUN.sqrt)((0, $4FbUN.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $2240f11bf00d2705$var$_default() {
    var innerRadius = $2240f11bf00d2705$var$arcInnerRadius, outerRadius = $2240f11bf00d2705$var$arcOuterRadius, cornerRadius = (0, $2240f11bf00d2705$var$_constant.default)(0), padRadius = null, startAngle = $2240f11bf00d2705$var$arcStartAngle, endAngle = $2240f11bf00d2705$var$arcEndAngle, padAngle = $2240f11bf00d2705$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $4FbUN.halfPi, a1 = endAngle.apply(this, arguments) - $4FbUN.halfPi, da = (0, $4FbUN.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $90QEI.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $4FbUN.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $4FbUN.tau - $4FbUN.epsilon) {
            context.moveTo(r1 * (0, $4FbUN.cos)(a0), r1 * (0, $4FbUN.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $4FbUN.epsilon) {
                context.moveTo(r0 * (0, $4FbUN.cos)(a1), r0 * (0, $4FbUN.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $4FbUN.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $4FbUN.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $4FbUN.min)((0, $4FbUN.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $4FbUN.epsilon) {
                var p0 = (0, $4FbUN.asin)(rp / r0 * (0, $4FbUN.sin)(ap)), p1 = (0, $4FbUN.asin)(rp / r1 * (0, $4FbUN.sin)(ap));
                if ((da0 -= p0 * 2) > $4FbUN.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $4FbUN.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $4FbUN.cos)(a01), y01 = r1 * (0, $4FbUN.sin)(a01), x10 = r0 * (0, $4FbUN.cos)(a10), y10 = r0 * (0, $4FbUN.sin)(a10); // Apply rounded corners?
            if (rc > $4FbUN.epsilon) {
                var x11 = r1 * (0, $4FbUN.cos)(a11), y11 = r1 * (0, $4FbUN.sin)(a11), x00 = r0 * (0, $4FbUN.cos)(a00), y00 = r0 * (0, $4FbUN.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $4FbUN.pi && (oc = $2240f11bf00d2705$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $4FbUN.sin)((0, $4FbUN.acos)((ax * bx + ay * by) / ((0, $4FbUN.sqrt)(ax * ax + ay * ay) * (0, $4FbUN.sqrt)(bx * bx + by * by))) / 2), lc = (0, $4FbUN.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $4FbUN.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $4FbUN.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $4FbUN.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $4FbUN.epsilon) {
                t0 = $2240f11bf00d2705$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $2240f11bf00d2705$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $4FbUN.atan2)(t0.y01, t0.x01), (0, $4FbUN.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $4FbUN.atan2)(t0.y01, t0.x01), (0, $4FbUN.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $4FbUN.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $4FbUN.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $4FbUN.atan2)(t1.y11, t1.x11), (0, $4FbUN.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $4FbUN.epsilon) || !(da0 > $4FbUN.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $4FbUN.epsilon) {
                t0 = $2240f11bf00d2705$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $2240f11bf00d2705$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $4FbUN.atan2)(t0.y01, t0.x01), (0, $4FbUN.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $4FbUN.atan2)(t0.y01, t0.x01), (0, $4FbUN.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $4FbUN.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $4FbUN.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $4FbUN.atan2)(t1.y11, t1.x11), (0, $4FbUN.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $4FbUN.pi / 2;
        return [
            (0, $4FbUN.cos)(a) * r,
            (0, $4FbUN.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $2240f11bf00d2705$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("90QEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $68fcf57574c29355$var$_path.default;
    }
});

var $68fcf57574c29355$var$_path = $68fcf57574c29355$var$_interopRequireDefault((parcelRequire("e0JQV")));
function $68fcf57574c29355$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("e0JQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a334a22bd4d84f2b$var$pi = Math.PI, $a334a22bd4d84f2b$var$tau = 2 * $a334a22bd4d84f2b$var$pi, $a334a22bd4d84f2b$var$epsilon = 1e-6, $a334a22bd4d84f2b$var$tauEpsilon = $a334a22bd4d84f2b$var$tau - $a334a22bd4d84f2b$var$epsilon;
function $a334a22bd4d84f2b$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $a334a22bd4d84f2b$var$path() {
    return new $a334a22bd4d84f2b$var$Path();
}
$a334a22bd4d84f2b$var$Path.prototype = $a334a22bd4d84f2b$var$path.prototype = {
    constructor: $a334a22bd4d84f2b$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $a334a22bd4d84f2b$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $a334a22bd4d84f2b$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($a334a22bd4d84f2b$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $a334a22bd4d84f2b$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $a334a22bd4d84f2b$var$epsilon || Math.abs(this._y1 - y0) > $a334a22bd4d84f2b$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $a334a22bd4d84f2b$var$tau + $a334a22bd4d84f2b$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $a334a22bd4d84f2b$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $a334a22bd4d84f2b$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $a334a22bd4d84f2b$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $a334a22bd4d84f2b$var$_default = $a334a22bd4d84f2b$var$path;
module.exports.default = $a334a22bd4d84f2b$var$_default;

});


parcelRegister("9yZGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f672430cbcef115$var$_default;
function $6f672430cbcef115$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("4FbUN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $36543bd751b04f81$var$acos;
module.exports.asin = $36543bd751b04f81$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $36543bd751b04f81$var$abs = Math.abs;
module.exports.abs = $36543bd751b04f81$var$abs;
const $36543bd751b04f81$var$atan2 = Math.atan2;
module.exports.atan2 = $36543bd751b04f81$var$atan2;
const $36543bd751b04f81$var$cos = Math.cos;
module.exports.cos = $36543bd751b04f81$var$cos;
const $36543bd751b04f81$var$max = Math.max;
module.exports.max = $36543bd751b04f81$var$max;
const $36543bd751b04f81$var$min = Math.min;
module.exports.min = $36543bd751b04f81$var$min;
const $36543bd751b04f81$var$sin = Math.sin;
module.exports.sin = $36543bd751b04f81$var$sin;
const $36543bd751b04f81$var$sqrt = Math.sqrt;
module.exports.sqrt = $36543bd751b04f81$var$sqrt;
const $36543bd751b04f81$var$epsilon = 1e-12;
module.exports.epsilon = $36543bd751b04f81$var$epsilon;
const $36543bd751b04f81$var$pi = Math.PI;
module.exports.pi = $36543bd751b04f81$var$pi;
const $36543bd751b04f81$var$halfPi = $36543bd751b04f81$var$pi / 2;
module.exports.halfPi = $36543bd751b04f81$var$halfPi;
const $36543bd751b04f81$var$tau = 2 * $36543bd751b04f81$var$pi;
module.exports.tau = $36543bd751b04f81$var$tau;
function $36543bd751b04f81$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $36543bd751b04f81$var$pi : Math.acos(x);
}
function $36543bd751b04f81$var$asin(x) {
    return x >= 1 ? $36543bd751b04f81$var$halfPi : x <= -1 ? -$36543bd751b04f81$var$halfPi : Math.asin(x);
}

});


parcelRegister("4JvMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $372404b051f5cfc2$var$_default;

var $90QEI = parcelRequire("90QEI");

var $372404b051f5cfc2$var$_array = $372404b051f5cfc2$var$_interopRequireDefault((parcelRequire("9fCTd")));

var $372404b051f5cfc2$var$_constant = $372404b051f5cfc2$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $372404b051f5cfc2$var$_linear = $372404b051f5cfc2$var$_interopRequireDefault((parcelRequire("asfCj")));

var $372404b051f5cfc2$var$_line = $372404b051f5cfc2$var$_interopRequireDefault((parcelRequire("9A7f4")));

var $714o2 = parcelRequire("714o2");
function $372404b051f5cfc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $372404b051f5cfc2$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $372404b051f5cfc2$var$_constant.default)(true), context = null, curve = $372404b051f5cfc2$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $714o2.x : (0, $372404b051f5cfc2$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $372404b051f5cfc2$var$_constant.default)(0) : (0, $372404b051f5cfc2$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $714o2.y : (0, $372404b051f5cfc2$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $372404b051f5cfc2$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $90QEI.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $372404b051f5cfc2$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $372404b051f5cfc2$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("9fCTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6bc3ae73f89d099d$var$_default;
module.exports.slice = void 0;
var $6bc3ae73f89d099d$var$slice = Array.prototype.slice;
module.exports.slice = $6bc3ae73f89d099d$var$slice;
function $6bc3ae73f89d099d$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("asfCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $79c8a215320f27f7$var$_default;
function $79c8a215320f27f7$var$Linear(context) {
    this._context = context;
}
$79c8a215320f27f7$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $79c8a215320f27f7$var$_default(context) {
    return new $79c8a215320f27f7$var$Linear(context);
}

});

parcelRegister("9A7f4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f9d17f5a727a601$var$_default;

var $90QEI = parcelRequire("90QEI");

var $6f9d17f5a727a601$var$_array = $6f9d17f5a727a601$var$_interopRequireDefault((parcelRequire("9fCTd")));

var $6f9d17f5a727a601$var$_constant = $6f9d17f5a727a601$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $6f9d17f5a727a601$var$_linear = $6f9d17f5a727a601$var$_interopRequireDefault((parcelRequire("asfCj")));

var $714o2 = parcelRequire("714o2");
function $6f9d17f5a727a601$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6f9d17f5a727a601$var$_default(x, y) {
    var defined = (0, $6f9d17f5a727a601$var$_constant.default)(true), context = null, curve = $6f9d17f5a727a601$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $714o2.x : (0, $6f9d17f5a727a601$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $714o2.y : (0, $6f9d17f5a727a601$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $6f9d17f5a727a601$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $90QEI.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $6f9d17f5a727a601$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $6f9d17f5a727a601$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $6f9d17f5a727a601$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("714o2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $51bc0784cbe1a230$var$x;
module.exports.y = $51bc0784cbe1a230$var$y;
function $51bc0784cbe1a230$var$x(p) {
    return p[0];
}
function $51bc0784cbe1a230$var$y(p) {
    return p[1];
}

});



parcelRegister("2H5MK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f6415c5cf4b821e$var$_default;

var $1f6415c5cf4b821e$var$_array = $1f6415c5cf4b821e$var$_interopRequireDefault((parcelRequire("9fCTd")));

var $1f6415c5cf4b821e$var$_constant = $1f6415c5cf4b821e$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $1f6415c5cf4b821e$var$_descending = $1f6415c5cf4b821e$var$_interopRequireDefault((parcelRequire("li19M")));

var $1f6415c5cf4b821e$var$_identity = $1f6415c5cf4b821e$var$_interopRequireDefault((parcelRequire("hB3kJ")));

var $4FbUN = parcelRequire("4FbUN");
function $1f6415c5cf4b821e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1f6415c5cf4b821e$var$_default() {
    var value = $1f6415c5cf4b821e$var$_identity.default, sortValues = $1f6415c5cf4b821e$var$_descending.default, sort = null, startAngle = (0, $1f6415c5cf4b821e$var$_constant.default)(0), endAngle = (0, $1f6415c5cf4b821e$var$_constant.default)($4FbUN.tau), padAngle = (0, $1f6415c5cf4b821e$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $1f6415c5cf4b821e$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($4FbUN.tau, Math.max(-$4FbUN.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $1f6415c5cf4b821e$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $1f6415c5cf4b821e$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $1f6415c5cf4b821e$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $1f6415c5cf4b821e$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("li19M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7fc2d19aeca163e$var$_default;
function $f7fc2d19aeca163e$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("hB3kJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccf87a4b3c38315c$var$_default;
function $ccf87a4b3c38315c$var$_default(d) {
    return d;
}

});


parcelRegister("8Q1J8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66f485010cc192a7$var$_default;

var $66f485010cc192a7$var$_radial = $66f485010cc192a7$var$_interopRequireWildcard((parcelRequire("9suIZ")));

var $66f485010cc192a7$var$_area = $66f485010cc192a7$var$_interopRequireDefault((parcelRequire("4JvMy")));

var $k3w6r = parcelRequire("k3w6r");
function $66f485010cc192a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $66f485010cc192a7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($66f485010cc192a7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $66f485010cc192a7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $66f485010cc192a7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $66f485010cc192a7$var$_default() {
    var a = (0, $66f485010cc192a7$var$_area.default)().curve($66f485010cc192a7$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $k3w6r.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $k3w6r.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $k3w6r.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $k3w6r.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $66f485010cc192a7$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("9suIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $6e2e8fe1447f48ea$var$curveRadial;

var $6e2e8fe1447f48ea$var$_linear = $6e2e8fe1447f48ea$var$_interopRequireDefault((parcelRequire("asfCj")));
function $6e2e8fe1447f48ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e2e8fe1447f48ea$var$curveRadialLinear = $6e2e8fe1447f48ea$var$curveRadial($6e2e8fe1447f48ea$var$_linear.default);
module.exports.curveRadialLinear = $6e2e8fe1447f48ea$var$curveRadialLinear;
function $6e2e8fe1447f48ea$var$Radial(curve) {
    this._curve = curve;
}
$6e2e8fe1447f48ea$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $6e2e8fe1447f48ea$var$curveRadial(curve) {
    function radial(context) {
        return new $6e2e8fe1447f48ea$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("k3w6r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e99cfd6bf7df5d67$var$_default;
module.exports.lineRadial = $e99cfd6bf7df5d67$var$lineRadial;

var $e99cfd6bf7df5d67$var$_radial = $e99cfd6bf7df5d67$var$_interopRequireWildcard((parcelRequire("9suIZ")));

var $e99cfd6bf7df5d67$var$_line = $e99cfd6bf7df5d67$var$_interopRequireDefault((parcelRequire("9A7f4")));
function $e99cfd6bf7df5d67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e99cfd6bf7df5d67$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e99cfd6bf7df5d67$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e99cfd6bf7df5d67$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e99cfd6bf7df5d67$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e99cfd6bf7df5d67$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $e99cfd6bf7df5d67$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $e99cfd6bf7df5d67$var$_default() {
    return $e99cfd6bf7df5d67$var$lineRadial((0, $e99cfd6bf7df5d67$var$_line.default)().curve($e99cfd6bf7df5d67$var$_radial.curveRadialLinear));
}

});


parcelRegister("15bV0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c9f80d8470e3bad$var$_default;
function $0c9f80d8470e3bad$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("UvLP5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $0a9de0013b82bcbb$var$link;
module.exports.linkHorizontal = $0a9de0013b82bcbb$var$linkHorizontal;
module.exports.linkRadial = $0a9de0013b82bcbb$var$linkRadial;
module.exports.linkVertical = $0a9de0013b82bcbb$var$linkVertical;

var $90QEI = parcelRequire("90QEI");

var $9fCTd = parcelRequire("9fCTd");

var $0a9de0013b82bcbb$var$_constant = $0a9de0013b82bcbb$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $6GXvJ = parcelRequire("6GXvJ");

var $714o2 = parcelRequire("714o2");
function $0a9de0013b82bcbb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0a9de0013b82bcbb$var$linkSource(d) {
    return d.source;
}
function $0a9de0013b82bcbb$var$linkTarget(d) {
    return d.target;
}
function $0a9de0013b82bcbb$var$link(curve) {
    let source = $0a9de0013b82bcbb$var$linkSource;
    let target = $0a9de0013b82bcbb$var$linkTarget;
    let x = $714o2.x;
    let y = $714o2.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $9fCTd.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $90QEI.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $0a9de0013b82bcbb$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $0a9de0013b82bcbb$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $0a9de0013b82bcbb$var$linkHorizontal() {
    return $0a9de0013b82bcbb$var$link($6GXvJ.bumpX);
}
function $0a9de0013b82bcbb$var$linkVertical() {
    return $0a9de0013b82bcbb$var$link($6GXvJ.bumpY);
}
function $0a9de0013b82bcbb$var$linkRadial() {
    const l = $0a9de0013b82bcbb$var$link($6GXvJ.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("6GXvJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $4df4d3e85e41c9b8$var$bumpRadial;
module.exports.bumpX = $4df4d3e85e41c9b8$var$bumpX;
module.exports.bumpY = $4df4d3e85e41c9b8$var$bumpY;

var $4df4d3e85e41c9b8$var$_pointRadial = $4df4d3e85e41c9b8$var$_interopRequireDefault((parcelRequire("15bV0")));
function $4df4d3e85e41c9b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $4df4d3e85e41c9b8$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $4df4d3e85e41c9b8$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $4df4d3e85e41c9b8$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $4df4d3e85e41c9b8$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $4df4d3e85e41c9b8$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $4df4d3e85e41c9b8$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $4df4d3e85e41c9b8$var$bumpX(context) {
    return new $4df4d3e85e41c9b8$var$Bump(context, true);
}
function $4df4d3e85e41c9b8$var$bumpY(context) {
    return new $4df4d3e85e41c9b8$var$Bump(context, false);
}
function $4df4d3e85e41c9b8$var$bumpRadial(context) {
    return new $4df4d3e85e41c9b8$var$BumpRadial(context);
}

});


parcelRegister("jt289", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e2c260d19e176c0c$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $90QEI = parcelRequire("90QEI");

var $e2c260d19e176c0c$var$_constant = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $e2c260d19e176c0c$var$_asterisk = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("a1kLk")));

var $e2c260d19e176c0c$var$_circle = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("8Pifm")));

var $e2c260d19e176c0c$var$_cross = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("994h0")));

var $e2c260d19e176c0c$var$_diamond = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("aWMJb")));

var $e2c260d19e176c0c$var$_diamond2 = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("i5UoN")));

var $e2c260d19e176c0c$var$_plus = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("e0q9L")));

var $e2c260d19e176c0c$var$_square = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("XN9hk")));

var $e2c260d19e176c0c$var$_square2 = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("86b5U")));

var $e2c260d19e176c0c$var$_star = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("8DCJr")));

var $e2c260d19e176c0c$var$_triangle = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("kFpHO")));

var $e2c260d19e176c0c$var$_triangle2 = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("fibnU")));

var $e2c260d19e176c0c$var$_wye = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("gJ4P0")));

var $e2c260d19e176c0c$var$_x = $e2c260d19e176c0c$var$_interopRequireDefault((parcelRequire("1cuVN")));
function $e2c260d19e176c0c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $e2c260d19e176c0c$var$symbolsFill = [
    $e2c260d19e176c0c$var$_circle.default,
    $e2c260d19e176c0c$var$_cross.default,
    $e2c260d19e176c0c$var$_diamond.default,
    $e2c260d19e176c0c$var$_square.default,
    $e2c260d19e176c0c$var$_star.default,
    $e2c260d19e176c0c$var$_triangle.default,
    $e2c260d19e176c0c$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $e2c260d19e176c0c$var$symbolsFill;
const $e2c260d19e176c0c$var$symbolsStroke = [
    $e2c260d19e176c0c$var$_circle.default,
    $e2c260d19e176c0c$var$_plus.default,
    $e2c260d19e176c0c$var$_x.default,
    $e2c260d19e176c0c$var$_triangle2.default,
    $e2c260d19e176c0c$var$_asterisk.default,
    $e2c260d19e176c0c$var$_square2.default,
    $e2c260d19e176c0c$var$_diamond2.default
];
module.exports.symbolsStroke = $e2c260d19e176c0c$var$symbolsStroke;
function $e2c260d19e176c0c$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $e2c260d19e176c0c$var$_constant.default)(type || $e2c260d19e176c0c$var$_circle.default);
    size = typeof size === "function" ? size : (0, $e2c260d19e176c0c$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $90QEI.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $e2c260d19e176c0c$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $e2c260d19e176c0c$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("a1kLk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $74ba1a5f3d929fae$var$sqrt3 = (0, $4FbUN.sqrt)(3);
var $74ba1a5f3d929fae$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size + (0, $4FbUN.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $74ba1a5f3d929fae$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $74ba1a5f3d929fae$var$_default;

});

parcelRegister("8Pifm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $66d13d965f937cc3$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size / $4FbUN.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $4FbUN.tau);
    }
};
module.exports.default = $66d13d965f937cc3$var$_default;

});

parcelRegister("994h0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $6a8844e7d08b15b1$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $6a8844e7d08b15b1$var$_default;

});

parcelRegister("aWMJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $7f851e7c3f91e885$var$tan30 = (0, $4FbUN.sqrt)(1 / 3);
const $7f851e7c3f91e885$var$tan30_2 = $7f851e7c3f91e885$var$tan30 * 2;
var $7f851e7c3f91e885$var$_default = {
    draw (context, size) {
        const y = (0, $4FbUN.sqrt)(size / $7f851e7c3f91e885$var$tan30_2);
        const x = y * $7f851e7c3f91e885$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $7f851e7c3f91e885$var$_default;

});

parcelRegister("i5UoN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $d2c4714565693200$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $d2c4714565693200$var$_default;

});

parcelRegister("e0q9L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $a3255aeea4148f63$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size - (0, $4FbUN.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $a3255aeea4148f63$var$_default;

});

parcelRegister("XN9hk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $0b3ba2b39dbb7849$var$_default = {
    draw (context, size) {
        const w = (0, $4FbUN.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $0b3ba2b39dbb7849$var$_default;

});

parcelRegister("86b5U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $5e577d608dfe587e$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $5e577d608dfe587e$var$_default;

});

parcelRegister("8DCJr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $64a00296c76644d4$var$ka = 0.89081309152928522810;
const $64a00296c76644d4$var$kr = (0, $4FbUN.sin)($4FbUN.pi / 10) / (0, $4FbUN.sin)(7 * $4FbUN.pi / 10);
const $64a00296c76644d4$var$kx = (0, $4FbUN.sin)($4FbUN.tau / 10) * $64a00296c76644d4$var$kr;
const $64a00296c76644d4$var$ky = -(0, $4FbUN.cos)($4FbUN.tau / 10) * $64a00296c76644d4$var$kr;
var $64a00296c76644d4$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size * $64a00296c76644d4$var$ka);
        const x = $64a00296c76644d4$var$kx * r;
        const y = $64a00296c76644d4$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $4FbUN.tau * i / 5;
            const c = (0, $4FbUN.cos)(a);
            const s = (0, $4FbUN.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $64a00296c76644d4$var$_default;

});

parcelRegister("kFpHO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $f0bb93954364852e$var$sqrt3 = (0, $4FbUN.sqrt)(3);
var $f0bb93954364852e$var$_default = {
    draw (context, size) {
        const y = -(0, $4FbUN.sqrt)(size / ($f0bb93954364852e$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$f0bb93954364852e$var$sqrt3 * y, -y);
        context.lineTo($f0bb93954364852e$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $f0bb93954364852e$var$_default;

});

parcelRegister("fibnU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $b2215e2f22a51bcc$var$sqrt3 = (0, $4FbUN.sqrt)(3);
var $b2215e2f22a51bcc$var$_default = {
    draw (context, size) {
        const s = (0, $4FbUN.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $b2215e2f22a51bcc$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $b2215e2f22a51bcc$var$_default;

});

parcelRegister("gJ4P0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
const $c2d496d01954bf1f$var$c = -0.5;
const $c2d496d01954bf1f$var$s = (0, $4FbUN.sqrt)(3) / 2;
const $c2d496d01954bf1f$var$k = 1 / (0, $4FbUN.sqrt)(12);
const $c2d496d01954bf1f$var$a = ($c2d496d01954bf1f$var$k / 2 + 1) * 3;
var $c2d496d01954bf1f$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size / $c2d496d01954bf1f$var$a);
        const x0 = r / 2, y0 = r * $c2d496d01954bf1f$var$k;
        const x1 = x0, y1 = r * $c2d496d01954bf1f$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($c2d496d01954bf1f$var$c * x0 - $c2d496d01954bf1f$var$s * y0, $c2d496d01954bf1f$var$s * x0 + $c2d496d01954bf1f$var$c * y0);
        context.lineTo($c2d496d01954bf1f$var$c * x1 - $c2d496d01954bf1f$var$s * y1, $c2d496d01954bf1f$var$s * x1 + $c2d496d01954bf1f$var$c * y1);
        context.lineTo($c2d496d01954bf1f$var$c * x2 - $c2d496d01954bf1f$var$s * y2, $c2d496d01954bf1f$var$s * x2 + $c2d496d01954bf1f$var$c * y2);
        context.lineTo($c2d496d01954bf1f$var$c * x0 + $c2d496d01954bf1f$var$s * y0, $c2d496d01954bf1f$var$c * y0 - $c2d496d01954bf1f$var$s * x0);
        context.lineTo($c2d496d01954bf1f$var$c * x1 + $c2d496d01954bf1f$var$s * y1, $c2d496d01954bf1f$var$c * y1 - $c2d496d01954bf1f$var$s * x1);
        context.lineTo($c2d496d01954bf1f$var$c * x2 + $c2d496d01954bf1f$var$s * y2, $c2d496d01954bf1f$var$c * y2 - $c2d496d01954bf1f$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $c2d496d01954bf1f$var$_default;

});

parcelRegister("1cuVN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4FbUN = parcelRequire("4FbUN");
var $0dfee7bf0f52d215$var$_default = {
    draw (context, size) {
        const r = (0, $4FbUN.sqrt)(size - (0, $4FbUN.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $0dfee7bf0f52d215$var$_default;

});


parcelRegister("hFjyF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdc56fd49e97a5e4$var$_default;

var $cdc56fd49e97a5e4$var$_noop = $cdc56fd49e97a5e4$var$_interopRequireDefault((parcelRequire("71HMR")));

var $j97pr = parcelRequire("j97pr");
function $cdc56fd49e97a5e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdc56fd49e97a5e4$var$BasisClosed(context) {
    this._context = context;
}
$cdc56fd49e97a5e4$var$BasisClosed.prototype = {
    areaStart: $cdc56fd49e97a5e4$var$_noop.default,
    areaEnd: $cdc56fd49e97a5e4$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $j97pr.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $cdc56fd49e97a5e4$var$_default(context) {
    return new $cdc56fd49e97a5e4$var$BasisClosed(context);
}

});
parcelRegister("71HMR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51da9794f3375056$var$_default;
function $51da9794f3375056$var$_default() {}

});

parcelRegister("j97pr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $df049af24dc70e6b$var$Basis;
module.exports.default = $df049af24dc70e6b$var$_default;
module.exports.point = $df049af24dc70e6b$var$point;
function $df049af24dc70e6b$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $df049af24dc70e6b$var$Basis(context) {
    this._context = context;
}
$df049af24dc70e6b$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $df049af24dc70e6b$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $df049af24dc70e6b$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $df049af24dc70e6b$var$_default(context) {
    return new $df049af24dc70e6b$var$Basis(context);
}

});


parcelRegister("8sKsF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6294fa833e0498e1$var$_default;

var $j97pr = parcelRequire("j97pr");
function $6294fa833e0498e1$var$BasisOpen(context) {
    this._context = context;
}
$6294fa833e0498e1$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $j97pr.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $6294fa833e0498e1$var$_default(context) {
    return new $6294fa833e0498e1$var$BasisOpen(context);
}

});

parcelRegister("iP30e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $j97pr = parcelRequire("j97pr");
function $db3f51ac96c87bca$var$Bundle(context, beta) {
    this._basis = new $j97pr.Basis(context);
    this._beta = beta;
}
$db3f51ac96c87bca$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $db3f51ac96c87bca$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $j97pr.Basis(context) : new $db3f51ac96c87bca$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $db3f51ac96c87bca$var$_default;

});

parcelRegister("cuxyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $91824fdf2a2c9513$var$CardinalClosed;
module.exports.default = void 0;

var $91824fdf2a2c9513$var$_noop = $91824fdf2a2c9513$var$_interopRequireDefault((parcelRequire("71HMR")));

var $aKtxc = parcelRequire("aKtxc");
function $91824fdf2a2c9513$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91824fdf2a2c9513$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$91824fdf2a2c9513$var$CardinalClosed.prototype = {
    areaStart: $91824fdf2a2c9513$var$_noop.default,
    areaEnd: $91824fdf2a2c9513$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $aKtxc.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $91824fdf2a2c9513$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $91824fdf2a2c9513$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $91824fdf2a2c9513$var$_default;

});
parcelRegister("aKtxc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $7d351c36b67a8220$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $7d351c36b67a8220$var$point;
function $7d351c36b67a8220$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $7d351c36b67a8220$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$7d351c36b67a8220$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $7d351c36b67a8220$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $7d351c36b67a8220$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $7d351c36b67a8220$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $7d351c36b67a8220$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $7d351c36b67a8220$var$_default;

});


parcelRegister("4YITs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $39ff96f07a4513f7$var$CardinalOpen;
module.exports.default = void 0;

var $aKtxc = parcelRequire("aKtxc");
function $39ff96f07a4513f7$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$39ff96f07a4513f7$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $aKtxc.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $39ff96f07a4513f7$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $39ff96f07a4513f7$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $39ff96f07a4513f7$var$_default;

});

parcelRegister("gy5Eg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cuxyd = parcelRequire("cuxyd");

var $c0c433fd9d20a520$var$_noop = $c0c433fd9d20a520$var$_interopRequireDefault((parcelRequire("71HMR")));

var $lnOBO = parcelRequire("lnOBO");
function $c0c433fd9d20a520$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c0c433fd9d20a520$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$c0c433fd9d20a520$var$CatmullRomClosed.prototype = {
    areaStart: $c0c433fd9d20a520$var$_noop.default,
    areaEnd: $c0c433fd9d20a520$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $lnOBO.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $c0c433fd9d20a520$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $c0c433fd9d20a520$var$CatmullRomClosed(context, alpha) : new $cuxyd.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $c0c433fd9d20a520$var$_default;

});
parcelRegister("lnOBO", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $4FbUN = parcelRequire("4FbUN");

var $aKtxc = parcelRequire("aKtxc");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $4FbUN.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $4FbUN.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $aKtxc.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("03s2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4YITs = parcelRequire("4YITs");

var $lnOBO = parcelRequire("lnOBO");
function $00a6080fb2c1ecae$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$00a6080fb2c1ecae$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $lnOBO.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $00a6080fb2c1ecae$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $00a6080fb2c1ecae$var$CatmullRomOpen(context, alpha) : new $4YITs.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $00a6080fb2c1ecae$var$_default;

});

parcelRegister("6EZe0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d95f88109a5bf8d$var$_default;

var $4d95f88109a5bf8d$var$_noop = $4d95f88109a5bf8d$var$_interopRequireDefault((parcelRequire("71HMR")));
function $4d95f88109a5bf8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d95f88109a5bf8d$var$LinearClosed(context) {
    this._context = context;
}
$4d95f88109a5bf8d$var$LinearClosed.prototype = {
    areaStart: $4d95f88109a5bf8d$var$_noop.default,
    areaEnd: $4d95f88109a5bf8d$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $4d95f88109a5bf8d$var$_default(context) {
    return new $4d95f88109a5bf8d$var$LinearClosed(context);
}

});

parcelRegister("lY9dJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $ffe65a952f8ab911$var$monotoneX;
module.exports.monotoneY = $ffe65a952f8ab911$var$monotoneY;
function $ffe65a952f8ab911$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $ffe65a952f8ab911$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($ffe65a952f8ab911$var$sign(s0) + $ffe65a952f8ab911$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $ffe65a952f8ab911$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $ffe65a952f8ab911$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $ffe65a952f8ab911$var$MonotoneX(context) {
    this._context = context;
}
$ffe65a952f8ab911$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $ffe65a952f8ab911$var$point(this, this._t0, $ffe65a952f8ab911$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $ffe65a952f8ab911$var$point(this, $ffe65a952f8ab911$var$slope2(this, t1 = $ffe65a952f8ab911$var$slope3(this, x, y)), t1);
                break;
            default:
                $ffe65a952f8ab911$var$point(this, this._t0, t1 = $ffe65a952f8ab911$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $ffe65a952f8ab911$var$MonotoneY(context) {
    this._context = new $ffe65a952f8ab911$var$ReflectContext(context);
}
($ffe65a952f8ab911$var$MonotoneY.prototype = Object.create($ffe65a952f8ab911$var$MonotoneX.prototype)).point = function(x, y) {
    $ffe65a952f8ab911$var$MonotoneX.prototype.point.call(this, y, x);
};
function $ffe65a952f8ab911$var$ReflectContext(context) {
    this._context = context;
}
$ffe65a952f8ab911$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $ffe65a952f8ab911$var$monotoneX(context) {
    return new $ffe65a952f8ab911$var$MonotoneX(context);
}
function $ffe65a952f8ab911$var$monotoneY(context) {
    return new $ffe65a952f8ab911$var$MonotoneY(context);
}

});

parcelRegister("d20Gv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97cbfe3939eff9b6$var$_default;
function $97cbfe3939eff9b6$var$Natural(context) {
    this._context = context;
}
$97cbfe3939eff9b6$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $97cbfe3939eff9b6$var$controlPoints(x), py = $97cbfe3939eff9b6$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $97cbfe3939eff9b6$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $97cbfe3939eff9b6$var$_default(context) {
    return new $97cbfe3939eff9b6$var$Natural(context);
}

});

parcelRegister("dJj1m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9fee3b7c971d5215$var$_default;
module.exports.stepAfter = $9fee3b7c971d5215$var$stepAfter;
module.exports.stepBefore = $9fee3b7c971d5215$var$stepBefore;
function $9fee3b7c971d5215$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$9fee3b7c971d5215$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $9fee3b7c971d5215$var$_default(context) {
    return new $9fee3b7c971d5215$var$Step(context, 0.5);
}
function $9fee3b7c971d5215$var$stepBefore(context) {
    return new $9fee3b7c971d5215$var$Step(context, 0);
}
function $9fee3b7c971d5215$var$stepAfter(context) {
    return new $9fee3b7c971d5215$var$Step(context, 1);
}

});

parcelRegister("ho6Px", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ca89f9e8dd5a9f59$var$_default;

var $ca89f9e8dd5a9f59$var$_array = $ca89f9e8dd5a9f59$var$_interopRequireDefault((parcelRequire("9fCTd")));

var $ca89f9e8dd5a9f59$var$_constant = $ca89f9e8dd5a9f59$var$_interopRequireDefault((parcelRequire("9yZGM")));

var $ca89f9e8dd5a9f59$var$_none = $ca89f9e8dd5a9f59$var$_interopRequireDefault((parcelRequire("cCsiF")));

var $ca89f9e8dd5a9f59$var$_none2 = $ca89f9e8dd5a9f59$var$_interopRequireDefault((parcelRequire("8lQut")));
function $ca89f9e8dd5a9f59$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca89f9e8dd5a9f59$var$stackValue(d, key) {
    return d[key];
}
function $ca89f9e8dd5a9f59$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $ca89f9e8dd5a9f59$var$_default() {
    var keys = (0, $ca89f9e8dd5a9f59$var$_constant.default)([]), order = $ca89f9e8dd5a9f59$var$_none2.default, offset = $ca89f9e8dd5a9f59$var$_none.default, value = $ca89f9e8dd5a9f59$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $ca89f9e8dd5a9f59$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $ca89f9e8dd5a9f59$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $ca89f9e8dd5a9f59$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $ca89f9e8dd5a9f59$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $ca89f9e8dd5a9f59$var$_none2.default : typeof _ === "function" ? _ : (0, $ca89f9e8dd5a9f59$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $ca89f9e8dd5a9f59$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("cCsiF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $92fefc7369242ce3$var$_default;
function $92fefc7369242ce3$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("8lQut", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6149006c6bcb7c3d$var$_default;
function $6149006c6bcb7c3d$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("gS501", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4859145835b576e$var$_default;

var $c4859145835b576e$var$_none = $c4859145835b576e$var$_interopRequireDefault((parcelRequire("cCsiF")));
function $c4859145835b576e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4859145835b576e$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $c4859145835b576e$var$_none.default)(series, order);
}

});

parcelRegister("ctjKT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9147847435d51b58$var$_default;
function $9147847435d51b58$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("ahzGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $77c72d70bf640d80$var$_default;

var $77c72d70bf640d80$var$_none = $77c72d70bf640d80$var$_interopRequireDefault((parcelRequire("cCsiF")));
function $77c72d70bf640d80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $77c72d70bf640d80$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $77c72d70bf640d80$var$_none.default)(series, order);
}

});

parcelRegister("kPTxX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2b3a879c8947dc6$var$_default;

var $f2b3a879c8947dc6$var$_none = $f2b3a879c8947dc6$var$_interopRequireDefault((parcelRequire("cCsiF")));
function $f2b3a879c8947dc6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2b3a879c8947dc6$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $f2b3a879c8947dc6$var$_none.default)(series, order);
}

});

parcelRegister("lrF5M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9cbfea94a752588$var$_default;

var $f9cbfea94a752588$var$_none = $f9cbfea94a752588$var$_interopRequireDefault((parcelRequire("8lQut")));
function $f9cbfea94a752588$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f9cbfea94a752588$var$_default(series) {
    var peaks = series.map($f9cbfea94a752588$var$peak);
    return (0, $f9cbfea94a752588$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $f9cbfea94a752588$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("f0F6C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aed6bdd3d04f81ca$var$_default;
module.exports.sum = $aed6bdd3d04f81ca$var$sum;

var $aed6bdd3d04f81ca$var$_none = $aed6bdd3d04f81ca$var$_interopRequireDefault((parcelRequire("8lQut")));
function $aed6bdd3d04f81ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aed6bdd3d04f81ca$var$_default(series) {
    var sums = series.map($aed6bdd3d04f81ca$var$sum);
    return (0, $aed6bdd3d04f81ca$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $aed6bdd3d04f81ca$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("2TVNI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $21cd8de45ae868e9$var$_default;

var $21cd8de45ae868e9$var$_ascending = $21cd8de45ae868e9$var$_interopRequireDefault((parcelRequire("f0F6C")));
function $21cd8de45ae868e9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21cd8de45ae868e9$var$_default(series) {
    return (0, $21cd8de45ae868e9$var$_ascending.default)(series).reverse();
}

});

parcelRegister("cDnpf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $932b488c9764036b$var$_default;

var $932b488c9764036b$var$_appearance = $932b488c9764036b$var$_interopRequireDefault((parcelRequire("lrF5M")));

var $f0F6C = parcelRequire("f0F6C");
function $932b488c9764036b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $932b488c9764036b$var$_default(series) {
    var n = series.length, i, j, sums = series.map($f0F6C.sum), order = (0, $932b488c9764036b$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("8TGph", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67a45ae7d009ff90$var$_default;

var $67a45ae7d009ff90$var$_none = $67a45ae7d009ff90$var$_interopRequireDefault((parcelRequire("8lQut")));
function $67a45ae7d009ff90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $67a45ae7d009ff90$var$_default(series) {
    return (0, $67a45ae7d009ff90$var$_none.default)(series).reverse();
}

});




var $kRS0m = parcelRequire("kRS0m");

var $kRS0m = parcelRequire("kRS0m");
class $22d1a4cfc5fba7ce$export$9f9d0139d032da4f {
    constructor(value){
        this.value = value;
    }
    toJSON() {
        return this.value;
    }
    // Don't add "Some" for consistency with erased options
    toString() {
        return String(this.value);
    }
    GetHashCode() {
        return (0, $kRS0m.structuralHash)(this.value);
    }
    Equals(other) {
        if (other == null) return false;
        else return (0, $kRS0m.equals)(this.value, other instanceof $22d1a4cfc5fba7ce$export$9f9d0139d032da4f ? other.value : other);
    }
    CompareTo(other) {
        if (other == null) return 1;
        else return (0, $kRS0m.compare)(this.value, other instanceof $22d1a4cfc5fba7ce$export$9f9d0139d032da4f ? other.value : other);
    }
}
function $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(x) {
    if (x == null) throw new Error("Option has no value");
    else return x instanceof $22d1a4cfc5fba7ce$export$9f9d0139d032da4f ? x.value : x;
}
function $22d1a4cfc5fba7ce$export$debb760848ca95a(opt) {
    return opt instanceof $22d1a4cfc5fba7ce$export$9f9d0139d032da4f ? opt.value : opt;
}
function $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd(x) {
    return x == null || x instanceof $22d1a4cfc5fba7ce$export$9f9d0139d032da4f ? new $22d1a4cfc5fba7ce$export$9f9d0139d032da4f(x) : x;
}
function $22d1a4cfc5fba7ce$export$e724fd86d7aa146b(x) {
    // This will fail with unit probably, an alternative would be:
    // return x === null ? undefined : (x === undefined ? new Some(x) : x);
    return x == null ? undefined : x;
}
function $22d1a4cfc5fba7ce$export$b187f57ee1822bc5(x) {
    return x == null ? null : $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(x);
}
function $22d1a4cfc5fba7ce$export$bffa455ba8c619a6(x) {
    return x == null ? undefined : $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(x);
}
function $22d1a4cfc5fba7ce$export$45b10814cc054894(opt) {
    return opt == null ? [] : [
        $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt)
    ];
}
function $22d1a4cfc5fba7ce$export$37721a79838ca038(opt, defaultValue) {
    return opt != null ? $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt) : defaultValue;
}
function $22d1a4cfc5fba7ce$export$c90763f2293d7e67(opt, defThunk) {
    return opt != null ? $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt) : defThunk();
}
function $22d1a4cfc5fba7ce$export$41d1a04d78e7b141(opt, ifNone) {
    return opt == null ? ifNone : opt;
}
function $22d1a4cfc5fba7ce$export$eb1968ae3f7e8865(opt, ifNoneThunk) {
    return opt == null ? ifNoneThunk() : opt;
}
function $22d1a4cfc5fba7ce$export$3dea766d36a8935f(predicate, opt) {
    return opt != null ? predicate($22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt)) ? opt : undefined : opt;
}
function $22d1a4cfc5fba7ce$export$871de8747c9eaa88(mapping, opt) {
    return opt != null ? $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd(mapping($22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt))) : undefined;
}
function $22d1a4cfc5fba7ce$export$5be556bf484c4f10(mapping, opt1, opt2) {
    return opt1 != null && opt2 != null ? mapping($22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt1), $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt2)) : undefined;
}
function $22d1a4cfc5fba7ce$export$f7389512af34c855(mapping, opt1, opt2, opt3) {
    return opt1 != null && opt2 != null && opt3 != null ? mapping($22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt1), $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt2), $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt3)) : undefined;
}
function $22d1a4cfc5fba7ce$export$2385a24977818dd0(binder, opt) {
    return opt != null ? binder($22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14(opt)) : undefined;
}
function $22d1a4cfc5fba7ce$export$4324eaa7776d3b57(op, arg) {
    try {
        return $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd(op(arg));
    } catch  {
        return undefined;
    }
}



var $eATN7 = parcelRequire("eATN7");

var $eATN7 = parcelRequire("eATN7");

var $kRS0m = parcelRequire("kRS0m");

var $fzAFM = parcelRequire("fzAFM");
class $3921efb06a31e9cc$export$5da6bb266b244b1f {
    constructor(declaringType, tag, name, fields){
        this.declaringType = declaringType;
        this.tag = tag;
        this.name = name;
        this.fields = fields;
    }
}
class $3921efb06a31e9cc$export$49bbbea0e28f81da {
    constructor(name, parameters, returnType){
        this.name = name;
        this.parameters = parameters;
        this.returnType = returnType;
    }
}
class $3921efb06a31e9cc$export$f0c1fe746ce4bb1e {
    constructor(fullname, generics, construct, parent, fields, cases, enumCases){
        this.fullname = fullname;
        this.generics = generics;
        this.construct = construct;
        this.parent = parent;
        this.fields = fields;
        this.cases = cases;
        this.enumCases = enumCases;
    }
    toString() {
        return $3921efb06a31e9cc$export$1d6cfa7493842c29(this);
    }
    GetHashCode() {
        return $3921efb06a31e9cc$export$c14f61804029af13(this);
    }
    Equals(other) {
        return $3921efb06a31e9cc$export$e9bab7fafb253603(this, other);
    }
}
class $3921efb06a31e9cc$export$e2a012deca8e0eb5 extends $3921efb06a31e9cc$export$f0c1fe746ce4bb1e {
    constructor(name){
        super(name);
    }
}
function $3921efb06a31e9cc$export$18737d7a203fc740(t) {
    return t.generics != null ? t.generics : [];
}
function $3921efb06a31e9cc$export$c14f61804029af13(t) {
    const fullnameHash = (0, $kRS0m.stringHash)(t.fullname);
    const genHashes = $3921efb06a31e9cc$export$18737d7a203fc740(t).map($3921efb06a31e9cc$export$c14f61804029af13);
    return (0, $kRS0m.combineHashCodes)([
        fullnameHash,
        ...genHashes
    ]);
}
function $3921efb06a31e9cc$export$e9bab7fafb253603(t1, t2) {
    if (t1.fullname === "") return t2.fullname === "" && (0, $kRS0m.equalArraysWith)($3921efb06a31e9cc$export$b0ab498daed3dd7f(t1), $3921efb06a31e9cc$export$b0ab498daed3dd7f(t2), ([k1, v1], [k2, v2])=>k1 === k2 && $3921efb06a31e9cc$export$e9bab7fafb253603(v1, v2));
    else return t1.fullname === t2.fullname && (0, $kRS0m.equalArraysWith)($3921efb06a31e9cc$export$18737d7a203fc740(t1), $3921efb06a31e9cc$export$18737d7a203fc740(t2), $3921efb06a31e9cc$export$e9bab7fafb253603);
}
function $3921efb06a31e9cc$export$8547d5acd31924e(fullname, generics, construct, parent) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(fullname, generics, construct, parent);
}
function $3921efb06a31e9cc$export$d341dea990ee4af6(fullname, generics, construct, fields) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(fullname, generics, construct, undefined, fields);
}
function $3921efb06a31e9cc$export$4bca6dc9d780d464(...fields) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("", undefined, undefined, undefined, ()=>fields);
}
function $3921efb06a31e9cc$export$1ae0dd948e267c6b(fullname, generics, construct, cases) {
    const t = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(fullname, generics, construct, undefined, undefined, ()=>{
        const caseNames = construct.prototype.cases();
        return cases().map((fields, i)=>new $3921efb06a31e9cc$export$5da6bb266b244b1f(t, i, caseNames[i], fields));
    });
    return t;
}
function $3921efb06a31e9cc$export$2163aa004254c8ff(...generics) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Tuple`" + generics.length, generics);
}
function $3921efb06a31e9cc$export$7740535942dd94ab(...generics) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Func`" + generics.length, generics);
}
function $3921efb06a31e9cc$export$14857d36df600d23(argType, returnType) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("Microsoft.FSharp.Core.FSharpFunc`2", [
        argType,
        returnType
    ]);
}
function $3921efb06a31e9cc$export$a0bfd80c70f2d46b(generic) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("Microsoft.FSharp.Core.FSharpOption`1", [
        generic
    ]);
}
function $3921efb06a31e9cc$export$5fe717259b8d6105(generic) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("Microsoft.FSharp.Collections.FSharpList`1", [
        generic
    ]);
}
function $3921efb06a31e9cc$export$9242f430c61b672d(generic) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("[]", [
        generic
    ]);
}
function $3921efb06a31e9cc$export$3120ec9ec286ab54(fullname, underlyingType, enumCases) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(fullname, [
        underlyingType
    ], undefined, undefined, undefined, undefined, enumCases);
}
function $3921efb06a31e9cc$export$cfd970c638408302(fullname) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(fullname);
}
function $3921efb06a31e9cc$export$6041990b44031fc4(name) {
    return new $3921efb06a31e9cc$export$e2a012deca8e0eb5(name);
}
const $3921efb06a31e9cc$export$e63caa28a27bc62e = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Object");
const $3921efb06a31e9cc$export$ffcad4a7b72710d8 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("Microsoft.FSharp.Core.Unit");
const $3921efb06a31e9cc$export$4b19e09c28c31d09 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Char");
const $3921efb06a31e9cc$export$36bbd56a39d3f734 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.String");
const $3921efb06a31e9cc$export$4b2f4351dd8f4737 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Boolean");
const $3921efb06a31e9cc$export$e123199e7dc4cbf4 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.SByte");
const $3921efb06a31e9cc$export$c006cc52c5c39616 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Byte");
const $3921efb06a31e9cc$export$482d438fe95b1d2b = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Int16");
const $3921efb06a31e9cc$export$d96ab529e3d5b757 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.UInt16");
const $3921efb06a31e9cc$export$d5481a1dd0e3648a = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Int32");
const $3921efb06a31e9cc$export$173d14c9e9e1a539 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.UInt32");
const $3921efb06a31e9cc$export$81545eb7084dcd0b = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Int64");
const $3921efb06a31e9cc$export$9f888871d1fa78ad = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.UInt64");
const $3921efb06a31e9cc$export$a6e469d82d53bf78 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Int128");
const $3921efb06a31e9cc$export$da130f58aded07f9 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.UInt128");
const $3921efb06a31e9cc$export$efcdfad88a82dd6a = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.IntPtr");
const $3921efb06a31e9cc$export$19939eff078bb403 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.UIntPtr");
const $3921efb06a31e9cc$export$ebc01d7438f6512a = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Half");
const $3921efb06a31e9cc$export$b51642c3501712df = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Single");
const $3921efb06a31e9cc$export$8ff85e1c626cc255 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Double");
const $3921efb06a31e9cc$export$71595c79c7738f26 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Decimal");
const $3921efb06a31e9cc$export$30afbe17ad7d0402 = new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e("System.Numerics.BigInteger");
function $3921efb06a31e9cc$export$a8ff84c12d48cfa6(info) {
    if (Array.isArray(info)) return info[0];
    else if (info instanceof $3921efb06a31e9cc$export$f0c1fe746ce4bb1e) {
        const elemType = $3921efb06a31e9cc$export$cc56411ddc6ec102(info);
        if (elemType != null) return $3921efb06a31e9cc$export$a8ff84c12d48cfa6(elemType) + "[]";
        else {
            const i = info.fullname.lastIndexOf(".");
            return i === -1 ? info.fullname : info.fullname.substr(i + 1);
        }
    } else return info.name;
}
function $3921efb06a31e9cc$export$1d6cfa7493842c29(t) {
    const elemType = $3921efb06a31e9cc$export$cc56411ddc6ec102(t);
    if (elemType != null) return $3921efb06a31e9cc$export$1d6cfa7493842c29(elemType) + "[]";
    else if (t.generics == null || t.generics.length === 0) return t.fullname;
    else return t.fullname + "[" + t.generics.map((x)=>$3921efb06a31e9cc$export$1d6cfa7493842c29(x)).join(",") + "]";
}
function $3921efb06a31e9cc$export$76a88f7de6507443(t) {
    const elemType = $3921efb06a31e9cc$export$cc56411ddc6ec102(t);
    if (elemType != null) return $3921efb06a31e9cc$export$76a88f7de6507443(elemType);
    else {
        const i = t.fullname.lastIndexOf(".");
        return i === -1 ? "" : t.fullname.substr(0, i);
    }
}
function $3921efb06a31e9cc$export$43bee75e5e14138e(t) {
    return $3921efb06a31e9cc$export$cc56411ddc6ec102(t) != null;
}
function $3921efb06a31e9cc$export$cc56411ddc6ec102(t) {
    return t.fullname === "[]" && t.generics?.length === 1 ? t.generics[0] : undefined;
}
function $3921efb06a31e9cc$export$6fbcf00b2c9d37c4(t) {
    return t.generics != null && t.generics.length > 0;
}
function $3921efb06a31e9cc$export$9bc22e80ea04e051(t) {
    return t instanceof $3921efb06a31e9cc$export$e2a012deca8e0eb5;
}
function $3921efb06a31e9cc$export$9fc8c979231a883(t) {
    return t.enumCases != null && t.enumCases.length > 0;
}
function $3921efb06a31e9cc$export$b0cce8e3db537309(t1, t2) {
    return t2.fullname === $3921efb06a31e9cc$export$e63caa28a27bc62e.fullname || t1.parent != null && (t1.parent.Equals(t2) || $3921efb06a31e9cc$export$b0cce8e3db537309(t1.parent, t2));
}
function $3921efb06a31e9cc$var$isErasedToNumber(t) {
    return $3921efb06a31e9cc$export$9fc8c979231a883(t) || [
        $3921efb06a31e9cc$export$e123199e7dc4cbf4.fullname,
        $3921efb06a31e9cc$export$c006cc52c5c39616.fullname,
        $3921efb06a31e9cc$export$482d438fe95b1d2b.fullname,
        $3921efb06a31e9cc$export$d96ab529e3d5b757.fullname,
        $3921efb06a31e9cc$export$d5481a1dd0e3648a.fullname,
        $3921efb06a31e9cc$export$173d14c9e9e1a539.fullname,
        $3921efb06a31e9cc$export$ebc01d7438f6512a.fullname,
        $3921efb06a31e9cc$export$b51642c3501712df.fullname,
        $3921efb06a31e9cc$export$8ff85e1c626cc255.fullname
    ].includes(t.fullname);
}
function $3921efb06a31e9cc$var$isErasedToBigInt(t) {
    return $3921efb06a31e9cc$export$9fc8c979231a883(t) || [
        $3921efb06a31e9cc$export$81545eb7084dcd0b.fullname,
        $3921efb06a31e9cc$export$9f888871d1fa78ad.fullname,
        $3921efb06a31e9cc$export$a6e469d82d53bf78.fullname,
        $3921efb06a31e9cc$export$da130f58aded07f9.fullname,
        $3921efb06a31e9cc$export$efcdfad88a82dd6a.fullname,
        $3921efb06a31e9cc$export$19939eff078bb403.fullname,
        $3921efb06a31e9cc$export$30afbe17ad7d0402.fullname
    ].includes(t.fullname);
}
function $3921efb06a31e9cc$export$142173e695a3a13(t, o) {
    if (t.fullname === $3921efb06a31e9cc$export$e63caa28a27bc62e.fullname) return true;
    switch(typeof o){
        case "boolean":
            return t.fullname === $3921efb06a31e9cc$export$4b2f4351dd8f4737.fullname;
        case "string":
            return t.fullname === $3921efb06a31e9cc$export$36bbd56a39d3f734.fullname;
        case "function":
            return $3921efb06a31e9cc$export$f6e2535fb5126e54(t);
        case "number":
            return $3921efb06a31e9cc$var$isErasedToNumber(t);
        case "bigint":
            return $3921efb06a31e9cc$var$isErasedToBigInt(t);
        default:
            return t.construct != null && o instanceof t.construct;
    }
}
function $3921efb06a31e9cc$export$615e91928d222e7d(t) {
    return t.generics == null ? t : new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(t.fullname, t.generics.map(()=>$3921efb06a31e9cc$export$e63caa28a27bc62e));
}
function $3921efb06a31e9cc$export$1e17737c7179d31d(t) {
    return t.generics?.[0];
}
function $3921efb06a31e9cc$export$70a5d58ec00f3c11(t) {
    if ($3921efb06a31e9cc$export$9fc8c979231a883(t) && t.enumCases != null) return t.enumCases.map((kv)=>kv[1]);
    else throw new Error(`${t.fullname} is not an enum type`);
}
function $3921efb06a31e9cc$export$cd2722bb53d0bea8(t) {
    if ($3921efb06a31e9cc$export$9fc8c979231a883(t) && t.enumCases != null) return t.enumCases.map((kv)=>kv[0]);
    else throw new Error(`${t.fullname} is not an enum type`);
}
function $3921efb06a31e9cc$var$getEnumCase(t, v) {
    if (t.enumCases != null) {
        if (typeof v === "string") {
            for (const kv of t.enumCases){
                if (kv[0] === v) return kv;
            }
            throw new Error(`'${v}' was not found in ${t.fullname}`);
        } else {
            for (const kv of t.enumCases){
                if (kv[1] === v) return kv;
            }
            // .NET returns the number even if it doesn't match any of the cases
            return [
                "",
                v
            ];
        }
    } else throw new Error(`${t.fullname} is not an enum type`);
}
function $3921efb06a31e9cc$export$b5de0eeb63903617(t, str) {
    // TODO: better int parsing here, parseInt ceils floats: "4.8" -> 4
    const value = parseInt(str, 10);
    return $3921efb06a31e9cc$var$getEnumCase(t, isNaN(value) ? str : value)[1];
}
function $3921efb06a31e9cc$export$5fc9b63d26bd9368(t, str, defValue) {
    try {
        defValue.contents = $3921efb06a31e9cc$export$b5de0eeb63903617(t, str);
        return true;
    } catch  {
        return false;
    }
}
function $3921efb06a31e9cc$export$e1d90e20ad64402a(t, v) {
    return $3921efb06a31e9cc$var$getEnumCase(t, v)[0];
}
function $3921efb06a31e9cc$export$2190ecbdbd91c18b(t, v) {
    try {
        const kv = $3921efb06a31e9cc$var$getEnumCase(t, v);
        return kv[0] != null && kv[0] !== "";
    } catch  {
    // supress error
    }
    return false;
}
function $3921efb06a31e9cc$export$9842ee3eadac7211(t) {
    if (t.cases != null) return t.cases();
    else throw new Error(`${t.fullname} is not an F# union type`);
}
function $3921efb06a31e9cc$export$b0ab498daed3dd7f(t) {
    if (t.fields != null) return t.fields();
    else throw new Error(`${t.fullname} is not an F# record type`);
}
function $3921efb06a31e9cc$export$1f28650e18437653(t) {
    if ($3921efb06a31e9cc$export$62b73b2f8f623580(t) && t.generics != null) return t.generics;
    else throw new Error(`${t.fullname} is not a tuple type`);
}
function $3921efb06a31e9cc$export$5db3156b25539904(t) {
    if ($3921efb06a31e9cc$export$f6e2535fb5126e54(t) && t.generics != null) {
        const gen = t.generics;
        return [
            gen[0],
            gen[1]
        ];
    } else throw new Error(`${t.fullname} is not an F# function type`);
}
function $3921efb06a31e9cc$export$99587fd450e9f2d(t) {
    return t instanceof $3921efb06a31e9cc$export$f0c1fe746ce4bb1e ? t.cases != null : t instanceof (0, $eATN7.Union);
}
function $3921efb06a31e9cc$export$6ba840931da50680(t) {
    return t instanceof $3921efb06a31e9cc$export$f0c1fe746ce4bb1e ? t.fields != null : t instanceof (0, $eATN7.Record);
}
function $3921efb06a31e9cc$export$62b73b2f8f623580(t) {
    return t.fullname.startsWith("System.Tuple");
}
function $3921efb06a31e9cc$export$f6e2535fb5126e54(t) {
    return t.fullname === "Microsoft.FSharp.Core.FSharpFunc`2";
}
function $3921efb06a31e9cc$export$191ac0eced82ce46(v, t) {
    const cases = $3921efb06a31e9cc$export$9842ee3eadac7211(t);
    const case_ = cases[v.tag];
    if (case_ == null) throw new Error(`Cannot find case ${v.name} in union type`);
    return [
        case_,
        v.fields
    ];
}
function $3921efb06a31e9cc$export$309400f473e3880b(uci) {
    return uci.fields == null ? [] : uci.fields;
}
function $3921efb06a31e9cc$export$9e3a3700ce0b0b89(v) {
    return Object.keys(v).map((k)=>v[k]);
}
function $3921efb06a31e9cc$export$ba212be7256ab0fb(v, field) {
    return v[field[0]];
}
function $3921efb06a31e9cc$export$6e8639fe0290f3b5(v) {
    return v;
}
function $3921efb06a31e9cc$export$1a60394d1cea06d(v, i) {
    return v[i];
}
function $3921efb06a31e9cc$export$e56a6584f93e6957(uci, values) {
    const expectedLength = (uci.fields || []).length;
    if (values.length !== expectedLength) throw new Error(`Expected an array of length ${expectedLength} but got ${values.length}`);
    const construct = uci.declaringType.construct;
    if (construct == null) return {};
    const isSingleCase = uci.declaringType.cases ? uci.declaringType.cases().length == 1 : false;
    if (isSingleCase) return new construct(...values);
    else return new construct(uci.tag, values);
}
function $3921efb06a31e9cc$export$b58500a28530c18(t, values) {
    const fields = $3921efb06a31e9cc$export$b0ab498daed3dd7f(t);
    if (fields.length !== values.length) throw new Error(`Expected an array of length ${fields.length} but got ${values.length}`);
    return t.construct != null ? new t.construct(...values) : fields.reduce((obj, [key, _t], i)=>{
        obj[key] = values[i];
        return obj;
    }, {});
}
function $3921efb06a31e9cc$export$f3583c34ca02a326(values, _t) {
    return values;
}
function $3921efb06a31e9cc$export$89fe0430e2244c8d(t, generics) {
    return new $3921efb06a31e9cc$export$f0c1fe746ce4bb1e(t.fullname, generics, t.construct, t.parent, t.fields, t.cases);
}
function $3921efb06a31e9cc$export$99152e8d49ca4e7d(t, consArgs) {
    // TODO: Check if consArgs length is same as t.construct?
    // (Arg types can still be different)
    if (typeof t.construct === "function") return new t.construct(...consArgs ?? []);
    else if ($3921efb06a31e9cc$var$isErasedToNumber(t)) return 0;
    else if ($3921efb06a31e9cc$var$isErasedToBigInt(t)) return 0n;
    else switch(t.fullname){
        case $3921efb06a31e9cc$export$e63caa28a27bc62e.fullname:
            return {};
        case $3921efb06a31e9cc$export$4b2f4351dd8f4737.fullname:
            return false;
        case $3921efb06a31e9cc$export$71595c79c7738f26.fullname:
            return new (0, $fzAFM.default)(0);
        case $3921efb06a31e9cc$export$4b19e09c28c31d09.fullname:
            // Even though char is a value type, it's erased to string, and Unchecked.defaultof<char> is null
            return null;
        default:
            throw new Error(`Cannot access constructor of ${t.fullname}`);
    }
}
function $3921efb06a31e9cc$export$bf7199a9ebcb84a9(propertyInfo, v) {
    return v[propertyInfo[0]];
}
// Fable.Core.Reflection
function $3921efb06a31e9cc$var$assertUnion(x) {
    if (!(x instanceof (0, $eATN7.Union))) throw new Error(`Value is not an F# union type`);
}
function $3921efb06a31e9cc$export$2687ce0d4702ff61(x) {
    $3921efb06a31e9cc$var$assertUnion(x);
    return x.tag;
}
function $3921efb06a31e9cc$export$b1398297ef8fc3ed(x) {
    $3921efb06a31e9cc$var$assertUnion(x);
    return x.cases()[x.tag];
}
function $3921efb06a31e9cc$export$d42e393b18dfe5d3(x) {
    $3921efb06a31e9cc$var$assertUnion(x);
    return x.fields;
}



var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");
const $b5b450d1f3f8f266$var$CaseRules = {
    None: 0,
    LowerFirst: 1,
    SnakeCase: 2,
    SnakeCaseAllCaps: 3,
    KebabCase: 4
};
function $b5b450d1f3f8f266$var$dashify(str, separator) {
    return str.replace(/[a-z]?[A-Z]/g, (m)=>m.length === 1 ? m.toLowerCase() : m.charAt(0) + separator + m.charAt(1).toLowerCase());
}
function $b5b450d1f3f8f266$var$changeCase(str, caseRule) {
    switch(caseRule){
        case $b5b450d1f3f8f266$var$CaseRules.LowerFirst:
            return str.charAt(0).toLowerCase() + str.slice(1);
        case $b5b450d1f3f8f266$var$CaseRules.SnakeCase:
            return $b5b450d1f3f8f266$var$dashify(str, "_");
        case $b5b450d1f3f8f266$var$CaseRules.SnakeCaseAllCaps:
            return $b5b450d1f3f8f266$var$dashify(str, "_").toUpperCase();
        case $b5b450d1f3f8f266$var$CaseRules.KebabCase:
            return $b5b450d1f3f8f266$var$dashify(str, "-");
        case $b5b450d1f3f8f266$var$CaseRules.None:
        default:
            return str;
    }
}
function $b5b450d1f3f8f266$export$c0695a590b8490e7(fields, caseRule = $b5b450d1f3f8f266$var$CaseRules.None) {
    const obj = {};
    const definedCaseRule = caseRule;
    function fail(kvPair) {
        throw new Error("Cannot infer key and value of " + String(kvPair));
    }
    function assign(key, caseRule, value) {
        key = $b5b450d1f3f8f266$var$changeCase(key, caseRule);
        obj[key] = value;
    }
    for (let kvPair of fields){
        let caseRule = $b5b450d1f3f8f266$var$CaseRules.None;
        if (kvPair == null) fail(kvPair);
        // Deflate unions and use the defined case rule
        if (kvPair instanceof (0, $eATN7.Union)) {
            const name = kvPair.cases()[kvPair.tag];
            kvPair = kvPair.fields.length === 0 ? name : [
                name
            ].concat(kvPair.fields);
            caseRule = definedCaseRule;
        }
        if (Array.isArray(kvPair)) switch(kvPair.length){
            case 0:
                fail(kvPair);
                break;
            case 1:
                assign(kvPair[0], caseRule, true);
                break;
            case 2:
                const value = kvPair[1];
                assign(kvPair[0], caseRule, value);
                break;
            default:
                assign(kvPair[0], caseRule, kvPair.slice(1));
        }
        else if (typeof kvPair === "string") assign(kvPair, caseRule, true);
        else fail(kvPair);
    }
    return obj;
}
function $b5b450d1f3f8f266$export$ce913dab6077e540(v, map) {
    for (const kv of map){
        if ((0, $kRS0m.equals)(v, kv[1])) return true;
    }
    return false;
}
function $b5b450d1f3f8f266$export$8e0f4a40881f4a6f(map, key, defaultValue) {
    if (map.has(key)) {
        defaultValue.contents = map.get(key);
        return true;
    }
    return false;
}
function $b5b450d1f3f8f266$export$59d4ed6bef8b84dd(v, set) {
    if (set.has(v)) return false;
    set.add(v);
    return true;
}
function $b5b450d1f3f8f266$export$d01824481b25eb24(dict, k, v) {
    if (dict.has(k)) return false;
    dict.set(k, v);
    return true;
}
function $b5b450d1f3f8f266$export$640abc42af5f7b25(dict, k, v) {
    if (dict.has(k)) throw new Error("An item with the same key has already been added. Key: " + k);
    dict.set(k, v);
}
function $b5b450d1f3f8f266$export$6e0d12c66f82a152(map, key) {
    if (map.has(key)) return map.get(key);
    else throw new Error(`The given key '${key}' was not present in the dictionary.`);
}
function $b5b450d1f3f8f266$export$16aec5c5f74de970(map, key, createValue) {
    if (map.has(key)) return map.get(key);
    const value = createValue(key);
    map.set(key, value);
    return value;
}


function $0ef027050085b17b$export$1a35e60cc07e6f13(a_mut, b_mut) {
    Enum_bitSetOrder: while(true){
        const a = a_mut, b = b_mut;
        if (a === 0 ? true : b === 0) return (0, $kRS0m.comparePrimitives)(a, b) | 0;
        else {
            const c = (0, $kRS0m.comparePrimitives)(b & 1, a & 1) | 0;
            if (c === 0) {
                a_mut = a >> 1;
                b_mut = b >> 1;
                continue Enum_bitSetOrder;
            } else return c | 0;
        }
        break;
    }
}
function $0ef027050085b17b$export$8b3fd701061a25a6(defaultValue, mapping, _arg) {
    if (_arg == null) return defaultValue;
    else return mapping((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(_arg));
}
class $0ef027050085b17b$export$f450c8c8eb8ba019 extends (0, $eATN7.Union) {
    constructor(Item){
        super();
        this.tag = 0;
        this.fields = [
            Item
        ];
    }
    cases() {
        return [
            "ReadOnlyDictionary"
        ];
    }
}
function $0ef027050085b17b$export$ae6ba34b501c482e(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Table`2", [
        gen0,
        gen1
    ], $0ef027050085b17b$export$f450c8c8eb8ba019, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$8547d5acd31924e)("System.Collections.Generic.Dictionary`2", [
                        gen0,
                        gen1
                    ])
                ]
            ]
        ]);
}
function $0ef027050085b17b$export$715b664602a1d47c(dict, seq) {
    const enumerator = (0, $kRS0m.getEnumerator)(seq);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            dict.set(forLoopVar[0], forLoopVar[1]);
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return dict;
}
function $0ef027050085b17b$export$cc62f3272162c107(key, table) {
    if (table.fields[0].has(key)) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(table.fields[0], key));
    else return undefined;
}



var $kRS0m = parcelRequire("kRS0m");
/**
 * DateTimeOffset functions.
 *
 * Note: Date instances are always DateObjects in local
 * timezone (because JS dates are all kinds of messed up).
 * A local date returns UTC epoch when `.getTime()` is called.
 *
 * Basically; invariant: date.getTime() always return UTC time.
 */ 
var $c7lrN = parcelRequire("c7lrN");

var $kRS0m = parcelRequire("kRS0m");
const $6ed86d8a11a8516b$var$shortDays = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
const $6ed86d8a11a8516b$var$longDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $6ed86d8a11a8516b$var$shortMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $6ed86d8a11a8516b$var$longMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
function $6ed86d8a11a8516b$var$parseRepeatToken(format, pos, patternChar) {
    let tokenLength = 0;
    let internalPos = pos;
    while(internalPos < format.length && format[internalPos] === patternChar){
        internalPos++;
        tokenLength++;
    }
    return tokenLength;
}
function $6ed86d8a11a8516b$var$parseNextChar(format, pos) {
    if (pos >= format.length - 1) return -1;
    return format.charCodeAt(pos + 1);
}
function $6ed86d8a11a8516b$var$parseQuotedString(format, pos) {
    let beginPos = pos;
    // Get the character used to quote the string
    const quoteChar = format[pos];
    let result = "";
    let foundQuote = false;
    while(pos < format.length){
        pos++;
        const currentChar = format[pos];
        if (currentChar === quoteChar) {
            foundQuote = true;
            break;
        } else if (currentChar === "\\") {
            if (pos < format.length) {
                pos++;
                result += format[pos];
            } else // This means that '\' is the last character in the string.
            throw new Error("Invalid string format");
        } else result += currentChar;
    }
    if (!foundQuote) // We could not find the matching quote
    throw new Error(`Invalid string format could not find matching quote for ${quoteChar}`);
    return [
        result,
        pos - beginPos + 1
    ];
}
function $6ed86d8a11a8516b$var$dateToStringWithCustomFormat(date, format, utc) {
    let cursorPos = 0;
    let tokenLength = 0;
    let result = "";
    const localizedDate = utc ? $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), 1 /* DateKind.UTC */ ) : date;
    while(cursorPos < format.length){
        const token = format[cursorPos];
        switch(token){
            case "d":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "d");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$d2d39d1adcc883a2(localizedDate);
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$d2d39d1adcc883a2(localizedDate), 2);
                        break;
                    case 3:
                        result += $6ed86d8a11a8516b$var$shortDays[$6ed86d8a11a8516b$export$a24aefd2b69080a9(localizedDate)];
                        break;
                    case 4:
                        result += $6ed86d8a11a8516b$var$longDays[$6ed86d8a11a8516b$export$a24aefd2b69080a9(localizedDate)];
                        break;
                    default:
                        break;
                }
                break;
            case "f":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "f");
                cursorPos += tokenLength;
                if (tokenLength <= 3) {
                    const precision = 10 ** (3 - tokenLength);
                    result += (0, $kRS0m.padWithZeros)(Math.floor($6ed86d8a11a8516b$export$edc5e5cb87280477(localizedDate) / precision), tokenLength);
                } else if (tokenLength <= 7) // JavaScript Date only support precision to the millisecond
                // so we fill the rest of the precision with 0 as if the date didn't have
                // milliseconds provided to it.
                // This is to have the same behavior as .NET when doing:
                // DateTime(1, 2, 3, 4, 5, 6, DateTimeKind.Utc).ToString("fffff") => 00000
                result += ("" + $6ed86d8a11a8516b$export$edc5e5cb87280477(localizedDate)).padEnd(tokenLength, "0");
                break;
            case "F":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "F");
                cursorPos += tokenLength;
                if (tokenLength <= 3) {
                    const precision = 10 ** (3 - tokenLength);
                    const value = Math.floor($6ed86d8a11a8516b$export$edc5e5cb87280477(localizedDate) / precision);
                    if (value != 0) result += (0, $kRS0m.padWithZeros)(value, tokenLength);
                } else if (tokenLength <= 7) {
                    // JavaScript Date only support precision to the millisecond
                    // so we can't go beyond that.
                    // We also need to pad start with 0 if the value is not 0
                    const value = $6ed86d8a11a8516b$export$edc5e5cb87280477(localizedDate);
                    if (value != 0) result += (0, $kRS0m.padWithZeros)(value, 3);
                }
                break;
            case "g":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "g");
                cursorPos += tokenLength;
                if (tokenLength <= 2) result += "A.D.";
                break;
            case "h":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "h");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$842e383dfc19bc67(localizedDate) % 12;
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$842e383dfc19bc67(localizedDate) % 12, 2);
                        break;
                    default:
                        break;
                }
                break;
            case "H":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "H");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$842e383dfc19bc67(localizedDate);
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$842e383dfc19bc67(localizedDate), 2);
                        break;
                    default:
                        break;
                }
                break;
            case "K":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "K");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        switch($6ed86d8a11a8516b$export$78062f36b16ed2f8(localizedDate)){
                            case 1 /* DateKind.UTC */ :
                                result += "Z";
                                break;
                            case 2 /* DateKind.Local */ :
                                result += $6ed86d8a11a8516b$export$4dcf2a40c0851df0(localizedDate.getTimezoneOffset() * -60000);
                                break;
                            case 0 /* DateKind.Unspecified */ :
                                break;
                        }
                        break;
                    default:
                        break;
                }
                break;
            case "m":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "m");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$1cacba1045a8e790(localizedDate);
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$1cacba1045a8e790(localizedDate), 2);
                        break;
                    default:
                        break;
                }
                break;
            case "M":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "M");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$af5de1609f06c8e6(localizedDate);
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$af5de1609f06c8e6(localizedDate), 2);
                        break;
                    case 3:
                        result += $6ed86d8a11a8516b$var$shortMonths[$6ed86d8a11a8516b$export$af5de1609f06c8e6(localizedDate) - 1];
                        break;
                    case 4:
                        result += $6ed86d8a11a8516b$var$longMonths[$6ed86d8a11a8516b$export$af5de1609f06c8e6(localizedDate) - 1];
                        break;
                    default:
                        break;
                }
                break;
            case "s":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "s");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(localizedDate);
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)($6ed86d8a11a8516b$export$3d3c77ce7df7d30d(localizedDate), 2);
                        break;
                    default:
                        break;
                }
                break;
            case "t":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "t");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += localizedDate.getHours() < 12 ? "A" : "P";
                        break;
                    case 2:
                        result += localizedDate.getHours() < 12 ? "AM" : "PM";
                        break;
                    default:
                        break;
                }
                break;
            case "y":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "y");
                cursorPos += tokenLength;
                switch(tokenLength){
                    case 1:
                        result += localizedDate.getFullYear() % 100;
                        break;
                    case 2:
                        result += (0, $kRS0m.padWithZeros)(localizedDate.getFullYear() % 100, 2);
                        break;
                    case 3:
                        result += (0, $kRS0m.padWithZeros)(localizedDate.getFullYear(), 3);
                        break;
                    case 4:
                        result += (0, $kRS0m.padWithZeros)(localizedDate.getFullYear(), 4);
                        break;
                    case 5:
                        result += (0, $kRS0m.padWithZeros)(localizedDate.getFullYear(), 5);
                        break;
                    default:
                        break;
                }
                break;
            case "z":
                tokenLength = $6ed86d8a11a8516b$var$parseRepeatToken(format, cursorPos, "z");
                cursorPos += tokenLength;
                let utcOffsetText = "";
                switch($6ed86d8a11a8516b$export$78062f36b16ed2f8(localizedDate)){
                    case 1 /* DateKind.UTC */ :
                        utcOffsetText = "+00:00";
                        break;
                    case 2 /* DateKind.Local */ :
                        utcOffsetText = $6ed86d8a11a8516b$export$4dcf2a40c0851df0(localizedDate.getTimezoneOffset() * -60000);
                        break;
                    case 0 /* DateKind.Unspecified */ :
                        utcOffsetText = $6ed86d8a11a8516b$export$4dcf2a40c0851df0($6ed86d8a11a8516b$export$b96ad347bdf3bd16(localizedDate).getTimezoneOffset() * -60000);
                        break;
                }
                const sign = utcOffsetText[0] === "-" ? "-" : "+";
                const hours = parseInt(utcOffsetText.substring(1, 3), 10);
                const minutes = parseInt(utcOffsetText.substring(4, 6), 10);
                switch(tokenLength){
                    case 1:
                        result += `${sign}${hours}`;
                        break;
                    case 2:
                        result += `${sign}${(0, $kRS0m.padWithZeros)(hours, 2)}`;
                        break;
                    default:
                        result += `${sign}${(0, $kRS0m.padWithZeros)(hours, 2)}:${(0, $kRS0m.padWithZeros)(minutes, 2)}`;
                        break;
                }
                break;
            case ":":
                result += ":";
                cursorPos++;
                break;
            case "/":
                result += "/";
                cursorPos++;
                break;
            case "'":
            case '"':
                const [quotedString, quotedStringLenght] = $6ed86d8a11a8516b$var$parseQuotedString(format, cursorPos);
                result += quotedString;
                cursorPos += quotedStringLenght;
                break;
            case "%":
                const nextChar = $6ed86d8a11a8516b$var$parseNextChar(format, cursorPos);
                if (nextChar >= 0 && nextChar !== "%".charCodeAt(0)) {
                    cursorPos += 2;
                    result += $6ed86d8a11a8516b$var$dateToStringWithCustomFormat(localizedDate, String.fromCharCode(nextChar), utc);
                } else throw new Error("Invalid format string");
                break;
            case "\\":
                const nextChar2 = $6ed86d8a11a8516b$var$parseNextChar(format, cursorPos);
                if (nextChar2 >= 0) {
                    cursorPos += 2;
                    result += String.fromCharCode(nextChar2);
                } else throw new Error("Invalid format string");
                break;
            default:
                cursorPos++;
                result += token;
                break;
        }
    }
    return result;
}
function $6ed86d8a11a8516b$export$78062f36b16ed2f8(value) {
    return value.kind || 0;
}
function $6ed86d8a11a8516b$export$b04aee43a70c325e(ms, offset) {
    return (0, $c7lrN.toInt64)((BigInt(ms) + 62135596800000n + BigInt(offset)) * 10000n);
}
function $6ed86d8a11a8516b$export$2044bef34fee81ea(ticks) {
    return Number(BigInt(ticks) / 10000n - 62135596800000n);
}
function $6ed86d8a11a8516b$export$4dcf2a40c0851df0(offset) {
    const isMinus = offset < 0;
    offset = Math.abs(offset);
    const hours = ~~(offset / 3600000);
    const minutes = offset % 3600000 / 60000;
    return (isMinus ? "-" : "+") + (0, $kRS0m.padWithZeros)(hours, 2) + ":" + (0, $kRS0m.padWithZeros)(minutes, 2);
}
function $6ed86d8a11a8516b$export$44fcf6ab0130c000(date, half) {
    const str = date.toISOString();
    return half === "first" ? str.substring(0, str.indexOf("T")) : str.substring(str.indexOf("T") + 1, str.length - 1);
}
function $6ed86d8a11a8516b$var$dateToISOString(d, utc) {
    if (utc) return d.toISOString();
    else {
        // JS Date is always local
        const printOffset = d.kind == null ? true : d.kind === 2 /* DateKind.Local */ ;
        return (0, $kRS0m.padWithZeros)(d.getFullYear(), 4) + "-" + (0, $kRS0m.padWithZeros)(d.getMonth() + 1, 2) + "-" + (0, $kRS0m.padWithZeros)(d.getDate(), 2) + "T" + (0, $kRS0m.padWithZeros)(d.getHours(), 2) + ":" + (0, $kRS0m.padWithZeros)(d.getMinutes(), 2) + ":" + (0, $kRS0m.padWithZeros)(d.getSeconds(), 2) + "." + (0, $kRS0m.padWithZeros)(d.getMilliseconds(), 3) + (printOffset ? $6ed86d8a11a8516b$export$4dcf2a40c0851df0(d.getTimezoneOffset() * -60000) : "");
    }
}
function $6ed86d8a11a8516b$var$dateToISOStringWithOffset(dateWithOffset, offset) {
    const str = dateWithOffset.toISOString();
    return str.substring(0, str.length - 1) + $6ed86d8a11a8516b$export$4dcf2a40c0851df0(offset);
}
function $6ed86d8a11a8516b$var$dateToStringWithOffset(date, format) {
    const d = new Date(date.getTime() + (date.offset ?? 0));
    if (typeof format !== "string") return d.toISOString().replace(/\.\d+/, "").replace(/[A-Z]|\.\d+/g, " ") + $6ed86d8a11a8516b$export$4dcf2a40c0851df0(date.offset ?? 0);
    else if (format.length === 1) switch(format){
        case "D":
        case "d":
            return $6ed86d8a11a8516b$export$44fcf6ab0130c000(d, "first");
        case "T":
        case "t":
            return $6ed86d8a11a8516b$export$44fcf6ab0130c000(d, "second");
        case "O":
        case "o":
            return $6ed86d8a11a8516b$var$dateToISOStringWithOffset(d, date.offset ?? 0);
        default:
            throw new Error("Unrecognized Date print format");
    }
    else return $6ed86d8a11a8516b$var$dateToStringWithCustomFormat(d, format, true);
}
function $6ed86d8a11a8516b$var$dateToStringWithKind(date, format) {
    const utc = date.kind === 1 /* DateKind.UTC */ ;
    if (typeof format !== "string") return utc ? date.toUTCString() : date.toLocaleString();
    else if (format.length === 1) switch(format){
        case "D":
        case "d":
            return utc ? $6ed86d8a11a8516b$export$44fcf6ab0130c000(date, "first") : date.toLocaleDateString();
        case "T":
        case "t":
            return utc ? $6ed86d8a11a8516b$export$44fcf6ab0130c000(date, "second") : date.toLocaleTimeString();
        case "O":
        case "o":
            return $6ed86d8a11a8516b$var$dateToISOString(date, utc);
        default:
            throw new Error("Unrecognized Date print format");
    }
    else return $6ed86d8a11a8516b$var$dateToStringWithCustomFormat(date, format, utc);
}
function $6ed86d8a11a8516b$export$f84e8e69fd4488a5(date, format, _provider) {
    return date.offset != null ? $6ed86d8a11a8516b$var$dateToStringWithOffset(date, format) : $6ed86d8a11a8516b$var$dateToStringWithKind(date, format);
}
function $6ed86d8a11a8516b$export$82f9ebd9adeba146(value, kind) {
    const d = new Date(value);
    d.kind = (kind == null ? 0 /* DateKind.Unspecified */  : kind) | 0;
    return d;
}
function $6ed86d8a11a8516b$export$b4dd4c63617c9281(ticks, kind) {
    kind = kind != null ? kind : 2 /* DateKind.Local */ ; // better default than Unspecified
    let date = $6ed86d8a11a8516b$export$82f9ebd9adeba146($6ed86d8a11a8516b$export$2044bef34fee81ea(ticks), kind);
    // Ticks are local to offset (in this case, either UTC or Local/Unknown).
    // If kind is anything but UTC, that means that the tick number was not
    // in utc, thus getTime() cannot return UTC, and needs to be shifted.
    if (kind !== 1 /* DateKind.UTC */ ) date = $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime() - (0, $kRS0m.dateOffset)(date), kind);
    return date;
}
function $6ed86d8a11a8516b$export$e10d98d82915c35a(date, kind) {
    switch(kind){
        case 1 /* DateKind.UTC */ :
            return $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), 1 /* DateKind.UTC */ );
        case 2 /* DateKind.Local */ :
            return $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), 2 /* DateKind.Local */ );
        default:
            const d = $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime() + (date.offset ?? 0), kind);
            return $6ed86d8a11a8516b$export$82f9ebd9adeba146(d.getTime() - (0, $kRS0m.dateOffset)(d), kind);
    }
}
function $6ed86d8a11a8516b$export$3d27d42b1034de5c(date) {
    return $6ed86d8a11a8516b$export$b04aee43a70c325e(date.getTime(), (0, $kRS0m.dateOffset)(date));
}
function $6ed86d8a11a8516b$export$5805e19da86cbb3c() {
    // This is "0001-01-01T00:00:00.000Z", actual JS min value is -8640000000000000
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(-62135596800000, 1 /* DateKind.UTC */ );
}
function $6ed86d8a11a8516b$export$b9dc90d6499a9909() {
    // This is "9999-12-31T23:59:59.999Z", actual JS max value is 8640000000000000
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(253402300799999, 1 /* DateKind.UTC */ );
}
function $6ed86d8a11a8516b$export$a6658d265f3f7695(input) {
    function fail() {
        throw new Error(`The string is not a valid Date: ${input}`);
    }
    if (input == null || input.trim() === "") fail();
    // ISO dates without TZ are parsed as UTC. Adding time without TZ keeps them local.
    if (input.length === 10 && input[4] === "-" && input[7] === "-") input += "T00:00:00";
    let date = new Date(input);
    let offset = null;
    if (isNaN(date.getTime())) {
        // Try to check strings JS Date cannot parse (see #1045, #1422)
        const m = /^\s*(\d+[^\w\s:]\d+[^\w\s:]\d+)?\s*(\d+:\d+(?::\d+(?:\.\d+)?)?)?\s*([AaPp][Mm])?\s*(Z|[+-]([01]?\d):?([0-5]?\d)?)?\s*$/.exec(input);
        if (m != null) {
            let baseDate;
            let timeInSeconds = 0;
            if (m[2] != null) {
                const timeParts = m[2].split(":");
                const hourPart = parseInt(timeParts[0], 10);
                timeInSeconds = hourPart * 3600 + parseInt(timeParts[1] || "0", 10) * 60 + parseFloat(timeParts[2] || "0");
                if (m[3] != null && m[3].toUpperCase() === "PM" && hourPart < 12) timeInSeconds += 720;
            }
            if (m[4] != null) {
                if (m[1] != null) baseDate = new Date(m[1] + " UTC");
                else {
                    const d = new Date();
                    baseDate = new Date(d.getUTCFullYear() + "/" + (d.getUTCMonth() + 1) + "/" + d.getUTCDate());
                }
                if (m[4] === "Z") offset = "Z";
                else {
                    let offsetInMinutes = parseInt(m[5], 10) * 60 + parseInt(m[6] || "0", 10);
                    if (m[4][0] === "-") offsetInMinutes *= -1;
                    offset = offsetInMinutes;
                    timeInSeconds -= offsetInMinutes * 60;
                }
            } else if (m[1] != null) baseDate = new Date(m[1]);
            else {
                const d = new Date();
                baseDate = new Date(d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate());
            }
            date = new Date(baseDate.getTime() + timeInSeconds * 1000);
            // correct for daylight savings time
            date = new Date(date.getTime() + (date.getTimezoneOffset() - baseDate.getTimezoneOffset()) * 60000);
        } else fail();
        // Check again the date is valid after transformations, see #2229
        if (isNaN(date.getTime())) fail();
    }
    return [
        date,
        offset
    ];
}
function $6ed86d8a11a8516b$export$98e6a39c04603d36(str, detectUTC = false) {
    const [date, offset] = $6ed86d8a11a8516b$export$a6658d265f3f7695(str);
    // .NET always parses DateTime as Local if there's offset info (even "Z")
    // Newtonsoft.Json uses UTC if the offset is "Z"
    const kind = offset != null ? detectUTC && offset === "Z" ? 1 /* DateKind.UTC */  : 2 /* DateKind.Local */  : 0 /* DateKind.Unspecified */ ;
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), kind);
}
function $6ed86d8a11a8516b$export$468ff95b83d315e5(v, defValue) {
    try {
        defValue.contents = $6ed86d8a11a8516b$export$98e6a39c04603d36(v);
        return true;
    } catch (_err) {
        return false;
    }
}
function $6ed86d8a11a8516b$export$185802fd694ee1f5(year, month, day, h = 0, m = 0, s = 0, ms = 0, kind) {
    const date = kind === 1 /* DateKind.UTC */  ? new Date(Date.UTC(year, month - 1, day, h, m, s, ms)) : new Date(year, month - 1, day, h, m, s, ms);
    if (year <= 99) {
        if (kind === 1 /* DateKind.UTC */ ) date.setUTCFullYear(year, month - 1, day);
        else date.setFullYear(year, month - 1, day);
    }
    const dateValue = date.getTime();
    if (isNaN(dateValue)) throw new Error("The parameters describe an unrepresentable Date.");
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(dateValue, kind);
}
function $6ed86d8a11a8516b$export$461939dd4422153() {
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(Date.now(), 2 /* DateKind.Local */ );
}
function $6ed86d8a11a8516b$export$a56f095995763cca() {
    return $6ed86d8a11a8516b$export$82f9ebd9adeba146(Date.now(), 1 /* DateKind.UTC */ );
}
function $6ed86d8a11a8516b$export$d0bdf45af03a6ea3() {
    return $6ed86d8a11a8516b$export$324d90190a8b822a($6ed86d8a11a8516b$export$461939dd4422153());
}
function $6ed86d8a11a8516b$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function $6ed86d8a11a8516b$export$4169ecd548fbc13a(year, month) {
    return month === 2 ? $6ed86d8a11a8516b$export$553d7fa8e3805fc0(year) ? 29 : 28 : month >= 8 ? month % 2 === 0 ? 31 : 30 : month % 2 === 0 ? 30 : 31;
}
function $6ed86d8a11a8516b$export$3230e995afdc9bec(date) {
    return date.kind === 1 /* DateKind.UTC */  ? date : $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), 1 /* DateKind.UTC */ );
}
function $6ed86d8a11a8516b$export$b96ad347bdf3bd16(date) {
    return date.kind === 2 /* DateKind.Local */  ? date : $6ed86d8a11a8516b$export$82f9ebd9adeba146(date.getTime(), 2 /* DateKind.Local */ );
}
function $6ed86d8a11a8516b$export$5289b38f662a812a(d, kind) {
    return $6ed86d8a11a8516b$export$185802fd694ee1f5($6ed86d8a11a8516b$export$31803937850fb2da(d), $6ed86d8a11a8516b$export$af5de1609f06c8e6(d), $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d), $6ed86d8a11a8516b$export$842e383dfc19bc67(d), $6ed86d8a11a8516b$export$1cacba1045a8e790(d), $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(d), $6ed86d8a11a8516b$export$edc5e5cb87280477(d), kind);
}
function $6ed86d8a11a8516b$export$54a89be6af0881dc(d) {
    return $6ed86d8a11a8516b$export$842e383dfc19bc67(d) * 3600000 + $6ed86d8a11a8516b$export$1cacba1045a8e790(d) * 60000 + $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(d) * 1000 + $6ed86d8a11a8516b$export$edc5e5cb87280477(d);
}
function $6ed86d8a11a8516b$export$324d90190a8b822a(d) {
    return $6ed86d8a11a8516b$export$185802fd694ee1f5($6ed86d8a11a8516b$export$31803937850fb2da(d), $6ed86d8a11a8516b$export$af5de1609f06c8e6(d), $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d), 0, 0, 0, 0, d.kind);
}
function $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCDate() : d.getDate();
}
function $6ed86d8a11a8516b$export$842e383dfc19bc67(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCHours() : d.getHours();
}
function $6ed86d8a11a8516b$export$edc5e5cb87280477(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCMilliseconds() : d.getMilliseconds();
}
function $6ed86d8a11a8516b$export$1cacba1045a8e790(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCMinutes() : d.getMinutes();
}
function $6ed86d8a11a8516b$export$af5de1609f06c8e6(d) {
    return (d.kind === 1 /* DateKind.UTC */  ? d.getUTCMonth() : d.getMonth()) + 1;
}
function $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCSeconds() : d.getSeconds();
}
function $6ed86d8a11a8516b$export$31803937850fb2da(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCFullYear() : d.getFullYear();
}
function $6ed86d8a11a8516b$export$a24aefd2b69080a9(d) {
    return d.kind === 1 /* DateKind.UTC */  ? d.getUTCDay() : d.getDay();
}
function $6ed86d8a11a8516b$export$75898a44428fae85(d) {
    const _year = $6ed86d8a11a8516b$export$31803937850fb2da(d);
    const _month = $6ed86d8a11a8516b$export$af5de1609f06c8e6(d);
    let _day = $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d);
    for(let i = 1; i < _month; i++)_day += $6ed86d8a11a8516b$export$4169ecd548fbc13a(_year, i);
    return _day;
}
function $6ed86d8a11a8516b$export$e16d8520af44a096(d, ts) {
    const newDate = $6ed86d8a11a8516b$export$82f9ebd9adeba146(d.getTime() + ts, d.kind);
    if (d.kind !== 1 /* DateKind.UTC */ ) {
        const oldTzOffset = d.getTimezoneOffset();
        const newTzOffset = newDate.getTimezoneOffset();
        return oldTzOffset !== newTzOffset ? $6ed86d8a11a8516b$export$82f9ebd9adeba146(newDate.getTime() + (newTzOffset - oldTzOffset) * 60000, d.kind) : newDate;
    } else return newDate;
}
function $6ed86d8a11a8516b$export$dd412b56f1e4d8aa(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, v * 86400000);
}
function $6ed86d8a11a8516b$export$4a4306ad4fa0e5e6(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, v * 3600000);
}
function $6ed86d8a11a8516b$export$2287e3d29250119e(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, v * 60000);
}
function $6ed86d8a11a8516b$export$3cb31b0df13be68(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, v * 1000);
}
function $6ed86d8a11a8516b$export$baf757aaf0c95c94(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, v);
}
function $6ed86d8a11a8516b$export$84f156599067de34(d, v) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(d, (0, $c7lrN.toFloat64)(v / 10000n));
}
function $6ed86d8a11a8516b$export$3d83eec43f4ea476(d, v) {
    const newMonth = $6ed86d8a11a8516b$export$af5de1609f06c8e6(d);
    const newYear = $6ed86d8a11a8516b$export$31803937850fb2da(d) + v;
    const _daysInMonth = $6ed86d8a11a8516b$export$4169ecd548fbc13a(newYear, newMonth);
    const newDay = Math.min(_daysInMonth, $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d));
    return $6ed86d8a11a8516b$export$185802fd694ee1f5(newYear, newMonth, newDay, $6ed86d8a11a8516b$export$842e383dfc19bc67(d), $6ed86d8a11a8516b$export$1cacba1045a8e790(d), $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(d), $6ed86d8a11a8516b$export$edc5e5cb87280477(d), d.kind);
}
function $6ed86d8a11a8516b$export$17c93e242b2d3a22(d, v) {
    let newMonth = $6ed86d8a11a8516b$export$af5de1609f06c8e6(d) + v;
    let newMonth_ = 0;
    let yearOffset = 0;
    if (newMonth > 12) {
        newMonth_ = newMonth % 12;
        yearOffset = Math.floor(newMonth / 12);
        newMonth = newMonth_;
    } else if (newMonth < 1) {
        newMonth_ = 12 + newMonth % 12;
        yearOffset = Math.floor(newMonth / 12) + (newMonth_ === 12 ? -1 : 0);
        newMonth = newMonth_;
    }
    const newYear = $6ed86d8a11a8516b$export$31803937850fb2da(d) + yearOffset;
    const _daysInMonth = $6ed86d8a11a8516b$export$4169ecd548fbc13a(newYear, newMonth);
    const newDay = Math.min(_daysInMonth, $6ed86d8a11a8516b$export$d2d39d1adcc883a2(d));
    return $6ed86d8a11a8516b$export$185802fd694ee1f5(newYear, newMonth, newDay, $6ed86d8a11a8516b$export$842e383dfc19bc67(d), $6ed86d8a11a8516b$export$1cacba1045a8e790(d), $6ed86d8a11a8516b$export$3d3c77ce7df7d30d(d), $6ed86d8a11a8516b$export$edc5e5cb87280477(d), d.kind);
}
function $6ed86d8a11a8516b$export$4e2d2ead65e5f7e3(d, that) {
    return typeof that === "number" ? $6ed86d8a11a8516b$export$e16d8520af44a096(d, -that) : d.getTime() - that.getTime();
}
function $6ed86d8a11a8516b$export$c72df26d2bb0681f(d) {
    return d.toDateString();
}
function $6ed86d8a11a8516b$export$ed29312e46cde58f(d) {
    return d.toLocaleDateString();
}
function $6ed86d8a11a8516b$export$f45b9f9645a703d3(d) {
    return d.toLocaleTimeString();
}
function $6ed86d8a11a8516b$export$9384d167e08fd225(d) {
    return d.toLocaleTimeString().replace(/:\d\d(?!:)/, "");
}
function $6ed86d8a11a8516b$export$e9bab7fafb253603(d1, d2) {
    return d1.getTime() === d2.getTime();
}
const $6ed86d8a11a8516b$export$398604a469f7de9a = (0, $kRS0m.compareDates);
const $6ed86d8a11a8516b$export$53576907a5c40ba3 = (0, $kRS0m.compareDates);
function $6ed86d8a11a8516b$export$a5fb1fdca49990a(x, y) {
    return $6ed86d8a11a8516b$export$e16d8520af44a096(x, y);
}
function $6ed86d8a11a8516b$export$1ba572a54983744c(x, y) {
    return $6ed86d8a11a8516b$export$4e2d2ead65e5f7e3(x, y);
}
function $6ed86d8a11a8516b$export$22d85042c308f25c(x) {
    const jan = new Date(x.getFullYear(), 0, 1);
    const jul = new Date(x.getFullYear(), 6, 1);
    return $6ed86d8a11a8516b$var$isDST(jan.getTimezoneOffset(), jul.getTimezoneOffset(), x.getTimezoneOffset());
}
function $6ed86d8a11a8516b$var$isDST(janOffset, julOffset, tOffset) {
    return Math.min(janOffset, julOffset) === tOffset;
}
var $6ed86d8a11a8516b$export$2e2bcd8739ae039 = $6ed86d8a11a8516b$export$82f9ebd9adeba146;



var $5OTL5 = parcelRequire("5OTL5");
function $9879a22dc3fb544d$export$185802fd694ee1f5(pattern, options = 0) {
    // Supported RegexOptions
    // * IgnoreCase:  0x0001
    // * Multiline:   0x0002
    // * Compiled:    0x0008 (ignored)
    // * Singleline:  0x0010
    // * ECMAScript:  0x0100 (ignored)
    if ((options & -284) !== 0) throw new Error("RegexOptions only supports: IgnoreCase, Multiline, Compiled, Singleline and ECMAScript");
    // Set always global and unicode flags for compatibility with dotnet, see #2925
    let flags = "gu";
    flags += options & 1 ? "i" : ""; // 0x0001 RegexOptions.IgnoreCase
    flags += options & 2 ? "m" : "";
    flags += options & 16 ? "s" : "";
    return new RegExp(pattern, flags);
}
function $9879a22dc3fb544d$export$4e7f196112fea3c5(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
function $9879a22dc3fb544d$export$e8bacd2802a88316(str) {
    return str.replace(/\\([\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|])/g, "$1");
}
function $9879a22dc3fb544d$export$b74c33566721f70f(reg, input, startAt = 0) {
    reg.lastIndex = startAt;
    return reg.test(input);
}
function $9879a22dc3fb544d$export$4659b591c19bdf3d(reg, input, startAt = 0) {
    reg.lastIndex = startAt;
    return reg.exec(input);
}
function $9879a22dc3fb544d$export$de994efd351b291c(reg, input, startAt = 0) {
    if (input == null) throw new Error("Input cannot ve null");
    if (!reg.global) throw new Error("Non-global RegExp"); // Prevent infinite loop
    reg.lastIndex = startAt;
    const matches1 = [];
    let m;
    let lastMatchIndex = -1;
    while((m = reg.exec(input)) != null)// It can happen even global regex get stuck, see #2845
    if (m.index === lastMatchIndex) reg.lastIndex++;
    else {
        lastMatchIndex = m.index;
        matches1.push(m);
    }
    return matches1;
}
function $9879a22dc3fb544d$export$41c562ebe57d11e2(reg) {
    let options = 256; // ECMAScript
    options |= reg.ignoreCase ? 1 : 0;
    options |= reg.multiline ? 2 : 0;
    return options;
}
function $9879a22dc3fb544d$export$77ad94ebf1c2b9ed(reg, input, replacement, limit, offset = 0) {
    function replacer() {
        let res = arguments[0];
        if (limit) {
            limit--;
            const match = [];
            const len = arguments.length;
            // arguments: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_function_as_a_parameter
            // * match: matched substring
            // * p1, p2, ...: nth capture group string
            // * offset: offset of matched substring
            // * string: whole string examined
            // * groups: named capturing groups
            //           ONLY if regex contains a named capture group AND browser supports named groups
            // -> last element can be groups OR input string
            // -> check if last element is string
            const withGroups = typeof arguments[len - 1] !== "string";
            let pLast = withGroups ? len - 3 : len - 2;
            for(let i = 0; i < pLast; i++)match.push(arguments[i]);
            match.index = arguments[pLast++];
            match.input = arguments[pLast++];
            if (withGroups) match.groups = arguments[pLast];
            res = replacement(match);
        }
        return res;
    }
    if (typeof reg === "string") {
        const tmp = reg;
        reg = $9879a22dc3fb544d$export$185802fd694ee1f5(input, limit ?? 0);
        input = tmp;
        limit = undefined;
    }
    if (typeof replacement === "function") {
        limit = limit == null ? -1 : limit;
        return input.substring(0, offset) + input.substring(offset).replace(reg, replacer);
    } else {
        replacement = replacement// $0 doesn't work with JS regex, see #1155
        .replace(/\$0/g, (_s)=>"$&")// named groups in replacement are `${name}` in .Net, but `$<name>` in JS (in regex: groups are `(?<name>...)` in both)
        .replace(/\${([^}]+)}/g, "\$<$1>");
        if (limit != null) {
            let m;
            const sub1 = input.substring(offset);
            const _matches = $9879a22dc3fb544d$export$de994efd351b291c(reg, sub1);
            const sub2 = $9879a22dc3fb544d$export$de994efd351b291c.length > limit ? (m = _matches[limit - 1], sub1.substring(0, m.index + m[0].length)) : sub1;
            return input.substring(0, offset) + sub2.replace(reg, replacement) + input.substring(offset + sub2.length);
        } else return input.replace(reg, replacement);
    }
}
function $9879a22dc3fb544d$export$65980d18b75784e2(reg, input, limit, offset = 0) {
    if (typeof reg === "string") {
        const tmp = reg;
        reg = $9879a22dc3fb544d$export$185802fd694ee1f5(input, limit ?? 0);
        input = tmp;
        limit = undefined;
    }
    input = input.substring(offset);
    return input.split(reg, limit);
}



var $eATN7 = parcelRequire("eATN7");
const $7802b3aa01031554$var$fsFormatRegExp = /(^|[^%])%([0+\- ]*)(\*|\d+)?(?:\.(\d+))?(\w)/g;
const $7802b3aa01031554$var$interpolateRegExp = /(?:(^|[^%])%([0+\- ]*)(\d+)?(?:\.(\d+))?(\w))?%P\(\)/g;
const $7802b3aa01031554$var$formatRegExp = /\{(\d+)(,-?\d+)?(?:\:([a-zA-Z])(\d{0,2})|\:(.+?))?\}/g;
function $7802b3aa01031554$var$isLessThan(x, y) {
    return (0, $5OTL5.compare)(x, y) < 0;
}
function $7802b3aa01031554$var$cmp(x, y, ic) {
    function isIgnoreCase(i) {
        return i === true || i === 1 /* StringComparison.CurrentCultureIgnoreCase */  || i === 3 /* StringComparison.InvariantCultureIgnoreCase */  || i === 5 /* StringComparison.OrdinalIgnoreCase */ ;
    }
    function isOrdinal(i) {
        return i === 4 /* StringComparison.Ordinal */  || i === 5 /* StringComparison.OrdinalIgnoreCase */ ;
    }
    if (x == null) return y == null ? 0 : -1;
    if (y == null) return 1;
     // everything is bigger than null
    if (isOrdinal(ic)) {
        if (isIgnoreCase(ic)) {
            x = x.toLowerCase();
            y = y.toLowerCase();
        }
        return x === y ? 0 : x < y ? -1 : 1;
    } else {
        if (isIgnoreCase(ic)) {
            x = x.toLocaleLowerCase();
            y = y.toLocaleLowerCase();
        }
        return x.localeCompare(y);
    }
}
function $7802b3aa01031554$export$398604a469f7de9a(...args) {
    switch(args.length){
        case 2:
            return $7802b3aa01031554$var$cmp(args[0], args[1], false);
        case 3:
            return $7802b3aa01031554$var$cmp(args[0], args[1], args[2]);
        case 4:
            return $7802b3aa01031554$var$cmp(args[0], args[1], args[2] === true);
        case 5:
            return $7802b3aa01031554$var$cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), false);
        case 6:
            return $7802b3aa01031554$var$cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), args[5]);
        case 7:
            return $7802b3aa01031554$var$cmp(args[0].substr(args[1], args[4]), args[2].substr(args[3], args[4]), args[5] === true);
        default:
            throw new Error("String.compare: Unsupported number of parameters");
    }
}
function $7802b3aa01031554$export$bfd84690a68064b1(x, y) {
    return $7802b3aa01031554$var$cmp(x, y, 4 /* StringComparison.Ordinal */ );
}
function $7802b3aa01031554$export$53576907a5c40ba3(x, y) {
    return $7802b3aa01031554$var$cmp(x, y, 0 /* StringComparison.CurrentCulture */ );
}
function $7802b3aa01031554$export$68326237475e9a7d(str, pattern, ic) {
    if (ic === 4 /* StringComparison.Ordinal */ ) return str.startsWith(pattern);
    if (str.length >= pattern.length) return $7802b3aa01031554$var$cmp(str.substr(0, pattern.length), pattern, ic) === 0;
    return false;
}
function $7802b3aa01031554$export$10fdab3683b55b22(str, pattern, ic) {
    if (ic === 4 /* StringComparison.Ordinal */ ) return str.endsWith(pattern);
    if (str.length >= pattern.length) return $7802b3aa01031554$var$cmp(str.substr(str.length - pattern.length, pattern.length), pattern, ic) === 0;
    return false;
}
function $7802b3aa01031554$export$3ce79d7714e5c4aa(str, anyOf, ...args) {
    if (str == null || str === "") return -1;
    const startIndex = args.length > 0 ? args[0] : 0;
    if (startIndex < 0) throw new Error("Start index cannot be negative");
    const length = args.length > 1 ? args[1] : str.length - startIndex;
    if (length < 0) throw new Error("Length cannot be negative");
    if (startIndex + length > str.length) throw new Error("Invalid startIndex and length");
    const endIndex = startIndex + length;
    const anyOfAsStr = "".concat.apply("", anyOf);
    for(let i = startIndex; i < endIndex; i++){
        if (anyOfAsStr.indexOf(str[i]) > -1) return i;
    }
    return -1;
}
function $7802b3aa01031554$export$d1317194012d6b34(input) {
    return {
        input: input,
        cont: $7802b3aa01031554$export$214f04bcc4009507(input)
    };
}
function $7802b3aa01031554$export$89e29e4ab65e70a9(str, values) {
    let valIdx = 0;
    let strIdx = 0;
    let result = "";
    $7802b3aa01031554$var$interpolateRegExp.lastIndex = 0;
    let match = $7802b3aa01031554$var$interpolateRegExp.exec(str);
    while(match){
        // The first group corresponds to the no-escape char (^|[^%]), the actual pattern starts in the next char
        // Note: we don't use negative lookbehind because some browsers don't support it yet
        const matchIndex = match.index + (match[1] || "").length;
        result += str.substring(strIdx, matchIndex).replace(/%%/g, "%");
        const [, , flags, padLength, precision, format] = match;
        // Save interpolateRegExp.lastIndex before running formatReplacement because the values
        // may also involve interpolation and make use of interpolateRegExp (see #3078)
        strIdx = $7802b3aa01031554$var$interpolateRegExp.lastIndex;
        result += $7802b3aa01031554$var$formatReplacement(values[valIdx++], flags, padLength, precision, format);
        // Move interpolateRegExp.lastIndex one char behind to make sure we match the no-escape char next time
        $7802b3aa01031554$var$interpolateRegExp.lastIndex = strIdx - 1;
        match = $7802b3aa01031554$var$interpolateRegExp.exec(str);
    }
    result += str.substring(strIdx).replace(/%%/g, "%");
    return result;
}
function $7802b3aa01031554$var$continuePrint(cont, arg) {
    return typeof arg === "string" ? cont(arg) : arg.cont(cont);
}
function $7802b3aa01031554$export$3de07bdccee76bc5(arg) {
    // Don't remove the lambda here, see #1357
    return $7802b3aa01031554$var$continuePrint((x)=>console.log(x), arg);
}
function $7802b3aa01031554$export$457e5164de7d35a2(arg) {
    return $7802b3aa01031554$var$continuePrint((x)=>console.error(x), arg);
}
function $7802b3aa01031554$export$598ff36d54604b81(arg) {
    return $7802b3aa01031554$var$continuePrint((x)=>x, arg);
}
function $7802b3aa01031554$export$c5eda7bb099ceb11(arg) {
    return $7802b3aa01031554$var$continuePrint((x)=>{
        throw new Error(x);
    }, arg);
}
function $7802b3aa01031554$var$formatReplacement(rep, flags, padLength, precision, format) {
    let sign = "";
    flags = flags || "";
    format = format || "";
    if ((0, $5OTL5.isNumeric)(rep)) {
        if (format.toLowerCase() !== "x") {
            if ($7802b3aa01031554$var$isLessThan(rep, 0)) {
                rep = (0, $5OTL5.multiply)(rep, -1);
                sign = "-";
            } else {
                if (flags.indexOf(" ") >= 0) sign = " ";
                else if (flags.indexOf("+") >= 0) sign = "+";
            }
        }
        precision = precision == null ? null : parseInt(precision, 10);
        switch(format){
            case "f":
            case "F":
                precision = precision != null ? precision : 6;
                rep = (0, $5OTL5.toFixed)(rep, precision);
                break;
            case "g":
            case "G":
                rep = precision != null ? (0, $5OTL5.toPrecision)(rep, precision) : (0, $5OTL5.toPrecision)(rep);
                break;
            case "e":
            case "E":
                rep = precision != null ? (0, $5OTL5.toExponential)(rep, precision) : (0, $5OTL5.toExponential)(rep);
                break;
            case "x":
                rep = (0, $5OTL5.toHex)(rep);
                break;
            case "X":
                rep = (0, $5OTL5.toHex)(rep).toUpperCase();
                break;
            default:
                rep = String(rep);
                break;
        }
    } else if (rep instanceof Date) rep = (0, $6ed86d8a11a8516b$export$f84e8e69fd4488a5)(rep);
    else rep = (0, $eATN7.toString)(rep);
    padLength = typeof padLength === "number" ? padLength : parseInt(padLength, 10);
    if (!isNaN(padLength)) {
        const zeroFlag = flags.indexOf("0") >= 0; // Use '0' for left padding
        const minusFlag = flags.indexOf("-") >= 0; // Right padding
        const ch = minusFlag || !zeroFlag ? " " : "0";
        if (ch === "0") {
            rep = $7802b3aa01031554$var$pad(rep, padLength - sign.length, ch, minusFlag);
            rep = sign + rep;
        } else rep = $7802b3aa01031554$var$pad(sign + rep, padLength, ch, minusFlag);
    } else rep = sign + rep;
    return rep;
}
function $7802b3aa01031554$var$createPrinter(cont, _strParts, _matches, _result = "", padArg = -1) {
    return (...args)=>{
        // Make copies of the values passed by reference because the function can be used multiple times
        let result = _result;
        const strParts = _strParts.slice();
        const matches = _matches.slice();
        for (const arg of args){
            const [, , flags, _padLength, precision, format] = matches[0];
            let padLength = _padLength;
            if (padArg >= 0) {
                padLength = padArg;
                padArg = -1;
            } else if (padLength === "*") {
                if (arg < 0) throw new Error("Non-negative number required");
                padArg = arg;
                continue;
            }
            result += strParts[0];
            result += $7802b3aa01031554$var$formatReplacement(arg, flags, padLength, precision, format);
            strParts.splice(0, 1);
            matches.splice(0, 1);
        }
        if (matches.length === 0) {
            result += strParts[0];
            return cont(result);
        } else return $7802b3aa01031554$var$createPrinter(cont, strParts, matches, result, padArg);
    };
}
function $7802b3aa01031554$export$214f04bcc4009507(str) {
    return (cont)=>{
        $7802b3aa01031554$var$fsFormatRegExp.lastIndex = 0;
        const strParts = [];
        const matches = [];
        let strIdx = 0;
        let match = $7802b3aa01031554$var$fsFormatRegExp.exec(str);
        while(match){
            // The first group corresponds to the no-escape char (^|[^%]), the actual pattern starts in the next char
            // Note: we don't use negative lookbehind because some browsers don't support it yet
            const matchIndex = match.index + (match[1] || "").length;
            strParts.push(str.substring(strIdx, matchIndex).replace(/%%/g, "%"));
            matches.push(match);
            strIdx = $7802b3aa01031554$var$fsFormatRegExp.lastIndex;
            // Likewise we need to move fsFormatRegExp.lastIndex one char behind to make sure we match the no-escape char next time
            $7802b3aa01031554$var$fsFormatRegExp.lastIndex -= 1;
            match = $7802b3aa01031554$var$fsFormatRegExp.exec(str);
        }
        if (strParts.length === 0) return cont(str.replace(/%%/g, "%"));
        else {
            strParts.push(str.substring(strIdx).replace(/%%/g, "%"));
            return $7802b3aa01031554$var$createPrinter(cont, strParts, matches);
        }
    };
}
function $7802b3aa01031554$export$d9468344d3651243(str, ...args) {
    let str2;
    if (typeof str === "object") {
        // Called with culture info
        str2 = String(args[0]);
        args.shift();
    } else str2 = str;
    return str2.replace($7802b3aa01031554$var$formatRegExp, (_, idx, padLength, format, precision, pattern)=>{
        if (idx < 0 || idx >= args.length) throw new Error("Index must be greater or equal to zero and less than the arguments' length.");
        let rep = args[idx];
        if ((0, $5OTL5.isNumeric)(rep)) {
            precision = precision == null ? null : parseInt(precision, 10);
            switch(format){
                case "f":
                case "F":
                    precision = precision != null ? precision : 2;
                    rep = (0, $5OTL5.toFixed)(rep, precision);
                    break;
                case "g":
                case "G":
                    rep = precision != null ? (0, $5OTL5.toPrecision)(rep, precision) : (0, $5OTL5.toPrecision)(rep);
                    break;
                case "e":
                case "E":
                    rep = precision != null ? (0, $5OTL5.toExponential)(rep, precision) : (0, $5OTL5.toExponential)(rep);
                    break;
                case "p":
                case "P":
                    precision = precision != null ? precision : 2;
                    rep = (0, $5OTL5.toFixed)((0, $5OTL5.multiply)(rep, 100), precision) + " %";
                    break;
                case "d":
                case "D":
                    rep = precision != null ? $7802b3aa01031554$export$bc3bea8325045070(String(rep), precision, "0") : String(rep);
                    break;
                case "x":
                case "X":
                    rep = precision != null ? $7802b3aa01031554$export$bc3bea8325045070((0, $5OTL5.toHex)(rep), precision, "0") : (0, $5OTL5.toHex)(rep);
                    if (format === "X") rep = rep.toUpperCase();
                    break;
                default:
                    if (pattern) {
                        let sign = "";
                        rep = pattern.replace(/([0#,]+)(\.[0#]+)?/, (_, intPart, decimalPart)=>{
                            if ($7802b3aa01031554$var$isLessThan(rep, 0)) {
                                rep = (0, $5OTL5.multiply)(rep, -1);
                                sign = "-";
                            }
                            decimalPart = decimalPart == null ? "" : decimalPart.substring(1);
                            rep = (0, $5OTL5.toFixed)(rep, Math.max(decimalPart.length, 0));
                            let [repInt, repDecimal] = rep.split(".");
                            repDecimal || (repDecimal = "");
                            const leftZeroes = intPart.replace(/,/g, "").replace(/^#+/, "").length;
                            repInt = $7802b3aa01031554$export$bc3bea8325045070(repInt, leftZeroes, "0");
                            const rightZeros = decimalPart.replace(/#+$/, "").length;
                            if (rightZeros > repDecimal.length) repDecimal = $7802b3aa01031554$export$7e24a29324041c48(repDecimal, rightZeros, "0");
                            else if (rightZeros < repDecimal.length) repDecimal = repDecimal.substring(0, rightZeros) + repDecimal.substring(rightZeros).replace(/0+$/, "");
                            // Thousands separator
                            if (intPart.indexOf(",") > 0) {
                                const i = repInt.length % 3;
                                const thousandGroups = Math.floor(repInt.length / 3);
                                let thousands = i > 0 ? repInt.substr(0, i) + (thousandGroups > 0 ? "," : "") : "";
                                for(let j = 0; j < thousandGroups; j++)thousands += repInt.substr(i + j * 3, 3) + (j < thousandGroups - 1 ? "," : "");
                                repInt = thousands;
                            }
                            return repDecimal.length > 0 ? repInt + "." + repDecimal : repInt;
                        });
                        rep = sign + rep;
                    }
            }
        } else if (rep instanceof Date) rep = (0, $6ed86d8a11a8516b$export$f84e8e69fd4488a5)(rep, pattern || format);
        else rep = (0, $eATN7.toString)(rep);
        padLength = parseInt((padLength || " ").substring(1), 10);
        if (!isNaN(padLength)) rep = $7802b3aa01031554$var$pad(String(rep), Math.abs(padLength), " ", padLength < 0);
        return rep;
    });
}
function $7802b3aa01031554$export$2a47f398eeff8b01(n, f) {
    if (n < 0) throw new Error("String length must be non-negative");
    const xs = new Array(n);
    for(let i = 0; i < n; i++)xs[i] = f(i);
    return xs.join("");
}
function $7802b3aa01031554$export$21a5ca8aa77d35ff(str, startIndex, value) {
    if (startIndex < 0 || startIndex > str.length) throw new Error("startIndex is negative or greater than the length of this instance.");
    return str.substring(0, startIndex) + value + str.substring(startIndex);
}
function $7802b3aa01031554$export$c8733ae29fb53302(str) {
    return typeof str !== "string" || str.length === 0;
}
function $7802b3aa01031554$export$c6e2787f63ca055d(str) {
    return typeof str !== "string" || /^\s*$/.test(str);
}
function $7802b3aa01031554$export$ee1b3e54f0441b22(...xs) {
    return xs.map((x)=>String(x)).join("");
}
function $7802b3aa01031554$export$f7e2c8231c57a8bd(delimiter, xs) {
    if (Array.isArray(xs)) return xs.join(delimiter);
    else return Array.from(xs).join(delimiter);
}
function $7802b3aa01031554$export$5b532d5614fd5b39(delimiter, xs, startIndex, count) {
    const endIndexPlusOne = startIndex + count;
    if (endIndexPlusOne > xs.length) throw new Error("Index and count must refer to a location within the buffer.");
    return xs.slice(startIndex, endIndexPlusOne).join(delimiter);
}
function $7802b3aa01031554$var$notSupported(name) {
    throw new Error("The environment doesn't support '" + name + "', please use a polyfill.");
}
function $7802b3aa01031554$export$2e65ad783d953e9e(inArray) {
    let str = "";
    for(let i = 0; i < inArray.length; i++)str += String.fromCharCode(inArray[i]);
    return typeof btoa === "function" ? btoa(str) : $7802b3aa01031554$var$notSupported("btoa");
}
function $7802b3aa01031554$export$fdad0628bec1dd41(b64Encoded) {
    const binary = typeof atob === "function" ? atob(b64Encoded) : $7802b3aa01031554$var$notSupported("atob");
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
}
function $7802b3aa01031554$var$pad(str, len, ch, isRight) {
    ch = ch || " ";
    len = len - str.length;
    for(let i = 0; i < len; i++)str = isRight ? str + ch : ch + str;
    return str;
}
function $7802b3aa01031554$export$bc3bea8325045070(str, len, ch) {
    return $7802b3aa01031554$var$pad(str, len, ch);
}
function $7802b3aa01031554$export$7e24a29324041c48(str, len, ch) {
    return $7802b3aa01031554$var$pad(str, len, ch, true);
}
function $7802b3aa01031554$export$cd7f480d6b8286c3(str, startIndex, count) {
    if (startIndex >= str.length) throw new Error("startIndex must be less than length of string");
    if (typeof count === "number" && startIndex + count > str.length) throw new Error("Index and count must refer to a location within the string.");
    return str.slice(0, startIndex) + (typeof count === "number" ? str.substr(startIndex + count) : "");
}
function $7802b3aa01031554$export$77ad94ebf1c2b9ed(str, search, replace) {
    return str.replace(new RegExp((0, $9879a22dc3fb544d$export$4e7f196112fea3c5)(search), "g"), replace);
}
function $7802b3aa01031554$export$606959e7ccb797f0(n, x) {
    return $7802b3aa01031554$export$2a47f398eeff8b01(n, ()=>x);
}
function $7802b3aa01031554$export$2a1422e7517645a9(input, index) {
    if (index < 0 || index >= input.length) throw new Error("Index was outside the bounds of the array.");
    return input[index];
}
function $7802b3aa01031554$export$65980d18b75784e2(str, splitters, count, options) {
    count = typeof count === "number" ? count : undefined;
    options = typeof options === "number" ? options : 0;
    if (count && count < 0) throw new Error("Count cannot be less than zero");
    if (count === 0) return [];
    const removeEmpty = (options & 1) === 1;
    const trim = (options & 2) === 2;
    splitters = splitters || [];
    splitters = splitters.filter((x)=>x).map((0, $9879a22dc3fb544d$export$4e7f196112fea3c5));
    splitters = splitters.length > 0 ? splitters : [
        "\\s"
    ];
    const splits = [];
    const reg = new RegExp(splitters.join("|"), "g");
    let findSplits = true;
    let i = 0;
    do {
        const match = reg.exec(str);
        if (match === null) {
            const candidate = trim ? str.substring(i).trim() : str.substring(i);
            if (!removeEmpty || candidate.length > 0) splits.push(candidate);
            findSplits = false;
        } else {
            const candidate = trim ? str.substring(i, match.index).trim() : str.substring(i, match.index);
            if (!removeEmpty || candidate.length > 0) {
                if (count != null && splits.length + 1 === count) {
                    splits.push(trim ? str.substring(i).trim() : str.substring(i));
                    findSplits = false;
                } else splits.push(candidate);
            }
            i = reg.lastIndex;
        }
    }while (findSplits);
    return splits;
}
function $7802b3aa01031554$export$87c2784dc9fc4ab(str, ...chars) {
    if (chars.length === 0) return str.trim();
    const pattern = "[" + (0, $9879a22dc3fb544d$export$4e7f196112fea3c5)(chars.join("")) + "]+";
    return str.replace(new RegExp("^" + pattern), "").replace(new RegExp(pattern + "$"), "");
}
function $7802b3aa01031554$export$fec973013a01a752(str, ...chars) {
    return chars.length === 0 ? str.trimStart() : str.replace(new RegExp("^[" + (0, $9879a22dc3fb544d$export$4e7f196112fea3c5)(chars.join("")) + "]+"), "");
}
function $7802b3aa01031554$export$8eb38b2a7b91ac21(str, ...chars) {
    return chars.length === 0 ? str.trimEnd() : str.replace(new RegExp("[" + (0, $9879a22dc3fb544d$export$4e7f196112fea3c5)(chars.join("")) + "]+$"), "");
}
function $7802b3aa01031554$export$3dea766d36a8935f(pred, x) {
    return x.split("").filter((c)=>pred(c)).join("");
}
function $7802b3aa01031554$export$662d3818631fba36(str, startIndex, length) {
    if (startIndex + (length || 0) > str.length) throw new Error("Invalid startIndex and/or length");
    return length != null ? str.substr(startIndex, length) : str.substr(startIndex);
}
function $7802b3aa01031554$export$88018320320746a9(str, startIndex, length) {
    return $7802b3aa01031554$export$662d3818631fba36(str, startIndex, length).split("");
}
function $7802b3aa01031554$export$bc71a178fd8db0f(strs, ...args) {
    return {
        strs: strs,
        args: args
    };
}
function $7802b3aa01031554$export$6088d99012177da4(fmts) {
    return (strs, ...args)=>({
            strs: strs,
            args: args,
            fmts: fmts
        });
}
function $7802b3aa01031554$export$f61ac8b6f1f46202(s) {
    const strs = s.strs.map((value)=>value.replace(/{/g, '{{').replace(/}/g, '}}'));
    return s.fmts ? strs.reduce((acc, newPart, index)=>acc + `{${String(index - 1) + s.fmts[index - 1]}}` + newPart) : strs.reduce((acc, newPart, index)=>acc + `{${index - 1}}` + newPart);
}



var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");



var $kRS0m = parcelRequire("kRS0m");

var $kRS0m = parcelRequire("kRS0m");
function $efa02a894ab154e8$export$5aed47dd1f4bcbcc(hash, eq) {
    return {
        Equals (x, y) {
            return eq(x, y);
        },
        GetHashCode (x_1) {
            return hash(x_1);
        }
    };
}
function $efa02a894ab154e8$export$2887c3ff5c15faf3() {
    return $efa02a894ab154e8$export$5aed47dd1f4bcbcc((0, $kRS0m.structuralHash), (0, $kRS0m.equals));
}
function $efa02a894ab154e8$export$ab9580ec4835c401() {
    return $efa02a894ab154e8$export$5aed47dd1f4bcbcc((0, $kRS0m.physicalHash), (e, e_1)=>e === e_1);
}
function $efa02a894ab154e8$export$5deb45fecd67f859(comparer) {
    return {
        Compare (x, y) {
            return comparer(x, y);
        }
    };
}
function $efa02a894ab154e8$export$fe834b789c7fece1() {
    return $efa02a894ab154e8$export$5deb45fecd67f859((0, $kRS0m.compare));
}





var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");
class $aa2eb3d7de5ba133$export$a76dbac5bd058d1b {
    constructor(value, capacity){
        this.buf = [];
        if (!(0, $7802b3aa01031554$export$c8733ae29fb53302)(value)) this.buf.push(value);
    }
    toString() {
        const _ = this;
        return (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("", _.buf);
    }
}
function $aa2eb3d7de5ba133$export$8bc57d8515c19f30() {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("System.Text.StringBuilder", undefined, $aa2eb3d7de5ba133$export$a76dbac5bd058d1b);
}
function $aa2eb3d7de5ba133$export$c5d05c6a25e844a2(value, capacity) {
    return new $aa2eb3d7de5ba133$export$a76dbac5bd058d1b(value, capacity);
}
function $aa2eb3d7de5ba133$export$260c34d6b3e20770(capacity) {
    return $aa2eb3d7de5ba133$export$c5d05c6a25e844a2("", capacity);
}
function $aa2eb3d7de5ba133$export$f1bbb1bc6adb5e98(value) {
    return $aa2eb3d7de5ba133$export$c5d05c6a25e844a2(value, 16);
}
function $aa2eb3d7de5ba133$export$11d4896a43bc5bcd() {
    return $aa2eb3d7de5ba133$export$c5d05c6a25e844a2("", 16);
}
function $aa2eb3d7de5ba133$export$6b50450544032b4c(x, s) {
    x.buf.push(s);
    return x;
}
function $aa2eb3d7de5ba133$export$773b85169825fcaa(x, s, startIndex, count) {
    x.buf.push((0, $7802b3aa01031554$export$662d3818631fba36)(s, startIndex, count));
    return x;
}
function $aa2eb3d7de5ba133$export$380be314ac460f13(x, c) {
    x.buf.push(c);
    return x;
}
function $aa2eb3d7de5ba133$export$b8a92401e368f9b1(x, o) {
    x.buf.push((0, $kRS0m.int32ToString)(o));
    return x;
}
function $aa2eb3d7de5ba133$export$7cad49e1ef432605(x, o) {
    x.buf.push(o.toString());
    return x;
}
function $aa2eb3d7de5ba133$export$884ea596fb61d3ad(x, o) {
    x.buf.push((0, $eATN7.toString)(o));
    return x;
}
function $aa2eb3d7de5ba133$export$4b402a09adf229a1(x, o) {
    x.buf.push((0, $eATN7.toString)(o));
    return x;
}
function $aa2eb3d7de5ba133$export$f79b46fdf57270a3(x, cs) {
    x.buf.push(cs.join(''));
    return x;
}
function $aa2eb3d7de5ba133$export$f4d22e689b6dca5d(x, s) {
    x.buf.push((0, $eATN7.toString)(s));
    return x;
}
function $aa2eb3d7de5ba133$export$53e9426b275a6099(x, fmt, o) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(fmt, o));
    return x;
}
function $aa2eb3d7de5ba133$export$ff374fe7a3727718(x, fmt, o1, o2) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(fmt, o1, o2));
    return x;
}
function $aa2eb3d7de5ba133$export$2f4fba24cd438442(x, fmt, o1, o2, o3) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(fmt, o1, o2, o3));
    return x;
}
function $aa2eb3d7de5ba133$export$3002a2a2c3158384(x, fmt, arr) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(fmt, ...arr));
    return x;
}
function $aa2eb3d7de5ba133$export$18ea6437e9e5ba61(x, provider, fmt, o) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(provider, fmt, o));
    return x;
}
function $aa2eb3d7de5ba133$export$dd228395c4da54a6(x, provider, fmt, o1, o2) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(provider, fmt, o1, o2));
    return x;
}
function $aa2eb3d7de5ba133$export$62098e7b29332b47(x, provider, fmt, o1, o2, o3) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(provider, fmt, o1, o2, o3));
    return x;
}
function $aa2eb3d7de5ba133$export$af57923b120fea7e(x, provider, fmt, arr) {
    x.buf.push((0, $7802b3aa01031554$export$d9468344d3651243)(provider, fmt, ...arr));
    return x;
}
function $aa2eb3d7de5ba133$export$5ef3f527b248937a(x) {
    x.buf.push("\n");
    return x;
}
function $aa2eb3d7de5ba133$export$adc172ef5ec1d9a4(x, s) {
    x.buf.push(s);
    x.buf.push("\n");
    return x;
}
function $aa2eb3d7de5ba133$export$de20c0c77a1c82b3(x) {
    (0, $kRS0m.clear)(x.buf);
    return x;
}
function $aa2eb3d7de5ba133$export$e99e8907ab557314(x, index) {
    let len = 0;
    let i = -1;
    while(i + 1 < x.buf.length && len < index){
        i = i + 1 | 0;
        len = len + x.buf[i].length | 0;
    }
    if ((index < 0 ? true : i < 0) ? true : i >= x.buf.length) throw new Error("Index was outside the bounds of the array");
    else {
        const pos = len - index - 1 | 0;
        return x.buf[i][pos];
    }
}
function $aa2eb3d7de5ba133$export$fd24f2943a0219a4(x, index, value) {
    let len = 0;
    let i = -1;
    while(i + 1 < x.buf.length && len < index){
        i = i + 1 | 0;
        len = len + x.buf[i].length | 0;
    }
    if ((index < 0 ? true : i < 0) ? true : i >= x.buf.length) throw new Error("Index was outside the bounds of the array");
    else {
        const pos = len - index - 1 | 0;
        x.buf[i] = x.buf[i].slice(0, pos - 1 + 1) + value + x.buf[i].slice(pos + 1, x.buf[i].length);
    }
}
function $aa2eb3d7de5ba133$export$fab29a637149bcdc(x, oldValue, newValue) {
    for(let i = x.buf.length - 1; i >= 0; i--)x.buf[i] = (0, $7802b3aa01031554$export$77ad94ebf1c2b9ed)(x.buf[i], oldValue, newValue);
    return x;
}
function $aa2eb3d7de5ba133$export$def874b2ccffcd98(x, oldValue, newValue) {
    const str = (0, $7802b3aa01031554$export$77ad94ebf1c2b9ed)((0, $eATN7.toString)(x), oldValue, newValue);
    return $aa2eb3d7de5ba133$export$6b50450544032b4c($aa2eb3d7de5ba133$export$de20c0c77a1c82b3(x), str);
}
function $aa2eb3d7de5ba133$export$7ca6c13ca0fbff04(x) {
    let len = 0;
    for(let i = x.buf.length - 1; i >= 0; i--)len = len + x.buf[i].length | 0;
    return len | 0;
}
function $aa2eb3d7de5ba133$export$fd7ff3bb38b7c8f9(x, firstIndex, length) {
    return (0, $7802b3aa01031554$export$662d3818631fba36)((0, $eATN7.toString)(x), firstIndex, length);
}


const $aa6a350ee7474f21$export$c41c26fdec11ec90 = {
    "System.Collections.IEqualityComparer.Equals541DA560" (x, y) {
        return (0, $kRS0m.equals)(x, y);
    },
    "System.Collections.IEqualityComparer.GetHashCode4E60E31B" (x_1) {
        return (0, $kRS0m.structuralHash)(x_1);
    }
};
const $aa6a350ee7474f21$export$ea99482f058f81ef = {
    "System.Collections.IEqualityComparer.Equals541DA560" (x, y) {
        return (0, $kRS0m.equals)(x, y);
    },
    "System.Collections.IEqualityComparer.GetHashCode4E60E31B" (x_1) {
        return (0, $kRS0m.structuralHash)(x_1);
    }
};
function $aa6a350ee7474f21$export$d009ffa0939ac970() {
    return (0, $efa02a894ab154e8$export$fe834b789c7fece1)();
}
function $aa6a350ee7474f21$export$af918a4279da88c8() {
    return (0, $efa02a894ab154e8$export$fe834b789c7fece1)();
}
function $aa6a350ee7474f21$export$f62943dc50e062f2() {
    return (0, $efa02a894ab154e8$export$2887c3ff5c15faf3)();
}
function $aa6a350ee7474f21$export$a382d3621b8bd42a() {
    return (0, $efa02a894ab154e8$export$2887c3ff5c15faf3)();
}
function $aa6a350ee7474f21$export$85b0ce7ccd58cf96(message) {
    return new Error(message);
}
function $aa6a350ee7474f21$export$13e7d0bec9443a96(exn) {
    return exn.message;
}
function $aa6a350ee7474f21$export$49fc45e4e62e7426(x) {
    throw new Error(x);
}
function $aa6a350ee7474f21$export$cdb8bb7ae421efe4(resource, action) {
    try {
        return action(resource);
    } finally{
        if ((0, $kRS0m.equals)(resource, (0, $kRS0m.defaultOf)())) ;
        else {
            let copyOfStruct = resource;
            (0, $kRS0m.disposeSafe)(copyOfStruct);
        }
    }
}
function $aa6a350ee7474f21$export$71bc834cee2b44c0(_lockObj, action) {
    return action();
}
function $aa6a350ee7474f21$export$3fceb385c593a12(input) {
    return input.Value;
}
function $aa6a350ee7474f21$export$db1d2a6f3518bc00(continuation, builder, format) {
    return format.cont((s)=>{
        (0, $aa2eb3d7de5ba133$export$6b50450544032b4c)(builder, s);
        return continuation();
    });
}
function $aa6a350ee7474f21$export$1ca523c0edc2f91a(builder, format) {
    return $aa6a350ee7474f21$export$db1d2a6f3518bc00(()=>{}, builder, format);
}


function $0e153c1be19b405c$export$882a7a2eca8e1502(cons, len) {
    if (typeof cons === "function") return new cons(len);
    else return new Array(len);
}





var $eATN7 = parcelRequire("eATN7");
function $5ce0fb420d4fadad$export$468ff95b83d315e5(str, defValue) {
    // TODO: test if value is valid and in range
    if (str != null && /\S/.test(str)) {
        const v = +str.replace("_", "");
        if (!Number.isNaN(v)) {
            defValue.contents = v;
            return true;
        }
    }
    return false;
}
function $5ce0fb420d4fadad$export$98e6a39c04603d36(str) {
    const defValue = new (0, $eATN7.FSharpRef)(0);
    if ($5ce0fb420d4fadad$export$468ff95b83d315e5(str, defValue)) return defValue.contents;
    else throw new Error(`The input string ${str} was not in a correct format.`);
}
function $5ce0fb420d4fadad$export$cedde49ca4e635df(x) {
    return x === Number.POSITIVE_INFINITY;
}
function $5ce0fb420d4fadad$export$86dc1490ec32fe0a(x) {
    return x === Number.NEGATIVE_INFINITY;
}
function $5ce0fb420d4fadad$export$4c8a3b4c9715e22d(x) {
    return x === Number.POSITIVE_INFINITY || x === Number.NEGATIVE_INFINITY;
}
function $5ce0fb420d4fadad$export$8960430cfd85939f(x, y) {
    return x > y ? x : y;
}
function $5ce0fb420d4fadad$export$96ec731ed4dcb222(x, y) {
    return x < y ? x : y;
}
function $5ce0fb420d4fadad$export$d5c1c11e7369f9ca(x, y) {
    return Math.abs(x) > Math.abs(y) ? x : y;
}
function $5ce0fb420d4fadad$export$98c4be7bef211208(x, y) {
    return Math.abs(x) < Math.abs(y) ? x : y;
}
function $5ce0fb420d4fadad$export$7d15b64cf5a3a4c4(x, min, max) {
    return x < min ? min : x > max ? max : x;
}



var $kRS0m = parcelRequire("kRS0m");
const $9216d27711cc273c$export$1d7558b55257001d = "The index was outside the range of elements in the collection.";
const $9216d27711cc273c$export$6f6b0078912f4c4b = "Collection was empty.";
const $9216d27711cc273c$export$2f1b8e728b004525 = "The input must be non-negative.";
const $9216d27711cc273c$export$bb8ebba5bfe3f17a = "The input sequence was empty.";
const $9216d27711cc273c$export$8f2c469045724186 = "The input sequence contains more than one element.";
const $9216d27711cc273c$export$bc2c3bc917b1d953 = "An index satisfying the predicate was not found in the collection.";
const $9216d27711cc273c$export$11574e3a2ac48981 = "The collections had different lengths.";
const $9216d27711cc273c$export$9f17aeddfa374276 = "The input sequence has an insufficient number of elements.";


function $e5d9070e144b905e$var$indexNotFound() {
    throw new Error("An index satisfying the predicate was not found in the collection.");
}
function $e5d9070e144b905e$var$differentLengths() {
    throw new Error("Arrays had different lengths");
}
function $e5d9070e144b905e$export$10d8903dec122b9d(array1, array2, cons) {
    const len1 = array1.length | 0;
    const len2 = array2.length | 0;
    const newArray = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len1 + len2);
    for(let i = 0; i <= len1 - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(newArray, i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1));
    for(let i_1 = 0; i_1 <= len2 - 1; i_1++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(newArray, i_1 + len1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, array2));
    return newArray;
}
function $e5d9070e144b905e$export$3dea766d36a8935f(predicate, array) {
    return array.filter(predicate);
}
function $e5d9070e144b905e$export$9563e054e6f787fb(target, targetIndex, count, value) {
    const start = targetIndex | 0;
    return target.fill(value, start, start + count);
}
function $e5d9070e144b905e$export$482c79a7d4ed32a1(array, start, count) {
    const start_1 = start | 0;
    return array.slice(start_1, start_1 + count);
}
function $e5d9070e144b905e$export$4c7897fafd92b108(array) {
    if (array.length === 0) throw new Error("The input array was empty\\nParameter name: array");
    return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(array.length - 1, array);
}
function $e5d9070e144b905e$export$e5907b21d797cce6(array) {
    if (array.length === 0) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(array.length - 1, array));
}
function $e5d9070e144b905e$export$e5bd5b3b105c2a71(f, source, cons) {
    const len = source.length | 0;
    const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len);
    for(let i = 0; i <= len - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, f(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source)));
    return target;
}
function $e5d9070e144b905e$export$871de8747c9eaa88(f, source, cons) {
    const len = source.length | 0;
    const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len);
    for(let i = 0; i <= len - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, f((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source)));
    return target;
}
function $e5d9070e144b905e$export$aded800c294daba4(f, source1, source2, cons) {
    if (source1.length !== source2.length) throw new Error("Arrays had different lengths");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, source1.length);
    for(let i = 0; i <= source1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, f(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2)));
    return result;
}
function $e5d9070e144b905e$export$5be556bf484c4f10(f, source1, source2, cons) {
    if (source1.length !== source2.length) throw new Error("Arrays had different lengths");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, source1.length);
    for(let i = 0; i <= source1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, f((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2)));
    return result;
}
function $e5d9070e144b905e$export$9ba7fb30dbbb3821(f, source1, source2, source3, cons) {
    if (source1.length !== source2.length ? true : source2.length !== source3.length) throw new Error("Arrays had different lengths");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, source1.length);
    for(let i = 0; i <= source1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, f(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source3)));
    return result;
}
function $e5d9070e144b905e$export$f7389512af34c855(f, source1, source2, source3, cons) {
    if (source1.length !== source2.length ? true : source2.length !== source3.length) throw new Error("Arrays had different lengths");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, source1.length);
    for(let i = 0; i <= source1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, f((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source3)));
    return result;
}
function $e5d9070e144b905e$export$9b19c2e3f2aab20f(mapping, state, array, cons) {
    const matchValue = array.length | 0;
    if (matchValue === 0) return [
        [],
        state
    ];
    else {
        let acc = state;
        const res = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, matchValue);
        for(let i = 0; i <= array.length - 1; i++){
            const patternInput = mapping(acc, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i, patternInput[0]);
            acc = patternInput[1];
        }
        return [
            res,
            acc
        ];
    }
}
function $e5d9070e144b905e$export$6d7c6abab27be307(mapping, array, state, cons) {
    const matchValue = array.length | 0;
    if (matchValue === 0) return [
        [],
        state
    ];
    else {
        let acc = state;
        const res = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, matchValue);
        for(let i = array.length - 1; i >= 0; i--){
            const patternInput = mapping((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array), acc);
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i, patternInput[0]);
            acc = patternInput[1];
        }
        return [
            res,
            acc
        ];
    }
}
function $e5d9070e144b905e$export$ddf7c77acd0bf516(source) {
    const len = source.length | 0;
    const target = new Array(len);
    for(let i = 0; i <= len - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, [
        i,
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source)
    ]);
    return target;
}
function $e5d9070e144b905e$export$6a506b36fdea397d(count, array) {
    const count_1 = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(0, count) | 0;
    return array.slice(0, 0 + count_1);
}
function $e5d9070e144b905e$export$ee1b3e54f0441b22(arrays, cons) {
    const arrays_1 = Array.isArray(arrays) ? arrays : Array.from(arrays);
    const matchValue = arrays_1.length | 0;
    switch(matchValue){
        case 0:
            return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
        case 1:
            return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, arrays_1);
        default:
            {
                let totalIdx = 0;
                let totalLength = 0;
                for(let idx = 0; idx <= arrays_1.length - 1; idx++){
                    const arr_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, arrays_1);
                    totalLength = totalLength + arr_1.length | 0;
                }
                const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, totalLength);
                for(let idx_1 = 0; idx_1 <= arrays_1.length - 1; idx_1++){
                    const arr_2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx_1, arrays_1);
                    for(let j = 0; j <= arr_2.length - 1; j++){
                        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, totalIdx, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(j, arr_2));
                        totalIdx = totalIdx + 1 | 0;
                    }
                }
                return result;
            }
    }
}
function $e5d9070e144b905e$export$bb44f104e3c54dae(mapping, array, cons) {
    return $e5d9070e144b905e$export$ee1b3e54f0441b22($e5d9070e144b905e$export$871de8747c9eaa88(mapping, array, (0, $kRS0m.defaultOf)()), cons);
}
function $e5d9070e144b905e$export$9c59b80dda569a6e(predicate, array) {
    return array.filter(predicate);
}
function $e5d9070e144b905e$export$305f7d4e9d4624f2(array, item_1, start, count, eq) {
    const start_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(start, 0) | 0;
    const end$0027 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((c)=>start_1 + c, count), array.length) | 0;
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i >= end$0027) return -1;
            else if (eq.Equals(item_1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return i | 0;
            else {
                i_mut = i + 1;
                continue loop;
            }
            break;
        }
    };
    return loop(start_1) | 0;
}
function $e5d9070e144b905e$export$2344b14b097df817(value, array, eq) {
    return $e5d9070e144b905e$export$305f7d4e9d4624f2(array, value, undefined, undefined, eq) >= 0;
}
function $e5d9070e144b905e$export$6e22c362a0406a2c(cons) {
    return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
}
function $e5d9070e144b905e$export$439306a4dcaafbb9(value, cons) {
    const ar = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 1);
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(ar, 0, value);
    return ar;
}
function $e5d9070e144b905e$export$2a47f398eeff8b01(count, initializer, cons) {
    if (count < 0) throw new Error("The input must be non-negative\\nParameter name: count");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, count);
    for(let i = 0; i <= count - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, initializer(i));
    return result;
}
function $e5d9070e144b905e$export$8f9d79d42bff1aac(array) {
    if (array.length < 2) return [];
    else {
        const count = array.length - 1 | 0;
        const result = new Array(count);
        for(let i = 0; i <= count - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, [
            (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array),
            (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i + 1, array)
        ]);
        return result;
    }
}
function $e5d9070e144b905e$export$606959e7ccb797f0(count, initial, cons) {
    if (count < 0) throw new Error("The input must be non-negative\\nParameter name: count");
    const result = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, count);
    for(let i = 0; i <= result.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, initial);
    return result;
}
function $e5d9070e144b905e$export$784d13d8ee351f07(array) {
    return array.slice();
}
function $e5d9070e144b905e$export$1c7fb22ad89b2a7c(source, sourceIndex, target, targetIndex, count) {
    (0, $kRS0m.copyToArray)(source, sourceIndex, target, targetIndex, count);
}
function $e5d9070e144b905e$export$66c1ae025e96b4bc(array) {
    const array_2 = array.slice();
    return array_2.reverse();
}
function $e5d9070e144b905e$export$c87d910e63d22ed6(folder, state, array, cons) {
    const res = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, array.length + 1);
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, 0, state);
    for(let i = 0; i <= array.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i + 1, folder((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, res), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array)));
    return res;
}
function $e5d9070e144b905e$export$7bd1078b283d99ad(folder, array, state, cons) {
    const res = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, array.length + 1);
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, array.length, state);
    for(let i = array.length - 1; i >= 0; i--)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i, folder((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i + 1, res)));
    return res;
}
function $e5d9070e144b905e$export$955fc4a6c4be454d(count, array, cons) {
    if (count > array.length) throw new Error("count is greater than array length\\nParameter name: count");
    if (count === array.length) return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
    else {
        const count_1 = (count < 0 ? 0 : count) | 0;
        return array.slice(count_1);
    }
}
function $e5d9070e144b905e$export$175dedd748069215(predicate, array, cons) {
    let count = 0;
    while(count < array.length && predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(count, array)))count = count + 1 | 0;
    if (count === array.length) return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
    else {
        const count_1 = count | 0;
        return array.slice(count_1);
    }
}
function $e5d9070e144b905e$export$b7df5d561049483a(count, array, cons) {
    if (count < 0) throw new Error("The input must be non-negative\\nParameter name: count");
    if (count > array.length) throw new Error("count is greater than array length\\nParameter name: count");
    if (count === 0) return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
    else return array.slice(0, 0 + count);
}
function $e5d9070e144b905e$export$9384c7afe4015e42(predicate, array, cons) {
    let count = 0;
    while(count < array.length && predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(count, array)))count = count + 1 | 0;
    if (count === 0) return (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, 0);
    else {
        const count_1 = count | 0;
        return array.slice(0, 0 + count_1);
    }
}
function $e5d9070e144b905e$export$7085ea1126df7818(x, array) {
    array.push(x);
}
function $e5d9070e144b905e$export$9760889ead41947a(range, array) {
    const enumerator = (0, $kRS0m.getEnumerator)(range);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]())$e5d9070e144b905e$export$7085ea1126df7818(enumerator["System.Collections.Generic.IEnumerator`1.get_Current"](), array);
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
}
function $e5d9070e144b905e$export$73ea5dcdf758ae6e(index, range, array) {
    let index_1;
    let i = index;
    const enumerator = (0, $kRS0m.getEnumerator)(range);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const x = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            index_1 = i | 0, array.splice(index_1, 0, x);
            i = i + 1 | 0;
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
}
function $e5d9070e144b905e$export$94ff4a985fbc3b28(item_1, array, eq) {
    const i = $e5d9070e144b905e$export$305f7d4e9d4624f2(array, item_1, undefined, undefined, eq) | 0;
    if (i > -1) {
        array.splice(i, 1);
        return true;
    } else return false;
}
function $e5d9070e144b905e$export$50ed39f80a942033(predicate, array) {
    const countRemoveAll = (count)=>{
        const i = array.findIndex(predicate) | 0;
        if (i > -1) {
            array.splice(i, 1);
            return countRemoveAll(count) + 1 | 0;
        } else return count | 0;
    };
    return countRemoveAll(0) | 0;
}
function $e5d9070e144b905e$export$b29f828819edca8d(f, source, cons) {
    const len = source.length | 0;
    const res1 = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len);
    const res2 = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len);
    let iTrue = 0;
    let iFalse = 0;
    for(let i = 0; i <= len - 1; i++)if (f((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source))) {
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res1, iTrue, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source));
        iTrue = iTrue + 1 | 0;
    } else {
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res2, iFalse, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source));
        iFalse = iFalse + 1 | 0;
    }
    return [
        $e5d9070e144b905e$export$6a506b36fdea397d(iTrue, res1),
        $e5d9070e144b905e$export$6a506b36fdea397d(iFalse, res2)
    ];
}
function $e5d9070e144b905e$export$71aa6c912b956294(predicate, array) {
    const matchValue = array.find(predicate);
    if (matchValue == null) return $e5d9070e144b905e$var$indexNotFound();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $e5d9070e144b905e$export$d65cb303b863e3bf(predicate, array) {
    return array.find(predicate);
}
function $e5d9070e144b905e$export$de3a4d4a0d731119(predicate, array) {
    const matchValue = array.findIndex(predicate) | 0;
    if (matchValue > -1) return matchValue | 0;
    else {
        $e5d9070e144b905e$var$indexNotFound();
        return -1;
    }
}
function $e5d9070e144b905e$export$5c13475397a61429(predicate, array) {
    const matchValue = array.findIndex(predicate) | 0;
    if (matchValue > -1) return matchValue;
    else return undefined;
}
function $e5d9070e144b905e$export$357523c63a2253b9(chooser, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i >= array.length) return $e5d9070e144b905e$var$indexNotFound();
            else {
                const matchValue = chooser((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
                if (matchValue != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                else {
                    i_mut = i + 1;
                    continue loop;
                }
            }
            break;
        }
    };
    return loop(0);
}
function $e5d9070e144b905e$export$d944e5c60afb688e(chooser, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i >= array.length) return undefined;
            else {
                const matchValue = chooser((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
                if (matchValue == null) {
                    i_mut = i + 1;
                    continue loop;
                } else return matchValue;
            }
            break;
        }
    };
    return loop(0);
}
function $e5d9070e144b905e$export$ec18defb06d12add(predicate, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i < 0) return $e5d9070e144b905e$var$indexNotFound();
            else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array);
            else {
                i_mut = i - 1;
                continue loop;
            }
            break;
        }
    };
    return loop(array.length - 1);
}
function $e5d9070e144b905e$export$36425195e236bb0f(predicate, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i < 0) return undefined;
            else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
            else {
                i_mut = i - 1;
                continue loop;
            }
            break;
        }
    };
    return loop(array.length - 1);
}
function $e5d9070e144b905e$export$8855a8be7bd3e9f8(predicate, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i < 0) return -1;
            else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return i | 0;
            else {
                i_mut = i - 1;
                continue loop;
            }
            break;
        }
    };
    return loop(array.length - 1) | 0;
}
function $e5d9070e144b905e$export$78e19deb30f83296(predicate, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i < 0) {
                $e5d9070e144b905e$var$indexNotFound();
                return -1;
            } else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return i | 0;
            else {
                i_mut = i - 1;
                continue loop;
            }
            break;
        }
    };
    return loop(array.length - 1) | 0;
}
function $e5d9070e144b905e$export$e1cc954945760117(predicate, array) {
    const loop = (i_mut)=>{
        loop: while(true){
            const i = i_mut;
            if (i < 0) return undefined;
            else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array))) return i;
            else {
                i_mut = i - 1;
                continue loop;
            }
            break;
        }
    };
    return loop(array.length - 1);
}
function $e5d9070e144b905e$export$7877a478dd30fd3d(chooser, array, cons) {
    const res = [];
    for(let i = 0; i <= array.length - 1; i++){
        const matchValue = chooser((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
        if (matchValue != null) {
            const y = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
            res.push(y);
        }
    }
    if ((0, $kRS0m.equals)(cons, (0, $kRS0m.defaultOf)())) return res;
    else return $e5d9070e144b905e$export$871de8747c9eaa88((x)=>x, res, cons);
}
function $e5d9070e144b905e$export$c336ee92e62ce644(folder, state, array) {
    return array.reduce((delegateArg, delegateArg_1, delegateArg_2)=>folder(delegateArg_2, delegateArg, delegateArg_1), state);
}
function $e5d9070e144b905e$export$93e2b83da34ff82a(folder, state, array) {
    const folder_1 = folder;
    return array.reduce(folder_1, state);
}
function $e5d9070e144b905e$export$c1a059043cc9c119(action, array) {
    for(let i = 0; i <= array.length - 1; i++)action((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
}
function $e5d9070e144b905e$export$5a067165821eae2d(action, array) {
    for(let i = 0; i <= array.length - 1; i++)action(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
}
function $e5d9070e144b905e$export$d1731a37ee7d4fbb(action, array1, array2) {
    if (array1.length !== array2.length) $e5d9070e144b905e$var$differentLengths();
    for(let i = 0; i <= array1.length - 1; i++)action((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2));
}
function $e5d9070e144b905e$export$ab3c1f9aeb4948fd(action, array1, array2) {
    if (array1.length !== array2.length) $e5d9070e144b905e$var$differentLengths();
    for(let i = 0; i <= array1.length - 1; i++)action(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2));
}
function $e5d9070e144b905e$export$dd1bc94b04021eeb(array) {
    return array.length === 0;
}
function $e5d9070e144b905e$export$e5bd981f5eeebe3b(predicate, array) {
    return array.every(predicate);
}
function $e5d9070e144b905e$export$95e62ad65da8b7d2(f, array) {
    const size = array.length | 0;
    const res = array.slice();
    const checkFlags = new Array(size);
    $e5d9070e144b905e$export$5a067165821eae2d((i, x)=>{
        const j = f(i) | 0;
        if (j < 0 ? true : j >= size) throw new Error("Not a valid permutation");
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, j, x);
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(checkFlags, j, 1);
    }, array);
    if (!checkFlags.every((y)=>1 === y)) throw new Error("Not a valid permutation");
    return res;
}
function $e5d9070e144b905e$export$673bd84e9c48e6b2(target, lower, upper, source) {
    const lower_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(lower, 0) | 0;
    const upper_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(upper, -1) | 0;
    const length = (upper_1 >= 0 ? upper_1 : target.length - 1) - lower_1 | 0;
    for(let i = 0; i <= length; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i + lower_1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source));
}
function $e5d9070e144b905e$export$9a2c8f31e984c6d5(projection, xs, comparer) {
    xs.sort((x, y)=>comparer.Compare(projection(x), projection(y)));
}
function $e5d9070e144b905e$export$f76e9de28552298f(xs, comparer) {
    xs.sort((x, y)=>comparer.Compare(x, y));
}
function $e5d9070e144b905e$export$97db5808d8f88186(xs, comparer) {
    const xs_1 = xs.slice();
    xs_1.sort((x, y)=>comparer.Compare(x, y));
    return xs_1;
}
function $e5d9070e144b905e$export$b035e44d7bb4278f(projection, xs, comparer) {
    const xs_1 = xs.slice();
    xs_1.sort((x, y)=>comparer.Compare(projection(x), projection(y)));
    return xs_1;
}
function $e5d9070e144b905e$export$9a59fdf05ed66d15(xs, comparer) {
    const xs_1 = xs.slice();
    xs_1.sort((x, y)=>comparer.Compare(x, y) * -1);
    return xs_1;
}
function $e5d9070e144b905e$export$ca6dab212df382f6(projection, xs, comparer) {
    const xs_1 = xs.slice();
    xs_1.sort((x, y)=>comparer.Compare(projection(x), projection(y)) * -1);
    return xs_1;
}
function $e5d9070e144b905e$export$a9e7d1a6fdcfefde(comparer, xs) {
    const comparer_1 = comparer;
    const xs_1 = xs.slice();
    xs_1.sort(comparer_1);
    return xs_1;
}
function $e5d9070e144b905e$export$8016484fb8238078(xs, ys) {
    const len1 = xs.length | 0;
    const len2 = ys.length | 0;
    const res = new Array(len1 * len2);
    for(let i = 0; i <= xs.length - 1; i++)for(let j = 0; j <= ys.length - 1; j++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i * len2 + j, [
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, xs),
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(j, ys)
    ]);
    return res;
}
function $e5d9070e144b905e$export$c48e357c1a89b78d(generator, state) {
    const res = [];
    const loop = (state_1_mut)=>{
        loop: while(true){
            const state_1 = state_1_mut;
            const matchValue = generator(state_1);
            if (matchValue != null) {
                const x = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[0];
                const s = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[1];
                res.push(x);
                state_1_mut = s;
                continue loop;
            }
            break;
        }
    };
    loop(state);
    return res;
}
function $e5d9070e144b905e$export$23c8d3f8757cab88(array) {
    const len = array.length | 0;
    const res1 = new Array(len);
    const res2 = new Array(len);
    $e5d9070e144b905e$export$5a067165821eae2d((i, tupledArg)=>{
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res1, i, tupledArg[0]);
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res2, i, tupledArg[1]);
    }, array);
    return [
        res1,
        res2
    ];
}
function $e5d9070e144b905e$export$a52790ad56d35e3d(array) {
    const len = array.length | 0;
    const res1 = new Array(len);
    const res2 = new Array(len);
    const res3 = new Array(len);
    $e5d9070e144b905e$export$5a067165821eae2d((i, tupledArg)=>{
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res1, i, tupledArg[0]);
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res2, i, tupledArg[1]);
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res3, i, tupledArg[2]);
    }, array);
    return [
        res1,
        res2,
        res3
    ];
}
function $e5d9070e144b905e$export$8901015135f2fb22(array1, array2) {
    if (array1.length !== array2.length) $e5d9070e144b905e$var$differentLengths();
    const result = new Array(array1.length);
    for(let i = 0; i <= array1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, [
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1),
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2)
    ]);
    return result;
}
function $e5d9070e144b905e$export$a3c629e5d025ffc1(array1, array2, array3) {
    if (array1.length !== array2.length ? true : array2.length !== array3.length) $e5d9070e144b905e$var$differentLengths();
    const result = new Array(array1.length);
    for(let i = 0; i <= array1.length - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, [
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1),
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2),
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array3)
    ]);
    return result;
}
function $e5d9070e144b905e$export$6302d00ba2848bf(chunkSize, array) {
    if (chunkSize < 1) throw new Error("The input must be positive.\\nParameter name: size");
    if (array.length === 0) return [
        []
    ];
    else {
        const result = [];
        for(let x = 0; x <= ~~Math.ceil(array.length / chunkSize) - 1; x++){
            let slice;
            const start_1 = x * chunkSize | 0;
            slice = array.slice(start_1, start_1 + chunkSize);
            result.push(slice);
        }
        return result;
    }
}
function $e5d9070e144b905e$export$b0d75975ac0be0e1(index, array) {
    if (index < 0 ? true : index > array.length) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return [
        array.slice(0, 0 + index),
        array.slice(index)
    ];
}
function $e5d9070e144b905e$export$ecb3797c03e8ce0c(comparer, source1, source2) {
    if (source1 == null) {
        if (source2 == null) return 0;
        else return -1;
    } else if (source2 == null) return 1;
    else {
        const len1 = source1.length | 0;
        const len2 = source2.length | 0;
        const len = (len1 < len2 ? len1 : len2) | 0;
        let i = 0;
        let res = 0;
        while(res === 0 && i < len){
            res = comparer((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2)) | 0;
            i = i + 1 | 0;
        }
        if (res !== 0) return res | 0;
        else if (len1 > len2) return 1;
        else if (len1 < len2) return -1;
        else return 0;
    }
}
function $e5d9070e144b905e$export$53576907a5c40ba3(comparer, source1, source2) {
    if (source1 == null) {
        if (source2 == null) return 0;
        else return -1;
    } else if (source2 == null) return 1;
    else {
        const len1 = source1.length | 0;
        const len2 = source2.length | 0;
        if (len1 > len2) return 1;
        else if (len1 < len2) return -1;
        else {
            let i = 0;
            let res = 0;
            while(res === 0 && i < len1){
                res = comparer((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, source2)) | 0;
                i = i + 1 | 0;
            }
            return res | 0;
        }
    }
}
function $e5d9070e144b905e$export$9d4fa3538bf09487(equals, array1, array2) {
    if (array1 == null) {
        if (array2 == null) return true;
        else return false;
    } else if (array2 == null) return false;
    else {
        let i = 0;
        let result = true;
        const length1 = array1.length | 0;
        const length2 = array2.length | 0;
        if (length1 > length2) return false;
        else if (length1 < length2) return false;
        else {
            while(i < length1 && result){
                result = equals((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2));
                i = i + 1 | 0;
            }
            return result;
        }
    }
}
function $e5d9070e144b905e$export$3367fc0da2c111f0(array) {
    switch(array.length){
        case 1:
            return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array);
        case 0:
            throw new Error("The input sequence was empty\\nParameter name: array");
        default:
            throw new Error("Input array too long\\nParameter name: array");
    }
}
function $e5d9070e144b905e$export$22f0cfb94dab14ba(array) {
    if (array.length === 1) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array));
    else return undefined;
}
function $e5d9070e144b905e$export$5fd5031fecdacec3(array) {
    if (array.length === 0) throw new Error("The input array was empty\\nParameter name: array");
    else return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array);
}
function $e5d9070e144b905e$export$1acbe849d0cb723e(array) {
    if (array.length === 0) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array));
}
function $e5d9070e144b905e$export$c01875f616615628(array) {
    if (array.length === 0) throw new Error("Not enough elements\\nParameter name: array");
    return array.slice(1);
}
function $e5d9070e144b905e$export$7061c75fc5af8b7e(index, array) {
    if (index < 0 ? true : index >= array.length) throw new Error("Index was outside the bounds of the array.\\nParameter name: index");
    else return array[index];
}
function $e5d9070e144b905e$export$8a8216c44337cd5(array, index, value) {
    if (index < 0 ? true : index >= array.length) throw new Error("Index was outside the bounds of the array.\\nParameter name: index");
    else array[index] = value;
}
function $e5d9070e144b905e$export$3fe40c3a4d8cb094(index, array) {
    if (index < 0 ? true : index >= array.length) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(array[index]);
}
function $e5d9070e144b905e$export$550943be80b2169b(folder, array, state) {
    return array.reduceRight((delegateArg, delegateArg_1, delegateArg_2)=>folder(delegateArg_2, delegateArg_1, delegateArg), state);
}
function $e5d9070e144b905e$export$c38b8353041a4f48(folder, array, state) {
    return array.reduceRight((delegateArg, delegateArg_1)=>folder(delegateArg_1, delegateArg), state);
}
function $e5d9070e144b905e$export$665dec9c39c3adad(folder, state, array1, array2) {
    let acc = state;
    if (array1.length !== array2.length) throw new Error("Arrays have different lengths");
    for(let i = 0; i <= array1.length - 1; i++)acc = folder(i, acc, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2));
    return acc;
}
function $e5d9070e144b905e$export$6eef545db8c1f6e(folder, state, array1, array2) {
    return $e5d9070e144b905e$export$665dec9c39c3adad((_arg, acc, x, y)=>folder(acc, x, y), state, array1, array2);
}
function $e5d9070e144b905e$export$eb873be546c6a428(folder, array1, array2, state) {
    let acc = state;
    if (array1.length !== array2.length) $e5d9070e144b905e$var$differentLengths();
    const size = array1.length | 0;
    for(let i = 1; i <= size; i++)acc = folder(i - 1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(size - i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(size - i, array2), acc);
    return acc;
}
function $e5d9070e144b905e$export$f04d6919de1a1f94(f, array1, array2, state) {
    return $e5d9070e144b905e$export$eb873be546c6a428((_arg, x, y, acc)=>f(x, y, acc), array1, array2, state);
}
function $e5d9070e144b905e$export$533b26079ad0b4b(reduction, array) {
    if (array.length === 0) throw new Error("The input array was empty");
    const reduction_1 = reduction;
    return array.reduce(reduction_1);
}
function $e5d9070e144b905e$export$90cf02207d4ef99b(reduction, array) {
    if (array.length === 0) throw new Error("The input array was empty");
    const reduction_1 = reduction;
    return array.reduceRight(reduction_1);
}
function $e5d9070e144b905e$export$a85e1ff32f9fff6e(predicate, array1, array2) {
    return $e5d9070e144b905e$export$6eef545db8c1f6e((acc, x, y)=>acc && predicate(x, y), true, array1, array2);
}
function $e5d9070e144b905e$export$f9300ec6f6f05293(predicate_mut, array_mut, index_mut) {
    existsOffset: while(true){
        const predicate = predicate_mut, array = array_mut, index = index_mut;
        if (index === array.length) return false;
        else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(index, array))) return true;
        else {
            predicate_mut = predicate;
            array_mut = array;
            index_mut = index + 1;
            continue existsOffset;
        }
        break;
    }
}
function $e5d9070e144b905e$export$f7e9f41ea797a17(predicate, array) {
    return $e5d9070e144b905e$export$f9300ec6f6f05293(predicate, array, 0);
}
function $e5d9070e144b905e$export$5c0f099be5c4dc6a(predicate_mut, array1_mut, array2_mut, index_mut) {
    existsOffset2: while(true){
        const predicate = predicate_mut, array1 = array1_mut, array2 = array2_mut, index = index_mut;
        if (index === array1.length) return false;
        else if (predicate((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(index, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(index, array2))) return true;
        else {
            predicate_mut = predicate;
            array1_mut = array1;
            array2_mut = array2;
            index_mut = index + 1;
            continue existsOffset2;
        }
        break;
    }
}
function $e5d9070e144b905e$export$d04ae74aaa2c0655(predicate, array1, array2) {
    if (array1.length !== array2.length) $e5d9070e144b905e$var$differentLengths();
    return $e5d9070e144b905e$export$5c0f099be5c4dc6a(predicate, array1, array2, 0);
}
function $e5d9070e144b905e$export$8a63f25cc62965f1(array, adder) {
    let acc = adder.GetZero();
    for(let i = 0; i <= array.length - 1; i++)acc = adder.Add(acc, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
    return acc;
}
function $e5d9070e144b905e$export$9e8299ab977385a3(projection, array, adder) {
    let acc = adder.GetZero();
    for(let i = 0; i <= array.length - 1; i++)acc = adder.Add(acc, projection((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array)));
    return acc;
}
function $e5d9070e144b905e$export$ad1963a493908da4(projection, xs, comparer) {
    return $e5d9070e144b905e$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? y : x, xs);
}
function $e5d9070e144b905e$export$8960430cfd85939f(xs, comparer) {
    return $e5d9070e144b905e$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? y : x, xs);
}
function $e5d9070e144b905e$export$8c826aa0fa59ac68(projection, xs, comparer) {
    return $e5d9070e144b905e$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? x : y, xs);
}
function $e5d9070e144b905e$export$96ec731ed4dcb222(xs, comparer) {
    return $e5d9070e144b905e$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? x : y, xs);
}
function $e5d9070e144b905e$export$cc6710ee5f037d57(array, averager) {
    if (array.length === 0) throw new Error("The input array was empty\\nParameter name: array");
    let total = averager.GetZero();
    for(let i = 0; i <= array.length - 1; i++)total = averager.Add(total, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array));
    return averager.DivideByInt(total, array.length);
}
function $e5d9070e144b905e$export$9077387bc3582185(projection, array, averager) {
    if (array.length === 0) throw new Error("The input array was empty\\nParameter name: array");
    let total = averager.GetZero();
    for(let i = 0; i <= array.length - 1; i++)total = averager.Add(total, projection((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array)));
    return averager.DivideByInt(total, array.length);
}
function $e5d9070e144b905e$export$5f2b86065ccf5a1(windowSize, source) {
    if (windowSize <= 0) throw new Error("windowSize must be positive");
    let res;
    const len = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(0, source.length - windowSize + 1) | 0;
    res = new Array(len);
    for(let i = windowSize; i <= source.length; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i - windowSize, source.slice(i - windowSize, i - 1 + 1));
    return res;
}
function $e5d9070e144b905e$export$7120a88bf3d39e8(chunks, array) {
    if (chunks < 1) throw new Error("The input must be positive.\\nParameter name: chunks");
    if (array.length === 0) return [
        []
    ];
    else {
        const result = [];
        const chunks_1 = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(chunks, array.length) | 0;
        const minChunkSize = ~~(array.length / chunks_1) | 0;
        const chunksWithExtraItem = array.length % chunks_1 | 0;
        for(let i = 0; i <= chunks_1 - 1; i++){
            const chunkSize = (i < chunksWithExtraItem ? minChunkSize + 1 : minChunkSize) | 0;
            let slice;
            const start_1 = i * minChunkSize + (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(chunksWithExtraItem, i) | 0;
            slice = array.slice(start_1, start_1 + chunkSize);
            result.push(slice);
        }
        return result;
    }
}
function $e5d9070e144b905e$export$9cb09a71b7d66923(arrays, cons) {
    const arrays_1 = Array.isArray(arrays) ? arrays : Array.from(arrays);
    const len = arrays_1.length | 0;
    if (len === 0) return new Array(0);
    else {
        const firstArray = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, arrays_1);
        const lenInner = firstArray.length | 0;
        if (!$e5d9070e144b905e$export$e5bd981f5eeebe3b((a)=>a.length === lenInner, arrays_1)) $e5d9070e144b905e$var$differentLengths();
        const result = new Array(lenInner);
        for(let i = 0; i <= lenInner - 1; i++){
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(result, i, (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len));
            for(let j = 0; j <= len - 1; j++)(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, result)[j] = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(j, arrays_1));
        }
        return result;
    }
}
function $e5d9070e144b905e$export$9f200c4466975173(index, y, xs, cons) {
    const len = xs.length | 0;
    if (index < 0 ? true : index > len) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len + 1);
    for(let i = 0; i <= index - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, xs));
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, index, y);
    for(let i_1 = index; i_1 <= len - 1; i_1++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i_1 + 1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, xs));
    return target;
}
function $e5d9070e144b905e$export$97e8c8737f8994b9(index, ys, xs, cons) {
    const len = xs.length | 0;
    if (index < 0 ? true : index > len) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    const ys_1 = Array.from(ys);
    const len2 = ys_1.length | 0;
    const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len + len2);
    for(let i = 0; i <= index - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, xs));
    for(let i_1 = 0; i_1 <= len2 - 1; i_1++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, index + i_1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, ys_1));
    for(let i_2 = index; i_2 <= len - 1; i_2++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i_2 + len2, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_2, xs));
    return target;
}
function $e5d9070e144b905e$export$aa72b1a59562dee2(index, xs) {
    if (index < 0 ? true : index >= xs.length) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    let i = -1;
    return $e5d9070e144b905e$export$3dea766d36a8935f((_arg)=>{
        i = i + 1 | 0;
        return i !== index;
    }, xs);
}
function $e5d9070e144b905e$export$a1b32c1cdbbe428e(index, count, xs) {
    let i = -1;
    let status = -1;
    const ys = $e5d9070e144b905e$export$3dea766d36a8935f((_arg)=>{
        i = i + 1 | 0;
        if (i === index) {
            status = 0;
            return false;
        } else if (i > index) {
            if (i < index + count) return false;
            else {
                status = 1;
                return true;
            }
        } else return true;
    }, xs);
    const status_1 = (status === 0 && i + 1 === index + count ? 1 : status) | 0;
    if (status_1 < 1) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + (status_1 < 0 ? "index" : "count"));
    return ys;
}
function $e5d9070e144b905e$export$b6d8713d53419d4c(index, y, xs, cons) {
    const len = xs.length | 0;
    if (index < 0 ? true : index >= len) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, len);
    for(let i = 0; i <= len - 1; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(target, i, i === index ? y : (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, xs));
    return target;
}
function $e5d9070e144b905e$export$4380c87abf28fdf(xs, newSize, zero, cons) {
    let array, array_1, start_2, count_2;
    if (newSize < 0) throw new Error("The input must be non-negative.\\nParameter name: newSize");
    const zero_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(zero, (0, $kRS0m.defaultOf)());
    if (xs.contents == null) xs.contents = (array = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, newSize), array.fill(zero_1, 0, 0 + newSize));
    else {
        const len = xs.contents.length | 0;
        if (newSize < len) xs.contents = (array_1 = xs.contents, array_1.slice(0, 0 + newSize));
        else if (newSize > len) {
            const target = (0, $0e153c1be19b405c$export$882a7a2eca8e1502)(cons, newSize);
            if (len > 0) $e5d9070e144b905e$export$1c7fb22ad89b2a7c(xs.contents, 0, target, 0, len);
            xs.contents = (start_2 = len | 0, count_2 = newSize - len | 0, target.fill(zero_1, start_2, start_2 + count_2));
        }
    }
}





var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");



class $e08834e1786645d9$export$46fa32c6f8b2f86 extends (0, $eATN7.Record) {
    constructor(head, tail){
        super();
        this.head = head;
        this.tail = tail;
    }
    toString() {
        const xs = this;
        return "[" + (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("; ", xs) + "]";
    }
    Equals(other) {
        const xs = this;
        if (xs === other) return true;
        else {
            const loop = (xs_1_mut, ys_1_mut)=>{
                loop: while(true){
                    const xs_1 = xs_1_mut, ys_1 = ys_1_mut;
                    const matchValue = xs_1.tail;
                    const matchValue_1 = ys_1.tail;
                    if (matchValue != null) {
                        if (matchValue_1 != null) {
                            const xt = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                            const yt = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_1);
                            if ((0, $kRS0m.equals)(xs_1.head, ys_1.head)) {
                                xs_1_mut = xt;
                                ys_1_mut = yt;
                                continue loop;
                            } else return false;
                        } else return false;
                    } else if (matchValue_1 != null) return false;
                    else return true;
                    break;
                }
            };
            return loop(xs, other);
        }
    }
    GetHashCode() {
        const xs = this;
        const loop = (i_mut, h_mut, xs_1_mut)=>{
            loop: while(true){
                const i = i_mut, h = h_mut, xs_1 = xs_1_mut;
                const matchValue = xs_1.tail;
                if (matchValue != null) {
                    const t = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                    if (i > 18) return h | 0;
                    else {
                        i_mut = i + 1;
                        h_mut = (h << 1) + (0, $kRS0m.structuralHash)(xs_1.head) + 631 * i;
                        xs_1_mut = t;
                        continue loop;
                    }
                } else return h | 0;
                break;
            }
        };
        return loop(0, 0, xs) | 0;
    }
    toJSON() {
        const this$ = this;
        return Array.from(this$);
    }
    CompareTo(other) {
        const xs = this;
        const loop = (xs_1_mut, ys_1_mut)=>{
            loop: while(true){
                const xs_1 = xs_1_mut, ys_1 = ys_1_mut;
                const matchValue = xs_1.tail;
                const matchValue_1 = ys_1.tail;
                if (matchValue != null) {
                    if (matchValue_1 != null) {
                        const xt = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                        const yt = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_1);
                        const c = (0, $kRS0m.compare)(xs_1.head, ys_1.head) | 0;
                        if (c === 0) {
                            xs_1_mut = xt;
                            ys_1_mut = yt;
                            continue loop;
                        } else return c | 0;
                    } else return 1;
                } else if (matchValue_1 != null) return -1;
                else return 0;
                break;
            }
        };
        return loop(xs, other) | 0;
    }
    GetEnumerator() {
        const xs = this;
        return $e08834e1786645d9$export$d5c5f9d2dd7dbba2(xs);
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const xs = this;
        return (0, $kRS0m.getEnumerator)(xs);
    }
}
function $e08834e1786645d9$export$d89f13acd6d8863(gen0) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("ListModule.FSharpList", [
        gen0
    ], $e08834e1786645d9$export$46fa32c6f8b2f86, ()=>[
            [
                "head",
                gen0
            ],
            [
                "tail",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)($e08834e1786645d9$export$d89f13acd6d8863(gen0))
            ]
        ]);
}
class $e08834e1786645d9$export$9eb8d7afe7bf3554 {
    constructor(xs){
        this.xs = xs;
        this.it = this.xs;
        this.current = (0, $kRS0m.defaultOf)();
    }
    "System.Collections.Generic.IEnumerator`1.get_Current"() {
        const _ = this;
        return _.current;
    }
    "System.Collections.IEnumerator.get_Current"() {
        const _ = this;
        return _.current;
    }
    "System.Collections.IEnumerator.MoveNext"() {
        const _ = this;
        const matchValue = _.it.tail;
        if (matchValue != null) {
            const t = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
            _.current = _.it.head;
            _.it = t;
            return true;
        } else return false;
    }
    "System.Collections.IEnumerator.Reset"() {
        const _ = this;
        _.it = _.xs;
        _.current = (0, $kRS0m.defaultOf)();
    }
    Dispose() {}
}
function $e08834e1786645d9$export$2f0d0f992ef5538(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("ListModule.ListEnumerator`1", [
        gen0
    ], $e08834e1786645d9$export$9eb8d7afe7bf3554);
}
function $e08834e1786645d9$export$d5c5f9d2dd7dbba2(xs) {
    return new $e08834e1786645d9$export$9eb8d7afe7bf3554(xs);
}
function $e08834e1786645d9$export$ca5f14a39f7c3bde() {
    return new $e08834e1786645d9$export$46fa32c6f8b2f86((0, $kRS0m.defaultOf)(), undefined);
}
function $e08834e1786645d9$export$62ac43da335545f6(x, xs) {
    return new $e08834e1786645d9$export$46fa32c6f8b2f86(x, xs);
}
function $e08834e1786645d9$export$10d5772debd84bf1(xs) {
    return xs.tail == null;
}
function $e08834e1786645d9$export$f15c1e15e73226cf(xs) {
    const loop = (i_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, xs_1 = xs_1_mut;
            const matchValue = xs_1.tail;
            if (matchValue != null) {
                i_mut = i + 1;
                xs_1_mut = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                continue loop;
            } else return i | 0;
            break;
        }
    };
    return loop(0, xs) | 0;
}
function $e08834e1786645d9$export$1d866465156343c7(xs) {
    const matchValue = xs.tail;
    if (matchValue != null) return xs.head;
    else throw new Error((0, $9216d27711cc273c$export$6f6b0078912f4c4b) + "\\nParameter name: " + "list");
}
function $e08834e1786645d9$export$4e0d45844bd5cd6a(xs) {
    const matchValue = xs.tail;
    if (matchValue != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
    else throw new Error((0, $9216d27711cc273c$export$6f6b0078912f4c4b) + "\\nParameter name: " + "list");
}
function $e08834e1786645d9$export$f63236b60aa2bf0(xs, index) {
    const loop = (i_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, xs_1 = xs_1_mut;
            const matchValue = xs_1.tail;
            if (matchValue != null) {
                if (i === index) return xs_1.head;
                else {
                    i_mut = i + 1;
                    xs_1_mut = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                    continue loop;
                }
            } else throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
            break;
        }
    };
    return loop(0, xs);
}
function $e08834e1786645d9$export$6362f022d562392() {
    throw new Error((0, $9216d27711cc273c$export$bc2c3bc917b1d953));
}
function $e08834e1786645d9$export$6e22c362a0406a2c() {
    return $e08834e1786645d9$export$ca5f14a39f7c3bde();
}
function $e08834e1786645d9$export$8327ebbef2a0ba76(x, xs) {
    return $e08834e1786645d9$export$62ac43da335545f6(x, xs);
}
function $e08834e1786645d9$export$439306a4dcaafbb9(x) {
    return $e08834e1786645d9$export$62ac43da335545f6(x, $e08834e1786645d9$export$ca5f14a39f7c3bde());
}
function $e08834e1786645d9$export$dd1bc94b04021eeb(xs) {
    return $e08834e1786645d9$export$10d5772debd84bf1(xs);
}
function $e08834e1786645d9$export$f24224f1c91d8156(xs) {
    return $e08834e1786645d9$export$f15c1e15e73226cf(xs);
}
function $e08834e1786645d9$export$5fd5031fecdacec3(xs) {
    return $e08834e1786645d9$export$1d866465156343c7(xs);
}
function $e08834e1786645d9$export$1acbe849d0cb723e(xs) {
    if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($e08834e1786645d9$export$1d866465156343c7(xs));
}
function $e08834e1786645d9$export$c01875f616615628(xs) {
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(xs);
}
function $e08834e1786645d9$export$e5907b21d797cce6(xs_mut) {
    tryLast: while(true){
        const xs = xs_mut;
        if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) return undefined;
        else {
            const t = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs);
            if ($e08834e1786645d9$export$10d5772debd84bf1(t)) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($e08834e1786645d9$export$1d866465156343c7(xs));
            else {
                xs_mut = t;
                continue tryLast;
            }
        }
        break;
    }
}
function $e08834e1786645d9$export$4c7897fafd92b108(xs) {
    const matchValue = $e08834e1786645d9$export$e5907b21d797cce6(xs);
    if (matchValue == null) throw new Error((0, $9216d27711cc273c$export$6f6b0078912f4c4b));
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $e08834e1786645d9$export$ecb3797c03e8ce0c(comparer, xs, ys) {
    const loop = (xs_1_mut, ys_1_mut)=>{
        loop: while(true){
            const xs_1 = xs_1_mut, ys_1 = ys_1_mut;
            const matchValue = $e08834e1786645d9$export$10d5772debd84bf1(xs_1);
            const matchValue_1 = $e08834e1786645d9$export$10d5772debd84bf1(ys_1);
            if (matchValue) {
                if (matchValue_1) return 0;
                else return -1;
            } else if (matchValue_1) return 1;
            else {
                const c = comparer($e08834e1786645d9$export$1d866465156343c7(xs_1), $e08834e1786645d9$export$1d866465156343c7(ys_1)) | 0;
                if (c === 0) {
                    xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                    ys_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys_1);
                    continue loop;
                } else return c | 0;
            }
            break;
        }
    };
    return loop(xs, ys) | 0;
}
function $e08834e1786645d9$export$45b10814cc054894(xs) {
    const len = $e08834e1786645d9$export$f15c1e15e73226cf(xs) | 0;
    const res = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(len), 0, len, null);
    const loop = (i_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, xs_1 = xs_1_mut;
            if (!$e08834e1786645d9$export$10d5772debd84bf1(xs_1)) {
                (0, $e5d9070e144b905e$export$8a8216c44337cd5)(res, i, $e08834e1786645d9$export$1d866465156343c7(xs_1));
                i_mut = i + 1;
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    loop(0, xs);
    return res;
}
function $e08834e1786645d9$export$93e2b83da34ff82a(folder, state, xs) {
    let acc = state;
    let xs_1 = xs;
    while(!$e08834e1786645d9$export$10d5772debd84bf1(xs_1)){
        acc = folder(acc, $e08834e1786645d9$export$5fd5031fecdacec3(xs_1));
        xs_1 = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
    }
    return acc;
}
function $e08834e1786645d9$export$66c1ae025e96b4bc(xs) {
    return $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>$e08834e1786645d9$export$62ac43da335545f6(x, acc), $e08834e1786645d9$export$ca5f14a39f7c3bde(), xs);
}
function $e08834e1786645d9$export$c38b8353041a4f48(folder, xs, state) {
    return (0, $e5d9070e144b905e$export$c38b8353041a4f48)(folder, $e08834e1786645d9$export$45b10814cc054894(xs), state);
}
function $e08834e1786645d9$export$c336ee92e62ce644(folder, state, xs) {
    const loop = (i_mut, acc_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, acc = acc_mut, xs_1 = xs_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return acc;
            else {
                i_mut = i + 1;
                acc_mut = folder(i, acc, $e08834e1786645d9$export$1d866465156343c7(xs_1));
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    return loop(0, state, xs);
}
function $e08834e1786645d9$export$6eef545db8c1f6e(folder, state, xs, ys) {
    let acc = state;
    let xs_1 = xs;
    let ys_1 = ys;
    while(!$e08834e1786645d9$export$10d5772debd84bf1(xs_1) && !$e08834e1786645d9$export$10d5772debd84bf1(ys_1)){
        acc = folder(acc, $e08834e1786645d9$export$1d866465156343c7(xs_1), $e08834e1786645d9$export$1d866465156343c7(ys_1));
        xs_1 = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
        ys_1 = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys_1);
    }
    return acc;
}
function $e08834e1786645d9$export$f04d6919de1a1f94(folder, xs, ys, state) {
    return (0, $e5d9070e144b905e$export$f04d6919de1a1f94)(folder, $e08834e1786645d9$export$45b10814cc054894(xs), $e08834e1786645d9$export$45b10814cc054894(ys), state);
}
function $e08834e1786645d9$export$c48e357c1a89b78d(gen, state) {
    const loop = (acc_mut, node_mut)=>{
        let t;
        loop: while(true){
            const acc = acc_mut, node = node_mut;
            const matchValue = gen(acc);
            if (matchValue != null) {
                acc_mut = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[1];
                node_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[0], undefined), node.tail = t, t);
                continue loop;
            } else return node;
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node_1 = loop(state, root);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node_1.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$c1a059043cc9c119(action, xs) {
    $e08834e1786645d9$export$93e2b83da34ff82a((unitVar, x)=>{
        action(x);
    }, undefined, xs);
}
function $e08834e1786645d9$export$d1731a37ee7d4fbb(action, xs, ys) {
    $e08834e1786645d9$export$6eef545db8c1f6e((unitVar, x, y)=>{
        action(x, y);
    }, undefined, xs, ys);
}
function $e08834e1786645d9$export$5a067165821eae2d(action, xs) {
    $e08834e1786645d9$export$93e2b83da34ff82a((i, x)=>{
        action(i, x);
        return i + 1 | 0;
    }, 0, xs);
}
function $e08834e1786645d9$export$ab3c1f9aeb4948fd(action, xs, ys) {
    $e08834e1786645d9$export$6eef545db8c1f6e((i, x, y)=>{
        action(i, x, y);
        return i + 1 | 0;
    }, 0, xs, ys);
}
function $e08834e1786645d9$export$1344b76b7b5a4395(xs) {
    return xs;
}
function $e08834e1786645d9$export$2d23f4f67ce65296(xs, tail_1) {
    let res = tail_1;
    for(let i = xs.length - 1; i >= 0; i--)res = $e08834e1786645d9$export$62ac43da335545f6((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, xs), res);
    return res;
}
function $e08834e1786645d9$export$cb197a913f6bb809(xs) {
    return $e08834e1786645d9$export$2d23f4f67ce65296(xs, $e08834e1786645d9$export$ca5f14a39f7c3bde());
}
function $e08834e1786645d9$export$c80b5fc7454ef206(xs) {
    let xs_3, t;
    if ((0, $kRS0m.isArrayLike)(xs)) return $e08834e1786645d9$export$cb197a913f6bb809(xs);
    else if (xs instanceof $e08834e1786645d9$export$46fa32c6f8b2f86) return xs;
    else {
        const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
        let node = root;
        const enumerator = (0, $kRS0m.getEnumerator)(xs);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
                const x = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                node = (xs_3 = node, t = new $e08834e1786645d9$export$46fa32c6f8b2f86(x, undefined), xs_3.tail = t, t);
            }
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
        const xs_5 = node;
        const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
        xs_5.tail = t_2;
        return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
    }
}
function $e08834e1786645d9$export$ee1b3e54f0441b22(lists) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    let node = root;
    const action = (xs)=>{
        node = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
            const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(x, undefined);
            acc.tail = t;
            return t;
        }, node, xs);
    };
    if ((0, $kRS0m.isArrayLike)(lists)) {
        const xs_3 = lists;
        xs_3.forEach(action);
    } else if (lists instanceof $e08834e1786645d9$export$46fa32c6f8b2f86) $e08834e1786645d9$export$c1a059043cc9c119(action, lists);
    else {
        const enumerator = (0, $kRS0m.getEnumerator)(lists);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]())action(enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]());
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
    }
    const xs_6 = node;
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    xs_6.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$c87d910e63d22ed6(folder, state, xs) {
    let xs_4, t_2;
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    let node;
    const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(state, undefined);
    root.tail = t;
    node = t;
    let acc = state;
    let xs_3 = xs;
    while(!$e08834e1786645d9$export$10d5772debd84bf1(xs_3)){
        acc = folder(acc, $e08834e1786645d9$export$1d866465156343c7(xs_3));
        node = (xs_4 = node, t_2 = new $e08834e1786645d9$export$46fa32c6f8b2f86(acc, undefined), xs_4.tail = t_2, t_2);
        xs_3 = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_3);
    }
    const xs_6 = node;
    const t_4 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    xs_6.tail = t_4;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$7bd1078b283d99ad(folder, xs, state) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$7bd1078b283d99ad)(folder, $e08834e1786645d9$export$45b10814cc054894(xs), state));
}
function $e08834e1786645d9$export$10d8903dec122b9d(xs, ys) {
    return $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>$e08834e1786645d9$export$62ac43da335545f6(x, acc), ys, $e08834e1786645d9$export$66c1ae025e96b4bc(xs));
}
function $e08834e1786645d9$export$bb44f104e3c54dae(mapping, xs) {
    let xs_1, t;
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    let node = root;
    let ys = xs;
    while(!$e08834e1786645d9$export$10d5772debd84bf1(ys)){
        let zs = mapping($e08834e1786645d9$export$1d866465156343c7(ys));
        while(!$e08834e1786645d9$export$10d5772debd84bf1(zs)){
            node = (xs_1 = node, t = new $e08834e1786645d9$export$46fa32c6f8b2f86($e08834e1786645d9$export$1d866465156343c7(zs), undefined), xs_1.tail = t, t);
            zs = $e08834e1786645d9$export$4e0d45844bd5cd6a(zs);
        }
        ys = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys);
    }
    const xs_3 = node;
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    xs_3.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$e5bd5b3b105c2a71(mapping, xs) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = $e08834e1786645d9$export$c336ee92e62ce644((i, acc, x)=>{
        const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(mapping(i, x), undefined);
        acc.tail = t;
        return t;
    }, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$871de8747c9eaa88(mapping, xs) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(mapping(x), undefined);
        acc.tail = t;
        return t;
    }, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$ddf7c77acd0bf516(xs) {
    return $e08834e1786645d9$export$e5bd5b3b105c2a71((i, x)=>[
            i,
            x
        ], xs);
}
function $e08834e1786645d9$export$5be556bf484c4f10(mapping, xs, ys) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = $e08834e1786645d9$export$6eef545db8c1f6e((acc, x, y)=>{
        const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(mapping(x, y), undefined);
        acc.tail = t;
        return t;
    }, root, xs, ys);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$aded800c294daba4(mapping, xs, ys) {
    const loop = (i_mut, acc_mut, xs_1_mut, ys_1_mut)=>{
        let t;
        loop: while(true){
            const i = i_mut, acc = acc_mut, xs_1 = xs_1_mut, ys_1 = ys_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1) ? true : $e08834e1786645d9$export$10d5772debd84bf1(ys_1)) return acc;
            else {
                i_mut = i + 1;
                acc_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86(mapping(i, $e08834e1786645d9$export$1d866465156343c7(xs_1), $e08834e1786645d9$export$1d866465156343c7(ys_1)), undefined), acc.tail = t, t);
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                ys_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys_1);
                continue loop;
            }
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node_1 = loop(0, root, xs, ys);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node_1.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$f7389512af34c855(mapping, xs, ys, zs) {
    const loop = (acc_mut, xs_1_mut, ys_1_mut, zs_1_mut)=>{
        let t;
        loop: while(true){
            const acc = acc_mut, xs_1 = xs_1_mut, ys_1 = ys_1_mut, zs_1 = zs_1_mut;
            if (($e08834e1786645d9$export$10d5772debd84bf1(xs_1) ? true : $e08834e1786645d9$export$10d5772debd84bf1(ys_1)) ? true : $e08834e1786645d9$export$10d5772debd84bf1(zs_1)) return acc;
            else {
                acc_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86(mapping($e08834e1786645d9$export$1d866465156343c7(xs_1), $e08834e1786645d9$export$1d866465156343c7(ys_1), $e08834e1786645d9$export$1d866465156343c7(zs_1)), undefined), acc.tail = t, t);
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                ys_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys_1);
                zs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(zs_1);
                continue loop;
            }
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node_1 = loop(root, xs, ys, zs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node_1.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$9b19c2e3f2aab20f(mapping, state, xs) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const patternInput_1 = $e08834e1786645d9$export$93e2b83da34ff82a((tupledArg, x)=>{
        let t;
        const patternInput = mapping(tupledArg[1], x);
        return [
            (t = new $e08834e1786645d9$export$46fa32c6f8b2f86(patternInput[0], undefined), tupledArg[0].tail = t, t),
            patternInput[1]
        ];
    }, [
        root,
        state
    ], xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    patternInput_1[0].tail = t_2;
    return [
        $e08834e1786645d9$export$4e0d45844bd5cd6a(root),
        patternInput_1[1]
    ];
}
function $e08834e1786645d9$export$6d7c6abab27be307(mapping, xs, state) {
    return $e08834e1786645d9$export$9b19c2e3f2aab20f((acc, x)=>mapping(x, acc), state, $e08834e1786645d9$export$66c1ae025e96b4bc(xs));
}
function $e08834e1786645d9$export$d944e5c60afb688e(f, xs) {
    const loop = (xs_1_mut)=>{
        loop: while(true){
            const xs_1 = xs_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return undefined;
            else {
                const matchValue = f($e08834e1786645d9$export$1d866465156343c7(xs_1));
                if (matchValue == null) {
                    xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                    continue loop;
                } else return matchValue;
            }
            break;
        }
    };
    return loop(xs);
}
function $e08834e1786645d9$export$357523c63a2253b9(f, xs) {
    const matchValue = $e08834e1786645d9$export$d944e5c60afb688e(f, xs);
    if (matchValue == null) return $e08834e1786645d9$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $e08834e1786645d9$export$d65cb303b863e3bf(f, xs) {
    return $e08834e1786645d9$export$d944e5c60afb688e((x)=>f(x) ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(x) : undefined, xs);
}
function $e08834e1786645d9$export$71aa6c912b956294(f, xs) {
    const matchValue = $e08834e1786645d9$export$d65cb303b863e3bf(f, xs);
    if (matchValue == null) return $e08834e1786645d9$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $e08834e1786645d9$export$36425195e236bb0f(f, xs) {
    return (0, $e5d9070e144b905e$export$36425195e236bb0f)(f, $e08834e1786645d9$export$45b10814cc054894(xs));
}
function $e08834e1786645d9$export$ec18defb06d12add(f, xs) {
    const matchValue = $e08834e1786645d9$export$36425195e236bb0f(f, xs);
    if (matchValue == null) return $e08834e1786645d9$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $e08834e1786645d9$export$5c13475397a61429(f, xs) {
    const loop = (i_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, xs_1 = xs_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return undefined;
            else if (f($e08834e1786645d9$export$1d866465156343c7(xs_1))) return i;
            else {
                i_mut = i + 1;
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    return loop(0, xs);
}
function $e08834e1786645d9$export$de3a4d4a0d731119(f, xs) {
    const matchValue = $e08834e1786645d9$export$5c13475397a61429(f, xs);
    if (matchValue == null) {
        $e08834e1786645d9$export$6362f022d562392();
        return -1;
    } else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue) | 0;
}
function $e08834e1786645d9$export$e1cc954945760117(f, xs) {
    return (0, $e5d9070e144b905e$export$e1cc954945760117)(f, $e08834e1786645d9$export$45b10814cc054894(xs));
}
function $e08834e1786645d9$export$78e19deb30f83296(f, xs) {
    const matchValue = $e08834e1786645d9$export$e1cc954945760117(f, xs);
    if (matchValue == null) {
        $e08834e1786645d9$export$6362f022d562392();
        return -1;
    } else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue) | 0;
}
function $e08834e1786645d9$export$3fe40c3a4d8cb094(n, xs) {
    const loop = (i_mut, xs_1_mut)=>{
        loop: while(true){
            const i = i_mut, xs_1 = xs_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return undefined;
            else if (i === n) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($e08834e1786645d9$export$1d866465156343c7(xs_1));
            else {
                i_mut = i + 1;
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    return loop(0, xs);
}
function $e08834e1786645d9$export$7061c75fc5af8b7e(n, xs) {
    return $e08834e1786645d9$export$f63236b60aa2bf0(xs, n);
}
function $e08834e1786645d9$export$3dea766d36a8935f(f, xs) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        if (f(x)) {
            const t = new $e08834e1786645d9$export$46fa32c6f8b2f86(x, undefined);
            acc.tail = t;
            return t;
        } else return acc;
    }, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$b29f828819edca8d(f, xs) {
    const matchValue = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const root2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const root1 = matchValue;
    const patternInput_1 = $e08834e1786645d9$export$93e2b83da34ff82a((tupledArg, x)=>{
        let t, t_2;
        const lacc = tupledArg[0];
        const racc = tupledArg[1];
        if (f(x)) return [
            (t = new $e08834e1786645d9$export$46fa32c6f8b2f86(x, undefined), lacc.tail = t, t),
            racc
        ];
        else return [
            lacc,
            (t_2 = new $e08834e1786645d9$export$46fa32c6f8b2f86(x, undefined), racc.tail = t_2, t_2)
        ];
    }, [
        root1,
        root2
    ], xs);
    const t_4 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    patternInput_1[0].tail = t_4;
    const t_5 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    patternInput_1[1].tail = t_5;
    return [
        $e08834e1786645d9$export$4e0d45844bd5cd6a(root1),
        $e08834e1786645d9$export$4e0d45844bd5cd6a(root2)
    ];
}
function $e08834e1786645d9$export$7877a478dd30fd3d(f, xs) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        const matchValue = f(x);
        if (matchValue == null) return acc;
        else {
            const t = new $e08834e1786645d9$export$46fa32c6f8b2f86((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue), undefined);
            acc.tail = t;
            return t;
        }
    }, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$2344b14b097df817(value, xs, eq) {
    return $e08834e1786645d9$export$5c13475397a61429((v)=>eq.Equals(value, v), xs) != null;
}
function $e08834e1786645d9$export$2a47f398eeff8b01(n, f) {
    let xs, t;
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    let node = root;
    for(let i = 0; i <= n - 1; i++)node = (xs = node, t = new $e08834e1786645d9$export$46fa32c6f8b2f86(f(i), undefined), xs.tail = t, t);
    const xs_2 = node;
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    xs_2.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$606959e7ccb797f0(n, x) {
    return $e08834e1786645d9$export$2a47f398eeff8b01(n, (_arg)=>x);
}
function $e08834e1786645d9$export$533b26079ad0b4b(f, xs) {
    if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) throw new Error((0, $9216d27711cc273c$export$6f6b0078912f4c4b));
    else return $e08834e1786645d9$export$93e2b83da34ff82a(f, $e08834e1786645d9$export$5fd5031fecdacec3(xs), $e08834e1786645d9$export$c01875f616615628(xs));
}
function $e08834e1786645d9$export$90cf02207d4ef99b(f, xs) {
    if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) throw new Error((0, $9216d27711cc273c$export$6f6b0078912f4c4b));
    else return $e08834e1786645d9$export$c38b8353041a4f48(f, $e08834e1786645d9$export$c01875f616615628(xs), $e08834e1786645d9$export$5fd5031fecdacec3(xs));
}
function $e08834e1786645d9$export$e5bd981f5eeebe3b(f, xs) {
    return $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>acc && f(x), true, xs);
}
function $e08834e1786645d9$export$a85e1ff32f9fff6e(f, xs, ys) {
    return $e08834e1786645d9$export$6eef545db8c1f6e((acc, x, y)=>acc && f(x, y), true, xs, ys);
}
function $e08834e1786645d9$export$f7e9f41ea797a17(f, xs) {
    return $e08834e1786645d9$export$5c13475397a61429(f, xs) != null;
}
function $e08834e1786645d9$export$d04ae74aaa2c0655(f_mut, xs_mut, ys_mut) {
    exists2: while(true){
        const f = f_mut, xs = xs_mut, ys = ys_mut;
        const matchValue = $e08834e1786645d9$export$10d5772debd84bf1(xs);
        const matchValue_1 = $e08834e1786645d9$export$10d5772debd84bf1(ys);
        let matchResult;
        if (matchValue) {
            if (matchValue_1) matchResult = 0;
            else matchResult = 2;
        } else if (matchValue_1) matchResult = 2;
        else matchResult = 1;
        switch(matchResult){
            case 0:
                return false;
            case 1:
                if (f($e08834e1786645d9$export$1d866465156343c7(xs), $e08834e1786645d9$export$1d866465156343c7(ys))) return true;
                else {
                    f_mut = f;
                    xs_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs);
                    ys_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(ys);
                    continue exists2;
                }
            default:
                throw new Error((0, $9216d27711cc273c$export$11574e3a2ac48981) + "\\nParameter name: " + "list2");
        }
        break;
    }
}
function $e08834e1786645d9$export$23c8d3f8757cab88(xs) {
    return $e08834e1786645d9$export$c38b8353041a4f48((tupledArg, tupledArg_1)=>[
            $e08834e1786645d9$export$62ac43da335545f6(tupledArg[0], tupledArg_1[0]),
            $e08834e1786645d9$export$62ac43da335545f6(tupledArg[1], tupledArg_1[1])
        ], xs, [
        $e08834e1786645d9$export$ca5f14a39f7c3bde(),
        $e08834e1786645d9$export$ca5f14a39f7c3bde()
    ]);
}
function $e08834e1786645d9$export$a52790ad56d35e3d(xs) {
    return $e08834e1786645d9$export$c38b8353041a4f48((tupledArg, tupledArg_1)=>[
            $e08834e1786645d9$export$62ac43da335545f6(tupledArg[0], tupledArg_1[0]),
            $e08834e1786645d9$export$62ac43da335545f6(tupledArg[1], tupledArg_1[1]),
            $e08834e1786645d9$export$62ac43da335545f6(tupledArg[2], tupledArg_1[2])
        ], xs, [
        $e08834e1786645d9$export$ca5f14a39f7c3bde(),
        $e08834e1786645d9$export$ca5f14a39f7c3bde(),
        $e08834e1786645d9$export$ca5f14a39f7c3bde()
    ]);
}
function $e08834e1786645d9$export$8901015135f2fb22(xs, ys) {
    return $e08834e1786645d9$export$5be556bf484c4f10((x, y)=>[
            x,
            y
        ], xs, ys);
}
function $e08834e1786645d9$export$a3c629e5d025ffc1(xs, ys, zs) {
    return $e08834e1786645d9$export$f7389512af34c855((x, y, z)=>[
            x,
            y,
            z
        ], xs, ys, zs);
}
function $e08834e1786645d9$export$a9e7d1a6fdcfefde(comparer, xs) {
    const arr = $e08834e1786645d9$export$45b10814cc054894(xs);
    arr.sort(comparer);
    return $e08834e1786645d9$export$cb197a913f6bb809(arr);
}
function $e08834e1786645d9$export$97db5808d8f88186(xs, comparer) {
    return $e08834e1786645d9$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(x, y), xs);
}
function $e08834e1786645d9$export$b035e44d7bb4278f(projection, xs, comparer) {
    return $e08834e1786645d9$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(projection(x), projection(y)), xs);
}
function $e08834e1786645d9$export$9a59fdf05ed66d15(xs, comparer) {
    return $e08834e1786645d9$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(x, y) * -1, xs);
}
function $e08834e1786645d9$export$ca6dab212df382f6(projection, xs, comparer) {
    return $e08834e1786645d9$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(projection(x), projection(y)) * -1, xs);
}
function $e08834e1786645d9$export$8a63f25cc62965f1(xs, adder) {
    return $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>adder.Add(acc, x), adder.GetZero(), xs);
}
function $e08834e1786645d9$export$9e8299ab977385a3(f, xs, adder) {
    return $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>adder.Add(acc, f(x)), adder.GetZero(), xs);
}
function $e08834e1786645d9$export$ad1963a493908da4(projection, xs, comparer) {
    return $e08834e1786645d9$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? y : x, xs);
}
function $e08834e1786645d9$export$8960430cfd85939f(xs, comparer) {
    return $e08834e1786645d9$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? y : x, xs);
}
function $e08834e1786645d9$export$8c826aa0fa59ac68(projection, xs, comparer) {
    return $e08834e1786645d9$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? x : y, xs);
}
function $e08834e1786645d9$export$96ec731ed4dcb222(xs, comparer) {
    return $e08834e1786645d9$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? x : y, xs);
}
function $e08834e1786645d9$export$cc6710ee5f037d57(xs, averager) {
    let count = 0;
    const total = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        count = count + 1 | 0;
        return averager.Add(acc, x);
    }, averager.GetZero(), xs);
    return averager.DivideByInt(total, count);
}
function $e08834e1786645d9$export$9077387bc3582185(f, xs, averager) {
    let count = 0;
    const total = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        count = count + 1 | 0;
        return averager.Add(acc, f(x));
    }, averager.GetZero(), xs);
    return averager.DivideByInt(total, count);
}
function $e08834e1786645d9$export$95e62ad65da8b7d2(f, xs) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$95e62ad65da8b7d2)(f, $e08834e1786645d9$export$45b10814cc054894(xs)));
}
function $e08834e1786645d9$export$6302d00ba2848bf(chunkSize, xs) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$871de8747c9eaa88)($e08834e1786645d9$export$cb197a913f6bb809, (0, $e5d9070e144b905e$export$6302d00ba2848bf)(chunkSize, $e08834e1786645d9$export$45b10814cc054894(xs))));
}
function $e08834e1786645d9$export$8016484fb8238078(xs, ys) {
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    let node = root;
    $e08834e1786645d9$export$c1a059043cc9c119((x)=>{
        $e08834e1786645d9$export$c1a059043cc9c119((y)=>{
            let xs_1, t;
            node = (xs_1 = node, t = new $e08834e1786645d9$export$46fa32c6f8b2f86([
                x,
                y
            ], undefined), xs_1.tail = t, t);
        }, ys);
    }, xs);
    const xs_3 = node;
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    xs_3.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$955fc4a6c4be454d(count_mut, xs_mut) {
    skip: while(true){
        const count = count_mut, xs = xs_mut;
        if (count <= 0) return xs;
        else if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) throw new Error((0, $9216d27711cc273c$export$9f17aeddfa374276) + "\\nParameter name: " + "list");
        else {
            count_mut = count - 1;
            xs_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs);
            continue skip;
        }
        break;
    }
}
function $e08834e1786645d9$export$175dedd748069215(predicate_mut, xs_mut) {
    skipWhile: while(true){
        const predicate = predicate_mut, xs = xs_mut;
        if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) return xs;
        else if (!predicate($e08834e1786645d9$export$1d866465156343c7(xs))) return xs;
        else {
            predicate_mut = predicate;
            xs_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs);
            continue skipWhile;
        }
        break;
    }
}
function $e08834e1786645d9$export$b7df5d561049483a(count, xs) {
    if (count < 0) throw new Error((0, $9216d27711cc273c$export$2f1b8e728b004525) + "\\nParameter name: " + "count");
    const loop = (i_mut, acc_mut, xs_1_mut)=>{
        let t;
        loop: while(true){
            const i = i_mut, acc = acc_mut, xs_1 = xs_1_mut;
            if (i <= 0) return acc;
            else if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) throw new Error((0, $9216d27711cc273c$export$9f17aeddfa374276) + "\\nParameter name: " + "list");
            else {
                i_mut = i - 1;
                acc_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86($e08834e1786645d9$export$1d866465156343c7(xs_1), undefined), acc.tail = t, t);
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = loop(count, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$9384c7afe4015e42(predicate, xs) {
    const loop = (acc_mut, xs_1_mut)=>{
        let t;
        loop: while(true){
            const acc = acc_mut, xs_1 = xs_1_mut;
            if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return acc;
            else if (!predicate($e08834e1786645d9$export$1d866465156343c7(xs_1))) return acc;
            else {
                acc_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86($e08834e1786645d9$export$1d866465156343c7(xs_1), undefined), acc.tail = t, t);
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = loop(root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$6a506b36fdea397d(count, xs) {
    const loop = (i_mut, acc_mut, xs_1_mut)=>{
        let t;
        loop: while(true){
            const i = i_mut, acc = acc_mut, xs_1 = xs_1_mut;
            if (i <= 0) return acc;
            else if ($e08834e1786645d9$export$10d5772debd84bf1(xs_1)) return acc;
            else {
                i_mut = i - 1;
                acc_mut = (t = new $e08834e1786645d9$export$46fa32c6f8b2f86($e08834e1786645d9$export$1d866465156343c7(xs_1), undefined), acc.tail = t, t);
                xs_1_mut = $e08834e1786645d9$export$4e0d45844bd5cd6a(xs_1);
                continue loop;
            }
            break;
        }
    };
    const root = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    const node = loop(count, root, xs);
    const t_2 = $e08834e1786645d9$export$ca5f14a39f7c3bde();
    node.tail = t_2;
    return $e08834e1786645d9$export$4e0d45844bd5cd6a(root);
}
function $e08834e1786645d9$export$9899dbe95982df9a(startIndex, endIndex, xs) {
    const len = $e08834e1786645d9$export$f24224f1c91d8156(xs) | 0;
    let startIndex_1;
    const index = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(startIndex, 0) | 0;
    startIndex_1 = index < 0 ? 0 : index;
    let endIndex_1;
    const index_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(endIndex, len - 1) | 0;
    endIndex_1 = index_1 >= len ? len - 1 : index_1;
    if (endIndex_1 < startIndex_1) return $e08834e1786645d9$export$ca5f14a39f7c3bde();
    else return $e08834e1786645d9$export$b7df5d561049483a(endIndex_1 - startIndex_1 + 1, $e08834e1786645d9$export$955fc4a6c4be454d(startIndex_1, xs));
}
function $e08834e1786645d9$export$b0d75975ac0be0e1(index, xs) {
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$2f1b8e728b004525) + "\\nParameter name: " + "index");
    if (index > $e08834e1786645d9$export$f15c1e15e73226cf(xs)) throw new Error((0, $9216d27711cc273c$export$9f17aeddfa374276) + "\\nParameter name: " + "index");
    return [
        $e08834e1786645d9$export$b7df5d561049483a(index, xs),
        $e08834e1786645d9$export$955fc4a6c4be454d(index, xs)
    ];
}
function $e08834e1786645d9$export$3367fc0da2c111f0(xs) {
    if ($e08834e1786645d9$export$10d5772debd84bf1(xs)) throw new Error((0, $9216d27711cc273c$export$bb8ebba5bfe3f17a) + "\\nParameter name: " + "list");
    else if ($e08834e1786645d9$export$10d5772debd84bf1($e08834e1786645d9$export$4e0d45844bd5cd6a(xs))) return $e08834e1786645d9$export$1d866465156343c7(xs);
    else throw new Error((0, $9216d27711cc273c$export$8f2c469045724186) + "\\nParameter name: " + "list");
}
function $e08834e1786645d9$export$22f0cfb94dab14ba(xs) {
    if (!$e08834e1786645d9$export$10d5772debd84bf1(xs) && $e08834e1786645d9$export$10d5772debd84bf1($e08834e1786645d9$export$4e0d45844bd5cd6a(xs))) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($e08834e1786645d9$export$1d866465156343c7(xs));
    else return undefined;
}
function $e08834e1786645d9$export$9c59b80dda569a6e(predicate, xs) {
    return $e08834e1786645d9$export$3dea766d36a8935f(predicate, xs);
}
function $e08834e1786645d9$export$8f9d79d42bff1aac(xs) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$8f9d79d42bff1aac)($e08834e1786645d9$export$45b10814cc054894(xs)));
}
function $e08834e1786645d9$export$5f2b86065ccf5a1(windowSize, xs) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$871de8747c9eaa88)($e08834e1786645d9$export$cb197a913f6bb809, (0, $e5d9070e144b905e$export$5f2b86065ccf5a1)(windowSize, $e08834e1786645d9$export$45b10814cc054894(xs))));
}
function $e08834e1786645d9$export$7120a88bf3d39e8(chunks, xs) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$871de8747c9eaa88)($e08834e1786645d9$export$cb197a913f6bb809, (0, $e5d9070e144b905e$export$7120a88bf3d39e8)(chunks, $e08834e1786645d9$export$45b10814cc054894(xs))));
}
function $e08834e1786645d9$export$9cb09a71b7d66923(lists) {
    return $e08834e1786645d9$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$871de8747c9eaa88)($e08834e1786645d9$export$cb197a913f6bb809, (0, $e5d9070e144b905e$export$9cb09a71b7d66923)((0, $e5d9070e144b905e$export$871de8747c9eaa88)($e08834e1786645d9$export$45b10814cc054894, Array.from(lists)))));
}
function $e08834e1786645d9$export$9f200c4466975173(index, y, xs) {
    let i = -1;
    let isDone = false;
    const result = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        i = i + 1 | 0;
        if (i === index) {
            isDone = true;
            return $e08834e1786645d9$export$62ac43da335545f6(x, $e08834e1786645d9$export$62ac43da335545f6(y, acc));
        } else return $e08834e1786645d9$export$62ac43da335545f6(x, acc);
    }, $e08834e1786645d9$export$ca5f14a39f7c3bde(), xs);
    return $e08834e1786645d9$export$66c1ae025e96b4bc(isDone ? result : i + 1 === index ? $e08834e1786645d9$export$62ac43da335545f6(y, result) : (()=>{
        throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    })());
}
function $e08834e1786645d9$export$97e8c8737f8994b9(index, ys, xs) {
    let i = -1;
    let isDone = false;
    const ys_1 = $e08834e1786645d9$export$c80b5fc7454ef206(ys);
    const result = $e08834e1786645d9$export$93e2b83da34ff82a((acc, x)=>{
        i = i + 1 | 0;
        if (i === index) {
            isDone = true;
            return $e08834e1786645d9$export$62ac43da335545f6(x, $e08834e1786645d9$export$10d8903dec122b9d(ys_1, acc));
        } else return $e08834e1786645d9$export$62ac43da335545f6(x, acc);
    }, $e08834e1786645d9$export$ca5f14a39f7c3bde(), xs);
    return $e08834e1786645d9$export$66c1ae025e96b4bc(isDone ? result : i + 1 === index ? $e08834e1786645d9$export$10d8903dec122b9d(ys_1, result) : (()=>{
        throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    })());
}
function $e08834e1786645d9$export$aa72b1a59562dee2(index, xs) {
    let i = -1;
    let isDone = false;
    const ys = $e08834e1786645d9$export$3dea766d36a8935f((_arg)=>{
        i = i + 1 | 0;
        if (i === index) {
            isDone = true;
            return false;
        } else return true;
    }, xs);
    if (!isDone) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return ys;
}
function $e08834e1786645d9$export$a1b32c1cdbbe428e(index, count, xs) {
    let i = -1;
    let status = -1;
    const ys = $e08834e1786645d9$export$3dea766d36a8935f((_arg)=>{
        i = i + 1 | 0;
        if (i === index) {
            status = 0;
            return false;
        } else if (i > index) {
            if (i < index + count) return false;
            else {
                status = 1;
                return true;
            }
        } else return true;
    }, xs);
    const status_1 = (status === 0 && i + 1 === index + count ? 1 : status) | 0;
    if (status_1 < 1) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + (status_1 < 0 ? "index" : "count"));
    return ys;
}
function $e08834e1786645d9$export$b6d8713d53419d4c(index, y, xs) {
    let isDone = false;
    const ys = $e08834e1786645d9$export$e5bd5b3b105c2a71((i, x)=>{
        if (i === index) {
            isDone = true;
            return y;
        } else return x;
    }, xs);
    if (!isDone) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return ys;
}



const $42cbcefff7323768$export$c1d29bc2efedc7e2 = "Enumeration already finished.";
const $42cbcefff7323768$export$d4f75b74a8a85920 = "Enumeration has not started. Call MoveNext.";
const $42cbcefff7323768$export$bb8ebba5bfe3f17a = "The input sequence was empty.";
const $42cbcefff7323768$export$8f2c469045724186 = "The input sequence contains more than one element.";
const $42cbcefff7323768$export$bc2c3bc917b1d953 = "An index satisfying the predicate was not found in the collection.";
const $42cbcefff7323768$export$9f17aeddfa374276 = "The input sequence has an insufficient number of elements.";
const $42cbcefff7323768$export$5c8816aab4f46f58 = "Reset is not supported on this enumerator.";
function $42cbcefff7323768$export$c9c12dccafdc9e15() {
    throw new Error($42cbcefff7323768$export$5c8816aab4f46f58);
}
function $42cbcefff7323768$export$fe7fea637c109b1() {
    throw new Error($42cbcefff7323768$export$d4f75b74a8a85920);
}
function $42cbcefff7323768$export$8314a61089d7dfd1() {
    throw new Error($42cbcefff7323768$export$c1d29bc2efedc7e2);
}
class $42cbcefff7323768$export$f84f5f7a2af4015b {
    constructor(f){
        this.f = f;
    }
    toString() {
        const xs = this;
        let i = 0;
        let str = "seq [";
        const e = (0, $kRS0m.getEnumerator)(xs);
        try {
            while(i < 4 && e["System.Collections.IEnumerator.MoveNext"]()){
                if (i > 0) str = str + "; ";
                str = str + (0, $eATN7.toString)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
                i = i + 1 | 0;
            }
            if (i === 4) str = str + "; ...";
            return str + "]";
        } finally{
            (0, $kRS0m.disposeSafe)(e);
        }
    }
    GetEnumerator() {
        const x = this;
        return x.f();
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const x = this;
        return x.f();
    }
}
function $42cbcefff7323768$export$c02749f189d1f722(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("SeqModule.Enumerator.Seq", [
        gen0
    ], $42cbcefff7323768$export$f84f5f7a2af4015b);
}
function $42cbcefff7323768$export$9de9c521f6c9f38f(f) {
    return new $42cbcefff7323768$export$f84f5f7a2af4015b(f);
}
class $42cbcefff7323768$export$2cbf863d8f6afaa7 {
    constructor(current, next, dispose){
        this.current = current;
        this.next = next;
        this.dispose = dispose;
    }
    "System.Collections.Generic.IEnumerator`1.get_Current"() {
        const _ = this;
        return _.current();
    }
    "System.Collections.IEnumerator.get_Current"() {
        const _ = this;
        return _.current();
    }
    "System.Collections.IEnumerator.MoveNext"() {
        const _ = this;
        return _.next();
    }
    "System.Collections.IEnumerator.Reset"() {
        $42cbcefff7323768$export$c9c12dccafdc9e15();
    }
    Dispose() {
        const _ = this;
        _.dispose();
    }
}
function $42cbcefff7323768$export$853e5f7f847a949f(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("SeqModule.Enumerator.FromFunctions`1", [
        gen0
    ], $42cbcefff7323768$export$2cbf863d8f6afaa7);
}
function $42cbcefff7323768$export$df49e5e409220125(current, next, dispose) {
    return new $42cbcefff7323768$export$2cbf863d8f6afaa7(current, next, dispose);
}
function $42cbcefff7323768$export$ebf0eca22469dbbc(e) {
    return $42cbcefff7323768$export$df49e5e409220125(()=>e["System.Collections.Generic.IEnumerator`1.get_Current"](), ()=>e["System.Collections.IEnumerator.MoveNext"](), ()=>{
        (0, $kRS0m.disposeSafe)(e);
    });
}
function $42cbcefff7323768$export$20426c14ee45c85e(sources) {
    let outerOpt = undefined;
    let innerOpt = undefined;
    let started = false;
    let finished = false;
    let curr = undefined;
    const finish = ()=>{
        finished = true;
        if (innerOpt != null) {
            const inner = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(innerOpt);
            try {
                (0, $kRS0m.disposeSafe)(inner);
            } finally{
                innerOpt = undefined;
            }
        }
        if (outerOpt != null) {
            const outer = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(outerOpt);
            try {
                (0, $kRS0m.disposeSafe)(outer);
            } finally{
                outerOpt = undefined;
            }
        }
    };
    return $42cbcefff7323768$export$df49e5e409220125(()=>{
        if (!started) $42cbcefff7323768$export$fe7fea637c109b1();
        else if (finished) $42cbcefff7323768$export$8314a61089d7dfd1();
        if (curr != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr);
        else return $42cbcefff7323768$export$8314a61089d7dfd1();
    }, ()=>{
        let copyOfStruct;
        if (!started) started = true;
        if (finished) return false;
        else {
            let res = undefined;
            while(res == null){
                const outerOpt_1 = outerOpt;
                const innerOpt_1 = innerOpt;
                if (outerOpt_1 != null) {
                    if (innerOpt_1 != null) {
                        const inner_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(innerOpt_1);
                        if (inner_1["System.Collections.IEnumerator.MoveNext"]()) {
                            curr = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(inner_1["System.Collections.Generic.IEnumerator`1.get_Current"]());
                            res = true;
                        } else try {
                            (0, $kRS0m.disposeSafe)(inner_1);
                        } finally{
                            innerOpt = undefined;
                        }
                    } else {
                        const outer_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(outerOpt_1);
                        if (outer_1["System.Collections.IEnumerator.MoveNext"]()) {
                            const ie = outer_1["System.Collections.Generic.IEnumerator`1.get_Current"]();
                            innerOpt = (copyOfStruct = ie, (0, $kRS0m.getEnumerator)(copyOfStruct));
                        } else {
                            finish();
                            res = false;
                        }
                    }
                } else outerOpt = (0, $kRS0m.getEnumerator)(sources);
            }
            return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(res);
        }
    }, ()=>{
        if (!finished) finish();
    });
}
function $42cbcefff7323768$export$8da5aab8659eb06(f, e) {
    return $42cbcefff7323768$export$df49e5e409220125(()=>e["System.Collections.Generic.IEnumerator`1.get_Current"](), ()=>e["System.Collections.IEnumerator.MoveNext"](), ()=>{
        try {
            (0, $kRS0m.disposeSafe)(e);
        } finally{
            f();
        }
    });
}
function $42cbcefff7323768$export$d82b80f0dbfe256d(openf, compute, closef) {
    let started = false;
    let curr = undefined;
    let state = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(openf());
    const dispose = ()=>{
        if (state != null) {
            const x_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(state);
            try {
                closef(x_1);
            } finally{
                state = undefined;
            }
        }
    };
    const finish = ()=>{
        try {
            dispose();
        } finally{
            curr = undefined;
        }
    };
    return $42cbcefff7323768$export$df49e5e409220125(()=>{
        if (!started) $42cbcefff7323768$export$fe7fea637c109b1();
        if (curr != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr);
        else return $42cbcefff7323768$export$8314a61089d7dfd1();
    }, ()=>{
        if (!started) started = true;
        if (state != null) {
            const s = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(state);
            let matchValue_1;
            try {
                matchValue_1 = compute(s);
            } catch (matchValue) {
                finish();
                throw matchValue;
            }
            if (matchValue_1 != null) {
                curr = matchValue_1;
                return true;
            } else {
                finish();
                return false;
            }
        } else return false;
    }, dispose);
}
function $42cbcefff7323768$export$f054447c84a06e65(f, state) {
    let curr = undefined;
    let acc = state;
    return $42cbcefff7323768$export$df49e5e409220125(()=>{
        if (curr != null) {
            const x = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr)[0];
            const st = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr)[1];
            return x;
        } else return $42cbcefff7323768$export$fe7fea637c109b1();
    }, ()=>{
        curr = f(acc);
        if (curr != null) {
            const x_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr)[0];
            const st_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(curr)[1];
            acc = st_1;
            return true;
        } else return false;
    }, ()=>{});
}
function $42cbcefff7323768$export$6362f022d562392() {
    throw new Error($42cbcefff7323768$export$bc2c3bc917b1d953);
}
function $42cbcefff7323768$export$14d5e08ade3f14c2(argName, arg) {
    if (arg == null) (0, $aa6a350ee7474f21$export$49fc45e4e62e7426)(argName);
}
function $42cbcefff7323768$export$327d67905f90fa80(f) {
    return $42cbcefff7323768$export$9de9c521f6c9f38f(f);
}
function $42cbcefff7323768$export$c80b5fc7454ef206(xs) {
    $42cbcefff7323768$export$14d5e08ade3f14c2("source", xs);
    return (0, $kRS0m.getEnumerator)(xs);
}
function $42cbcefff7323768$export$1391212d75b2ee65(generator) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>(0, $kRS0m.getEnumerator)(generator()));
}
function $42cbcefff7323768$export$ee1b3e54f0441b22(sources) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>$42cbcefff7323768$export$20426c14ee45c85e(sources));
}
function $42cbcefff7323768$export$c48e357c1a89b78d(generator, state) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>$42cbcefff7323768$export$f054447c84a06e65(generator, state));
}
function $42cbcefff7323768$export$6e22c362a0406a2c() {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>new Array(0));
}
function $42cbcefff7323768$export$439306a4dcaafbb9(x) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>(0, $e5d9070e144b905e$export$439306a4dcaafbb9)(x));
}
function $42cbcefff7323768$export$cb197a913f6bb809(arr) {
    return arr;
}
function $42cbcefff7323768$export$45b10814cc054894(xs) {
    if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) {
        const a = xs;
        return (0, $e08834e1786645d9$export$45b10814cc054894)(a);
    } else return Array.from(xs);
}
function $42cbcefff7323768$export$97ef4da51e4fceb3(xs) {
    return xs;
}
function $42cbcefff7323768$export$effcdbd76139450(xs) {
    if ((0, $kRS0m.isArrayLike)(xs)) return (0, $e08834e1786645d9$export$cb197a913f6bb809)(xs);
    else if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return xs;
    else return (0, $e08834e1786645d9$export$c80b5fc7454ef206)(xs);
}
function $42cbcefff7323768$export$80d376111cc09ad7(create, compute, dispose) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>$42cbcefff7323768$export$d82b80f0dbfe256d(create, compute, dispose));
}
function $42cbcefff7323768$export$7395da449cea18d1(create, compute, dispose) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>{
        let i = -1;
        return $42cbcefff7323768$export$d82b80f0dbfe256d(create, (x)=>{
            i = i + 1 | 0;
            return compute(i, x);
        }, dispose);
    });
}
function $42cbcefff7323768$export$10d8903dec122b9d(xs, ys) {
    return $42cbcefff7323768$export$ee1b3e54f0441b22([
        xs,
        ys
    ]);
}
function $42cbcefff7323768$export$f2db7d5238e1d23f(xs) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>{
        $42cbcefff7323768$export$14d5e08ade3f14c2("source", xs);
        return $42cbcefff7323768$export$ebf0eca22469dbbc((0, $kRS0m.getEnumerator)(xs));
    });
}
function $42cbcefff7323768$export$7877a478dd30fd3d(chooser, xs) {
    return $42cbcefff7323768$export$80d376111cc09ad7(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (e)=>{
        let curr = undefined;
        while(curr == null && e["System.Collections.IEnumerator.MoveNext"]())curr = chooser(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        return curr;
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$ecb3797c03e8ce0c(comparer, xs, ys) {
    const e1 = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const e2 = $42cbcefff7323768$export$c80b5fc7454ef206(ys);
        try {
            let c = 0;
            let b1 = e1["System.Collections.IEnumerator.MoveNext"]();
            let b2 = e2["System.Collections.IEnumerator.MoveNext"]();
            while(c === 0 && b1 && b2){
                c = comparer(e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"]()) | 0;
                if (c === 0) {
                    b1 = e1["System.Collections.IEnumerator.MoveNext"]();
                    b2 = e2["System.Collections.IEnumerator.MoveNext"]();
                }
            }
            return (c !== 0 ? c : b1 ? 1 : b2 ? -1 : 0) | 0;
        } finally{
            (0, $kRS0m.disposeSafe)(e2);
        }
    } finally{
        (0, $kRS0m.disposeSafe)(e1);
    }
}
function $42cbcefff7323768$export$2344b14b097df817(value, xs, comparer) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        let found = false;
        while(!found && e["System.Collections.IEnumerator.MoveNext"]())found = comparer.Equals(value, e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        return found;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$861f8efb7480e521(create, moveNext, current) {
    return $42cbcefff7323768$export$80d376111cc09ad7(create, (x)=>moveNext(x) ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(current(x)) : undefined, (x_1)=>{
        const matchValue = x_1;
        if ((0, $kRS0m.isDisposable)(matchValue)) {
            const id = matchValue;
            (0, $kRS0m.disposeSafe)(id);
        }
    });
}
function $42cbcefff7323768$export$a961e324f78542f0(source, compensation) {
    const compensation_1 = compensation;
    return $42cbcefff7323768$export$327d67905f90fa80(()=>{
        try {
            return $42cbcefff7323768$export$8da5aab8659eb06(compensation_1, $42cbcefff7323768$export$c80b5fc7454ef206(source));
        } catch (matchValue) {
            compensation_1();
            throw matchValue;
        }
    });
}
function $42cbcefff7323768$export$19377b1e8666bd96(resource, source) {
    const compensation = ()=>{
        if ((0, $kRS0m.equals)(resource, (0, $kRS0m.defaultOf)())) ;
        else {
            let copyOfStruct = resource;
            (0, $kRS0m.disposeSafe)(copyOfStruct);
        }
    };
    return $42cbcefff7323768$export$327d67905f90fa80(()=>{
        try {
            return $42cbcefff7323768$export$8da5aab8659eb06(compensation, $42cbcefff7323768$export$c80b5fc7454ef206(source(resource)));
        } catch (matchValue_1) {
            compensation();
            throw matchValue_1;
        }
    });
}
function $42cbcefff7323768$export$d6ea9ba8df458a3e(guard, xs) {
    return $42cbcefff7323768$export$ee1b3e54f0441b22($42cbcefff7323768$export$c48e357c1a89b78d((i)=>guard() ? [
            xs,
            i + 1
        ] : undefined, 0));
}
function $42cbcefff7323768$export$3dea766d36a8935f(f, xs) {
    return $42cbcefff7323768$export$7877a478dd30fd3d((x)=>{
        if (f(x)) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(x);
        else return undefined;
    }, xs);
}
function $42cbcefff7323768$export$f7e9f41ea797a17(predicate, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        let found = false;
        while(!found && e["System.Collections.IEnumerator.MoveNext"]())found = predicate(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        return found;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$d04ae74aaa2c0655(predicate, xs, ys) {
    const e1 = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const e2 = $42cbcefff7323768$export$c80b5fc7454ef206(ys);
        try {
            let found = false;
            while(!found && e1["System.Collections.IEnumerator.MoveNext"]() && e2["System.Collections.IEnumerator.MoveNext"]())found = predicate(e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"]());
            return found;
        } finally{
            (0, $kRS0m.disposeSafe)(e2);
        }
    } finally{
        (0, $kRS0m.disposeSafe)(e1);
    }
}
function $42cbcefff7323768$export$3367fc0da2c111f0(xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        if (e["System.Collections.IEnumerator.MoveNext"]()) {
            const v = e["System.Collections.Generic.IEnumerator`1.get_Current"]();
            if (e["System.Collections.IEnumerator.MoveNext"]()) throw new Error($42cbcefff7323768$export$8f2c469045724186 + "\\nParameter name: " + "source");
            else return v;
        } else throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a + "\\nParameter name: " + "source");
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$22f0cfb94dab14ba(xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        if (e["System.Collections.IEnumerator.MoveNext"]()) {
            const v = e["System.Collections.Generic.IEnumerator`1.get_Current"]();
            return e["System.Collections.IEnumerator.MoveNext"]() ? undefined : (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(v);
        } else return undefined;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$d65cb303b863e3bf(predicate, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        let res = undefined;
        while(res == null && e["System.Collections.IEnumerator.MoveNext"]()){
            const c = e["System.Collections.Generic.IEnumerator`1.get_Current"]();
            if (predicate(c)) res = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(c);
        }
        return res;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$71aa6c912b956294(predicate, xs) {
    const matchValue = $42cbcefff7323768$export$d65cb303b863e3bf(predicate, xs);
    if (matchValue == null) return $42cbcefff7323768$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$36425195e236bb0f(predicate, xs) {
    return (0, $e5d9070e144b905e$export$36425195e236bb0f)(predicate, $42cbcefff7323768$export$45b10814cc054894(xs));
}
function $42cbcefff7323768$export$ec18defb06d12add(predicate, xs) {
    const matchValue = $42cbcefff7323768$export$36425195e236bb0f(predicate, xs);
    if (matchValue == null) return $42cbcefff7323768$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$5c13475397a61429(predicate, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const loop = (i_mut)=>{
            loop: while(true){
                const i = i_mut;
                if (e["System.Collections.IEnumerator.MoveNext"]()) {
                    if (predicate(e["System.Collections.Generic.IEnumerator`1.get_Current"]())) return i;
                    else {
                        i_mut = i + 1;
                        continue loop;
                    }
                } else return undefined;
                break;
            }
        };
        return loop(0);
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$de3a4d4a0d731119(predicate, xs) {
    const matchValue = $42cbcefff7323768$export$5c13475397a61429(predicate, xs);
    if (matchValue == null) {
        $42cbcefff7323768$export$6362f022d562392();
        return -1;
    } else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue) | 0;
}
function $42cbcefff7323768$export$e1cc954945760117(predicate, xs) {
    return (0, $e5d9070e144b905e$export$e1cc954945760117)(predicate, $42cbcefff7323768$export$45b10814cc054894(xs));
}
function $42cbcefff7323768$export$78e19deb30f83296(predicate, xs) {
    const matchValue = $42cbcefff7323768$export$e1cc954945760117(predicate, xs);
    if (matchValue == null) {
        $42cbcefff7323768$export$6362f022d562392();
        return -1;
    } else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue) | 0;
}
function $42cbcefff7323768$export$93e2b83da34ff82a(folder, state, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        let acc = state;
        while(e["System.Collections.IEnumerator.MoveNext"]())acc = folder(acc, e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        return acc;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$c38b8353041a4f48(folder, xs, state) {
    return (0, $e5d9070e144b905e$export$c38b8353041a4f48)(folder, $42cbcefff7323768$export$45b10814cc054894(xs), state);
}
function $42cbcefff7323768$export$6eef545db8c1f6e(folder, state, xs, ys) {
    const e1 = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const e2 = $42cbcefff7323768$export$c80b5fc7454ef206(ys);
        try {
            let acc = state;
            while(e1["System.Collections.IEnumerator.MoveNext"]() && e2["System.Collections.IEnumerator.MoveNext"]())acc = folder(acc, e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"]());
            return acc;
        } finally{
            (0, $kRS0m.disposeSafe)(e2);
        }
    } finally{
        (0, $kRS0m.disposeSafe)(e1);
    }
}
function $42cbcefff7323768$export$f04d6919de1a1f94(folder, xs, ys, state) {
    return (0, $e5d9070e144b905e$export$f04d6919de1a1f94)(folder, $42cbcefff7323768$export$45b10814cc054894(xs), $42cbcefff7323768$export$45b10814cc054894(ys), state);
}
function $42cbcefff7323768$export$e5bd981f5eeebe3b(predicate, xs) {
    return !$42cbcefff7323768$export$f7e9f41ea797a17((x)=>!predicate(x), xs);
}
function $42cbcefff7323768$export$a85e1ff32f9fff6e(predicate, xs, ys) {
    return !$42cbcefff7323768$export$d04ae74aaa2c0655((x, y)=>!predicate(x, y), xs, ys);
}
function $42cbcefff7323768$export$1acbe849d0cb723e(xs) {
    if ((0, $kRS0m.isArrayLike)(xs)) return (0, $e5d9070e144b905e$export$1acbe849d0cb723e)(xs);
    else if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return (0, $e08834e1786645d9$export$1acbe849d0cb723e)(xs);
    else {
        const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
        try {
            return e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) : undefined;
        } finally{
            (0, $kRS0m.disposeSafe)(e);
        }
    }
}
function $42cbcefff7323768$export$5fd5031fecdacec3(xs) {
    const matchValue = $42cbcefff7323768$export$1acbe849d0cb723e(xs);
    if (matchValue == null) throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a + "\\nParameter name: " + "source");
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$2a47f398eeff8b01(count, f) {
    return $42cbcefff7323768$export$c48e357c1a89b78d((i)=>i < count ? [
            f(i),
            i + 1
        ] : undefined, 0);
}
function $42cbcefff7323768$export$eac530aded73d64c(f) {
    return $42cbcefff7323768$export$2a47f398eeff8b01(2147483647, f);
}
function $42cbcefff7323768$export$dd1bc94b04021eeb(xs) {
    if ((0, $kRS0m.isArrayLike)(xs)) {
        const a = xs;
        return a.length === 0;
    } else if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return (0, $e08834e1786645d9$export$dd1bc94b04021eeb)(xs);
    else {
        const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
        try {
            return !e["System.Collections.IEnumerator.MoveNext"]();
        } finally{
            (0, $kRS0m.disposeSafe)(e);
        }
    }
}
function $42cbcefff7323768$export$3fe40c3a4d8cb094(index, xs) {
    if ((0, $kRS0m.isArrayLike)(xs)) return (0, $e5d9070e144b905e$export$3fe40c3a4d8cb094)(index, xs);
    else if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return (0, $e08834e1786645d9$export$3fe40c3a4d8cb094)(index, xs);
    else {
        const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
        try {
            const loop = (index_1_mut)=>{
                loop: while(true){
                    const index_1 = index_1_mut;
                    if (!e["System.Collections.IEnumerator.MoveNext"]()) return undefined;
                    else if (index_1 === 0) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
                    else {
                        index_1_mut = index_1 - 1;
                        continue loop;
                    }
                    break;
                }
            };
            return loop(index);
        } finally{
            (0, $kRS0m.disposeSafe)(e);
        }
    }
}
function $42cbcefff7323768$export$7061c75fc5af8b7e(index, xs) {
    const matchValue = $42cbcefff7323768$export$3fe40c3a4d8cb094(index, xs);
    if (matchValue == null) throw new Error($42cbcefff7323768$export$9f17aeddfa374276 + "\\nParameter name: " + "index");
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$c1a059043cc9c119(action, xs) {
    $42cbcefff7323768$export$93e2b83da34ff82a((unitVar, x)=>{
        action(x);
    }, undefined, xs);
}
function $42cbcefff7323768$export$d1731a37ee7d4fbb(action, xs, ys) {
    $42cbcefff7323768$export$6eef545db8c1f6e((unitVar, x, y)=>{
        action(x, y);
    }, undefined, xs, ys);
}
function $42cbcefff7323768$export$5a067165821eae2d(action, xs) {
    $42cbcefff7323768$export$93e2b83da34ff82a((i, x)=>{
        action(i, x);
        return i + 1 | 0;
    }, 0, xs);
}
function $42cbcefff7323768$export$ab3c1f9aeb4948fd(action, xs, ys) {
    $42cbcefff7323768$export$6eef545db8c1f6e((i, x, y)=>{
        action(i, x, y);
        return i + 1 | 0;
    }, 0, xs, ys);
}
function $42cbcefff7323768$export$e5907b21d797cce6(xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const loop = (acc_mut)=>{
            loop: while(true){
                const acc = acc_mut;
                if (!e["System.Collections.IEnumerator.MoveNext"]()) return acc;
                else {
                    acc_mut = e["System.Collections.Generic.IEnumerator`1.get_Current"]();
                    continue loop;
                }
                break;
            }
        };
        return e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(loop(e["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$4c7897fafd92b108(xs) {
    const matchValue = $42cbcefff7323768$export$e5907b21d797cce6(xs);
    if (matchValue == null) throw new Error($42cbcefff7323768$export$9f17aeddfa374276 + "\\nParameter name: " + "source");
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$f24224f1c91d8156(xs) {
    if ((0, $kRS0m.isArrayLike)(xs)) {
        const a = xs;
        return a.length | 0;
    } else if (xs instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return (0, $e08834e1786645d9$export$f24224f1c91d8156)(xs) | 0;
    else {
        const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
        try {
            let count = 0;
            while(e["System.Collections.IEnumerator.MoveNext"]())count = count + 1 | 0;
            return count | 0;
        } finally{
            (0, $kRS0m.disposeSafe)(e);
        }
    }
}
function $42cbcefff7323768$export$871de8747c9eaa88(mapping, xs) {
    return $42cbcefff7323768$export$80d376111cc09ad7(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (e)=>e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(mapping(e["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$e5bd5b3b105c2a71(mapping, xs) {
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(mapping(i, e["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$ddf7c77acd0bf516(xs) {
    return $42cbcefff7323768$export$e5bd5b3b105c2a71((i, x)=>[
            i,
            x
        ], xs);
}
function $42cbcefff7323768$export$5be556bf484c4f10(mapping, xs, ys) {
    return $42cbcefff7323768$export$80d376111cc09ad7(()=>[
            $42cbcefff7323768$export$c80b5fc7454ef206(xs),
            $42cbcefff7323768$export$c80b5fc7454ef206(ys)
        ], (tupledArg)=>{
        const e1 = tupledArg[0];
        const e2 = tupledArg[1];
        return e1["System.Collections.IEnumerator.MoveNext"]() && e2["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(mapping(e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined;
    }, (tupledArg_1)=>{
        try {
            (0, $kRS0m.disposeSafe)(tupledArg_1[0]);
        } finally{
            (0, $kRS0m.disposeSafe)(tupledArg_1[1]);
        }
    });
}
function $42cbcefff7323768$export$aded800c294daba4(mapping, xs, ys) {
    return $42cbcefff7323768$export$7395da449cea18d1(()=>[
            $42cbcefff7323768$export$c80b5fc7454ef206(xs),
            $42cbcefff7323768$export$c80b5fc7454ef206(ys)
        ], (i, tupledArg)=>{
        const e1 = tupledArg[0];
        const e2 = tupledArg[1];
        return e1["System.Collections.IEnumerator.MoveNext"]() && e2["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(mapping(i, e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined;
    }, (tupledArg_1)=>{
        try {
            (0, $kRS0m.disposeSafe)(tupledArg_1[0]);
        } finally{
            (0, $kRS0m.disposeSafe)(tupledArg_1[1]);
        }
    });
}
function $42cbcefff7323768$export$f7389512af34c855(mapping, xs, ys, zs) {
    return $42cbcefff7323768$export$80d376111cc09ad7(()=>[
            $42cbcefff7323768$export$c80b5fc7454ef206(xs),
            $42cbcefff7323768$export$c80b5fc7454ef206(ys),
            $42cbcefff7323768$export$c80b5fc7454ef206(zs)
        ], (tupledArg)=>{
        const e1 = tupledArg[0];
        const e2 = tupledArg[1];
        const e3 = tupledArg[2];
        return e1["System.Collections.IEnumerator.MoveNext"]() && e2["System.Collections.IEnumerator.MoveNext"]() && e3["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(mapping(e1["System.Collections.Generic.IEnumerator`1.get_Current"](), e2["System.Collections.Generic.IEnumerator`1.get_Current"](), e3["System.Collections.Generic.IEnumerator`1.get_Current"]())) : undefined;
    }, (tupledArg_1)=>{
        try {
            (0, $kRS0m.disposeSafe)(tupledArg_1[0]);
        } finally{
            try {
                (0, $kRS0m.disposeSafe)(tupledArg_1[1]);
            } finally{
                (0, $kRS0m.disposeSafe)(tupledArg_1[2]);
            }
        }
    });
}
function $42cbcefff7323768$export$b2cbc93d4da94977(xs) {
    $42cbcefff7323768$export$14d5e08ade3f14c2("source", xs);
    return $42cbcefff7323768$export$871de8747c9eaa88((x)=>x, xs);
}
class $42cbcefff7323768$export$52178a8464ab8b5 {
    constructor(cleanup, res){
        this.cleanup = cleanup;
        this.res = res;
    }
    Dispose() {
        const _ = this;
        _.cleanup();
    }
    GetEnumerator() {
        const _ = this;
        return (0, $kRS0m.getEnumerator)(_.res);
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const _ = this;
        return (0, $kRS0m.getEnumerator)(_.res);
    }
}
function $42cbcefff7323768$export$f734367d56f36251(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("SeqModule.CachedSeq`1", [
        gen0
    ], $42cbcefff7323768$export$52178a8464ab8b5);
}
function $42cbcefff7323768$export$3e405a892b2f2a5a(cleanup, res) {
    return new $42cbcefff7323768$export$52178a8464ab8b5(cleanup, res);
}
function $42cbcefff7323768$export$d9518c87d556a0bb(_) {
    _.cleanup();
}
function $42cbcefff7323768$export$69a3209f1a06c04d(source) {
    $42cbcefff7323768$export$14d5e08ade3f14c2("source", source);
    const prefix = [];
    let enumeratorR = undefined;
    return $42cbcefff7323768$export$3e405a892b2f2a5a(()=>{
        (0, $aa6a350ee7474f21$export$71bc834cee2b44c0)(prefix, ()=>{
            (0, $kRS0m.clear)(prefix);
            let matchResult, e;
            if (enumeratorR != null) {
                if ((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(enumeratorR) != null) {
                    matchResult = 0;
                    e = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(enumeratorR));
                } else matchResult = 1;
            } else matchResult = 1;
            switch(matchResult){
                case 0:
                    (0, $kRS0m.disposeSafe)(e);
                    break;
            }
            enumeratorR = undefined;
        });
    }, $42cbcefff7323768$export$c48e357c1a89b78d((i_1)=>(0, $aa6a350ee7474f21$export$71bc834cee2b44c0)(prefix, ()=>{
            if (i_1 < prefix.length) return [
                prefix[i_1],
                i_1 + 1
            ];
            else {
                if (i_1 >= prefix.length) {
                    let optEnumerator_2;
                    if (enumeratorR != null) optEnumerator_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(enumeratorR);
                    else {
                        const optEnumerator = (0, $kRS0m.getEnumerator)(source);
                        enumeratorR = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(optEnumerator);
                        optEnumerator_2 = optEnumerator;
                    }
                    if (optEnumerator_2 == null) ;
                    else {
                        const enumerator = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(optEnumerator_2);
                        if (enumerator["System.Collections.IEnumerator.MoveNext"]()) prefix.push(enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]());
                        else {
                            (0, $kRS0m.disposeSafe)(enumerator);
                            enumeratorR = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(undefined);
                        }
                    }
                }
                if (i_1 < prefix.length) return [
                    prefix[i_1],
                    i_1 + 1
                ];
                else return undefined;
            }
        }), 0));
}
function $42cbcefff7323768$export$8016484fb8238078(xs, ys) {
    const ysCache = $42cbcefff7323768$export$69a3209f1a06c04d(ys);
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$ee1b3e54f0441b22($42cbcefff7323768$export$871de8747c9eaa88((x)=>$42cbcefff7323768$export$871de8747c9eaa88((y)=>[
                    x,
                    y
                ], ysCache), xs)));
}
function $42cbcefff7323768$export$9b19c2e3f2aab20f(mapping, state, xs) {
    const patternInput = (0, $e5d9070e144b905e$export$9b19c2e3f2aab20f)(mapping, state, $42cbcefff7323768$export$45b10814cc054894(xs));
    return [
        $42cbcefff7323768$export$b2cbc93d4da94977(patternInput[0]),
        patternInput[1]
    ];
}
function $42cbcefff7323768$export$6d7c6abab27be307(mapping, xs, state) {
    const patternInput = (0, $e5d9070e144b905e$export$6d7c6abab27be307)(mapping, $42cbcefff7323768$export$45b10814cc054894(xs), state);
    return [
        $42cbcefff7323768$export$b2cbc93d4da94977(patternInput[0]),
        patternInput[1]
    ];
}
function $42cbcefff7323768$export$d944e5c60afb688e(chooser, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        let res = undefined;
        while(res == null && e["System.Collections.IEnumerator.MoveNext"]())res = chooser(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        return res;
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$357523c63a2253b9(chooser, xs) {
    const matchValue = $42cbcefff7323768$export$d944e5c60afb688e(chooser, xs);
    if (matchValue == null) return $42cbcefff7323768$export$6362f022d562392();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $42cbcefff7323768$export$533b26079ad0b4b(folder, xs) {
    const e = $42cbcefff7323768$export$c80b5fc7454ef206(xs);
    try {
        const loop = (acc_mut)=>{
            loop: while(true){
                const acc = acc_mut;
                if (e["System.Collections.IEnumerator.MoveNext"]()) {
                    acc_mut = folder(acc, e["System.Collections.Generic.IEnumerator`1.get_Current"]());
                    continue loop;
                } else return acc;
                break;
            }
        };
        if (e["System.Collections.IEnumerator.MoveNext"]()) return loop(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        else throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a);
    } finally{
        (0, $kRS0m.disposeSafe)(e);
    }
}
function $42cbcefff7323768$export$90cf02207d4ef99b(folder, xs) {
    const arr = $42cbcefff7323768$export$45b10814cc054894(xs);
    if (arr.length > 0) return arr.reduceRight(folder);
    else throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a);
}
function $42cbcefff7323768$export$606959e7ccb797f0(n, x) {
    return $42cbcefff7323768$export$2a47f398eeff8b01(n, (_arg)=>x);
}
function $42cbcefff7323768$export$66c1ae025e96b4bc(xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$66c1ae025e96b4bc)($42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$c87d910e63d22ed6(folder, state, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>{
        let acc = state;
        return $42cbcefff7323768$export$ee1b3e54f0441b22([
            $42cbcefff7323768$export$439306a4dcaafbb9(state),
            $42cbcefff7323768$export$871de8747c9eaa88((x)=>{
                acc = folder(acc, x);
                return acc;
            }, xs)
        ]);
    });
}
function $42cbcefff7323768$export$7bd1078b283d99ad(folder, xs, state) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$7bd1078b283d99ad)(folder, $42cbcefff7323768$export$45b10814cc054894(xs), state)));
}
function $42cbcefff7323768$export$955fc4a6c4be454d(count, source) {
    return $42cbcefff7323768$export$327d67905f90fa80(()=>{
        const e = $42cbcefff7323768$export$c80b5fc7454ef206(source);
        try {
            for(let _ = 1; _ <= count; _++){
                if (!e["System.Collections.IEnumerator.MoveNext"]()) throw new Error($42cbcefff7323768$export$9f17aeddfa374276 + "\\nParameter name: " + "source");
            }
            return $42cbcefff7323768$export$8da5aab8659eb06(()=>{}, e);
        } catch (matchValue) {
            (0, $kRS0m.disposeSafe)(e);
            throw matchValue;
        }
    });
}
function $42cbcefff7323768$export$175dedd748069215(predicate, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>{
        let skipped = true;
        return $42cbcefff7323768$export$3dea766d36a8935f((x)=>{
            if (skipped) skipped = predicate(x);
            return !skipped;
        }, xs);
    });
}
function $42cbcefff7323768$export$c01875f616615628(xs) {
    return $42cbcefff7323768$export$955fc4a6c4be454d(1, xs);
}
function $42cbcefff7323768$export$b7df5d561049483a(count, xs) {
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>{
        if (i < count) {
            if (e["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
            else throw new Error($42cbcefff7323768$export$9f17aeddfa374276 + "\\nParameter name: " + "source");
        } else return undefined;
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$9384c7afe4015e42(predicate, xs) {
    return $42cbcefff7323768$export$80d376111cc09ad7(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (e)=>e["System.Collections.IEnumerator.MoveNext"]() && predicate(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) : undefined, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$6a506b36fdea397d(count, xs) {
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>i < count && e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) : undefined, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$8901015135f2fb22(xs, ys) {
    return $42cbcefff7323768$export$5be556bf484c4f10((x, y)=>[
            x,
            y
        ], xs, ys);
}
function $42cbcefff7323768$export$a3c629e5d025ffc1(xs, ys, zs) {
    return $42cbcefff7323768$export$f7389512af34c855((x, y, z)=>[
            x,
            y,
            z
        ], xs, ys, zs);
}
function $42cbcefff7323768$export$bb44f104e3c54dae(mapping, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$ee1b3e54f0441b22($42cbcefff7323768$export$871de8747c9eaa88(mapping, xs)));
}
function $42cbcefff7323768$export$9c59b80dda569a6e(predicate, xs) {
    return $42cbcefff7323768$export$3dea766d36a8935f(predicate, xs);
}
function $42cbcefff7323768$export$8f9d79d42bff1aac(xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$8f9d79d42bff1aac)($42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$7120a88bf3d39e8(chunks, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$7120a88bf3d39e8)(chunks, $42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$5f2b86065ccf5a1(windowSize, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$5f2b86065ccf5a1)(windowSize, $42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$9cb09a71b7d66923(xss) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$871de8747c9eaa88)($42cbcefff7323768$export$cb197a913f6bb809, (0, $e5d9070e144b905e$export$9cb09a71b7d66923)((0, $e5d9070e144b905e$export$871de8747c9eaa88)($42cbcefff7323768$export$45b10814cc054894, $42cbcefff7323768$export$45b10814cc054894(xss))))));
}
function $42cbcefff7323768$export$a9e7d1a6fdcfefde(comparer, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>{
        const arr = $42cbcefff7323768$export$45b10814cc054894(xs);
        arr.sort(comparer);
        return $42cbcefff7323768$export$cb197a913f6bb809(arr);
    });
}
function $42cbcefff7323768$export$97db5808d8f88186(xs, comparer) {
    return $42cbcefff7323768$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(x, y), xs);
}
function $42cbcefff7323768$export$b035e44d7bb4278f(projection, xs, comparer) {
    return $42cbcefff7323768$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(projection(x), projection(y)), xs);
}
function $42cbcefff7323768$export$9a59fdf05ed66d15(xs, comparer) {
    return $42cbcefff7323768$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(x, y) * -1, xs);
}
function $42cbcefff7323768$export$ca6dab212df382f6(projection, xs, comparer) {
    return $42cbcefff7323768$export$a9e7d1a6fdcfefde((x, y)=>comparer.Compare(projection(x), projection(y)) * -1, xs);
}
function $42cbcefff7323768$export$8a63f25cc62965f1(xs, adder) {
    return $42cbcefff7323768$export$93e2b83da34ff82a((acc, x)=>adder.Add(acc, x), adder.GetZero(), xs);
}
function $42cbcefff7323768$export$9e8299ab977385a3(f, xs, adder) {
    return $42cbcefff7323768$export$93e2b83da34ff82a((acc, x)=>adder.Add(acc, f(x)), adder.GetZero(), xs);
}
function $42cbcefff7323768$export$ad1963a493908da4(projection, xs, comparer) {
    return $42cbcefff7323768$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? y : x, xs);
}
function $42cbcefff7323768$export$8960430cfd85939f(xs, comparer) {
    return $42cbcefff7323768$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? y : x, xs);
}
function $42cbcefff7323768$export$8c826aa0fa59ac68(projection, xs, comparer) {
    return $42cbcefff7323768$export$533b26079ad0b4b((x, y)=>comparer.Compare(projection(y), projection(x)) > 0 ? x : y, xs);
}
function $42cbcefff7323768$export$96ec731ed4dcb222(xs, comparer) {
    return $42cbcefff7323768$export$533b26079ad0b4b((x, y)=>comparer.Compare(y, x) > 0 ? x : y, xs);
}
function $42cbcefff7323768$export$cc6710ee5f037d57(xs, averager) {
    let count = 0;
    const total = $42cbcefff7323768$export$93e2b83da34ff82a((acc, x)=>{
        count = count + 1 | 0;
        return averager.Add(acc, x);
    }, averager.GetZero(), xs);
    if (count === 0) throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a + "\\nParameter name: " + "source");
    else return averager.DivideByInt(total, count);
}
function $42cbcefff7323768$export$9077387bc3582185(f, xs, averager) {
    let count = 0;
    const total = $42cbcefff7323768$export$93e2b83da34ff82a((acc, x)=>{
        count = count + 1 | 0;
        return averager.Add(acc, f(x));
    }, averager.GetZero(), xs);
    if (count === 0) throw new Error($42cbcefff7323768$export$bb8ebba5bfe3f17a + "\\nParameter name: " + "source");
    else return averager.DivideByInt(total, count);
}
function $42cbcefff7323768$export$95e62ad65da8b7d2(f, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$95e62ad65da8b7d2)(f, $42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$6302d00ba2848bf(chunkSize, xs) {
    return $42cbcefff7323768$export$1391212d75b2ee65(()=>$42cbcefff7323768$export$cb197a913f6bb809((0, $e5d9070e144b905e$export$6302d00ba2848bf)(chunkSize, $42cbcefff7323768$export$45b10814cc054894(xs))));
}
function $42cbcefff7323768$export$9f200c4466975173(index, y, xs) {
    let isDone = false;
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>{
        if ((isDone ? true : i < index) && e["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        else if (i === index) {
            isDone = true;
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(y);
        } else {
            if (!isDone) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
            return undefined;
        }
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$97e8c8737f8994b9(index, ys, xs) {
    let status = -1;
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return $42cbcefff7323768$export$7395da449cea18d1(()=>[
            $42cbcefff7323768$export$c80b5fc7454ef206(xs),
            $42cbcefff7323768$export$c80b5fc7454ef206(ys)
        ], (i, tupledArg)=>{
        const e1 = tupledArg[0];
        const e2 = tupledArg[1];
        if (i === index) status = 0;
        let inserted;
        if (status === 0) {
            if (e2["System.Collections.IEnumerator.MoveNext"]()) inserted = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e2["System.Collections.Generic.IEnumerator`1.get_Current"]());
            else {
                status = 1;
                inserted = undefined;
            }
        } else inserted = undefined;
        if (inserted == null) {
            if (e1["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e1["System.Collections.Generic.IEnumerator`1.get_Current"]());
            else {
                if (status < 1) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
                return undefined;
            }
        } else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(inserted));
    }, (tupledArg_1)=>{
        (0, $kRS0m.disposeSafe)(tupledArg_1[0]);
        (0, $kRS0m.disposeSafe)(tupledArg_1[1]);
    });
}
function $42cbcefff7323768$export$aa72b1a59562dee2(index, xs) {
    let isDone = false;
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>{
        if ((isDone ? true : i < index) && e["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        else if (i === index && e["System.Collections.IEnumerator.MoveNext"]()) {
            isDone = true;
            return e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) : undefined;
        } else {
            if (!isDone) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
            return undefined;
        }
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$a1b32c1cdbbe428e(index, count, xs) {
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>{
        if (i < index) {
            if (e["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
            else throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
        } else {
            if (i === index) for(let _ = 1; _ <= count; _++){
                if (!e["System.Collections.IEnumerator.MoveNext"]()) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "count");
            }
            return e["System.Collections.IEnumerator.MoveNext"]() ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]()) : undefined;
        }
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}
function $42cbcefff7323768$export$b6d8713d53419d4c(index, y, xs) {
    let isDone = false;
    if (index < 0) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
    return $42cbcefff7323768$export$7395da449cea18d1(()=>$42cbcefff7323768$export$c80b5fc7454ef206(xs), (i, e)=>{
        if ((isDone ? true : i < index) && e["System.Collections.IEnumerator.MoveNext"]()) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e["System.Collections.Generic.IEnumerator`1.get_Current"]());
        else if (i === index && e["System.Collections.IEnumerator.MoveNext"]()) {
            isDone = true;
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(y);
        } else {
            if (!isDone) throw new Error((0, $9216d27711cc273c$export$1d7558b55257001d) + "\\nParameter name: " + "index");
            return undefined;
        }
    }, (e_1)=>{
        (0, $kRS0m.disposeSafe)(e_1);
    });
}




parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $cc1z1 = parcelRequire("cc1z1");
const $f559a3d33a977349$export$88214af1db8f02e1 = (0, $cc1z1.default);






var $98d8e74a1fff5068$export$2fb4bfa701a7ee12;
(function(NumberStyles) {
    // None = 0x00000000,
    // AllowLeadingWhite = 0x00000001,
    // AllowTrailingWhite = 0x00000002,
    // AllowLeadingSign = 0x00000004,
    // AllowTrailingSign = 0x00000008,
    // AllowParentheses = 0x00000010,
    // AllowDecimalPoint = 0x00000020,
    // AllowThousands = 0x00000040,
    // AllowExponent = 0x00000080,
    // AllowCurrencySymbol = 0x00000100,
    NumberStyles[NumberStyles["AllowHexSpecifier"] = 512] = "AllowHexSpecifier";
// Integer = AllowLeadingWhite | AllowTrailingWhite | AllowLeadingSign,
// HexNumber = AllowLeadingWhite | AllowTrailingWhite | AllowHexSpecifier,
// Number = AllowLeadingWhite | AllowTrailingWhite | AllowLeadingSign |
//          AllowTrailingSign | AllowDecimalPoint | AllowThousands,
// Float = AllowLeadingWhite | AllowTrailingWhite | AllowLeadingSign |
//         AllowDecimalPoint | AllowExponent,
// Currency = AllowLeadingWhite | AllowTrailingWhite | AllowLeadingSign | AllowTrailingSign |
//            AllowParentheses | AllowDecimalPoint | AllowThousands | AllowCurrencySymbol,
// Any = AllowLeadingWhite | AllowTrailingWhite | AllowLeadingSign | AllowTrailingSign |
//       AllowParentheses | AllowDecimalPoint | AllowThousands | AllowCurrencySymbol | AllowExponent,
})($98d8e74a1fff5068$export$2fb4bfa701a7ee12 || ($98d8e74a1fff5068$export$2fb4bfa701a7ee12 = {}));
function $98d8e74a1fff5068$var$validResponse(regexMatch, radix) {
    const [, sign, prefix, digits] = regexMatch;
    return {
        sign: sign || "",
        prefix: prefix || "",
        digits: digits,
        radix: radix
    };
}
function $98d8e74a1fff5068$var$getRange(unsigned, bitsize) {
    switch(bitsize){
        case 8:
            return unsigned ? [
                0,
                255
            ] : [
                -128,
                127
            ];
        case 16:
            return unsigned ? [
                0,
                65535
            ] : [
                -32768,
                32767
            ];
        case 32:
            return unsigned ? [
                0,
                4294967295
            ] : [
                -2147483648,
                2147483647
            ];
        default:
            throw new Error("Invalid bit size.");
    }
}
function $98d8e74a1fff5068$var$getInvalidDigits(radix) {
    switch(radix){
        case 2:
            return /[^0-1]/;
        case 8:
            return /[^0-7]/;
        case 10:
            return /[^0-9]/;
        case 16:
            return /[^0-9a-fA-F]/;
        default:
            throw new Error("Invalid Base.");
    }
}
function $98d8e74a1fff5068$export$36e24695f02d4503(radix) {
    switch(radix){
        case 2:
            return "0b";
        case 8:
            return "0o";
        case 10:
            return "";
        case 16:
            return "0x";
        default:
            return "";
    }
}
function $98d8e74a1fff5068$export$77a7e7c53c75d0(prefix, style) {
    if (style & $98d8e74a1fff5068$export$2fb4bfa701a7ee12.AllowHexSpecifier) return 16;
    else switch(prefix){
        case "0b":
        case "0B":
            return 2;
        case "0o":
        case "0O":
            return 8;
        case "0x":
        case "0X":
            return 16;
        default:
            return 10;
    }
}
function $98d8e74a1fff5068$export$1ea939691cdc45b8(str, style, radix) {
    const integerRegex = /^\s*([\+\-])?(0[xXoObB])?([0-9a-fA-F]+)\s*$/;
    const res = integerRegex.exec(str.replace(/_/g, ""));
    if (res != null) {
        const [, , prefix, digits] = res;
        radix = radix || $98d8e74a1fff5068$export$77a7e7c53c75d0(prefix, style);
        const invalidDigits = $98d8e74a1fff5068$var$getInvalidDigits(radix);
        if (!invalidDigits.test(digits)) return $98d8e74a1fff5068$var$validResponse(res, radix);
    }
    return null;
}
function $98d8e74a1fff5068$export$98e6a39c04603d36(str, style, unsigned, bitsize, radix) {
    const res = $98d8e74a1fff5068$export$1ea939691cdc45b8(str, style, radix);
    if (res != null) {
        let v = Number.parseInt(res.sign + res.digits, res.radix);
        if (!Number.isNaN(v)) {
            const [umin, umax] = $98d8e74a1fff5068$var$getRange(true, bitsize);
            if (!unsigned && res.radix !== 10 && v >= umin && v <= umax) v = v << 32 - bitsize >> 32 - bitsize;
            const [min, max] = $98d8e74a1fff5068$var$getRange(unsigned, bitsize);
            if (v >= min && v <= max) return v;
        }
    }
    throw new Error(`The input string ${str} was not in a correct format.`);
}
function $98d8e74a1fff5068$export$468ff95b83d315e5(str, style, unsigned, bitsize, defValue) {
    try {
        defValue.contents = $98d8e74a1fff5068$export$98e6a39c04603d36(str, style, unsigned, bitsize);
        return true;
    } catch  {
        return false;
    }
}
function $98d8e74a1fff5068$export$4cbff5ef24614dc7(x) {
    return x === -128 ? x : -x;
}
function $98d8e74a1fff5068$export$9b736586c807d703(x) {
    return x === -32768 ? x : -x;
}
function $98d8e74a1fff5068$export$87c665ad90b41cb3(x) {
    return x === -2147483648 ? x : -x;
}
function $98d8e74a1fff5068$export$9edaf4efe6390181(x, y, out) {
    const div = ~~(x / y);
    const rem = x % y;
    if (out === void 0) return [
        div,
        rem
    ];
    else {
        out.contents = rem;
        return div;
    }
}




var $eATN7 = parcelRequire("eATN7");


var $eATN7 = parcelRequire("eATN7");







var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");





var $kRS0m = parcelRequire("kRS0m");




var $eATN7 = parcelRequire("eATN7");


class $3029827f1b7d692a$export$9d0bf21c11057332 {
    constructor(items, comparer){
        const this$ = new (0, $eATN7.FSharpRef)((0, $kRS0m.defaultOf)());
        this.comparer = comparer;
        this$.contents = this;
        this.hashMap = new Map([]);
        this["init@9"] = 1;
        const enumerator = (0, $kRS0m.getEnumerator)(items);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
                const item = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                $3029827f1b7d692a$export$546fe6eb9d17e6a0(this$.contents, item);
            }
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
    }
    get [Symbol.toStringTag]() {
        return "HashSet";
    }
    toJSON() {
        const this$ = this;
        return Array.from(this$);
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const this$ = this;
        return (0, $kRS0m.getEnumerator)(this$);
    }
    GetEnumerator() {
        const this$ = this;
        return (0, $kRS0m.getEnumerator)((0, $42cbcefff7323768$export$ee1b3e54f0441b22)(this$.hashMap.values()));
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.Generic.ICollection`1.Add2B595"(item) {
        const this$ = this;
        $3029827f1b7d692a$export$546fe6eb9d17e6a0(this$, item);
    }
    "System.Collections.Generic.ICollection`1.Clear"() {
        const this$ = this;
        $3029827f1b7d692a$export$2e1c82600e9ae4af(this$);
    }
    "System.Collections.Generic.ICollection`1.Contains2B595"(item) {
        const this$ = this;
        return $3029827f1b7d692a$export$136f9bd3edd2836a(this$, item);
    }
    "System.Collections.Generic.ICollection`1.CopyToZ3B4C077E"(array, arrayIndex) {
        const this$ = this;
        (0, $42cbcefff7323768$export$5a067165821eae2d)((i, e)=>{
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(array, arrayIndex + i, e);
        }, this$);
    }
    "System.Collections.Generic.ICollection`1.get_Count"() {
        const this$ = this;
        return $3029827f1b7d692a$export$82133222b99bbef3(this$) | 0;
    }
    "System.Collections.Generic.ICollection`1.get_IsReadOnly"() {
        return false;
    }
    "System.Collections.Generic.ICollection`1.Remove2B595"(item) {
        const this$ = this;
        return $3029827f1b7d692a$export$a81cc17abae4c38d(this$, item);
    }
    get size() {
        const this$ = this;
        return $3029827f1b7d692a$export$82133222b99bbef3(this$) | 0;
    }
    add(k) {
        const this$ = this;
        $3029827f1b7d692a$export$546fe6eb9d17e6a0(this$, k);
        return this$;
    }
    clear() {
        const this$ = this;
        $3029827f1b7d692a$export$2e1c82600e9ae4af(this$);
    }
    delete(k) {
        const this$ = this;
        return $3029827f1b7d692a$export$a81cc17abae4c38d(this$, k);
    }
    has(k) {
        const this$ = this;
        return $3029827f1b7d692a$export$136f9bd3edd2836a(this$, k);
    }
    keys() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>x, this$);
    }
    values() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>x, this$);
    }
    entries() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((v)=>[
                v,
                v
            ], this$);
    }
    forEach(f, thisArg) {
        const this$ = this;
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((x)=>{
            f(x, x, this$);
        }, this$);
    }
}
function $3029827f1b7d692a$export$a2a3f3c6757c3c7e(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.Collections.HashSet", [
        gen0
    ], $3029827f1b7d692a$export$9d0bf21c11057332);
}
function $3029827f1b7d692a$export$66454eb65fce2240(items, comparer) {
    return new $3029827f1b7d692a$export$9d0bf21c11057332(items, comparer);
}
function $3029827f1b7d692a$var$HashSet__TryFindIndex_2B595(this$, k) {
    const h = this$.comparer.GetHashCode(k) | 0;
    let matchValue;
    let outArg = (0, $kRS0m.defaultOf)();
    matchValue = [
        (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(this$.hashMap, h, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ];
    if (matchValue[0]) return [
        true,
        h,
        matchValue[1].findIndex((v_1)=>this$.comparer.Equals(k, v_1))
    ];
    else return [
        false,
        h,
        -1
    ];
}
function $3029827f1b7d692a$var$HashSet__TryFind_2B595(this$, k) {
    const matchValue = $3029827f1b7d692a$var$HashSet__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1])[matchValue[2]]);
        default:
            return undefined;
    }
}
function $3029827f1b7d692a$export$6edb119d1846f7a8(this$) {
    return this$.comparer;
}
function $3029827f1b7d692a$export$2e1c82600e9ae4af(this$) {
    this$.hashMap.clear();
}
function $3029827f1b7d692a$export$82133222b99bbef3(this$) {
    let count = 0;
    let enumerator = (0, $kRS0m.getEnumerator)(this$.hashMap.values());
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const items = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            count = count + items.length | 0;
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return count | 0;
}
function $3029827f1b7d692a$export$546fe6eb9d17e6a0(this$, k) {
    const matchValue = $3029827f1b7d692a$var$HashSet__TryFindIndex_2B595(this$, k);
    if (matchValue[0]) {
        if (matchValue[2] > -1) return false;
        else {
            const value = void (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1]).push(k);
            return true;
        }
    } else {
        this$.hashMap.set(matchValue[1], [
            k
        ]);
        return true;
    }
}
function $3029827f1b7d692a$export$136f9bd3edd2836a(this$, k) {
    const matchValue = $3029827f1b7d692a$var$HashSet__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return true;
        default:
            return false;
    }
}
function $3029827f1b7d692a$export$a81cc17abae4c38d(this$, k) {
    const matchValue = $3029827f1b7d692a$var$HashSet__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1]).splice(matchValue[2], 1);
            return true;
        default:
            return false;
    }
}


class $70b963136d0d9ffe$export$13543b72fbe26180 {
    constructor(k){
        this.k = k;
    }
}
function $70b963136d0d9ffe$export$5cbc4c30f146386f(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Set.SetTreeLeaf`1", [
        gen0
    ], $70b963136d0d9ffe$export$13543b72fbe26180);
}
function $70b963136d0d9ffe$export$5996c62447ec32dc(k) {
    return new $70b963136d0d9ffe$export$13543b72fbe26180(k);
}
function $70b963136d0d9ffe$export$45c0aadcd3d191fc(_) {
    return _.k;
}
class $70b963136d0d9ffe$export$24d1adc20488b851 extends $70b963136d0d9ffe$export$13543b72fbe26180 {
    constructor(v, left, right, h){
        super(v);
        this.left = left;
        this.right = right;
        this.h = h | 0;
    }
}
function $70b963136d0d9ffe$export$7e7a5a7eca3ae995(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Set.SetTreeNode`1", [
        gen0
    ], $70b963136d0d9ffe$export$24d1adc20488b851, $70b963136d0d9ffe$export$5cbc4c30f146386f(gen0));
}
function $70b963136d0d9ffe$export$a36da15ead77cf48(v, left, right, h) {
    return new $70b963136d0d9ffe$export$24d1adc20488b851(v, left, right, h);
}
function $70b963136d0d9ffe$export$3a6709e904d70df6(_) {
    return _.left;
}
function $70b963136d0d9ffe$export$c48088e0810c0478(_) {
    return _.right;
}
function $70b963136d0d9ffe$export$44830e1b4642d2f2(_) {
    return _.h;
}
function $70b963136d0d9ffe$export$789a9e5439ddb314() {
    return undefined;
}
function $70b963136d0d9ffe$export$8912492b8ec9b6e6(t_mut, acc_mut) {
    SetTreeModule_countAux: while(true){
        const t = t_mut, acc = acc_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                acc_mut = $70b963136d0d9ffe$export$8912492b8ec9b6e6($70b963136d0d9ffe$export$c48088e0810c0478(tn), acc + 1);
                continue SetTreeModule_countAux;
            } else return acc + 1 | 0;
        } else return acc | 0;
        break;
    }
}
function $70b963136d0d9ffe$export$f65a0d7730a61e07(s) {
    return $70b963136d0d9ffe$export$8912492b8ec9b6e6(s, 0);
}
function $70b963136d0d9ffe$export$c3c52fb53cb440cd(l, k, r) {
    let tn, tn_1;
    let hl;
    const t = l;
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        hl = t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn = t2, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn)) : 1;
    } else hl = 0;
    let hr;
    const t_1 = r;
    if (t_1 != null) {
        const t2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t_1);
        hr = t2_1 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn_1 = t2_1, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn_1)) : 1;
    } else hr = 0;
    const m = (hl < hr ? hr : hl) | 0;
    if (m === 0) return $70b963136d0d9ffe$export$5996c62447ec32dc(k);
    else return $70b963136d0d9ffe$export$a36da15ead77cf48(k, l, r, m + 1);
}
function $70b963136d0d9ffe$export$65b35bfea104d2ba(t1, v, t2) {
    let tn, tn_1, t_2, t2_3, tn_2, t_3, t2_4, tn_3;
    let t1h;
    const t = t1;
    if (t != null) {
        const t2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        t1h = t2_1 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn = t2_1, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn)) : 1;
    } else t1h = 0;
    let t2h;
    const t_1 = t2;
    if (t_1 != null) {
        const t2_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t_1);
        t2h = t2_2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn_1 = t2_2, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn_1)) : 1;
    } else t2h = 0;
    if (t2h > t1h + 2) {
        const matchValue = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t2);
        if (matchValue instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const t2$0027 = matchValue;
            if ((t_2 = $70b963136d0d9ffe$export$3a6709e904d70df6(t2$0027), t_2 != null ? (t2_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t_2), t2_3 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn_2 = t2_3, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn_2)) : 1) : 0) > t1h + 1) {
                const matchValue_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($70b963136d0d9ffe$export$3a6709e904d70df6(t2$0027));
                if (matchValue_1 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const t2l = matchValue_1;
                    return $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c3c52fb53cb440cd(t1, v, $70b963136d0d9ffe$export$3a6709e904d70df6(t2l)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2l), $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c48088e0810c0478(t2l), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2$0027), $70b963136d0d9ffe$export$c48088e0810c0478(t2$0027)));
                } else throw new Error("internal error: Set.rebalance");
            } else return $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c3c52fb53cb440cd(t1, v, $70b963136d0d9ffe$export$3a6709e904d70df6(t2$0027)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2$0027), $70b963136d0d9ffe$export$c48088e0810c0478(t2$0027));
        } else throw new Error("internal error: Set.rebalance");
    } else if (t1h > t2h + 2) {
        const matchValue_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t1);
        if (matchValue_2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const t1$0027 = matchValue_2;
            if ((t_3 = $70b963136d0d9ffe$export$c48088e0810c0478(t1$0027), t_3 != null ? (t2_4 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t_3), t2_4 instanceof $70b963136d0d9ffe$export$24d1adc20488b851 ? (tn_3 = t2_4, $70b963136d0d9ffe$export$44830e1b4642d2f2(tn_3)) : 1) : 0) > t2h + 1) {
                const matchValue_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($70b963136d0d9ffe$export$c48088e0810c0478(t1$0027));
                if (matchValue_3 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const t1r = matchValue_3;
                    return $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$3a6709e904d70df6(t1$0027), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1$0027), $70b963136d0d9ffe$export$3a6709e904d70df6(t1r)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1r), $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c48088e0810c0478(t1r), v, t2));
                } else throw new Error("internal error: Set.rebalance");
            } else return $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$3a6709e904d70df6(t1$0027), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1$0027), $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$c48088e0810c0478(t1$0027), v, t2));
        } else throw new Error("internal error: Set.rebalance");
    } else return $70b963136d0d9ffe$export$c3c52fb53cb440cd(t1, v, t2);
}
function $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        const c = comparer.Compare(k, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2)) | 0;
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            if (c < 0) return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, $70b963136d0d9ffe$export$3a6709e904d70df6(tn)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$c48088e0810c0478(tn));
            else if (c === 0) return t;
            else return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$3a6709e904d70df6(tn), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, $70b963136d0d9ffe$export$c48088e0810c0478(tn)));
        } else {
            const c_1 = comparer.Compare(k, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2)) | 0;
            if (c_1 < 0) return $70b963136d0d9ffe$export$a36da15ead77cf48(k, $70b963136d0d9ffe$export$789a9e5439ddb314(), t, 2);
            else if (c_1 === 0) return t;
            else return $70b963136d0d9ffe$export$a36da15ead77cf48(k, t, $70b963136d0d9ffe$export$789a9e5439ddb314(), 2);
        }
    } else return $70b963136d0d9ffe$export$5996c62447ec32dc(k);
}
function $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, t1, k, t2) {
    if (t1 != null) {
        const t1$0027 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t1);
        if (t2 != null) {
            const t2$0027 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t2);
            if (t1$0027 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const t1n = t1$0027;
                if (t2$0027 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const t2n = t2$0027;
                    if ($70b963136d0d9ffe$export$44830e1b4642d2f2(t1n) + 2 < $70b963136d0d9ffe$export$44830e1b4642d2f2(t2n)) return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, t1, k, $70b963136d0d9ffe$export$3a6709e904d70df6(t2n)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2n), $70b963136d0d9ffe$export$c48088e0810c0478(t2n));
                    else if ($70b963136d0d9ffe$export$44830e1b4642d2f2(t2n) + 2 < $70b963136d0d9ffe$export$44830e1b4642d2f2(t1n)) return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$3a6709e904d70df6(t1n), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1n), $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, $70b963136d0d9ffe$export$c48088e0810c0478(t1n), k, t2));
                    else return $70b963136d0d9ffe$export$c3c52fb53cb440cd(t1, k, t2);
                } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2$0027), t1));
            } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1$0027), t2));
        } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, t1);
    } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, t2);
}
function $70b963136d0d9ffe$export$d3289c110494d73f(comparer, pivot, t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            const c = comparer.Compare(pivot, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)) | 0;
            if (c < 0) {
                const patternInput = $70b963136d0d9ffe$export$d3289c110494d73f(comparer, pivot, $70b963136d0d9ffe$export$3a6709e904d70df6(tn));
                return [
                    patternInput[0],
                    patternInput[1],
                    $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, patternInput[2], $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$c48088e0810c0478(tn))
                ];
            } else if (c === 0) return [
                $70b963136d0d9ffe$export$3a6709e904d70df6(tn),
                true,
                $70b963136d0d9ffe$export$c48088e0810c0478(tn)
            ];
            else {
                const patternInput_1 = $70b963136d0d9ffe$export$d3289c110494d73f(comparer, pivot, $70b963136d0d9ffe$export$c48088e0810c0478(tn));
                return [
                    $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, $70b963136d0d9ffe$export$3a6709e904d70df6(tn), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), patternInput_1[0]),
                    patternInput_1[1],
                    patternInput_1[2]
                ];
            }
        } else {
            const c_1 = comparer.Compare($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), pivot) | 0;
            if (c_1 < 0) return [
                t,
                false,
                $70b963136d0d9ffe$export$789a9e5439ddb314()
            ];
            else if (c_1 === 0) return [
                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                true,
                $70b963136d0d9ffe$export$789a9e5439ddb314()
            ];
            else return [
                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                false,
                t
            ];
        }
    } else return [
        $70b963136d0d9ffe$export$789a9e5439ddb314(),
        false,
        $70b963136d0d9ffe$export$789a9e5439ddb314()
    ];
}
function $70b963136d0d9ffe$export$5423851f97c35a04(t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            if ($70b963136d0d9ffe$export$3a6709e904d70df6(tn) == null) return [
                $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn),
                $70b963136d0d9ffe$export$c48088e0810c0478(tn)
            ];
            else {
                const patternInput = $70b963136d0d9ffe$export$5423851f97c35a04($70b963136d0d9ffe$export$3a6709e904d70df6(tn));
                return [
                    patternInput[0],
                    $70b963136d0d9ffe$export$c3c52fb53cb440cd(patternInput[1], $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$c48088e0810c0478(tn))
                ];
            }
        } else return [
            $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2),
            $70b963136d0d9ffe$export$789a9e5439ddb314()
        ];
    } else throw new Error("internal error: Set.spliceOutSuccessor");
}
function $70b963136d0d9ffe$export$d52c8967ecbb435f(comparer, k, t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        const c = comparer.Compare(k, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2)) | 0;
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            if (c < 0) return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$d52c8967ecbb435f(comparer, k, $70b963136d0d9ffe$export$3a6709e904d70df6(tn)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$c48088e0810c0478(tn));
            else if (c === 0) {
                if ($70b963136d0d9ffe$export$3a6709e904d70df6(tn) == null) return $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                else if ($70b963136d0d9ffe$export$c48088e0810c0478(tn) == null) return $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                else {
                    const patternInput = $70b963136d0d9ffe$export$5423851f97c35a04($70b963136d0d9ffe$export$c48088e0810c0478(tn));
                    return $70b963136d0d9ffe$export$c3c52fb53cb440cd($70b963136d0d9ffe$export$3a6709e904d70df6(tn), patternInput[0], patternInput[1]);
                }
            } else return $70b963136d0d9ffe$export$65b35bfea104d2ba($70b963136d0d9ffe$export$3a6709e904d70df6(tn), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$d52c8967ecbb435f(comparer, k, $70b963136d0d9ffe$export$c48088e0810c0478(tn)));
        } else if (c === 0) return $70b963136d0d9ffe$export$789a9e5439ddb314();
        else return t;
    } else return t;
}
function $70b963136d0d9ffe$export$c7e8af7f2034a817(comparer_mut, k_mut, t_mut) {
    SetTreeModule_mem: while(true){
        const comparer = comparer_mut, k = k_mut, t = t_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            const c = comparer.Compare(k, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2)) | 0;
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                if (c < 0) {
                    comparer_mut = comparer;
                    k_mut = k;
                    t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                    continue SetTreeModule_mem;
                } else if (c === 0) return true;
                else {
                    comparer_mut = comparer;
                    k_mut = k;
                    t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                    continue SetTreeModule_mem;
                }
            } else return c === 0;
        } else return false;
        break;
    }
}
function $70b963136d0d9ffe$export$37ebdc42ab2d97ab(f_mut, t_mut) {
    SetTreeModule_iter: while(true){
        const f = f_mut, t = t_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                $70b963136d0d9ffe$export$37ebdc42ab2d97ab(f, $70b963136d0d9ffe$export$3a6709e904d70df6(tn));
                f($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn));
                f_mut = f;
                t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                continue SetTreeModule_iter;
            } else f($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
        }
        break;
    }
}
function $70b963136d0d9ffe$export$2024953aeafba010(f_mut, t_mut, x_mut) {
    SetTreeModule_foldBackOpt: while(true){
        const f = f_mut, t = t_mut, x = x_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                f_mut = f;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                x_mut = f($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), $70b963136d0d9ffe$export$2024953aeafba010(f, $70b963136d0d9ffe$export$c48088e0810c0478(tn), x));
                continue SetTreeModule_foldBackOpt;
            } else return f($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), x);
        } else return x;
        break;
    }
}
function $70b963136d0d9ffe$export$f95f330bb16ee4a1(f, m, x) {
    return $70b963136d0d9ffe$export$2024953aeafba010(f, m, x);
}
function $70b963136d0d9ffe$export$fe5ced2df4dde3e0(f_mut, x_mut, t_mut) {
    SetTreeModule_foldOpt: while(true){
        const f = f_mut, x = x_mut, t = t_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                f_mut = f;
                x_mut = f($70b963136d0d9ffe$export$fe5ced2df4dde3e0(f, x, $70b963136d0d9ffe$export$3a6709e904d70df6(tn)), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn));
                t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                continue SetTreeModule_foldOpt;
            } else return f(x, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
        } else return x;
        break;
    }
}
function $70b963136d0d9ffe$export$a1cee8850fe1e106(f, x, m) {
    return $70b963136d0d9ffe$export$fe5ced2df4dde3e0(f, x, m);
}
function $70b963136d0d9ffe$export$b0352873018b28b1(f_mut, t_mut) {
    SetTreeModule_forall: while(true){
        const f = f_mut, t = t_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                if (f($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)) && $70b963136d0d9ffe$export$b0352873018b28b1(f, $70b963136d0d9ffe$export$3a6709e904d70df6(tn))) {
                    f_mut = f;
                    t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                    continue SetTreeModule_forall;
                } else return false;
            } else return f($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
        } else return true;
        break;
    }
}
function $70b963136d0d9ffe$export$cd31b0fd969b2290(f_mut, t_mut) {
    SetTreeModule_exists: while(true){
        const f = f_mut, t = t_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                if (f($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)) ? true : $70b963136d0d9ffe$export$cd31b0fd969b2290(f, $70b963136d0d9ffe$export$3a6709e904d70df6(tn))) return true;
                else {
                    f_mut = f;
                    t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                    continue SetTreeModule_exists;
                }
            } else return f($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
        } else return false;
        break;
    }
}
function $70b963136d0d9ffe$export$4742de591ce465cc(comparer, a, b) {
    return $70b963136d0d9ffe$export$b0352873018b28b1((x)=>$70b963136d0d9ffe$export$c7e8af7f2034a817(comparer, x, b), a);
}
function $70b963136d0d9ffe$export$d96f18f7b4957457(comparer, a, b) {
    if ($70b963136d0d9ffe$export$b0352873018b28b1((x)=>$70b963136d0d9ffe$export$c7e8af7f2034a817(comparer, x, b), a)) return $70b963136d0d9ffe$export$cd31b0fd969b2290((x_1)=>!$70b963136d0d9ffe$export$c7e8af7f2034a817(comparer, x_1, a), b);
    else return false;
}
function $70b963136d0d9ffe$export$f38a4c015ec32205(comparer_mut, f_mut, t_mut, acc_mut) {
    SetTreeModule_filterAux: while(true){
        const comparer = comparer_mut, f = f_mut, t = t_mut, acc = acc_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                const acc_1 = f($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)) ? $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), acc) : acc;
                comparer_mut = comparer;
                f_mut = f;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                acc_mut = $70b963136d0d9ffe$export$f38a4c015ec32205(comparer, f, $70b963136d0d9ffe$export$c48088e0810c0478(tn), acc_1);
                continue SetTreeModule_filterAux;
            } else if (f($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2))) return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), acc);
            else return acc;
        } else return acc;
        break;
    }
}
function $70b963136d0d9ffe$export$7828704826267a03(comparer, f, s) {
    return $70b963136d0d9ffe$export$f38a4c015ec32205(comparer, f, s, $70b963136d0d9ffe$export$789a9e5439ddb314());
}
function $70b963136d0d9ffe$export$278c79d3d6feb2b2(comparer_mut, t_mut, acc_mut) {
    SetTreeModule_diffAux: while(true){
        const comparer = comparer_mut, t = t_mut, acc = acc_mut;
        if (acc == null) return acc;
        else if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                comparer_mut = comparer;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                acc_mut = $70b963136d0d9ffe$export$278c79d3d6feb2b2(comparer, $70b963136d0d9ffe$export$c48088e0810c0478(tn), $70b963136d0d9ffe$export$d52c8967ecbb435f(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), acc));
                continue SetTreeModule_diffAux;
            } else return $70b963136d0d9ffe$export$d52c8967ecbb435f(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), acc);
        } else return acc;
        break;
    }
}
function $70b963136d0d9ffe$export$59ea7dd0be5b125e(comparer, a, b) {
    return $70b963136d0d9ffe$export$278c79d3d6feb2b2(comparer, b, a);
}
function $70b963136d0d9ffe$export$b5732a1bda3a884f(comparer, t1, t2) {
    if (t1 != null) {
        const t1$0027 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t1);
        if (t2 != null) {
            const t2$0027 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t2);
            if (t1$0027 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const t1n = t1$0027;
                if (t2$0027 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const t2n = t2$0027;
                    if ($70b963136d0d9ffe$export$44830e1b4642d2f2(t1n) > $70b963136d0d9ffe$export$44830e1b4642d2f2(t2n)) {
                        const patternInput = $70b963136d0d9ffe$export$d3289c110494d73f(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1n), t2);
                        return $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, $70b963136d0d9ffe$export$b5732a1bda3a884f(comparer, $70b963136d0d9ffe$export$3a6709e904d70df6(t1n), patternInput[0]), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1n), $70b963136d0d9ffe$export$b5732a1bda3a884f(comparer, $70b963136d0d9ffe$export$c48088e0810c0478(t1n), patternInput[2]));
                    } else {
                        const patternInput_1 = $70b963136d0d9ffe$export$d3289c110494d73f(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2n), t1);
                        return $70b963136d0d9ffe$export$ea8dd23fcccb59fa(comparer, $70b963136d0d9ffe$export$b5732a1bda3a884f(comparer, $70b963136d0d9ffe$export$3a6709e904d70df6(t2n), patternInput_1[0]), $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2n), $70b963136d0d9ffe$export$b5732a1bda3a884f(comparer, $70b963136d0d9ffe$export$c48088e0810c0478(t2n), patternInput_1[2]));
                    }
                } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2$0027), t1);
            } else return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t1$0027), t2);
        } else return t1;
    } else return t2;
}
function $70b963136d0d9ffe$export$63703c2297c773d(comparer_mut, b_mut, t_mut, acc_mut) {
    SetTreeModule_intersectionAux: while(true){
        const comparer = comparer_mut, b = b_mut, t = t_mut, acc = acc_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                const acc_1 = $70b963136d0d9ffe$export$63703c2297c773d(comparer, b, $70b963136d0d9ffe$export$c48088e0810c0478(tn), acc);
                const acc_2 = $70b963136d0d9ffe$export$c7e8af7f2034a817(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), b) ? $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), acc_1) : acc_1;
                comparer_mut = comparer;
                b_mut = b;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                acc_mut = acc_2;
                continue SetTreeModule_intersectionAux;
            } else if ($70b963136d0d9ffe$export$c7e8af7f2034a817(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), b)) return $70b963136d0d9ffe$export$554bcee7588f20db(comparer, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), acc);
            else return acc;
        } else return acc;
        break;
    }
}
function $70b963136d0d9ffe$export$fa5db0f7a01d55f9(comparer, a, b) {
    return $70b963136d0d9ffe$export$63703c2297c773d(comparer, b, a, $70b963136d0d9ffe$export$789a9e5439ddb314());
}
function $70b963136d0d9ffe$export$8db5d3522219c656(comparer, f, k, acc1, acc2) {
    if (f(k)) return [
        $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, acc1),
        acc2
    ];
    else return [
        acc1,
        $70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, acc2)
    ];
}
function $70b963136d0d9ffe$export$49a54111921b90a1(comparer_mut, f_mut, t_mut, acc__mut, acc__1_mut) {
    SetTreeModule_partitionAux: while(true){
        const comparer = comparer_mut, f = f_mut, t = t_mut, acc_ = acc__mut, acc__1 = acc__1_mut;
        const acc = [
            acc_,
            acc__1
        ];
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                const acc_1 = $70b963136d0d9ffe$export$49a54111921b90a1(comparer, f, $70b963136d0d9ffe$export$c48088e0810c0478(tn), acc[0], acc[1]);
                const acc_4 = $70b963136d0d9ffe$export$8db5d3522219c656(comparer, f, $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), acc_1[0], acc_1[1]);
                comparer_mut = comparer;
                f_mut = f;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                acc__mut = acc_4[0];
                acc__1_mut = acc_4[1];
                continue SetTreeModule_partitionAux;
            } else return $70b963136d0d9ffe$export$8db5d3522219c656(comparer, f, $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), acc[0], acc[1]);
        } else return acc;
        break;
    }
}
function $70b963136d0d9ffe$export$85bee28024c07215(comparer, f, s) {
    return $70b963136d0d9ffe$export$49a54111921b90a1(comparer, f, s, $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$789a9e5439ddb314());
}
function $70b963136d0d9ffe$export$41e56467bab7d9be(t_mut, n_mut) {
    SetTreeModule_minimumElementAux: while(true){
        const t = t_mut, n = n_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                t_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                n_mut = $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn);
                continue SetTreeModule_minimumElementAux;
            } else return $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2);
        } else return n;
        break;
    }
}
function $70b963136d0d9ffe$export$5d7a7574099d3773(t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($70b963136d0d9ffe$export$41e56467bab7d9be($70b963136d0d9ffe$export$3a6709e904d70df6(tn), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)));
        } else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
    } else return undefined;
}
function $70b963136d0d9ffe$export$44308dc338ab0b98(t_mut, n_mut) {
    SetTreeModule_maximumElementAux: while(true){
        const t = t_mut, n = n_mut;
        if (t != null) {
            const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
            if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                const tn = t2;
                t_mut = $70b963136d0d9ffe$export$c48088e0810c0478(tn);
                n_mut = $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn);
                continue SetTreeModule_maximumElementAux;
            } else return $70b963136d0d9ffe$export$45c0aadcd3d191fc(t2);
        } else return n;
        break;
    }
}
function $70b963136d0d9ffe$export$3d056da10369cae6(t) {
    if (t != null) {
        const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t);
        if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
            const tn = t2;
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($70b963136d0d9ffe$export$44308dc338ab0b98($70b963136d0d9ffe$export$c48088e0810c0478(tn), $70b963136d0d9ffe$export$45c0aadcd3d191fc(tn)));
        } else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2));
    } else return undefined;
}
function $70b963136d0d9ffe$export$cbffa98cb2ffd14c(s) {
    const matchValue = $70b963136d0d9ffe$export$5d7a7574099d3773(s);
    if (matchValue == null) throw new Error("Set contains no elements");
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $70b963136d0d9ffe$export$2897c5c613357c45(s) {
    const matchValue = $70b963136d0d9ffe$export$3d056da10369cae6(s);
    if (matchValue == null) throw new Error("Set contains no elements");
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
class $70b963136d0d9ffe$export$15b5e21e435c5ab6 extends (0, $eATN7.Record) {
    constructor(stack, started){
        super();
        this.stack = stack;
        this.started = started;
    }
}
function $70b963136d0d9ffe$export$6a8bdbe6734115a8(gen0) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("Set.SetTreeModule.SetIterator`1", [
        gen0
    ], $70b963136d0d9ffe$export$15b5e21e435c5ab6, ()=>[
            [
                "stack",
                (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)($70b963136d0d9ffe$export$5cbc4c30f146386f(gen0)))
            ],
            [
                "started",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
function $70b963136d0d9ffe$export$8c6af5176c8ad1da(stack_mut) {
    SetTreeModule_collapseLHS: while(true){
        const stack = stack_mut;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(stack)) {
            const x = (0, $e08834e1786645d9$export$5fd5031fecdacec3)(stack);
            const rest = (0, $e08834e1786645d9$export$c01875f616615628)(stack);
            if (x != null) {
                const x2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(x);
                if (x2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const xn = x2;
                    stack_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                        $70b963136d0d9ffe$export$3a6709e904d70df6(xn),
                        $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(xn)),
                        $70b963136d0d9ffe$export$c48088e0810c0478(xn)
                    ], rest);
                    continue SetTreeModule_collapseLHS;
                } else return stack;
            } else {
                stack_mut = rest;
                continue SetTreeModule_collapseLHS;
            }
        } else return (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
        break;
    }
}
function $70b963136d0d9ffe$export$54ebdf61c6573155(s) {
    return new $70b963136d0d9ffe$export$15b5e21e435c5ab6($70b963136d0d9ffe$export$8c6af5176c8ad1da((0, $e08834e1786645d9$export$439306a4dcaafbb9)(s)), false);
}
function $70b963136d0d9ffe$export$b2a85c116b8fddda() {
    throw new Error("Enumeration not started");
}
function $70b963136d0d9ffe$export$20537e55aab7f1b3() {
    throw new Error("Enumeration already started");
}
function $70b963136d0d9ffe$export$c7c08dcd17c8fea2(i) {
    if (i.started) {
        const matchValue = i.stack;
        if ((0, $e08834e1786645d9$export$dd1bc94b04021eeb)(matchValue)) return $70b963136d0d9ffe$export$20537e55aab7f1b3();
        else if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue) != null) {
            const t = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue));
            return $70b963136d0d9ffe$export$45c0aadcd3d191fc(t);
        } else throw new Error("Please report error: Set iterator, unexpected stack for current");
    } else return $70b963136d0d9ffe$export$b2a85c116b8fddda();
}
function $70b963136d0d9ffe$export$3763961bbdc7b66c(i) {
    if (i.started) {
        const matchValue = i.stack;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(matchValue)) {
            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue) != null) {
                const t = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue));
                if (t instanceof $70b963136d0d9ffe$export$24d1adc20488b851) throw new Error("Please report error: Set iterator, unexpected stack for moveNext");
                else {
                    i.stack = $70b963136d0d9ffe$export$8c6af5176c8ad1da((0, $e08834e1786645d9$export$c01875f616615628)(matchValue));
                    return !(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(i.stack);
                }
            } else throw new Error("Please report error: Set iterator, unexpected stack for moveNext");
        } else return false;
    } else {
        i.started = true;
        return !(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(i.stack);
    }
}
function $70b963136d0d9ffe$export$a7eb0ba385eeac02(s) {
    let i = $70b963136d0d9ffe$export$54ebdf61c6573155(s);
    return {
        "System.Collections.Generic.IEnumerator`1.get_Current" () {
            return $70b963136d0d9ffe$export$c7c08dcd17c8fea2(i);
        },
        "System.Collections.IEnumerator.get_Current" () {
            return $70b963136d0d9ffe$export$c7c08dcd17c8fea2(i);
        },
        "System.Collections.IEnumerator.MoveNext" () {
            return $70b963136d0d9ffe$export$3763961bbdc7b66c(i);
        },
        "System.Collections.IEnumerator.Reset" () {
            i = $70b963136d0d9ffe$export$54ebdf61c6573155(s);
        },
        Dispose () {}
    };
}
function $70b963136d0d9ffe$export$f24b671965a5caf(comparer_mut, l1_mut, l2_mut) {
    SetTreeModule_compareStacks: while(true){
        const comparer = comparer_mut, l1 = l1_mut, l2 = l2_mut;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
            if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                    if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                        const x1_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                        const x2_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                        if (x1_3 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                            const x1n_2 = x1_3;
                            if ($70b963136d0d9ffe$export$3a6709e904d70df6(x1n_2) == null) {
                                if (x2_3 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                    const x2n_2 = x2_3;
                                    if ($70b963136d0d9ffe$export$3a6709e904d70df6(x2n_2) == null) {
                                        const c = comparer.Compare($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_2), $70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_2)) | 0;
                                        if (c !== 0) return c | 0;
                                        else {
                                            comparer_mut = comparer;
                                            l1_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$c48088e0810c0478(x1n_2), (0, $e08834e1786645d9$export$c01875f616615628)(l1));
                                            l2_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$c48088e0810c0478(x2n_2), (0, $e08834e1786645d9$export$c01875f616615628)(l2));
                                            continue SetTreeModule_compareStacks;
                                        }
                                    } else {
                                        let matchResult, t1_6, x1_4, t2_6, x2_4;
                                        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
                                            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                                                matchResult = 0;
                                                t1_6 = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                                                x1_4 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                                            } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                                if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                                    matchResult = 1;
                                                    t2_6 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                                    x2_4 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                                } else matchResult = 2;
                                            } else matchResult = 2;
                                        } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                                matchResult = 1;
                                                t2_6 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                                x2_4 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                            } else matchResult = 2;
                                        } else matchResult = 2;
                                        switch(matchResult){
                                            case 0:
                                                if (x1_4 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                                    const x1n_3 = x1_4;
                                                    comparer_mut = comparer;
                                                    l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                        $70b963136d0d9ffe$export$3a6709e904d70df6(x1n_3),
                                                        $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_3), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x1n_3), 0)
                                                    ], t1_6);
                                                    l2_mut = l2;
                                                    continue SetTreeModule_compareStacks;
                                                } else {
                                                    comparer_mut = comparer;
                                                    l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                        $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                        $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_4))
                                                    ], t1_6);
                                                    l2_mut = l2;
                                                    continue SetTreeModule_compareStacks;
                                                }
                                            case 1:
                                                if (x2_4 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                                    const x2n_3 = x2_4;
                                                    comparer_mut = comparer;
                                                    l1_mut = l1;
                                                    l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                        $70b963136d0d9ffe$export$3a6709e904d70df6(x2n_3),
                                                        $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_3), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x2n_3), 0)
                                                    ], t2_6);
                                                    continue SetTreeModule_compareStacks;
                                                } else {
                                                    comparer_mut = comparer;
                                                    l1_mut = l1;
                                                    l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                        $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                        $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_4))
                                                    ], t2_6);
                                                    continue SetTreeModule_compareStacks;
                                                }
                                            default:
                                                throw new Error("unexpected state in SetTree.compareStacks");
                                        }
                                    }
                                } else {
                                    const c_1 = comparer.Compare($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_2), $70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_3)) | 0;
                                    if (c_1 !== 0) return c_1 | 0;
                                    else {
                                        comparer_mut = comparer;
                                        l1_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$c48088e0810c0478(x1n_2), (0, $e08834e1786645d9$export$c01875f616615628)(l1));
                                        l2_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$789a9e5439ddb314(), (0, $e08834e1786645d9$export$c01875f616615628)(l2));
                                        continue SetTreeModule_compareStacks;
                                    }
                                }
                            } else {
                                let matchResult_1, t1_7, x1_5, t2_7, x2_5;
                                if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
                                    if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                                        matchResult_1 = 0;
                                        t1_7 = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                                        x1_5 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                                    } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                        if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                            matchResult_1 = 1;
                                            t2_7 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                            x2_5 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                        } else matchResult_1 = 2;
                                    } else matchResult_1 = 2;
                                } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                    if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                        matchResult_1 = 1;
                                        t2_7 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                        x2_5 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                    } else matchResult_1 = 2;
                                } else matchResult_1 = 2;
                                switch(matchResult_1){
                                    case 0:
                                        if (x1_5 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                            const x1n_4 = x1_5;
                                            comparer_mut = comparer;
                                            l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$3a6709e904d70df6(x1n_4),
                                                $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_4), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x1n_4), 0)
                                            ], t1_7);
                                            l2_mut = l2;
                                            continue SetTreeModule_compareStacks;
                                        } else {
                                            comparer_mut = comparer;
                                            l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_5))
                                            ], t1_7);
                                            l2_mut = l2;
                                            continue SetTreeModule_compareStacks;
                                        }
                                    case 1:
                                        if (x2_5 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                            const x2n_4 = x2_5;
                                            comparer_mut = comparer;
                                            l1_mut = l1;
                                            l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$3a6709e904d70df6(x2n_4),
                                                $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_4), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x2n_4), 0)
                                            ], t2_7);
                                            continue SetTreeModule_compareStacks;
                                        } else {
                                            comparer_mut = comparer;
                                            l1_mut = l1;
                                            l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_5))
                                            ], t2_7);
                                            continue SetTreeModule_compareStacks;
                                        }
                                    default:
                                        throw new Error("unexpected state in SetTree.compareStacks");
                                }
                            }
                        } else if (x2_3 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                            const x2n_5 = x2_3;
                            if ($70b963136d0d9ffe$export$3a6709e904d70df6(x2n_5) == null) {
                                const c_2 = comparer.Compare($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_3), $70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_5)) | 0;
                                if (c_2 !== 0) return c_2 | 0;
                                else {
                                    comparer_mut = comparer;
                                    l1_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$789a9e5439ddb314(), (0, $e08834e1786645d9$export$c01875f616615628)(l1));
                                    l2_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$c48088e0810c0478(x2n_5), (0, $e08834e1786645d9$export$c01875f616615628)(l2));
                                    continue SetTreeModule_compareStacks;
                                }
                            } else {
                                let matchResult_2, t1_8, x1_6, t2_8, x2_6;
                                if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
                                    if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                                        matchResult_2 = 0;
                                        t1_8 = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                                        x1_6 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                                    } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                        if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                            matchResult_2 = 1;
                                            t2_8 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                            x2_6 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                        } else matchResult_2 = 2;
                                    } else matchResult_2 = 2;
                                } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                    if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                        matchResult_2 = 1;
                                        t2_8 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                        x2_6 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                    } else matchResult_2 = 2;
                                } else matchResult_2 = 2;
                                switch(matchResult_2){
                                    case 0:
                                        if (x1_6 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                            const x1n_5 = x1_6;
                                            comparer_mut = comparer;
                                            l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$3a6709e904d70df6(x1n_5),
                                                $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_5), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x1n_5), 0)
                                            ], t1_8);
                                            l2_mut = l2;
                                            continue SetTreeModule_compareStacks;
                                        } else {
                                            comparer_mut = comparer;
                                            l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_6))
                                            ], t1_8);
                                            l2_mut = l2;
                                            continue SetTreeModule_compareStacks;
                                        }
                                    case 1:
                                        if (x2_6 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                            const x2n_6 = x2_6;
                                            comparer_mut = comparer;
                                            l1_mut = l1;
                                            l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$3a6709e904d70df6(x2n_6),
                                                $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_6), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x2n_6), 0)
                                            ], t2_8);
                                            continue SetTreeModule_compareStacks;
                                        } else {
                                            comparer_mut = comparer;
                                            l1_mut = l1;
                                            l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                                $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                                $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_6))
                                            ], t2_8);
                                            continue SetTreeModule_compareStacks;
                                        }
                                    default:
                                        throw new Error("unexpected state in SetTree.compareStacks");
                                }
                            }
                        } else {
                            const c_3 = comparer.Compare($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_3), $70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_3)) | 0;
                            if (c_3 !== 0) return c_3 | 0;
                            else {
                                comparer_mut = comparer;
                                l1_mut = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                                l2_mut = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                continue SetTreeModule_compareStacks;
                            }
                        }
                    } else {
                        const x2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                        let matchResult_3, t1_2, x1, t2_2, x2_1;
                        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
                            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                                matchResult_3 = 0;
                                t1_2 = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                                x1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                            } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                                if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                    matchResult_3 = 1;
                                    t2_2 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                    x2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                                } else matchResult_3 = 2;
                            } else matchResult_3 = 2;
                        } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                matchResult_3 = 1;
                                t2_2 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                x2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                            } else matchResult_3 = 2;
                        } else matchResult_3 = 2;
                        switch(matchResult_3){
                            case 0:
                                if (x1 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                    const x1n = x1;
                                    comparer_mut = comparer;
                                    l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                        $70b963136d0d9ffe$export$3a6709e904d70df6(x1n),
                                        $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x1n), 0)
                                    ], t1_2);
                                    l2_mut = l2;
                                    continue SetTreeModule_compareStacks;
                                } else {
                                    comparer_mut = comparer;
                                    l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                        $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                        $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1))
                                    ], t1_2);
                                    l2_mut = l2;
                                    continue SetTreeModule_compareStacks;
                                }
                            case 1:
                                if (x2_1 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                    const x2n = x2_1;
                                    comparer_mut = comparer;
                                    l1_mut = l1;
                                    l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                        $70b963136d0d9ffe$export$3a6709e904d70df6(x2n),
                                        $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x2n), 0)
                                    ], t2_2);
                                    continue SetTreeModule_compareStacks;
                                } else {
                                    comparer_mut = comparer;
                                    l1_mut = l1;
                                    l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                        $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                        $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_1))
                                    ], t2_2);
                                    continue SetTreeModule_compareStacks;
                                }
                            default:
                                throw new Error("unexpected state in SetTree.compareStacks");
                        }
                    }
                } else if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                    const x1_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                    let matchResult_4, t1_4, x1_2, t2_4, x2_2;
                    if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l1)) {
                        if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1) != null) {
                            matchResult_4 = 0;
                            t1_4 = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                            x1_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l1));
                        } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                                matchResult_4 = 1;
                                t2_4 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                                x2_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                            } else matchResult_4 = 2;
                        } else matchResult_4 = 2;
                    } else if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) {
                        if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2) != null) {
                            matchResult_4 = 1;
                            t2_4 = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                            x2_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(l2));
                        } else matchResult_4 = 2;
                    } else matchResult_4 = 2;
                    switch(matchResult_4){
                        case 0:
                            if (x1_2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                const x1n_1 = x1_2;
                                comparer_mut = comparer;
                                l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                    $70b963136d0d9ffe$export$3a6709e904d70df6(x1n_1),
                                    $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1n_1), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x1n_1), 0)
                                ], t1_4);
                                l2_mut = l2;
                                continue SetTreeModule_compareStacks;
                            } else {
                                comparer_mut = comparer;
                                l1_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                    $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                    $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x1_2))
                                ], t1_4);
                                l2_mut = l2;
                                continue SetTreeModule_compareStacks;
                            }
                        case 1:
                            if (x2_2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                                const x2n_1 = x2_2;
                                comparer_mut = comparer;
                                l1_mut = l1;
                                l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                    $70b963136d0d9ffe$export$3a6709e904d70df6(x2n_1),
                                    $70b963136d0d9ffe$export$a36da15ead77cf48($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2n_1), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$c48088e0810c0478(x2n_1), 0)
                                ], t2_4);
                                continue SetTreeModule_compareStacks;
                            } else {
                                comparer_mut = comparer;
                                l1_mut = l1;
                                l2_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                                    $70b963136d0d9ffe$export$789a9e5439ddb314(),
                                    $70b963136d0d9ffe$export$5996c62447ec32dc($70b963136d0d9ffe$export$45c0aadcd3d191fc(x2_2))
                                ], t2_4);
                                continue SetTreeModule_compareStacks;
                            }
                        default:
                            throw new Error("unexpected state in SetTree.compareStacks");
                    }
                } else {
                    comparer_mut = comparer;
                    l1_mut = (0, $e08834e1786645d9$export$c01875f616615628)(l1);
                    l2_mut = (0, $e08834e1786645d9$export$c01875f616615628)(l2);
                    continue SetTreeModule_compareStacks;
                }
            } else return 1;
        } else if ((0, $e08834e1786645d9$export$dd1bc94b04021eeb)(l2)) return 0;
        else return -1;
        break;
    }
}
function $70b963136d0d9ffe$export$90b4d910bde247d6(comparer, t1, t2) {
    if (t1 == null) {
        if (t2 == null) return 0;
        else return -1;
    } else if (t2 == null) return 1;
    else return $70b963136d0d9ffe$export$f24b671965a5caf(comparer, (0, $e08834e1786645d9$export$439306a4dcaafbb9)(t1), (0, $e08834e1786645d9$export$439306a4dcaafbb9)(t2)) | 0;
}
function $70b963136d0d9ffe$export$52ead7305d4117f6(s) {
    return $70b963136d0d9ffe$export$cbffa98cb2ffd14c(s);
}
function $70b963136d0d9ffe$export$339dbd16008a7ce0(t) {
    const loop = (t$0027_mut, acc_mut)=>{
        loop: while(true){
            const t$0027 = t$0027_mut, acc = acc_mut;
            if (t$0027 != null) {
                const t2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t$0027);
                if (t2 instanceof $70b963136d0d9ffe$export$24d1adc20488b851) {
                    const tn = t2;
                    t$0027_mut = $70b963136d0d9ffe$export$3a6709e904d70df6(tn);
                    acc_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$45c0aadcd3d191fc(tn), loop($70b963136d0d9ffe$export$c48088e0810c0478(tn), acc));
                    continue loop;
                } else return (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($70b963136d0d9ffe$export$45c0aadcd3d191fc(t2), acc);
            } else return acc;
            break;
        }
    };
    return loop(t, (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
}
function $70b963136d0d9ffe$export$59d907858844748e(s, arr, i) {
    let j = i;
    $70b963136d0d9ffe$export$37ebdc42ab2d97ab((x)=>{
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(arr, j, x);
        j = j + 1 | 0;
    }, s);
}
function $70b963136d0d9ffe$export$78ae8a49fe129cf7(s) {
    const n = $70b963136d0d9ffe$export$f65a0d7730a61e07(s) | 0;
    const res = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(n), 0, n, null);
    $70b963136d0d9ffe$export$59d907858844748e(s, res, 0);
    return res;
}
function $70b963136d0d9ffe$export$9995ed4f5029c46f(comparer_mut, acc_mut, e_mut) {
    SetTreeModule_mkFromEnumerator: while(true){
        const comparer = comparer_mut, acc = acc_mut, e = e_mut;
        if (e["System.Collections.IEnumerator.MoveNext"]()) {
            comparer_mut = comparer;
            acc_mut = $70b963136d0d9ffe$export$554bcee7588f20db(comparer, e["System.Collections.Generic.IEnumerator`1.get_Current"](), acc);
            e_mut = e;
            continue SetTreeModule_mkFromEnumerator;
        } else return acc;
        break;
    }
}
function $70b963136d0d9ffe$export$e542a06bc464ca1b(comparer, l) {
    return (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((acc, k)=>$70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, acc), $70b963136d0d9ffe$export$789a9e5439ddb314(), l);
}
function $70b963136d0d9ffe$export$4292d2f029ac57e(comparer, l) {
    return (0, $e08834e1786645d9$export$93e2b83da34ff82a)((acc, k)=>$70b963136d0d9ffe$export$554bcee7588f20db(comparer, k, acc), $70b963136d0d9ffe$export$789a9e5439ddb314(), l);
}
function $70b963136d0d9ffe$export$e3b9796be05e5b5(comparer, c) {
    if ((0, $kRS0m.isArrayLike)(c)) return $70b963136d0d9ffe$export$e542a06bc464ca1b(comparer, c);
    else if (c instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return $70b963136d0d9ffe$export$4292d2f029ac57e(comparer, c);
    else {
        const ie = (0, $kRS0m.getEnumerator)(c);
        try {
            return $70b963136d0d9ffe$export$9995ed4f5029c46f(comparer, $70b963136d0d9ffe$export$789a9e5439ddb314(), ie);
        } finally{
            (0, $kRS0m.disposeSafe)(ie);
        }
    }
}
class $70b963136d0d9ffe$export$88d402ddcae9d5f0 {
    constructor(comparer, tree){
        this.comparer = comparer;
        this.tree = tree;
    }
    GetHashCode() {
        const this$ = this;
        return $70b963136d0d9ffe$export$a92f8b898cfc8eb3(this$) | 0;
    }
    Equals(that) {
        let that_1;
        const this$ = this;
        return that instanceof $70b963136d0d9ffe$export$88d402ddcae9d5f0 && (that_1 = that, $70b963136d0d9ffe$export$90b4d910bde247d6($70b963136d0d9ffe$export$d16bb59de454fb21(this$), $70b963136d0d9ffe$export$b385a8e891a7eb9e(this$), $70b963136d0d9ffe$export$b385a8e891a7eb9e(that_1)) === 0);
    }
    toString() {
        const this$ = this;
        return "set [" + (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("; ", (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>{
            let copyOfStruct = x;
            return (0, $eATN7.toString)(copyOfStruct);
        }, this$)) + "]";
    }
    get [Symbol.toStringTag]() {
        return "FSharpSet";
    }
    toJSON() {
        const this$ = this;
        return Array.from(this$);
    }
    CompareTo(that) {
        const s = this;
        return $70b963136d0d9ffe$export$90b4d910bde247d6($70b963136d0d9ffe$export$d16bb59de454fb21(s), $70b963136d0d9ffe$export$b385a8e891a7eb9e(s), $70b963136d0d9ffe$export$b385a8e891a7eb9e(that)) | 0;
    }
    "System.Collections.Generic.ICollection`1.Add2B595"(x) {
        throw new Error("ReadOnlyCollection");
    }
    "System.Collections.Generic.ICollection`1.Clear"() {
        throw new Error("ReadOnlyCollection");
    }
    "System.Collections.Generic.ICollection`1.Remove2B595"(x) {
        throw new Error("ReadOnlyCollection");
    }
    "System.Collections.Generic.ICollection`1.Contains2B595"(x) {
        const s = this;
        return $70b963136d0d9ffe$export$c7e8af7f2034a817($70b963136d0d9ffe$export$d16bb59de454fb21(s), x, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
    }
    "System.Collections.Generic.ICollection`1.CopyToZ3B4C077E"(arr, i) {
        const s = this;
        $70b963136d0d9ffe$export$59d907858844748e($70b963136d0d9ffe$export$b385a8e891a7eb9e(s), arr, i);
    }
    "System.Collections.Generic.ICollection`1.get_IsReadOnly"() {
        return true;
    }
    "System.Collections.Generic.ICollection`1.get_Count"() {
        const s = this;
        return $70b963136d0d9ffe$export$97e0619aa4c4dece(s) | 0;
    }
    "System.Collections.Generic.IReadOnlyCollection`1.get_Count"() {
        const s = this;
        return $70b963136d0d9ffe$export$97e0619aa4c4dece(s) | 0;
    }
    GetEnumerator() {
        const s = this;
        return $70b963136d0d9ffe$export$a7eb0ba385eeac02($70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const s = this;
        return $70b963136d0d9ffe$export$a7eb0ba385eeac02($70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
    }
    get size() {
        const s = this;
        return $70b963136d0d9ffe$export$97e0619aa4c4dece(s) | 0;
    }
    add(k) {
        const s = this;
        throw new Error("Set cannot be mutated");
    }
    clear() {
        throw new Error("Set cannot be mutated");
    }
    delete(k) {
        throw new Error("Set cannot be mutated");
    }
    has(k) {
        const s = this;
        return $70b963136d0d9ffe$export$5a6573e0052ad83f(s, k);
    }
    keys() {
        const s = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>x, s);
    }
    values() {
        const s = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>x, s);
    }
    entries() {
        const s = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((v)=>[
                v,
                v
            ], s);
    }
    forEach(f, thisArg) {
        const s = this;
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((x)=>{
            f(x, x, s);
        }, s);
    }
}
function $70b963136d0d9ffe$export$dceeb81977fb08e0(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Set.FSharpSet", [
        gen0
    ], $70b963136d0d9ffe$export$88d402ddcae9d5f0);
}
function $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, tree) {
    return new $70b963136d0d9ffe$export$88d402ddcae9d5f0(comparer, tree);
}
function $70b963136d0d9ffe$export$d16bb59de454fb21(set$) {
    return set$.comparer;
}
function $70b963136d0d9ffe$export$b385a8e891a7eb9e(set$) {
    return set$.tree;
}
function $70b963136d0d9ffe$export$d32b715fbf15c867(comparer) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, $70b963136d0d9ffe$export$789a9e5439ddb314());
}
function $70b963136d0d9ffe$export$1270f4128df94243(s, value) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(s), $70b963136d0d9ffe$export$554bcee7588f20db($70b963136d0d9ffe$export$d16bb59de454fb21(s), value, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s)));
}
function $70b963136d0d9ffe$export$6f04f4bf5eb5ec8d(s, value) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(s), $70b963136d0d9ffe$export$d52c8967ecbb435f($70b963136d0d9ffe$export$d16bb59de454fb21(s), value, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s)));
}
function $70b963136d0d9ffe$export$97e0619aa4c4dece(s) {
    return $70b963136d0d9ffe$export$f65a0d7730a61e07($70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$5a6573e0052ad83f(s, value) {
    return $70b963136d0d9ffe$export$c7e8af7f2034a817($70b963136d0d9ffe$export$d16bb59de454fb21(s), value, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$ef6e94eb0e3cc113(s, x) {
    $70b963136d0d9ffe$export$37ebdc42ab2d97ab(x, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$52be35753f99a807(s, f, z) {
    const f_1 = f;
    return $70b963136d0d9ffe$export$a1cee8850fe1e106((x, z_1)=>f_1(z_1, x), z, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$7980136274876327(s) {
    return $70b963136d0d9ffe$export$b385a8e891a7eb9e(s) == null;
}
function $70b963136d0d9ffe$export$7b1f6aee2242db82(s, f) {
    if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(s) == null) return [
        s,
        s
    ];
    else {
        const patternInput = $70b963136d0d9ffe$export$85bee28024c07215($70b963136d0d9ffe$export$d16bb59de454fb21(s), f, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
        return [
            $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(s), patternInput[0]),
            $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(s), patternInput[1])
        ];
    }
}
function $70b963136d0d9ffe$export$3cb01d2785869415(s, f) {
    if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(s) == null) return s;
    else return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(s), $70b963136d0d9ffe$export$7828704826267a03($70b963136d0d9ffe$export$d16bb59de454fb21(s), f, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s)));
}
function $70b963136d0d9ffe$export$34341b623709b963(s, f, comparer) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, $70b963136d0d9ffe$export$a1cee8850fe1e106((acc, k)=>$70b963136d0d9ffe$export$554bcee7588f20db(comparer, f(k), acc), $70b963136d0d9ffe$export$789a9e5439ddb314(), $70b963136d0d9ffe$export$b385a8e891a7eb9e(s)));
}
function $70b963136d0d9ffe$export$b7bed913c448b1e5(s, f) {
    return $70b963136d0d9ffe$export$cd31b0fd969b2290(f, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$180f5335e12965e7(s, f) {
    return $70b963136d0d9ffe$export$b0352873018b28b1(f, $70b963136d0d9ffe$export$b385a8e891a7eb9e(s));
}
function $70b963136d0d9ffe$export$1bcf0b707e21f1fa(set1, set2) {
    if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(set1) == null) return set1;
    else if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(set2) == null) return set1;
    else return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$59ea7dd0be5b125e($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2)));
}
function $70b963136d0d9ffe$export$f3072a5d1b47bd83(set1, set2) {
    if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(set2) == null) return set1;
    else if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(set1) == null) return set2;
    else return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b5732a1bda3a884f($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2)));
}
function $70b963136d0d9ffe$export$3670db128b65e09(a, b) {
    if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(b) == null) return b;
    else if ($70b963136d0d9ffe$export$b385a8e891a7eb9e(a) == null) return a;
    else return $70b963136d0d9ffe$export$87aea6de1d59b0d9($70b963136d0d9ffe$export$d16bb59de454fb21(a), $70b963136d0d9ffe$export$fa5db0f7a01d55f9($70b963136d0d9ffe$export$d16bb59de454fb21(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(b)));
}
function $70b963136d0d9ffe$export$3a3ac94a12ae0fc6(sets) {
    return (0, $42cbcefff7323768$export$533b26079ad0b4b)($70b963136d0d9ffe$export$3670db128b65e09, sets);
}
function $70b963136d0d9ffe$export$18b57644a8732872(a, b) {
    return $70b963136d0d9ffe$export$90b4d910bde247d6($70b963136d0d9ffe$export$d16bb59de454fb21(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(b)) === 0;
}
function $70b963136d0d9ffe$export$957ae12d21d24bd5(a, b) {
    return $70b963136d0d9ffe$export$90b4d910bde247d6($70b963136d0d9ffe$export$d16bb59de454fb21(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(a), $70b963136d0d9ffe$export$b385a8e891a7eb9e(b));
}
function $70b963136d0d9ffe$export$c87206884f47eb66(x) {
    return $70b963136d0d9ffe$export$52ead7305d4117f6($70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$878517f67cb0d1ef(x) {
    return $70b963136d0d9ffe$export$cbffa98cb2ffd14c($70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$16f617d5158851d6(x) {
    return $70b963136d0d9ffe$export$2897c5c613357c45($70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$bbf6ce4d6b5cc1ca(x, otherSet) {
    return $70b963136d0d9ffe$export$4742de591ce465cc($70b963136d0d9ffe$export$d16bb59de454fb21(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(otherSet));
}
function $70b963136d0d9ffe$export$d5e50e44210213a8(x, otherSet) {
    return $70b963136d0d9ffe$export$4742de591ce465cc($70b963136d0d9ffe$export$d16bb59de454fb21(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(otherSet), $70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$3a58dc2659bfedd4(x, otherSet) {
    return $70b963136d0d9ffe$export$d96f18f7b4957457($70b963136d0d9ffe$export$d16bb59de454fb21(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(otherSet));
}
function $70b963136d0d9ffe$export$555c25b26bd21fae(x, otherSet) {
    return $70b963136d0d9ffe$export$d96f18f7b4957457($70b963136d0d9ffe$export$d16bb59de454fb21(x), $70b963136d0d9ffe$export$b385a8e891a7eb9e(otherSet), $70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$b4ca31c9d41bba29(x) {
    return $70b963136d0d9ffe$export$339dbd16008a7ce0($70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$c6cb9534e3f2feb5(x) {
    return $70b963136d0d9ffe$export$78ae8a49fe129cf7($70b963136d0d9ffe$export$b385a8e891a7eb9e(x));
}
function $70b963136d0d9ffe$export$a92f8b898cfc8eb3(this$) {
    let res = 0;
    const enumerator = (0, $kRS0m.getEnumerator)(this$);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const x_1 = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            res = (res << 1) + (0, $kRS0m.structuralHash)(x_1) + 631 | 0;
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return Math.abs(res) | 0;
}
function $70b963136d0d9ffe$export$dd1bc94b04021eeb(set$) {
    return $70b963136d0d9ffe$export$7980136274876327(set$);
}
function $70b963136d0d9ffe$export$2344b14b097df817(element, set$) {
    return $70b963136d0d9ffe$export$5a6573e0052ad83f(set$, element);
}
function $70b963136d0d9ffe$export$e16d8520af44a096(value, set$) {
    return $70b963136d0d9ffe$export$1270f4128df94243(set$, value);
}
function $70b963136d0d9ffe$export$439306a4dcaafbb9(value, comparer) {
    return $70b963136d0d9ffe$export$1270f4128df94243($70b963136d0d9ffe$export$d32b715fbf15c867(comparer), value);
}
function $70b963136d0d9ffe$export$cd7f480d6b8286c3(value, set$) {
    return $70b963136d0d9ffe$export$6f04f4bf5eb5ec8d(set$, value);
}
function $70b963136d0d9ffe$export$971dd5b0dfd021b6(set1, set2) {
    return $70b963136d0d9ffe$export$f3072a5d1b47bd83(set1, set2);
}
function $70b963136d0d9ffe$export$1819b47e174a9ed2(sets, comparer) {
    return (0, $42cbcefff7323768$export$93e2b83da34ff82a)($70b963136d0d9ffe$export$f3072a5d1b47bd83, $70b963136d0d9ffe$export$d32b715fbf15c867(comparer), sets);
}
function $70b963136d0d9ffe$export$1f4807a235930d45(set1, set2) {
    return $70b963136d0d9ffe$export$3670db128b65e09(set1, set2);
}
function $70b963136d0d9ffe$export$7e91d8cfc2441b98(sets) {
    return $70b963136d0d9ffe$export$3a3ac94a12ae0fc6(sets);
}
function $70b963136d0d9ffe$export$c1a059043cc9c119(action, set$) {
    $70b963136d0d9ffe$export$ef6e94eb0e3cc113(set$, action);
}
function $70b963136d0d9ffe$export$6e22c362a0406a2c(comparer) {
    return $70b963136d0d9ffe$export$d32b715fbf15c867(comparer);
}
function $70b963136d0d9ffe$export$e5bd981f5eeebe3b(predicate, set$) {
    return $70b963136d0d9ffe$export$180f5335e12965e7(set$, predicate);
}
function $70b963136d0d9ffe$export$f7e9f41ea797a17(predicate, set$) {
    return $70b963136d0d9ffe$export$b7bed913c448b1e5(set$, predicate);
}
function $70b963136d0d9ffe$export$3dea766d36a8935f(predicate, set$) {
    return $70b963136d0d9ffe$export$3cb01d2785869415(set$, predicate);
}
function $70b963136d0d9ffe$export$b29f828819edca8d(predicate, set$) {
    return $70b963136d0d9ffe$export$7b1f6aee2242db82(set$, predicate);
}
function $70b963136d0d9ffe$export$93e2b83da34ff82a(folder, state, set$) {
    return $70b963136d0d9ffe$export$a1cee8850fe1e106(folder, state, $70b963136d0d9ffe$export$b385a8e891a7eb9e(set$));
}
function $70b963136d0d9ffe$export$c38b8353041a4f48(folder, set$, state) {
    return $70b963136d0d9ffe$export$f95f330bb16ee4a1(folder, $70b963136d0d9ffe$export$b385a8e891a7eb9e(set$), state);
}
function $70b963136d0d9ffe$export$871de8747c9eaa88(mapping, set$, comparer) {
    return $70b963136d0d9ffe$export$34341b623709b963(set$, mapping, comparer);
}
function $70b963136d0d9ffe$export$85b9a36db797e02b(set$) {
    return $70b963136d0d9ffe$export$97e0619aa4c4dece(set$);
}
function $70b963136d0d9ffe$export$97ef4da51e4fceb3(elements, comparer) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, $70b963136d0d9ffe$export$e3b9796be05e5b5(comparer, elements));
}
function $70b963136d0d9ffe$export$cb197a913f6bb809(array, comparer) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, $70b963136d0d9ffe$export$e542a06bc464ca1b(comparer, array));
}
function $70b963136d0d9ffe$export$effcdbd76139450(set$) {
    return $70b963136d0d9ffe$export$b4ca31c9d41bba29(set$);
}
function $70b963136d0d9ffe$export$45b10814cc054894(set$) {
    return $70b963136d0d9ffe$export$c6cb9534e3f2feb5(set$);
}
function $70b963136d0d9ffe$export$1344b76b7b5a4395(set$) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((x)=>x, set$);
}
function $70b963136d0d9ffe$export$c80b5fc7454ef206(elements, comparer) {
    return $70b963136d0d9ffe$export$87aea6de1d59b0d9(comparer, $70b963136d0d9ffe$export$e3b9796be05e5b5(comparer, elements));
}
function $70b963136d0d9ffe$export$acaf96a27438246b(set1, set2) {
    return $70b963136d0d9ffe$export$1bcf0b707e21f1fa(set1, set2);
}
function $70b963136d0d9ffe$export$af04532ec9ff13d2(set1, set2) {
    return $70b963136d0d9ffe$export$4742de591ce465cc($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2));
}
function $70b963136d0d9ffe$export$bea8187457f3dd6f(set1, set2) {
    return $70b963136d0d9ffe$export$4742de591ce465cc($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1));
}
function $70b963136d0d9ffe$export$ce49a009f31cfea(set1, set2) {
    return $70b963136d0d9ffe$export$d96f18f7b4957457($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2));
}
function $70b963136d0d9ffe$export$a0ab6075b70df7df(set1, set2) {
    return $70b963136d0d9ffe$export$d96f18f7b4957457($70b963136d0d9ffe$export$d16bb59de454fb21(set1), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set2), $70b963136d0d9ffe$export$b385a8e891a7eb9e(set1));
}
function $70b963136d0d9ffe$export$e89e1227a4e488d2(set$) {
    return $70b963136d0d9ffe$export$878517f67cb0d1ef(set$);
}
function $70b963136d0d9ffe$export$b5ffc73cb49257f3(set$) {
    return $70b963136d0d9ffe$export$16f617d5158851d6(set$);
}
function $70b963136d0d9ffe$export$ed1b4f34a0e8b0cc(s1, s2) {
    return (0, $42cbcefff7323768$export$93e2b83da34ff82a)((acc, x)=>acc.add(x), s1, s2);
}
function $70b963136d0d9ffe$export$d6c8f572f8cede78(s1, s2) {
    if (s1 instanceof (0, $3029827f1b7d692a$export$9d0bf21c11057332)) {
        const s1_1 = s1;
        return (0, $3029827f1b7d692a$export$66454eb65fce2240)(s2, (0, $3029827f1b7d692a$export$6edb119d1846f7a8)(s1_1));
    } else return new Set(s2);
}
function $70b963136d0d9ffe$export$270280d5c5773890(s1, s2) {
    const s2_1 = $70b963136d0d9ffe$export$d6c8f572f8cede78(s1, s2);
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((x)=>{
        if (!s2_1.has(x)) s1.delete(x);
    }, s1.values());
}
function $70b963136d0d9ffe$export$3571f70f773686ac(s1, s2) {
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((x)=>{
        s1.delete(x);
    }, s2);
}
function $70b963136d0d9ffe$export$2b09cdc61b8a3240(s1, s2) {
    const s2_1 = $70b963136d0d9ffe$export$d6c8f572f8cede78(s1, s2);
    return (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((value)=>s2_1.has(value), s1.values());
}
function $70b963136d0d9ffe$export$22c04563e192ea02(s1, s2) {
    return (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((value)=>s1.has(value), s2);
}
function $70b963136d0d9ffe$export$482f663f0ebd84b8(s1, s2) {
    const s2_1 = $70b963136d0d9ffe$export$d6c8f572f8cede78(s1, s2);
    if (s2_1.size > s1.size) return (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((value)=>s2_1.has(value), s1.values());
    else return false;
}
function $70b963136d0d9ffe$export$6761052aa11d0482(s1, s2) {
    const s2_1 = (0, $42cbcefff7323768$export$69a3209f1a06c04d)(s2);
    if ((0, $42cbcefff7323768$export$f7e9f41ea797a17)((arg)=>!s1.has(arg), s2_1)) return (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((value_2)=>s1.has(value_2), s2_1);
    else return false;
}



var $kRS0m = parcelRequire("kRS0m");

class $7bbf2c7402328604$export$505c630c0b27c516 extends (0, $eATN7.Record) {
    constructor(Name, Quality, Speed){
        super();
        this.Name = Name;
        this.Quality = Quality;
        this.Speed = Speed;
    }
}
function $7bbf2c7402328604$export$f389f59a8e9b39bf() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Fertilizer", [], $7bbf2c7402328604$export$505c630c0b27c516, ()=>[
            [
                "Name",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "Quality",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Speed",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ]
        ]);
}
const $7bbf2c7402328604$export$70921c9a086f6004 = (option)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((_arg)=>_arg.Name, option);
const $7bbf2c7402328604$export$4689e1bbdbf4db51 = (_arg_1)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (_arg)=>_arg.Quality, _arg_1);
const $7bbf2c7402328604$export$12ba9d8c8c76f13f = (_arg_1)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (_arg)=>_arg.Speed, _arg_1);
function $7bbf2c7402328604$export$125e96caa9d3db22(quality) {
    return (0, $3921efb06a31e9cc$export$e1d90e20ad64402a)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
        [
            "Normal",
            0
        ],
        [
            "Silver",
            1
        ],
        [
            "Gold",
            2
        ],
        [
            "Iridium",
            3
        ]
    ]), quality);
}
class $7bbf2c7402328604$export$e7a5f882b7c87870 extends (0, $eATN7.Union) {
    constructor(Item){
        super();
        this.tag = 0;
        this.fields = [
            Item
        ];
    }
    cases() {
        return [
            "ByQuality"
        ];
    }
}
function $7bbf2c7402328604$export$dd69cde14303022b(gen0) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Qualities`1", [
        gen0
    ], $7bbf2c7402328604$export$e7a5f882b7c87870, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$9242f430c61b672d)(gen0)
                ]
            ]
        ]);
}
const $7bbf2c7402328604$export$127ff803a92644c = new $7bbf2c7402328604$export$e7a5f882b7c87870((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Float64Array(4), 0, 4, 0));
const $7bbf2c7402328604$export$54fd8b3fc157341a = new $7bbf2c7402328604$export$e7a5f882b7c87870(new Float64Array([
    1,
    1.25,
    1.5,
    2
]));
function $7bbf2c7402328604$export$a0d475150deff27c(_arg) {
    return (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, x)=>[
            i,
            x
        ], _arg.fields[0]);
}
function $7bbf2c7402328604$export$a324e82014c2a7ef(scalar, qualities) {
    const arr = (0, $e5d9070e144b905e$export$784d13d8ee351f07)(qualities.fields[0]);
    for(let i = 0; i <= 3; i++)(0, $e5d9070e144b905e$export$8a8216c44337cd5)(arr, i, scalar * (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, arr));
    return new $7bbf2c7402328604$export$e7a5f882b7c87870(arr);
}
function $7bbf2c7402328604$export$a50d46369ca5fbd2(a, b) {
    let sum = 0;
    for(let i = 0; i <= 3; i++)sum = sum + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, a.fields[0]) * (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, b.fields[0]);
    return sum;
}
class $7bbf2c7402328604$export$118171a82d109c04 extends (0, $eATN7.Record) {
    constructor(Level, Buff){
        super();
        this.Level = Level;
        this.Buff = Buff;
    }
}
function $7bbf2c7402328604$export$2a218d1146113848() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Skill", [], $7bbf2c7402328604$export$118171a82d109c04, ()=>[
            [
                "Level",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Buff",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ]
        ]);
}
const $7bbf2c7402328604$export$d10f771b17a7f4d8 = new $7bbf2c7402328604$export$118171a82d109c04(0, 0);
function $7bbf2c7402328604$export$ec8168623fc320df(skill) {
    return skill.Level + skill.Buff;
}
class $7bbf2c7402328604$export$42ad0ac7fc7503a6 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Tiller",
            "Artisan",
            "Agriculturist",
            "Gatherer",
            "Botanist"
        ];
    }
}
function $7bbf2c7402328604$export$eded135980cc84c() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Profession", [], $7bbf2c7402328604$export$42ad0ac7fc7503a6, ()=>[
            [],
            [],
            [],
            [],
            []
        ]);
}
const $7bbf2c7402328604$export$a24a89bf935f16be = [
    new $7bbf2c7402328604$export$42ad0ac7fc7503a6(0, []),
    new $7bbf2c7402328604$export$42ad0ac7fc7503a6(1, []),
    new $7bbf2c7402328604$export$42ad0ac7fc7503a6(2, [])
];
const $7bbf2c7402328604$export$ca2a686c637fb772 = [
    new $7bbf2c7402328604$export$42ad0ac7fc7503a6(3, []),
    new $7bbf2c7402328604$export$42ad0ac7fc7503a6(4, [])
];
class $7bbf2c7402328604$export$bc572fe44976cfbc extends (0, $eATN7.Record) {
    constructor(Farming, Foraging, Professions, IgnoreSkillLevelRequirements, IgnoreProfessionConflicts){
        super();
        this.Farming = Farming;
        this.Foraging = Foraging;
        this.Professions = Professions;
        this.IgnoreSkillLevelRequirements = IgnoreSkillLevelRequirements;
        this.IgnoreProfessionConflicts = IgnoreProfessionConflicts;
    }
}
function $7bbf2c7402328604$export$d4572be1898ebd50() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Skills", [], $7bbf2c7402328604$export$bc572fe44976cfbc, ()=>[
            [
                "Farming",
                $7bbf2c7402328604$export$2a218d1146113848()
            ],
            [
                "Foraging",
                $7bbf2c7402328604$export$2a218d1146113848()
            ],
            [
                "Professions",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    $7bbf2c7402328604$export$eded135980cc84c()
                ])
            ],
            [
                "IgnoreSkillLevelRequirements",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "IgnoreProfessionConflicts",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
const $7bbf2c7402328604$export$e4da585a3ddc880e = new $7bbf2c7402328604$export$bc572fe44976cfbc($7bbf2c7402328604$export$d10f771b17a7f4d8, $7bbf2c7402328604$export$d10f771b17a7f4d8, (0, $70b963136d0d9ffe$export$6e22c362a0406a2c)({
    Compare: (0, $kRS0m.compare)
}), false, false);
function $7bbf2c7402328604$export$48bd7047d7efb319(profession, skills) {
    let matchResult;
    if (skills.IgnoreSkillLevelRequirements) matchResult = 0;
    else switch(profession.tag){
        case 1:
        case 2:
            matchResult = 2;
            break;
        case 3:
            matchResult = 3;
            break;
        case 4:
            matchResult = 4;
            break;
        default:
            matchResult = 1;
    }
    switch(matchResult){
        case 0:
            return true;
        case 1:
            return skills.Farming.Level >= 5;
        case 2:
            return skills.Farming.Level >= 10;
        case 3:
            return skills.Foraging.Level >= 5;
        default:
            return skills.Foraging.Level >= 10;
    }
}
function $7bbf2c7402328604$export$ab4ce16a5fab460c(profession, skills) {
    if ($7bbf2c7402328604$export$48bd7047d7efb319(profession, skills)) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(skills.Professions, profession);
    else return false;
}
function $7bbf2c7402328604$var$SkillsModule_ifElseDistribution(probabilities) {
    const dist = new Float64Array(4);
    let currentProb = 1;
    for(let idx = 0; idx <= probabilities.length - 1; idx++){
        const forLoopVar = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, probabilities);
        const prob = currentProb * (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(1, forLoopVar[1]);
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(dist, forLoopVar[0], prob);
        currentProb = currentProb - prob;
    }
    return new $7bbf2c7402328604$export$e7a5f882b7c87870(dist);
}
function $7bbf2c7402328604$export$448a53924e05a12a(fertQuality, skills) {
    const buffLevel = $7bbf2c7402328604$export$ec8168623fc320df(skills.Farming);
    const gold = 0.01 + 0.2 * (buffLevel / 10 + fertQuality * (buffLevel + 2) / 12);
    return $7bbf2c7402328604$var$SkillsModule_ifElseDistribution(fertQuality >= 3 ? [
        [
            3,
            gold / 2
        ],
        [
            2,
            gold
        ],
        [
            1,
            1
        ]
    ] : [
        [
            2,
            gold
        ],
        [
            1,
            (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(2 * gold, 0.75)
        ],
        [
            0,
            1
        ]
    ]);
}
function $7bbf2c7402328604$export$17f2a017346d4cdb(fertilizer, skills) {
    return $7bbf2c7402328604$export$448a53924e05a12a($7bbf2c7402328604$export$4689e1bbdbf4db51(fertilizer), skills);
}
function $7bbf2c7402328604$export$7d37df9c03df61ad(skills) {
    if ($7bbf2c7402328604$export$ab4ce16a5fab460c(new $7bbf2c7402328604$export$42ad0ac7fc7503a6(4, []), skills)) return new $7bbf2c7402328604$export$e7a5f882b7c87870(new Float64Array([
        0,
        0,
        0,
        1
    ]));
    else {
        const buffLevel = $7bbf2c7402328604$export$ec8168623fc320df(skills.Foraging);
        return $7bbf2c7402328604$var$SkillsModule_ifElseDistribution([
            [
                2,
                buffLevel / 30
            ],
            [
                1,
                buffLevel / 15
            ],
            [
                0,
                1
            ]
        ]);
    }
}
function $7bbf2c7402328604$export$57e654937063e3bc(skills) {
    const probs = $7bbf2c7402328604$export$7d37df9c03df61ad(skills);
    if ($7bbf2c7402328604$export$ab4ce16a5fab460c(new $7bbf2c7402328604$export$42ad0ac7fc7503a6(3, []), skills)) return $7bbf2c7402328604$export$a324e82014c2a7ef(1.2, probs);
    else return probs;
}



var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");




var $kRS0m = parcelRequire("kRS0m");

class $cdb0798a49937e52$export$3a8840c5b2ecf003 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Seeds",
            "Vegetable",
            "Fruit",
            "Flower",
            "Forage",
            "ArtisanGood",
            "Other"
        ];
    }
}
function $cdb0798a49937e52$export$bb1b1bb12099cb41() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Category", [], $cdb0798a49937e52$export$3a8840c5b2ecf003, ()=>[
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ]);
}
function $cdb0798a49937e52$export$e843299bff4b2adc(skills, _arg) {
    let matchResult;
    switch(_arg.tag){
        case 2:
            if ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []), skills)) matchResult = 0;
            else matchResult = 1;
            break;
        case 1:
            if ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []), skills)) matchResult = 0;
            else matchResult = 1;
            break;
        case 3:
            if ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []), skills)) matchResult = 0;
            else matchResult = 1;
            break;
        default:
            matchResult = 1;
    }
    switch(matchResult){
        case 0:
            return 1.1;
        default:
            {
                let matchResult_1;
                if (_arg.tag === 5) {
                    if ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(1, []), skills)) matchResult_1 = 0;
                    else matchResult_1 = 1;
                } else matchResult_1 = 1;
                switch(matchResult_1){
                    case 0:
                        return 1.4;
                    default:
                        return 1;
                }
            }
    }
}
class $cdb0798a49937e52$export$bf73db94524e6efd extends (0, $eATN7.Record) {
    constructor(ProfitMargin, BearsKnowledge, TillerForForagedFruit){
        super();
        this.ProfitMargin = ProfitMargin;
        this.BearsKnowledge = BearsKnowledge;
        this.TillerForForagedFruit = TillerForForagedFruit;
    }
}
function $cdb0798a49937e52$export$64bfc21753b12c95() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Multipliers", [], $cdb0798a49937e52$export$bf73db94524e6efd, ()=>[
            [
                "ProfitMargin",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "BearsKnowledge",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "TillerForForagedFruit",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
const $cdb0798a49937e52$export$c1df43900d74485 = new $cdb0798a49937e52$export$bf73db94524e6efd(1, false, false);
class $cdb0798a49937e52$export$6d08773d2e66f8f2 extends (0, $eATN7.Record) {
    constructor(Id, Name, SellPrice, Category){
        super();
        this.Id = Id;
        this.Name = Name;
        this.SellPrice = SellPrice;
        this.Category = Category;
    }
}
function $cdb0798a49937e52$export$800598ed9ffd5a17() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Item", [], $cdb0798a49937e52$export$6d08773d2e66f8f2, ()=>[
            [
                "Id",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Name",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "SellPrice",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Category",
                $cdb0798a49937e52$export$bb1b1bb12099cb41()
            ]
        ]);
}
const $cdb0798a49937e52$export$862394b9f1767313 = new Uint32Array([
    410,
    398
]);
function $cdb0798a49937e52$export$2b98ae8437d26af2(multipliers, item) {
    if (multipliers.TillerForForagedFruit) return (0, $e5d9070e144b905e$export$2344b14b097df817)(item.Id, $cdb0798a49937e52$export$862394b9f1767313, {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    });
    else return false;
}
function $cdb0798a49937e52$export$c4f9d70374ab8977(skills, multipliers, forage, item) {
    return (forage && (0, $kRS0m.equals)(item.Category, new $cdb0798a49937e52$export$3a8840c5b2ecf003(2, [])) && !$cdb0798a49937e52$export$2b98ae8437d26af2(multipliers, item) ? 1 : $cdb0798a49937e52$export$e843299bff4b2adc(skills, item.Category)) * multipliers.ProfitMargin * (multipliers.BearsKnowledge && item.Id === 410 ? 3 : 1);
}
function $cdb0798a49937e52$var$ItemModule_sellPriceAfterMultipliers(qualityMultiplier, multiplier, basePrice) {
    let value_5, value_2;
    return (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1, (value_5 = multiplier * (value_2 = qualityMultiplier * basePrice, value_2 >>> 0), value_5 >>> 0));
}
function $cdb0798a49937e52$export$79f2cfc9263aeba8(multiplier, basePrice, quality) {
    if (basePrice === 0) return 0;
    else return $cdb0798a49937e52$var$ItemModule_sellPriceAfterMultipliers((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, (0, $7bbf2c7402328604$export$54fd8b3fc157341a).fields[0]), multiplier, basePrice);
}
function $cdb0798a49937e52$export$e7352280cc38789a(skills, multipliers, forage, item, quality) {
    return $cdb0798a49937e52$export$79f2cfc9263aeba8($cdb0798a49937e52$export$c4f9d70374ab8977(skills, multipliers, forage, item), item.SellPrice, quality);
}
function $cdb0798a49937e52$export$5086874fd964ff1e(multiplier, basePrice) {
    if (basePrice === 0) return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Uint32Array(4), 0, 4, 0));
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((quality)=>$cdb0798a49937e52$var$ItemModule_sellPriceAfterMultipliers(quality, multiplier, basePrice), (0, $7bbf2c7402328604$export$54fd8b3fc157341a).fields[0], Uint32Array));
}
function $cdb0798a49937e52$export$74a6bc33980f5545(skills, multipliers, forage, item) {
    return $cdb0798a49937e52$export$5086874fd964ff1e($cdb0798a49937e52$export$c4f9d70374ab8977(skills, multipliers, forage, item), item.SellPrice);
}
function $cdb0798a49937e52$export$2b4b439fa798796a(item) {
    const matchValue = item.Category;
    switch(matchValue.tag){
        case 2:
        case 1:
        case 3:
        case 4:
            return true;
        default:
            return item.Id === 417;
    }
}
function $cdb0798a49937e52$export$dcbc0b335ff6ede5(seed) {
    return 1.95 + (seed === 499 ? 0.005 : 0);
}
class $cdb0798a49937e52$export$d988cf39da1e0d72 extends (0, $eATN7.Record) {
    constructor(Item, Processor, Ratio){
        super();
        this.Item = Item;
        this.Processor = Processor;
        this.Ratio = Ratio;
    }
}
function $cdb0798a49937e52$export$e199f01bc592175b() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.ProcessedItem", [], $cdb0798a49937e52$export$d988cf39da1e0d72, ()=>[
            [
                "Item",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Processor",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "Ratio",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ]
        ]);
}
class $cdb0798a49937e52$export$264ad599d7cef668 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Jam",
            "Pickles",
            "Wine",
            "Juice",
            "SeedsFromSeedMaker",
            "Processed"
        ];
    }
}
function $cdb0798a49937e52$export$dad5cd665e3081d1() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Product", [], $cdb0798a49937e52$export$264ad599d7cef668, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "seed",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    $cdb0798a49937e52$export$e199f01bc592175b()
                ]
            ]
        ]);
}
function $cdb0798a49937e52$export$c6a0133b8eb2ee08(_arg) {
    let item;
    switch(_arg.tag){
        case 1:
            item = _arg.fields[0];
            break;
        case 2:
            item = _arg.fields[0];
            break;
        case 3:
            item = _arg.fields[0];
            break;
        case 4:
            item = _arg.fields[0];
            break;
        case 5:
            item = _arg.fields[0].Item;
            break;
        default:
            item = _arg.fields[0];
    }
    return item;
}
function $cdb0798a49937e52$export$e6b3143d100519a1(getItem, product) {
    const name = getItem($cdb0798a49937e52$export$c6a0133b8eb2ee08(product)).Name;
    switch(product.tag){
        case 1:
            return `Pickled ${name}`;
        case 2:
            return `${name} Wine`;
        case 3:
            return `${name} Juice`;
        case 4:
            return name;
        case 5:
            return name;
        default:
            return `${name} Jam`;
    }
}
function $cdb0798a49937e52$export$3b5fd34b2463eb68(_arg) {
    switch(_arg.tag){
        case 2:
        case 3:
            return "Keg";
        case 4:
            return "Seed Maker";
        case 5:
            return _arg.fields[0].Processor;
        default:
            return "Preserves Jar";
    }
}
function $cdb0798a49937e52$export$511b8a2bc67af810(getItem, qualityArtisanProducts, _arg) {
    switch(_arg.tag){
        case 4:
            return false;
        case 5:
            {
                const p = _arg.fields[0];
                if (qualityArtisanProducts) {
                    if ((0, $kRS0m.equals)(getItem(p.Item).Category, new $cdb0798a49937e52$export$3a8840c5b2ecf003(5, []))) return true;
                    else return p.Item === 395;
                } else return false;
            }
        default:
            return qualityArtisanProducts;
    }
}
function $cdb0798a49937e52$export$403a708bcc36bf56(getItem, qualityArtisanProducts, quality, product) {
    if ($cdb0798a49937e52$export$511b8a2bc67af810(getItem, qualityArtisanProducts, product)) return quality | 0;
    else return 0;
}
function $cdb0798a49937e52$export$83efbe66f022093f(basePrice) {
    return basePrice * 2 + 50;
}
function $cdb0798a49937e52$export$274a72237c790bf2(basePrice) {
    return basePrice * 3;
}
function $cdb0798a49937e52$export$e09e3a35a3df6638(basePrice) {
    const value_2 = 2.25 * basePrice;
    return value_2 >>> 0;
}
function $cdb0798a49937e52$var$ProductModule_productPrice(_arg) {
    switch(_arg.tag){
        case 2:
            return $cdb0798a49937e52$export$274a72237c790bf2;
        case 3:
            return $cdb0798a49937e52$export$e09e3a35a3df6638;
        case 4:
        case 5:
            return (x)=>x;
        default:
            return $cdb0798a49937e52$export$83efbe66f022093f;
    }
}
function $cdb0798a49937e52$var$ProductModule_multiplierAndPrice(getItem, skills, multipliers, product) {
    let matchResult, item, itemId;
    switch(product.tag){
        case 1:
            matchResult = 0;
            item = product.fields[0];
            break;
        case 2:
            matchResult = 0;
            item = product.fields[0];
            break;
        case 3:
            matchResult = 0;
            item = product.fields[0];
            break;
        case 4:
            matchResult = 1;
            itemId = product.fields[0];
            break;
        case 5:
            matchResult = 1;
            itemId = product.fields[0].Item;
            break;
        default:
            matchResult = 0;
            item = product.fields[0];
    }
    switch(matchResult){
        case 0:
            return [
                $cdb0798a49937e52$export$e843299bff4b2adc(skills, new $cdb0798a49937e52$export$3a8840c5b2ecf003(5, [])) * multipliers.ProfitMargin,
                $cdb0798a49937e52$var$ProductModule_productPrice(product)(getItem(item).SellPrice)
            ];
        default:
            {
                const item_1 = getItem(itemId);
                return [
                    $cdb0798a49937e52$export$c4f9d70374ab8977(skills, multipliers, false, item_1),
                    item_1.SellPrice
                ];
            }
    }
}
function $cdb0798a49937e52$export$44ccbacbee724776(getItem, skills, multipliers, qap, quality, product) {
    const patternInput = $cdb0798a49937e52$var$ProductModule_multiplierAndPrice(getItem, skills, multipliers, product);
    const quality_1 = $cdb0798a49937e52$export$403a708bcc36bf56(getItem, qap, quality, product) | 0;
    return [
        $cdb0798a49937e52$export$79f2cfc9263aeba8(patternInput[0], patternInput[1], quality_1),
        quality_1
    ];
}
function $cdb0798a49937e52$export$bd123e9830004dc8(getItem, skills, multipliers, qap, quality, product) {
    return $cdb0798a49937e52$export$44ccbacbee724776(getItem, skills, multipliers, qap, quality, product)[0];
}
function $cdb0798a49937e52$export$c645c9b0434d387(getItem, skills, multipliers, qap, product) {
    const patternInput = $cdb0798a49937e52$var$ProductModule_multiplierAndPrice(getItem, skills, multipliers, product);
    const price = patternInput[1];
    const multiplier = patternInput[0];
    if ($cdb0798a49937e52$export$511b8a2bc67af810(getItem, qap, product)) return $cdb0798a49937e52$export$5086874fd964ff1e(multiplier, price);
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Uint32Array(4), 0, 4, $cdb0798a49937e52$export$79f2cfc9263aeba8(multiplier, price, 0)));
}
function $cdb0798a49937e52$export$209a37fa913f613e(product) {
    let matchResult, seed, i, o;
    switch(product.tag){
        case 4:
            matchResult = 0;
            seed = product.fields[0];
            break;
        case 5:
            if (product.fields[0].Ratio != null) {
                matchResult = 1;
                i = product.fields[0].Ratio[0];
                o = product.fields[0].Ratio[1];
            } else matchResult = 2;
            break;
        default:
            matchResult = 2;
    }
    switch(matchResult){
        case 0:
            return $cdb0798a49937e52$export$dcbc0b335ff6ede5(seed * 1);
        case 1:
            return o / i;
        default:
            return 1;
    }
}
function $cdb0798a49937e52$export$a5f43b83fd6b1aef(getItem, skills, multipliers, qap, quality, product) {
    return $cdb0798a49937e52$export$bd123e9830004dc8(getItem, skills, multipliers, qap, quality, product) * $cdb0798a49937e52$export$209a37fa913f613e(product);
}
function $cdb0798a49937e52$export$2e9a7757f7096130(getItem, skills, multipliers, qap, product) {
    const quantity = $cdb0798a49937e52$export$209a37fa913f613e(product);
    return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((price)=>price * quantity, $cdb0798a49937e52$export$c645c9b0434d387(getItem, skills, multipliers, qap, product).fields[0], Float64Array));
}


function $e189d4fb2d038fab$export$17231478d9f68f3b(season, seasons) {
    return !((1 << season & seasons) === 0);
}
function $e189d4fb2d038fab$export$af4097e6505d16e6(seasons) {
    return (0, $42cbcefff7323768$export$93e2b83da34ff82a)((seasons_1, season)=>seasons_1 | 1 << season, 0, seasons);
}
function $e189d4fb2d038fab$export$2b0a192178337539(a, b) {
    return (0, $0ef027050085b17b$export$1a35e60cc07e6f13)(a, b);
}
function $e189d4fb2d038fab$export$17d0dbcd198f4e3f(season) {
    return (0, $3921efb06a31e9cc$export$e1d90e20ad64402a)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
        [
            "Spring",
            0
        ],
        [
            "Summer",
            1
        ],
        [
            "Fall",
            2
        ],
        [
            "Winter",
            3
        ]
    ]), season);
}
function $e189d4fb2d038fab$var$SeasonModule_wrapAroundNegative(value) {
    if (value < 0) return value + 4 | 0;
    else return value | 0;
}
function $e189d4fb2d038fab$var$SeasonModule_plusMod(i, season) {
    return (season + i) % 4;
}
function $e189d4fb2d038fab$var$SeasonModule_minus(i, season) {
    return $e189d4fb2d038fab$var$SeasonModule_wrapAroundNegative($e189d4fb2d038fab$var$SeasonModule_plusMod((0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(i), season));
}
function $e189d4fb2d038fab$export$cf069fed41640b38(season) {
    return $e189d4fb2d038fab$var$SeasonModule_plusMod(1, season);
}
function $e189d4fb2d038fab$export$b6f4b90f6ce05161(season) {
    return $e189d4fb2d038fab$var$SeasonModule_minus(1, season);
}
function $e189d4fb2d038fab$export$d1ef7efb0a77e09d(start, finish) {
    let seasons = 0;
    let season = start;
    while(season !== finish){
        seasons = seasons | 1 << season | 0;
        season = $e189d4fb2d038fab$export$cf069fed41640b38(season) | 0;
    }
    return seasons | 1 << finish | 0;
}
function $e189d4fb2d038fab$export$285ee136cbe1eabd(start, finish) {
    return $e189d4fb2d038fab$var$SeasonModule_wrapAroundNegative(finish - start);
}
function $e189d4fb2d038fab$export$641f31a913d47020(start, finish) {
    return (0, $e5d9070e144b905e$export$2a47f398eeff8b01)($e189d4fb2d038fab$export$285ee136cbe1eabd(start, finish) + 1, (i)=>$e189d4fb2d038fab$var$SeasonModule_plusMod(i, start), Int32Array);
}
class $e189d4fb2d038fab$export$37a247c0b17a17ff extends (0, $eATN7.Record) {
    constructor(Season, Day){
        super();
        this.Season = Season | 0;
        this.Day = Day;
    }
}
function $e189d4fb2d038fab$export$29a8a6e9851b7490() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.Date", [], $e189d4fb2d038fab$export$37a247c0b17a17ff, ()=>[
            [
                "Season",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ])
            ],
            [
                "Day",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ]
        ]);
}
function $e189d4fb2d038fab$export$ade24b166187735c(start, finish) {
    const days = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Uint32Array($e189d4fb2d038fab$export$285ee136cbe1eabd(start.Season, finish.Season) + 1), 0, $e189d4fb2d038fab$export$285ee136cbe1eabd(start.Season, finish.Season) + 1, 28);
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(days, 0, 28 - start.Day + 1);
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(days, days.length - 1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(days.length - 1, days) - (28 - finish.Day));
    return days;
}
function $e189d4fb2d038fab$export$76d2bde4e6058336(start, finish) {
    let value;
    return (value = $e189d4fb2d038fab$export$285ee136cbe1eabd(start.Season, finish.Season) | 0, value >>> 0) * 28 - start.Day + finish.Day + 1;
}
function $e189d4fb2d038fab$export$5ec9284b921d00e4(toolLevel) {
    return (0, $3921efb06a31e9cc$export$e1d90e20ad64402a)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.ToolLevel", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
        [
            "Normal",
            0
        ],
        [
            "Copper",
            1
        ],
        [
            "Steel",
            2
        ],
        [
            "Gold",
            3
        ],
        [
            "Iridium",
            4
        ]
    ]), toolLevel);
}
class $e189d4fb2d038fab$export$c856d3225a0dda43 extends (0, $eATN7.Record) {
    constructor(SpecialCharm, LuckBuff, GiantCropOrientationsPerTile, ShavingToolLevel){
        super();
        this.SpecialCharm = SpecialCharm;
        this.LuckBuff = LuckBuff;
        this.GiantCropOrientationsPerTile = GiantCropOrientationsPerTile;
        this.ShavingToolLevel = ShavingToolLevel;
    }
}
function $e189d4fb2d038fab$export$3c1fb9f69cd3649() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.CropAmountSettings", [], $e189d4fb2d038fab$export$c856d3225a0dda43, ()=>[
            [
                "SpecialCharm",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "LuckBuff",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "GiantCropOrientationsPerTile",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ShavingToolLevel",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.ToolLevel", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Copper",
                        1
                    ],
                    [
                        "Steel",
                        2
                    ],
                    [
                        "Gold",
                        3
                    ],
                    [
                        "Iridium",
                        4
                    ]
                ]))
            ]
        ]);
}
const $e189d4fb2d038fab$export$d4f06157fdf80d3d = new $e189d4fb2d038fab$export$c856d3225a0dda43(false, 0, 3, undefined);
class $e189d4fb2d038fab$export$580189a0f5486b62 extends (0, $eATN7.Record) {
    constructor(MinCropYield, MaxCropYield, ExtraCropChance, CanDouble, FarmLevelsPerYieldIncrease, FarmingQualities){
        super();
        this.MinCropYield = MinCropYield;
        this.MaxCropYield = MaxCropYield;
        this.ExtraCropChance = ExtraCropChance;
        this.CanDouble = CanDouble;
        this.FarmLevelsPerYieldIncrease = FarmLevelsPerYieldIncrease;
        this.FarmingQualities = FarmingQualities;
    }
}
function $e189d4fb2d038fab$export$78162291eae1f110() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.CropAmount", [], $e189d4fb2d038fab$export$580189a0f5486b62, ()=>[
            [
                "MinCropYield",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "MaxCropYield",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "ExtraCropChance",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "CanDouble",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "FarmLevelsPerYieldIncrease",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "FarmingQualities",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
const $e189d4fb2d038fab$export$8beea5fd6014ad13 = new $e189d4fb2d038fab$export$580189a0f5486b62(1, 1, 0, true, 0, true);
function $e189d4fb2d038fab$export$46bdf02ee511d984(settings) {
    return (settings.SpecialCharm ? 0.025 : 0) / 1200 + settings.LuckBuff / 1500 + 0.0001;
}
function $e189d4fb2d038fab$export$ad794f70a3ba900d(settings, quantity) {
    return $e189d4fb2d038fab$export$46bdf02ee511d984(settings) * quantity + quantity;
}
function $e189d4fb2d038fab$export$4d576ebde18299af(extraChance) {
    return 1 / (1 - (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(extraChance, 0.9)) - 1;
}
function $e189d4fb2d038fab$export$40c9c0334082ca24(skills, settings, amount) {
    const expectedQuantity = (amount.MinCropYield + amount.MaxCropYield + (amount.FarmLevelsPerYieldIncrease !== 0 && (amount.MinCropYield > 1 ? true : amount.MaxCropYield > 1) ? ~~(skills.Farming.Level / amount.FarmLevelsPerYieldIncrease) : 0)) / 2 + $e189d4fb2d038fab$export$4d576ebde18299af(amount.ExtraCropChance);
    if (amount.CanDouble) return $e189d4fb2d038fab$export$ad794f70a3ba900d(settings, expectedQuantity);
    else return expectedQuantity;
}
function $e189d4fb2d038fab$export$3ffac6b237f05023(skills, settings, cropAmount, farmingQuantities) {
    const quantity = $e189d4fb2d038fab$export$40c9c0334082ca24(skills, settings, cropAmount);
    if (cropAmount.FarmingQualities) {
        const qualities_1 = farmingQuantities;
        return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$b6d8713d53419d4c)(0, quantity - 1 + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, qualities_1.fields[0]), qualities_1.fields[0], Float64Array));
    } else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$b6d8713d53419d4c)(0, quantity + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $7bbf2c7402328604$export$127ff803a92644c).fields[0]), (0, $7bbf2c7402328604$export$127ff803a92644c).fields[0], Float64Array));
}
function $e189d4fb2d038fab$export$a46b3ab4a7186455(shavingToolLevel) {
    const damage = ~~(shavingToolLevel / 2) + 1 | 0;
    const shavingProb = damage / 5;
    return ~~(3 / damage) * shavingProb * (2 * damage) + shavingProb * (2 * (3 % damage));
}
function $e189d4fb2d038fab$export$6065c2a4b37f9358(settings) {
    return 2 + (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, $e189d4fb2d038fab$export$a46b3ab4a7186455, settings.ShavingToolLevel);
}
function $e189d4fb2d038fab$export$74ed7df6b1c9d864(settings) {
    const arg0__1 = 0.99;
    return Math.pow(arg0__1, settings.GiantCropOrientationsPerTile);
}
function $e189d4fb2d038fab$export$357b9c25784b5f74(skills, settings, amount) {
    const nonGiantQuantity = $e189d4fb2d038fab$export$40c9c0334082ca24(skills, settings, amount);
    const giantQuantity = $e189d4fb2d038fab$export$6065c2a4b37f9358(settings);
    const noGiantProb = $e189d4fb2d038fab$export$74ed7df6b1c9d864(settings);
    return noGiantProb * nonGiantQuantity + (1 - noGiantProb) * giantQuantity;
}
function $e189d4fb2d038fab$export$63bad12f713b5ee5(skills, settings, amount, farmingQuantities) {
    const noGiantProb = $e189d4fb2d038fab$export$74ed7df6b1c9d864(settings);
    const expectedGiant = (1 - noGiantProb) * $e189d4fb2d038fab$export$6065c2a4b37f9358(settings);
    const qualities_2 = (0, $7bbf2c7402328604$export$a324e82014c2a7ef)(noGiantProb, $e189d4fb2d038fab$export$3ffac6b237f05023(skills, settings, amount, farmingQuantities));
    return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$b6d8713d53419d4c)(0, expectedGiant + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, qualities_2.fields[0]), qualities_2.fields[0], Float64Array));
}
class $e189d4fb2d038fab$export$5b280effc20e3931 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "FixedPrice",
            "ScalingPrice"
        ];
    }
}
function $e189d4fb2d038fab$export$cddd08008c542aa3() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.SeedPrice", [], $e189d4fb2d038fab$export$5b280effc20e3931, ()=>[
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ]
        ]);
}
function $e189d4fb2d038fab$export$e847fdb9cedfbd36(_arg) {
    let v;
    if (_arg.tag === 1) v = _arg.fields[0];
    else v = _arg.fields[0];
    return v;
}
function $e189d4fb2d038fab$export$455c07935541b632(speedBonus, stages) {
    const total = (0, $e5d9070e144b905e$export$8a63f25cc62965f1)(stages, {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    });
    const stages_1 = (0, $e5d9070e144b905e$export$784d13d8ee351f07)(stages);
    let daysToReduce;
    let value_1;
    const value = Math.fround(speedBonus) * total;
    value_1 = Math.ceil(value);
    daysToReduce = value_1 >>> 0;
    let daysReduced = 0;
    let traverses = 0;
    while(daysReduced < daysToReduce && traverses < 3){
        if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, stages_1) > 1) {
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(stages_1, 0, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, stages_1) - 1);
            daysReduced = daysReduced + 1;
        }
        let stage = 1;
        while(daysReduced < daysToReduce && stage < stages_1.length){
            if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(stage, stages_1) > 0) {
                (0, $e5d9070e144b905e$export$8a8216c44337cd5)(stages_1, stage, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(stage, stages_1) - 1);
                daysReduced = daysReduced + 1;
            }
            stage = stage + 1 | 0;
        }
        traverses = traverses + 1;
    }
    return [
        stages_1,
        total - daysReduced
    ];
}
function $e189d4fb2d038fab$export$afe58414eb6e822(regrowTime, growthTime, days) {
    const days_1 = days - 1;
    if (regrowTime == null) return ~~(days_1 / growthTime) | 0;
    else if (growthTime > days_1) return 0;
    else {
        const time = regrowTime;
        return 1 + ~~((days_1 - growthTime) / time);
    }
}
function $e189d4fb2d038fab$export$540e37fd0d22453b(regrowTime, growthTime, harvests) {
    if (regrowTime == null) return growthTime * harvests;
    else return growthTime + regrowTime * (harvests - 1);
}
class $e189d4fb2d038fab$export$be4357b4be0569ed extends (0, $eATN7.Record) {
    constructor(Seed, Item, Amount, ExtraItem, Giant, Seasons, Stages, RegrowTime, Paddy){
        super();
        this.Seed = Seed;
        this.Item = Item;
        this.Amount = Amount;
        this.ExtraItem = ExtraItem;
        this.Giant = Giant;
        this.Seasons = Seasons | 0;
        this.Stages = Stages;
        this.RegrowTime = RegrowTime;
        this.Paddy = Paddy;
    }
}
function $e189d4fb2d038fab$export$5eb9b2f9b0a5c405() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.FarmCrop", [], $e189d4fb2d038fab$export$be4357b4be0569ed, ()=>[
            [
                "Seed",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Item",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Amount",
                $e189d4fb2d038fab$export$78162291eae1f110()
            ],
            [
                "ExtraItem",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)))
            ],
            [
                "Giant",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "Seasons",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Seasons", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "None",
                        0
                    ],
                    [
                        "Spring",
                        1
                    ],
                    [
                        "Summer",
                        2
                    ],
                    [
                        "Fall",
                        4
                    ],
                    [
                        "Winter",
                        8
                    ],
                    [
                        "All",
                        15
                    ]
                ])
            ],
            [
                "Stages",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "RegrowTime",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "Paddy",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
function $e189d4fb2d038fab$export$2e2a6174825fd428(crop) {
    return crop.Seed * 1;
}
function $e189d4fb2d038fab$export$4f6ced0ca5ac5df1(season, crop) {
    return $e189d4fb2d038fab$export$17231478d9f68f3b(season, crop.Seasons);
}
function $e189d4fb2d038fab$export$70e277d5cd0ce149(seasons, crop) {
    return !((seasons & crop.Seasons) === 0);
}
function $e189d4fb2d038fab$export$31d622cd09c8b99e(item, crop) {
    const price = item(crop.Item).SellPrice;
    const value_2 = (0, $kRS0m.round)(16 * Math.log(0.018 * price + 1));
    return value_2 >>> 0;
}
function $e189d4fb2d038fab$export$75b9a8d7898562b5(giantCropProb, crop) {
    if (crop.Giant) return 1 - giantCropProb;
    else return 1;
}
function $e189d4fb2d038fab$export$3d0291ad00f066e0(item, giantCropProb, crop) {
    return $e189d4fb2d038fab$export$31d622cd09c8b99e(item, crop) * $e189d4fb2d038fab$export$75b9a8d7898562b5(giantCropProb, crop);
}
function $e189d4fb2d038fab$export$c18dcc1cdb869855(crop) {
    const matchValue = crop.ExtraItem;
    if (matchValue == null) return new Uint32Array([
        crop.Item
    ]);
    else return new Uint32Array([
        crop.Item,
        matchValue[0]
    ]);
}
class $e189d4fb2d038fab$export$4c9fbc271eb33a56 extends (0, $eATN7.Record) {
    constructor(Seed, Foragables, SeedRecipeUnlockLevel, Season, Stages){
        super();
        this.Seed = Seed;
        this.Foragables = Foragables;
        this.SeedRecipeUnlockLevel = SeedRecipeUnlockLevel;
        this.Season = Season | 0;
        this.Stages = Stages;
    }
}
function $e189d4fb2d038fab$export$d4562a271dfbcd7() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.ForageCrop", [], $e189d4fb2d038fab$export$4c9fbc271eb33a56, ()=>[
            [
                "Seed",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Foragables",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "SeedRecipeUnlockLevel",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Season",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ])
            ],
            [
                "Stages",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ]
        ]);
}
function $e189d4fb2d038fab$export$62ea73f630367ff4(crop) {
    return crop.Seed * 1;
}
function $e189d4fb2d038fab$export$fe4953169b833a05(item, crop) {
    return item(crop.Seed * 1).Name;
}
function $e189d4fb2d038fab$export$d8c874891ace1c01(skills, crop) {
    return skills.Foraging.Level >= crop.SeedRecipeUnlockLevel;
}
function $e189d4fb2d038fab$export$70f1cb7c361e987(crop) {
    return 1 << crop.Season;
}
function $e189d4fb2d038fab$export$15655c68d8532196(season, crop) {
    return crop.Season === season;
}
function $e189d4fb2d038fab$export$13a39490af2cacb6(seasons, crop) {
    return $e189d4fb2d038fab$export$17231478d9f68f3b(crop.Season, seasons);
}
function $e189d4fb2d038fab$export$ad7c058c40b5f8ce(skills) {
    if ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(3, []), skills)) return 1.2;
    else return 1;
}
function $e189d4fb2d038fab$export$986570cdcba4cb5d(skills) {
    return 5 * $e189d4fb2d038fab$export$ad7c058c40b5f8ce(skills);
}
class $e189d4fb2d038fab$export$8e58b6dc125f7f1b extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "FarmCrop",
            "ForageCrop"
        ];
    }
}
function $e189d4fb2d038fab$export$614a3506a98cbb0e() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Crop", [], $e189d4fb2d038fab$export$8e58b6dc125f7f1b, ()=>[
            [
                [
                    "Item",
                    $e189d4fb2d038fab$export$5eb9b2f9b0a5c405()
                ]
            ],
            [
                [
                    "Item",
                    $e189d4fb2d038fab$export$d4562a271dfbcd7()
                ]
            ]
        ]);
}
function $e189d4fb2d038fab$export$f1b4c0d5ff03a35f(item, _arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$fe4953169b833a05(item, _arg.fields[0]);
    else return item(_arg.fields[0].Item).Name;
}
function $e189d4fb2d038fab$export$b5a6878176d48f7f(_arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$70f1cb7c361e987(_arg.fields[0]) | 0;
    else return _arg.fields[0].Seasons | 0;
}
function $e189d4fb2d038fab$export$9cc23dda456089a(season, _arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$15655c68d8532196(season, _arg.fields[0]);
    else return $e189d4fb2d038fab$export$4f6ced0ca5ac5df1(season, _arg.fields[0]);
}
function $e189d4fb2d038fab$export$4c2775d8781aa270(seasons, _arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$13a39490af2cacb6(seasons, _arg.fields[0]);
    else return $e189d4fb2d038fab$export$70e277d5cd0ce149(seasons, _arg.fields[0]);
}
function $e189d4fb2d038fab$export$84ab64957aa0b624(_arg) {
    if (_arg.tag === 1) return _arg.fields[0].Stages;
    else return _arg.fields[0].Stages;
}
function $e189d4fb2d038fab$export$f226ed110ac4bf77(crop) {
    return (0, $e5d9070e144b905e$export$8a63f25cc62965f1)($e189d4fb2d038fab$export$84ab64957aa0b624(crop), {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    });
}
function $e189d4fb2d038fab$export$bc42fb51d91a98ea(_arg) {
    if (_arg.tag === 1) return false;
    else return _arg.fields[0].Paddy;
}
function $e189d4fb2d038fab$export$6d4b23de33bebe68(_arg) {
    if (_arg.tag === 1) return false;
    else return _arg.fields[0].Giant;
}
function $e189d4fb2d038fab$export$e3cd08c7ffece832(_arg) {
    if (_arg.tag === 1) return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, _arg.fields[0].Foragables);
    else return _arg.fields[0].Item;
}
function $e189d4fb2d038fab$export$a873be80581d6a18(_arg) {
    if (_arg.tag === 1) return _arg.fields[0].Foragables;
    else return $e189d4fb2d038fab$export$c18dcc1cdb869855(_arg.fields[0]);
}
function $e189d4fb2d038fab$export$f448f4dc09946ac4(_arg) {
    if (_arg.tag === 1) return _arg.fields[0].Seed;
    else return _arg.fields[0].Seed;
}
function $e189d4fb2d038fab$export$33d35c6548f3ff99(_arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$62ea73f630367ff4(_arg.fields[0]);
    else return $e189d4fb2d038fab$export$2e2a6174825fd428(_arg.fields[0]);
}
function $e189d4fb2d038fab$export$5692a699d737ba41(speed, crop) {
    return $e189d4fb2d038fab$export$455c07935541b632(speed, $e189d4fb2d038fab$export$84ab64957aa0b624(crop))[1];
}
function $e189d4fb2d038fab$export$cca15d7258ab2709(speed, crop) {
    return $e189d4fb2d038fab$export$455c07935541b632(speed, $e189d4fb2d038fab$export$84ab64957aa0b624(crop));
}
function $e189d4fb2d038fab$export$93f201b907e0b82c(_arg) {
    if (_arg.tag === 1) return undefined;
    else return _arg.fields[0].RegrowTime;
}
const $e189d4fb2d038fab$export$52eb22f4c7e28f2f = (arg)=>$e189d4fb2d038fab$export$93f201b907e0b82c(arg) != null;
function $e189d4fb2d038fab$export$29c1f1b1e148f91a(item, _arg) {
    if (_arg.tag === 1) return 5;
    else return $e189d4fb2d038fab$export$31d622cd09c8b99e(item, _arg.fields[0]);
}
function $e189d4fb2d038fab$export$def8c5c8d048f5dd(giantCropProb, skills, _arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$ad7c058c40b5f8ce(skills);
    else return $e189d4fb2d038fab$export$75b9a8d7898562b5(giantCropProb, _arg.fields[0]);
}
function $e189d4fb2d038fab$export$f34c1d38a2aa4e8f(item, giantCropProb, skills, _arg) {
    if (_arg.tag === 1) return $e189d4fb2d038fab$export$986570cdcba4cb5d(skills);
    else return $e189d4fb2d038fab$export$3d0291ad00f066e0(item, giantCropProb, _arg.fields[0]);
}
function $e189d4fb2d038fab$export$c494ac7f0bc75424(_arg) {
    if (_arg.tag === 1) return false;
    else return true;
}
function $e189d4fb2d038fab$export$a6e0eedf3a1bd082(_arg) {
    if (_arg.tag === 1) return true;
    else return false;
}
function $e189d4fb2d038fab$export$9a6d33d4fe8fe14(item, crop) {
    return (0, $cdb0798a49937e52$export$2b4b439fa798796a)(item($e189d4fb2d038fab$export$e3cd08c7ffece832(crop)));
}
function $e189d4fb2d038fab$export$518a79ca6e7bc25b(crop) {
    const array = $e189d4fb2d038fab$export$a873be80581d6a18(crop);
    return (0, $e5d9070e144b905e$export$2344b14b097df817)($e189d4fb2d038fab$export$33d35c6548f3ff99(crop), array, {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    });
}







var $eATN7 = parcelRequire("eATN7");



var $eATN7 = parcelRequire("eATN7");




var $eATN7 = parcelRequire("eATN7");












var $kRS0m = parcelRequire("kRS0m");


var $kRS0m = parcelRequire("kRS0m");




var $eATN7 = parcelRequire("eATN7");



class $148a4dcdb95c00cf$export$4ee70ab773570fb9 {
    constructor(pairs, comparer){
        const this$ = new (0, $eATN7.FSharpRef)((0, $kRS0m.defaultOf)());
        this.comparer = comparer;
        this$.contents = this;
        this.hashMap = new Map([]);
        this["init@9"] = 1;
        const enumerator = (0, $kRS0m.getEnumerator)(pairs);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
                const pair = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                $148a4dcdb95c00cf$export$ba2096b25cef384a(this$.contents, pair[0], pair[1]);
            }
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
    }
    get [Symbol.toStringTag]() {
        return "Dictionary";
    }
    toJSON() {
        const this$ = this;
        return Array.from(this$);
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const this$ = this;
        return (0, $kRS0m.getEnumerator)(this$);
    }
    GetEnumerator() {
        const this$ = this;
        return (0, $kRS0m.getEnumerator)((0, $42cbcefff7323768$export$ee1b3e54f0441b22)(this$.hashMap.values()));
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.Generic.ICollection`1.Add2B595"(item) {
        const this$ = this;
        $148a4dcdb95c00cf$export$ba2096b25cef384a(this$, item[0], item[1]);
    }
    "System.Collections.Generic.ICollection`1.Clear"() {
        const this$ = this;
        $148a4dcdb95c00cf$export$3c9dc81c11c6bc9f(this$);
    }
    "System.Collections.Generic.ICollection`1.Contains2B595"(item) {
        const this$ = this;
        const matchValue = $148a4dcdb95c00cf$export$510c553bbf6d6b14(this$, item[0]);
        let matchResult, p_1;
        if (matchValue != null) {
            if ((0, $kRS0m.equals)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[1], item[1])) {
                matchResult = 0;
                p_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
            } else matchResult = 1;
        } else matchResult = 1;
        switch(matchResult){
            case 0:
                return true;
            default:
                return false;
        }
    }
    "System.Collections.Generic.ICollection`1.CopyToZ3B4C077E"(array, arrayIndex) {
        const this$ = this;
        (0, $42cbcefff7323768$export$5a067165821eae2d)((i, e)=>{
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(array, arrayIndex + i, e);
        }, this$);
    }
    "System.Collections.Generic.ICollection`1.get_Count"() {
        const this$ = this;
        return $148a4dcdb95c00cf$export$72e692789747521f(this$) | 0;
    }
    "System.Collections.Generic.ICollection`1.get_IsReadOnly"() {
        return false;
    }
    "System.Collections.Generic.ICollection`1.Remove2B595"(item) {
        const this$ = this;
        const matchValue = $148a4dcdb95c00cf$export$510c553bbf6d6b14(this$, item[0]);
        if (matchValue != null) {
            if ((0, $kRS0m.equals)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[1], item[1])) $148a4dcdb95c00cf$export$168563ec280211b8(this$, item[0]);
            return true;
        } else return false;
    }
    "System.Collections.Generic.IDictionary`2.Add5BDDA1"(key, value) {
        const this$ = this;
        $148a4dcdb95c00cf$export$ba2096b25cef384a(this$, key, value);
    }
    "System.Collections.Generic.IDictionary`2.ContainsKey2B595"(key) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$a2c9e2aff7ba0982(this$, key);
    }
    "System.Collections.Generic.IDictionary`2.get_Item2B595"(key) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$b13a1d87696b48f1(this$, key);
    }
    "System.Collections.Generic.IDictionary`2.set_Item5BDDA1"(key, v) {
        const this$ = this;
        $148a4dcdb95c00cf$export$44c7cd7d90e2d424(this$, key, v);
    }
    "System.Collections.Generic.IDictionary`2.get_Keys"() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$871de8747c9eaa88)((pair)=>pair[0], this$)));
    }
    "System.Collections.Generic.IDictionary`2.Remove2B595"(key) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$168563ec280211b8(this$, key);
    }
    "System.Collections.Generic.IDictionary`2.TryGetValue6DC89625"(key, value) {
        const this$ = this;
        const matchValue = $148a4dcdb95c00cf$export$510c553bbf6d6b14(this$, key);
        if (matchValue != null) {
            const pair = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
            value.contents = pair[1];
            return true;
        } else return false;
    }
    "System.Collections.Generic.IDictionary`2.get_Values"() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$871de8747c9eaa88)((pair)=>pair[1], this$)));
    }
    get size() {
        const this$ = this;
        return $148a4dcdb95c00cf$export$72e692789747521f(this$) | 0;
    }
    clear() {
        const this$ = this;
        $148a4dcdb95c00cf$export$3c9dc81c11c6bc9f(this$);
    }
    delete(k) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$168563ec280211b8(this$, k);
    }
    entries() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>[
                p[0],
                p[1]
            ], this$);
    }
    get(k) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$b13a1d87696b48f1(this$, k);
    }
    has(k) {
        const this$ = this;
        return $148a4dcdb95c00cf$export$a2c9e2aff7ba0982(this$, k);
    }
    keys() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>p[0], this$);
    }
    set(k, v) {
        const this$ = this;
        $148a4dcdb95c00cf$export$44c7cd7d90e2d424(this$, k, v);
        return this$;
    }
    values() {
        const this$ = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>p[1], this$);
    }
    forEach(f, thisArg) {
        const this$ = this;
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((p)=>{
            f(p[1], p[0], this$);
        }, this$);
    }
}
function $148a4dcdb95c00cf$export$2d577e7fd69dea43(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.Collections.Dictionary", [
        gen0,
        gen1
    ], $148a4dcdb95c00cf$export$4ee70ab773570fb9);
}
function $148a4dcdb95c00cf$export$14d0579bed7eb105(pairs, comparer) {
    return new $148a4dcdb95c00cf$export$4ee70ab773570fb9(pairs, comparer);
}
function $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k) {
    const h = this$.comparer.GetHashCode(k) | 0;
    let matchValue;
    let outArg = (0, $kRS0m.defaultOf)();
    matchValue = [
        (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(this$.hashMap, h, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ];
    if (matchValue[0]) return [
        true,
        h,
        matchValue[1].findIndex((pair)=>this$.comparer.Equals(k, pair[0]))
    ];
    else return [
        false,
        h,
        -1
    ];
}
function $148a4dcdb95c00cf$export$510c553bbf6d6b14(this$, k) {
    const matchValue = $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1])[matchValue[2]];
        default:
            return undefined;
    }
}
function $148a4dcdb95c00cf$export$6bafbbdf72c93fba(this$) {
    return this$.comparer;
}
function $148a4dcdb95c00cf$export$3c9dc81c11c6bc9f(this$) {
    this$.hashMap.clear();
}
function $148a4dcdb95c00cf$export$72e692789747521f(this$) {
    let count = 0;
    let enumerator = (0, $kRS0m.getEnumerator)(this$.hashMap.values());
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const pairs = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            count = count + pairs.length | 0;
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return count | 0;
}
function $148a4dcdb95c00cf$export$b13a1d87696b48f1(this$, k) {
    const matchValue = $148a4dcdb95c00cf$export$510c553bbf6d6b14(this$, k);
    if (matchValue != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue)[1];
    else throw new Error("The item was not found in collection");
}
function $148a4dcdb95c00cf$export$44c7cd7d90e2d424(this$, k, v) {
    const matchValue = $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k);
    if (matchValue[0]) {
        if (matchValue[2] > -1) (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1])[matchValue[2]] = [
            k,
            v
        ];
        else {
            const value = void (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1]).push([
                k,
                v
            ]);
        }
    } else this$.hashMap.set(matchValue[1], [
        [
            k,
            v
        ]
    ]);
}
function $148a4dcdb95c00cf$export$ba2096b25cef384a(this$, k, v) {
    const matchValue = $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k);
    if (matchValue[0]) {
        if (matchValue[2] > -1) throw new Error((0, $7802b3aa01031554$export$d9468344d3651243)("An item with the same key has already been added. Key: {0}", k));
        else {
            const value = void (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1]).push([
                k,
                v
            ]);
        }
    } else this$.hashMap.set(matchValue[1], [
        [
            k,
            v
        ]
    ]);
}
function $148a4dcdb95c00cf$export$a2c9e2aff7ba0982(this$, k) {
    const matchValue = $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return true;
        default:
            return false;
    }
}
function $148a4dcdb95c00cf$export$168563ec280211b8(this$, k) {
    const matchValue = $148a4dcdb95c00cf$var$Dictionary__TryFindIndex_2B595(this$, k);
    let matchResult;
    if (matchValue[0]) {
        if (matchValue[2] > -1) matchResult = 0;
        else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(this$.hashMap, matchValue[1]).splice(matchValue[2], 1);
            return true;
        default:
            return false;
    }
}



var $eATN7 = parcelRequire("eATN7");
function $2f87a1ba4ae7cb49$export$983a3b5fb2f7202e(xs, comparer) {
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const hashSet = new (0, $3029827f1b7d692a$export$9d0bf21c11057332)([], comparer);
        return (0, $42cbcefff7323768$export$3dea766d36a8935f)((x)=>(0, $b5b450d1f3f8f266$export$59d4ed6bef8b84dd)(x, hashSet), xs);
    });
}
function $2f87a1ba4ae7cb49$export$6c6b412778ff3439(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const hashSet = new (0, $3029827f1b7d692a$export$9d0bf21c11057332)([], comparer);
        return (0, $42cbcefff7323768$export$3dea766d36a8935f)((x)=>(0, $b5b450d1f3f8f266$export$59d4ed6bef8b84dd)(projection(x), hashSet), xs);
    });
}
function $2f87a1ba4ae7cb49$export$67aba9fb222c5e1d(itemsToExclude, xs, comparer) {
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const hashSet = new (0, $3029827f1b7d692a$export$9d0bf21c11057332)(itemsToExclude, comparer);
        return (0, $42cbcefff7323768$export$3dea766d36a8935f)((x)=>(0, $b5b450d1f3f8f266$export$59d4ed6bef8b84dd)(x, hashSet), xs);
    });
}
function $2f87a1ba4ae7cb49$export$1d012a0dff3dab06(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const dict = new (0, $148a4dcdb95c00cf$export$4ee70ab773570fb9)([], comparer);
        const keys = [];
        const enumerator = (0, $kRS0m.getEnumerator)(xs);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
                const key = projection(enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]());
                let matchValue;
                let outArg = 0;
                matchValue = [
                    (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(dict, key, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v | 0;
                    })),
                    outArg
                ];
                if (matchValue[0]) dict.set(key, matchValue[1] + 1);
                else {
                    dict.set(key, 1);
                    keys.push(key);
                }
            }
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((key_1)=>[
                key_1,
                (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(dict, key_1)
            ], keys);
    });
}
function $2f87a1ba4ae7cb49$export$3f063810d7bf01bd(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const dict = new (0, $148a4dcdb95c00cf$export$4ee70ab773570fb9)([], comparer);
        const keys = [];
        const enumerator = (0, $kRS0m.getEnumerator)(xs);
        try {
            while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
                const x = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                const key = projection(x);
                let matchValue;
                let outArg = (0, $kRS0m.defaultOf)();
                matchValue = [
                    (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(dict, key, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
                if (matchValue[0]) matchValue[1].push(x);
                else {
                    (0, $b5b450d1f3f8f266$export$640abc42af5f7b25)(dict, key, [
                        x
                    ]);
                    keys.push(key);
                }
            }
        } finally{
            (0, $kRS0m.disposeSafe)(enumerator);
        }
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((key_1)=>[
                key_1,
                (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(dict, key_1)
            ], keys);
    });
}
function $2f87a1ba4ae7cb49$export$2fb09f0d977e5bc3(xs, comparer) {
    return (0, $42cbcefff7323768$export$45b10814cc054894)($2f87a1ba4ae7cb49$export$983a3b5fb2f7202e(xs, comparer));
}
function $2f87a1ba4ae7cb49$export$effbaf7fe33d93db(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$45b10814cc054894)($2f87a1ba4ae7cb49$export$6c6b412778ff3439(projection, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$ba2ab87988640898(itemsToExclude, xs, comparer) {
    return (0, $42cbcefff7323768$export$45b10814cc054894)($2f87a1ba4ae7cb49$export$67aba9fb222c5e1d(itemsToExclude, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$3ae317badb60c618(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$45b10814cc054894)($2f87a1ba4ae7cb49$export$1d012a0dff3dab06(projection, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>[
            tupledArg[0],
            (0, $42cbcefff7323768$export$45b10814cc054894)(tupledArg[1])
        ], $2f87a1ba4ae7cb49$export$3f063810d7bf01bd(projection, xs, comparer)));
}
function $2f87a1ba4ae7cb49$export$79e69e71065d8ca8(xs, comparer) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)($2f87a1ba4ae7cb49$export$983a3b5fb2f7202e(xs, comparer));
}
function $2f87a1ba4ae7cb49$export$c8355bec154476ab(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)($2f87a1ba4ae7cb49$export$6c6b412778ff3439(projection, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$7206ce0619e34641(itemsToExclude, xs, comparer) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)($2f87a1ba4ae7cb49$export$67aba9fb222c5e1d(itemsToExclude, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$9fd5f180a285fbe9(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)($2f87a1ba4ae7cb49$export$1d012a0dff3dab06(projection, xs, comparer));
}
function $2f87a1ba4ae7cb49$export$f02d921629812702(projection, xs, comparer) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>[
            tupledArg[0],
            (0, $42cbcefff7323768$export$effcdbd76139450)(tupledArg[1])
        ], $2f87a1ba4ae7cb49$export$3f063810d7bf01bd(projection, xs, comparer)));
}



var $kRS0m = parcelRequire("kRS0m");

class $a117bb35793377d5$export$c44280b23694a5a5 extends (0, $eATN7.Record) {
    constructor(Items, Products, FarmCrops, ForageCrops){
        super();
        this.Items = Items;
        this.Products = Products;
        this.FarmCrops = FarmCrops;
        this.ForageCrops = ForageCrops;
    }
}
function $a117bb35793377d5$export$5a4265096a05f379() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.ExtractedData", [], $a117bb35793377d5$export$c44280b23694a5a5, ()=>[
            [
                "Items",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $cdb0798a49937e52$export$800598ed9ffd5a17)())
            ],
            [
                "Products",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $cdb0798a49937e52$export$e199f01bc592175b)()))
            ],
            [
                "FarmCrops",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $e189d4fb2d038fab$export$5eb9b2f9b0a5c405)())
            ],
            [
                "ForageCrops",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $e189d4fb2d038fab$export$d4562a271dfbcd7)())
            ]
        ]);
}
class $a117bb35793377d5$export$5636878579d6b4b0 extends (0, $eATN7.Record) {
    constructor(Fertilizers, FertilizerPrices, GenerateSeedPrices, SeedPrices, ProcessorUnlockLevel){
        super();
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.GenerateSeedPrices = GenerateSeedPrices;
        this.SeedPrices = SeedPrices;
        this.ProcessorUnlockLevel = ProcessorUnlockLevel;
    }
}
function $a117bb35793377d5$export$51d6abd8faaebcc9() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.SupplementalData", [], $a117bb35793377d5$export$5636878579d6b4b0, ()=>[
            [
                "Fertilizers",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "FertilizerPrices",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ],
            [
                "GenerateSeedPrices",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ],
            [
                "SeedPrices",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $e189d4fb2d038fab$export$cddd08008c542aa3)()))
            ],
            [
                "ProcessorUnlockLevel",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ]
        ]);
}
class $a117bb35793377d5$export$4e4902e9343e97d0 extends (0, $eATN7.Record) {
    constructor(Fertilizers, FertilizerPrices, Crops, SeedPrices, Seed, Items, Products, ProcessorUnlockLevel){
        super();
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.Crops = Crops;
        this.SeedPrices = SeedPrices;
        this.Seed = Seed;
        this.Items = Items;
        this.Products = Products;
        this.ProcessorUnlockLevel = ProcessorUnlockLevel;
    }
}
function $a117bb35793377d5$export$673822fe45936d46() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.GameData", [], $a117bb35793377d5$export$4e4902e9343e97d0, ()=>[
            [
                "Fertilizers",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "FertilizerPrices",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ],
            [
                "Crops",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)())
            ],
            [
                "SeedPrices",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $e189d4fb2d038fab$export$cddd08008c542aa3)()))
            ],
            [
                "Seed",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "Items",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $cdb0798a49937e52$export$800598ed9ffd5a17)())
            ],
            [
                "Products",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $cdb0798a49937e52$export$e199f01bc592175b)()))
            ],
            [
                "ProcessorUnlockLevel",
                (0, $0ef027050085b17b$export$ae6ba34b501c482e)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ]
        ]);
}
function $a117bb35793377d5$var$GameDataModule_implicitProduct(data, item, processor) {
    const itemId = item.Id;
    const matchValue = item.Category;
    let matchResult;
    switch(matchValue.tag){
        case 2:
            switch(processor){
                case "Preserves Jar":
                    matchResult = 0;
                    break;
                case "Keg":
                    matchResult = 1;
                    break;
                case "Seed Maker":
                    matchResult = 4;
                    break;
                default:
                    matchResult = 5;
            }
            break;
        case 1:
            switch(processor){
                case "Preserves Jar":
                    matchResult = 2;
                    break;
                case "Keg":
                    matchResult = 3;
                    break;
                case "Seed Maker":
                    matchResult = 4;
                    break;
                default:
                    matchResult = 5;
            }
            break;
        default:
            if (processor === "Seed Maker") matchResult = 4;
            else matchResult = 5;
    }
    switch(matchResult){
        case 0:
            return new (0, $cdb0798a49937e52$export$264ad599d7cef668)(0, [
                itemId
            ]);
        case 1:
            return new (0, $cdb0798a49937e52$export$264ad599d7cef668)(2, [
                itemId
            ]);
        case 2:
            return new (0, $cdb0798a49937e52$export$264ad599d7cef668)(1, [
                itemId
            ]);
        case 3:
            return new (0, $cdb0798a49937e52$export$264ad599d7cef668)(3, [
                itemId
            ]);
        case 4:
            return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arg)=>new (0, $cdb0798a49937e52$export$264ad599d7cef668)(4, [
                    arg * 1
                ]), (0, $0ef027050085b17b$export$cc62f3272162c107)(itemId, data.Seed));
        default:
            return undefined;
    }
}
function $a117bb35793377d5$export$323f73e82c9af216(data, processor, item) {
    const matchValue = (0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((table_1)=>(0, $0ef027050085b17b$export$cc62f3272162c107)(processor, table_1), (0, $0ef027050085b17b$export$cc62f3272162c107)(item, data.Products));
    if (matchValue == null) return $a117bb35793377d5$var$GameDataModule_implicitProduct(data, (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item), processor);
    else return new (0, $cdb0798a49937e52$export$264ad599d7cef668)(5, [
        matchValue
    ]);
}
function $a117bb35793377d5$export$a8beba8a53794dfa(data, item) {
    const products = (0, $0ef027050085b17b$export$cc62f3272162c107)(item, data.Products);
    const item_1 = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item);
    return (0, $42cbcefff7323768$export$93e2b83da34ff82a)((implicit_1, products_1)=>(0, $e5d9070e144b905e$export$10d8903dec122b9d)(implicit_1, Array.from((0, $42cbcefff7323768$export$871de8747c9eaa88)((Item)=>new (0, $cdb0798a49937e52$export$264ad599d7cef668)(5, [
                Item
            ]), products_1.fields[0].values()))), (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((processor)=>{
        if ((0, $42cbcefff7323768$export$f7e9f41ea797a17)((arg10$0040_1)=>arg10$0040_1.fields[0].has(processor), (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(products))) return undefined;
        else return $a117bb35793377d5$var$GameDataModule_implicitProduct(data, item_1, processor);
    }, [
        "Preserves Jar",
        "Keg",
        "Seed Maker"
    ]), (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(products));
}
function $a117bb35793377d5$export$e74237245234b309(extracted, supplemental) {
    let seq_14, seq_16, seq_18;
    let items;
    const seq = (0, $42cbcefff7323768$export$871de8747c9eaa88)((v)=>[
            v.Id,
            v
        ], extracted.Items);
    items = new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq));
    let crops;
    const array_3 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((Item_1)=>new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
            Item_1
        ]), extracted.FarmCrops);
    crops = (0, $e5d9070e144b905e$export$10d8903dec122b9d)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((Item_2)=>new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(1, [
            Item_2
        ]), extracted.ForageCrops), array_3);
    let generatedPrices;
    const seq_2 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg_1)=>[
            tupledArg_1[0],
            (0, $42cbcefff7323768$export$871de8747c9eaa88)((tuple_1)=>tuple_1[1], tupledArg_1[1])
        ], (0, $2f87a1ba4ae7cb49$export$3f063810d7bf01bd)((tuple)=>tuple[0], (0, $42cbcefff7323768$export$bb44f104e3c54dae)((tupledArg)=>(0, $e5d9070e144b905e$export$871de8747c9eaa88)((seed)=>[
                seed,
                new (0, $e189d4fb2d038fab$export$5b280effc20e3931)(1, [
                    tupledArg[0],
                    undefined
                ])
            ], tupledArg[1]), supplemental.GenerateSeedPrices.fields[0]), {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    }));
    generatedPrices = new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_2));
    let seedPrices;
    const seq_6 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((k)=>{
        let seed_2, seq_4, source_7;
        return [
            k,
            (seed_2 = k, seq_4 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((v_1)=>[
                    (0, $e189d4fb2d038fab$export$e847fdb9cedfbd36)(v_1),
                    v_1
                ], (source_7 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $0ef027050085b17b$export$cc62f3272162c107)(seed_2, supplemental.SeedPrices), new Array(0)), (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $0ef027050085b17b$export$cc62f3272162c107)(seed_2, generatedPrices), (0, $42cbcefff7323768$export$6e22c362a0406a2c)()), source_7))), new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_4)))
        ];
    }, (0, $42cbcefff7323768$export$871de8747c9eaa88)((0, $e189d4fb2d038fab$export$f448f4dc09946ac4), crops));
    seedPrices = new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_6));
    let seeds_1;
    const seq_8 = (0, $42cbcefff7323768$export$7877a478dd30fd3d)((crop)=>{
        if ((0, $e189d4fb2d038fab$export$9a6d33d4fe8fe14)((key_5)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(items.fields[0], key_5), crop)) return [
            (0, $e189d4fb2d038fab$export$e3cd08c7ffece832)(crop),
            (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop)
        ];
        else return undefined;
    }, crops);
    seeds_1 = new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_8));
    let products_1;
    const seq_12 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg_2)=>{
        let seq_10;
        return [
            tupledArg_2[0],
            (seq_10 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((v_2)=>[
                    v_2.Processor,
                    v_2
                ], tupledArg_2[1]), new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_10)))
        ];
    }, extracted.Products.fields[0]);
    products_1 = new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_12));
    return new $a117bb35793377d5$export$4e4902e9343e97d0((seq_14 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((v_3)=>[
            v_3.Name,
            v_3
        ], supplemental.Fertilizers), new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_14))), (seq_16 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((k_1)=>[
            k_1,
            (0, $22d1a4cfc5fba7ce$export$c90763f2293d7e67)((0, $0ef027050085b17b$export$cc62f3272162c107)(k_1, supplemental.FertilizerPrices), ()=>new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)(new Map([])))
        ], (0, $42cbcefff7323768$export$871de8747c9eaa88)((_arg_8)=>_arg_8.Name, supplemental.Fertilizers)), new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_16))), (seq_18 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((v_4)=>[
            (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(v_4),
            v_4
        ], crops), new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new Map([]), seq_18))), seedPrices, seeds_1, items, products_1, supplemental.ProcessorUnlockLevel);
}
class $a117bb35793377d5$export$18a2be9195644f38 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Farm",
            "Greenhouse",
            "Ginger Island"
        ];
    }
}
function $a117bb35793377d5$export$4479c41f4f18ce99() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.Location", [], $a117bb35793377d5$export$18a2be9195644f38, ()=>[
            [],
            [],
            []
        ]);
}
function $a117bb35793377d5$export$b95380ae288bc3cf(_arg) {
    switch(_arg.tag){
        case 1:
        case 2:
            return false;
        default:
            return true;
    }
}
function $a117bb35793377d5$export$13b51a0b17e296cd(_arg) {
    switch(_arg.tag){
        case 0:
        case 1:
            return 0;
        default:
            return 0.1;
    }
}
class $a117bb35793377d5$export$90bbc03bb9e08c8e extends (0, $eATN7.Record) {
    constructor(StartDate, EndDate, Location, Skills, Multipliers, CropAmount, JojaMembership, Irrigated, QualityArtisanProducts){
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Location = Location;
        this.Skills = Skills;
        this.Multipliers = Multipliers;
        this.CropAmount = CropAmount;
        this.JojaMembership = JojaMembership;
        this.Irrigated = Irrigated;
        this.QualityArtisanProducts = QualityArtisanProducts;
    }
}
function $a117bb35793377d5$export$cbc7380c0206788a() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.GameVariables", [], $a117bb35793377d5$export$90bbc03bb9e08c8e, ()=>[
            [
                "StartDate",
                (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
            ],
            [
                "EndDate",
                (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
            ],
            [
                "Location",
                $a117bb35793377d5$export$4479c41f4f18ce99()
            ],
            [
                "Skills",
                (0, $7bbf2c7402328604$export$d4572be1898ebd50)()
            ],
            [
                "Multipliers",
                (0, $cdb0798a49937e52$export$64bfc21753b12c95)()
            ],
            [
                "CropAmount",
                (0, $e189d4fb2d038fab$export$3c1fb9f69cd3649)()
            ],
            [
                "JojaMembership",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "Irrigated",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "QualityArtisanProducts",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
const $a117bb35793377d5$export$2b4be54c783a4750 = new $a117bb35793377d5$export$90bbc03bb9e08c8e(new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(0, 1), new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(3, 28), new $a117bb35793377d5$export$18a2be9195644f38(0, []), (0, $7bbf2c7402328604$export$e4da585a3ddc880e), (0, $cdb0798a49937e52$export$c1df43900d74485), (0, $e189d4fb2d038fab$export$d4f06157fdf80d3d), false, false, false);
function $a117bb35793377d5$export$471d880c1f433e29(vars) {
    return (0, $e189d4fb2d038fab$export$d1ef7efb0a77e09d)(vars.StartDate.Season, vars.EndDate.Season);
}
function $a117bb35793377d5$export$a3141f96ca725916(vars, crop) {
    if (!(0, $kRS0m.equals)(vars.Location, new $a117bb35793377d5$export$18a2be9195644f38(0, []))) return true;
    else return (0, $e189d4fb2d038fab$export$4c2775d8781aa270)($a117bb35793377d5$export$471d880c1f433e29(vars), crop);
}
function $a117bb35793377d5$export$ccac27a3f7dbc48b(vars, crops) {
    let seasons;
    if ((0, $kRS0m.equals)(vars.Location, new $a117bb35793377d5$export$18a2be9195644f38(0, []))) return (0, $42cbcefff7323768$export$3dea766d36a8935f)((seasons = $a117bb35793377d5$export$471d880c1f433e29(vars) | 0, (_arg)=>(0, $e189d4fb2d038fab$export$4c2775d8781aa270)(seasons, _arg)), crops);
    else return crops;
}
function $a117bb35793377d5$export$7e053ecac9f0db98(vars, crop) {
    return ((0, $7bbf2c7402328604$export$ab4ce16a5fab460c)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(2, []), vars.Skills) ? 0.1 : 0) + (vars.Irrigated && (0, $e189d4fb2d038fab$export$bc42fb51d91a98ea)(crop) ? 0.25 : 0);
}
function $a117bb35793377d5$export$e12d31b6f28a873f(vars, fertilizer, crop) {
    return (0, $7bbf2c7402328604$export$12ba9d8c8c76f13f)(fertilizer) + $a117bb35793377d5$export$7e053ecac9f0db98(vars, crop);
}
function $a117bb35793377d5$export$9686fb6378660d64(vars, fertilizer, crop) {
    return (0, $e189d4fb2d038fab$export$cca15d7258ab2709)($a117bb35793377d5$export$e12d31b6f28a873f(vars, fertilizer, crop), crop);
}
function $a117bb35793377d5$export$3302572d20aa94ca(vars, fertilizer, crop) {
    return $a117bb35793377d5$export$9686fb6378660d64(vars, fertilizer, crop)[1];
}
function $a117bb35793377d5$export$e890505f776f0f35(vars) {
    if ($a117bb35793377d5$export$b95380ae288bc3cf(vars.Location)) return 1 - (0, $e189d4fb2d038fab$export$74ed7df6b1c9d864)(vars.CropAmount);
    else return 0;
}
function $a117bb35793377d5$export$7d50549ec2ff6dd4(vars, crop) {
    if (crop.Giant && $a117bb35793377d5$export$b95380ae288bc3cf(vars.Location)) return 0.1 * (1 - (0, $e189d4fb2d038fab$export$74ed7df6b1c9d864)(vars.CropAmount));
    else return 0;
}
function $a117bb35793377d5$export$af075c3b0643dbbc(vars, _arg) {
    if (_arg.tag === 1) return $a117bb35793377d5$export$13b51a0b17e296cd(vars.Location);
    else return $a117bb35793377d5$export$7d50549ec2ff6dd4(vars, _arg.fields[0]);
}
function $a117bb35793377d5$export$ef4eb9bf41e48f4a(vars, crop) {
    if (vars.Skills.IgnoreSkillLevelRequirements) return true;
    else return (0, $e189d4fb2d038fab$export$d8c874891ace1c01)(vars.Skills, crop);
}
function $a117bb35793377d5$export$7424f280c9568769(vars, crop) {
    if (crop.Giant && $a117bb35793377d5$export$b95380ae288bc3cf(vars.Location)) return (0, $e189d4fb2d038fab$export$357b9c25784b5f74)(vars.Skills, vars.CropAmount, crop.Amount);
    else return (0, $e189d4fb2d038fab$export$40c9c0334082ca24)(vars.Skills, vars.CropAmount, crop.Amount);
}
function $a117bb35793377d5$export$ab2b954ea6fd06ca(vars, fertilizer, crop) {
    const qualities = (0, $7bbf2c7402328604$export$17f2a017346d4cdb)(fertilizer, vars.Skills);
    if (crop.Giant && $a117bb35793377d5$export$b95380ae288bc3cf(vars.Location)) return (0, $e189d4fb2d038fab$export$63bad12f713b5ee5)(vars.Skills, vars.CropAmount, crop.Amount, qualities);
    else return (0, $e189d4fb2d038fab$export$3ffac6b237f05023)(vars.Skills, vars.CropAmount, crop.Amount, qualities);
}
function $a117bb35793377d5$export$3f1fefec7d4e8a64(vars, crop) {
    return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((a)=>a / crop.Foragables.length, (0, $7bbf2c7402328604$export$57e654937063e3bc)(vars.Skills).fields[0], Float64Array));
}
function $a117bb35793377d5$export$eba3ec6aec8588b3(vars, fertilizer, crop) {
    const quantity = $a117bb35793377d5$export$ab2b954ea6fd06ca(vars, fertilizer, crop);
    const matchValue = crop.ExtraItem;
    if (matchValue == null) return [
        quantity
    ];
    else return [
        quantity,
        new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$b6d8713d53419d4c)(0, matchValue[1] + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $7bbf2c7402328604$export$127ff803a92644c).fields[0]), (0, $7bbf2c7402328604$export$127ff803a92644c).fields[0], Float64Array))
    ];
}
function $a117bb35793377d5$export$fa8566c54ebcfb81(vars, crop) {
    return (0, $e189d4fb2d038fab$export$ad7c058c40b5f8ce)(vars.Skills) / crop.Foragables.length;
}
function $a117bb35793377d5$export$a3c803c6c0388454(vars, _arg) {
    if (_arg.tag === 1) return $a117bb35793377d5$export$fa8566c54ebcfb81(vars, _arg.fields[0]);
    else return $a117bb35793377d5$export$7424f280c9568769(vars, _arg.fields[0]);
}
function $a117bb35793377d5$export$705a5d7b10a5d098(vars, fertilizer, _arg) {
    if (_arg.tag === 1) return $a117bb35793377d5$export$3f1fefec7d4e8a64(vars, _arg.fields[0]);
    else return $a117bb35793377d5$export$ab2b954ea6fd06ca(vars, fertilizer, _arg.fields[0]);
}
function $a117bb35793377d5$export$e92e56ca8bfa8dc7(vars, fertilizer, _arg) {
    if (_arg.tag === 1) {
        const crop_1 = _arg.fields[0];
        const value = $a117bb35793377d5$export$3f1fefec7d4e8a64(vars, crop_1);
        const count = crop_1.Foragables.length | 0;
        return (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(count), 0, count, value);
    } else return $a117bb35793377d5$export$eba3ec6aec8588b3(vars, fertilizer, _arg.fields[0]);
}
function $a117bb35793377d5$export$8b1f176e807e6ab4(data, vars, processor) {
    if (vars.Skills.IgnoreSkillLevelRequirements) return true;
    else return (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((l)=>l <= vars.Skills.Farming.Level, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $0ef027050085b17b$export$cc62f3272162c107)(processor, data.ProcessorUnlockLevel)));
}
function $a117bb35793377d5$export$7eeef82a43679c9e(data, vars) {
    return (arg)=>$a117bb35793377d5$export$8b1f176e807e6ab4(data, vars, (0, $cdb0798a49937e52$export$3b5fd34b2463eb68)(arg));
}
function $a117bb35793377d5$export$818344e214fe839e(data, vars, seed, _arg) {
    let value_5;
    if (_arg.tag === 1) {
        const price_2 = (0, $22d1a4cfc5fba7ce$export$c90763f2293d7e67)(_arg.fields[1], ()=>2 * (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], seed * 1).SellPrice);
        if (_arg.fields[0] === "Joja") {
            const value_2 = vars.Multipliers.ProfitMargin * (vars.JojaMembership ? 1 : 1.25) * price_2;
            return value_2 >>> 0;
        } else return (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1, (value_5 = vars.Multipliers.ProfitMargin * price_2, value_5 >>> 0));
    } else return _arg.fields[1];
}
function $a117bb35793377d5$export$9f54cc0163ec0391(vars, forage, item, quality) {
    return (0, $cdb0798a49937e52$export$e7352280cc38789a)(vars.Skills, vars.Multipliers, forage, item, quality);
}
function $a117bb35793377d5$export$dcb147af0f4b8d20(vars, forage, item) {
    return (0, $cdb0798a49937e52$export$74a6bc33980f5545)(vars.Skills, vars.Multipliers, forage, item);
}
function $a117bb35793377d5$export$dd97a9a222eebe8(data, vars, quality, product) {
    return (0, $cdb0798a49937e52$export$44ccbacbee724776)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}
function $a117bb35793377d5$export$b2525098505c1744(data, vars, quality, product) {
    return (0, $cdb0798a49937e52$export$bd123e9830004dc8)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}
function $a117bb35793377d5$export$9cf000d4259784ff(data, vars, product) {
    return (0, $cdb0798a49937e52$export$c645c9b0434d387)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, product);
}
function $a117bb35793377d5$export$d2085a6d61ca5031(data, vars, quality, product) {
    return (0, $cdb0798a49937e52$export$a5f43b83fd6b1aef)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}
function $a117bb35793377d5$export$1de53ee5c74c2816(data, vars, product) {
    return (0, $cdb0798a49937e52$export$2e9a7757f7096130)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, product);
}
function $a117bb35793377d5$export$d976e3e1cc3d85a6(data, vars, quality, product) {
    return (0, $cdb0798a49937e52$export$403a708bcc36bf56)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), vars.QualityArtisanProducts, quality, product);
}
function $a117bb35793377d5$export$6de4f019aaca4b93(data, vars, seed) {
    return $a117bb35793377d5$export$9f54cc0163ec0391(vars, false, (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], seed * 1), 0);
}
function $a117bb35793377d5$export$666269e000cfb462(data, crop) {
    return (0, $e189d4fb2d038fab$export$29c1f1b1e148f91a)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), crop);
}
function $a117bb35793377d5$export$ac54dd2c8c89eb30(vars, crop) {
    return (0, $e189d4fb2d038fab$export$def8c5c8d048f5dd)($a117bb35793377d5$export$e890505f776f0f35(vars), vars.Skills, crop);
}
function $a117bb35793377d5$export$9a7a916d4806bc7f(data, vars, crop) {
    return (0, $e189d4fb2d038fab$export$f34c1d38a2aa4e8f)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), $a117bb35793377d5$export$e890505f776f0f35(vars), vars.Skills, crop);
}



var $kRS0m = parcelRequire("kRS0m");




var $eATN7 = parcelRequire("eATN7");




var $kRS0m = parcelRequire("kRS0m");



var $eATN7 = parcelRequire("eATN7");


class $cee18de5b874f6d4$export$a154ba9e46da4796 {
    constructor(k, v){
        this.k = k;
        this.v = v;
    }
}
function $cee18de5b874f6d4$export$2fac35adbde225e0(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Map.MapTreeLeaf`2", [
        gen0,
        gen1
    ], $cee18de5b874f6d4$export$a154ba9e46da4796);
}
function $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, v) {
    return new $cee18de5b874f6d4$export$a154ba9e46da4796(k, v);
}
function $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(_) {
    return _.k;
}
function $cee18de5b874f6d4$export$4278c1b57041ecb9(_) {
    return _.v;
}
class $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 extends $cee18de5b874f6d4$export$a154ba9e46da4796 {
    constructor(k, v, left, right, h){
        super(k, v);
        this.left = left;
        this.right = right;
        this.h = h | 0;
    }
}
function $cee18de5b874f6d4$export$318c9911f574315e(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Map.MapTreeNode`2", [
        gen0,
        gen1
    ], $cee18de5b874f6d4$export$6ac58b91e0d1f4d8, $cee18de5b874f6d4$export$2fac35adbde225e0(gen0, gen1));
}
function $cee18de5b874f6d4$export$a78cd7fe5354600b(k, v, left, right, h) {
    return new $cee18de5b874f6d4$export$6ac58b91e0d1f4d8(k, v, left, right, h);
}
function $cee18de5b874f6d4$export$b1651dc4a24955a7(_) {
    return _.left;
}
function $cee18de5b874f6d4$export$3c20aa294876b222(_) {
    return _.right;
}
function $cee18de5b874f6d4$export$72fcc38e1f2d1b04(_) {
    return _.h;
}
function $cee18de5b874f6d4$export$e26ed7329f8c306e() {
    return undefined;
}
function $cee18de5b874f6d4$export$26ef43b944e7b14f(acc_mut, m_mut) {
    MapTreeModule_sizeAux: while(true){
        const acc = acc_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                acc_mut = $cee18de5b874f6d4$export$26ef43b944e7b14f(acc + 1, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
                m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                continue MapTreeModule_sizeAux;
            } else return acc + 1 | 0;
        } else return acc | 0;
        break;
    }
}
function $cee18de5b874f6d4$export$989a5112f39c2166(x) {
    return $cee18de5b874f6d4$export$26ef43b944e7b14f(0, x);
}
function $cee18de5b874f6d4$export$c9e6e1e1671ffbb2(l, k, v, r) {
    let mn, mn_1;
    let hl;
    const m = l;
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        hl = m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn = m2, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn)) : 1;
    } else hl = 0;
    let hr;
    const m_1 = r;
    if (m_1 != null) {
        const m2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_1);
        hr = m2_1 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn_1 = m2_1, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn_1)) : 1;
    } else hr = 0;
    const m_2 = (hl < hr ? hr : hl) | 0;
    if (m_2 === 0) return $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, v);
    else return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, v, l, r, m_2 + 1);
}
function $cee18de5b874f6d4$export$2dac9c836dfa6c0e(t1, k, v, t2) {
    let mn, mn_1, m_2, m2_2, mn_2, m_3, m2_3, mn_3;
    let t1h;
    const m = t1;
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        t1h = m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn = m2, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn)) : 1;
    } else t1h = 0;
    let t2h;
    const m_1 = t2;
    if (m_1 != null) {
        const m2_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_1);
        t2h = m2_1 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn_1 = m2_1, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn_1)) : 1;
    } else t2h = 0;
    if (t2h > t1h + 2) {
        const matchValue = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t2);
        if (matchValue instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const t2$0027 = matchValue;
            if ((m_2 = $cee18de5b874f6d4$export$b1651dc4a24955a7(t2$0027), m_2 != null ? (m2_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_2), m2_2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn_2 = m2_2, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn_2)) : 1) : 0) > t1h + 1) {
                const matchValue_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($cee18de5b874f6d4$export$b1651dc4a24955a7(t2$0027));
                if (matchValue_1 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                    const t2l = matchValue_1;
                    return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$c9e6e1e1671ffbb2(t1, k, v, $cee18de5b874f6d4$export$b1651dc4a24955a7(t2l)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t2l), $cee18de5b874f6d4$export$4278c1b57041ecb9(t2l), $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$3c20aa294876b222(t2l), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t2$0027), $cee18de5b874f6d4$export$4278c1b57041ecb9(t2$0027), $cee18de5b874f6d4$export$3c20aa294876b222(t2$0027)));
                } else throw new Error("internal error: Map.rebalance");
            } else return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$c9e6e1e1671ffbb2(t1, k, v, $cee18de5b874f6d4$export$b1651dc4a24955a7(t2$0027)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t2$0027), $cee18de5b874f6d4$export$4278c1b57041ecb9(t2$0027), $cee18de5b874f6d4$export$3c20aa294876b222(t2$0027));
        } else throw new Error("internal error: Map.rebalance");
    } else if (t1h > t2h + 2) {
        const matchValue_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(t1);
        if (matchValue_2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const t1$0027 = matchValue_2;
            if ((m_3 = $cee18de5b874f6d4$export$3c20aa294876b222(t1$0027), m_3 != null ? (m2_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_3), m2_3 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8 ? (mn_3 = m2_3, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn_3)) : 1) : 0) > t2h + 1) {
                const matchValue_3 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($cee18de5b874f6d4$export$3c20aa294876b222(t1$0027));
                if (matchValue_3 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                    const t1r = matchValue_3;
                    return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$b1651dc4a24955a7(t1$0027), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t1$0027), $cee18de5b874f6d4$export$4278c1b57041ecb9(t1$0027), $cee18de5b874f6d4$export$b1651dc4a24955a7(t1r)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t1r), $cee18de5b874f6d4$export$4278c1b57041ecb9(t1r), $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$3c20aa294876b222(t1r), k, v, t2));
                } else throw new Error("internal error: Map.rebalance");
            } else return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$b1651dc4a24955a7(t1$0027), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(t1$0027), $cee18de5b874f6d4$export$4278c1b57041ecb9(t1$0027), $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$3c20aa294876b222(t1$0027), k, v, t2));
        } else throw new Error("internal error: Map.rebalance");
    } else return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2(t1, k, v, t2);
}
function $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        const c = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) | 0;
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            if (c < 0) return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn));
            else if (c === 0) return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, v, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn), $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn));
            else return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$b1651dc4a24955a7(mn), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, $cee18de5b874f6d4$export$3c20aa294876b222(mn)));
        } else if (c < 0) return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, v, $cee18de5b874f6d4$export$e26ed7329f8c306e(), m, 2);
        else if (c === 0) return $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, v);
        else return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, v, m, $cee18de5b874f6d4$export$e26ed7329f8c306e(), 2);
    } else return $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, v);
}
function $cee18de5b874f6d4$export$1b96b989c0318e6d(comparer_mut, k_mut, m_mut) {
    MapTreeModule_tryFind: while(true){
        const comparer = comparer_mut, k = k_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            const c = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) | 0;
            if (c === 0) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
            else if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                comparer_mut = comparer;
                k_mut = k;
                m_mut = c < 0 ? $cee18de5b874f6d4$export$b1651dc4a24955a7(mn) : $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                continue MapTreeModule_tryFind;
            } else return undefined;
        } else return undefined;
        break;
    }
}
function $cee18de5b874f6d4$export$b1ffabbca4263ead(comparer, k, m) {
    const matchValue = $cee18de5b874f6d4$export$1b96b989c0318e6d(comparer, k, m);
    if (matchValue == null) throw new Error();
    else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
}
function $cee18de5b874f6d4$export$c60c7cff4894fd6d(comparer, f, k, v, acc1, acc2) {
    if (f(k, v)) return [
        $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, acc1),
        acc2
    ];
    else return [
        acc1,
        $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, acc2)
    ];
}
function $cee18de5b874f6d4$export$427a546267ce30f4(comparer_mut, f_mut, m_mut, acc__mut, acc__1_mut) {
    MapTreeModule_partitionAux: while(true){
        const comparer = comparer_mut, f = f_mut, m = m_mut, acc_ = acc__mut, acc__1 = acc__1_mut;
        const acc = [
            acc_,
            acc__1
        ];
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                const acc_1 = $cee18de5b874f6d4$export$427a546267ce30f4(comparer, f, $cee18de5b874f6d4$export$3c20aa294876b222(mn), acc[0], acc[1]);
                const acc_4 = $cee18de5b874f6d4$export$c60c7cff4894fd6d(comparer, f, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), acc_1[0], acc_1[1]);
                comparer_mut = comparer;
                f_mut = f;
                m_mut = $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                acc__mut = acc_4[0];
                acc__1_mut = acc_4[1];
                continue MapTreeModule_partitionAux;
            } else return $cee18de5b874f6d4$export$c60c7cff4894fd6d(comparer, f, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2), acc[0], acc[1]);
        } else return acc;
        break;
    }
}
function $cee18de5b874f6d4$export$d438af01702bf868(comparer, f, m) {
    return $cee18de5b874f6d4$export$427a546267ce30f4(comparer, f, m, $cee18de5b874f6d4$export$e26ed7329f8c306e(), $cee18de5b874f6d4$export$e26ed7329f8c306e());
}
function $cee18de5b874f6d4$export$cdea37c7daf15917(comparer, f, k, v, acc) {
    if (f(k, v)) return $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, k, v, acc);
    else return acc;
}
function $cee18de5b874f6d4$export$a01eb67955a745c0(comparer_mut, f_mut, m_mut, acc_mut) {
    MapTreeModule_filterAux: while(true){
        const comparer = comparer_mut, f = f_mut, m = m_mut, acc = acc_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                const acc_1 = $cee18de5b874f6d4$export$a01eb67955a745c0(comparer, f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn), acc);
                const acc_2 = $cee18de5b874f6d4$export$cdea37c7daf15917(comparer, f, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), acc_1);
                comparer_mut = comparer;
                f_mut = f;
                m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                acc_mut = acc_2;
                continue MapTreeModule_filterAux;
            } else return $cee18de5b874f6d4$export$cdea37c7daf15917(comparer, f, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2), acc);
        } else return acc;
        break;
    }
}
function $cee18de5b874f6d4$export$1927069bf18c386d(comparer, f, m) {
    return $cee18de5b874f6d4$export$a01eb67955a745c0(comparer, f, m, $cee18de5b874f6d4$export$e26ed7329f8c306e());
}
function $cee18de5b874f6d4$export$d934c1f351076358(m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            if ($cee18de5b874f6d4$export$b1651dc4a24955a7(mn) == null) return [
                $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn),
                $cee18de5b874f6d4$export$4278c1b57041ecb9(mn),
                $cee18de5b874f6d4$export$3c20aa294876b222(mn)
            ];
            else {
                const patternInput = $cee18de5b874f6d4$export$d934c1f351076358($cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
                return [
                    patternInput[0],
                    patternInput[1],
                    $cee18de5b874f6d4$export$c9e6e1e1671ffbb2(patternInput[2], $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn))
                ];
            }
        } else return [
            $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2),
            $cee18de5b874f6d4$export$4278c1b57041ecb9(m2),
            $cee18de5b874f6d4$export$e26ed7329f8c306e()
        ];
    } else throw new Error("internal error: Map.spliceOutSuccessor");
}
function $cee18de5b874f6d4$export$c14e06c0c09a7824(comparer, k, m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        const c = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) | 0;
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            if (c < 0) return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$c14e06c0c09a7824(comparer, k, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn));
            else if (c === 0) {
                if ($cee18de5b874f6d4$export$b1651dc4a24955a7(mn) == null) return $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                else if ($cee18de5b874f6d4$export$3c20aa294876b222(mn) == null) return $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                else {
                    const patternInput = $cee18de5b874f6d4$export$d934c1f351076358($cee18de5b874f6d4$export$3c20aa294876b222(mn));
                    return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$b1651dc4a24955a7(mn), patternInput[0], patternInput[1], patternInput[2]);
                }
            } else return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$b1651dc4a24955a7(mn), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$c14e06c0c09a7824(comparer, k, $cee18de5b874f6d4$export$3c20aa294876b222(mn)));
        } else if (c === 0) return $cee18de5b874f6d4$export$e26ed7329f8c306e();
        else return m;
    } else return $cee18de5b874f6d4$export$e26ed7329f8c306e();
}
function $cee18de5b874f6d4$export$38c76335f5787e10(comparer, k, u, m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            const c = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn)) | 0;
            if (c < 0) return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$38c76335f5787e10(comparer, k, u, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn));
            else if (c === 0) {
                const matchValue_1 = u((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($cee18de5b874f6d4$export$4278c1b57041ecb9(mn)));
                if (matchValue_1 != null) return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_1), $cee18de5b874f6d4$export$b1651dc4a24955a7(mn), $cee18de5b874f6d4$export$3c20aa294876b222(mn), $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn));
                else if ($cee18de5b874f6d4$export$b1651dc4a24955a7(mn) == null) return $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                else if ($cee18de5b874f6d4$export$3c20aa294876b222(mn) == null) return $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                else {
                    const patternInput = $cee18de5b874f6d4$export$d934c1f351076358($cee18de5b874f6d4$export$3c20aa294876b222(mn));
                    return $cee18de5b874f6d4$export$c9e6e1e1671ffbb2($cee18de5b874f6d4$export$b1651dc4a24955a7(mn), patternInput[0], patternInput[1], patternInput[2]);
                }
            } else return $cee18de5b874f6d4$export$2dac9c836dfa6c0e($cee18de5b874f6d4$export$b1651dc4a24955a7(mn), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), $cee18de5b874f6d4$export$38c76335f5787e10(comparer, k, u, $cee18de5b874f6d4$export$3c20aa294876b222(mn)));
        } else {
            const c_1 = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) | 0;
            if (c_1 < 0) {
                const matchValue_2 = u(undefined);
                if (matchValue_2 != null) return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_2), $cee18de5b874f6d4$export$e26ed7329f8c306e(), m, 2);
                else return m;
            } else if (c_1 === 0) {
                const matchValue_3 = u((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($cee18de5b874f6d4$export$4278c1b57041ecb9(m2)));
                if (matchValue_3 != null) return $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_3));
                else return $cee18de5b874f6d4$export$e26ed7329f8c306e();
            } else {
                const matchValue_4 = u(undefined);
                if (matchValue_4 != null) return $cee18de5b874f6d4$export$a78cd7fe5354600b(k, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_4), m, $cee18de5b874f6d4$export$e26ed7329f8c306e(), 2);
                else return m;
            }
        }
    } else {
        const matchValue = u(undefined);
        if (matchValue != null) return $cee18de5b874f6d4$export$731a9ad425fc2c8a(k, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue));
        else return m;
    }
}
function $cee18de5b874f6d4$export$df2d9c9fdef1637d(comparer_mut, k_mut, m_mut) {
    MapTreeModule_mem: while(true){
        const comparer = comparer_mut, k = k_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            const c = comparer.Compare(k, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) | 0;
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                if (c < 0) {
                    comparer_mut = comparer;
                    k_mut = k;
                    m_mut = $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                    continue MapTreeModule_mem;
                } else if (c === 0) return true;
                else {
                    comparer_mut = comparer;
                    k_mut = k;
                    m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                    continue MapTreeModule_mem;
                }
            } else return c === 0;
        } else return false;
        break;
    }
}
function $cee18de5b874f6d4$export$e318e24ea4036e6(f_mut, m_mut) {
    MapTreeModule_iterOpt: while(true){
        const f = f_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                $cee18de5b874f6d4$export$e318e24ea4036e6(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
                f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn));
                f_mut = f;
                m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                continue MapTreeModule_iterOpt;
            } else f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
        }
        break;
    }
}
function $cee18de5b874f6d4$export$a3180471a8949740(f, m) {
    $cee18de5b874f6d4$export$e318e24ea4036e6(f, m);
}
function $cee18de5b874f6d4$export$ad3287cfb707b118(f_mut, m_mut) {
    MapTreeModule_tryPickOpt: while(true){
        const f = f_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                const matchValue = $cee18de5b874f6d4$export$ad3287cfb707b118(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
                if (matchValue == null) {
                    const matchValue_1 = f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn));
                    if (matchValue_1 == null) {
                        f_mut = f;
                        m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                        continue MapTreeModule_tryPickOpt;
                    } else return matchValue_1;
                } else return matchValue;
            } else return f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
        } else return undefined;
        break;
    }
}
function $cee18de5b874f6d4$export$9795c5ada06a6129(f, m) {
    return $cee18de5b874f6d4$export$ad3287cfb707b118(f, m);
}
function $cee18de5b874f6d4$export$67d837b51c87d3f7(f_mut, m_mut) {
    MapTreeModule_existsOpt: while(true){
        const f = f_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                if ($cee18de5b874f6d4$export$67d837b51c87d3f7(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)) ? true : f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn))) return true;
                else {
                    f_mut = f;
                    m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                    continue MapTreeModule_existsOpt;
                }
            } else return f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
        } else return false;
        break;
    }
}
function $cee18de5b874f6d4$export$6c9add8c00707ead(f, m) {
    return $cee18de5b874f6d4$export$67d837b51c87d3f7(f, m);
}
function $cee18de5b874f6d4$export$768aaee7aceaca43(f_mut, m_mut) {
    MapTreeModule_forallOpt: while(true){
        const f = f_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                if ($cee18de5b874f6d4$export$768aaee7aceaca43(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)) && f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn))) {
                    f_mut = f;
                    m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                    continue MapTreeModule_forallOpt;
                } else return false;
            } else return f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
        } else return true;
        break;
    }
}
function $cee18de5b874f6d4$export$93022a3ea64248ad(f, m) {
    return $cee18de5b874f6d4$export$768aaee7aceaca43(f, m);
}
function $cee18de5b874f6d4$export$3a298860c76721b1(f, m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            const l2 = $cee18de5b874f6d4$export$3a298860c76721b1(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
            const v2 = f($cee18de5b874f6d4$export$4278c1b57041ecb9(mn));
            const r2 = $cee18de5b874f6d4$export$3a298860c76721b1(f, $cee18de5b874f6d4$export$3c20aa294876b222(mn));
            return $cee18de5b874f6d4$export$a78cd7fe5354600b($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), v2, l2, r2, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn));
        } else return $cee18de5b874f6d4$export$731a9ad425fc2c8a($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), f($cee18de5b874f6d4$export$4278c1b57041ecb9(m2)));
    } else return $cee18de5b874f6d4$export$e26ed7329f8c306e();
}
function $cee18de5b874f6d4$export$5a2dbbbec8b54731(f, m) {
    if (m != null) {
        const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
        if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
            const mn = m2;
            const l2 = $cee18de5b874f6d4$export$5a2dbbbec8b54731(f, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn));
            const v2 = f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn));
            const r2 = $cee18de5b874f6d4$export$5a2dbbbec8b54731(f, $cee18de5b874f6d4$export$3c20aa294876b222(mn));
            return $cee18de5b874f6d4$export$a78cd7fe5354600b($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), v2, l2, r2, $cee18de5b874f6d4$export$72fcc38e1f2d1b04(mn));
        } else return $cee18de5b874f6d4$export$731a9ad425fc2c8a($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2)));
    } else return $cee18de5b874f6d4$export$e26ed7329f8c306e();
}
function $cee18de5b874f6d4$export$41465ab1d34bca0e(f, m) {
    return $cee18de5b874f6d4$export$5a2dbbbec8b54731(f, m);
}
function $cee18de5b874f6d4$export$fabbdd6a981a6523(f_mut, m_mut, x_mut) {
    MapTreeModule_foldBackOpt: while(true){
        const f = f_mut, m = m_mut, x = x_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                const x_1 = $cee18de5b874f6d4$export$fabbdd6a981a6523(f, $cee18de5b874f6d4$export$3c20aa294876b222(mn), x);
                const x_2 = f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), x_1);
                f_mut = f;
                m_mut = $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                x_mut = x_2;
                continue MapTreeModule_foldBackOpt;
            } else return f($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2), x);
        } else return x;
        break;
    }
}
function $cee18de5b874f6d4$export$b32cb04d0e7b1f8c(f, m, x) {
    return $cee18de5b874f6d4$export$fabbdd6a981a6523(f, m, x);
}
function $cee18de5b874f6d4$export$9cbc1bef99c43bd0(f_mut, x_mut, m_mut) {
    MapTreeModule_foldOpt: while(true){
        const f = f_mut, x = x_mut, m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                const mn = m2;
                f_mut = f;
                x_mut = f($cee18de5b874f6d4$export$9cbc1bef99c43bd0(f, x, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn)), $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn));
                m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                continue MapTreeModule_foldOpt;
            } else return f(x, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2));
        } else return x;
        break;
    }
}
function $cee18de5b874f6d4$export$33ba2bfd3e7ff317(f, x, m) {
    return $cee18de5b874f6d4$export$9cbc1bef99c43bd0(f, x, m);
}
function $cee18de5b874f6d4$export$1c97335201f0fc02(comparer, lo, hi, f, m, x) {
    const foldFromTo = (f_1_mut, m_1_mut, x_1_mut)=>{
        foldFromTo: while(true){
            const f_1 = f_1_mut, m_1 = m_1_mut, x_1 = x_1_mut;
            if (m_1 != null) {
                const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_1);
                if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                    const mn = m2;
                    const cLoKey = comparer.Compare(lo, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn)) | 0;
                    const cKeyHi = comparer.Compare($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), hi) | 0;
                    const x_2 = cLoKey < 0 ? foldFromTo(f_1, $cee18de5b874f6d4$export$b1651dc4a24955a7(mn), x_1) : x_1;
                    const x_3 = cLoKey <= 0 && cKeyHi <= 0 ? f_1($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn), x_2) : x_2;
                    if (cKeyHi < 0) {
                        f_1_mut = f_1;
                        m_1_mut = $cee18de5b874f6d4$export$3c20aa294876b222(mn);
                        x_1_mut = x_3;
                        continue foldFromTo;
                    } else return x_3;
                } else if (comparer.Compare(lo, $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2)) <= 0 && comparer.Compare($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), hi) <= 0) return f_1($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2), $cee18de5b874f6d4$export$4278c1b57041ecb9(m2), x_1);
                else return x_1;
            } else return x_1;
            break;
        }
    };
    if (comparer.Compare(lo, hi) === 1) return x;
    else return foldFromTo(f, m, x);
}
function $cee18de5b874f6d4$export$3bfd4518c08b80b1(comparer, lo, hi, f, m, x) {
    return $cee18de5b874f6d4$export$1c97335201f0fc02(comparer, lo, hi, f, m, x);
}
function $cee18de5b874f6d4$export$d1efb301d629c2e1(m) {
    const loop = (m_1_mut, acc_mut)=>{
        loop: while(true){
            const m_1 = m_1_mut, acc = acc_mut;
            if (m_1 != null) {
                const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m_1);
                if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                    const mn = m2;
                    m_1_mut = $cee18de5b874f6d4$export$b1651dc4a24955a7(mn);
                    acc_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                        $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn),
                        $cee18de5b874f6d4$export$4278c1b57041ecb9(mn)
                    ], loop($cee18de5b874f6d4$export$3c20aa294876b222(mn), acc));
                    continue loop;
                } else return (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                    $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2),
                    $cee18de5b874f6d4$export$4278c1b57041ecb9(m2)
                ], acc);
            } else return acc;
            break;
        }
    };
    return loop(m, (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
}
function $cee18de5b874f6d4$export$ef2e1235f18e29c(m, arr, i) {
    let j = i;
    $cee18de5b874f6d4$export$a3180471a8949740((x, y)=>{
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(arr, j, [
            x,
            y
        ]);
        j = j + 1 | 0;
    }, m);
}
function $cee18de5b874f6d4$export$d46168c281ac54dc(m) {
    const n = $cee18de5b874f6d4$export$989a5112f39c2166(m) | 0;
    const res = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(n), 0, n, [
        null,
        null
    ]);
    $cee18de5b874f6d4$export$ef2e1235f18e29c(m, res, 0);
    return res;
}
function $cee18de5b874f6d4$export$50952cf4d2e25359(comparer, l) {
    return (0, $e08834e1786645d9$export$93e2b83da34ff82a)((acc, tupledArg)=>$cee18de5b874f6d4$export$b845a3a1a6860630(comparer, tupledArg[0], tupledArg[1], acc), $cee18de5b874f6d4$export$e26ed7329f8c306e(), l);
}
function $cee18de5b874f6d4$export$eab2c4a5882a12f5(comparer_mut, acc_mut, e_mut) {
    MapTreeModule_mkFromEnumerator: while(true){
        const comparer = comparer_mut, acc = acc_mut, e = e_mut;
        if (e["System.Collections.IEnumerator.MoveNext"]()) {
            const patternInput = e["System.Collections.Generic.IEnumerator`1.get_Current"]();
            comparer_mut = comparer;
            acc_mut = $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, patternInput[0], patternInput[1], acc);
            e_mut = e;
            continue MapTreeModule_mkFromEnumerator;
        } else return acc;
        break;
    }
}
function $cee18de5b874f6d4$export$b146fdb357916632(comparer, arr) {
    let res = $cee18de5b874f6d4$export$e26ed7329f8c306e();
    for(let idx = 0; idx <= arr.length - 1; idx++){
        const forLoopVar = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, arr);
        res = $cee18de5b874f6d4$export$b845a3a1a6860630(comparer, forLoopVar[0], forLoopVar[1], res);
    }
    return res;
}
function $cee18de5b874f6d4$export$e48bba52d419acd8(comparer, c) {
    if ((0, $kRS0m.isArrayLike)(c)) return $cee18de5b874f6d4$export$b146fdb357916632(comparer, c);
    else if (c instanceof (0, $e08834e1786645d9$export$46fa32c6f8b2f86)) return $cee18de5b874f6d4$export$50952cf4d2e25359(comparer, c);
    else {
        const ie = (0, $kRS0m.getEnumerator)(c);
        try {
            return $cee18de5b874f6d4$export$eab2c4a5882a12f5(comparer, $cee18de5b874f6d4$export$e26ed7329f8c306e(), ie);
        } finally{
            (0, $kRS0m.disposeSafe)(ie);
        }
    }
}
class $cee18de5b874f6d4$export$19e5afc2cec14cae extends (0, $eATN7.Record) {
    constructor(stack, started){
        super();
        this.stack = stack;
        this.started = started;
    }
}
function $cee18de5b874f6d4$export$c7d7ecd86bc3d54b(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("Map.MapTreeModule.MapIterator`2", [
        gen0,
        gen1
    ], $cee18de5b874f6d4$export$19e5afc2cec14cae, ()=>[
            [
                "stack",
                (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)($cee18de5b874f6d4$export$2fac35adbde225e0(gen0, gen1)))
            ],
            [
                "started",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
function $cee18de5b874f6d4$export$61f1bcf164ab6dee(stack_mut) {
    MapTreeModule_collapseLHS: while(true){
        const stack = stack_mut;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(stack)) {
            const rest = (0, $e08834e1786645d9$export$c01875f616615628)(stack);
            const m = (0, $e08834e1786645d9$export$5fd5031fecdacec3)(stack);
            if (m != null) {
                const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
                if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                    const mn = m2;
                    stack_mut = (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                        $cee18de5b874f6d4$export$b1651dc4a24955a7(mn),
                        $cee18de5b874f6d4$export$731a9ad425fc2c8a($cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(mn), $cee18de5b874f6d4$export$4278c1b57041ecb9(mn)),
                        $cee18de5b874f6d4$export$3c20aa294876b222(mn)
                    ], rest);
                    continue MapTreeModule_collapseLHS;
                } else return stack;
            } else {
                stack_mut = rest;
                continue MapTreeModule_collapseLHS;
            }
        } else return (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
        break;
    }
}
function $cee18de5b874f6d4$export$371ee96503d209c2(m) {
    return new $cee18de5b874f6d4$export$19e5afc2cec14cae($cee18de5b874f6d4$export$61f1bcf164ab6dee((0, $e08834e1786645d9$export$439306a4dcaafbb9)(m)), false);
}
function $cee18de5b874f6d4$export$eb70be8311af6e29() {
    throw new Error("enumeration not started");
}
function $cee18de5b874f6d4$export$f636046d9a0f908f() {
    throw new Error("enumeration already finished");
}
function $cee18de5b874f6d4$export$b464b82c20aea3ae(i) {
    if (i.started) {
        const matchValue = i.stack;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(matchValue)) {
            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue) != null) {
                const m = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue));
                if (m instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) throw new Error("Please report error: Map iterator, unexpected stack for current");
                else return [
                    $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m),
                    $cee18de5b874f6d4$export$4278c1b57041ecb9(m)
                ];
            } else throw new Error("Please report error: Map iterator, unexpected stack for current");
        } else return $cee18de5b874f6d4$export$f636046d9a0f908f();
    } else return $cee18de5b874f6d4$export$eb70be8311af6e29();
}
function $cee18de5b874f6d4$export$6d14c1ab760e20a3(i) {
    if (i.started) {
        const matchValue = i.stack;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(matchValue)) {
            if ((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue) != null) {
                const m = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue));
                if (m instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) throw new Error("Please report error: Map iterator, unexpected stack for moveNext");
                else {
                    i.stack = $cee18de5b874f6d4$export$61f1bcf164ab6dee((0, $e08834e1786645d9$export$c01875f616615628)(matchValue));
                    return !(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(i.stack);
                }
            } else throw new Error("Please report error: Map iterator, unexpected stack for moveNext");
        } else return false;
    } else {
        i.started = true;
        return !(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(i.stack);
    }
}
function $cee18de5b874f6d4$export$948f9229550a0aa4(m) {
    let i = $cee18de5b874f6d4$export$371ee96503d209c2(m);
    return {
        "System.Collections.Generic.IEnumerator`1.get_Current" () {
            return $cee18de5b874f6d4$export$b464b82c20aea3ae(i);
        },
        "System.Collections.IEnumerator.get_Current" () {
            return $cee18de5b874f6d4$export$b464b82c20aea3ae(i);
        },
        "System.Collections.IEnumerator.MoveNext" () {
            return $cee18de5b874f6d4$export$6d14c1ab760e20a3(i);
        },
        "System.Collections.IEnumerator.Reset" () {
            i = $cee18de5b874f6d4$export$371ee96503d209c2(m);
        },
        Dispose () {}
    };
}
function $cee18de5b874f6d4$export$3dba302906848bbb(s) {
    return (0, $42cbcefff7323768$export$c48e357c1a89b78d)((en_1)=>{
        if (en_1["System.Collections.IEnumerator.MoveNext"]()) return [
            en_1["System.Collections.Generic.IEnumerator`1.get_Current"](),
            en_1
        ];
        else return undefined;
    }, $cee18de5b874f6d4$export$948f9229550a0aa4(s));
}
function $cee18de5b874f6d4$export$79d1b83964e9ab2e(m_mut) {
    MapTreeModule_leftmost: while(true){
        const m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            let matchResult, nd_1;
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                if ($cee18de5b874f6d4$export$72fcc38e1f2d1b04(m2) > 1) {
                    matchResult = 0;
                    nd_1 = m2;
                } else matchResult = 1;
            } else matchResult = 1;
            switch(matchResult){
                case 0:
                    if ($cee18de5b874f6d4$export$b1651dc4a24955a7(nd_1) == null) return [
                        $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(nd_1),
                        $cee18de5b874f6d4$export$4278c1b57041ecb9(nd_1)
                    ];
                    else {
                        m_mut = $cee18de5b874f6d4$export$b1651dc4a24955a7(nd_1);
                        continue MapTreeModule_leftmost;
                    }
                default:
                    return [
                        $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2),
                        $cee18de5b874f6d4$export$4278c1b57041ecb9(m2)
                    ];
            }
        } else throw new Error();
        break;
    }
}
function $cee18de5b874f6d4$export$44c6b58eab97478d(m_mut) {
    MapTreeModule_rightmost: while(true){
        const m = m_mut;
        if (m != null) {
            const m2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(m);
            let matchResult, nd_1;
            if (m2 instanceof $cee18de5b874f6d4$export$6ac58b91e0d1f4d8) {
                if ($cee18de5b874f6d4$export$72fcc38e1f2d1b04(m2) > 1) {
                    matchResult = 0;
                    nd_1 = m2;
                } else matchResult = 1;
            } else matchResult = 1;
            switch(matchResult){
                case 0:
                    if ($cee18de5b874f6d4$export$3c20aa294876b222(nd_1) == null) return [
                        $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(nd_1),
                        $cee18de5b874f6d4$export$4278c1b57041ecb9(nd_1)
                    ];
                    else {
                        m_mut = $cee18de5b874f6d4$export$3c20aa294876b222(nd_1);
                        continue MapTreeModule_rightmost;
                    }
                default:
                    return [
                        $cee18de5b874f6d4$export$e1b2c1f61d9e6c6b(m2),
                        $cee18de5b874f6d4$export$4278c1b57041ecb9(m2)
                    ];
            }
        } else throw new Error();
        break;
    }
}
class $cee18de5b874f6d4$export$cd3a191a686c5aa3 {
    constructor(comparer, tree){
        this.comparer = comparer;
        this.tree = tree;
    }
    GetHashCode() {
        const this$ = this;
        return $cee18de5b874f6d4$export$b73c63b3ed5ce298(this$) | 0;
    }
    Equals(that) {
        const this$ = this;
        if (that instanceof $cee18de5b874f6d4$export$cd3a191a686c5aa3) {
            const that_1 = that;
            const e1 = (0, $kRS0m.getEnumerator)(this$);
            try {
                const e2 = (0, $kRS0m.getEnumerator)(that_1);
                try {
                    const loop = ()=>{
                        const m1 = e1["System.Collections.IEnumerator.MoveNext"]();
                        if (m1 === e2["System.Collections.IEnumerator.MoveNext"]()) {
                            if (!m1) return true;
                            else {
                                const e1c = e1["System.Collections.Generic.IEnumerator`1.get_Current"]();
                                const e2c = e2["System.Collections.Generic.IEnumerator`1.get_Current"]();
                                if ((0, $kRS0m.equals)(e1c[0], e2c[0]) && (0, $kRS0m.equals)(e1c[1], e2c[1])) return loop();
                                else return false;
                            }
                        } else return false;
                    };
                    return loop();
                } finally{
                    (0, $kRS0m.disposeSafe)(e2);
                }
            } finally{
                (0, $kRS0m.disposeSafe)(e1);
            }
        } else return false;
    }
    toString() {
        const this$ = this;
        return "map [" + (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("; ", (0, $42cbcefff7323768$export$871de8747c9eaa88)((kv)=>(0, $7802b3aa01031554$export$d9468344d3651243)("({0}, {1})", kv[0], kv[1]), this$)) + "]";
    }
    get [Symbol.toStringTag]() {
        return "FSharpMap";
    }
    toJSON() {
        const this$ = this;
        return Array.from(this$);
    }
    GetEnumerator() {
        const _ = this;
        return $cee18de5b874f6d4$export$948f9229550a0aa4(_.tree);
    }
    [Symbol.iterator]() {
        return (0, $kRS0m.toIterator)((0, $kRS0m.getEnumerator)(this));
    }
    "System.Collections.IEnumerable.GetEnumerator"() {
        const _ = this;
        return $cee18de5b874f6d4$export$948f9229550a0aa4(_.tree);
    }
    CompareTo(obj) {
        const m = this;
        if (obj instanceof $cee18de5b874f6d4$export$cd3a191a686c5aa3) {
            const m2 = obj;
            return (0, $42cbcefff7323768$export$ecb3797c03e8ce0c)((kvp1, kvp2)=>{
                const c = m.comparer.Compare(kvp1[0], kvp2[0]) | 0;
                return (c !== 0 ? c : (0, $kRS0m.compare)(kvp1[1], kvp2[1])) | 0;
            }, m, m2) | 0;
        } else throw new Error("not comparable\\nParameter name: obj");
    }
    "System.Collections.Generic.ICollection`1.Add2B595"(x) {
        throw new Error("Map cannot be mutated");
    }
    "System.Collections.Generic.ICollection`1.Clear"() {
        throw new Error("Map cannot be mutated");
    }
    "System.Collections.Generic.ICollection`1.Remove2B595"(x) {
        throw new Error("Map cannot be mutated");
    }
    "System.Collections.Generic.ICollection`1.Contains2B595"(x) {
        const m = this;
        return $cee18de5b874f6d4$export$dbac7bf9c27882b(m, x[0]) && (0, $kRS0m.equals)($cee18de5b874f6d4$export$96f485bc49c6f699(m, x[0]), x[1]);
    }
    "System.Collections.Generic.ICollection`1.CopyToZ3B4C077E"(arr, i) {
        const m = this;
        $cee18de5b874f6d4$export$ef2e1235f18e29c(m.tree, arr, i);
    }
    "System.Collections.Generic.ICollection`1.get_IsReadOnly"() {
        return true;
    }
    "System.Collections.Generic.ICollection`1.get_Count"() {
        const m = this;
        return $cee18de5b874f6d4$export$58eb0dfed250c7b1(m) | 0;
    }
    "System.Collections.Generic.IReadOnlyCollection`1.get_Count"() {
        const m = this;
        return $cee18de5b874f6d4$export$58eb0dfed250c7b1(m) | 0;
    }
    get size() {
        const m = this;
        return $cee18de5b874f6d4$export$58eb0dfed250c7b1(m) | 0;
    }
    clear() {
        throw new Error("Map cannot be mutated");
    }
    delete(_arg) {
        throw new Error("Map cannot be mutated");
    }
    entries() {
        const m = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>[
                p[0],
                p[1]
            ], m);
    }
    get(k) {
        const m = this;
        return $cee18de5b874f6d4$export$96f485bc49c6f699(m, k);
    }
    has(k) {
        const m = this;
        return $cee18de5b874f6d4$export$dbac7bf9c27882b(m, k);
    }
    keys() {
        const m = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>p[0], m);
    }
    set(k, v) {
        const m = this;
        throw new Error("Map cannot be mutated");
    }
    values() {
        const m = this;
        return (0, $42cbcefff7323768$export$871de8747c9eaa88)((p)=>p[1], m);
    }
    forEach(f, thisArg) {
        const m = this;
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((p)=>{
            f(p[1], p[0], m);
        }, m);
    }
}
function $cee18de5b874f6d4$export$86aa42c46f27ec74(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Map.FSharpMap", [
        gen0,
        gen1
    ], $cee18de5b874f6d4$export$cd3a191a686c5aa3);
}
function $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(comparer, tree) {
    return new $cee18de5b874f6d4$export$cd3a191a686c5aa3(comparer, tree);
}
function $cee18de5b874f6d4$export$ad57b851c1bbc905(comparer) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(comparer, $cee18de5b874f6d4$export$e26ed7329f8c306e());
}
function $cee18de5b874f6d4$export$dedbbfeaefcfd2b7(m) {
    return m.comparer;
}
function $cee18de5b874f6d4$export$7fb8f715a20afa4c(m) {
    return m.tree;
}
function $cee18de5b874f6d4$export$7d09cc6e9599afc9(m, key, value) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$b845a3a1a6860630(m.comparer, key, value, m.tree));
}
function $cee18de5b874f6d4$export$4bca87029b3c4067(m, key, f) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$38c76335f5787e10(m.comparer, key, f, m.tree));
}
function $cee18de5b874f6d4$export$64bb97fc72e77e67(m) {
    return m.tree == null;
}
function $cee18de5b874f6d4$export$96f485bc49c6f699(m, key) {
    return $cee18de5b874f6d4$export$b1ffabbca4263ead(m.comparer, key, m.tree);
}
function $cee18de5b874f6d4$export$6408eef4157960b8(m, f) {
    return $cee18de5b874f6d4$export$9795c5ada06a6129(f, m.tree);
}
function $cee18de5b874f6d4$export$7baebb347b8f4638(m, predicate) {
    return $cee18de5b874f6d4$export$6c9add8c00707ead(predicate, m.tree);
}
function $cee18de5b874f6d4$export$de1f0e2b817a8937(m, predicate) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$1927069bf18c386d(m.comparer, predicate, m.tree));
}
function $cee18de5b874f6d4$export$37850625fe23e4b3(m, predicate) {
    return $cee18de5b874f6d4$export$93022a3ea64248ad(predicate, m.tree);
}
function $cee18de5b874f6d4$export$4de37d44171b60e1(m, f, acc) {
    return $cee18de5b874f6d4$export$b32cb04d0e7b1f8c(f, m.tree, acc);
}
function $cee18de5b874f6d4$export$7b544649ff11b4ee(m, lo, hi, f, acc) {
    return $cee18de5b874f6d4$export$3bfd4518c08b80b1(m.comparer, lo, hi, f, m.tree, acc);
}
function $cee18de5b874f6d4$export$2da0fd6db906f195(m, f) {
    $cee18de5b874f6d4$export$a3180471a8949740(f, m.tree);
}
function $cee18de5b874f6d4$export$502dc25d2a890489(m, f) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$3a298860c76721b1(f, m.tree));
}
function $cee18de5b874f6d4$export$635cbeab5c042eed(m, f) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$41465ab1d34bca0e(f, m.tree));
}
function $cee18de5b874f6d4$export$b27f33e2c366011e(m, predicate) {
    const patternInput = $cee18de5b874f6d4$export$d438af01702bf868(m.comparer, predicate, m.tree);
    return [
        $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, patternInput[0]),
        $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, patternInput[1])
    ];
}
function $cee18de5b874f6d4$export$58eb0dfed250c7b1(m) {
    return $cee18de5b874f6d4$export$989a5112f39c2166(m.tree);
}
function $cee18de5b874f6d4$export$dbac7bf9c27882b(m, key) {
    return $cee18de5b874f6d4$export$df2d9c9fdef1637d(m.comparer, key, m.tree);
}
function $cee18de5b874f6d4$export$c087b7d0b1911afa(m, key) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(m.comparer, $cee18de5b874f6d4$export$c14e06c0c09a7824(m.comparer, key, m.tree));
}
function $cee18de5b874f6d4$export$85aaeab595e7c60(_, key, value) {
    const matchValue = $cee18de5b874f6d4$export$1b96b989c0318e6d(_.comparer, key, _.tree);
    if (matchValue == null) return false;
    else {
        const v = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
        value.contents = v;
        return true;
    }
}
function $cee18de5b874f6d4$export$e008bb2aa261f4c4(_) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((kvp)=>kvp[0], $cee18de5b874f6d4$export$d46168c281ac54dc(_.tree));
}
function $cee18de5b874f6d4$export$b8f847e5bdc30d4a(_) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((kvp)=>kvp[1], $cee18de5b874f6d4$export$d46168c281ac54dc(_.tree));
}
function $cee18de5b874f6d4$export$516f185323564018(m) {
    return $cee18de5b874f6d4$export$79d1b83964e9ab2e(m.tree);
}
function $cee18de5b874f6d4$export$7037ea3668cb41cf(m) {
    return $cee18de5b874f6d4$export$44c6b58eab97478d(m.tree);
}
function $cee18de5b874f6d4$export$dabe6a04d430958f(m, key) {
    return $cee18de5b874f6d4$export$1b96b989c0318e6d(m.comparer, key, m.tree);
}
function $cee18de5b874f6d4$export$f3f7d80241efe10a(m) {
    return $cee18de5b874f6d4$export$d1efb301d629c2e1(m.tree);
}
function $cee18de5b874f6d4$export$7fe3f32f488d5b68(m) {
    return $cee18de5b874f6d4$export$d46168c281ac54dc(m.tree);
}
function $cee18de5b874f6d4$export$b73c63b3ed5ce298(this$) {
    const combineHash = (x, y)=>(x << 1) + y + 631;
    let res = 0;
    const enumerator = (0, $kRS0m.getEnumerator)(this$);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const activePatternResult = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            res = combineHash(res, (0, $kRS0m.structuralHash)(activePatternResult[0])) | 0;
            res = combineHash(res, (0, $kRS0m.structuralHash)(activePatternResult[1])) | 0;
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return res | 0;
}
function $cee18de5b874f6d4$export$dd1bc94b04021eeb(table) {
    return $cee18de5b874f6d4$export$64bb97fc72e77e67(table);
}
function $cee18de5b874f6d4$export$e16d8520af44a096(key, value, table) {
    return $cee18de5b874f6d4$export$7d09cc6e9599afc9(table, key, value);
}
function $cee18de5b874f6d4$export$d8a7b8f475ec0161(key, f, table) {
    return $cee18de5b874f6d4$export$4bca87029b3c4067(table, key, f);
}
function $cee18de5b874f6d4$export$71aa6c912b956294(key, table) {
    return $cee18de5b874f6d4$export$96f485bc49c6f699(table, key);
}
function $cee18de5b874f6d4$export$d65cb303b863e3bf(key, table) {
    return $cee18de5b874f6d4$export$dabe6a04d430958f(table, key);
}
function $cee18de5b874f6d4$export$cd7f480d6b8286c3(key, table) {
    return $cee18de5b874f6d4$export$c087b7d0b1911afa(table, key);
}
function $cee18de5b874f6d4$export$a653f93c9670a0bc(key, table) {
    return $cee18de5b874f6d4$export$dbac7bf9c27882b(table, key);
}
function $cee18de5b874f6d4$export$c1a059043cc9c119(action, table) {
    $cee18de5b874f6d4$export$2da0fd6db906f195(table, action);
}
function $cee18de5b874f6d4$export$d944e5c60afb688e(chooser, table) {
    return $cee18de5b874f6d4$export$6408eef4157960b8(table, chooser);
}
function $cee18de5b874f6d4$export$357523c63a2253b9(chooser, table) {
    const matchValue = $cee18de5b874f6d4$export$d944e5c60afb688e(chooser, table);
    if (matchValue != null) return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
    else throw new Error();
}
function $cee18de5b874f6d4$export$f7e9f41ea797a17(predicate, table) {
    return $cee18de5b874f6d4$export$7baebb347b8f4638(table, predicate);
}
function $cee18de5b874f6d4$export$3dea766d36a8935f(predicate, table) {
    return $cee18de5b874f6d4$export$de1f0e2b817a8937(table, predicate);
}
function $cee18de5b874f6d4$export$b29f828819edca8d(predicate, table) {
    return $cee18de5b874f6d4$export$b27f33e2c366011e(table, predicate);
}
function $cee18de5b874f6d4$export$e5bd981f5eeebe3b(predicate, table) {
    return $cee18de5b874f6d4$export$37850625fe23e4b3(table, predicate);
}
function $cee18de5b874f6d4$export$871de8747c9eaa88(mapping, table) {
    return $cee18de5b874f6d4$export$635cbeab5c042eed(table, mapping);
}
function $cee18de5b874f6d4$export$93e2b83da34ff82a(folder, state, table) {
    return $cee18de5b874f6d4$export$33ba2bfd3e7ff317(folder, state, $cee18de5b874f6d4$export$7fb8f715a20afa4c(table));
}
function $cee18de5b874f6d4$export$c38b8353041a4f48(folder, table, state) {
    return $cee18de5b874f6d4$export$b32cb04d0e7b1f8c(folder, $cee18de5b874f6d4$export$7fb8f715a20afa4c(table), state);
}
function $cee18de5b874f6d4$export$1344b76b7b5a4395(table) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((kvp)=>[
            kvp[0],
            kvp[1]
        ], table);
}
function $cee18de5b874f6d4$export$c236cd0b25d5b614(predicate, table) {
    return (0, $42cbcefff7323768$export$357523c63a2253b9)((kvp)=>{
        const k = kvp[0];
        if (predicate(k, kvp[1])) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(k);
        else return undefined;
    }, table);
}
function $cee18de5b874f6d4$export$f9dbe6f741496d3e(predicate, table) {
    return (0, $42cbcefff7323768$export$d944e5c60afb688e)((kvp)=>{
        const k = kvp[0];
        if (predicate(k, kvp[1])) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(k);
        else return undefined;
    }, table);
}
function $cee18de5b874f6d4$export$97ef4da51e4fceb3(elements, comparer) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(comparer, $cee18de5b874f6d4$export$e48bba52d419acd8(comparer, elements));
}
function $cee18de5b874f6d4$export$c80b5fc7454ef206(elements, comparer) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(comparer, $cee18de5b874f6d4$export$e48bba52d419acd8(comparer, elements));
}
function $cee18de5b874f6d4$export$cb197a913f6bb809(elements, comparer) {
    return $cee18de5b874f6d4$export$7cfd59c4b8abe0b9(comparer, $cee18de5b874f6d4$export$e48bba52d419acd8(comparer, elements));
}
function $cee18de5b874f6d4$export$effcdbd76139450(table) {
    return $cee18de5b874f6d4$export$f3f7d80241efe10a(table);
}
function $cee18de5b874f6d4$export$45b10814cc054894(table) {
    return $cee18de5b874f6d4$export$7fe3f32f488d5b68(table);
}
function $cee18de5b874f6d4$export$ed97f33186d4b816(table) {
    return $cee18de5b874f6d4$export$e008bb2aa261f4c4(table);
}
function $cee18de5b874f6d4$export$68c286be0e7e55b7(table) {
    return $cee18de5b874f6d4$export$b8f847e5bdc30d4a(table);
}
function $cee18de5b874f6d4$export$cef7d9675e18ab09(table) {
    return $cee18de5b874f6d4$export$516f185323564018(table);
}
function $cee18de5b874f6d4$export$e18bec7defd22519(table) {
    return $cee18de5b874f6d4$export$7037ea3668cb41cf(table);
}
function $cee18de5b874f6d4$export$6e22c362a0406a2c(comparer) {
    return $cee18de5b874f6d4$export$ad57b851c1bbc905(comparer);
}
function $cee18de5b874f6d4$export$85b9a36db797e02b(table) {
    return $cee18de5b874f6d4$export$58eb0dfed250c7b1(table);
}









var $c7lrN = parcelRequire("c7lrN");



const $3699f71d1df66484$export$15e20ddeb406d406 = console;
function $3699f71d1df66484$export$7c8963ce39fc29c(projection, a, b) {
    if ((0, $kRS0m.compare)(projection(a), projection(b)) <= 0) return a;
    else return b;
}
function $3699f71d1df66484$export$1f1fcf30eadb9697(projection, a, b) {
    if ((0, $kRS0m.compare)(projection(a), projection(b)) >= 0) return a;
    else return b;
}
function $3699f71d1df66484$export$c90542dabcef4ab1(projection, a, b) {
    return (0, $kRS0m.compare)(projection(a), projection(b));
}
function $3699f71d1df66484$export$7c247520d7ef73eb(projection, ascending) {
    if (ascending) return (a)=>(b)=>$3699f71d1df66484$export$c90542dabcef4ab1(projection, a, b);
    else return (a_1)=>(b_1)=>$3699f71d1df66484$export$c90542dabcef4ab1(projection, b_1, a_1);
}
function $3699f71d1df66484$export$9749d42f85d96507(f) {
    let prevInput = (0, $kRS0m.defaultOf)();
    let prevOutput = (0, $kRS0m.defaultOf)();
    return (x)=>{
        if (!(x === prevInput)) {
            prevInput = x;
            prevOutput = f(x);
        }
        return prevOutput;
    };
}
function $3699f71d1df66484$export$de7d922902dff7f1(merger, a, b) {
    if (a == null) {
        if (b == null) return undefined;
        else {
            const b_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(b);
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(b_2);
        }
    } else if (b == null) {
        const a_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(a);
        return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(a_2);
    } else {
        const a_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(a);
        const b_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(b);
        return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(merger(a_1, b_1));
    }
}
function $3699f71d1df66484$export$98f1870260e36073(a, b) {
    if (a != null) {
        if (b != null) {
            const a_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(a);
            const b_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(b);
            return (0, $kRS0m.compare)(a_1, b_1) | 0;
        } else return -1;
    } else if (b != null) return 1;
    else return 0;
}
function $3699f71d1df66484$export$b6076d49e7646d88(projection, a, b) {
    return $3699f71d1df66484$export$98f1870260e36073(projection(a), projection(b));
}
function $3699f71d1df66484$export$635a5682a4ff6ef0(_arg) {
    if (_arg.tag === 1) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(_arg.fields[0]);
}
function $3699f71d1df66484$export$21222002bbbb0942(_arg) {
    if (_arg.tag === 1) throw new Error("The result value was Error.\\nParameter name: result");
    else return _arg.fields[0];
}
function $3699f71d1df66484$export$a3bcc1b465b448b9(defaultValue, _arg) {
    if (_arg.tag === 1) return defaultValue;
    else return _arg.fields[0];
}
function $3699f71d1df66484$export$c53496e1eeb7cd06(_arg) {
    if (_arg.tag === 1) return false;
    else return true;
}
function $3699f71d1df66484$export$543ab221b2f27e00(_arg) {
    if (_arg.tag === 1) return true;
    else return false;
}
function $3699f71d1df66484$export$7b1a35e5f2abf04a(reduction, mapping, array) {
    if (array.length === 0) throw new Error("The given array cannot be empty.\\nParameter name: array");
    let current = mapping((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array));
    for(let idx = 0; idx <= array.length - 1; idx++){
        const x = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, array);
        current = reduction(current, mapping(x));
    }
    return current;
}
function $3699f71d1df66484$export$9f397f7c51499c56(reduction, mapping, array1, array2) {
    const len = array1.length | 0;
    if (len !== array2.length) throw new Error("The given arrays had different lengths.\\nParameter name: array1");
    if (len === 0) throw new Error("The given arrays cannot be empty.\\nParameter name: array1");
    let current = mapping((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, array2));
    for(let i = 1; i <= len - 1; i++)current = reduction(current, mapping((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array1), (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, array2)));
    return current;
}
const $3699f71d1df66484$export$b16bf5d4b63332b6 = (_arg_1)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)("No Fertilizer", (_arg)=>_arg.Name, _arg_1);
class $3699f71d1df66484$export$12e6ad755a4a86f9 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "NonCustom",
            "Custom"
        ];
    }
}
function $3699f71d1df66484$export$71cbeed5e0d6df07(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.CustomChoice`2", [
        gen0,
        gen1
    ], $3699f71d1df66484$export$12e6ad755a4a86f9, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ]
        ]);
}
class $3699f71d1df66484$export$a608f594c3a26e93 extends (0, $eATN7.Record) {
    constructor(Values, Selected){
        super();
        this.Values = Values;
        this.Selected = Selected;
    }
}
function $3699f71d1df66484$export$ebebe1f140009e4d(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Selection`2", [
        gen0,
        gen1
    ], $3699f71d1df66484$export$a608f594c3a26e93, ()=>[
            [
                "Values",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpMap`2", [
                    gen0,
                    gen1
                ])
            ],
            [
                "Selected",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    gen0
                ])
            ]
        ]);
}
function $3699f71d1df66484$export$f3e43be845c183f1() {
    return new $3699f71d1df66484$export$a608f594c3a26e93((0, $cee18de5b874f6d4$export$6e22c362a0406a2c)({
        Compare: (0, $kRS0m.compare)
    }), (0, $70b963136d0d9ffe$export$6e22c362a0406a2c)({
        Compare: (0, $kRS0m.compare)
    }));
}
function $3699f71d1df66484$export$96a0df907279b51f(key, selection) {
    if ((0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(selection.Selected, key)) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $cee18de5b874f6d4$export$96f485bc49c6f699)(selection.Values, key));
    else return undefined;
}
class $3699f71d1df66484$export$8a3b7320744db3a9 extends (0, $eATN7.Record) {
    constructor(Crops, SeedPrices, NoFertilizer, Fertilizers, FertilizerPrices, SellRaw, Products, UseHarvestedSeeds, UseSeedMaker, UseForageSeeds, CustomSeedPrices, CustomFertilizerPrices, CustomSellPrices){
        super();
        this.Crops = Crops;
        this.SeedPrices = SeedPrices;
        this.NoFertilizer = NoFertilizer;
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.SellRaw = SellRaw;
        this.Products = Products;
        this.UseHarvestedSeeds = UseHarvestedSeeds;
        this.UseSeedMaker = UseSeedMaker;
        this.UseForageSeeds = UseForageSeeds;
        this.CustomSeedPrices = CustomSeedPrices;
        this.CustomFertilizerPrices = CustomFertilizerPrices;
        this.CustomSellPrices = CustomSellPrices;
    }
}
function $3699f71d1df66484$export$93a9b72b9b376c5d() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Selections", [], $3699f71d1df66484$export$8a3b7320744db3a9, ()=>[
            [
                "Crops",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ])
            ],
            [
                "SeedPrices",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpMap`2", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539),
                    (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                        (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                    ])
                ])
            ],
            [
                "NoFertilizer",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "Fertilizers",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ])
            ],
            [
                "FertilizerPrices",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpMap`2", [
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734),
                    (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                        (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                    ])
                ])
            ],
            [
                "SellRaw",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ])
            ],
            [
                "Products",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpMap`2", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539),
                    (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                        (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                    ])
                ])
            ],
            [
                "UseHarvestedSeeds",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ])
            ],
            [
                "UseSeedMaker",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ])
            ],
            [
                "UseForageSeeds",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ])
            ],
            [
                "CustomSeedPrices",
                $3699f71d1df66484$export$ebebe1f140009e4d((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "CustomFertilizerPrices",
                $3699f71d1df66484$export$ebebe1f140009e4d((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "CustomSellPrices",
                $3699f71d1df66484$export$ebebe1f140009e4d((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)))
            ]
        ]);
}
function $3699f71d1df66484$var$SelectionsModule_ensureMapEntries(keys, map) {
    return (0, $cee18de5b874f6d4$export$c80b5fc7454ef206)((0, $42cbcefff7323768$export$871de8747c9eaa88)((key)=>[
            key,
            (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $cee18de5b874f6d4$export$d65cb303b863e3bf)(key, map), (0, $70b963136d0d9ffe$export$6e22c362a0406a2c)({
                Compare: (0, $kRS0m.compare)
            }))
        ], keys), {
        Compare: (0, $kRS0m.compare)
    });
}
function $3699f71d1df66484$export$df2d545542fb7e19(data, selected) {
    return new $3699f71d1df66484$export$8a3b7320744db3a9(selected.Crops, $3699f71d1df66484$var$SelectionsModule_ensureMapEntries(data.Crops.fields[0].keys(), selected.SeedPrices), selected.NoFertilizer, selected.Fertilizers, $3699f71d1df66484$var$SelectionsModule_ensureMapEntries(data.Fertilizers.fields[0].keys(), selected.FertilizerPrices), selected.SellRaw, $3699f71d1df66484$var$SelectionsModule_ensureMapEntries(data.Items.fields[0].keys(), selected.Products), selected.UseHarvestedSeeds, selected.UseSeedMaker, selected.UseForageSeeds, selected.CustomSeedPrices, selected.CustomFertilizerPrices, selected.CustomSellPrices);
}
function $3699f71d1df66484$var$SelectionsModule_mapOfSets(table) {
    return (0, $cee18de5b874f6d4$export$c80b5fc7454ef206)((0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>[
            tupledArg[0],
            (0, $70b963136d0d9ffe$export$c80b5fc7454ef206)(tupledArg[1].fields[0].keys(), {
                Compare: (0, $kRS0m.compare)
            })
        ], table.fields[0]), {
        Compare: (0, $kRS0m.compare)
    });
}
function $3699f71d1df66484$export$9061320d5fee8ae8(data) {
    const seedSet = (predicate)=>(0, $70b963136d0d9ffe$export$c80b5fc7454ef206)((0, $42cbcefff7323768$export$7877a478dd30fd3d)((crop)=>{
            if (predicate(crop)) return (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
            else return undefined;
        }, data.Crops.fields[0].values()), {
            Compare: (0, $kRS0m.comparePrimitives)
        });
    const forageCrops = seedSet((0, $e189d4fb2d038fab$export$a6e0eedf3a1bd082));
    let items;
    const array_2 = (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((0, $e189d4fb2d038fab$export$a873be80581d6a18), Array.from(data.Crops.fields[0].values()), Uint32Array);
    items = (0, $e5d9070e144b905e$export$10d8903dec122b9d)(Uint32Array.from((0, $42cbcefff7323768$export$871de8747c9eaa88)((seed)=>seed * 1, forageCrops)), array_2, Uint32Array);
    return new $3699f71d1df66484$export$8a3b7320744db3a9((0, $70b963136d0d9ffe$export$c80b5fc7454ef206)(data.Crops.fields[0].keys(), {
        Compare: (0, $kRS0m.comparePrimitives)
    }), $3699f71d1df66484$var$SelectionsModule_mapOfSets(data.SeedPrices), true, (0, $70b963136d0d9ffe$export$c80b5fc7454ef206)(data.Fertilizers.fields[0].keys(), {
        Compare: (0, $kRS0m.comparePrimitives)
    }), $3699f71d1df66484$var$SelectionsModule_mapOfSets(data.FertilizerPrices), (0, $70b963136d0d9ffe$export$cb197a913f6bb809)(items, {
        Compare: (0, $kRS0m.comparePrimitives)
    }), (0, $cee18de5b874f6d4$export$c80b5fc7454ef206)((0, $42cbcefff7323768$export$871de8747c9eaa88)((item)=>[
            item,
            (0, $70b963136d0d9ffe$export$cb197a913f6bb809)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((0, $cdb0798a49937e52$export$3b5fd34b2463eb68), (0, $a117bb35793377d5$export$a8beba8a53794dfa)(data, item)), {
                Compare: (0, $kRS0m.comparePrimitives)
            })
        ], items), {
        Compare: (0, $kRS0m.comparePrimitives)
    }), seedSet((0, $e189d4fb2d038fab$export$518a79ca6e7bc25b)), seedSet((crop_2)=>(0, $e189d4fb2d038fab$export$9a6d33d4fe8fe14)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), crop_2)), forageCrops, $3699f71d1df66484$export$f3e43be845c183f1(), $3699f71d1df66484$export$f3e43be845c183f1(), $3699f71d1df66484$export$f3e43be845c183f1());
}
class $3699f71d1df66484$export$a588ef89de95aa8f extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Buy First",
            "Stockpile",
            "Ignore"
        ];
    }
}
function $3699f71d1df66484$export$43804ad8ff7cbd7() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.SeedStrategy", [], $3699f71d1df66484$export$a588ef89de95aa8f, ()=>[
            [],
            [],
            []
        ]);
}
class $3699f71d1df66484$export$c41588bc52e5d7c7 extends (0, $eATN7.Record) {
    constructor(SeedStrategy, PayForFertilizer, PayForDestroyedFertilizer){
        super();
        this.SeedStrategy = SeedStrategy;
        this.PayForFertilizer = PayForFertilizer;
        this.PayForDestroyedFertilizer = PayForDestroyedFertilizer;
    }
}
function $3699f71d1df66484$export$5f9de42bde5b8061() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.ProfitSettings", [], $3699f71d1df66484$export$c41588bc52e5d7c7, ()=>[
            [
                "SeedStrategy",
                $3699f71d1df66484$export$43804ad8ff7cbd7()
            ],
            [
                "PayForFertilizer",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "PayForDestroyedFertilizer",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
class $3699f71d1df66484$export$c72f6eaae7b9adff extends (0, $eATN7.Record) {
    constructor(Game, Profit, Selected){
        super();
        this.Game = Game;
        this.Profit = Profit;
        this.Selected = Selected;
    }
}
function $3699f71d1df66484$export$8bb33babc70c6427() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Settings", [], $3699f71d1df66484$export$c72f6eaae7b9adff, ()=>[
            [
                "Game",
                (0, $a117bb35793377d5$export$cbc7380c0206788a)()
            ],
            [
                "Profit",
                $3699f71d1df66484$export$5f9de42bde5b8061()
            ],
            [
                "Selected",
                $3699f71d1df66484$export$93a9b72b9b376c5d()
            ]
        ]);
}
function $3699f71d1df66484$export$c65c8037db236fae(data, settings) {
    return new $3699f71d1df66484$export$c72f6eaae7b9adff(settings.Game, settings.Profit, $3699f71d1df66484$export$df2d545542fb7e19(data, settings.Selected));
}
class $3699f71d1df66484$export$e5d97828673c2a38 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Ranker",
            "Optimizer"
        ];
    }
}
function $3699f71d1df66484$export$34e880ca4a41811a() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.AppMode", [], $3699f71d1df66484$export$e5d97828673c2a38, ()=>[
            [],
            []
        ]);
}
class $3699f71d1df66484$export$5472259569c801e3 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "All Pairs",
            "Crops",
            "Fertilizers"
        ];
    }
}
function $3699f71d1df66484$export$1824d3b6bd68574d() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.RankItem", [], $3699f71d1df66484$export$5472259569c801e3, ()=>[
            [],
            [],
            []
        ]);
}
class $3699f71d1df66484$export$f79c53f8fc5ad0e extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Gold",
            "ROI",
            "XP"
        ];
    }
}
function $3699f71d1df66484$export$a74b6a5c4e0a0ce2() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.RankMetric", [], $3699f71d1df66484$export$f79c53f8fc5ad0e, ()=>[
            [],
            [],
            []
        ]);
}
function $3699f71d1df66484$export$d5ab4692440e2f4a(_arg) {
    switch(_arg.tag){
        case 1:
            return "%";
        case 2:
            return "xp";
        default:
            return "g";
    }
}
class $3699f71d1df66484$export$c525707b46ee8b45 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Total",
            "Per Day",
            "Per Season"
        ];
    }
}
function $3699f71d1df66484$export$75ade4344f3555a8() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.TimeNormalization", [], $3699f71d1df66484$export$c525707b46ee8b45, ()=>[
            [],
            [],
            []
        ]);
}
function $3699f71d1df66484$export$61b794ced48389aa(_arg) {
    switch(_arg.tag){
        case 1:
            return "day";
        case 2:
            return "season";
        default:
            return "";
    }
}
class $3699f71d1df66484$export$e10de9ebf9a3bcf6 extends (0, $eATN7.Record) {
    constructor(RankItem, RankMetric, TimeNormalization, ShowInvalid, BrushSpan, SelectedCropAndFertilizer){
        super();
        this.RankItem = RankItem;
        this.RankMetric = RankMetric;
        this.TimeNormalization = TimeNormalization;
        this.ShowInvalid = ShowInvalid;
        this.BrushSpan = BrushSpan;
        this.SelectedCropAndFertilizer = SelectedCropAndFertilizer;
    }
}
function $3699f71d1df66484$export$1cfa882f9734b85c() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Ranker", [], $3699f71d1df66484$export$e10de9ebf9a3bcf6, ()=>[
            [
                "RankItem",
                $3699f71d1df66484$export$1824d3b6bd68574d()
            ],
            [
                "RankMetric",
                $3699f71d1df66484$export$a74b6a5c4e0a0ce2()
            ],
            [
                "TimeNormalization",
                $3699f71d1df66484$export$75ade4344f3555a8()
            ],
            [
                "ShowInvalid",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "BrushSpan",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
            ],
            [
                "SelectedCropAndFertilizer",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539)), (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734)))))
            ]
        ]);
}
class $3699f71d1df66484$export$d46dd6b37eef15e5 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Gold",
            "XP"
        ];
    }
}
function $3699f71d1df66484$export$f84cde22303e6288() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.OptimizationObjective", [], $3699f71d1df66484$export$d46dd6b37eef15e5, ()=>[
            [],
            []
        ]);
}
class $3699f71d1df66484$export$5d396b237bd33221 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Crops",
            "Fertilizers",
            "Misc",
            "Load/Save"
        ];
    }
}
function $3699f71d1df66484$export$ca496ce55ada41e0() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.SettingsTab", [], $3699f71d1df66484$export$5d396b237bd33221, ()=>[
            [],
            [],
            [],
            []
        ]);
}
class $3699f71d1df66484$export$688dd1dfb49cf808 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "CropFilters",
            "Crops",
            "Products",
            "Seeds",
            "Fertilizers",
            "FertilizerPrices",
            "Skills",
            "Multipliers",
            "CropSettings",
            "Mod",
            "RankerGrowthCalendar",
            "RankerSummary",
            "OptimizerGrowthCalendar",
            "OptimizerSummary"
        ];
    }
}
function $3699f71d1df66484$export$b122996215503ad8() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.OpenDetails", [], $3699f71d1df66484$export$688dd1dfb49cf808, ()=>[
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ]);
}
class $3699f71d1df66484$export$4a265e05b3750eef extends (0, $eATN7.Record) {
    constructor(ItemNameSearch, InSeason, Seasons, Regrows, Giant, Forage){
        super();
        this.ItemNameSearch = ItemNameSearch;
        this.InSeason = InSeason;
        this.Seasons = Seasons | 0;
        this.Regrows = Regrows;
        this.Giant = Giant;
        this.Forage = Forage;
    }
}
function $3699f71d1df66484$export$4e7aa36ca71d7d0e() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.CropFilters", [], $3699f71d1df66484$export$4a265e05b3750eef, ()=>[
            [
                "ItemNameSearch",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "InSeason",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "Seasons",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Seasons", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "None",
                        0
                    ],
                    [
                        "Spring",
                        1
                    ],
                    [
                        "Summer",
                        2
                    ],
                    [
                        "Fall",
                        4
                    ],
                    [
                        "Winter",
                        8
                    ],
                    [
                        "All",
                        15
                    ]
                ])
            ],
            [
                "Regrows",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "Giant",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "Forage",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ]
        ]);
}
const $3699f71d1df66484$export$f6bbffe374f1c8e1 = new $3699f71d1df66484$export$4a265e05b3750eef("", true, 0, undefined, undefined, undefined);
class $3699f71d1df66484$export$f5cb00b74b6a34bb extends (0, $eATN7.Record) {
    constructor(Filters, CropSort, ProductSort, SeedSort, ProductQuality, NormalizeProductPrices){
        super();
        this.Filters = Filters;
        this.CropSort = CropSort;
        this.ProductSort = ProductSort;
        this.SeedSort = SeedSort;
        this.ProductQuality = ProductQuality | 0;
        this.NormalizeProductPrices = NormalizeProductPrices;
    }
}
function $3699f71d1df66484$export$62d9766c815df4b9() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.CropTabState", [], $3699f71d1df66484$export$f5cb00b74b6a34bb, ()=>[
            [
                "Filters",
                $3699f71d1df66484$export$4e7aa36ca71d7d0e()
            ],
            [
                "CropSort",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "ProductSort",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "SeedSort",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "ProductQuality",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Silver",
                        1
                    ],
                    [
                        "Gold",
                        2
                    ],
                    [
                        "Iridium",
                        3
                    ]
                ])
            ],
            [
                "NormalizeProductPrices",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
class $3699f71d1df66484$export$32d6e6630321d5dc extends (0, $eATN7.Record) {
    constructor(Mode, Ranker, OptimizationObjective, SettingsTab, OpenDetails, CropTab, FertilizerSort, FertilizerPriceSort){
        super();
        this.Mode = Mode;
        this.Ranker = Ranker;
        this.OptimizationObjective = OptimizationObjective;
        this.SettingsTab = SettingsTab;
        this.OpenDetails = OpenDetails;
        this.CropTab = CropTab;
        this.FertilizerSort = FertilizerSort;
        this.FertilizerPriceSort = FertilizerPriceSort;
    }
}
function $3699f71d1df66484$export$1ca09fa0b7507761() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.UIState", [], $3699f71d1df66484$export$32d6e6630321d5dc, ()=>[
            [
                "Mode",
                $3699f71d1df66484$export$34e880ca4a41811a()
            ],
            [
                "Ranker",
                $3699f71d1df66484$export$1cfa882f9734b85c()
            ],
            [
                "OptimizationObjective",
                $3699f71d1df66484$export$f84cde22303e6288()
            ],
            [
                "SettingsTab",
                $3699f71d1df66484$export$ca496ce55ada41e0()
            ],
            [
                "OpenDetails",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                    $3699f71d1df66484$export$b122996215503ad8()
                ])
            ],
            [
                "CropTab",
                $3699f71d1df66484$export$62d9766c815df4b9()
            ],
            [
                "FertilizerSort",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ],
            [
                "FertilizerPriceSort",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
            ]
        ]);
}
class $3699f71d1df66484$export$3463c369d5cc977f extends (0, $eATN7.Record) {
    constructor(Name, UniqueId, Settings){
        super();
        this.Name = Name;
        this.UniqueId = UniqueId;
        this.Settings = Settings;
    }
}
function $3699f71d1df66484$export$afe90dd46d357489() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Preset", [], $3699f71d1df66484$export$3463c369d5cc977f, ()=>[
            [
                "Name",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "UniqueId",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$81545eb7084dcd0b))
            ],
            [
                "Settings",
                $3699f71d1df66484$export$8bb33babc70c6427()
            ]
        ]);
}
function $3699f71d1df66484$export$1f050c40b73d064f(uniqueId, preset) {
    return (0, $42cbcefff7323768$export$2344b14b097df817)(uniqueId, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(preset.UniqueId), {
        Equals: (0, $c7lrN.equals),
        GetHashCode: (0, $kRS0m.bigintHash)
    });
}
class $3699f71d1df66484$export$86fbec116b87613f extends (0, $eATN7.Record) {
    constructor(Data, Presets, State){
        super();
        this.Data = Data;
        this.Presets = Presets;
        this.State = State;
    }
}
function $3699f71d1df66484$export$27e0aa119595e4b8() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.App", [], $3699f71d1df66484$export$86fbec116b87613f, ()=>[
            [
                "Data",
                (0, $a117bb35793377d5$export$673822fe45936d46)()
            ],
            [
                "Presets",
                (0, $3921efb06a31e9cc$export$5fe717259b8d6105)($3699f71d1df66484$export$afe90dd46d357489())
            ],
            [
                "State",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)($3699f71d1df66484$export$8bb33babc70c6427(), $3699f71d1df66484$export$1ca09fa0b7507761())
            ]
        ]);
}
class $3699f71d1df66484$export$682c179f50ab847d extends (0, $eATN7.Record) {
    constructor(Major, Minor, Patch){
        super();
        this.Major = Major;
        this.Minor = Minor;
        this.Patch = Patch;
    }
    toString() {
        const this$ = this;
        return `${this$.Major}.${this$.Minor}.${this$.Patch}`;
    }
}
function $3699f71d1df66484$export$8fc7278601dbae43() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Version", [], $3699f71d1df66484$export$682c179f50ab847d, ()=>[
            [
                "Major",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Minor",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Patch",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ]
        ]);
}
function $3699f71d1df66484$var$VersionModule_$007CNat$007C_$007C(str) {
    let matchValue;
    let outArg = 0;
    matchValue = [
        (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(str, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ];
    if (matchValue[0]) return matchValue[1];
    else return undefined;
}
function $3699f71d1df66484$export$ab7144b9bc13e399(str) {
    const matchValue = (0, $7802b3aa01031554$export$65980d18b75784e2)(str, [
        "."
    ], undefined, 0);
    let matchResult, major, minor, patch;
    if (!(0, $e5d9070e144b905e$export$9d4fa3538bf09487)((x, y)=>x === y, matchValue, (0, $kRS0m.defaultOf)()) && matchValue.length === 3) {
        const activePatternResult = $3699f71d1df66484$var$VersionModule_$007CNat$007C_$007C((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, matchValue));
        if (activePatternResult != null) {
            const activePatternResult_1 = $3699f71d1df66484$var$VersionModule_$007CNat$007C_$007C((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, matchValue));
            if (activePatternResult_1 != null) {
                const activePatternResult_2 = $3699f71d1df66484$var$VersionModule_$007CNat$007C_$007C((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(2, matchValue));
                if (activePatternResult_2 != null) {
                    matchResult = 0;
                    major = activePatternResult;
                    minor = activePatternResult_1;
                    patch = activePatternResult_2;
                } else matchResult = 1;
            } else matchResult = 1;
        } else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return new $3699f71d1df66484$export$682c179f50ab847d(major, minor, patch);
        default:
            return undefined;
    }
}
const $3699f71d1df66484$export$866688da15343462 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($3699f71d1df66484$export$ab7144b9bc13e399("1.0.0"));
function $3699f71d1df66484$export$eb28436a1114d93c(data, app) {
    const patternInput = app.State;
    const settings = patternInput[0];
    const State = [
        $3699f71d1df66484$export$c65c8037db236fae(data, settings),
        patternInput[1]
    ];
    return new $3699f71d1df66484$export$86fbec116b87613f(data, (0, $e08834e1786645d9$export$871de8747c9eaa88)((preset)=>new $3699f71d1df66484$export$3463c369d5cc977f(preset.Name, preset.UniqueId, $3699f71d1df66484$export$c65c8037db236fae(data, settings)), app.Presets), State);
}









class $7c6f80c5743180ba$export$641283dac61e9c0e extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetLevel",
            "SetBuff"
        ];
    }
}
function $7c6f80c5743180ba$export$f5aec69ea298934f() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.SkillMessage", [], $7c6f80c5743180ba$export$641283dac61e9c0e, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$bb5bb5912cca8d32 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetFarming",
            "SetForaging",
            "SetProfession",
            "SetIgnoreSkillLevelRequirements",
            "SetIgnoreProfessionConflicts"
        ];
    }
}
function $7c6f80c5743180ba$export$61af12dd4ba3f948() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.SkillsMessage", [], $7c6f80c5743180ba$export$bb5bb5912cca8d32, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$f5aec69ea298934f()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$f5aec69ea298934f()
                ]
            ],
            [
                [
                    "Item1",
                    (0, $7bbf2c7402328604$export$eded135980cc84c)()
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$795537fe84622889 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetSpecialCharm",
            "SetLuckBuff",
            "SetGiantCropOrientationsPerTile",
            "SetShavingToolLevel"
        ];
    }
}
function $7c6f80c5743180ba$export$1a3887111beb3b79() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.CropAmountMessage", [], $7c6f80c5743180ba$export$795537fe84622889, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.ToolLevel", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Copper",
                            1
                        ],
                        [
                            "Steel",
                            2
                        ],
                        [
                            "Gold",
                            3
                        ],
                        [
                            "Iridium",
                            4
                        ]
                    ]))
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$335e301269bc1503 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetProfitMargin",
            "SetBearsKnowledge",
            "SetTillerForForagedFruit"
        ];
    }
}
function $7c6f80c5743180ba$export$da8691a8103c80a2() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.MultipliersMessage", [], $7c6f80c5743180ba$export$335e301269bc1503, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetStartDate",
            "SetEndDate",
            "SetLocation",
            "SetSkills",
            "SetMultipliers",
            "SetCropAmount",
            "SetJojaMembership",
            "SetIrrigated",
            "SetQualityArtisanProducts"
        ];
    }
}
function $7c6f80c5743180ba$export$3862718d8eaa9efd() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.GameVariablesMessage", [], $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1, ()=>[
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $a117bb35793377d5$export$4479c41f4f18ce99)()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$61af12dd4ba3f948()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$da8691a8103c80a2()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$1a3887111beb3b79()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$304072893c6c33e4 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetSelected",
            "SetManySelected"
        ];
    }
}
function $7c6f80c5743180ba$export$4fe63bc224260a5b(gen0) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.SelectionMessage`1", [
        gen0
    ], $7c6f80c5743180ba$export$304072893c6c33e4, ()=>[
            [
                [
                    "Item1",
                    gen0
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpSet`1", [
                        gen0
                    ])
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$dd429cf9e5006db2 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "AddCustom",
            "EditCustom",
            "RemoveCustom",
            "SelectCustom"
        ];
    }
}
function $7c6f80c5743180ba$export$8b5272d526620772(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.CustomMessage`2", [
        gen0,
        gen1
    ], $7c6f80c5743180ba$export$dd429cf9e5006db2, ()=>[
            [
                [
                    "Item1",
                    gen0
                ],
                [
                    "Item2",
                    gen1
                ]
            ],
            [
                [
                    "Item1",
                    gen0
                ],
                [
                    "Item2",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b(gen0)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$ae2c9c198ad166ff extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SelectCrops",
            "SelectSeedPrices",
            "SelectNoFertilizer",
            "SelectFertilizers",
            "SelectFertilizerPrices",
            "SelectSellRaw",
            "SelectProducts",
            "SelectUseHarvestedSeeds",
            "SelectUseSeedMaker",
            "SelectUseForageSeeds",
            "SetCustomFertilizerPrice",
            "SetCustomSeedPrice",
            "SetCustomSellPrice"
        ];
    }
}
function $7c6f80c5743180ba$export$fe23121b427f3382() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.SelectionsMessage", [], $7c6f80c5743180ba$export$ae2c9c198ad166ff, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$36bbd56a39d3f734))
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$36bbd56a39d3f734))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$4fe63bc224260a5b((0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$8b5272d526620772((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$8b5272d526620772((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$8b5272d526620772((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)))
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetSeedStrategy",
            "SetPayForFertilizer",
            "SetPayForDestroyedFertilizer"
        ];
    }
}
function $7c6f80c5743180ba$export$a8f8a61142db3c88() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.ProfitMessage", [], $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2, ()=>[
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$43804ad8ff7cbd7)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$31d5215e225c155b extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetGameVariables",
            "SetProfit",
            "SetSelections"
        ];
    }
}
function $7c6f80c5743180ba$export$7fd29a5c73aeda22() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.SettingsMessage", [], $7c6f80c5743180ba$export$31d5215e225c155b, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$3862718d8eaa9efd()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$a8f8a61142db3c88()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$fe23121b427f3382()
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$4e595afe15e5e4d6 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetItemNameSearch",
            "SetInSeason",
            "SetSeasons",
            "SetRegrows",
            "SetGiant",
            "SetForage",
            "ClearFilters"
        ];
    }
}
function $7c6f80c5743180ba$export$be15fe1894994710() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.CropFiltersMessage", [], $7c6f80c5743180ba$export$4e595afe15e5e4d6, ()=>[
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Seasons", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "None",
                            0
                        ],
                        [
                            "Spring",
                            1
                        ],
                        [
                            "Summer",
                            2
                        ],
                        [
                            "Fall",
                            4
                        ],
                        [
                            "Winter",
                            8
                        ],
                        [
                            "All",
                            15
                        ]
                    ])
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            []
        ]);
}
class $7c6f80c5743180ba$export$edd3bdc535d06a1 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetCropFilters",
            "SetCropSort",
            "SetProductSort",
            "SetSeedSort",
            "SetProductQuality",
            "SetNormalizeProductPrices"
        ];
    }
}
function $7c6f80c5743180ba$export$f01ae8cf64de533b() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.CropTabMessage", [], $7c6f80c5743180ba$export$edd3bdc535d06a1, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$be15fe1894994710()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Silver",
                            1
                        ],
                        [
                            "Gold",
                            2
                        ],
                        [
                            "Iridium",
                            3
                        ]
                    ])
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$6ae9f6bb93c8d52f extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetRankItem",
            "SetRankMetric",
            "SetTimeNormalization",
            "SetShowInvalid",
            "SetBrushSpan",
            "SetSelectedCropAndFertilizer"
        ];
    }
}
function $7c6f80c5743180ba$export$d40d38d9254484e1() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.RankerMessage", [], $7c6f80c5743180ba$export$6ae9f6bb93c8d52f, ()=>[
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$1824d3b6bd68574d)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$a74b6a5c4e0a0ce2)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$75ade4344f3555a8)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539)), (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734)))))
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$78428c3f899407d extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetAppMode",
            "SetRanker",
            "SetOptimizationObjective",
            "SetSettingsTab",
            "SetDetailsOpen",
            "SetCropTabState",
            "SetFertilizerSort",
            "SetFertilizerPriceSort"
        ];
    }
}
function $7c6f80c5743180ba$export$403fb520ba5d577() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.UIMessage", [], $7c6f80c5743180ba$export$78428c3f899407d, ()=>[
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$34e880ca4a41811a)()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$d40d38d9254484e1()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$f84cde22303e6288)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$ca496ce55ada41e0)()
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3699f71d1df66484$export$b122996215503ad8)()
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$f01ae8cf64de533b()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$decfa90875508c9d extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "LoadSaveGame",
            "SavePreset",
            "RenamePreset",
            "DeletePreset"
        ];
    }
}
function $7c6f80c5743180ba$export$1d22e3188a2267b5() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.PresetsMessage", [], $7c6f80c5743180ba$export$decfa90875508c9d, ()=>[
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$afe90dd46d357489)()
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3699f71d1df66484$export$8bb33babc70c6427)()
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$7c34fbaae8d281c1 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetSettings",
            "SetUI",
            "LoadSettings"
        ];
    }
}
function $7c6f80c5743180ba$export$a060c0551075d9d4() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.StateMessage", [], $7c6f80c5743180ba$export$7c34fbaae8d281c1, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$7fd29a5c73aeda22()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$403fb520ba5d577()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3699f71d1df66484$export$8bb33babc70c6427)()
                ]
            ]
        ]);
}
class $7c6f80c5743180ba$export$da423d5c8ff19e85 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "SetState",
            "SetPresets",
            "SyncPresets",
            "NuclearReset"
        ];
    }
}
function $7c6f80c5743180ba$export$1077138eec82a0d6() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Update.AppMessage", [], $7c6f80c5743180ba$export$da423d5c8ff19e85, ()=>[
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$a060c0551075d9d4()
                ]
            ],
            [
                [
                    "Item",
                    $7c6f80c5743180ba$export$1d22e3188a2267b5()
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3699f71d1df66484$export$afe90dd46d357489)())
                ]
            ],
            []
        ]);
}
function $7c6f80c5743180ba$var$setSelected(makeSelected, value, set$) {
    if (makeSelected) return (0, $70b963136d0d9ffe$export$e16d8520af44a096)(value, set$);
    else return (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(value, set$);
}
function $7c6f80c5743180ba$export$e8b0345151fdf1df(msg, skill_1) {
    if (msg.tag === 1) return new (0, $7bbf2c7402328604$export$118171a82d109c04)(skill_1.Level, msg.fields[0]);
    else return new (0, $7bbf2c7402328604$export$118171a82d109c04)(msg.fields[0], skill_1.Buff);
}
function $7c6f80c5743180ba$export$21d125155bb0f111(msg, skills_1) {
    switch(msg.tag){
        case 1:
            return new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(skills_1.Farming, $7c6f80c5743180ba$export$e8b0345151fdf1df(msg.fields[0], skills_1.Foraging), skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
        case 2:
            {
                const selected = msg.fields[1];
                const profession = msg.fields[0];
                return new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(skills_1.Farming, skills_1.Foraging, $7c6f80c5743180ba$var$setSelected(selected, profession, skills_1.IgnoreProfessionConflicts ? skills_1.Professions : profession.tag === 1 ? selected ? (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(2, []), (0, $70b963136d0d9ffe$export$e16d8520af44a096)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []), skills_1.Professions)) : skills_1.Professions : profession.tag === 2 ? selected ? (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(1, []), (0, $70b963136d0d9ffe$export$e16d8520af44a096)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []), skills_1.Professions)) : skills_1.Professions : profession.tag === 3 ? selected ? skills_1.Professions : (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(4, []), skills_1.Professions) : profession.tag === 4 ? selected ? (0, $70b963136d0d9ffe$export$e16d8520af44a096)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(3, []), skills_1.Professions) : skills_1.Professions : selected ? skills_1.Professions : (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(2, []), (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(1, []), skills_1.Professions))), skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
            }
        case 3:
            return new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(skills_1.Farming, skills_1.Foraging, skills_1.Professions, msg.fields[0], skills_1.IgnoreProfessionConflicts);
        case 4:
            return new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(skills_1.Farming, skills_1.Foraging, skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, msg.fields[0]);
        default:
            return new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)($7c6f80c5743180ba$export$e8b0345151fdf1df(msg.fields[0], skills_1.Farming), skills_1.Foraging, skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
    }
}
function $7c6f80c5743180ba$export$8ec12c98b5d34f5(msg, amount) {
    switch(msg.tag){
        case 1:
            return new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(amount.SpecialCharm, msg.fields[0], amount.GiantCropOrientationsPerTile, amount.ShavingToolLevel);
        case 2:
            return new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(amount.SpecialCharm, amount.LuckBuff, msg.fields[0], amount.ShavingToolLevel);
        case 3:
            return new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(amount.SpecialCharm, amount.LuckBuff, amount.GiantCropOrientationsPerTile, msg.fields[0]);
        default:
            return new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(msg.fields[0], amount.LuckBuff, amount.GiantCropOrientationsPerTile, amount.ShavingToolLevel);
    }
}
function $7c6f80c5743180ba$export$f7e856314f28d0a5(msg, multipliers_1) {
    switch(msg.tag){
        case 1:
            return new (0, $cdb0798a49937e52$export$bf73db94524e6efd)(multipliers_1.ProfitMargin, msg.fields[0], multipliers_1.TillerForForagedFruit);
        case 2:
            return new (0, $cdb0798a49937e52$export$bf73db94524e6efd)(multipliers_1.ProfitMargin, multipliers_1.BearsKnowledge, msg.fields[0]);
        default:
            return new (0, $cdb0798a49937e52$export$bf73db94524e6efd)(msg.fields[0], multipliers_1.BearsKnowledge, multipliers_1.TillerForForagedFruit);
    }
}
function $7c6f80c5743180ba$export$94ea62e65e90c61b(msg, vars) {
    switch(msg.tag){
        case 1:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, msg.fields[0], vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 2:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, msg.fields[0], vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 3:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, $7c6f80c5743180ba$export$21d125155bb0f111(msg.fields[0], vars.Skills), vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 4:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, $7c6f80c5743180ba$export$f7e856314f28d0a5(msg.fields[0], vars.Multipliers), vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 5:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, $7c6f80c5743180ba$export$8ec12c98b5d34f5(msg.fields[0], vars.CropAmount), vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 6:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, msg.fields[0], vars.Irrigated, vars.QualityArtisanProducts);
        case 7:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, msg.fields[0], vars.QualityArtisanProducts);
        case 8:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, msg.fields[0]);
        default:
            return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(msg.fields[0], vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
    }
}
function $7c6f80c5743180ba$var$select(msg, set$) {
    if (msg.tag === 1) {
        const keys = msg.fields[0];
        if (msg.fields[1]) return (0, $70b963136d0d9ffe$export$f3072a5d1b47bd83)(set$, keys);
        else return (0, $70b963136d0d9ffe$export$1bcf0b707e21f1fa)(set$, keys);
    } else return $7c6f80c5743180ba$var$setSelected(msg.fields[1], msg.fields[0], set$);
}
function $7c6f80c5743180ba$var$mapSelectWith(containsKey, key, msg, map) {
    if (msg.tag === 1) return (0, $cee18de5b874f6d4$export$871de8747c9eaa88)((id$0027_1, selection)=>{
        if (containsKey(id$0027_1, key) && (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(msg.fields[0], id$0027_1)) return $7c6f80c5743180ba$var$setSelected(msg.fields[1], key, selection);
        else return selection;
    }, map);
    else return (0, $cee18de5b874f6d4$export$d8a7b8f475ec0161)(msg.fields[0], (option)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((set$)=>$7c6f80c5743180ba$var$setSelected(msg.fields[1], key, set$), option), map);
}
function $7c6f80c5743180ba$var$mapSelect(data, key, msg, map) {
    return $7c6f80c5743180ba$var$mapSelectWith((id$0027, key_1)=>{
        const arg10$0040_1 = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.fields[0], id$0027);
        return arg10$0040_1.fields[0].has(key_1);
    }, key, msg, map);
}
function $7c6f80c5743180ba$export$4c00f665f0d4b443(msg, selection) {
    switch(msg.tag){
        case 2:
            {
                const key_1 = msg.fields[0];
                const Selected = (0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)(key_1, selection.Selected);
                return new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$cd7f480d6b8286c3)(key_1, selection.Values), Selected);
            }
        case 1:
            return new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$e16d8520af44a096)(msg.fields[0], msg.fields[1], selection.Values), selection.Selected);
        case 3:
            return new (0, $3699f71d1df66484$export$a608f594c3a26e93)(selection.Values, $7c6f80c5743180ba$var$select(msg.fields[0], selection.Selected));
        default:
            {
                const key = msg.fields[0];
                return new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$e16d8520af44a096)(key, msg.fields[1], selection.Values), (0, $70b963136d0d9ffe$export$e16d8520af44a096)(key, selection.Selected));
            }
    }
}
function $7c6f80c5743180ba$export$4ea6092c933ebdb5(data, msg, selection) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, $7c6f80c5743180ba$var$mapSelect(data.SeedPrices, msg.fields[0], msg.fields[1], selection.SeedPrices), selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 2:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, msg.fields[0], selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 3:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, $7c6f80c5743180ba$var$select(msg.fields[0], selection.Fertilizers), selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 4:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, $7c6f80c5743180ba$var$mapSelect(data.FertilizerPrices, msg.fields[0], msg.fields[1], selection.FertilizerPrices), selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 5:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, $7c6f80c5743180ba$var$select(msg.fields[0], selection.SellRaw), selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 6:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, $7c6f80c5743180ba$var$mapSelectWith((item, processor_1)=>(0, $a117bb35793377d5$export$323f73e82c9af216)(data, processor_1, item) != null, msg.fields[0], msg.fields[1], selection.Products), selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 7:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, $7c6f80c5743180ba$var$select(msg.fields[0], selection.UseHarvestedSeeds), selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 8:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, $7c6f80c5743180ba$var$select(msg.fields[0], selection.UseSeedMaker), selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 9:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, $7c6f80c5743180ba$var$select(msg.fields[0], selection.UseForageSeeds), selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 10:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, $7c6f80c5743180ba$export$4c00f665f0d4b443(msg.fields[0], selection.CustomFertilizerPrices), selection.CustomSellPrices);
        case 11:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, $7c6f80c5743180ba$export$4c00f665f0d4b443(msg.fields[0], selection.CustomSeedPrices), selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 12:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, $7c6f80c5743180ba$export$4c00f665f0d4b443(msg.fields[0], selection.CustomSellPrices));
        default:
            return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)($7c6f80c5743180ba$var$select(msg.fields[0], selection.Crops), selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
    }
}
function $7c6f80c5743180ba$export$d9c350e4af54b3ec(msg, profit_1) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$c41588bc52e5d7c7)(profit_1.SeedStrategy, msg.fields[0], profit_1.PayForDestroyedFertilizer);
        case 2:
            return new (0, $3699f71d1df66484$export$c41588bc52e5d7c7)(profit_1.SeedStrategy, profit_1.PayForFertilizer, msg.fields[0]);
        default:
            return new (0, $3699f71d1df66484$export$c41588bc52e5d7c7)(msg.fields[0], profit_1.PayForFertilizer, profit_1.PayForDestroyedFertilizer);
    }
}
function $7c6f80c5743180ba$export$a5a6e0b888b2c992(data, msg, settings_1) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)(settings_1.Game, $7c6f80c5743180ba$export$d9c350e4af54b3ec(msg.fields[0], settings_1.Profit), settings_1.Selected);
        case 2:
            return new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)(settings_1.Game, settings_1.Profit, $7c6f80c5743180ba$export$4ea6092c933ebdb5(data, msg.fields[0], settings_1.Selected));
        default:
            return new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)($7c6f80c5743180ba$export$94ea62e65e90c61b(msg.fields[0], settings_1.Game), settings_1.Profit, settings_1.Selected);
    }
}
function $7c6f80c5743180ba$export$e3b4d2d5dfa7f4e1(msg, filters) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(filters.ItemNameSearch, msg.fields[0], filters.Seasons, filters.Regrows, filters.Giant, filters.Forage);
        case 2:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(filters.ItemNameSearch, filters.InSeason, msg.fields[0], filters.Regrows, filters.Giant, filters.Forage);
        case 3:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(filters.ItemNameSearch, filters.InSeason, filters.Seasons, msg.fields[0], filters.Giant, filters.Forage);
        case 4:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(filters.ItemNameSearch, filters.InSeason, filters.Seasons, filters.Regrows, msg.fields[0], filters.Forage);
        case 5:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(filters.ItemNameSearch, filters.InSeason, filters.Seasons, filters.Regrows, filters.Giant, msg.fields[0]);
        case 6:
            return 0, $3699f71d1df66484$export$f6bbffe374f1c8e1;
        default:
            return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(msg.fields[0], filters.InSeason, filters.Seasons, filters.Regrows, filters.Giant, filters.Forage);
    }
}
function $7c6f80c5743180ba$export$30c656b98663dc84(msg, state_1) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)(state_1.Filters, [
                msg.fields[0][0],
                msg.fields[0][1]
            ], state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 2:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)(state_1.Filters, state_1.CropSort, [
                msg.fields[0][0],
                msg.fields[0][1]
            ], state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 3:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)(state_1.Filters, state_1.CropSort, state_1.ProductSort, [
                msg.fields[0][0],
                msg.fields[0][1]
            ], state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 4:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)(state_1.Filters, state_1.CropSort, state_1.ProductSort, state_1.SeedSort, msg.fields[0], state_1.NormalizeProductPrices);
        case 5:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)(state_1.Filters, state_1.CropSort, state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, msg.fields[0]);
        default:
            return new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)($7c6f80c5743180ba$export$e3b4d2d5dfa7f4e1(msg.fields[0], state_1.Filters), state_1.CropSort, state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
    }
}
function $7c6f80c5743180ba$export$b7d6e7ed8e053682(msg, ranker_1) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(ranker_1.RankItem, msg.fields[0], ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 2:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(ranker_1.RankItem, ranker_1.RankMetric, msg.fields[0], ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 3:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, msg.fields[0], ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 4:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, [
                msg.fields[0],
                msg.fields[1]
            ], ranker_1.SelectedCropAndFertilizer);
        case 5:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, msg.fields[0]);
        default:
            return new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(msg.fields[0], ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
    }
}
function $7c6f80c5743180ba$export$7afd9c1079ecedf7(msg, presets_1) {
    let bind$0040;
    switch(msg.tag){
        case 1:
            return (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(new (0, $3699f71d1df66484$export$3463c369d5cc977f)(msg.fields[0], undefined, msg.fields[1]), presets_1);
        case 2:
            {
                const i_1 = msg.fields[0] | 0;
                return (0, $e08834e1786645d9$export$b6d8713d53419d4c)(i_1, (bind$0040 = (0, $e08834e1786645d9$export$7061c75fc5af8b7e)(i_1, presets_1), new (0, $3699f71d1df66484$export$3463c369d5cc977f)(msg.fields[1], bind$0040.UniqueId, bind$0040.Settings)), presets_1);
            }
        case 3:
            return (0, $e08834e1786645d9$export$aa72b1a59562dee2)(msg.fields[0], presets_1);
        default:
            {
                const preset = msg.fields[0];
                return (0, $0ef027050085b17b$export$8b3fd701061a25a6)((0, $e08834e1786645d9$export$8327ebbef2a0ba76)(preset, presets_1), (i)=>(0, $e08834e1786645d9$export$b6d8713d53419d4c)(i, preset, presets_1), (0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((uniqueId)=>(0, $e08834e1786645d9$export$5c13475397a61429)((preset_1)=>(0, $3699f71d1df66484$export$1f050c40b73d064f)(uniqueId, preset_1), presets_1), preset.UniqueId));
            }
    }
}
function $7c6f80c5743180ba$export$5525e5ba287fa6f5(msg, ui_1) {
    switch(msg.tag){
        case 1:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, $7c6f80c5743180ba$export$b7d6e7ed8e053682(msg.fields[0], ui_1.Ranker), ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 2:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, msg.fields[0], ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 3:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, msg.fields[0], ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 4:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, $7c6f80c5743180ba$var$setSelected(msg.fields[1], msg.fields[0], ui_1.OpenDetails), ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 5:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, $7c6f80c5743180ba$export$30c656b98663dc84(msg.fields[0], ui_1.CropTab), ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 6:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, [
                msg.fields[0][0],
                msg.fields[0][1]
            ], ui_1.FertilizerPriceSort);
        case 7:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, [
                msg.fields[0][0],
                msg.fields[0][1]
            ]);
        default:
            return new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(msg.fields[0], ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
    }
}
function $7c6f80c5743180ba$export$ca000e230c0caa3e(msg, data, oldSettings, oldUI) {
    switch(msg.tag){
        case 1:
            return [
                oldSettings,
                $7c6f80c5743180ba$export$5525e5ba287fa6f5(msg.fields[0], oldUI)
            ];
        case 2:
            return [
                msg.fields[0],
                oldUI
            ];
        default:
            return [
                $7c6f80c5743180ba$export$a5a6e0b888b2c992(data, msg.fields[0], oldSettings),
                oldUI
            ];
    }
}


function $d28ec4fb6293f25e$export$d347d69f75548a2f(mapping, option) {
    return (0, $0ef027050085b17b$export$8b3fd701061a25a6)((0, $kRS0m.defaultOf)(), mapping, option);
}
function $d28ec4fb6293f25e$export$4b9672654250d8bc(x) {
    return (0, $kRS0m.round)(x, 2);
}
function $d28ec4fb6293f25e$export$c24201f7fe3571d8(g) {
    return g.toString() + "g";
}
function $d28ec4fb6293f25e$export$5b67fc450104cf2e(gold_1) {
    return (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%.2fg"))(gold_1);
}
function $d28ec4fb6293f25e$export$6a471d06cdf866ce(xp_1) {
    return xp_1.toString() + "xp";
}
function $d28ec4fb6293f25e$export$10ee73951df888d5(xp_1) {
    return xp_1.toString() + "xp";
}
function $d28ec4fb6293f25e$export$626336c2cd4b14de(value) {
    const arg = value * 100;
    return (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%.0f%%"))(arg);
}
function $d28ec4fb6293f25e$export$2ae0f0836c569eb0(value) {
    const arg = value * 100;
    return (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%.2f%%"))(arg);
}
function $d28ec4fb6293f25e$export$1afd584f29b0f373(text) {
    return text.slice(0, 1).toLocaleUpperCase() + text.slice(1, text.length);
}
function $d28ec4fb6293f25e$export$cefb40c9962541b5(text) {
    return text + "s";
}
function $d28ec4fb6293f25e$export$1a5a2ebc3aaa9655(value, text) {
    if (value === 1) return text;
    else return $d28ec4fb6293f25e$export$cefb40c9962541b5(text);
}
function $d28ec4fb6293f25e$export$12bf26cb720cb002(timeout, f) {
    let last = undefined;
    return (value)=>{
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((handle)=>{
            window.clearInterval(handle);
        }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(last));
        last = window.setTimeout(()=>{
            f(value);
        }, timeout);
    };
}
function $d28ec4fb6293f25e$export$d6e5ca10785815df(event) {
    event.stopPropagation();
    event.preventDefault();
}
function $d28ec4fb6293f25e$export$cdbb71092bf28e30(array, index) {
    return (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(0, (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(array.length - 1, index));
}
function $d28ec4fb6293f25e$export$cb85b9e32fe5dbc3(seed, file) {
    return `img/Crops/${seed}/${file}.webp`;
}
function $d28ec4fb6293f25e$export$724d9d2af3d3f0c8(folder, file) {
    return `img/${folder}/${file}.webp`;
}
const $d28ec4fb6293f25e$export$e8d5d03e106a89 = (file)=>$d28ec4fb6293f25e$export$724d9d2af3d3f0c8("Fertilizers", file);
function $d28ec4fb6293f25e$export$afd779920dce460f(itemId) {
    return $d28ec4fb6293f25e$export$724d9d2af3d3f0c8("Items", itemId.toString());
}
const $d28ec4fb6293f25e$export$cf50e4bcf4357ed5 = (file)=>$d28ec4fb6293f25e$export$724d9d2af3d3f0c8("Processors", file);
const $d28ec4fb6293f25e$export$cfdd2cea81bbb65 = (file)=>$d28ec4fb6293f25e$export$724d9d2af3d3f0c8("Vendors", file);
function $d28ec4fb6293f25e$export$65829f8b026536c(seed, item, stage) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("img", {
        alt: `${item.Name} Stage ${stage}`,
        src: $d28ec4fb6293f25e$export$cb85b9e32fe5dbc3(seed, (0, $kRS0m.int32ToString)(stage))
    });
}
function $d28ec4fb6293f25e$export$fc0d6d6a98e4de00(seed, item) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("img", {
        alt: `${item.Name} Regrow Stage`,
        src: $d28ec4fb6293f25e$export$cb85b9e32fe5dbc3(seed, "Regrow")
    });
}
function $d28ec4fb6293f25e$var$Icon_fromClassNameAndAlt(name, altText) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("img", {
        className: name.toLocaleLowerCase(),
        alt: altText
    });
}
function $d28ec4fb6293f25e$var$Icon_fromClassName(name) {
    return $d28ec4fb6293f25e$var$Icon_fromClassNameAndAlt(name, "");
}
function $d28ec4fb6293f25e$var$Icon_messageWithChildren(name, children) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("span", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "icon-message"
        ],
        (elems = [
            $d28ec4fb6293f25e$var$Icon_fromClassName(name),
            /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                children: [
                    children
                ]
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $d28ec4fb6293f25e$export$9a7b8ed73dd9e407(children) {
    return $d28ec4fb6293f25e$var$Icon_messageWithChildren("warning", children);
}
function $d28ec4fb6293f25e$export$382c1e24b4db459f(children) {
    return $d28ec4fb6293f25e$var$Icon_messageWithChildren("error", children);
}
function $d28ec4fb6293f25e$var$Icon_message(name, text) {
    return $d28ec4fb6293f25e$var$Icon_messageWithChildren(name, text);
}
function $d28ec4fb6293f25e$export$a59f727245974ec4(text) {
    return $d28ec4fb6293f25e$var$Icon_message("warning", text);
}
function $d28ec4fb6293f25e$export$97fee0e1b1631f99(text) {
    return $d28ec4fb6293f25e$var$Icon_message("error", text);
}
function $d28ec4fb6293f25e$var$Icon_fromImageAndText(img, text) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("span", {
        className: "icon-text",
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray([
            img,
            text
        ])
    });
}
const $d28ec4fb6293f25e$var$Icon_fromClassAndName = (arg)=>{
    const img = $d28ec4fb6293f25e$var$Icon_fromClassName(arg);
    return (text)=>$d28ec4fb6293f25e$var$Icon_fromImageAndText(img, text);
};
function $d28ec4fb6293f25e$var$Icon_fromClassIsName(name) {
    return $d28ec4fb6293f25e$var$Icon_fromClassAndName(name)(name);
}
function $d28ec4fb6293f25e$var$Icon_fromPathAndAlt(path, altText) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("img", {
        className: "icon",
        src: path,
        alt: altText
    });
}
function $d28ec4fb6293f25e$var$Icon_fromPath(path) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndAlt(path, "");
}
const $d28ec4fb6293f25e$var$Icon_fromPathAndName = (arg)=>{
    const img = $d28ec4fb6293f25e$var$Icon_fromPath(arg);
    return (text)=>$d28ec4fb6293f25e$var$Icon_fromImageAndText(img, text);
};
const $d28ec4fb6293f25e$export$931c4b7e95b3cb50 = (arg)=>$d28ec4fb6293f25e$var$Icon_fromClassIsName((0, $e189d4fb2d038fab$export$17d0dbcd198f4e3f)(arg));
function $d28ec4fb6293f25e$export$da2e6f014faedd47(profession) {
    return $d28ec4fb6293f25e$var$Icon_fromClassIsName((0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(profession));
}
const $d28ec4fb6293f25e$export$14bb04b6b2668a74 = $d28ec4fb6293f25e$var$Icon_fromClassIsName("Farming");
const $d28ec4fb6293f25e$export$c3e6c39ff0428361 = $d28ec4fb6293f25e$var$Icon_fromClassIsName("Foraging");
const $d28ec4fb6293f25e$export$80f83a8db8a2647f = $d28ec4fb6293f25e$var$Icon_fromClassAndName("bears-knowledge")("Bear\'s Knowledge");
const $d28ec4fb6293f25e$export$eae2c00988c0b6ae = $d28ec4fb6293f25e$var$Icon_fromClassAndName("special-charm")("Special Charm");
const $d28ec4fb6293f25e$export$d6b50c1760f9d6d = $d28ec4fb6293f25e$var$Icon_fromClassAndName("random")("Luck Buff");
function $d28ec4fb6293f25e$export$cf2a4a102a3813db(item) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndName($d28ec4fb6293f25e$export$afd779920dce460f(item.Id))(item.Name);
}
function $d28ec4fb6293f25e$export$be70ef43515665ec(data, itemId) {
    return $d28ec4fb6293f25e$export$cf2a4a102a3813db((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], itemId));
}
function $d28ec4fb6293f25e$export$7a33edf1c72aa43a(data, seed) {
    return $d28ec4fb6293f25e$export$be70ef43515665ec(data, seed * 1);
}
function $d28ec4fb6293f25e$var$Icon_withQuality(quality, name, img) {
    let elems;
    const qualityName = (0, $7bbf2c7402328604$export$125e96caa9d3db22)(quality);
    return $d28ec4fb6293f25e$var$Icon_fromImageAndText(/*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "quality"
        ],
        (elems = [
            img,
            $d28ec4fb6293f25e$var$Icon_fromClassNameAndAlt(qualityName, quality === 0 ? "" : `${qualityName} quality`)
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ]))), name);
}
function $d28ec4fb6293f25e$export$879da5e7d24182f3(item, quality) {
    return $d28ec4fb6293f25e$var$Icon_withQuality(quality, item.Name, $d28ec4fb6293f25e$var$Icon_fromPath($d28ec4fb6293f25e$export$afd779920dce460f(item.Id)));
}
function $d28ec4fb6293f25e$export$45ec8428b410e378(data, item, quality) {
    return $d28ec4fb6293f25e$export$879da5e7d24182f3((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item), quality);
}
function $d28ec4fb6293f25e$export$66a32dfdff138951(data, product, quality) {
    let matchResult, item;
    switch(product.tag){
        case 4:
            matchResult = 0;
            item = product.fields[0];
            break;
        case 5:
            matchResult = 0;
            item = product.fields[0].Item;
            break;
        default:
            matchResult = 1;
    }
    switch(matchResult){
        case 0:
            return $d28ec4fb6293f25e$export$45ec8428b410e378(data, item, quality);
        default:
            {
                const product_1 = product;
                const img = $d28ec4fb6293f25e$var$Icon_fromClassName((0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(product_1));
                return $d28ec4fb6293f25e$var$Icon_withQuality(quality, (0, $cdb0798a49937e52$export$e6b3143d100519a1)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), product_1), img);
            }
    }
}
function $d28ec4fb6293f25e$export$7feb6616db82ddb7(name) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndName($d28ec4fb6293f25e$export$e8d5d03e106a89(name))(name);
}
function $d28ec4fb6293f25e$export$e9f5ed6a6e06383b(fertilizer) {
    return $d28ec4fb6293f25e$export$7feb6616db82ddb7(fertilizer.Name);
}
function $d28ec4fb6293f25e$export$b425e1f3273281be(data, _arg) {
    if (_arg.tag === 1) return $d28ec4fb6293f25e$export$7a33edf1c72aa43a(data, _arg.fields[0].Seed);
    else return $d28ec4fb6293f25e$export$be70ef43515665ec(data, _arg.fields[0].Item);
}
function $d28ec4fb6293f25e$export$f99d6a82f56d73ea(name) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndName($d28ec4fb6293f25e$export$cfdd2cea81bbb65(name))(name);
}
function $d28ec4fb6293f25e$export$3a0f02ca583081c4(processor) {
    return $d28ec4fb6293f25e$var$Icon_fromImageAndText(/*#__PURE__*/ (0, $hURbM.createElement)("img", {
        className: "icon-processor",
        src: $d28ec4fb6293f25e$export$cf50e4bcf4357ed5(processor),
        alt: ""
    }), processor);
}
function $d28ec4fb6293f25e$export$53a8d1230ff4fe8f(season) {
    const name = (0, $e189d4fb2d038fab$export$17d0dbcd198f4e3f)(season);
    return $d28ec4fb6293f25e$var$Icon_fromClassNameAndAlt(name, name);
}
function $d28ec4fb6293f25e$export$665b4d28ae288326(item) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndAlt($d28ec4fb6293f25e$export$afd779920dce460f(item.Id), item.Name);
}
function $d28ec4fb6293f25e$export$be33bccc3dd6214(data, itemId) {
    return $d28ec4fb6293f25e$export$665b4d28ae288326((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], itemId));
}
function $d28ec4fb6293f25e$export$e9e0c573c240ebb3(name) {
    return $d28ec4fb6293f25e$var$Icon_fromPathAndAlt($d28ec4fb6293f25e$export$cfdd2cea81bbb65(name), name);
}
function $d28ec4fb6293f25e$export$4e8c53e206dfbfdb(processor) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("img", {
        className: "icon-processor",
        src: $d28ec4fb6293f25e$export$cf50e4bcf4357ed5(processor),
        alt: processor
    });
}
function $d28ec4fb6293f25e$export$de51857dc0ef8573(css, label, element) {
    const children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
            className: css,
            children: label
        }),
        element
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("label", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
function $d28ec4fb6293f25e$export$51c3c710ff66e3c3(className, text, element) {
    return $d28ec4fb6293f25e$export$de51857dc0ef8573(className, text, element);
}
function $d28ec4fb6293f25e$export$645889107ac6ca1b(label, element) {
    return $d28ec4fb6293f25e$export$51c3c710ff66e3c3("label-text", label, element);
}
function $d28ec4fb6293f25e$export$de3f5e0fbb46ff22(label, element) {
    return $d28ec4fb6293f25e$export$51c3c710ff66e3c3("label-hidden", label, element);
}
class $d28ec4fb6293f25e$var$LazyHidden_LazyHiddenProps extends (0, $eATN7.Record) {
    constructor(Render, Visible){
        super();
        this.Render = Render;
        this.Visible = Visible;
    }
}
function $d28ec4fb6293f25e$var$LazyHidden_LazyHiddenProps_$reflection() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.View.Prelude.LazyHidden.LazyHiddenProps", [], $d28ec4fb6293f25e$var$LazyHidden_LazyHiddenProps, ()=>[
            [
                "Render",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$ffcad4a7b72710d8), (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.ReactElement", undefined))
            ],
            [
                "Visible",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
class $d28ec4fb6293f25e$var$LazyHidden_LazyHidden extends (0, $hURbM.Component) {
    constructor(props){
        super(props);
        this.rendered = false;
    }
    shouldComponentUpdate(next, _arg) {
        return next.Visible;
    }
    render() {
        const this$ = this;
        this$.rendered = this$.rendered ? true : this$.props.Visible;
        return this$.rendered ? this$.props.Render() : (0, $kRS0m.defaultOf)();
    }
}
function $d28ec4fb6293f25e$var$LazyHidden_LazyHidden_$reflection() {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("StardewValleyStonks.WebApp.View.Prelude.LazyHidden.LazyHidden", undefined, $d28ec4fb6293f25e$var$LazyHidden_LazyHidden, (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.Component`2", [
        $d28ec4fb6293f25e$var$LazyHidden_LazyHiddenProps_$reflection(),
        (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
    ], (0, $hURbM.Component)));
}
function $d28ec4fb6293f25e$var$LazyHidden_LazyHidden_$ctor_45BC3791(props) {
    return new $d28ec4fb6293f25e$var$LazyHidden_LazyHidden(props);
}
function $d28ec4fb6293f25e$var$LazyHidden_view(visible, render) {
    const props = new $d28ec4fb6293f25e$var$LazyHidden_LazyHiddenProps(render, visible);
    return /*#__PURE__*/ $hURbM.createElement($d28ec4fb6293f25e$var$LazyHidden_LazyHidden, props);
}
function $d28ec4fb6293f25e$var$tabId(label, tab) {
    let str_1;
    return `${label.toLocaleLowerCase()}-tab-${str_1 = (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(tab), str_1.toLocaleLowerCase()}`;
}
function $d28ec4fb6293f25e$export$b2539bed5023c21c(props) {
    let elems, elems_1;
    const tabs = props.Tabs;
    const current = props.Current;
    const dispatch = props.Dispatch;
    const label = props.Label;
    let tabRefs;
    const initialValue = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(tabs.length), 0, tabs.length, undefined);
    tabRefs = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(initialValue);
    const xs_4 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "role",
                (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                    "tablist"
                ])
            ],
            [
                "aria-label",
                `${label} Tabs`
            ],
            (elems = (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, tab)=>{
                let array;
                const active = (0, $kRS0m.equals)(current, tab);
                return /*#__PURE__*/ (0, $hURbM.createElement)("button", {
                    role: (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                        "tab"
                    ]),
                    id: $d28ec4fb6293f25e$var$tabId(label, tab),
                    ref: (array = tabRefs.current, (value_6)=>{
                        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(array, i, value_6);
                    }),
                    "aria-selected": active,
                    tabIndex: active ? 0 : -1,
                    onClick: (_arg)=>{
                        dispatch(tab);
                    },
                    onKeyDown: (e)=>{
                        let matchValue;
                        (0, $42cbcefff7323768$export$c1a059043cc9c119)((i_1)=>{
                            (0, $42cbcefff7323768$export$c1a059043cc9c119)((elm)=>{
                                elm.focus();
                            }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, tabRefs.current)));
                            dispatch((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, tabs));
                        }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((matchValue = e.key, matchValue === "ArrowRight" ? i === tabs.length - 1 ? 0 : i + 1 : matchValue === "ArrowLeft" ? i === 0 ? tabs.length - 1 : i - 1 : undefined)));
                    },
                    children: (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(tab)
                });
            }, tabs), [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ]))),
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "role",
                (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                    "tabpanel"
                ])
            ],
            [
                "aria-labelledby",
                (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                    $d28ec4fb6293f25e$var$tabId(label, current)
                ])
            ],
            (elems_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tab_1)=>{
                const active_1 = (0, $kRS0m.equals)(tab_1, current);
                return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                    let str_1;
                    return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "id",
                        `${label.toLocaleLowerCase()}-${(str_1 = (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(tab_1), str_1.toLocaleLowerCase())}`
                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(active_1 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "className",
                            "active"
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "children",
                                $d28ec4fb6293f25e$var$LazyHidden_view(active_1, ()=>props.Panel(tab_1))
                            ])))));
                }))));
            }, tabs), [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_1))
            ])
        ])))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_4);
}
function $d28ec4fb6293f25e$var$detailsSectionWith(openDetails, key, summaryContent, children, dispatch) {
    let str, elems;
    const open$0027 = (0, $70b963136d0d9ffe$export$2344b14b097df817)(key, openDetails);
    const id = `${(str = (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(key), str.toLocaleLowerCase())}-details`;
    return /*#__PURE__*/ (0, $hURbM.createElement)("details", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "open",
            open$0027
        ],
        [
            "onToggle",
            (e)=>{
                let tupledArg;
                dispatch((tupledArg = [
                    key,
                    e.target.open
                ], new (0, $7c6f80c5743180ba$export$78428c3f899407d)(4, [
                    tupledArg[0],
                    tupledArg[1]
                ])));
            }
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("summary", {
                children: [
                    summaryContent
                ]
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                id: id,
                children: children
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $d28ec4fb6293f25e$export$c46d4dde2384c4e1(openDetails, key, summary, children, dispatch) {
    return $d28ec4fb6293f25e$var$detailsSectionWith(openDetails, key, summary, children, dispatch);
}
function $d28ec4fb6293f25e$export$58335bbff18cfa1d(openDetails, key, summary, children, dispatch) {
    return $d28ec4fb6293f25e$var$detailsSectionWith(openDetails, key, summary, $d28ec4fb6293f25e$var$LazyHidden_view((0, $70b963136d0d9ffe$export$2344b14b097df817)(key, openDetails), children), dispatch);
}


var $2b9cc1991658e590$exports = {};
$2b9cc1991658e590$exports = JSON.parse("{\"Items\":[{\"Id\":16,\"Name\":\"Wild Horseradish\",\"SellPrice\":50,\"Category\":\"Forage\"},{\"Id\":18,\"Name\":\"Daffodil\",\"SellPrice\":30,\"Category\":\"Forage\"},{\"Id\":20,\"Name\":\"Leek\",\"SellPrice\":60,\"Category\":\"Forage\"},{\"Id\":22,\"Name\":\"Dandelion\",\"SellPrice\":40,\"Category\":\"Forage\"},{\"Id\":24,\"Name\":\"Parsnip\",\"SellPrice\":35,\"Category\":\"Vegetable\"},{\"Id\":90,\"Name\":\"Cactus Fruit\",\"SellPrice\":75,\"Category\":\"Fruit\"},{\"Id\":178,\"Name\":\"Hay\",\"SellPrice\":0,\"Category\":\"Other\"},{\"Id\":188,\"Name\":\"Green Bean\",\"SellPrice\":40,\"Category\":\"Vegetable\"},{\"Id\":190,\"Name\":\"Cauliflower\",\"SellPrice\":175,\"Category\":\"Vegetable\"},{\"Id\":192,\"Name\":\"Potato\",\"SellPrice\":80,\"Category\":\"Vegetable\"},{\"Id\":245,\"Name\":\"Sugar\",\"SellPrice\":50,\"Category\":\"Other\"},{\"Id\":246,\"Name\":\"Wheat Flour\",\"SellPrice\":50,\"Category\":\"Other\"},{\"Id\":247,\"Name\":\"Oil\",\"SellPrice\":100,\"Category\":\"Other\"},{\"Id\":248,\"Name\":\"Garlic\",\"SellPrice\":60,\"Category\":\"Vegetable\"},{\"Id\":250,\"Name\":\"Kale\",\"SellPrice\":110,\"Category\":\"Vegetable\"},{\"Id\":252,\"Name\":\"Rhubarb\",\"SellPrice\":220,\"Category\":\"Fruit\"},{\"Id\":254,\"Name\":\"Melon\",\"SellPrice\":250,\"Category\":\"Fruit\"},{\"Id\":256,\"Name\":\"Tomato\",\"SellPrice\":60,\"Category\":\"Vegetable\"},{\"Id\":258,\"Name\":\"Blueberry\",\"SellPrice\":50,\"Category\":\"Fruit\"},{\"Id\":260,\"Name\":\"Hot Pepper\",\"SellPrice\":40,\"Category\":\"Fruit\"},{\"Id\":262,\"Name\":\"Wheat\",\"SellPrice\":25,\"Category\":\"Vegetable\"},{\"Id\":264,\"Name\":\"Radish\",\"SellPrice\":90,\"Category\":\"Vegetable\"},{\"Id\":266,\"Name\":\"Red Cabbage\",\"SellPrice\":260,\"Category\":\"Vegetable\"},{\"Id\":268,\"Name\":\"Starfruit\",\"SellPrice\":750,\"Category\":\"Fruit\"},{\"Id\":270,\"Name\":\"Corn\",\"SellPrice\":50,\"Category\":\"Vegetable\"},{\"Id\":271,\"Name\":\"Unmilled Rice\",\"SellPrice\":30,\"Category\":\"Vegetable\"},{\"Id\":272,\"Name\":\"Eggplant\",\"SellPrice\":60,\"Category\":\"Vegetable\"},{\"Id\":273,\"Name\":\"Rice Shoot\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":274,\"Name\":\"Artichoke\",\"SellPrice\":160,\"Category\":\"Vegetable\"},{\"Id\":276,\"Name\":\"Pumpkin\",\"SellPrice\":320,\"Category\":\"Vegetable\"},{\"Id\":278,\"Name\":\"Bok Choy\",\"SellPrice\":80,\"Category\":\"Vegetable\"},{\"Id\":280,\"Name\":\"Yam\",\"SellPrice\":160,\"Category\":\"Vegetable\"},{\"Id\":282,\"Name\":\"Cranberries\",\"SellPrice\":75,\"Category\":\"Fruit\"},{\"Id\":284,\"Name\":\"Beet\",\"SellPrice\":100,\"Category\":\"Vegetable\"},{\"Id\":299,\"Name\":\"Amaranth Seeds\",\"SellPrice\":35,\"Category\":\"Seeds\"},{\"Id\":300,\"Name\":\"Amaranth\",\"SellPrice\":150,\"Category\":\"Vegetable\"},{\"Id\":301,\"Name\":\"Grape Starter\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":302,\"Name\":\"Hops Starter\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":303,\"Name\":\"Pale Ale\",\"SellPrice\":300,\"Category\":\"ArtisanGood\"},{\"Id\":304,\"Name\":\"Hops\",\"SellPrice\":25,\"Category\":\"Vegetable\"},{\"Id\":346,\"Name\":\"Beer\",\"SellPrice\":200,\"Category\":\"ArtisanGood\"},{\"Id\":347,\"Name\":\"Rare Seed\",\"SellPrice\":200,\"Category\":\"Seeds\"},{\"Id\":376,\"Name\":\"Poppy\",\"SellPrice\":140,\"Category\":\"Flower\"},{\"Id\":395,\"Name\":\"Coffee\",\"SellPrice\":150,\"Category\":\"Other\"},{\"Id\":396,\"Name\":\"Spice Berry\",\"SellPrice\":80,\"Category\":\"Fruit\"},{\"Id\":398,\"Name\":\"Grape\",\"SellPrice\":80,\"Category\":\"Fruit\"},{\"Id\":400,\"Name\":\"Strawberry\",\"SellPrice\":120,\"Category\":\"Fruit\"},{\"Id\":402,\"Name\":\"Sweet Pea\",\"SellPrice\":50,\"Category\":\"Flower\"},{\"Id\":404,\"Name\":\"Common Mushroom\",\"SellPrice\":40,\"Category\":\"Forage\"},{\"Id\":406,\"Name\":\"Wild Plum\",\"SellPrice\":80,\"Category\":\"Fruit\"},{\"Id\":408,\"Name\":\"Hazelnut\",\"SellPrice\":90,\"Category\":\"Forage\"},{\"Id\":410,\"Name\":\"Blackberry\",\"SellPrice\":20,\"Category\":\"Fruit\"},{\"Id\":412,\"Name\":\"Winter Root\",\"SellPrice\":70,\"Category\":\"Forage\"},{\"Id\":414,\"Name\":\"Crystal Fruit\",\"SellPrice\":150,\"Category\":\"Fruit\"},{\"Id\":416,\"Name\":\"Snow Yam\",\"SellPrice\":100,\"Category\":\"Forage\"},{\"Id\":417,\"Name\":\"Sweet Gem Berry\",\"SellPrice\":3000,\"Category\":\"Other\"},{\"Id\":418,\"Name\":\"Crocus\",\"SellPrice\":60,\"Category\":\"Flower\"},{\"Id\":421,\"Name\":\"Sunflower\",\"SellPrice\":80,\"Category\":\"Flower\"},{\"Id\":423,\"Name\":\"Rice\",\"SellPrice\":100,\"Category\":\"Other\"},{\"Id\":425,\"Name\":\"Fairy Seeds\",\"SellPrice\":100,\"Category\":\"Seeds\"},{\"Id\":427,\"Name\":\"Tulip Bulb\",\"SellPrice\":10,\"Category\":\"Seeds\"},{\"Id\":429,\"Name\":\"Jazz Seeds\",\"SellPrice\":15,\"Category\":\"Seeds\"},{\"Id\":431,\"Name\":\"Sunflower Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":433,\"Name\":\"Coffee Bean\",\"SellPrice\":15,\"Category\":\"Seeds\"},{\"Id\":453,\"Name\":\"Poppy Seeds\",\"SellPrice\":50,\"Category\":\"Seeds\"},{\"Id\":454,\"Name\":\"Ancient Fruit\",\"SellPrice\":550,\"Category\":\"Fruit\"},{\"Id\":455,\"Name\":\"Spangle Seeds\",\"SellPrice\":25,\"Category\":\"Seeds\"},{\"Id\":472,\"Name\":\"Parsnip Seeds\",\"SellPrice\":10,\"Category\":\"Seeds\"},{\"Id\":473,\"Name\":\"Bean Starter\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":474,\"Name\":\"Cauliflower Seeds\",\"SellPrice\":40,\"Category\":\"Seeds\"},{\"Id\":475,\"Name\":\"Potato Seeds\",\"SellPrice\":25,\"Category\":\"Seeds\"},{\"Id\":476,\"Name\":\"Garlic Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":477,\"Name\":\"Kale Seeds\",\"SellPrice\":35,\"Category\":\"Seeds\"},{\"Id\":478,\"Name\":\"Rhubarb Seeds\",\"SellPrice\":50,\"Category\":\"Seeds\"},{\"Id\":479,\"Name\":\"Melon Seeds\",\"SellPrice\":40,\"Category\":\"Seeds\"},{\"Id\":480,\"Name\":\"Tomato Seeds\",\"SellPrice\":25,\"Category\":\"Seeds\"},{\"Id\":481,\"Name\":\"Blueberry Seeds\",\"SellPrice\":40,\"Category\":\"Seeds\"},{\"Id\":482,\"Name\":\"Pepper Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":483,\"Name\":\"Wheat Seeds\",\"SellPrice\":5,\"Category\":\"Seeds\"},{\"Id\":484,\"Name\":\"Radish Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":485,\"Name\":\"Red Cabbage Seeds\",\"SellPrice\":50,\"Category\":\"Seeds\"},{\"Id\":486,\"Name\":\"Starfruit Seeds\",\"SellPrice\":200,\"Category\":\"Seeds\"},{\"Id\":487,\"Name\":\"Corn Seeds\",\"SellPrice\":75,\"Category\":\"Seeds\"},{\"Id\":488,\"Name\":\"Eggplant Seeds\",\"SellPrice\":10,\"Category\":\"Seeds\"},{\"Id\":489,\"Name\":\"Artichoke Seeds\",\"SellPrice\":15,\"Category\":\"Seeds\"},{\"Id\":490,\"Name\":\"Pumpkin Seeds\",\"SellPrice\":50,\"Category\":\"Seeds\"},{\"Id\":491,\"Name\":\"Bok Choy Seeds\",\"SellPrice\":25,\"Category\":\"Seeds\"},{\"Id\":492,\"Name\":\"Yam Seeds\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":493,\"Name\":\"Cranberry Seeds\",\"SellPrice\":60,\"Category\":\"Seeds\"},{\"Id\":494,\"Name\":\"Beet Seeds\",\"SellPrice\":10,\"Category\":\"Seeds\"},{\"Id\":495,\"Name\":\"Spring Seeds\",\"SellPrice\":35,\"Category\":\"Seeds\"},{\"Id\":496,\"Name\":\"Summer Seeds\",\"SellPrice\":55,\"Category\":\"Seeds\"},{\"Id\":497,\"Name\":\"Fall Seeds\",\"SellPrice\":45,\"Category\":\"Seeds\"},{\"Id\":498,\"Name\":\"Winter Seeds\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":499,\"Name\":\"Ancient Seeds\",\"SellPrice\":30,\"Category\":\"Seeds\"},{\"Id\":591,\"Name\":\"Tulip\",\"SellPrice\":30,\"Category\":\"Flower\"},{\"Id\":593,\"Name\":\"Summer Spangle\",\"SellPrice\":90,\"Category\":\"Flower\"},{\"Id\":595,\"Name\":\"Fairy Rose\",\"SellPrice\":290,\"Category\":\"Flower\"},{\"Id\":597,\"Name\":\"Blue Jazz\",\"SellPrice\":50,\"Category\":\"Flower\"},{\"Id\":745,\"Name\":\"Strawberry Seeds\",\"SellPrice\":0,\"Category\":\"Seeds\"},{\"Id\":770,\"Name\":\"Mixed Seeds\",\"SellPrice\":0,\"Category\":\"Seeds\"},{\"Id\":771,\"Name\":\"Fiber\",\"SellPrice\":1,\"Category\":\"Other\"},{\"Id\":802,\"Name\":\"Cactus Seeds\",\"SellPrice\":0,\"Category\":\"Seeds\"},{\"Id\":830,\"Name\":\"Taro Root\",\"SellPrice\":100,\"Category\":\"Vegetable\"},{\"Id\":831,\"Name\":\"Taro Tuber\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":832,\"Name\":\"Pineapple\",\"SellPrice\":300,\"Category\":\"Fruit\"},{\"Id\":833,\"Name\":\"Pineapple Seeds\",\"SellPrice\":240,\"Category\":\"Seeds\"},{\"Id\":885,\"Name\":\"Fiber Seeds\",\"SellPrice\":5,\"Category\":\"Seeds\"},{\"Id\":4000,\"Name\":\"Carrot Seeds\",\"SellPrice\":15,\"Category\":\"Seeds\"},{\"Id\":4001,\"Name\":\"Carrot\",\"SellPrice\":35,\"Category\":\"Vegetable\"},{\"Id\":4002,\"Name\":\"Summer Squash Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":4003,\"Name\":\"Summer Squash\",\"SellPrice\":45,\"Category\":\"Vegetable\"},{\"Id\":4004,\"Name\":\"Broccoli Seeds\",\"SellPrice\":40,\"Category\":\"Seeds\"},{\"Id\":4005,\"Name\":\"Broccoli\",\"SellPrice\":70,\"Category\":\"Vegetable\"},{\"Id\":4006,\"Name\":\"Powdermelon Seeds\",\"SellPrice\":20,\"Category\":\"Seeds\"},{\"Id\":4007,\"Name\":\"Powdermelon\",\"SellPrice\":60,\"Category\":\"Fruit\"}],\"Products\":{\"262\":[{\"Item\":346,\"Processor\":\"Keg\"},{\"Item\":246,\"Processor\":\"Mill\"}],\"270\":[{\"Item\":247,\"Processor\":\"Oil Maker\"}],\"271\":[{\"Item\":423,\"Processor\":\"Mill\"}],\"284\":[{\"Item\":245,\"Processor\":\"Mill\",\"Ratio\":[1,3]}],\"304\":[{\"Item\":303,\"Processor\":\"Keg\"}],\"421\":[{\"Item\":247,\"Processor\":\"Oil Maker\"}],\"431\":[{\"Item\":247,\"Processor\":\"Oil Maker\"}],\"433\":[{\"Item\":395,\"Processor\":\"Keg\",\"Ratio\":[5,1]}]},\"FarmCrops\":[{\"Seed\":273,\"Item\":271,\"Amount\":{\"ExtraCropChance\":0.1,\"CanDouble\":false,\"FarmLevelsPerYieldIncrease\":10},\"Seasons\":[\"Spring\"],\"Stages\":[1,2,2,3],\"Paddy\":true},{\"Seed\":299,\"Item\":300,\"Amount\":{\"CanDouble\":false},\"Seasons\":[\"Fall\"],\"Stages\":[1,2,2,2]},{\"Seed\":301,\"Item\":398,\"Seasons\":[\"Fall\"],\"Stages\":[1,1,2,3,3],\"RegrowTime\":3},{\"Seed\":302,\"Item\":304,\"Seasons\":[\"Summer\"],\"Stages\":[1,1,2,3,4],\"RegrowTime\":1},{\"Seed\":347,\"Item\":417,\"Seasons\":[\"Fall\"],\"Stages\":[2,4,6,6,6]},{\"Seed\":425,\"Item\":595,\"Seasons\":[\"Fall\"],\"Stages\":[1,4,4,3]},{\"Seed\":427,\"Item\":591,\"Seasons\":[\"Spring\"],\"Stages\":[1,1,2,2]},{\"Seed\":429,\"Item\":597,\"Seasons\":[\"Spring\"],\"Stages\":[1,2,2,2]},{\"Seed\":431,\"Item\":421,\"Amount\":{\"CanDouble\":false},\"ExtraItem\":[431,1],\"Seasons\":[\"Summer\",\"Fall\"],\"Stages\":[1,2,3,2]},{\"Seed\":433,\"Item\":433,\"Amount\":{\"MinCropYield\":4,\"MaxCropYield\":4,\"ExtraCropChance\":0.02},\"Seasons\":[\"Spring\",\"Summer\"],\"Stages\":[1,2,2,3,2],\"RegrowTime\":2},{\"Seed\":453,\"Item\":376,\"Seasons\":[\"Summer\"],\"Stages\":[1,2,2,2]},{\"Seed\":455,\"Item\":593,\"Seasons\":[\"Summer\"],\"Stages\":[1,2,3,2]},{\"Seed\":472,\"Item\":24,\"Seasons\":[\"Spring\"],\"Stages\":[1,1,1,1]},{\"Seed\":473,\"Item\":188,\"Seasons\":[\"Spring\"],\"Stages\":[1,1,1,3,4],\"RegrowTime\":3},{\"Seed\":474,\"Item\":190,\"Giant\":true,\"Seasons\":[\"Spring\"],\"Stages\":[1,2,4,4,1]},{\"Seed\":475,\"Item\":192,\"Amount\":{\"ExtraCropChance\":0.2},\"Seasons\":[\"Spring\"],\"Stages\":[1,1,1,2,1]},{\"Seed\":476,\"Item\":248,\"Seasons\":[\"Spring\"],\"Stages\":[1,1,1,1]},{\"Seed\":477,\"Item\":250,\"Amount\":{\"CanDouble\":false},\"Seasons\":[\"Spring\"],\"Stages\":[1,2,2,1]},{\"Seed\":478,\"Item\":252,\"Seasons\":[\"Spring\"],\"Stages\":[2,2,2,3,4]},{\"Seed\":479,\"Item\":254,\"Giant\":true,\"Seasons\":[\"Summer\"],\"Stages\":[1,2,3,3,3]},{\"Seed\":480,\"Item\":256,\"Amount\":{\"ExtraCropChance\":0.05},\"Seasons\":[\"Summer\"],\"Stages\":[2,2,2,2,3],\"RegrowTime\":4},{\"Seed\":481,\"Item\":258,\"Amount\":{\"MinCropYield\":3,\"MaxCropYield\":3,\"ExtraCropChance\":0.02},\"Seasons\":[\"Summer\"],\"Stages\":[1,3,3,4,2],\"RegrowTime\":4},{\"Seed\":482,\"Item\":260,\"Amount\":{\"ExtraCropChance\":0.03},\"Seasons\":[\"Summer\"],\"Stages\":[1,1,1,1,1],\"RegrowTime\":3},{\"Seed\":483,\"Item\":262,\"Amount\":{\"CanDouble\":false},\"ExtraItem\":[178,0.4],\"Seasons\":[\"Summer\",\"Fall\"],\"Stages\":[1,1,1,1]},{\"Seed\":484,\"Item\":264,\"Seasons\":[\"Summer\"],\"Stages\":[2,1,2,1]},{\"Seed\":485,\"Item\":266,\"Seasons\":[\"Summer\"],\"Stages\":[2,1,2,2,2]},{\"Seed\":486,\"Item\":268,\"Seasons\":[\"Summer\"],\"Stages\":[2,3,2,3,3]},{\"Seed\":487,\"Item\":270,\"Seasons\":[\"Summer\",\"Fall\"],\"Stages\":[2,3,3,3,3],\"RegrowTime\":4},{\"Seed\":488,\"Item\":272,\"Amount\":{\"ExtraCropChance\":0.002},\"Seasons\":[\"Fall\"],\"Stages\":[1,1,1,1,1],\"RegrowTime\":5},{\"Seed\":489,\"Item\":274,\"Seasons\":[\"Fall\"],\"Stages\":[2,2,1,2,1]},{\"Seed\":490,\"Item\":276,\"Giant\":true,\"Seasons\":[\"Fall\"],\"Stages\":[1,2,3,4,3]},{\"Seed\":491,\"Item\":278,\"Seasons\":[\"Fall\"],\"Stages\":[1,1,1,1]},{\"Seed\":492,\"Item\":280,\"Seasons\":[\"Fall\"],\"Stages\":[1,3,3,3]},{\"Seed\":493,\"Item\":282,\"Amount\":{\"MinCropYield\":2,\"MaxCropYield\":2,\"ExtraCropChance\":0.1},\"Seasons\":[\"Fall\"],\"Stages\":[1,2,1,1,2],\"RegrowTime\":5},{\"Seed\":494,\"Item\":284,\"Seasons\":[\"Fall\"],\"Stages\":[1,1,2,2]},{\"Seed\":499,\"Item\":454,\"Seasons\":[\"Spring\",\"Summer\",\"Fall\"],\"Stages\":[2,7,7,7,5],\"RegrowTime\":7},{\"Seed\":745,\"Item\":400,\"Amount\":{\"ExtraCropChance\":0.02},\"Seasons\":[\"Spring\"],\"Stages\":[1,1,2,2,2],\"RegrowTime\":4},{\"Seed\":802,\"Item\":90,\"Seasons\":[],\"Stages\":[2,2,2,3,3],\"RegrowTime\":3},{\"Seed\":831,\"Item\":830,\"Seasons\":[\"Summer\"],\"Stages\":[1,2,3,4],\"Paddy\":true},{\"Seed\":833,\"Item\":832,\"Seasons\":[\"Summer\"],\"Stages\":[1,3,3,4,3],\"RegrowTime\":7},{\"Seed\":885,\"Item\":771,\"Amount\":{\"MinCropYield\":4,\"MaxCropYield\":7,\"ExtraCropChance\":0.01,\"CanDouble\":false,\"FarmingQualities\":false},\"ExtraItem\":[770,0.1],\"Seasons\":[\"Spring\",\"Summer\",\"Fall\",\"Winter\"],\"Stages\":[1,2,2,2]},{\"Seed\":4000,\"Item\":4001,\"Seasons\":[\"Spring\"],\"Stages\":[1,1,1]},{\"Seed\":4002,\"Item\":4003,\"Seasons\":[\"Summer\"],\"Stages\":[1,1,1,1,2],\"RegrowTime\":3},{\"Seed\":4004,\"Item\":4005,\"Seasons\":[\"Fall\"],\"Stages\":[1,2,2,3],\"RegrowTime\":4},{\"Seed\":4006,\"Item\":4007,\"Giant\":true,\"Seasons\":[\"Winter\"],\"Stages\":[1,1,1,2,2]}],\"ForageCrops\":[{\"Seed\":495,\"Foragables\":[16,18,20,22],\"SeedRecipeUnlockLevel\":1,\"Season\":\"Spring\",\"Stages\":[3,4]},{\"Seed\":496,\"Foragables\":[396,398,402],\"SeedRecipeUnlockLevel\":4,\"Season\":\"Summer\",\"Stages\":[3,4]},{\"Seed\":497,\"Foragables\":[404,406,408,410],\"SeedRecipeUnlockLevel\":6,\"Season\":\"Fall\",\"Stages\":[3,4]},{\"Seed\":498,\"Foragables\":[412,414,416,418],\"SeedRecipeUnlockLevel\":7,\"Season\":\"Winter\",\"Stages\":[3,4]}]}");


var $4af8c52d8621581e$exports = {};
$4af8c52d8621581e$exports = JSON.parse("{\"Fertilizers\":[{\"Name\":\"Basic Fertilizer\",\"Quality\":1},{\"Name\":\"Quality Fertilizer\",\"Quality\":2},{\"Name\":\"Deluxe Fertilizer\",\"Quality\":3},{\"Name\":\"Speed-Gro\",\"Speed\":0.1},{\"Name\":\"Deluxe Speed-Gro\",\"Speed\":0.25},{\"Name\":\"Hyper Speed-Gro\",\"Speed\":0.33}],\"FertilizerPrices\":{\"Basic Fertilizer\":{\"Pierre\":100},\"Quality Fertilizer\":{\"Pierre\":150},\"Speed-Gro\":{\"Pierre\":100},\"Deluxe Speed-Gro\":{\"Pierre\":150,\"Oasis\":80}},\"GenerateSeedPrices\":{\"Pierre\":[273,299,301,302,425,427,429,453,455,472,473,474,475,476,477,479,480,481,482,483,484,485,487,488,489,490,491,492,493],\"Joja\":[299,301,302,425,427,429,453,455,472,473,474,475,477,479,480,482,483,484,487,488,490,491,492,493],\"Oasis\":[478,486,494]},\"SeedPrices\":{\"347\":[{\"Vendor\":\"Traveling Cart\",\"Price\":1000,\"Type\":\"Fixed\"}],\"431\":[{\"Vendor\":\"Joja\",\"Price\":100,\"Type\":\"Scaling\"},{\"Vendor\":\"Pierre\",\"Price\":200,\"Type\":\"Scaling\"}],\"433\":[{\"Vendor\":\"Traveling Cart\",\"Price\":2500,\"Type\":\"Fixed\"}],\"493\":[{\"Vendor\":\"Pierre\",\"Price\":240,\"Type\":\"Scaling\"},{\"Vendor\":\"Joja\",\"Price\":240,\"Type\":\"Scaling\"}],\"745\":[{\"Vendor\":\"Pierre\",\"Price\":100,\"Type\":\"Fixed\"}],\"802\":[{\"Vendor\":\"Oasis\",\"Price\":150,\"Type\":\"Scaling\"}]},\"ProcessorUnlockLevel\":{\"Preserves Jar\":4,\"Keg\":8,\"Seed Maker\":9,\"Oil Maker\":9}}");





var $eATN7 = parcelRequire("eATN7");


var $kRS0m = parcelRequire("kRS0m");


function $d06a0138b761f217$export$74ce92fe28dd0fc4(ResultValue) {
    return new $d06a0138b761f217$export$450bb352655ebd9b(0, [
        ResultValue
    ]);
}
function $d06a0138b761f217$export$d97575ed967f0cc(ErrorValue) {
    return new $d06a0138b761f217$export$450bb352655ebd9b(1, [
        ErrorValue
    ]);
}
class $d06a0138b761f217$export$450bb352655ebd9b extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Ok",
            "Error"
        ];
    }
}
function $d06a0138b761f217$export$c42070d5153142ae(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpResult`2", [
        gen0,
        gen1
    ], $d06a0138b761f217$export$450bb352655ebd9b, ()=>[
            [
                [
                    "ResultValue",
                    gen0
                ]
            ],
            [
                [
                    "ErrorValue",
                    gen1
                ]
            ]
        ]);
}
function $d06a0138b761f217$export$7eb72553d53998e3(mapping, result) {
    if (result.tag === /* Ok */ 0) return $d06a0138b761f217$export$74ce92fe28dd0fc4(mapping(result.fields[0]));
    else return $d06a0138b761f217$export$d97575ed967f0cc(result.fields[0]);
}
function $d06a0138b761f217$export$34adf8fc280f0a4b(mapping, result) {
    if (result.tag === /* Ok */ 0) return $d06a0138b761f217$export$74ce92fe28dd0fc4(result.fields[0]);
    else return $d06a0138b761f217$export$d97575ed967f0cc(mapping(result.fields[0]));
}
function $d06a0138b761f217$export$231ecfcfaf6b3fe(binder, result) {
    if (result.tag === /* Ok */ 0) return binder(result.fields[0]);
    else return $d06a0138b761f217$export$d97575ed967f0cc(result.fields[0]);
}
function $d06a0138b761f217$export$9b7837b8f166174b(result) {
    if (result.tag === /* Ok */ 0) return true;
    else return false;
}
function $d06a0138b761f217$export$cb9233a84bf0e33d(result) {
    if (result.tag === /* Ok */ 0) return false;
    else return true;
}
function $d06a0138b761f217$export$7d9d92d6fe345a36(value, result) {
    if (result.tag === /* Ok */ 0) return (0, $kRS0m.equals)(result.fields[0], value);
    else return false;
}
function $d06a0138b761f217$export$6d282a8c29ad8e11(result) {
    if (result.tag === /* Ok */ 0) return 1;
    else return 0;
}
function $d06a0138b761f217$export$10219401f41909d3(defaultValue, result) {
    if (result.tag === /* Ok */ 0) return result.fields[0];
    else return defaultValue;
}
function $d06a0138b761f217$export$826286879c1915fd(defThunk, result) {
    if (result.tag === /* Ok */ 0) return result.fields[0];
    else return defThunk(result.fields[0]);
}
function $d06a0138b761f217$export$86283a7859c5adb5(predicate, result) {
    if (result.tag === /* Ok */ 0) return predicate(result.fields[0]);
    else return false;
}
function $d06a0138b761f217$export$c9103c9123cd961d(folder, state, result) {
    if (result.tag === /* Ok */ 0) return folder(state, result.fields[0]);
    else return state;
}
function $d06a0138b761f217$export$b343c052bb499026(folder, result, state) {
    if (result.tag === /* Ok */ 0) return folder(result.fields[0], state);
    else return state;
}
function $d06a0138b761f217$export$307ce94b459f5fb2(predicate, result) {
    if (result.tag === /* Ok */ 0) return predicate(result.fields[0]);
    else return true;
}
function $d06a0138b761f217$export$fe1f1d2300cbcb3c(action, result) {
    if (result.tag === /* Ok */ 0) action(result.fields[0]);
}
function $d06a0138b761f217$export$4a230e678abb0e8(result) {
    if (result.tag === /* Ok */ 0) return [
        result.fields[0]
    ];
    else return [];
}
function $d06a0138b761f217$export$1278c7688d951bd6(result) {
    if (result.tag === /* Ok */ 0) return (0, $e08834e1786645d9$export$439306a4dcaafbb9)(result.fields[0]);
    else return (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
}
function $d06a0138b761f217$export$ec97e80f8cfaff60(result) {
    if (result.tag === /* Ok */ 0) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(result.fields[0]);
    else return undefined;
}
function $d06a0138b761f217$export$3ec1abab5b6c84e8(result) {
    if (result.tag === /* Ok */ 0) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(result.fields[0]);
    else return undefined;
}



var $eATN7 = parcelRequire("eATN7");



var $kRS0m = parcelRequire("kRS0m");


class $5c30c14fc487c53f$export$e778e3159a77f99f extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "BadPrimitive",
            "BadPrimitiveExtra",
            "BadType",
            "BadField",
            "BadPath",
            "TooSmallArray",
            "FailMessage",
            "BadOneOf"
        ];
    }
}
function $5c30c14fc487c53f$export$7d09a91af7f24eb7() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("Thoth.Json.ErrorReason", [], $5c30c14fc487c53f$export$e778e3159a77f99f, ()=>[
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ],
                [
                    "Item3",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ],
                [
                    "Item3",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
                ]
            ],
            [
                [
                    "Item",
                    (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734))
                ]
            ]
        ]);
}
class $5c30c14fc487c53f$export$9e558e3dec30b036 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "PascalCase",
            "CamelCase",
            "SnakeCase"
        ];
    }
}
function $5c30c14fc487c53f$export$d22394065f2bdf10() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("Thoth.Json.CaseStrategy", [], $5c30c14fc487c53f$export$9e558e3dec30b036, ()=>[
            [],
            [],
            []
        ]);
}
class $5c30c14fc487c53f$export$ceeb7a9ab32347e5 extends (0, $eATN7.Record) {
    constructor(Hash, Coders){
        super();
        this.Hash = Hash;
        this.Coders = Coders;
    }
}
function $5c30c14fc487c53f$export$ac5d068ec91c03c2() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("Thoth.Json.ExtraCoders", [], $5c30c14fc487c53f$export$ceeb7a9ab32347e5, ()=>[
            [
                "Hash",
                (0, $3921efb06a31e9cc$export$36bbd56a39d3f734)
            ],
            [
                "Coders",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Microsoft.FSharp.Collections.FSharpMap`2", [
                    (0, $3921efb06a31e9cc$export$36bbd56a39d3f734),
                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$e63caa28a27bc62e), (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)), (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$e63caa28a27bc62e), (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("Microsoft.FSharp.Core.FSharpResult`2", [
                        (0, $3921efb06a31e9cc$export$e63caa28a27bc62e),
                        (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), $5c30c14fc487c53f$export$7d09a91af7f24eb7())
                    ], (0, $d06a0138b761f217$export$450bb352655ebd9b), ()=>[
                            [
                                [
                                    "ResultValue",
                                    (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
                                ]
                            ],
                            [
                                [
                                    "ErrorValue",
                                    (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), $5c30c14fc487c53f$export$7d09a91af7f24eb7())
                                ]
                            ]
                        ]))))
                ])
            ]
        ]);
}
class $5c30c14fc487c53f$export$16d85587f6d335cd {
    constructor(){
        this.cache = new Map([]);
    }
}
function $5c30c14fc487c53f$export$a2e3e8f5a08e8f35(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Thoth.Json.Util.Cache`1", [
        gen0
    ], $5c30c14fc487c53f$export$16d85587f6d335cd);
}
function $5c30c14fc487c53f$export$2706b19d70d30332() {
    return new $5c30c14fc487c53f$export$16d85587f6d335cd();
}
function $5c30c14fc487c53f$export$13d7539a3e56b28c(__, key, factory) {
    let matchValue;
    let outArg = (0, $kRS0m.defaultOf)();
    matchValue = [
        (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(__.cache, key, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ];
    if (matchValue[0]) return matchValue[1];
    else {
        const x_1 = factory();
        (0, $b5b450d1f3f8f266$export$640abc42af5f7b25)(__.cache, key, x_1);
        return x_1;
    }
}
const $5c30c14fc487c53f$export$dc4f3fd3a24229a1 = $5c30c14fc487c53f$export$2706b19d70d30332();
const $5c30c14fc487c53f$export$3af5a3bafabfd795 = $5c30c14fc487c53f$export$2706b19d70d30332();
function $5c30c14fc487c53f$export$5a4a7a92425b4206(str) {
    return str.slice(undefined, 1).toLowerCase() + str.slice(1, str.length);
}
function $5c30c14fc487c53f$export$961cef5fdb5fe03c(caseStrategy, fieldName) {
    switch(caseStrategy.tag){
        case 2:
            return (0, $9879a22dc3fb544d$export$77ad94ebf1c2b9ed)($5c30c14fc487c53f$export$5a4a7a92425b4206(fieldName), "[A-Z]", "_$0").toLowerCase();
        case 0:
            return fieldName;
        default:
            return $5c30c14fc487c53f$export$5a4a7a92425b4206(fieldName);
    }
}



// RFC 4122 compliant. From https://stackoverflow.com/a/13653180/3922220
// const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
// Relax GUID parsing, see #1637
const $1e2c404b14cccd24$var$guidRegex = /^[\(\{]{0,2}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[\)\}]{0,2}$/;
const $1e2c404b14cccd24$var$guidRegexNoHyphen = /^([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})$/;
const $1e2c404b14cccd24$var$guidRegexHex = /^\{0x[0-9a-f]{8},(0x[0-9a-f]{4},){2}\{(0x[0-9a-f]{2},){7}0x[0-9a-f]{2}\}\}$/;
const $1e2c404b14cccd24$var$guidHexCaptures = /^([0-9a-f]{8})-(([0-9a-f]{4})-)(([0-9a-f]{4})-)([0-9a-f]{2})([0-9a-f]{2})-([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/;
function $1e2c404b14cccd24$export$f84e8e69fd4488a5(str, format, _provider) {
    if (format && format?.length > 0) switch(format){
        case "N":
            return str.replace(/-/g, '');
        case "D":
            return str;
        case "B":
            return "{" + str + "}";
        case "P":
            return "(" + str + ")";
        case "X":
            return str.replace($1e2c404b14cccd24$var$guidHexCaptures, "{0x$1,0x$3,0x$5,{0x$6,0x$7,0x$8,0x$9,0x$10,0x$11,0x$12,0x$13}}");
        default:
            throw new Error("Unrecognized Guid print format");
    }
    else return str;
}
function $1e2c404b14cccd24$export$98e6a39c04603d36(str) {
    function hyphenateGuid(str) {
        return str.replace($1e2c404b14cccd24$var$guidRegexNoHyphen, "$1-$2-$3-$4-$5");
    }
    const wsTrimAndLowered = str.trim().toLowerCase();
    if ($1e2c404b14cccd24$var$guidRegex.test(wsTrimAndLowered)) return (0, $7802b3aa01031554$export$87c2784dc9fc4ab)(wsTrimAndLowered, "{", "}", "(", ")");
    else if ($1e2c404b14cccd24$var$guidRegexNoHyphen.test(wsTrimAndLowered)) return hyphenateGuid(wsTrimAndLowered);
    else if ($1e2c404b14cccd24$var$guidRegexHex.test(wsTrimAndLowered)) return hyphenateGuid(wsTrimAndLowered.replace(/[\{\},]|0x/g, ''));
    else throw new Error("Guid should contain 32 digits with 4 dashes: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx");
}
function $1e2c404b14cccd24$export$468ff95b83d315e5(str, defValue) {
    try {
        defValue.contents = $1e2c404b14cccd24$export$98e6a39c04603d36(str);
        return true;
    } catch  {
        return false;
    }
}
function $1e2c404b14cccd24$export$665eeb3ced5fba0b() {
    let b = "";
    for(let a = 0; a++ < 36;)b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : "-";
    return b;
}
// Maps for number <-> hex string conversion
let $1e2c404b14cccd24$var$_convertMapsInitialized = false;
let $1e2c404b14cccd24$var$_byteToHex;
let $1e2c404b14cccd24$var$_hexToByte;
function $1e2c404b14cccd24$var$initConvertMaps() {
    $1e2c404b14cccd24$var$_byteToHex = new Array(256);
    $1e2c404b14cccd24$var$_hexToByte = {};
    for(let i = 0; i < 256; i++){
        $1e2c404b14cccd24$var$_byteToHex[i] = (i + 0x100).toString(16).substr(1);
        $1e2c404b14cccd24$var$_hexToByte[$1e2c404b14cccd24$var$_byteToHex[i]] = i;
    }
    $1e2c404b14cccd24$var$_convertMapsInitialized = true;
}
function $1e2c404b14cccd24$export$a3f8261c743ae9bb(s) {
    if (!$1e2c404b14cccd24$var$_convertMapsInitialized) $1e2c404b14cccd24$var$initConvertMaps();
    let i = 0;
    const buf = new Uint8Array(16);
    s.toLowerCase().replace(/[0-9a-f]{2}/g, (oct)=>{
        switch(i){
            // .NET saves first three byte groups with different endianness
            // See https://stackoverflow.com/a/16722909/3922220
            case 0:
            case 1:
            case 2:
            case 3:
                buf[3 - i++] = $1e2c404b14cccd24$var$_hexToByte[oct];
                break;
            case 4:
            case 5:
                buf[9 - i++] = $1e2c404b14cccd24$var$_hexToByte[oct];
                break;
            case 6:
            case 7:
                buf[13 - i++] = $1e2c404b14cccd24$var$_hexToByte[oct];
                break;
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
                buf[i++] = $1e2c404b14cccd24$var$_hexToByte[oct];
                break;
        }
    });
    // Zero out remaining bytes if string was short
    while(i < 16)buf[i++] = 0;
    return buf;
}
function $1e2c404b14cccd24$export$710a051825f7f6a2(buf) {
    if (buf.length !== 16) throw new Error("Byte array for GUID must be exactly 16 bytes long");
    if (!$1e2c404b14cccd24$var$_convertMapsInitialized) $1e2c404b14cccd24$var$initConvertMaps();
    const guid = $1e2c404b14cccd24$var$_byteToHex[buf[3]] + $1e2c404b14cccd24$var$_byteToHex[buf[2]] + $1e2c404b14cccd24$var$_byteToHex[buf[1]] + $1e2c404b14cccd24$var$_byteToHex[buf[0]] + "-" + $1e2c404b14cccd24$var$_byteToHex[buf[5]] + $1e2c404b14cccd24$var$_byteToHex[buf[4]] + "-" + $1e2c404b14cccd24$var$_byteToHex[buf[7]] + $1e2c404b14cccd24$var$_byteToHex[buf[6]] + "-" + $1e2c404b14cccd24$var$_byteToHex[buf[8]] + $1e2c404b14cccd24$var$_byteToHex[buf[9]] + "-" + $1e2c404b14cccd24$var$_byteToHex[buf[10]] + $1e2c404b14cccd24$var$_byteToHex[buf[11]] + $1e2c404b14cccd24$var$_byteToHex[buf[12]] + $1e2c404b14cccd24$var$_byteToHex[buf[13]] + $1e2c404b14cccd24$var$_byteToHex[buf[14]] + $1e2c404b14cccd24$var$_byteToHex[buf[15]];
    return guid;
}



var $eATN7 = parcelRequire("eATN7");


var $c7lrN = parcelRequire("c7lrN");


var $c7lrN = parcelRequire("c7lrN");
function $7a0dc84f38e8179a$var$getMaxValue(unsigned, radix, isNegative) {
    switch(radix){
        case 2:
            return unsigned ? "1111111111111111111111111111111111111111111111111111111111111111" : isNegative ? "1000000000000000000000000000000000000000000000000000000000000000" : "111111111111111111111111111111111111111111111111111111111111111";
        case 8:
            return unsigned ? "1777777777777777777777" : isNegative ? "1000000000000000000000" : "777777777777777777777";
        case 10:
            return unsigned ? "18446744073709551615" : isNegative ? "9223372036854775808" : "9223372036854775807";
        case 16:
            return unsigned ? "FFFFFFFFFFFFFFFF" : isNegative ? "8000000000000000" : "7FFFFFFFFFFFFFFF";
        default:
            throw new Error("Invalid radix.");
    }
}
function $7a0dc84f38e8179a$export$98e6a39c04603d36(str, style, unsigned, _bitsize, radix) {
    const res = (0, $98d8e74a1fff5068$export$1ea939691cdc45b8)(str, style, radix);
    if (res != null) {
        const lessOrEqual = (x, y)=>{
            const len = Math.max(x.length, y.length);
            return x.padStart(len, "0") <= y.padStart(len, "0");
        };
        const isNegative = res.sign === "-";
        const maxValue = $7a0dc84f38e8179a$var$getMaxValue(unsigned || res.radix !== 10, res.radix, isNegative);
        if (lessOrEqual(res.digits.toUpperCase(), maxValue)) {
            str = (0, $98d8e74a1fff5068$export$36e24695f02d4503)(res.radix) + res.digits;
            str = isNegative ? res.sign + str : str;
            return (0, $c7lrN.fromString)(str);
        }
    }
    throw new Error(`The input string ${str} was not in a correct format.`);
}
function $7a0dc84f38e8179a$export$468ff95b83d315e5(str, style, unsigned, bitsize, defValue) {
    try {
        defValue.contents = $7a0dc84f38e8179a$export$98e6a39c04603d36(str, style, unsigned, bitsize);
        return true;
    } catch  {
        return false;
    }
}



var $fzAFM = parcelRequire("fzAFM");

/**
 * DateTimeOffset functions.
 *
 * Note: DateOffset instances are always DateObjects in local
 * timezone (because JS dates are all kinds of messed up).
 * A local date returns UTC epoch when `.getTime()` is called.
 *
 * However, this means that in order to construct an UTC date
 * from a DateOffset with offset of +5 hours, you first need
 * to subtract those 5 hours, than add the "local" offset.
 * As said, all kinds of messed up.
 *
 * Basically; invariant: date.getTime() always return UTC time.
 */ 
var $c7lrN = parcelRequire("c7lrN");


var $kRS0m = parcelRequire("kRS0m");
function $d85d237bf9fec1b6$export$2e2bcd8739ae039(value, offset) {
    $d85d237bf9fec1b6$var$checkOffsetInRange(offset);
    const d = new Date(value);
    d.offset = offset != null ? offset : new Date().getTimezoneOffset() * -60000;
    return d;
}
function $d85d237bf9fec1b6$export$cc800923e997bb8(value) {
    return value.offset || 0;
}
function $d85d237bf9fec1b6$var$checkOffsetInRange(offset) {
    if (offset != null && offset !== 0) {
        if (offset % 60000 !== 0) throw new Error("Offset must be specified in whole minutes.");
        if (Math.abs(offset / 3600000) > 14) throw new Error("Offset must be within plus or minus 14 hours.");
    }
}
function $d85d237bf9fec1b6$export$e57ff100d91bd4b9(date, offset) {
    let offset2 = 0;
    switch(date.kind){
        case 1 /* DateKind.UTC */ :
            if (offset != null && offset !== 0) throw new Error("The UTC Offset for Utc DateTime instances must be 0.");
            offset2 = 0;
            break;
        case 2 /* DateKind.Local */ :
            offset2 = date.getTimezoneOffset() * -60000;
            if (offset != null && offset !== offset2) throw new Error("The UTC Offset of the local dateTime parameter does not match the offset argument.");
            break;
        case 0 /* DateKind.Unspecified */ :
        default:
            if (offset == null) offset2 = date.getTimezoneOffset() * -60000;
            else offset2 = offset;
            break;
    }
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(date.getTime(), offset2);
}
function $d85d237bf9fec1b6$export$b4dd4c63617c9281(ticks, offset) {
    const ms = (0, $6ed86d8a11a8516b$export$2044bef34fee81ea)(ticks) - offset;
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(ms, offset);
}
function $d85d237bf9fec1b6$export$e20f9ba3c2af84fa(ms) {
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039((0, $c7lrN.toFloat64)(ms), 0);
}
function $d85d237bf9fec1b6$export$b80b3c2f3ea08d0c(seconds) {
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039((0, $c7lrN.toFloat64)(seconds * 1000n), 0);
}
function $d85d237bf9fec1b6$export$8f1d3af68a71544(date) {
    return (0, $6ed86d8a11a8516b$export$b04aee43a70c325e)(date.getTime(), 0);
}
function $d85d237bf9fec1b6$export$5805e19da86cbb3c() {
    // This is "0001-01-01T00:00:00.000Z", actual JS min value is -8640000000000000
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(-62135596800000, 0);
}
function $d85d237bf9fec1b6$export$b9dc90d6499a9909() {
    // This is "9999-12-31T23:59:59.999Z", actual JS max value is 8640000000000000
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(253402300799999, 0);
}
function $d85d237bf9fec1b6$export$98e6a39c04603d36(str) {
    const [date, offsetMatch] = (0, $6ed86d8a11a8516b$export$a6658d265f3f7695)(str);
    const offset = offsetMatch == null ? date.getTimezoneOffset() * -60000 : offsetMatch === "Z" ? 0 : offsetMatch * 60000;
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(date.getTime(), offset);
}
function $d85d237bf9fec1b6$export$468ff95b83d315e5(v, defValue) {
    try {
        defValue.contents = $d85d237bf9fec1b6$export$98e6a39c04603d36(v);
        return true;
    } catch (_err) {
        return false;
    }
}
function $d85d237bf9fec1b6$export$185802fd694ee1f5(year, month, day, h, m, s, ms, offset) {
    if (offset == null) {
        offset = ms;
        ms = 0;
    }
    $d85d237bf9fec1b6$var$checkOffsetInRange(offset);
    let date;
    if (offset === 0) {
        date = new Date(Date.UTC(year, month - 1, day, h, m, s, ms));
        if (year <= 99) date.setUTCFullYear(year, month - 1, day);
    } else {
        const str = (0, $kRS0m.padWithZeros)(year, 4) + "-" + (0, $kRS0m.padWithZeros)(month, 2) + "-" + (0, $kRS0m.padWithZeros)(day, 2) + "T" + (0, $kRS0m.padWithZeros)(h, 2) + ":" + (0, $kRS0m.padWithZeros)(m, 2) + ":" + (0, $kRS0m.padWithZeros)(s, 2) + "." + (0, $kRS0m.padWithZeros)(ms, 3) + (0, $6ed86d8a11a8516b$export$4dcf2a40c0851df0)(offset);
        date = new Date(str);
    }
    const dateValue = date.getTime();
    if (isNaN(dateValue)) throw new Error("The parameters describe an unrepresentable Date");
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(dateValue, offset);
}
function $d85d237bf9fec1b6$export$461939dd4422153() {
    const date = new Date();
    const offset = date.getTimezoneOffset() * -60000;
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(date.getTime(), offset);
}
function $d85d237bf9fec1b6$export$a56f095995763cca() {
    const date = $d85d237bf9fec1b6$export$461939dd4422153();
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(date.getTime(), 0);
}
function $d85d237bf9fec1b6$export$3230e995afdc9bec(date) {
    return (0, $6ed86d8a11a8516b$export$2e2bcd8739ae039)(date.getTime(), 1 /* DateKind.UTC */ );
}
function $d85d237bf9fec1b6$export$b96ad347bdf3bd16(date) {
    return (0, $6ed86d8a11a8516b$export$2e2bcd8739ae039)(date.getTime(), 2 /* DateKind.Local */ );
}
function $d85d237bf9fec1b6$export$54a89be6af0881dc(d) {
    const d2 = new Date(d.getTime() + (d.offset ?? 0));
    return d2.getUTCHours() * 3600000 + d2.getUTCMinutes() * 60000 + d2.getUTCSeconds() * 1000 + d2.getUTCMilliseconds();
}
function $d85d237bf9fec1b6$export$324d90190a8b822a(d) {
    const d2 = new Date(d.getTime() + (d.offset ?? 0));
    return (0, $6ed86d8a11a8516b$export$185802fd694ee1f5)(d2.getUTCFullYear(), d2.getUTCMonth() + 1, d2.getUTCDate(), 0, 0, 0, 0);
}
function $d85d237bf9fec1b6$export$d2d39d1adcc883a2(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCDate();
}
function $d85d237bf9fec1b6$export$842e383dfc19bc67(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCHours();
}
function $d85d237bf9fec1b6$export$edc5e5cb87280477(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCMilliseconds();
}
function $d85d237bf9fec1b6$export$1cacba1045a8e790(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCMinutes();
}
function $d85d237bf9fec1b6$export$af5de1609f06c8e6(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCMonth() + 1;
}
function $d85d237bf9fec1b6$export$3d3c77ce7df7d30d(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCSeconds();
}
function $d85d237bf9fec1b6$export$31803937850fb2da(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCFullYear();
}
function $d85d237bf9fec1b6$export$a24aefd2b69080a9(d) {
    return new Date(d.getTime() + (d.offset ?? 0)).getUTCDay();
}
function $d85d237bf9fec1b6$export$75898a44428fae85(d) {
    const d2 = new Date(d.getTime() + (d.offset ?? 0));
    const _year = d2.getUTCFullYear();
    const _month = d2.getUTCMonth() + 1;
    let _day = d2.getUTCDate();
    for(let i = 1; i < _month; i++)_day += (0, $6ed86d8a11a8516b$export$4169ecd548fbc13a)(_year, i);
    return _day;
}
function $d85d237bf9fec1b6$export$e16d8520af44a096(d, ts) {
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(d.getTime() + ts, d.offset ?? 0);
}
function $d85d237bf9fec1b6$export$dd412b56f1e4d8aa(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, v * 86400000);
}
function $d85d237bf9fec1b6$export$4a4306ad4fa0e5e6(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, v * 3600000);
}
function $d85d237bf9fec1b6$export$2287e3d29250119e(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, v * 60000);
}
function $d85d237bf9fec1b6$export$3cb31b0df13be68(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, v * 1000);
}
function $d85d237bf9fec1b6$export$baf757aaf0c95c94(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, v);
}
function $d85d237bf9fec1b6$export$84f156599067de34(d, v) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(d, (0, $c7lrN.toFloat64)(v / 10000n));
}
function $d85d237bf9fec1b6$export$3d83eec43f4ea476(d, v) {
    const newMonth = d.getUTCMonth() + 1;
    const newYear = d.getUTCFullYear() + v;
    const _daysInMonth = (0, $6ed86d8a11a8516b$export$4169ecd548fbc13a)(newYear, newMonth);
    const newDay = Math.min(_daysInMonth, d.getUTCDate());
    return $d85d237bf9fec1b6$export$185802fd694ee1f5(newYear, newMonth, newDay, d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds(), d.offset ?? 0);
}
function $d85d237bf9fec1b6$export$17c93e242b2d3a22(d, v) {
    const d2 = new Date(d.getTime() + (d.offset ?? 0));
    let newMonth = d2.getUTCMonth() + 1 + v;
    let newMonth_ = 0;
    let yearOffset = 0;
    if (newMonth > 12) {
        newMonth_ = newMonth % 12;
        yearOffset = Math.floor(newMonth / 12);
        newMonth = newMonth_;
    } else if (newMonth < 1) {
        newMonth_ = 12 + newMonth % 12;
        yearOffset = Math.floor(newMonth / 12) + (newMonth_ === 12 ? -1 : 0);
        newMonth = newMonth_;
    }
    const newYear = d2.getUTCFullYear() + yearOffset;
    const _daysInMonth = (0, $6ed86d8a11a8516b$export$4169ecd548fbc13a)(newYear, newMonth);
    const newDay = Math.min(_daysInMonth, d2.getUTCDate());
    return $d85d237bf9fec1b6$export$185802fd694ee1f5(newYear, newMonth, newDay, d2.getUTCHours(), d2.getUTCMinutes(), d2.getUTCSeconds(), d2.getUTCMilliseconds(), d.offset ?? 0);
}
function $d85d237bf9fec1b6$export$4e2d2ead65e5f7e3(d, that) {
    return typeof that === "number" ? $d85d237bf9fec1b6$export$2e2bcd8739ae039(d.getTime() - that, d.offset ?? 0) : d.getTime() - that.getTime();
}
function $d85d237bf9fec1b6$export$e9bab7fafb253603(d1, d2) {
    return d1.getTime() === d2.getTime();
}
function $d85d237bf9fec1b6$export$3b03131497d4f379(d1, d2) {
    return d1.getTime() === d2.getTime() && d1.offset === d2.offset;
}
function $d85d237bf9fec1b6$export$398604a469f7de9a(d1, d2) {
    return (0, $kRS0m.compareDates)(d1, d2);
}
const $d85d237bf9fec1b6$export$53576907a5c40ba3 = $d85d237bf9fec1b6$export$398604a469f7de9a;
function $d85d237bf9fec1b6$export$a5fb1fdca49990a(x, y) {
    return $d85d237bf9fec1b6$export$e16d8520af44a096(x, y);
}
function $d85d237bf9fec1b6$export$1ba572a54983744c(x, y) {
    return $d85d237bf9fec1b6$export$4e2d2ead65e5f7e3(x, y);
}
function $d85d237bf9fec1b6$export$3be3bdfb9de4338e(d, offset) {
    return $d85d237bf9fec1b6$export$2e2bcd8739ae039(d.getTime(), offset);
}
function $d85d237bf9fec1b6$export$4334d6bdff36ac48(d) {
    return (0, $c7lrN.fromFloat64)(d.getTime());
}
function $d85d237bf9fec1b6$export$53fdcf9ba380a851(d) {
    return (0, $c7lrN.fromFloat64)(d.getTime() / 1000.0);
}



var $kRS0m = parcelRequire("kRS0m");

var $c7lrN = parcelRequire("c7lrN");
/**
 * Calls:
 * - `Math.ceil` if the `value` is **negative**
 * - `Math.floor` if the `value` is **positive**
 * @param value Value to round
 */ function $47c835136897402a$var$signedRound(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
}
function $47c835136897402a$export$185802fd694ee1f5(d = 0, h = 0, m = 0, s = 0, ms = 0) {
    switch(arguments.length){
        case 1:
            // ticks
            return $47c835136897402a$export$b4dd4c63617c9281(arguments[0]);
        case 3:
            // h,m,s
            d = 0, h = arguments[0], m = arguments[1], s = arguments[2], ms = 0;
            break;
        default:
            break;
    }
    return d * 86400000 + h * 3600000 + m * 60000 + s * 1000 + ms;
}
function $47c835136897402a$export$b4dd4c63617c9281(ticks) {
    return Number(BigInt(ticks) / 10000n);
}
function $47c835136897402a$export$3204197c7287a709(d) {
    return $47c835136897402a$export$185802fd694ee1f5(d, 0, 0, 0);
}
function $47c835136897402a$export$dafe02dd684dc2af(h) {
    return $47c835136897402a$export$185802fd694ee1f5(h, 0, 0);
}
function $47c835136897402a$export$2573b0584d6d05ea(m) {
    return $47c835136897402a$export$185802fd694ee1f5(0, m, 0);
}
function $47c835136897402a$export$d5805bbcec54c5ee(s) {
    return $47c835136897402a$export$185802fd694ee1f5(0, 0, s);
}
function $47c835136897402a$export$3cf5dda4201cc0f2(ts) {
    return $47c835136897402a$var$signedRound(ts / 86400000);
}
function $47c835136897402a$export$8d468796d69cdad1(ts) {
    return $47c835136897402a$var$signedRound(ts % 86400000 / 3600000);
}
function $47c835136897402a$export$666252b437cce0c7(ts) {
    return $47c835136897402a$var$signedRound(ts % 3600000 / 60000);
}
function $47c835136897402a$export$4792e48abc550fa1(ts) {
    return $47c835136897402a$var$signedRound(ts % 60000 / 1000);
}
function $47c835136897402a$export$9a27fac83d67afd3(ts) {
    return $47c835136897402a$var$signedRound(ts % 1000);
}
function $47c835136897402a$export$e8e6acc9efcde79f(ts) {
    return (0, $c7lrN.toInt64)((0, $c7lrN.fromFloat64)(ts * 10000));
}
function $47c835136897402a$export$ea7ecd994c44d3a7(ts) {
    return ts / 86400000;
}
function $47c835136897402a$export$15b453508f4a9bed(ts) {
    return ts / 3600000;
}
function $47c835136897402a$export$a0f172bd92bc8985(ts) {
    return ts / 60000;
}
function $47c835136897402a$export$1c11f05f2859a7d1(ts) {
    return ts / 1000;
}
function $47c835136897402a$export$aef51622e549b8b0(ts) {
    return ts * -1;
}
function $47c835136897402a$export$e16d8520af44a096(ts1, ts2) {
    return ts1 + ts2;
}
function $47c835136897402a$export$4e2d2ead65e5f7e3(ts1, ts2) {
    return ts1 - ts2;
}
function $47c835136897402a$export$2060d2db72cce88f(ts, factor) {
    return ts * factor;
}
function $47c835136897402a$export$cd007d971a5a2143(ts, b) {
    return ts / b;
}
const $47c835136897402a$export$a5fb1fdca49990a = $47c835136897402a$export$e16d8520af44a096;
const $47c835136897402a$export$1ba572a54983744c = $47c835136897402a$export$4e2d2ead65e5f7e3;
const $47c835136897402a$export$bef948e98114a357 = $47c835136897402a$export$2060d2db72cce88f;
const $47c835136897402a$export$a6e41fbebc04a9a6 = $47c835136897402a$export$cd007d971a5a2143;
const $47c835136897402a$export$398604a469f7de9a = (0, $kRS0m.comparePrimitives);
const $47c835136897402a$export$53576907a5c40ba3 = (0, $kRS0m.comparePrimitives);
function $47c835136897402a$export$1f34108aa9eb96ab(x) {
    return Math.abs(x);
}
function $47c835136897402a$export$f84e8e69fd4488a5(ts, format = "c", _provider) {
    if ([
        "c",
        "g",
        "G"
    ].indexOf(format) === -1) throw new Error("Custom formats are not supported");
    const d = Math.abs($47c835136897402a$export$3cf5dda4201cc0f2(ts));
    const h = Math.abs($47c835136897402a$export$8d468796d69cdad1(ts));
    const m = Math.abs($47c835136897402a$export$666252b437cce0c7(ts));
    const s = Math.abs($47c835136897402a$export$4792e48abc550fa1(ts));
    const ms = Math.abs($47c835136897402a$export$9a27fac83d67afd3(ts));
    const sign = ts < 0 ? "-" : "";
    return `${sign}${d === 0 && (format === "c" || format === "g") ? "" : format === "c" ? d + "." : d + ":"}${format === "g" ? h : (0, $kRS0m.padWithZeros)(h, 2)}:${(0, $kRS0m.padWithZeros)(m, 2)}:${(0, $kRS0m.padWithZeros)(s, 2)}${ms === 0 && (format === "c" || format === "g") ? "" : format === "g" ? "." + (0, $kRS0m.padWithZeros)(ms, 3) : "." + (0, $kRS0m.padLeftAndRightWithZeros)(ms, 3, 7)}`;
}
function $47c835136897402a$export$98e6a39c04603d36(str) {
    const firstDot = str.search("\\.");
    const firstColon = str.search("\\:");
    if (firstDot === -1 && firstColon === -1) {
        const d = parseInt(str, 0);
        if (isNaN(d)) throw new Error(`String '${str}' was not recognized as a valid TimeSpan.`);
        else return $47c835136897402a$export$185802fd694ee1f5(d, 0, 0, 0, 0);
    }
    if (firstColon > 0) {
        // WIP: (-?)(((\d+)\.)?([0-9]|0[0-9]|1[0-9]|2[0-3]):(\d+)(:\d+(\.\d{1,7})?)?|\d+(?:(?!\.)))
        const r = /^(-?)((\d+)\.)?(?:0*)([0-9]|0[0-9]|1[0-9]|2[0-3]):(?:0*)([0-5][0-9]|[0-9])(:(?:0*)([0-5][0-9]|[0-9]))?\.?(\d+)?$/.exec(str);
        if (r != null && r[4] != null && r[5] != null) {
            let d = 0;
            let ms = 0;
            let s = 0;
            const sign = r[1] != null && r[1] === "-" ? -1 : 1;
            const h = +r[4];
            const m = +r[5];
            if (r[3] != null) d = +r[3];
            if (r[7] != null) s = +r[7];
            if (r[8] != null) // Depending on the number of decimals passed, we need to adapt the numbers
            switch(r[8].length){
                case 1:
                    ms = +r[8] * 100;
                    break;
                case 2:
                    ms = +r[8] * 10;
                    break;
                case 3:
                    ms = +r[8];
                    break;
                case 4:
                    ms = +r[8] / 10;
                    break;
                case 5:
                    ms = +r[8] / 100;
                    break;
                case 6:
                    ms = +r[8] / 1000;
                    break;
                case 7:
                    ms = +r[8] / 10000;
                    break;
                default:
                    throw new Error(`String '${str}' was not recognized as a valid TimeSpan.`);
            }
            return sign * $47c835136897402a$export$185802fd694ee1f5(d, h, m, s, ms);
        }
    }
    throw new Error(`String '${str}' was not recognized as a valid TimeSpan.`);
}
function $47c835136897402a$export$468ff95b83d315e5(v, defValue) {
    try {
        defValue.contents = $47c835136897402a$export$98e6a39c04603d36(v);
        return true;
    } catch  {
        return false;
    }
}





var $kRS0m = parcelRequire("kRS0m");





function $34cef9b1902a53c2$export$53a896e75eb468c1(o) {
    return typeof o === "undefined";
}
function $34cef9b1902a53c2$var$genericMsg(msg, value_1, newLine) {
    try {
        return "Expecting " + msg + " but instead got:" + (newLine ? "\n" : " ") + (JSON.stringify(value_1, null, 4) + '');
    } catch (matchValue) {
        return "Expecting " + msg + " but decoder failed. Couldn\'t report given value due to circular structure." + (newLine ? "\n" : " ");
    }
}
function $34cef9b1902a53c2$var$errorToString(path, error) {
    const reason_1 = error.tag === 2 ? $34cef9b1902a53c2$var$genericMsg(error.fields[0], error.fields[1], true) : error.tag === 1 ? $34cef9b1902a53c2$var$genericMsg(error.fields[0], error.fields[1], false) + "\nReason: " + error.fields[2] : error.tag === 3 ? $34cef9b1902a53c2$var$genericMsg(error.fields[0], error.fields[1], true) : error.tag === 4 ? $34cef9b1902a53c2$var$genericMsg(error.fields[0], error.fields[1], true) + ("\nNode `" + error.fields[2] + "` is unkown.") : error.tag === 5 ? "Expecting " + error.fields[0] + ".\n" + (JSON.stringify(error.fields[1], null, 4) + '') : error.tag === 7 ? "The following errors were found:\n\n" + (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("\n\n", error.fields[0]) : error.tag === 6 ? "The following `failure` occurred with the decoder: " + error.fields[0] : $34cef9b1902a53c2$var$genericMsg(error.fields[0], error.fields[1], false);
    if (error.tag === 7) return reason_1;
    else return "Error at: `" + path + "`\n" + reason_1;
}
function $34cef9b1902a53c2$export$5f36b26c3833b3ba(path, decoder, value_1) {
    const matchValue = decoder(path, value_1);
    if (matchValue.tag === 1) {
        const error = matchValue.fields[0];
        return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            $34cef9b1902a53c2$var$errorToString(error[0], error[1])
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        matchValue.fields[0]
    ]);
}
function $34cef9b1902a53c2$export$3004f64547af360e(decoder, value_1) {
    try {
        return $34cef9b1902a53c2$export$5f36b26c3833b3ba("$", decoder, JSON.parse(value_1));
    } catch (matchValue) {
        if (matchValue instanceof SyntaxError) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            "Given an invalid JSON: " + matchValue.message
        ]);
        else throw matchValue;
    }
}
function $34cef9b1902a53c2$export$6c65599023ae894b(decoder, value_1) {
    const matchValue = $34cef9b1902a53c2$export$3004f64547af360e(decoder, value_1);
    if (matchValue.tag === 1) throw new Error(matchValue.fields[0]);
    else return matchValue.fields[0];
}
function $34cef9b1902a53c2$export$1bc3347b5a3e0603(path, decoder) {
    const decoder_1 = decoder;
    return (value_1)=>$34cef9b1902a53c2$export$5f36b26c3833b3ba(path, decoder_1, value_1);
}
function $34cef9b1902a53c2$export$a0fb664af7d0cc44(decoder) {
    const decoder_1 = decoder;
    return (value_1)=>$34cef9b1902a53c2$export$3004f64547af360e(decoder_1, value_1);
}
function $34cef9b1902a53c2$export$22b082955e083ec3(path, value_1) {
    if (typeof value_1 === "string") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        value_1
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a string",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$eba6f6f03b0a92e7(path, value_1) {
    if (typeof value_1 === "string") {
        const str = value_1;
        if (str.length === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            str[0]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a single character string",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a char",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$46e8f25c7328f77e(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = "00000000-0000-0000-0000-000000000000";
        matchValue = [
            (0, $1e2c404b14cccd24$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            matchValue[1]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a guid",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a guid",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$523c0b569236b342(path, value_1) {
    if (value_1 == null) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        undefined
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "null",
                value_1
            ])
        ]
    ]);
}
const $34cef9b1902a53c2$export$d03d8c52dd769681 = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? -128 <= value_1_1 && value_1_1 <= 127 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                (value_1_1 + 0x80 & 0xFF) - 0x80
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "a sbyte",
                        value_1_1,
                        "Value was either too large or too small for a sbyte"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "a sbyte",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, false, 8, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v | 0;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "a sbyte",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a sbyte",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$9f5d4a7c57665797 = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? 0 <= value_1_1 && value_1_1 <= 255 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                value_1_1 & 0xFF
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "a byte",
                        value_1_1,
                        "Value was either too large or too small for a byte"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "a byte",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, true, 8, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "a byte",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a byte",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$c35c15c7caeff2b6 = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? -32768 <= value_1_1 && value_1_1 <= 32767 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                (value_1_1 + 0x8000 & 0xFFFF) - 0x8000
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int16",
                        value_1_1,
                        "Value was either too large or too small for an int16"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int16",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, false, 16, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v | 0;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an int16",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an int16",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$56bd24b5a3ee8456 = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? 0 <= value_1_1 && value_1_1 <= 65535 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                value_1_1 & 0xFFFF
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint16",
                        value_1_1,
                        "Value was either too large or too small for an uint16"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint16",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, true, 16, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an uint16",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an uint16",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$7d260a2a5f8bc19e = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? -2147483648 <= value_1_1 && value_1_1 <= 2147483647 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                ~~value_1_1
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int",
                        value_1_1,
                        "Value was either too large or too small for an int"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, false, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v | 0;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an int",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an int",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$de9ffb9418dd7d0d = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? 0 <= value_1_1 && value_1_1 <= 4294967295 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                value_1_1 >>> 0
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint32",
                        value_1_1,
                        "Value was either too large or too small for an uint32"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint32",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(value_3, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an uint32",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an uint32",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$af207e6076994812 = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? (0, $c7lrN.toFloat64)(-9223372036854775808n) <= value_1_1 && value_1_1 <= (0, $c7lrN.toFloat64)(9223372036854775807n) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                (0, $c7lrN.toInt64)((0, $c7lrN.fromFloat64)(value_1_1))
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int64",
                        value_1_1,
                        "Value was either too large or too small for an int64"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an int64",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0n;
            matchValue = [
                (0, $7a0dc84f38e8179a$export$468ff95b83d315e5)(value_3, 511, false, 64, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an int64",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an int64",
                    value_3
                ])
            ]
        ]);
    };
const $34cef9b1902a53c2$export$870002f71f6ee2de = (path)=>(value_2)=>{
        const path_1 = path;
        const value_3 = value_2;
        if (typeof value_3 === "number") {
            const value_1_1 = value_3;
            return isFinite(value_1_1) && Math.floor(value_1_1) === value_1_1 ? (0, $c7lrN.toFloat64)(0n) <= value_1_1 && value_1_1 <= (0, $c7lrN.toFloat64)(18446744073709551615n) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                (0, $c7lrN.toUInt64)((0, $c7lrN.fromFloat64)(value_1_1))
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint64",
                        value_1_1,
                        "Value was either too large or too small for an uint64"
                    ])
                ]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                        "an uint64",
                        value_1_1,
                        "Value is not an integral value"
                    ])
                ]
            ]);
        } else if (typeof value_3 === "string") {
            let matchValue;
            let outArg = 0n;
            matchValue = [
                (0, $7a0dc84f38e8179a$export$468ff95b83d315e5)(value_3, 511, true, 64, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v;
                })),
                outArg
            ];
            return matchValue[0] ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                matchValue[1]
            ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "an uint64",
                        value_3
                    ])
                ]
            ]);
        } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path_1,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "an uint64",
                    value_3
                ])
            ]
        ]);
    };
function $34cef9b1902a53c2$export$a0f65b52274bcc00(path, value_1) {
    if (typeof value_1 === "number") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        (0, $c7lrN.fromInt32)(value_1)
    ]);
    else if (typeof value_1 === "string") try {
        return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $c7lrN.parse)(value_1)
        ]);
    } catch (matchValue) {
        return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a bigint",
                    value_1
                ])
            ]
        ]);
    }
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a bigint",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$87b259aa03e3d267(path, value_1) {
    if (typeof value_1 === "boolean") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        value_1
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a boolean",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$6b5cd3983e3ee5ab(path, value_1) {
    if (typeof value_1 === "number") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        value_1
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a float",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$1a4bac2aea11f30e(path, value_1) {
    if (typeof value_1 === "number") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        value_1
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a float32",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$78a48a3d1e5dbe89(path, value_1) {
    if (typeof value_1 === "number") return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        new (0, $fzAFM.default)(value_1)
    ]);
    else if (typeof value_1 === "string") {
        let matchValue;
        let outArg = new (0, $fzAFM.default)("0");
        matchValue = [
            (0, $fzAFM.tryParse)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            matchValue[1]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a decimal",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a decimal",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$7ba4466dbd0f07e1(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = (0, $6ed86d8a11a8516b$export$5805e19da86cbb3c)();
        matchValue = [
            (0, $6ed86d8a11a8516b$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $6ed86d8a11a8516b$export$3230e995afdc9bec)(matchValue[1])
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a datetime",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a datetime",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$bba860f70a1c641b(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = (0, $6ed86d8a11a8516b$export$5805e19da86cbb3c)();
        matchValue = [
            (0, $6ed86d8a11a8516b$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $6ed86d8a11a8516b$export$3230e995afdc9bec)(matchValue[1])
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a datetime",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a datetime",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$7dda925e4d5db125(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = (0, $6ed86d8a11a8516b$export$5805e19da86cbb3c)();
        matchValue = [
            (0, $6ed86d8a11a8516b$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            matchValue[1]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a datetime",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a datetime",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$d44d82300fe8076b(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = (0, $d85d237bf9fec1b6$export$5805e19da86cbb3c)();
        matchValue = [
            (0, $d85d237bf9fec1b6$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            matchValue[1]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a datetimeoffset",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a datetime",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$f5d579fa0450f175(path, value_1) {
    if (typeof value_1 === "string") {
        let matchValue;
        let outArg = 0;
        matchValue = [
            (0, $47c835136897402a$export$468ff95b83d315e5)(value_1, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v;
            })),
            outArg
        ];
        if (matchValue[0]) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            matchValue[1]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                    "a timespan",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a timespan",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$var$decodeMaybeNull(path, decoder, value_1) {
    if (value_1 == null) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        undefined
    ]);
    else {
        const matchValue = decoder(path, value_1);
        if (matchValue.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            matchValue.fields[0]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(matchValue.fields[0])
        ]);
    }
}
function $34cef9b1902a53c2$export$516e28dec6a4b6d4(fieldName, decoder, path, value_1) {
    if (value_1 === null ? false : Object.getPrototypeOf(value_1 || false) === Object.prototype) {
        const fieldValue = value_1[fieldName];
        if ($34cef9b1902a53c2$export$53a896e75eb468c1(fieldValue)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            undefined
        ]);
        else return $34cef9b1902a53c2$var$decodeMaybeNull(path + "." + fieldName, decoder, fieldValue);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(2, [
                "an object",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$var$badPathError(fieldNames, currentPath, value_1) {
    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(currentPath, (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(".", (0, $e08834e1786645d9$export$8327ebbef2a0ba76)("$", fieldNames))),
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(4, [
                "an object with path `" + (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(".", fieldNames) + "`",
                value_1,
                (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $e08834e1786645d9$export$e5907b21d797cce6)(fieldNames), "")
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$39d612e03251acb2(fieldNames, decoder, firstPath, firstValue) {
    const _arg = (0, $e08834e1786645d9$export$93e2b83da34ff82a)((tupledArg, field_1)=>{
        const curPath = tupledArg[0];
        const curValue = tupledArg[1];
        const res = tupledArg[2];
        if (res == null) {
            if (curValue == null) return [
                curPath,
                curValue,
                new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    undefined
                ])
            ];
            else if (curValue === null ? false : Object.getPrototypeOf(curValue || false) === Object.prototype) return [
                curPath + "." + field_1,
                curValue[field_1],
                undefined
            ];
            else return [
                curPath,
                curValue,
                new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    [
                        curPath,
                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(2, [
                            "an object",
                            curValue
                        ])
                    ]
                ])
            ];
        } else return [
            curPath,
            curValue,
            res
        ];
    }, [
        firstPath,
        firstValue,
        undefined
    ], fieldNames);
    if (_arg[2] == null) {
        const lastValue = _arg[1];
        if ($34cef9b1902a53c2$export$53a896e75eb468c1(lastValue)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            undefined
        ]);
        else return $34cef9b1902a53c2$var$decodeMaybeNull(_arg[0], decoder, lastValue);
    } else return _arg[2];
}
function $34cef9b1902a53c2$export$e0f35d825088c098(fieldName, decoder, path, value_1) {
    if (value_1 === null ? false : Object.getPrototypeOf(value_1 || false) === Object.prototype) {
        const fieldValue = value_1[fieldName];
        if ($34cef9b1902a53c2$export$53a896e75eb468c1(fieldValue)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(3, [
                    "an object with a field named `" + fieldName + "`",
                    value_1
                ])
            ]
        ]);
        else return decoder(path + "." + fieldName, fieldValue);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(2, [
                "an object",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$493d36ec626b6698(fieldNames, decoder, firstPath, firstValue) {
    const _arg = (0, $e08834e1786645d9$export$93e2b83da34ff82a)((tupledArg, field_1)=>{
        const curPath = tupledArg[0];
        const curValue = tupledArg[1];
        const res = tupledArg[2];
        if (res == null) {
            if (curValue == null) return [
                curPath,
                curValue,
                $34cef9b1902a53c2$var$badPathError(fieldNames, curPath, firstValue)
            ];
            else if (curValue === null ? false : Object.getPrototypeOf(curValue || false) === Object.prototype) {
                const curValue_1 = curValue[field_1];
                if ($34cef9b1902a53c2$export$53a896e75eb468c1(curValue_1)) return [
                    curPath,
                    curValue_1,
                    $34cef9b1902a53c2$var$badPathError(fieldNames, undefined, firstValue)
                ];
                else return [
                    curPath + "." + field_1,
                    curValue_1,
                    undefined
                ];
            } else return [
                curPath,
                curValue,
                new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    [
                        curPath,
                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(2, [
                            "an object",
                            curValue
                        ])
                    ]
                ])
            ];
        } else return [
            curPath,
            curValue,
            res
        ];
    }, [
        firstPath,
        firstValue,
        undefined
    ], fieldNames);
    if (_arg[2] == null) return decoder(_arg[0], _arg[1]);
    else return _arg[2];
}
function $34cef9b1902a53c2$export$b610b8812bbcded9(requestedIndex, decoder, path, value_1) {
    let copyOfStruct;
    const currentPath = path + ".[" + (0, $kRS0m.int32ToString)(requestedIndex) + "]";
    if (Array.isArray(value_1)) {
        const vArray = value_1;
        if (requestedIndex < vArray.length) return decoder(currentPath, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(requestedIndex, vArray));
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                currentPath,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(5, [
                    "a longer array. Need index `" + (0, $kRS0m.int32ToString)(requestedIndex) + "` but there are only `" + (copyOfStruct = vArray.length, (0, $kRS0m.int32ToString)(copyOfStruct)) + "` entries",
                    value_1
                ])
            ]
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            currentPath,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "an array",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$a75d1723e6bda2ec(decoder, path, value_1) {
    if (value_1 == null) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        undefined
    ]);
    else return (0, $d06a0138b761f217$export$7eb72553d53998e3)((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd), decoder(path, value_1));
}
function $34cef9b1902a53c2$export$8837f4fc672e936d(decoder, path, value_1) {
    if (Array.isArray(value_1)) {
        let i = -1;
        return (0, $d06a0138b761f217$export$7eb72553d53998e3)((0, $e08834e1786645d9$export$66c1ae025e96b4bc), (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((acc, value_2)=>{
            i = i + 1 | 0;
            if (acc.tag === 0) {
                const matchValue = decoder(path + ".[" + (0, $kRS0m.int32ToString)(i) + "]", value_2);
                if (matchValue.tag === 0) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(matchValue.fields[0], acc.fields[0])
                ]);
                else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    matchValue.fields[0]
                ]);
            } else return acc;
        }, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
        ]), value_1));
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a list",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$1041d4276c328e4d(decoder, path, value_1) {
    if (Array.isArray(value_1)) {
        let i = -1;
        return (0, $d06a0138b761f217$export$7eb72553d53998e3)((0, $42cbcefff7323768$export$66c1ae025e96b4bc), (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((acc, value_2)=>{
            i = i + 1 | 0;
            if (acc.tag === 0) {
                const matchValue = decoder(path + ".[" + (0, $kRS0m.int32ToString)(i) + "]", value_2);
                if (matchValue.tag === 0) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    (0, $42cbcefff7323768$export$10d8903dec122b9d)([
                        matchValue.fields[0]
                    ], acc.fields[0])
                ]);
                else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    matchValue.fields[0]
                ]);
            } else return acc;
        }, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            []
        ]), value_1));
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "a seq",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$2f23118c22fb2630(decoder, path, value_1) {
    if (Array.isArray(value_1)) {
        let i = -1;
        const tokens = value_1;
        return (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((acc, value_2)=>{
            i = i + 1 | 0;
            if (acc.tag === 0) {
                const acc_1 = acc.fields[0];
                const matchValue = decoder(path + ".[" + (0, $kRS0m.int32ToString)(i) + "]", value_2);
                if (matchValue.tag === 0) {
                    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(acc_1, i, matchValue.fields[0]);
                    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                        acc_1
                    ]);
                } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    matchValue.fields[0]
                ]);
            } else return acc;
        }, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(tokens.length), 0, tokens.length, null)
        ]), tokens);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "an array",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$ed97f33186d4b816(path, value_1) {
    if (value_1 === null ? false : Object.getPrototypeOf(value_1 || false) === Object.prototype) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        (0, $e08834e1786645d9$export$c80b5fc7454ef206)(Object.keys(value_1))
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "an object",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$a6b37472941cc417(decoder, path, value_1) {
    const matchValue = $34cef9b1902a53c2$export$ed97f33186d4b816(path, value_1);
    if (matchValue.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        matchValue.fields[0]
    ]);
    else return (0, $d06a0138b761f217$export$7eb72553d53998e3)((0, $e08834e1786645d9$export$66c1ae025e96b4bc), (0, $e08834e1786645d9$export$93e2b83da34ff82a)((acc, prop)=>{
        if (acc.tag === 0) {
            const matchValue_1 = decoder(path, value_1[prop]);
            if (matchValue_1.tag === 0) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                    prop,
                    matchValue_1.fields[0]
                ], acc.fields[0])
            ]);
            else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                matchValue_1.fields[0]
            ]);
        } else return acc;
    }, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
    ]), matchValue.fields[0]));
}
function $34cef9b1902a53c2$export$a9a18ae5ba42aeab(decoders, path, value_1) {
    const runner = (decoders_1_mut, errors_mut)=>{
        runner: while(true){
            const decoders_1 = decoders_1_mut, errors = errors_mut;
            if ((0, $e08834e1786645d9$export$dd1bc94b04021eeb)(decoders_1)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(7, [
                        errors
                    ])
                ]
            ]);
            else {
                const matchValue = $34cef9b1902a53c2$export$5f36b26c3833b3ba(path, (0, $kRS0m.uncurry2)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(decoders_1)), value_1);
                if (matchValue.tag === 1) {
                    decoders_1_mut = (0, $e08834e1786645d9$export$c01875f616615628)(decoders_1);
                    errors_mut = (0, $e08834e1786645d9$export$10d8903dec122b9d)(errors, (0, $e08834e1786645d9$export$439306a4dcaafbb9)(matchValue.fields[0]));
                    continue runner;
                } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    matchValue.fields[0]
                ]);
            }
            break;
        }
    };
    return runner(decoders, (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
}
function $34cef9b1902a53c2$export$f2c4f74e8fe88e34(output, path, value_1) {
    if (value_1 == null) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        output
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "null",
                value_1
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$2ab9a8f9f1186f14(_arg, v) {
    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        v
    ]);
}
function $34cef9b1902a53c2$export$9094b7742a87955e(output, _arg, _arg_1) {
    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        output
    ]);
}
function $34cef9b1902a53c2$export$2b62a06a9fee979c(msg, path, _arg) {
    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(6, [
                msg
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$export$9768a9ae43d7f016(cb, decoder, path, value_1) {
    const matchValue = decoder(path, value_1);
    if (matchValue.tag === 0) return cb(matchValue.fields[0], path, value_1);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        matchValue.fields[0]
    ]);
}
function $34cef9b1902a53c2$export$84bf76cd7afc7469(decoders, path, value_1) {
    const runner = (decoders_1_mut, values_mut)=>{
        runner: while(true){
            const decoders_1 = decoders_1_mut, values = values_mut;
            if ((0, $e08834e1786645d9$export$dd1bc94b04021eeb)(decoders_1)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                values
            ]);
            else {
                const matchValue = (0, $e08834e1786645d9$export$5fd5031fecdacec3)(decoders_1)(path)(value_1);
                if (matchValue.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    matchValue.fields[0]
                ]);
                else {
                    decoders_1_mut = (0, $e08834e1786645d9$export$c01875f616615628)(decoders_1);
                    values_mut = (0, $e08834e1786645d9$export$10d8903dec122b9d)(values, (0, $e08834e1786645d9$export$439306a4dcaafbb9)(matchValue.fields[0]));
                    continue runner;
                }
            }
            break;
        }
    };
    return runner(decoders, (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
}
function $34cef9b1902a53c2$export$871de8747c9eaa88(ctor, d1, path, value_1) {
    const matchValue = d1(path, value_1);
    if (matchValue.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        matchValue.fields[0]
    ]);
    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        ctor(matchValue.fields[0])
    ]);
}
function $34cef9b1902a53c2$export$5be556bf484c4f10(ctor, d1, d2, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0])
        ]);
    }
}
function $34cef9b1902a53c2$export$f7389512af34c855(ctor, d1, d2, d3, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0])
            ]);
        }
    }
}
function $34cef9b1902a53c2$export$dddc425886bb4024(ctor, d1, d2, d3, d4, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const matchValue_3 = d4(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else {
                const copyOfStruct_3 = matchValue_3;
                if (copyOfStruct_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    copyOfStruct_3.fields[0]
                ]);
                else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0], copyOfStruct_3.fields[0])
                ]);
            }
        }
    }
}
function $34cef9b1902a53c2$export$89e0958a4f22698b(ctor, d1, d2, d3, d4, d5, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const matchValue_3 = d4(path, value_1);
    const matchValue_4 = d5(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else {
                const copyOfStruct_3 = matchValue_3;
                if (copyOfStruct_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    copyOfStruct_3.fields[0]
                ]);
                else {
                    const copyOfStruct_4 = matchValue_4;
                    if (copyOfStruct_4.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        copyOfStruct_4.fields[0]
                    ]);
                    else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                        ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0], copyOfStruct_3.fields[0], copyOfStruct_4.fields[0])
                    ]);
                }
            }
        }
    }
}
function $34cef9b1902a53c2$export$93c2dc1c6eacd42c(ctor, d1, d2, d3, d4, d5, d6, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const matchValue_3 = d4(path, value_1);
    const matchValue_4 = d5(path, value_1);
    const matchValue_5 = d6(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else {
                const copyOfStruct_3 = matchValue_3;
                if (copyOfStruct_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    copyOfStruct_3.fields[0]
                ]);
                else {
                    const copyOfStruct_4 = matchValue_4;
                    if (copyOfStruct_4.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        copyOfStruct_4.fields[0]
                    ]);
                    else {
                        const copyOfStruct_5 = matchValue_5;
                        if (copyOfStruct_5.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            copyOfStruct_5.fields[0]
                        ]);
                        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                            ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0], copyOfStruct_3.fields[0], copyOfStruct_4.fields[0], copyOfStruct_5.fields[0])
                        ]);
                    }
                }
            }
        }
    }
}
function $34cef9b1902a53c2$export$a23802bf7d2b7306(ctor, d1, d2, d3, d4, d5, d6, d7, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const matchValue_3 = d4(path, value_1);
    const matchValue_4 = d5(path, value_1);
    const matchValue_5 = d6(path, value_1);
    const matchValue_6 = d7(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else {
                const copyOfStruct_3 = matchValue_3;
                if (copyOfStruct_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    copyOfStruct_3.fields[0]
                ]);
                else {
                    const copyOfStruct_4 = matchValue_4;
                    if (copyOfStruct_4.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        copyOfStruct_4.fields[0]
                    ]);
                    else {
                        const copyOfStruct_5 = matchValue_5;
                        if (copyOfStruct_5.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            copyOfStruct_5.fields[0]
                        ]);
                        else {
                            const copyOfStruct_6 = matchValue_6;
                            if (copyOfStruct_6.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                copyOfStruct_6.fields[0]
                            ]);
                            else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0], copyOfStruct_3.fields[0], copyOfStruct_4.fields[0], copyOfStruct_5.fields[0], copyOfStruct_6.fields[0])
                            ]);
                        }
                    }
                }
            }
        }
    }
}
function $34cef9b1902a53c2$export$308685edec35689e(ctor, d1, d2, d3, d4, d5, d6, d7, d8, path, value_1) {
    const matchValue = d1(path, value_1);
    const matchValue_1 = d2(path, value_1);
    const matchValue_2 = d3(path, value_1);
    const matchValue_3 = d4(path, value_1);
    const matchValue_4 = d5(path, value_1);
    const matchValue_5 = d6(path, value_1);
    const matchValue_6 = d7(path, value_1);
    const matchValue_7 = d8(path, value_1);
    const copyOfStruct = matchValue;
    if (copyOfStruct.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        copyOfStruct.fields[0]
    ]);
    else {
        const copyOfStruct_1 = matchValue_1;
        if (copyOfStruct_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            copyOfStruct_1.fields[0]
        ]);
        else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                copyOfStruct_2.fields[0]
            ]);
            else {
                const copyOfStruct_3 = matchValue_3;
                if (copyOfStruct_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    copyOfStruct_3.fields[0]
                ]);
                else {
                    const copyOfStruct_4 = matchValue_4;
                    if (copyOfStruct_4.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        copyOfStruct_4.fields[0]
                    ]);
                    else {
                        const copyOfStruct_5 = matchValue_5;
                        if (copyOfStruct_5.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            copyOfStruct_5.fields[0]
                        ]);
                        else {
                            const copyOfStruct_6 = matchValue_6;
                            if (copyOfStruct_6.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                copyOfStruct_6.fields[0]
                            ]);
                            else {
                                const copyOfStruct_7 = matchValue_7;
                                if (copyOfStruct_7.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    copyOfStruct_7.fields[0]
                                ]);
                                else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    ctor(copyOfStruct.fields[0], copyOfStruct_1.fields[0], copyOfStruct_2.fields[0], copyOfStruct_3.fields[0], copyOfStruct_4.fields[0], copyOfStruct_5.fields[0], copyOfStruct_6.fields[0], copyOfStruct_7.fields[0])
                                ]);
                            }
                        }
                    }
                }
            }
        }
    }
}
function $34cef9b1902a53c2$export$1ae5bb9217ed77cc() {
    return (d)=>(d_1)=>(path)=>(value_1)=>$34cef9b1902a53c2$export$5be556bf484c4f10((arg, func)=>func(arg), (0, $kRS0m.uncurry2)(d), (0, $kRS0m.uncurry2)(d_1), path, value_1);
}
function $34cef9b1902a53c2$var$unwrapWith(errors, path, decoder, value_1) {
    const matchValue = decoder(path, value_1);
    if (matchValue.tag === 1) {
        errors.push(matchValue.fields[0]);
        return (0, $kRS0m.defaultOf)();
    } else return matchValue.fields[0];
}
class $34cef9b1902a53c2$export$524e184dd1e357e7 {
    constructor(path, v){
        let _this, _this_1;
        this.errors = [];
        this.required = (_this = this, {
            Field (fieldName, decoder) {
                return $34cef9b1902a53c2$var$unwrapWith(_this.errors, path, (path_1, value_1)=>$34cef9b1902a53c2$export$e0f35d825088c098(fieldName, decoder, path_1, value_1), v);
            },
            At (fieldNames, decoder_2) {
                return $34cef9b1902a53c2$var$unwrapWith(_this.errors, path, (firstPath, firstValue)=>$34cef9b1902a53c2$export$493d36ec626b6698(fieldNames, decoder_2, firstPath, firstValue), v);
            },
            Raw (decoder_4) {
                return $34cef9b1902a53c2$var$unwrapWith(_this.errors, path, decoder_4, v);
            }
        });
        this.optional = (_this_1 = this, {
            Field (fieldName_1, decoder_5) {
                return $34cef9b1902a53c2$var$unwrapWith(_this_1.errors, path, (path_2, value_2)=>$34cef9b1902a53c2$export$516e28dec6a4b6d4(fieldName_1, decoder_5, path_2, value_2), v);
            },
            At (fieldNames_1, decoder_7) {
                return $34cef9b1902a53c2$var$unwrapWith(_this_1.errors, path, (firstPath_1, firstValue_1)=>$34cef9b1902a53c2$export$39d612e03251acb2(fieldNames_1, decoder_7, firstPath_1, firstValue_1), v);
            },
            Raw (decoder_9) {
                const matchValue = decoder_9(path, v);
                if (matchValue.tag === 1) {
                    const reason = matchValue.fields[0][1];
                    const error = matchValue.fields[0];
                    let matchResult, v_2;
                    switch(reason.tag){
                        case 3:
                        case 4:
                            matchResult = 1;
                            break;
                        case 5:
                        case 6:
                        case 7:
                            matchResult = 2;
                            break;
                        case 1:
                            matchResult = 0;
                            v_2 = reason.fields[1];
                            break;
                        case 2:
                            matchResult = 0;
                            v_2 = reason.fields[1];
                            break;
                        default:
                            matchResult = 0;
                            v_2 = reason.fields[1];
                    }
                    switch(matchResult){
                        case 0:
                            if (v_2 == null) return undefined;
                            else {
                                _this_1.errors.push(error);
                                return (0, $kRS0m.defaultOf)();
                            }
                        case 1:
                            return undefined;
                        default:
                            _this_1.errors.push(error);
                            return (0, $kRS0m.defaultOf)();
                    }
                } else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(matchValue.fields[0]);
            }
        });
    }
    get Required() {
        const __ = this;
        return __.required;
    }
    get Optional() {
        const __ = this;
        return __.optional;
    }
}
function $34cef9b1902a53c2$export$f3527236ee6e7d1e(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Thoth.Json.Decode.Getters`1", [
        gen0
    ], $34cef9b1902a53c2$export$524e184dd1e357e7);
}
function $34cef9b1902a53c2$export$c5119ddb1210078(path, v) {
    return new $34cef9b1902a53c2$export$524e184dd1e357e7(path, v);
}
function $34cef9b1902a53c2$export$a09539cea969898e(__) {
    return (0, $42cbcefff7323768$export$effcdbd76139450)(__.errors);
}
function $34cef9b1902a53c2$export$be5493f9613cbbe(builder, path, v) {
    const getters = $34cef9b1902a53c2$export$c5119ddb1210078(path, v);
    const result = builder(getters);
    const matchValue = $34cef9b1902a53c2$export$a09539cea969898e(getters);
    if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(matchValue)) {
        const errors = matchValue;
        if ((0, $e08834e1786645d9$export$f24224f1c91d8156)(errors) > 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            [
                path,
                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(7, [
                    (0, $e08834e1786645d9$export$871de8747c9eaa88)((tupledArg)=>$34cef9b1902a53c2$var$errorToString(tupledArg[0], tupledArg[1]), errors)
                ])
            ]
        ]);
        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
            (0, $e08834e1786645d9$export$5fd5031fecdacec3)(matchValue)
        ]);
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        result
    ]);
}
function $34cef9b1902a53c2$export$92cb60c38e93b2cb(decoder1, decoder2) {
    let decoder_3;
    const decoder = decoder1;
    decoder_3 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_3)=>(value_4)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_2;
                const decoder_1 = decoder2;
                decoder_2 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_2)=>(value_3)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v2, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                v1,
                                v2
                            ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_2), path_2, value_3);
            }), (0, $kRS0m.uncurry2)(decoder_3), path_3, value_4);
}
function $34cef9b1902a53c2$export$7664ff7197245275(decoder1, decoder2, decoder3) {
    let decoder_5;
    const decoder = decoder1;
    decoder_5 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_5)=>(value_6)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_4;
                const decoder_1 = decoder2;
                decoder_4 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_4)=>(value_5)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_3;
                            const decoder_2 = decoder3;
                            decoder_3 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_3)=>(value_4)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v3, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                            v1,
                                            v2,
                                            v3
                                        ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_3), path_3, value_4);
                        }), (0, $kRS0m.uncurry2)(decoder_4), path_4, value_5);
            }), (0, $kRS0m.uncurry2)(decoder_5), path_5, value_6);
}
function $34cef9b1902a53c2$export$b14eba571629e996(decoder1, decoder2, decoder3, decoder4) {
    let decoder_7;
    const decoder = decoder1;
    decoder_7 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_7)=>(value_8)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_6;
                const decoder_1 = decoder2;
                decoder_6 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_6)=>(value_7)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_5;
                            const decoder_2 = decoder3;
                            decoder_5 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_5)=>(value_6)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v3)=>{
                                        let decoder_4;
                                        const decoder_3 = decoder4;
                                        decoder_4 = (path_3)=>(value_4)=>$34cef9b1902a53c2$export$b610b8812bbcded9(3, decoder_3, path_3, value_4);
                                        return (path_4)=>(value_5)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v4, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                                        v1,
                                                        v2,
                                                        v3,
                                                        v4
                                                    ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_4), path_4, value_5);
                                    }), (0, $kRS0m.uncurry2)(decoder_5), path_5, value_6);
                        }), (0, $kRS0m.uncurry2)(decoder_6), path_6, value_7);
            }), (0, $kRS0m.uncurry2)(decoder_7), path_7, value_8);
}
function $34cef9b1902a53c2$export$51158e295b814981(decoder1, decoder2, decoder3, decoder4, decoder5) {
    let decoder_9;
    const decoder = decoder1;
    decoder_9 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_9)=>(value_10)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_8;
                const decoder_1 = decoder2;
                decoder_8 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_8)=>(value_9)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_7;
                            const decoder_2 = decoder3;
                            decoder_7 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_7)=>(value_8)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v3)=>{
                                        let decoder_6;
                                        const decoder_3 = decoder4;
                                        decoder_6 = (path_3)=>(value_4)=>$34cef9b1902a53c2$export$b610b8812bbcded9(3, decoder_3, path_3, value_4);
                                        return (path_6)=>(value_7)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v4)=>{
                                                    let decoder_5;
                                                    const decoder_4 = decoder5;
                                                    decoder_5 = (path_4)=>(value_5)=>$34cef9b1902a53c2$export$b610b8812bbcded9(4, decoder_4, path_4, value_5);
                                                    return (path_5)=>(value_6)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v5, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                                                    v1,
                                                                    v2,
                                                                    v3,
                                                                    v4,
                                                                    v5
                                                                ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_5), path_5, value_6);
                                                }), (0, $kRS0m.uncurry2)(decoder_6), path_6, value_7);
                                    }), (0, $kRS0m.uncurry2)(decoder_7), path_7, value_8);
                        }), (0, $kRS0m.uncurry2)(decoder_8), path_8, value_9);
            }), (0, $kRS0m.uncurry2)(decoder_9), path_9, value_10);
}
function $34cef9b1902a53c2$export$f52b7ee4eabdb261(decoder1, decoder2, decoder3, decoder4, decoder5, decoder6) {
    let decoder_11;
    const decoder = decoder1;
    decoder_11 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_11)=>(value_12)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_10;
                const decoder_1 = decoder2;
                decoder_10 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_10)=>(value_11)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_9;
                            const decoder_2 = decoder3;
                            decoder_9 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_9)=>(value_10)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v3)=>{
                                        let decoder_8;
                                        const decoder_3 = decoder4;
                                        decoder_8 = (path_3)=>(value_4)=>$34cef9b1902a53c2$export$b610b8812bbcded9(3, decoder_3, path_3, value_4);
                                        return (path_8)=>(value_9)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v4)=>{
                                                    let decoder_7;
                                                    const decoder_4 = decoder5;
                                                    decoder_7 = (path_4)=>(value_5)=>$34cef9b1902a53c2$export$b610b8812bbcded9(4, decoder_4, path_4, value_5);
                                                    return (path_7)=>(value_8)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v5)=>{
                                                                let decoder_6;
                                                                const decoder_5 = decoder6;
                                                                decoder_6 = (path_5)=>(value_6)=>$34cef9b1902a53c2$export$b610b8812bbcded9(5, decoder_5, path_5, value_6);
                                                                return (path_6)=>(value_7)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v6, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                                                                v1,
                                                                                v2,
                                                                                v3,
                                                                                v4,
                                                                                v5,
                                                                                v6
                                                                            ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_6), path_6, value_7);
                                                            }), (0, $kRS0m.uncurry2)(decoder_7), path_7, value_8);
                                                }), (0, $kRS0m.uncurry2)(decoder_8), path_8, value_9);
                                    }), (0, $kRS0m.uncurry2)(decoder_9), path_9, value_10);
                        }), (0, $kRS0m.uncurry2)(decoder_10), path_10, value_11);
            }), (0, $kRS0m.uncurry2)(decoder_11), path_11, value_12);
}
function $34cef9b1902a53c2$export$16acf2602fbdbf83(decoder1, decoder2, decoder3, decoder4, decoder5, decoder6, decoder7) {
    let decoder_13;
    const decoder = decoder1;
    decoder_13 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_13)=>(value_14)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_12;
                const decoder_1 = decoder2;
                decoder_12 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_12)=>(value_13)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_11;
                            const decoder_2 = decoder3;
                            decoder_11 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_11)=>(value_12)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v3)=>{
                                        let decoder_10;
                                        const decoder_3 = decoder4;
                                        decoder_10 = (path_3)=>(value_4)=>$34cef9b1902a53c2$export$b610b8812bbcded9(3, decoder_3, path_3, value_4);
                                        return (path_10)=>(value_11)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v4)=>{
                                                    let decoder_9;
                                                    const decoder_4 = decoder5;
                                                    decoder_9 = (path_4)=>(value_5)=>$34cef9b1902a53c2$export$b610b8812bbcded9(4, decoder_4, path_4, value_5);
                                                    return (path_9)=>(value_10)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v5)=>{
                                                                let decoder_8;
                                                                const decoder_5 = decoder6;
                                                                decoder_8 = (path_5)=>(value_6)=>$34cef9b1902a53c2$export$b610b8812bbcded9(5, decoder_5, path_5, value_6);
                                                                return (path_8)=>(value_9)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v6)=>{
                                                                            let decoder_7;
                                                                            const decoder_6 = decoder7;
                                                                            decoder_7 = (path_6)=>(value_7)=>$34cef9b1902a53c2$export$b610b8812bbcded9(6, decoder_6, path_6, value_7);
                                                                            return (path_7)=>(value_8)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v7, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                                                                            v1,
                                                                                            v2,
                                                                                            v3,
                                                                                            v4,
                                                                                            v5,
                                                                                            v6,
                                                                                            v7
                                                                                        ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_7), path_7, value_8);
                                                                        }), (0, $kRS0m.uncurry2)(decoder_8), path_8, value_9);
                                                            }), (0, $kRS0m.uncurry2)(decoder_9), path_9, value_10);
                                                }), (0, $kRS0m.uncurry2)(decoder_10), path_10, value_11);
                                    }), (0, $kRS0m.uncurry2)(decoder_11), path_11, value_12);
                        }), (0, $kRS0m.uncurry2)(decoder_12), path_12, value_13);
            }), (0, $kRS0m.uncurry2)(decoder_13), path_13, value_14);
}
function $34cef9b1902a53c2$export$258c90b8fff5318e(decoder1, decoder2, decoder3, decoder4, decoder5, decoder6, decoder7, decoder8) {
    let decoder_15;
    const decoder = decoder1;
    decoder_15 = (path)=>(value_1)=>$34cef9b1902a53c2$export$b610b8812bbcded9(0, decoder, path, value_1);
    return (path_15)=>(value_16)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v1)=>{
                let decoder_14;
                const decoder_1 = decoder2;
                decoder_14 = (path_1)=>(value_2)=>$34cef9b1902a53c2$export$b610b8812bbcded9(1, decoder_1, path_1, value_2);
                return (path_14)=>(value_15)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v2)=>{
                            let decoder_13;
                            const decoder_2 = decoder3;
                            decoder_13 = (path_2)=>(value_3)=>$34cef9b1902a53c2$export$b610b8812bbcded9(2, decoder_2, path_2, value_3);
                            return (path_13)=>(value_14)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v3)=>{
                                        let decoder_12;
                                        const decoder_3 = decoder4;
                                        decoder_12 = (path_3)=>(value_4)=>$34cef9b1902a53c2$export$b610b8812bbcded9(3, decoder_3, path_3, value_4);
                                        return (path_12)=>(value_13)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v4)=>{
                                                    let decoder_11;
                                                    const decoder_4 = decoder5;
                                                    decoder_11 = (path_4)=>(value_5)=>$34cef9b1902a53c2$export$b610b8812bbcded9(4, decoder_4, path_4, value_5);
                                                    return (path_11)=>(value_12)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v5)=>{
                                                                let decoder_10;
                                                                const decoder_5 = decoder6;
                                                                decoder_10 = (path_5)=>(value_6)=>$34cef9b1902a53c2$export$b610b8812bbcded9(5, decoder_5, path_5, value_6);
                                                                return (path_10)=>(value_11)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v6)=>{
                                                                            let decoder_9;
                                                                            const decoder_6 = decoder7;
                                                                            decoder_9 = (path_6)=>(value_7)=>$34cef9b1902a53c2$export$b610b8812bbcded9(6, decoder_6, path_6, value_7);
                                                                            return (path_9)=>(value_10)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((0, $kRS0m.uncurry3)((v7)=>{
                                                                                        let decoder_8;
                                                                                        const decoder_7 = decoder8;
                                                                                        decoder_8 = (path_7)=>(value_8)=>$34cef9b1902a53c2$export$b610b8812bbcded9(7, decoder_7, path_7, value_8);
                                                                                        return (path_8)=>(value_9)=>$34cef9b1902a53c2$export$9768a9ae43d7f016((v8, arg10$0040, arg20$0040)=>$34cef9b1902a53c2$export$9094b7742a87955e([
                                                                                                        v1,
                                                                                                        v2,
                                                                                                        v3,
                                                                                                        v4,
                                                                                                        v5,
                                                                                                        v6,
                                                                                                        v7,
                                                                                                        v8
                                                                                                    ], arg10$0040, arg20$0040), (0, $kRS0m.uncurry2)(decoder_8), path_8, value_9);
                                                                                    }), (0, $kRS0m.uncurry2)(decoder_9), path_9, value_10);
                                                                        }), (0, $kRS0m.uncurry2)(decoder_10), path_10, value_11);
                                                            }), (0, $kRS0m.uncurry2)(decoder_11), path_11, value_12);
                                                }), (0, $kRS0m.uncurry2)(decoder_12), path_12, value_13);
                                    }), (0, $kRS0m.uncurry2)(decoder_13), path_13, value_14);
                        }), (0, $kRS0m.uncurry2)(decoder_14), path_14, value_15);
            }), (0, $kRS0m.uncurry2)(decoder_15), path_15, value_16);
}
function $34cef9b1902a53c2$export$b7eef48498bbd53e(decoder) {
    let d;
    const decoder_1 = decoder;
    d = (path)=>(value_1)=>$34cef9b1902a53c2$export$a6b37472941cc417(decoder_1, path, value_1);
    return (path_1)=>(value_2)=>$34cef9b1902a53c2$export$871de8747c9eaa88((elements)=>(0, $cee18de5b874f6d4$export$97ef4da51e4fceb3)(elements, {
                    Compare: (0, $kRS0m.comparePrimitives)
                }), (0, $kRS0m.uncurry2)(d), path_1, value_2);
}
function $34cef9b1902a53c2$export$1dad060c4b418921(keyDecoder, valueDecoder) {
    let d;
    const decoder = $34cef9b1902a53c2$export$92cb60c38e93b2cb(keyDecoder, valueDecoder);
    d = (path)=>(value_1)=>$34cef9b1902a53c2$export$2f23118c22fb2630((0, $kRS0m.uncurry2)(decoder), path, value_1);
    return (path_1)=>(value_2)=>$34cef9b1902a53c2$export$871de8747c9eaa88((elements)=>(0, $cee18de5b874f6d4$export$c80b5fc7454ef206)(elements, {
                    Compare: (0, $kRS0m.compare)
                }), (0, $kRS0m.uncurry2)(d), path_1, value_2);
}
function $34cef9b1902a53c2$var$toMap(xs) {
    return (0, $cee18de5b874f6d4$export$c80b5fc7454ef206)(xs, {
        Compare: (0, $kRS0m.compare)
    });
}
function $34cef9b1902a53c2$var$toSet(xs) {
    return (0, $70b963136d0d9ffe$export$c80b5fc7454ef206)(xs, {
        Compare: (0, $kRS0m.compare)
    });
}
function $34cef9b1902a53c2$var$autoObject(decoderInfos, path, value_1) {
    if (!(value_1 === null ? false : Object.getPrototypeOf(value_1 || false) === Object.prototype)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "an object",
                value_1
            ])
        ]
    ]);
    else return (0, $e5d9070e144b905e$export$c38b8353041a4f48)((tupledArg, acc)=>{
        const name = tupledArg[0];
        if (acc.tag === 0) return (0, $d06a0138b761f217$export$7eb72553d53998e3)((v)=>(0, $e08834e1786645d9$export$8327ebbef2a0ba76)(v, acc.fields[0]), tupledArg[1](path + "." + name)(value_1[name]));
        else return acc;
    }, decoderInfos, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
    ]));
}
function $34cef9b1902a53c2$var$autoObject2(keyDecoder, valueDecoder, path, value_1) {
    if (!(value_1 === null ? false : Object.getPrototypeOf(value_1 || false) === Object.prototype)) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                "an object",
                value_1
            ])
        ]
    ]);
    else return (0, $42cbcefff7323768$export$93e2b83da34ff82a)((acc, name)=>{
        if (acc.tag === 0) {
            const matchValue = keyDecoder(path, name);
            if (matchValue.tag === 0) {
                const _arg = valueDecoder(path + "." + name, value_1[name]);
                if (_arg.tag === 0) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                        matchValue.fields[0],
                        _arg.fields[0]
                    ], acc.fields[0])
                ]);
                else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                    _arg.fields[0]
                ]);
            } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                matchValue.fields[0]
            ]);
        } else return acc;
    }, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
    ]), Object.keys(value_1));
}
function $34cef9b1902a53c2$var$mixedArray(offset, decoders, path, values) {
    let arg_1;
    const expectedLength = decoders.length + offset | 0;
    if (expectedLength !== values.length) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(6, [
                (arg_1 = values.length | 0, (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Expected array of length %i but got %i"))(expectedLength)(arg_1))
            ])
        ]
    ]);
    else {
        let result = new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
        ]);
        for(let i = offset; i <= values.length - 1; i++)if (result.tag === 0) {
            const acc = result.fields[0];
            const path_1 = (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%s[%i]"))(path)(i);
            const decoder = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i - offset, decoders);
            const value_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, values);
            result = (0, $d06a0138b761f217$export$7eb72553d53998e3)((v)=>(0, $e08834e1786645d9$export$8327ebbef2a0ba76)(v, acc), decoder(path_1)(value_1));
        }
        return (0, $d06a0138b761f217$export$7eb72553d53998e3)((0, $e08834e1786645d9$export$66c1ae025e96b4bc), result);
    }
}
function $34cef9b1902a53c2$var$makeUnion(extra, caseStrategy, t, name, path, values) {
    const uci = (0, $e5d9070e144b905e$export$d65cb303b863e3bf)((x)=>(0, $3921efb06a31e9cc$export$a8ff84c12d48cfa6)(x) === name, (0, $3921efb06a31e9cc$export$9842ee3eadac7211)(t, true));
    if (uci != null) {
        const uci_1 = uci;
        const decoders = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((fi)=>$34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, fi[1]), (0, $3921efb06a31e9cc$export$309400f473e3880b)(uci_1));
        return (0, $d06a0138b761f217$export$7eb72553d53998e3)((values_2)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(uci_1, (0, $e08834e1786645d9$export$45b10814cc054894)(values_2), true), decoders.length === 0 && values.length <= 1 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
        ]) : $34cef9b1902a53c2$var$mixedArray(1, decoders, path, values));
    } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        [
            path,
            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(6, [
                "Cannot find case " + name + " in " + (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t)
            ])
        ]
    ]);
}
function $34cef9b1902a53c2$var$autoDecodeRecordsAndUnions(extra, caseStrategy, isOptional, t) {
    let arg;
    const decoderRef = new (0, $eATN7.FSharpRef)((0, $kRS0m.defaultOf)());
    let extra_1;
    const matchValue = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
    extra_1 = matchValue === "" ? extra : (0, $cee18de5b874f6d4$export$e16d8520af44a096)(matchValue, decoderRef, extra);
    let decoder;
    if ((0, $3921efb06a31e9cc$export$6ba840931da50680)(t, true)) {
        const decoders = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((fi)=>[
                (0, $5c30c14fc487c53f$export$961cef5fdb5fe03c)(caseStrategy, (0, $3921efb06a31e9cc$export$a8ff84c12d48cfa6)(fi)),
                $34cef9b1902a53c2$var$autoDecoder(extra_1, caseStrategy, false, fi[1])
            ], (0, $3921efb06a31e9cc$export$b0ab498daed3dd7f)(t, true));
        decoder = (path)=>(value_1)=>(0, $d06a0138b761f217$export$7eb72553d53998e3)((xs)=>(0, $3921efb06a31e9cc$export$b58500a28530c18)(t, (0, $e08834e1786645d9$export$45b10814cc054894)(xs), true), $34cef9b1902a53c2$var$autoObject(decoders, path, value_1));
    } else if ((0, $3921efb06a31e9cc$export$99587fd450e9f2d)(t, true)) decoder = (path_1)=>(value_2)=>{
            if (typeof value_2 === "string") return $34cef9b1902a53c2$var$makeUnion(extra_1, caseStrategy, t, value_2, path_1, []);
            else if (Array.isArray(value_2)) {
                const values = value_2;
                return (0, $d06a0138b761f217$export$231ecfcfaf6b3fe)((name_2)=>$34cef9b1902a53c2$var$makeUnion(extra_1, caseStrategy, t, name_2, path_1, values), $34cef9b1902a53c2$export$22b082955e083ec3(path_1 + "[0]", (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, values)));
            } else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_1,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                        "a string or array",
                        value_2
                    ])
                ]
            ]);
        };
    else if (isOptional) decoder = (path_2)=>(value_3)=>new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                [
                    path_2,
                    new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(2, [
                        "an extra coder for " + (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t),
                        value_3
                    ])
                ]
            ]);
    else throw new Error((arg = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t), (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Cannot generate auto decoder for %s. Please pass an extra decoder.\n\nDocumentation available at: https://thoth-org.github.io/Thoth.Json/documentation/auto/extra-coders.html#ready-to-use-extra-coders"))(arg)));
    decoderRef.contents = decoder;
    return decoder;
}
function $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, isOptional, t) {
    let decoder_13, decoder_14, decoder_15, decoder_16;
    const fullname = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
    const matchValue = (0, $cee18de5b874f6d4$export$d65cb303b863e3bf)(fullname, extra);
    if (matchValue == null) {
        if ((0, $3921efb06a31e9cc$export$43bee75e5e14138e)(t)) {
            const decoder = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $3921efb06a31e9cc$export$cc56411ddc6ec102)(t));
            return (path_1)=>(value_2)=>$34cef9b1902a53c2$export$2f23118c22fb2630((0, $kRS0m.uncurry2)(decoder), path_1, value_2);
        } else if ((0, $3921efb06a31e9cc$export$9fc8c979231a883)(t)) {
            const enumType = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)((0, $3921efb06a31e9cc$export$1e17737c7179d31d)(t));
            switch(enumType){
                case "System.SByte":
                    return (path_2)=>(value_4)=>{
                            const t_2 = t;
                            const path_3 = path_2;
                            const value_5 = value_4;
                            const matchValue_1 = $34cef9b1902a53c2$export$d03d8c52dd769681(path_3)(value_5);
                            if (matchValue_1.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_1.fields[0]
                            ]);
                            else {
                                const enumValue = matchValue_1.fields[0] | 0;
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_2), {
                                    Equals: (x, y)=>x === y,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_2, enumValue.toString())
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_3,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_2),
                                            value_5,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                case "System.Byte":
                    return (path_4)=>(value_7)=>{
                            const t_3 = t;
                            const path_5 = path_4;
                            const value_8 = value_7;
                            const matchValue_2 = $34cef9b1902a53c2$export$9f5d4a7c57665797(path_5)(value_8);
                            if (matchValue_2.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_2.fields[0]
                            ]);
                            else {
                                const enumValue_1 = matchValue_2.fields[0];
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue_1, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_3), {
                                    Equals: (x_1, y_1)=>x_1 === y_1,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_3, enumValue_1.toString())
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_5,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_3),
                                            value_8,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                case "System.Int16":
                    return (path_6)=>(value_10)=>{
                            const t_4 = t;
                            const path_7 = path_6;
                            const value_11 = value_10;
                            const matchValue_3 = $34cef9b1902a53c2$export$c35c15c7caeff2b6(path_7)(value_11);
                            if (matchValue_3.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_3.fields[0]
                            ]);
                            else {
                                const enumValue_2 = matchValue_3.fields[0] | 0;
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue_2, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_4), {
                                    Equals: (x_2, y_2)=>x_2 === y_2,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_4, (0, $kRS0m.int16ToString)(enumValue_2))
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_7,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_4),
                                            value_11,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                case "System.UInt16":
                    return (path_8)=>(value_13)=>{
                            const t_5 = t;
                            const path_9 = path_8;
                            const value_14 = value_13;
                            const matchValue_4 = $34cef9b1902a53c2$export$56bd24b5a3ee8456(path_9)(value_14);
                            if (matchValue_4.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_4.fields[0]
                            ]);
                            else {
                                const enumValue_3 = matchValue_4.fields[0];
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue_3, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_5), {
                                    Equals: (x_3, y_3)=>x_3 === y_3,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_5, enumValue_3.toString())
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_9,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_5),
                                            value_14,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                case "System.Int32":
                    return (path_10)=>(value_16)=>{
                            const t_6 = t;
                            const path_11 = path_10;
                            const value_17 = value_16;
                            const matchValue_5 = $34cef9b1902a53c2$export$7d260a2a5f8bc19e(path_11)(value_17);
                            if (matchValue_5.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_5.fields[0]
                            ]);
                            else {
                                const enumValue_4 = matchValue_5.fields[0] | 0;
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue_4, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_6), {
                                    Equals: (x_4, y_4)=>x_4 === y_4,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_6, (0, $kRS0m.int32ToString)(enumValue_4))
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_11,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_6),
                                            value_17,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                case "System.UInt32":
                    return (path_12)=>(value_19)=>{
                            const t_7 = t;
                            const path_13 = path_12;
                            const value_20 = value_19;
                            const matchValue_6 = $34cef9b1902a53c2$export$de9ffb9418dd7d0d(path_13)(value_20);
                            if (matchValue_6.tag === 1) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                matchValue_6.fields[0]
                            ]);
                            else {
                                const enumValue_5 = matchValue_6.fields[0];
                                return (0, $42cbcefff7323768$export$2344b14b097df817)(enumValue_5, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)(t_7), {
                                    Equals: (x_5, y_5)=>x_5 === y_5,
                                    GetHashCode: (0, $kRS0m.numberHash)
                                }) ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                    (0, $3921efb06a31e9cc$export$b5de0eeb63903617)(t_7, enumValue_5.toString())
                                ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                    [
                                        path_13,
                                        new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(1, [
                                            (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t_7),
                                            value_20,
                                            "Unkown value provided for the enum"
                                        ])
                                    ]
                                ]);
                            }
                        };
                default:
                    {
                        const arg = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
                        const clo_1 = (0, $7802b3aa01031554$export$c5eda7bb099ceb11)((0, $7802b3aa01031554$export$d1317194012d6b34)("Cannot generate auto decoder for %s.\nThoth.Json.Net only support the following enum types:\n- sbyte\n- byte\n- int16\n- uint16\n- int\n- uint32\nIf you can\'t use one of these types, please pass an extra decoder.\n                    "))(arg);
                        return (arg_1)=>{
                            const clo_2 = clo_1(arg_1);
                            return clo_2;
                        };
                    }
            }
        } else if ((0, $3921efb06a31e9cc$export$6fbcf00b2c9d37c4)(t)) {
            if ((0, $3921efb06a31e9cc$export$62b73b2f8f623580)(t)) {
                const decoders = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((t_8)=>$34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, t_8), (0, $3921efb06a31e9cc$export$1f28650e18437653)(t));
                return (path_14)=>(value_21)=>Array.isArray(value_21) ? (0, $d06a0138b761f217$export$7eb72553d53998e3)((xs)=>(0, $3921efb06a31e9cc$export$f3583c34ca02a326)((0, $e08834e1786645d9$export$45b10814cc054894)(xs), t), $34cef9b1902a53c2$var$mixedArray(0, decoders, path_14, value_21)) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            [
                                path_14,
                                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                                    "an array",
                                    value_21
                                ])
                            ]
                        ]);
            } else {
                const fullname_1 = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)((0, $3921efb06a31e9cc$export$615e91928d222e7d)(t));
                switch(fullname_1){
                    case "Microsoft.FSharp.Core.FSharpOption`1[System.Object]":
                        return decoder_13 = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, true, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t))), (path_15)=>(value_22)=>$34cef9b1902a53c2$export$a75d1723e6bda2ec((0, $kRS0m.uncurry2)(decoder_13), path_15, value_22);
                    case "Microsoft.FSharp.Collections.FSharpList`1[System.Object]":
                        return decoder_14 = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t))), (path_16)=>(value_23)=>$34cef9b1902a53c2$export$8837f4fc672e936d((0, $kRS0m.uncurry2)(decoder_14), path_16, value_23);
                    case "System.Collections.Generic.IEnumerable`1[System.Object]":
                        return decoder_15 = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t))), (path_17)=>(value_24)=>$34cef9b1902a53c2$export$1041d4276c328e4d((0, $kRS0m.uncurry2)(decoder_15), path_17, value_24);
                    case "Microsoft.FSharp.Collections.FSharpMap`2[System.Object,System.Object]":
                        {
                            const keyDecoder = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)));
                            const valueDecoder = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)));
                            let d_20;
                            const decoders_1 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                                (path_18)=>(value_25)=>$34cef9b1902a53c2$var$autoObject2((0, $kRS0m.uncurry2)(keyDecoder), (0, $kRS0m.uncurry2)(valueDecoder), path_18, value_25),
                                (decoder_16 = $34cef9b1902a53c2$export$92cb60c38e93b2cb((0, $kRS0m.uncurry2)(keyDecoder), (0, $kRS0m.uncurry2)(valueDecoder)), (path_19)=>(value_26)=>$34cef9b1902a53c2$export$8837f4fc672e936d((0, $kRS0m.uncurry2)(decoder_16), path_19, value_26))
                            ]);
                            d_20 = (path_20)=>(value_27)=>$34cef9b1902a53c2$export$a9a18ae5ba42aeab(decoders_1, path_20, value_27);
                            return (path_21)=>(value_29)=>$34cef9b1902a53c2$export$871de8747c9eaa88($34cef9b1902a53c2$var$toMap, (0, $kRS0m.uncurry2)(d_20), path_21, value_29);
                        }
                    case "Microsoft.FSharp.Collections.FSharpSet`1[System.Object]":
                        {
                            const decoder_17 = $34cef9b1902a53c2$var$autoDecoder(extra, caseStrategy, false, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)));
                            return (path_22)=>(value_30)=>{
                                    const matchValue_7 = $34cef9b1902a53c2$export$2f23118c22fb2630((0, $kRS0m.uncurry2)(decoder_17), path_22, value_30);
                                    return matchValue_7.tag === 0 ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                                        $34cef9b1902a53c2$var$toSet(matchValue_7.fields[0])
                                    ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                                        matchValue_7.fields[0]
                                    ]);
                                };
                        }
                    default:
                        return $34cef9b1902a53c2$var$autoDecodeRecordsAndUnions(extra, caseStrategy, isOptional, t);
                }
            }
        } else switch(fullname){
            case "System.Boolean":
                return (path_23)=>(value_32)=>$34cef9b1902a53c2$export$87b259aa03e3d267(path_23, value_32);
            case "Microsoft.FSharp.Core.Unit":
                return (path_24)=>(value_33)=>$34cef9b1902a53c2$export$523c0b569236b342(path_24, value_33);
            case "System.String":
                return (path_25)=>(value_34)=>$34cef9b1902a53c2$export$22b082955e083ec3(path_25, value_34);
            case "System.Char":
                return (path_26)=>(value_35)=>$34cef9b1902a53c2$export$eba6f6f03b0a92e7(path_26, value_35);
            case "System.SByte":
                return $34cef9b1902a53c2$export$d03d8c52dd769681;
            case "System.Byte":
                return $34cef9b1902a53c2$export$9f5d4a7c57665797;
            case "System.Int16":
                return $34cef9b1902a53c2$export$c35c15c7caeff2b6;
            case "System.UInt16":
                return $34cef9b1902a53c2$export$56bd24b5a3ee8456;
            case "System.Int32":
                return $34cef9b1902a53c2$export$7d260a2a5f8bc19e;
            case "System.UInt32":
                return $34cef9b1902a53c2$export$de9ffb9418dd7d0d;
            case "System.Double":
                return (path_27)=>(value_36)=>$34cef9b1902a53c2$export$6b5cd3983e3ee5ab(path_27, value_36);
            case "System.Single":
                return (path_28)=>(value_37)=>$34cef9b1902a53c2$export$1a4bac2aea11f30e(path_28, value_37);
            case "System.DateTime":
                return (path_29)=>(value_38)=>$34cef9b1902a53c2$export$bba860f70a1c641b(path_29, value_38);
            case "System.DateTimeOffset":
                return (path_30)=>(value_39)=>$34cef9b1902a53c2$export$d44d82300fe8076b(path_30, value_39);
            case "System.TimeSpan":
                return (path_31)=>(value_40)=>$34cef9b1902a53c2$export$f5d579fa0450f175(path_31, value_40);
            case "System.Guid":
                return (path_32)=>(value_41)=>$34cef9b1902a53c2$export$46e8f25c7328f77e(path_32, value_41);
            case "System.Object":
                return (_arg_6)=>(v)=>new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                            v
                        ]);
            default:
                return $34cef9b1902a53c2$var$autoDecodeRecordsAndUnions(extra, caseStrategy, isOptional, t);
        }
    } else {
        const decoderRef = matchValue;
        return (path)=>(value_1)=>decoderRef.contents(path)(value_1);
    }
}
function $34cef9b1902a53c2$var$makeExtra(extra) {
    if (extra != null) return (0, $cee18de5b874f6d4$export$871de8747c9eaa88)((_arg, tupledArg)=>new (0, $eATN7.FSharpRef)(tupledArg[1]), extra.Coders);
    else return (0, $cee18de5b874f6d4$export$6e22c362a0406a2c)({
        Compare: (0, $kRS0m.comparePrimitives)
    });
}
class $34cef9b1902a53c2$export$6cc2e70440926d44 {
    constructor(){}
}
function $34cef9b1902a53c2$export$e7be7f20cd4d1844() {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Thoth.Json.Decode.Auto", undefined, $34cef9b1902a53c2$export$6cc2e70440926d44);
}
function $34cef9b1902a53c2$export$728f61e20ee47ea8(t, caseStrategy, extra) {
    let y_1, y;
    const caseStrategy_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(caseStrategy, new (0, $5c30c14fc487c53f$export$9e558e3dec30b036)(0, []));
    return (0, $5c30c14fc487c53f$export$13d7539a3e56b28c)((0, $5c30c14fc487c53f$export$3af5a3bafabfd795), (y_1 = (y = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t), (0, $eATN7.toString)(caseStrategy_1) + y), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((e)=>e.Hash, extra), "") + y_1), ()=>$34cef9b1902a53c2$var$autoDecoder($34cef9b1902a53c2$var$makeExtra(extra), caseStrategy_1, false, t));
}
function $34cef9b1902a53c2$export$61f7b9e6d2e5c4(t, caseStrategy, extra) {
    const caseStrategy_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(caseStrategy, new (0, $5c30c14fc487c53f$export$9e558e3dec30b036)(0, []));
    return $34cef9b1902a53c2$var$autoDecoder($34cef9b1902a53c2$var$makeExtra(extra), caseStrategy_1, false, t);
}




var $kRS0m = parcelRequire("kRS0m");

var $fzAFM = parcelRequire("fzAFM");

var $kRS0m = parcelRequire("kRS0m");


var $c7lrN = parcelRequire("c7lrN");





var $eATN7 = parcelRequire("eATN7");





function $619ae88d57e33a2f$export$46e8f25c7328f77e(value) {
    return value;
}
function $619ae88d57e33a2f$export$78a48a3d1e5dbe89(value) {
    return (0, $fzAFM.toString)(value);
}
const $619ae88d57e33a2f$export$f2c4f74e8fe88e34 = (0, $kRS0m.defaultOf)();
function $619ae88d57e33a2f$export$be5493f9613cbbe(values) {
    const o = {};
    const enumerator = (0, $kRS0m.getEnumerator)(values);
    try {
        while(enumerator["System.Collections.IEnumerator.MoveNext"]()){
            const forLoopVar = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            o[forLoopVar[0]] = forLoopVar[1];
        }
    } finally{
        (0, $kRS0m.disposeSafe)(enumerator);
    }
    return o;
}
function $619ae88d57e33a2f$export$8837f4fc672e936d(values) {
    return Array.from(values);
}
function $619ae88d57e33a2f$export$1041d4276c328e4d(values) {
    return Array.from(values);
}
function $619ae88d57e33a2f$export$b7eef48498bbd53e(values) {
    return $619ae88d57e33a2f$export$be5493f9613cbbe((0, $cee18de5b874f6d4$export$effcdbd76139450)(values));
}
function $619ae88d57e33a2f$export$a0f65b52274bcc00(value) {
    return (0, $c7lrN.toString)(value);
}
function $619ae88d57e33a2f$export$d44d82300fe8076b(value) {
    return (0, $6ed86d8a11a8516b$export$f84e8e69fd4488a5)(value, "O", {});
}
function $619ae88d57e33a2f$export$f5d579fa0450f175(value) {
    return (0, $47c835136897402a$export$f84e8e69fd4488a5)(value);
}
function $619ae88d57e33a2f$export$af207e6076994812(value) {
    return String(value);
}
function $619ae88d57e33a2f$export$870002f71f6ee2de(value) {
    return String(value);
}
function $619ae88d57e33a2f$export$523c0b569236b342() {
    return (0, $kRS0m.defaultOf)();
}
function $619ae88d57e33a2f$export$92cb60c38e93b2cb(enc1, enc2, v1, v2) {
    return [
        enc1(v1),
        enc2(v2)
    ];
}
function $619ae88d57e33a2f$export$7664ff7197245275(enc1, enc2, enc3, v1, v2, v3) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3)
    ];
}
function $619ae88d57e33a2f$export$b14eba571629e996(enc1, enc2, enc3, enc4, v1, v2, v3, v4) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3),
        enc4(v4)
    ];
}
function $619ae88d57e33a2f$export$51158e295b814981(enc1, enc2, enc3, enc4, enc5, v1, v2, v3, v4, v5) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3),
        enc4(v4),
        enc5(v5)
    ];
}
function $619ae88d57e33a2f$export$f52b7ee4eabdb261(enc1, enc2, enc3, enc4, enc5, enc6, v1, v2, v3, v4, v5, v6) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3),
        enc4(v4),
        enc5(v5),
        enc6(v6)
    ];
}
function $619ae88d57e33a2f$export$16acf2602fbdbf83(enc1, enc2, enc3, enc4, enc5, enc6, enc7, v1, v2, v3, v4, v5, v6, v7) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3),
        enc4(v4),
        enc5(v5),
        enc6(v6),
        enc7(v7)
    ];
}
function $619ae88d57e33a2f$export$258c90b8fff5318e(enc1, enc2, enc3, enc4, enc5, enc6, enc7, enc8, v1, v2, v3, v4, v5, v6, v7, v8) {
    return [
        enc1(v1),
        enc2(v2),
        enc3(v3),
        enc4(v4),
        enc5(v5),
        enc6(v6),
        enc7(v7),
        enc8(v8)
    ];
}
function $619ae88d57e33a2f$export$871de8747c9eaa88(keyEncoder, valueEncoder, values) {
    return $619ae88d57e33a2f$export$8837f4fc672e936d((0, $e08834e1786645d9$export$871de8747c9eaa88)((tupledArg)=>$619ae88d57e33a2f$export$92cb60c38e93b2cb(keyEncoder, valueEncoder, tupledArg[0], tupledArg[1]), (0, $cee18de5b874f6d4$export$effcdbd76139450)(values)));
}
function $619ae88d57e33a2f$export$1416d16ea4117609(value) {
    return value;
}
function $619ae88d57e33a2f$export$a1e8a75505c05e27(value) {
    return value;
}
function $619ae88d57e33a2f$export$a4da2899f5e9fb4f(value) {
    return value;
}
function $619ae88d57e33a2f$export$362489ea12abc8a0(value) {
    return value;
}
function $619ae88d57e33a2f$export$b3bc4f99534de3b5(value) {
    return value;
}
function $619ae88d57e33a2f$export$865dfed649441da9(value) {
    return value;
}
function $619ae88d57e33a2f$export$7ba4466dbd0f07e1(value) {
    return (0, $6ed86d8a11a8516b$export$f84e8e69fd4488a5)(value, "O", {});
}
function $619ae88d57e33a2f$export$f84e8e69fd4488a5(space, value) {
    return JSON.stringify(value, undefined, (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(space));
}
function $619ae88d57e33a2f$export$a75d1723e6bda2ec(encoder) {
    return (arg)=>(0, $22d1a4cfc5fba7ce$export$c90763f2293d7e67)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)(encoder, arg), ()=>$619ae88d57e33a2f$export$f2c4f74e8fe88e34);
}
function $619ae88d57e33a2f$var$autoEncodeRecordsAndUnions(extra, caseStrategy, skipNullField, t) {
    let arg;
    const encoderRef = new (0, $eATN7.FSharpRef)((0, $kRS0m.defaultOf)());
    let extra_1;
    const matchValue = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
    extra_1 = matchValue === "" ? extra : (0, $cee18de5b874f6d4$export$e16d8520af44a096)(matchValue, encoderRef, extra);
    let encoder;
    if ((0, $3921efb06a31e9cc$export$6ba840931da50680)(t, true)) {
        const setters = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((fi)=>{
            const targetKey = (0, $5c30c14fc487c53f$export$961cef5fdb5fe03c)(caseStrategy, (0, $3921efb06a31e9cc$export$a8ff84c12d48cfa6)(fi));
            const encode_1 = $619ae88d57e33a2f$var$autoEncoder(extra_1, caseStrategy, skipNullField, fi[1]);
            return (source)=>(target)=>{
                    const value = (0, $3921efb06a31e9cc$export$ba212be7256ab0fb)(source, fi);
                    if (!skipNullField ? true : skipNullField && !(value == null)) target[targetKey] = encode_1(value);
                    return target;
                };
        }, (0, $3921efb06a31e9cc$export$b0ab498daed3dd7f)(t, true));
        encoder = (source_1)=>(0, $42cbcefff7323768$export$93e2b83da34ff82a)((target_1, set$)=>set$(source_1)(target_1), {}, setters);
    } else if ((0, $3921efb06a31e9cc$export$99587fd450e9f2d)(t, true)) encoder = (value_1)=>{
        const patternInput = (0, $3921efb06a31e9cc$export$191ac0eced82ce46)(value_1, t, true);
        const info = patternInput[0];
        const fields = patternInput[1];
        const matchValue_1 = fields.length | 0;
        if (matchValue_1 === 0) return (0, $3921efb06a31e9cc$export$a8ff84c12d48cfa6)(info);
        else {
            const len = matchValue_1 | 0;
            const fieldTypes = (0, $3921efb06a31e9cc$export$309400f473e3880b)(info);
            const target_2 = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(len + 1), 0, len + 1, null);
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(target_2, 0, (0, $3921efb06a31e9cc$export$a8ff84c12d48cfa6)(info));
            for(let i = 1; i <= len; i++){
                const encode_2 = $619ae88d57e33a2f$var$autoEncoder(extra_1, caseStrategy, skipNullField, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i - 1, fieldTypes)[1]);
                (0, $e5d9070e144b905e$export$8a8216c44337cd5)(target_2, i, encode_2((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i - 1, fields)));
            }
            return target_2;
        }
    };
    else throw new Error((arg = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t), (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Cannot generate auto encoder for %s. Please pass an extra encoder.\n\nDocumentation available at: https://thoth-org.github.io/Thoth.Json/documentation/auto/extra-coders.html#ready-to-use-extra-coders"))(arg)));
    encoderRef.contents = encoder;
    return encoder;
}
function $619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, t) {
    const fullname = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
    const matchValue = (0, $cee18de5b874f6d4$export$d65cb303b863e3bf)(fullname, extra);
    if (matchValue == null) {
        if ((0, $3921efb06a31e9cc$export$43bee75e5e14138e)(t)) {
            const encoder = $619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, (0, $3921efb06a31e9cc$export$cc56411ddc6ec102)(t));
            return (value)=>$619ae88d57e33a2f$export$1041d4276c328e4d((0, $42cbcefff7323768$export$871de8747c9eaa88)(encoder, value));
        } else if ((0, $3921efb06a31e9cc$export$9fc8c979231a883)(t)) {
            const enumType = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)((0, $3921efb06a31e9cc$export$1e17737c7179d31d)(t));
            switch(enumType){
                case "System.SByte":
                    return (value_1)=>value_1;
                case "System.Byte":
                    return (value_3)=>value_3;
                case "System.Int16":
                    return (value_5)=>value_5;
                case "System.UInt16":
                    return (value_7)=>value_7;
                case "System.Int32":
                    return (value_9)=>value_9;
                case "System.UInt32":
                    return (value_11)=>value_11;
                default:
                    {
                        const arg = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t);
                        const clo_1 = (0, $7802b3aa01031554$export$c5eda7bb099ceb11)((0, $7802b3aa01031554$export$d1317194012d6b34)("Cannot generate auto encoder for %s.\nThoth.Json.Net only support the following enum types:\n- sbyte\n- byte\n- int16\n- uint16\n- int\n- uint32\n\nIf you can\'t use one of these types, please pass an extra encoder.\n\nDocumentation available at: https://thoth-org.github.io/Thoth.Json/documentation/auto/extra-coders.html#ready-to-use-extra-coders\n                    "))(arg);
                        return clo_1;
                    }
            }
        } else if ((0, $3921efb06a31e9cc$export$6fbcf00b2c9d37c4)(t)) {
            if ((0, $3921efb06a31e9cc$export$62b73b2f8f623580)(t)) {
                const encoders = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((t_2)=>$619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, t_2), (0, $3921efb06a31e9cc$export$1f28650e18437653)(t));
                return (value_13)=>$619ae88d57e33a2f$export$1041d4276c328e4d((0, $42cbcefff7323768$export$e5bd5b3b105c2a71)((i, x)=>(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, encoders)(x), (0, $3921efb06a31e9cc$export$6e8639fe0290f3b5)(value_13)));
            } else {
                const fullname_1 = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)((0, $3921efb06a31e9cc$export$615e91928d222e7d)(t));
                if (fullname_1 === "Microsoft.FSharp.Core.FSharpOption`1[System.Object]") {
                    const encoder_2 = new (0, $kRS0m.Lazy)(()=>$619ae88d57e33a2f$export$a75d1723e6bda2ec($619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)))));
                    return (value_14)=>{
                        if (value_14 == null) return $619ae88d57e33a2f$export$f2c4f74e8fe88e34;
                        else return encoder_2.Value(value_14);
                    };
                } else if ((fullname_1 === "Microsoft.FSharp.Collections.FSharpList`1[System.Object]" ? true : fullname_1 === "Microsoft.FSharp.Collections.FSharpSet`1[System.Object]") ? true : fullname_1 === "System.Collections.Generic.IEnumerable`1[System.Object]") {
                    const encoder_3 = $619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)));
                    return (value_15)=>$619ae88d57e33a2f$export$1041d4276c328e4d((0, $42cbcefff7323768$export$871de8747c9eaa88)(encoder_3, value_15));
                } else if (fullname_1 === "Microsoft.FSharp.Collections.FSharpMap`2[System.Object,System.Object]") {
                    const keyType = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t));
                    const valueEncoder = $619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, (0, $3921efb06a31e9cc$export$18737d7a203fc740)(t)));
                    if ((0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(keyType) === "System.String" ? true : (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(keyType) === "System.Guid") return (value_16)=>(0, $42cbcefff7323768$export$93e2b83da34ff82a)((target, _arg)=>{
                            const activePatternResult = _arg;
                            target[activePatternResult[0]] = valueEncoder(activePatternResult[1]);
                            return target;
                        }, {}, value_16);
                    else {
                        let keyEncoder;
                        const clo_2 = $619ae88d57e33a2f$var$autoEncoder(extra, caseStrategy, skipNullField, keyType);
                        keyEncoder = clo_2;
                        return (value_17)=>$619ae88d57e33a2f$export$1041d4276c328e4d((0, $42cbcefff7323768$export$871de8747c9eaa88)((_arg_1)=>{
                                const activePatternResult_1 = _arg_1;
                                return [
                                    keyEncoder(activePatternResult_1[0]),
                                    valueEncoder(activePatternResult_1[1])
                                ];
                            }, value_17));
                    }
                } else return $619ae88d57e33a2f$var$autoEncodeRecordsAndUnions(extra, caseStrategy, skipNullField, t);
            }
        } else switch(fullname){
            case "System.Boolean":
                return (value_18)=>value_18;
            case "Microsoft.FSharp.Core.Unit":
                return $619ae88d57e33a2f$export$523c0b569236b342;
            case "System.String":
                return (value_20)=>value_20;
            case "System.Char":
                return (value_22)=>value_22;
            case "System.SByte":
                return (value_24)=>value_24;
            case "System.Byte":
                return (value_26)=>value_26;
            case "System.Int16":
                return (value_28)=>value_28;
            case "System.UInt16":
                return (value_30)=>value_30;
            case "System.Int32":
                return (value_32)=>value_32;
            case "System.UInt32":
                return (value_34)=>value_34;
            case "System.Double":
                return (value_36)=>value_36;
            case "System.Single":
                return (value_38)=>value_38;
            case "System.DateTime":
                return $619ae88d57e33a2f$export$7ba4466dbd0f07e1;
            case "System.DateTimeOffset":
                return $619ae88d57e33a2f$export$d44d82300fe8076b;
            case "System.TimeSpan":
                return $619ae88d57e33a2f$export$f5d579fa0450f175;
            case "System.Guid":
                return $619ae88d57e33a2f$export$46e8f25c7328f77e;
            case "System.Object":
                return (x_1)=>x_1;
            default:
                return $619ae88d57e33a2f$var$autoEncodeRecordsAndUnions(extra, caseStrategy, skipNullField, t);
        }
    } else {
        const encoderRef = matchValue;
        return (v)=>encoderRef.contents(v);
    }
}
function $619ae88d57e33a2f$var$makeExtra(extra) {
    if (extra != null) return (0, $cee18de5b874f6d4$export$871de8747c9eaa88)((_arg, tupledArg)=>new (0, $eATN7.FSharpRef)(tupledArg[0]), extra.Coders);
    else return (0, $cee18de5b874f6d4$export$6e22c362a0406a2c)({
        Compare: (0, $kRS0m.comparePrimitives)
    });
}
class $619ae88d57e33a2f$export$6cc2e70440926d44 {
    constructor(){}
}
function $619ae88d57e33a2f$export$e7be7f20cd4d1844() {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Thoth.Json.Encode.Auto", undefined, $619ae88d57e33a2f$export$6cc2e70440926d44);
}
function $619ae88d57e33a2f$export$b99c23c41e8274a2(t, caseStrategy, extra, skipNullField) {
    let y_1, y;
    const caseStrategy_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(caseStrategy, new (0, $5c30c14fc487c53f$export$9e558e3dec30b036)(0, []));
    const skipNullField_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(skipNullField, true);
    return (0, $5c30c14fc487c53f$export$13d7539a3e56b28c)((0, $5c30c14fc487c53f$export$dc4f3fd3a24229a1), (y_1 = (y = (0, $3921efb06a31e9cc$export$1d6cfa7493842c29)(t), (0, $eATN7.toString)(caseStrategy_1) + y), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((e)=>e.Hash, extra), "") + y_1), ()=>$619ae88d57e33a2f$var$autoEncoder($619ae88d57e33a2f$var$makeExtra(extra), caseStrategy_1, skipNullField_1, t));
}
function $619ae88d57e33a2f$export$f7b5f03c0dbd883e(t, caseStrategy, extra, skipNullField) {
    const caseStrategy_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(caseStrategy, new (0, $5c30c14fc487c53f$export$9e558e3dec30b036)(0, []));
    const skipNullField_1 = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(skipNullField, true);
    return $619ae88d57e33a2f$var$autoEncoder($619ae88d57e33a2f$var$makeExtra(extra), caseStrategy_1, skipNullField_1, t);
}
function $619ae88d57e33a2f$export$c564cdbbe6da493(space, value) {
    return $619ae88d57e33a2f$export$f84e8e69fd4488a5(space, value);
}






var $kRS0m = parcelRequire("kRS0m");



var $eATN7 = parcelRequire("eATN7");










function $2ac5cc1926ee502c$export$5060e3c1a4b7ce12(encoder, seq) {
    return (0, $619ae88d57e33a2f$export$1041d4276c328e4d)((0, $42cbcefff7323768$export$871de8747c9eaa88)(encoder, seq));
}
function $2ac5cc1926ee502c$export$432e2548e7ed1c9d(keyString, encodeValue, seq) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>[
            keyString(tupledArg[0]),
            encodeValue(tupledArg[1])
        ], seq));
}
function $2ac5cc1926ee502c$export$b3704793a95972ab(keyString, encodeValue, table) {
    return $2ac5cc1926ee502c$export$432e2548e7ed1c9d(keyString, encodeValue, table.fields[0]);
}
function $2ac5cc1926ee502c$export$8459ac7fca0d3445(seed) {
    return seed;
}
function $2ac5cc1926ee502c$export$a3dc9cd234b9ad68(item) {
    return item;
}
function $2ac5cc1926ee502c$export$3480dd50edeaa941(season) {
    return (0, $e189d4fb2d038fab$export$17d0dbcd198f4e3f)(season);
}
function $2ac5cc1926ee502c$export$708e0bcbcf420899(seasons) {
    let array;
    return $2ac5cc1926ee502c$export$5060e3c1a4b7ce12($2ac5cc1926ee502c$export$3480dd50edeaa941, (array = (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
        [
            "Spring",
            0
        ],
        [
            "Summer",
            1
        ],
        [
            "Fall",
            2
        ],
        [
            "Winter",
            3
        ]
    ])), array.filter((season)=>(0, $e189d4fb2d038fab$export$17231478d9f68f3b)(season, seasons))));
}
function $2ac5cc1926ee502c$export$34b28a2de2908422(date) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
        [
            "Season",
            $2ac5cc1926ee502c$export$3480dd50edeaa941(date.Season)
        ],
        [
            "Day",
            date.Day
        ]
    ]);
}
function $2ac5cc1926ee502c$export$f0f9afc3b6699723(fertilizer) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "Name",
            fertilizer.Name
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(fertilizer.Quality !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "Quality",
                fertilizer.Quality
            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>fertilizer.Speed !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "Speed",
                    fertilizer.Speed
                ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))));
}
function $2ac5cc1926ee502c$export$3359b1937a204f6e(_arg) {
    if (_arg.tag === 1) {
        if (_arg.fields[1] != null) {
            const p_1 = _arg.fields[1];
            return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
                [
                    "Type",
                    "Scaling"
                ],
                [
                    "Vendor",
                    _arg.fields[0]
                ],
                [
                    "Price",
                    p_1
                ]
            ]);
        } else return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
            [
                "Type",
                "Scaling"
            ],
            [
                "Vendor",
                _arg.fields[0]
            ]
        ]);
    } else return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
        [
            "Type",
            "Fixed"
        ],
        [
            "Vendor",
            _arg.fields[0]
        ],
        [
            "Price",
            _arg.fields[1]
        ]
    ]);
}
function $2ac5cc1926ee502c$export$e8130acba32686f3(amount) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(amount.MinCropYield !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).MinCropYield ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "MinCropYield",
            amount.MinCropYield
        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(amount.MaxCropYield !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).MaxCropYield ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "MaxCropYield",
                amount.MaxCropYield
            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(amount.ExtraCropChance !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).ExtraCropChance ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "ExtraCropChance",
                    amount.ExtraCropChance
                ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(amount.CanDouble !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).CanDouble ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "CanDouble",
                        amount.CanDouble
                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(amount.FarmLevelsPerYieldIncrease !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).FarmLevelsPerYieldIncrease ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "FarmLevelsPerYieldIncrease",
                            amount.FarmLevelsPerYieldIncrease
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>amount.FarmingQualities !== (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).FarmingQualities ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "FarmingQualities",
                                amount.FarmingQualities
                            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))))))))));
}
function $2ac5cc1926ee502c$export$294e155d3f2115c7(crop) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "Seed",
            $2ac5cc1926ee502c$export$8459ac7fca0d3445(crop.Seed)
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "Item",
                $2ac5cc1926ee502c$export$a3dc9cd234b9ad68(crop.Item)
            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(!(0, $kRS0m.equals)(crop.Amount, (0, $e189d4fb2d038fab$export$8beea5fd6014ad13)) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "Amount",
                    $2ac5cc1926ee502c$export$e8130acba32686f3(crop.Amount)
                ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                    let tupledArg;
                    return (0, $42cbcefff7323768$export$10d8903dec122b9d)(crop.ExtraItem != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "ExtraItem",
                        (tupledArg = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(crop.ExtraItem), (0, $619ae88d57e33a2f$export$92cb60c38e93b2cb)($2ac5cc1926ee502c$export$a3dc9cd234b9ad68, (value)=>value, tupledArg[0], tupledArg[1]))
                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(crop.Giant ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "Giant",
                            crop.Giant
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "Seasons",
                                $2ac5cc1926ee502c$export$708e0bcbcf420899(crop.Seasons)
                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                    "Stages",
                                    $2ac5cc1926ee502c$export$5060e3c1a4b7ce12((value_3)=>value_3, crop.Stages)
                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(crop.RegrowTime != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "RegrowTime",
                                        (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(crop.RegrowTime)
                                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>crop.Paddy ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "Paddy",
                                            crop.Paddy
                                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)()))))))))));
                })))))))));
}
function $2ac5cc1926ee502c$export$f1742f777548217b(crop) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
        [
            "Seed",
            $2ac5cc1926ee502c$export$8459ac7fca0d3445(crop.Seed)
        ],
        [
            "Foragables",
            $2ac5cc1926ee502c$export$5060e3c1a4b7ce12($2ac5cc1926ee502c$export$a3dc9cd234b9ad68, crop.Foragables)
        ],
        [
            "SeedRecipeUnlockLevel",
            crop.SeedRecipeUnlockLevel
        ],
        [
            "Season",
            $2ac5cc1926ee502c$export$3480dd50edeaa941(crop.Season)
        ],
        [
            "Stages",
            $2ac5cc1926ee502c$export$5060e3c1a4b7ce12((value_1)=>value_1, crop.Stages)
        ]
    ]);
}
function $2ac5cc1926ee502c$export$9525283a2499e5bb(data) {
    let encoder_1;
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)([
        [
            "Items",
            $2ac5cc1926ee502c$export$5060e3c1a4b7ce12((0, $619ae88d57e33a2f$export$f7b5f03c0dbd883e)((0, $cdb0798a49937e52$export$800598ed9ffd5a17)(), undefined, undefined, undefined), data.Items)
        ],
        [
            "Products",
            $2ac5cc1926ee502c$export$b3704793a95972ab((0, $eATN7.toString), (encoder_1 = (0, $619ae88d57e33a2f$export$f7b5f03c0dbd883e)((0, $3921efb06a31e9cc$export$e63caa28a27bc62e), undefined, undefined, undefined), (seq_1)=>$2ac5cc1926ee502c$export$5060e3c1a4b7ce12(encoder_1, seq_1)), data.Products)
        ],
        [
            "FarmCrops",
            $2ac5cc1926ee502c$export$5060e3c1a4b7ce12($2ac5cc1926ee502c$export$294e155d3f2115c7, data.FarmCrops)
        ],
        [
            "ForageCrops",
            $2ac5cc1926ee502c$export$5060e3c1a4b7ce12($2ac5cc1926ee502c$export$f1742f777548217b, data.ForageCrops)
        ]
    ]);
}
const $2ac5cc1926ee502c$export$8f4044fbf5f951fc = (str)=>{
    let matchValue, outArg;
    return matchValue = (outArg = 0, [
        (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(str, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ]), matchValue[0] ? matchValue[1] * 1 : undefined;
};
const $2ac5cc1926ee502c$export$cb7e4fe2b02f7b3c = (str)=>{
    let matchValue, outArg;
    return matchValue = (outArg = 0, [
        (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(str, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
            outArg = v;
        })),
        outArg
    ]), matchValue[0] ? matchValue[1] * 1 : undefined;
};
function $2ac5cc1926ee502c$var$Decode_natMeasure() {
    return (arg)=>{
        const clo_1 = (0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)(arg);
        return clo_1;
    };
}
function $2ac5cc1926ee502c$export$cee84912ed0f36b8(decoder) {
    return (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$871de8747c9eaa88)((array)=>(0, $70b963136d0d9ffe$export$cb197a913f6bb809)(array, {
                    Compare: (0, $kRS0m.compare)
                }), (path, value)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)(decoder, path, value), path_1, value_1);
}
function $2ac5cc1926ee502c$var$Decode_wrapKeys(mapping, keyWrap, decodeValue) {
    let d;
    let value_1;
    const decoder = decodeValue;
    value_1 = (path)=>(value)=>(0, $34cef9b1902a53c2$export$a6b37472941cc417)(decoder, path, value);
    d = (arg)=>{
        const clo_1 = value_1(arg);
        return clo_1;
    };
    return (path_1)=>(value_2)=>(0, $34cef9b1902a53c2$export$871de8747c9eaa88)(mapping, (0, $kRS0m.uncurry2)(d), path_1, value_2);
}
function $2ac5cc1926ee502c$var$Decode_parseKeysWith(mapping, parseKey, decodeValue) {
    return (path_2)=>(value_3)=>(0, $34cef9b1902a53c2$export$9768a9ae43d7f016)((0, $kRS0m.uncurry3)((kvps)=>{
                const acc = [];
                const parseKeys = (_arg_mut)=>{
                    parseKeys: while(true){
                        const _arg = _arg_mut;
                        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(_arg)) {
                            const matchValue = parseKey((0, $e08834e1786645d9$export$5fd5031fecdacec3)(_arg)[0]);
                            if (matchValue == null) return false;
                            else {
                                const key_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                                acc.push([
                                    key_1,
                                    (0, $e08834e1786645d9$export$5fd5031fecdacec3)(_arg)[1]
                                ]);
                                _arg_mut = (0, $e08834e1786645d9$export$c01875f616615628)(_arg);
                                continue parseKeys;
                            }
                        } else return true;
                        break;
                    }
                };
                if (parseKeys(kvps)) {
                    const output = mapping(acc);
                    return (arg10$0040)=>(arg20$0040)=>(0, $34cef9b1902a53c2$export$9094b7742a87955e)(output, arg10$0040, arg20$0040);
                } else return (path_1)=>(value_2)=>new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            [
                                path_1,
                                new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                                    "a valid key",
                                    value_2
                                ])
                            ]
                        ]);
            }), (path, value)=>(0, $34cef9b1902a53c2$export$a6b37472941cc417)(decodeValue, path, value), path_2, value_3);
}
function $2ac5cc1926ee502c$export$2c8bbcc5f7443337(keyWrap, decodeValue) {
    return $2ac5cc1926ee502c$var$Decode_wrapKeys((seq)=>new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new (0, $148a4dcdb95c00cf$export$4ee70ab773570fb9)([], {
            Equals: (0, $kRS0m.equals),
            GetHashCode: (0, $kRS0m.structuralHash)
        }), seq)), keyWrap, decodeValue);
}
function $2ac5cc1926ee502c$export$8d7624c7fd750668(parseKey, decodeValue) {
    return $2ac5cc1926ee502c$var$Decode_parseKeysWith((seq)=>new (0, $0ef027050085b17b$export$f450c8c8eb8ba019)((0, $0ef027050085b17b$export$715b664602a1d47c)(new (0, $148a4dcdb95c00cf$export$4ee70ab773570fb9)([], {
            Equals: (0, $kRS0m.equals),
            GetHashCode: (0, $kRS0m.structuralHash)
        }), seq)), parseKey, decodeValue);
}
const $2ac5cc1926ee502c$export$c97d52115d609594 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_2)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                let objectArg, objectArg_1, objectArg_2;
                return new (0, $7bbf2c7402328604$export$505c630c0b27c516)((objectArg = get$.Required, objectArg.Field("Name", (0, $34cef9b1902a53c2$export$22b082955e083ec3))), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg_1 = get$.Optional, objectArg_1.Field("Quality", (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)))), 0), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg_2 = get$.Optional, objectArg_2.Field("Speed", (0, $34cef9b1902a53c2$export$6b5cd3983e3ee5ab))), 0));
            }, path_2, v);
})();
const $2ac5cc1926ee502c$export$8e79f3cd110c6deb = $2ac5cc1926ee502c$var$Decode_natMeasure();
const $2ac5cc1926ee502c$export$25b03812f93cd1a7 = $2ac5cc1926ee502c$var$Decode_natMeasure();
const $2ac5cc1926ee502c$export$7871109a04e8709c = (path_2)=>(value_1)=>(0, $34cef9b1902a53c2$export$9768a9ae43d7f016)((0, $kRS0m.uncurry3)((str)=>{
            let matchValue;
            let outArg = 0;
            matchValue = [
                (0, $3921efb06a31e9cc$export$5fc9b63d26bd9368)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ]), str, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                    outArg = v | 0;
                })),
                outArg
            ];
            if (matchValue[0]) return (arg10$0040)=>(arg20$0040)=>(0, $34cef9b1902a53c2$export$9094b7742a87955e)(matchValue[1], arg10$0040, arg20$0040);
            else return (path_1)=>(arg20$0040_1)=>(0, $34cef9b1902a53c2$export$2b62a06a9fee979c)(`Failed to parse season: ${str}`, path_1, arg20$0040_1);
        }), (0, $34cef9b1902a53c2$export$22b082955e083ec3), path_2, value_1);
const $2ac5cc1926ee502c$export$b1fc7994f5fe16fe = (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$871de8747c9eaa88)((0, $e189d4fb2d038fab$export$af4097e6505d16e6), (path, value)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$7871109a04e8709c), path, value), path_1, value_1);
const $2ac5cc1926ee502c$export$cf4d5fc7554256e2 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                let objectArg, objectArg_1;
                return new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)((objectArg = get$.Required, objectArg.Field("Season", (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$7871109a04e8709c))), (objectArg_1 = get$.Required, objectArg_1.Field("Day", (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)))));
            }, path, v);
})();
const $2ac5cc1926ee502c$export$2bc1841c2ccdec13 = (path_7)=>(value_7)=>(0, $34cef9b1902a53c2$export$9768a9ae43d7f016)((0, $kRS0m.uncurry3)((tupledArg)=>(path_6)=>{
                const kind = tupledArg[0];
                const vendor = tupledArg[1];
                const price = tupledArg[2];
                return (value_6)=>kind === "Fixed" ? price == null ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        [
                            path_6,
                            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(3, [
                                `an object with a field named '${"Price"}'`,
                                value_6
                            ])
                        ]
                    ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                        new (0, $e189d4fb2d038fab$export$5b280effc20e3931)(0, [
                            vendor,
                            price
                        ])
                    ]) : kind === "Scaling" ? price == null ? new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                        new (0, $e189d4fb2d038fab$export$5b280effc20e3931)(1, [
                            vendor,
                            undefined
                        ])
                    ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                        new (0, $e189d4fb2d038fab$export$5b280effc20e3931)(1, [
                            vendor,
                            price
                        ])
                    ]) : new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                        [
                            path_6,
                            new (0, $5c30c14fc487c53f$export$e778e3159a77f99f)(0, [
                                `a valid price type ('${"Fixed"}' or '${"Scaling"}')`,
                                value_6
                            ])
                        ]
                    ]);
            }), (path_5, value_5)=>(0, $34cef9b1902a53c2$export$f7389512af34c855)((a, b, c)=>[
                    a,
                    b,
                    c
                ], (path_1, value_1)=>(0, $34cef9b1902a53c2$export$e0f35d825088c098)("Type", (0, $34cef9b1902a53c2$export$22b082955e083ec3), path_1, value_1), (path_3, value_3)=>(0, $34cef9b1902a53c2$export$e0f35d825088c098)("Vendor", (0, $34cef9b1902a53c2$export$22b082955e083ec3), path_3, value_3), (path_4, value_4)=>(0, $34cef9b1902a53c2$export$516e28dec6a4b6d4)("Price", (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)), path_4, value_4), path_5, value_5), path_7, value_7);
const $2ac5cc1926ee502c$export$9d859e984ffe3604 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_3)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                const field = (name, decoder, defaultValue)=>{
                    let objectArg;
                    return (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg = get$.Optional, objectArg.Field(name, (0, $kRS0m.uncurry2)(decoder))), defaultValue);
                };
                const MinCropYield = field("MinCropYield", (0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).MinCropYield);
                const MaxCropYield = field("MaxCropYield", (0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).MaxCropYield);
                const FarmLevelsPerYieldIncrease = field("FarmLevelsPerYieldIncrease", (0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).FarmLevelsPerYieldIncrease);
                return new (0, $e189d4fb2d038fab$export$580189a0f5486b62)(MinCropYield, MaxCropYield, field("ExtraCropChance", (path)=>(value)=>(0, $34cef9b1902a53c2$export$6b5cd3983e3ee5ab)(path, value), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).ExtraCropChance), field("CanDouble", (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$87b259aa03e3d267)(path_1, value_1), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).CanDouble), FarmLevelsPerYieldIncrease, field("FarmingQualities", (path_2)=>(value_2)=>(0, $34cef9b1902a53c2$export$87b259aa03e3d267)(path_2, value_2), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13).FarmingQualities));
            }, path_3, v);
})();
const $2ac5cc1926ee502c$export$ef3673530d496ba9 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_4)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                let objectArg, objectArg_1, objectArg_2, arg_7, objectArg_3, objectArg_4, objectArg_5, objectArg_6, objectArg_7, objectArg_8;
                return new (0, $e189d4fb2d038fab$export$be4357b4be0569ed)((objectArg = get$.Required, objectArg.Field("Seed", (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$25b03812f93cd1a7))), (objectArg_1 = get$.Required, objectArg_1.Field("Item", (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$8e79f3cd110c6deb))), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg_2 = get$.Optional, objectArg_2.Field("Amount", (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$9d859e984ffe3604))), (0, $e189d4fb2d038fab$export$8beea5fd6014ad13)), (arg_7 = (0, $34cef9b1902a53c2$export$92cb60c38e93b2cb)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$8e79f3cd110c6deb), (0, $34cef9b1902a53c2$export$6b5cd3983e3ee5ab)), objectArg_3 = get$.Optional, objectArg_3.Field("ExtraItem", (0, $kRS0m.uncurry2)(arg_7))), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg_4 = get$.Optional, objectArg_4.Field("Giant", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))), false), (objectArg_5 = get$.Required, objectArg_5.Field("Seasons", (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$b1fc7994f5fe16fe))), (objectArg_6 = get$.Required, objectArg_6.Field("Stages", (path_2, value_3)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)), path_2, value_3))), (objectArg_7 = get$.Optional, objectArg_7.Field("RegrowTime", (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)))), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((objectArg_8 = get$.Optional, objectArg_8.Field("Paddy", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))), false));
            }, path_4, v);
})();
const $2ac5cc1926ee502c$export$df6f890272683e48 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_2)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                const field = (name, decoder)=>{
                    const objectArg = get$.Required;
                    return objectArg.Field(name, (0, $kRS0m.uncurry2)(decoder));
                };
                return new (0, $e189d4fb2d038fab$export$4c9fbc271eb33a56)(field("Seed", $2ac5cc1926ee502c$export$25b03812f93cd1a7), field("Foragables", (path)=>(value)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$8e79f3cd110c6deb), path, value)), field("SeedRecipeUnlockLevel", (0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)), field("Season", $2ac5cc1926ee502c$export$7871109a04e8709c), field("Stages", (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)), path_1, value_1)));
            }, path_2, v);
})();
const $2ac5cc1926ee502c$export$7921cb58ee70bb50 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_2)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                const field = (name, decode)=>{
                    const objectArg = get$.Required;
                    return objectArg.Field(name, (0, $kRS0m.uncurry2)(decode));
                };
                return new (0, $a117bb35793377d5$export$c44280b23694a5a5)(field("Items", (0, $34cef9b1902a53c2$export$61f7b9e6d2e5c4)((0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $cdb0798a49937e52$export$800598ed9ffd5a17)()), undefined, undefined)), field("Products", $2ac5cc1926ee502c$export$8d7624c7fd750668($2ac5cc1926ee502c$export$8f4044fbf5f951fc, (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$61f7b9e6d2e5c4)((0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $cdb0798a49937e52$export$e199f01bc592175b)()), undefined, undefined)))), field("FarmCrops", (path)=>(value)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$ef3673530d496ba9), path, value)), field("ForageCrops", (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$df6f890272683e48), path_1, value_1)));
            }, path_2, v);
})();
const $2ac5cc1926ee502c$export$62db023d278fb24c = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_3)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                const field = (name, decode)=>{
                    const objectArg = get$.Required;
                    return objectArg.Field(name, (0, $kRS0m.uncurry2)(decode));
                };
                return new (0, $a117bb35793377d5$export$5636878579d6b4b0)(field("Fertilizers", (path)=>(value)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$c97d52115d609594), path, value)), field("FertilizerPrices", $2ac5cc1926ee502c$export$2c8bbcc5f7443337((x)=>x, (0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$2c8bbcc5f7443337((x_1)=>x_1, (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)))))), field("GenerateSeedPrices", $2ac5cc1926ee502c$export$2c8bbcc5f7443337((x_2)=>x_2, (path_1, value_1)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$25b03812f93cd1a7), path_1, value_1))), field("SeedPrices", $2ac5cc1926ee502c$export$8d7624c7fd750668($2ac5cc1926ee502c$export$cb7e4fe2b02f7b3c, (path_2, value_2)=>(0, $34cef9b1902a53c2$export$2f23118c22fb2630)((0, $kRS0m.uncurry2)($2ac5cc1926ee502c$export$2bc1841c2ccdec13), path_2, value_2))), field("ProcessorUnlockLevel", $2ac5cc1926ee502c$export$2c8bbcc5f7443337((x_3)=>x_3, (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$de9ffb9418dd7d0d)))));
            }, path_3, v);
})();






var $kRS0m = parcelRequire("kRS0m");

const $39847b2e2a09f858$export$6e22c362a0406a2c = new (0, $5c30c14fc487c53f$export$ceeb7a9ab32347e5)("", (0, $cee18de5b874f6d4$export$6e22c362a0406a2c)({
    Compare: (0, $kRS0m.comparePrimitives)
}));












var $eATN7 = parcelRequire("eATN7");




var $eATN7 = parcelRequire("eATN7");
function $3001a185859d1e72$export$468ff95b83d315e5(str, defValue) {
    if (str != null && str.match(/^\s*true\s*$/i)) {
        defValue.contents = true;
        return true;
    } else if (str != null && str.match(/^\s*false\s*$/i)) {
        defValue.contents = false;
        return true;
    }
    return false;
}
function $3001a185859d1e72$export$98e6a39c04603d36(str) {
    const defValue = new (0, $eATN7.FSharpRef)(false);
    if ($3001a185859d1e72$export$468ff95b83d315e5(str, defValue)) return defValue.contents;
    else throw new Error(`String '${str}' was not recognized as a valid Boolean.`);
}



const $6107b71bda0f6ed5$export$410953f9081714c4 = (0, (/*@__PURE__*/$parcel$interopDefault($2b9cc1991658e590$exports)));
const $6107b71bda0f6ed5$export$357519570781107e = (0, (/*@__PURE__*/$parcel$interopDefault($4af8c52d8621581e$exports)));
function $6107b71bda0f6ed5$var$load(json, decoder) {
    return (0, $3699f71d1df66484$export$21222002bbbb0942)((0, $34cef9b1902a53c2$export$5f36b26c3833b3ba)("$", decoder, json));
}
const $6107b71bda0f6ed5$var$gameData = (0, $a117bb35793377d5$export$e74237245234b309)($6107b71bda0f6ed5$var$load($6107b71bda0f6ed5$export$410953f9081714c4, (0, $kRS0m.uncurry2)((0, $2ac5cc1926ee502c$export$7921cb58ee70bb50))), $6107b71bda0f6ed5$var$load($6107b71bda0f6ed5$export$357519570781107e, (0, $kRS0m.uncurry2)((0, $2ac5cc1926ee502c$export$62db023d278fb24c))));
const $6107b71bda0f6ed5$var$settingsCoders = new (0, $5c30c14fc487c53f$export$ceeb7a9ab32347e5)((()=>{
    let copyOfStruct = (0, $1e2c404b14cccd24$export$665eeb3ced5fba0b)();
    return copyOfStruct;
})(), (0, $cee18de5b874f6d4$export$e16d8520af44a096)("StardewValleyStonks.Date", [
    (0, $2ac5cc1926ee502c$export$34b28a2de2908422),
    (0, $2ac5cc1926ee502c$export$cf4d5fc7554256e2)
], (0, $39847b2e2a09f858$export$6e22c362a0406a2c).Coders));
function $6107b71bda0f6ed5$var$encodeCropFilters(filters) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "ItemNameSearch",
            filters.ItemNameSearch
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "Seasons",
                (0, $2ac5cc1926ee502c$export$708e0bcbcf420899)(filters.Seasons)
            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "InSeason",
                    filters.InSeason
                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(filters.Giant != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "Giant",
                        (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(filters.Giant)
                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(filters.Regrows != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "Giant",
                            (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(filters.Regrows)
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>filters.Forage != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "Giant",
                                (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(filters.Forage)
                            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))))))))));
}
const $6107b71bda0f6ed5$var$decodeCropFilters = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_5)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                let objectArg_2, objectArg_3, objectArg_4, objectArg_5;
                let ItemNameSearch;
                const objectArg = get$.Required;
                ItemNameSearch = objectArg.Field("ItemNameSearch", (0, $34cef9b1902a53c2$export$22b082955e083ec3));
                let Seasons;
                const objectArg_1 = get$.Required;
                Seasons = objectArg_1.Field("Seasons", (0, $kRS0m.uncurry2)((0, $2ac5cc1926ee502c$export$b1fc7994f5fe16fe)));
                return new (0, $3699f71d1df66484$export$4a265e05b3750eef)(ItemNameSearch, (objectArg_2 = get$.Required, objectArg_2.Field("InSeason", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))), Seasons, (objectArg_3 = get$.Optional, objectArg_3.Field("Regrows", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))), (objectArg_4 = get$.Optional, objectArg_4.Field("Giant", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))), (objectArg_5 = get$.Optional, objectArg_5.Field("Forage", (0, $34cef9b1902a53c2$export$87b259aa03e3d267))));
            }, path_5, v);
})();
const $6107b71bda0f6ed5$var$encodeSettings = (0, $619ae88d57e33a2f$export$f7b5f03c0dbd883e)((0, $3699f71d1df66484$export$8bb33babc70c6427)(), undefined, $6107b71bda0f6ed5$var$settingsCoders, undefined);
const $6107b71bda0f6ed5$var$decodeSettings = (0, $34cef9b1902a53c2$export$61f7b9e6d2e5c4)((0, $3699f71d1df66484$export$8bb33babc70c6427)(), undefined, $6107b71bda0f6ed5$var$settingsCoders);
const $6107b71bda0f6ed5$var$encodeNestedOption = (0, $619ae88d57e33a2f$export$a75d1723e6bda2ec)((()=>{
    const enc = (0, $619ae88d57e33a2f$export$a75d1723e6bda2ec)((0, $2ac5cc1926ee502c$export$8459ac7fca0d3445));
    return (tupledArg)=>(0, $619ae88d57e33a2f$export$92cb60c38e93b2cb)(enc, (_arg)=>{
            if (_arg != null) {
                if ((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(_arg) != null) {
                    const fert = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(_arg);
                    return fert;
                } else return "";
            } else return 0, $619ae88d57e33a2f$export$f2c4f74e8fe88e34;
        }, tupledArg[0], tupledArg[1]);
})());
const $6107b71bda0f6ed5$var$decodeNestedOption = (()=>{
    const decoder_1 = (0, $34cef9b1902a53c2$export$92cb60c38e93b2cb)((path, value)=>(0, $34cef9b1902a53c2$export$a75d1723e6bda2ec)((0, $kRS0m.uncurry2)((0, $2ac5cc1926ee502c$export$25b03812f93cd1a7)), path, value), (path_4, value_4)=>(0, $34cef9b1902a53c2$export$a9a18ae5ba42aeab)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            (path_1)=>(value_1)=>(0, $34cef9b1902a53c2$export$f2c4f74e8fe88e34)(undefined, path_1, value_1),
            (path_3)=>(value_3)=>(0, $34cef9b1902a53c2$export$871de8747c9eaa88)((_arg)=>{
                        if (_arg === "") return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(undefined);
                        else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(_arg);
                    }, (0, $34cef9b1902a53c2$export$22b082955e083ec3), path_3, value_3)
        ]), path_4, value_4));
    return (path_5)=>(value_5)=>(0, $34cef9b1902a53c2$export$a75d1723e6bda2ec)((0, $kRS0m.uncurry2)(decoder_1), path_5, value_5);
})();
const $6107b71bda0f6ed5$var$uiCoders = (()=>{
    let copyOfStruct, copyOfStruct_1, key_1;
    const extra_3 = new (0, $5c30c14fc487c53f$export$ceeb7a9ab32347e5)((copyOfStruct = (0, $1e2c404b14cccd24$export$665eeb3ced5fba0b)(), copyOfStruct), (0, $cee18de5b874f6d4$export$e16d8520af44a096)("StardewValleyStonks.WebApp.CropFilters", [
        $6107b71bda0f6ed5$var$encodeCropFilters,
        $6107b71bda0f6ed5$var$decodeCropFilters
    ], (0, $39847b2e2a09f858$export$6e22c362a0406a2c).Coders));
    return new (0, $5c30c14fc487c53f$export$ceeb7a9ab32347e5)((copyOfStruct_1 = (0, $1e2c404b14cccd24$export$665eeb3ced5fba0b)(), copyOfStruct_1), (key_1 = "Microsoft.FSharp.Core.FSharpOption`1[System.Tuple`2[Microsoft.FSharp.Core.FSharpOption`1[System.UInt32[StardewValleyStonks.SeedNum]],Microsoft.FSharp.Core.FSharpOption`1[Microsoft.FSharp.Core.FSharpOption`1[System.String]]]]", (0, $cee18de5b874f6d4$export$e16d8520af44a096)(key_1, [
        $6107b71bda0f6ed5$var$encodeNestedOption,
        $6107b71bda0f6ed5$var$decodeNestedOption
    ], extra_3.Coders)));
})();
const $6107b71bda0f6ed5$var$encodeUI = (0, $619ae88d57e33a2f$export$f7b5f03c0dbd883e)((0, $3699f71d1df66484$export$1ca09fa0b7507761)(), undefined, $6107b71bda0f6ed5$var$uiCoders, undefined);
const $6107b71bda0f6ed5$var$decodeUI = (0, $34cef9b1902a53c2$export$61f7b9e6d2e5c4)((0, $3699f71d1df66484$export$1ca09fa0b7507761)(), undefined, $6107b71bda0f6ed5$var$uiCoders);
const $6107b71bda0f6ed5$export$a5c0be419ecbe5e4 = $6107b71bda0f6ed5$var$encodeSettings;
const $6107b71bda0f6ed5$export$e68b5f10651e3294 = $6107b71bda0f6ed5$var$encodeCropFilters;
const $6107b71bda0f6ed5$export$ababaa8df402fe01 = $6107b71bda0f6ed5$var$encodeUI;
const $6107b71bda0f6ed5$export$532a24964282d9 = (tupledArg)=>(0, $619ae88d57e33a2f$export$92cb60c38e93b2cb)($6107b71bda0f6ed5$export$a5c0be419ecbe5e4, $6107b71bda0f6ed5$export$ababaa8df402fe01, tupledArg[0], tupledArg[1]);
function $6107b71bda0f6ed5$export$2b49ff5e3c9e1d82(preset) {
    return (0, $619ae88d57e33a2f$export$be5493f9613cbbe)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "Name",
            preset.Name
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(preset.UniqueId != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "UniqueId",
                (0, $619ae88d57e33a2f$export$af207e6076994812)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(preset.UniqueId))
            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "Settings",
                    $6107b71bda0f6ed5$var$encodeSettings(preset.Settings)
                ]))))))));
}
function $6107b71bda0f6ed5$export$70147ef05049ab8b() {
    return (arg)=>{
        const clo = $6107b71bda0f6ed5$var$decodeSettings(arg);
        return clo;
    };
}
function $6107b71bda0f6ed5$export$c93175176d1efd4d() {
    return (arg)=>{
        const clo = $6107b71bda0f6ed5$var$decodeCropFilters(arg);
        return clo;
    };
}
function $6107b71bda0f6ed5$export$a2c5651f52664f57() {
    return (arg)=>{
        const clo = $6107b71bda0f6ed5$var$decodeUI(arg);
        return clo;
    };
}
const $6107b71bda0f6ed5$export$99935372a5eca571 = (0, $34cef9b1902a53c2$export$92cb60c38e93b2cb)((0, $kRS0m.uncurry2)($6107b71bda0f6ed5$export$70147ef05049ab8b()), (0, $kRS0m.uncurry2)($6107b71bda0f6ed5$export$a2c5651f52664f57()));
const $6107b71bda0f6ed5$export$e97d97daa2af5e80 = (()=>{
    const u = (0, $kRS0m.defaultOf)();
    return (path_1)=>(v)=>(0, $34cef9b1902a53c2$export$be5493f9613cbbe)((get$)=>{
                let objectArg, objectArg_1, objectArg_2;
                return new (0, $3699f71d1df66484$export$3463c369d5cc977f)((objectArg = get$.Required, objectArg.Field("Name", (0, $34cef9b1902a53c2$export$22b082955e083ec3))), (objectArg_1 = get$.Optional, objectArg_1.Field("UniqueId", (0, $kRS0m.uncurry2)((0, $34cef9b1902a53c2$export$af207e6076994812)))), (objectArg_2 = get$.Required, objectArg_2.Field("Settings", (0, $kRS0m.uncurry2)($6107b71bda0f6ed5$var$decodeSettings))));
            }, path_1, v);
})();
const $6107b71bda0f6ed5$export$62680b65e63e14ec = (()=>{
    let CustomFertilizerPrices;
    const selections = (0, $3699f71d1df66484$export$9061320d5fee8ae8)($6107b71bda0f6ed5$var$gameData);
    return new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)((0, $a117bb35793377d5$export$2b4be54c783a4750), new (0, $3699f71d1df66484$export$c41588bc52e5d7c7)(new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(0, []), true, true), (CustomFertilizerPrices = new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$cb197a913f6bb809)([
        [
            "Basic Fertilizer",
            4
        ],
        [
            "Quality Fertilizer",
            19
        ],
        [
            "Deluxe Fertilizer",
            216
        ],
        [
            "Speed-Gro",
            25
        ],
        [
            "Deluxe Speed-Gro",
            42
        ],
        [
            "Hyper Speed-Gro",
            376
        ]
    ], {
        Compare: (0, $kRS0m.comparePrimitives)
    }), selections.CustomFertilizerPrices.Selected), new (0, $3699f71d1df66484$export$8a3b7320744db3a9)(selections.Crops, selections.SeedPrices, selections.NoFertilizer, selections.Fertilizers, selections.FertilizerPrices, selections.SellRaw, selections.Products, selections.UseHarvestedSeeds, selections.UseSeedMaker, selections.UseForageSeeds, new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$cb197a913f6bb809)([
        [
            831,
            24
        ],
        [
            833,
            400
        ],
        [
            885,
            8
        ]
    ], {
        Compare: (0, $kRS0m.comparePrimitives)
    }), selections.CustomSeedPrices.Selected), CustomFertilizerPrices, new (0, $3699f71d1df66484$export$a608f594c3a26e93)((0, $cee18de5b874f6d4$export$cb197a913f6bb809)([
        [
            495,
            [
                294,
                false
            ]
        ],
        [
            496,
            [
                294,
                false
            ]
        ],
        [
            497,
            [
                294,
                false
            ]
        ],
        [
            498,
            [
                294,
                false
            ]
        ]
    ], {
        Compare: (0, $kRS0m.comparePrimitives)
    }), selections.CustomSellPrices.Selected))));
})();
const $6107b71bda0f6ed5$export$d7e9dfed7f23bc58 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
    new (0, $3699f71d1df66484$export$3463c369d5cc977f)("Year 1", undefined, new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)($6107b71bda0f6ed5$export$62680b65e63e14ec.Game, $6107b71bda0f6ed5$export$62680b65e63e14ec.Profit, (()=>{
        const bind$0040 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Selected;
        return new (0, $3699f71d1df66484$export$8a3b7320744db3a9)((0, $70b963136d0d9ffe$export$1bcf0b707e21f1fa)($6107b71bda0f6ed5$export$62680b65e63e14ec.Selected.Crops, (0, $70b963136d0d9ffe$export$cb197a913f6bb809)(new Uint32Array([
            347,
            476,
            478,
            485,
            486,
            489,
            494,
            499,
            802,
            831,
            833,
            885
        ]), {
            Compare: (0, $kRS0m.comparePrimitives)
        })), bind$0040.SeedPrices, bind$0040.NoFertilizer, (0, $70b963136d0d9ffe$export$cb197a913f6bb809)([
            "Basic Fertilizer",
            "Speed-Gro"
        ], {
            Compare: (0, $kRS0m.comparePrimitives)
        }), bind$0040.FertilizerPrices, bind$0040.SellRaw, (0, $cee18de5b874f6d4$export$871de8747c9eaa88)((_arg, products)=>(0, $70b963136d0d9ffe$export$cd7f480d6b8286c3)("Mill", products), $6107b71bda0f6ed5$export$62680b65e63e14ec.Selected.Products), bind$0040.UseHarvestedSeeds, bind$0040.UseSeedMaker, bind$0040.UseForageSeeds, bind$0040.CustomSeedPrices, bind$0040.CustomFertilizerPrices, bind$0040.CustomSellPrices);
    })())),
    new (0, $3699f71d1df66484$export$3463c369d5cc977f)("End Game", undefined, new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)((()=>{
        let bind$0040_2, bind$0040_5, bind$0040_6;
        const bind$0040_1 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game;
        return new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(bind$0040_1.StartDate, bind$0040_1.EndDate, bind$0040_1.Location, (bind$0040_2 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills, new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(new (0, $7bbf2c7402328604$export$118171a82d109c04)(10, $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills.Farming.Buff), new (0, $7bbf2c7402328604$export$118171a82d109c04)(10, $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills.Foraging.Buff), (0, $70b963136d0d9ffe$export$cb197a913f6bb809)([
            new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []),
            new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(1, []),
            new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(3, []),
            new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(4, [])
        ], {
            Compare: (0, $kRS0m.compare)
        }), bind$0040_2.IgnoreSkillLevelRequirements, bind$0040_2.IgnoreProfessionConflicts)), (bind$0040_5 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Multipliers, new (0, $cdb0798a49937e52$export$bf73db94524e6efd)(bind$0040_5.ProfitMargin, true, bind$0040_5.TillerForForagedFruit)), (bind$0040_6 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.CropAmount, new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(true, bind$0040_6.LuckBuff, bind$0040_6.GiantCropOrientationsPerTile, bind$0040_6.ShavingToolLevel)), bind$0040_1.JojaMembership, bind$0040_1.Irrigated, bind$0040_1.QualityArtisanProducts);
    })(), (()=>{
        const bind$0040_7 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Profit;
        return new (0, $3699f71d1df66484$export$c41588bc52e5d7c7)(new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(1, []), bind$0040_7.PayForFertilizer, bind$0040_7.PayForDestroyedFertilizer);
    })(), $6107b71bda0f6ed5$export$62680b65e63e14ec.Selected))
]);
const $6107b71bda0f6ed5$export$a876fd23edd12487 = new (0, $3699f71d1df66484$export$e10de9ebf9a3bcf6)(new (0, $3699f71d1df66484$export$5472259569c801e3)(1, []), new (0, $3699f71d1df66484$export$f79c53f8fc5ad0e)(0, []), new (0, $3699f71d1df66484$export$c525707b46ee8b45)(2, []), false, [
    0,
    20
], undefined);
const $6107b71bda0f6ed5$export$d9137282456a64c7 = new (0, $3699f71d1df66484$export$f5cb00b74b6a34bb)((0, $3699f71d1df66484$export$f6bbffe374f1c8e1), [
    4,
    true
], [
    0,
    true
], [
    0,
    true
], 0, false);
const $6107b71bda0f6ed5$export$c02ffde06c137a78 = new (0, $3699f71d1df66484$export$32d6e6630321d5dc)(new (0, $3699f71d1df66484$export$e5d97828673c2a38)(0, []), $6107b71bda0f6ed5$export$a876fd23edd12487, new (0, $3699f71d1df66484$export$d46dd6b37eef15e5)(0, []), new (0, $3699f71d1df66484$export$5d396b237bd33221)(2, []), (0, $70b963136d0d9ffe$export$cb197a913f6bb809)([
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(0, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(1, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(4, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(6, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(11, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(10, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(13, []),
    new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(12, [])
], {
    Compare: (0, $kRS0m.compare)
}), $6107b71bda0f6ed5$export$d9137282456a64c7, [
    0,
    true
], [
    0,
    true
]);
const $6107b71bda0f6ed5$export$15f9e5520abdaa5b = new (0, $3699f71d1df66484$export$86fbec116b87613f)($6107b71bda0f6ed5$var$gameData, $6107b71bda0f6ed5$export$d7e9dfed7f23bc58, [
    $6107b71bda0f6ed5$export$62680b65e63e14ec,
    $6107b71bda0f6ed5$export$c02ffde06c137a78
]);
function $6107b71bda0f6ed5$var$LocalStorage_saveVersion() {
    const data = (0, $eATN7.toString)((0, $3699f71d1df66484$export$866688da15343462));
    try {
        localStorage.setItem("Version", data);
    } catch (e) {
        (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(new Error(`Failed to save ${"Version"}, local storage might be full.`, {
            cause: e
        })));
    }
}
function $6107b71bda0f6ed5$var$LocalStorage_trySave(key, encoder, value) {
    const data = (0, $619ae88d57e33a2f$export$f84e8e69fd4488a5)(0, encoder(value));
    const key_1 = key;
    try {
        localStorage.setItem(key_1, data);
    } catch (e) {
        (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(new Error(`Failed to save ${key_1}, local storage might be full.`, {
            cause: e
        })));
    }
}
function $6107b71bda0f6ed5$export$520eda09f56bd178(state_, state__1) {
    $6107b71bda0f6ed5$var$LocalStorage_trySave("State", $6107b71bda0f6ed5$export$532a24964282d9, [
        state_,
        state__1
    ]);
}
function $6107b71bda0f6ed5$export$7c05abc0fc70f420(presets) {
    $6107b71bda0f6ed5$var$LocalStorage_trySave("Presets", (seq)=>(0, $2ac5cc1926ee502c$export$5060e3c1a4b7ce12)($6107b71bda0f6ed5$export$2b49ff5e3c9e1d82, seq), presets);
}
function $6107b71bda0f6ed5$var$LocalStorage_saveAll(app) {
    $6107b71bda0f6ed5$var$LocalStorage_saveVersion();
    const tupledArg = app.State;
    $6107b71bda0f6ed5$export$520eda09f56bd178(tupledArg[0], tupledArg[1]);
    $6107b71bda0f6ed5$export$7c05abc0fc70f420(app.Presets);
}
function $6107b71bda0f6ed5$var$LocalStorage_tryLoad(key, decoder) {
    const matchValue = localStorage.getItem(key);
    if (matchValue != null) {
        const matchValue_1 = (0, $34cef9b1902a53c2$export$3004f64547af360e)(decoder, matchValue);
        if (matchValue_1.tag === 1) {
            (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(`Failed to load ${key} from local storage: ${matchValue_1.fields[0]}`));
            return undefined;
        } else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(matchValue_1.fields[0]);
    } else {
        (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(`Failed to load ${key} from local storage: key not found.`));
        return undefined;
    }
}
function $6107b71bda0f6ed5$var$LocalStorage_loadState() {
    return (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)($6107b71bda0f6ed5$var$LocalStorage_tryLoad("State", (0, $kRS0m.uncurry2)($6107b71bda0f6ed5$export$99935372a5eca571)), $6107b71bda0f6ed5$export$15f9e5520abdaa5b.State);
}
function $6107b71bda0f6ed5$var$LocalStorage_loadPresets() {
    return (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)($6107b71bda0f6ed5$var$LocalStorage_tryLoad("Presets", (path, value)=>(0, $34cef9b1902a53c2$export$8837f4fc672e936d)((0, $kRS0m.uncurry2)($6107b71bda0f6ed5$export$e97d97daa2af5e80), path, value)), (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
}
function $6107b71bda0f6ed5$export$ce646708c34d95b6() {
    let ver;
    const matchValue = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((0, $3699f71d1df66484$export$ab7144b9bc13e399), localStorage.getItem("Version"));
    if (matchValue != null) {
        if ((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue) != null) {
            if (ver = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue), ver.Major !== (0, $3699f71d1df66484$export$866688da15343462).Major && ver.Major !== 0) {
                const ver_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                throw new Error(`Unexpected major version: ${ver_1.Major}`);
            } else {
                const ver_2 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
                let app;
                const State = $6107b71bda0f6ed5$var$LocalStorage_loadState();
                app = new (0, $3699f71d1df66484$export$86fbec116b87613f)($6107b71bda0f6ed5$var$gameData, $6107b71bda0f6ed5$var$LocalStorage_loadPresets(), State);
                if ((0, $kRS0m.equals)(ver_2, (0, $3699f71d1df66484$export$866688da15343462))) return app;
                else {
                    const app_1 = (0, $3699f71d1df66484$export$eb28436a1114d93c)($6107b71bda0f6ed5$var$gameData, app);
                    $6107b71bda0f6ed5$var$LocalStorage_saveAll(app_1);
                    return app_1;
                }
            }
        } else throw new Error(`Invalid version: ${localStorage.getItem("Version")}`);
    } else {
        (0, $3699f71d1df66484$export$15e20ddeb406d406).info((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)("No version key found in local storage, loading default app..."));
        $6107b71bda0f6ed5$var$LocalStorage_saveAll($6107b71bda0f6ed5$export$15f9e5520abdaa5b);
        return $6107b71bda0f6ed5$export$15f9e5520abdaa5b;
    }
}
function $6107b71bda0f6ed5$export$150ab4375b03de9b(dispatch) {
    window.onstorage = (e)=>{
        const matchValue = e.key;
        if (matchValue === (0, $kRS0m.defaultOf)()) window.location.reload();
        else switch(matchValue){
            case "Version":
                if (e.newValue == null) window.location.reload();
                else {
                    const matchValue_1 = (0, $3699f71d1df66484$export$ab7144b9bc13e399)(e.newValue);
                    let matchResult, ver_1;
                    if (matchValue_1 != null) {
                        if ((0, $kRS0m.equals)(matchValue_1, (0, $3699f71d1df66484$export$866688da15343462))) {
                            matchResult = 0;
                            ver_1 = matchValue_1;
                        } else matchResult = 1;
                    } else matchResult = 1;
                    switch(matchResult){
                        case 0:
                            break;
                        case 1:
                            window.location.reload();
                            break;
                    }
                }
                break;
            case "Presets":
                if (e.newValue == null) dispatch((0, $e08834e1786645d9$export$6e22c362a0406a2c)());
                else {
                    const matchValue_2 = (0, $34cef9b1902a53c2$export$3004f64547af360e)((path, value)=>(0, $34cef9b1902a53c2$export$8837f4fc672e936d)((0, $kRS0m.uncurry2)($6107b71bda0f6ed5$export$e97d97daa2af5e80), path, value), e.newValue);
                    if (matchValue_2.tag === 1) (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(`Failed to load saved settings from local storage: ${matchValue_2.fields[0]}`));
                    else dispatch(matchValue_2.fields[0]);
                }
                break;
            case "State":
                break;
            default:
                (0, $3699f71d1df66484$export$15e20ddeb406d406).warn((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(`Unknown key from storage event: ${matchValue}`));
        }
    };
}
function $6107b71bda0f6ed5$var$XML_getString(doc, node, path) {
    return doc.evaluate(path, node, (0, $kRS0m.defaultOf)(), XPathResult.STRING_TYPE, (0, $kRS0m.defaultOf)()).stringValue;
}
function $6107b71bda0f6ed5$var$XML_stringValue(doc, node, path) {
    const value = $6107b71bda0f6ed5$var$XML_getString(doc, node, path);
    if (value === "") return undefined;
    else return value;
}
function $6107b71bda0f6ed5$var$XML_parseWith(parser, doc, node, path) {
    const matchValue = parser($6107b71bda0f6ed5$var$XML_getString(doc, node, path));
    if (matchValue[0]) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(matchValue[1]);
    else return undefined;
}
const $6107b71bda0f6ed5$var$XML_natValue = (doc)=>(node)=>(path)=>$6107b71bda0f6ed5$var$XML_parseWith((arg)=>{
                let outArg = 0;
                return [
                    (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(arg, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
            }, doc, node, path);
const $6107b71bda0f6ed5$var$XML_int64Value = (doc)=>(node)=>(path)=>$6107b71bda0f6ed5$var$XML_parseWith((arg)=>{
                let outArg = 0n;
                return [
                    (0, $7a0dc84f38e8179a$export$468ff95b83d315e5)(arg, 511, false, 64, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
            }, doc, node, path);
const $6107b71bda0f6ed5$var$XML_floatValue = (doc)=>(node)=>(path)=>$6107b71bda0f6ed5$var$XML_parseWith((arg)=>{
                let outArg = 0;
                return [
                    (0, $5ce0fb420d4fadad$export$468ff95b83d315e5)(arg, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
            }, doc, node, path);
function $6107b71bda0f6ed5$var$XML_optionBoolValue(doc, node, path) {
    return (0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((node_1)=>{
        const matchValue = node_1.attributes["xsi:nil"];
        if (matchValue == null) {
            let matchValue_2;
            let outArg_1 = false;
            matchValue_2 = [
                (0, $3001a185859d1e72$export$468ff95b83d315e5)($6107b71bda0f6ed5$var$XML_getString(doc, node_1, "."), new (0, $eATN7.FSharpRef)(()=>outArg_1, (v_1)=>{
                    outArg_1 = v_1;
                })),
                outArg_1
            ];
            if (matchValue_2[0]) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(matchValue_2[1]);
            else return undefined;
        } else {
            const attr = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
            return (0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((str)=>{
                let matchValue_1;
                let outArg = false;
                matchValue_1 = [
                    (0, $3001a185859d1e72$export$468ff95b83d315e5)(str, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
                let matchResult;
                if (matchValue_1[0]) {
                    if (matchValue_1[1]) matchResult = 0;
                    else matchResult = 1;
                } else matchResult = 1;
                switch(matchResult){
                    case 0:
                        return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(undefined);
                    default:
                        return undefined;
                }
            }, attr.value);
        }
    }, doc.evaluate(path, node, (0, $kRS0m.defaultOf)(), XPathResult.FIRST_ORDERED_NODE_TYPE, (0, $kRS0m.defaultOf)()).singleNodeValue);
}
function $6107b71bda0f6ed5$var$XML_array(typePath, parser, doc, node, path) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arrNode)=>{
        const arr = [];
        const iter = doc.evaluate(typePath, arrNode, (0, $kRS0m.defaultOf)(), XPathResult.UNORDERED_NODE_ITERATOR_TYPE, (0, $kRS0m.defaultOf)());
        let finished = false;
        while(!finished){
            const matchValue = iter.iterateNext();
            if (matchValue == null) finished = true;
            else {
                const e = matchValue;
                (0, $42cbcefff7323768$export$c1a059043cc9c119)((item)=>{
                    arr.push(item);
                }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(parser(e.textContent)));
            }
        }
        return arr;
    }, doc.evaluate(path, node, (0, $kRS0m.defaultOf)(), XPathResult.FIRST_ORDERED_NODE_TYPE, (0, $kRS0m.defaultOf)()).singleNodeValue);
}
const $6107b71bda0f6ed5$var$XML_natArray = (doc)=>(node)=>(path)=>$6107b71bda0f6ed5$var$XML_array("int", (str)=>{
                let matchValue;
                let outArg = 0;
                matchValue = [
                    (0, $98d8e74a1fff5068$export$468ff95b83d315e5)(str, 511, true, 32, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                        outArg = v;
                    })),
                    outArg
                ];
                if (matchValue[0]) return matchValue[1];
                else return undefined;
            }, doc, node, path);
const $6107b71bda0f6ed5$var$XML_stringArray = (doc)=>(node)=>(path)=>$6107b71bda0f6ed5$var$XML_array("string", (_arg)=>{
                if (_arg === "") return undefined;
                else return _arg;
            }, doc, node, path);
const $6107b71bda0f6ed5$var$XML_xmlParser = new DOMParser();
function $6107b71bda0f6ed5$var$XML_parse(xml) {
    return $6107b71bda0f6ed5$var$XML_xmlParser.parseFromString(xml, "text/xml");
}
function $6107b71bda0f6ed5$export$6f99be9d94cb9e9d(xml) {
    const doc = $6107b71bda0f6ed5$var$XML_parse(xml);
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((farmer)=>{
        let bind$0040, bind$0040_1, bind$0040_5;
        const missing = [];
        const tryGet = (name, parser, path, defaultValue)=>{
            const matchValue = parser(doc)(farmer)(path);
            if (matchValue == null) {
                missing.push(name);
                return defaultValue;
            } else return (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
        };
        const professions = tryGet("Professions", $6107b71bda0f6ed5$var$XML_natArray, "professions", new Uint32Array([]));
        const eventsSeen = tryGet("Seen Events", $6107b71bda0f6ed5$var$XML_natArray, "eventsSeen", new Uint32Array([]));
        const mailReceived = tryGet("Received Mail", $6107b71bda0f6ed5$var$XML_stringArray, "mailReceived", []);
        const specialCharm = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(tryGet("Special Charm", (doc_1)=>(node)=>(path_1)=>$6107b71bda0f6ed5$var$XML_optionBoolValue(doc_1, node, path_1), "hasSpecialCharm", (0, $e189d4fb2d038fab$export$d4f06157fdf80d3d).SpecialCharm), (0, $e189d4fb2d038fab$export$d4f06157fdf80d3d).SpecialCharm);
        const farmingLevel = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(10, tryGet("Farming Level", $6107b71bda0f6ed5$var$XML_natValue, "farmingLevel", (0, $7bbf2c7402328604$export$d10f771b17a7f4d8).Level));
        const foragingLevel = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(10, tryGet("Foraging Level", $6107b71bda0f6ed5$var$XML_natValue, "foragingLevel", (0, $7bbf2c7402328604$export$d10f771b17a7f4d8).Level));
        const day = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(28, (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1, tryGet("Day", $6107b71bda0f6ed5$var$XML_natValue, "dayOfMonthForSaveGame", 1)));
        const season = ~~tryGet("Season", $6107b71bda0f6ed5$var$XML_natValue, "seasonForSaveGame", 0) | 0;
        const profitMargin = tryGet("Difficulty Modifier", $6107b71bda0f6ed5$var$XML_floatValue, "difficultyModifier", (0, $cdb0798a49937e52$export$c1df43900d74485).ProfitMargin);
        const farmerName = tryGet("Farmer Name", (doc_2)=>(node_1)=>(path_2)=>$6107b71bda0f6ed5$var$XML_stringValue(doc_2, node_1, path_2), "name", "Imported Save");
        const uniqueId = $6107b71bda0f6ed5$var$XML_int64Value(doc)(farmer)("UniqueMultiplayerID");
        if (uniqueId == null) missing.push("Unique Game ID");
        return [
            new (0, $3699f71d1df66484$export$3463c369d5cc977f)(farmerName, uniqueId, new (0, $3699f71d1df66484$export$c72f6eaae7b9adff)((bind$0040 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game, new (0, $a117bb35793377d5$export$90bbc03bb9e08c8e)(new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(season, day), bind$0040.EndDate, bind$0040.Location, (bind$0040_1 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills, new (0, $7bbf2c7402328604$export$bc572fe44976cfbc)(new (0, $7bbf2c7402328604$export$118171a82d109c04)(farmingLevel, $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills.Farming.Buff), new (0, $7bbf2c7402328604$export$118171a82d109c04)(foragingLevel, $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Skills.Foraging.Buff), (0, $70b963136d0d9ffe$export$cb197a913f6bb809)((0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>{
                if ((0, $e5d9070e144b905e$export$2344b14b097df817)(tupledArg[1], professions, {
                    Equals: (x, y)=>x === y,
                    GetHashCode: (0, $kRS0m.numberHash)
                })) return tupledArg[0];
                else return undefined;
            }, [
                [
                    new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(0, []),
                    1
                ],
                [
                    new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(1, []),
                    4
                ],
                [
                    new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(2, []),
                    5
                ],
                [
                    new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(3, []),
                    13
                ],
                [
                    new (0, $7bbf2c7402328604$export$42ad0ac7fc7503a6)(4, []),
                    16
                ]
            ]), {
                Compare: (0, $kRS0m.compare)
            }), bind$0040_1.IgnoreSkillLevelRequirements, bind$0040_1.IgnoreProfessionConflicts)), new (0, $cdb0798a49937e52$export$bf73db94524e6efd)(profitMargin, (0, $e5d9070e144b905e$export$2344b14b097df817)(2120303, eventsSeen, {
                Equals: (x_2, y_2)=>x_2 === y_2,
                GetHashCode: (0, $kRS0m.numberHash)
            }), $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.Multipliers.TillerForForagedFruit), (bind$0040_5 = $6107b71bda0f6ed5$export$62680b65e63e14ec.Game.CropAmount, new (0, $e189d4fb2d038fab$export$c856d3225a0dda43)(specialCharm, bind$0040_5.LuckBuff, bind$0040_5.GiantCropOrientationsPerTile, bind$0040_5.ShavingToolLevel)), (0, $e5d9070e144b905e$export$2344b14b097df817)("JojaMember", mailReceived, {
                Equals: (x_3, y_3)=>x_3 === y_3,
                GetHashCode: (0, $kRS0m.stringHash)
            }), bind$0040.Irrigated, bind$0040.QualityArtisanProducts)), $6107b71bda0f6ed5$export$62680b65e63e14ec.Profit, $6107b71bda0f6ed5$export$62680b65e63e14ec.Selected)),
            missing
        ];
    }, doc.evaluate("Farmer", doc, (0, $kRS0m.defaultOf)(), XPathResult.FIRST_ORDERED_NODE_TYPE, (0, $kRS0m.defaultOf)()).singleNodeValue);
}




parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $kRS0m = parcelRequire("kRS0m");

parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");



var $kRS0m = parcelRequire("kRS0m");


parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $kRS0m = parcelRequire("kRS0m");





function $2bc91fecd0c77f83$export$1001d0232b7c15ad(precision, min, max, value, dispatch) {
    let handler;
    return /*#__PURE__*/ (0, $hURbM.createElement)("input", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "type",
            "range"
        ],
        [
            "min",
            min
        ],
        [
            "max",
            max
        ],
        [
            "step",
            precision
        ],
        [
            "value",
            value
        ],
        (handler = (0, $d28ec4fb6293f25e$export$12bf26cb720cb002)(5, dispatch), [
            "onChange",
            (ev)=>{
                const value_10 = ev.target.valueAsNumber;
                if (!(value_10 == null) && !Number.isNaN(value_10)) handler(value_10);
            }
        ])
    ])));
}
function $2bc91fecd0c77f83$export$c6a3e7abd13d5ca4(min, max, value, dispatch) {
    return $2bc91fecd0c77f83$export$1001d0232b7c15ad(1, min, max, value, (arg)=>{
        dispatch(arg >>> 0);
    });
}
function $2bc91fecd0c77f83$var$NumberInput(props) {
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState([
        props.Value,
        true
    ]);
    const value = patternInput[0][0];
    const setState = patternInput[1];
    const updateInput = ()=>{
        setState([
            value,
            !patternInput[0][1]
        ]);
    };
    const dependencies = [
        props.Value
    ];
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        if (props.Value !== value) setState([
            props.Value,
            true
        ]);
    }, dependencies);
    return /*#__PURE__*/ (0, $hURbM.createElement)("input", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "className",
            "input-box"
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "style",
                {
                    width: props.Width
                }
            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "type",
                    "number"
                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(props.Min != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "min",
                        (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(props.Min)
                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(props.Max != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "max",
                            (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(props.Max)
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "step",
                                props.Precision
                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                    "value",
                                    value
                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "onChange",
                                        (ev)=>{
                                            const value_16 = ev.target.valueAsNumber;
                                            if (!(value_16 == null) && !Number.isNaN(value_16)) {
                                                const p = 1 / props.Precision;
                                                const v_1 = (0, $kRS0m.round)(value_16 * p) / p;
                                                if (v_1 !== value && (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((m)=>m <= v_1, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(props.Min)) && (0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((m_1)=>v_1 <= m_1, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(props.Max))) props.Dispatch(v_1);
                                            }
                                        }
                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "onBlur",
                                            (_arg)=>{
                                                updateInput();
                                            }
                                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                "onKeyDown",
                                                (e)=>{
                                                    const matchValue = e.key;
                                                    switch(matchValue){
                                                        case "Enter":
                                                        case "Escape":
                                                            (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(e);
                                                            updateInput();
                                                            break;
                                                        default:
                                                            undefined;
                                                    }
                                                }
                                            ])))))))))))))))))))))));
}
function $2bc91fecd0c77f83$export$91c39a88397ac04b(width, min, max, value, dispatch) {
    let Min;
    return /*#__PURE__*/ (0, $hURbM.createElement)($2bc91fecd0c77f83$var$NumberInput, (Min = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(min, 0), {
        Dispatch: (arg)=>{
            dispatch(arg >>> 0);
        },
        Max: (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(max, 4294967295),
        Min: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(Min),
        Precision: 1,
        Value: value,
        Width: width
    }));
}
function $2bc91fecd0c77f83$export$6b5cd3983e3ee5ab(width, precision, min, max, value, dispatch) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($2bc91fecd0c77f83$var$NumberInput, {
        Dispatch: dispatch,
        Max: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(max),
        Min: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(min),
        Precision: precision,
        Value: value,
        Width: width
    });
}
function $2bc91fecd0c77f83$var$numberWithRange(label, number, range) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("span", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "number-and-range"
        ],
        (elems = [
            (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)(label, number),
            (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)(label, range)
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $2bc91fecd0c77f83$export$9456ea0ed272a8e8(label, width, precision, min, max, value, dispatch) {
    return $2bc91fecd0c77f83$var$numberWithRange(label, $2bc91fecd0c77f83$export$6b5cd3983e3ee5ab(width, precision, min, max, value, dispatch), $2bc91fecd0c77f83$export$1001d0232b7c15ad(precision, min, max, value, dispatch));
}
function $2bc91fecd0c77f83$export$39d8cf33b76d38c6(label, width, min, max, value, dispatch) {
    return $2bc91fecd0c77f83$var$numberWithRange(label, $2bc91fecd0c77f83$export$91c39a88397ac04b(width, min, max, value, dispatch), $2bc91fecd0c77f83$export$c6a3e7abd13d5ca4(min, max, value, dispatch));
}
function $2bc91fecd0c77f83$export$6f093cfa640b7166(value, dispatch) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("input", {
        className: "input-box",
        type: "text",
        value: value,
        onChange: (ev)=>{
            dispatch(ev.target.value);
        }
    });
}
function $2bc91fecd0c77f83$export$b44abdc670aa384b(children, value, dispatch) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("label", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "checkbox"
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("input", {
                type: "checkbox",
                checked: value,
                onChange: (ev)=>{
                    dispatch(ev.target.checked);
                }
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("img", {
                alt: ""
            }),
            children
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $2bc91fecd0c77f83$export$b07e517d22efa1ca(text_1, value, dispatch) {
    return $2bc91fecd0c77f83$export$b44abdc670aa384b(/*#__PURE__*/ (0, $hURbM.createElement)("span", {
        children: [
            text_1
        ]
    }), value, dispatch);
}
function $2bc91fecd0c77f83$export$94bb27baab8fb67d(labelText, value, dispatch) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("label", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "checkbox"
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                className: "hidden-text",
                children: labelText
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("input", {
                type: "checkbox",
                checked: value,
                onChange: (ev)=>{
                    dispatch(ev.target.checked);
                }
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("img", {
                alt: ""
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}







var $kRS0m = parcelRequire("kRS0m");

var $eATN7 = parcelRequire("eATN7");







parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");




function $120450cd5ed2b836$var$compareWithDirection(comparer, ascending) {
    if (ascending) return (a)=>(b)=>comparer(a, b);
    else return (a_1)=>(b_1)=>comparer(b_1, a_1);
}
function $120450cd5ed2b836$var$optionCompareByWith(projection, compare, a, b) {
    const matchValue = projection(a);
    const matchValue_1 = projection(b);
    if (matchValue == null) {
        if (matchValue_1 == null) return 0;
        else return 1;
    } else if (matchValue_1 == null) return -1;
    else {
        const a_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue);
        const b_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(matchValue_1);
        return compare(a_1, b_1) | 0;
    }
}
function $120450cd5ed2b836$export$81714dda78efa120(projection, ascending) {
    const compare = $120450cd5ed2b836$var$compareWithDirection((0, $kRS0m.compare), ascending);
    return (a)=>(b)=>$120450cd5ed2b836$var$optionCompareByWith(projection, (0, $kRS0m.uncurry2)(compare), a, b);
}
class $120450cd5ed2b836$export$b25f3f4236d22958 extends (0, $eATN7.Record) {
    constructor(Header, Display, Sort, Select, Key, Disabled){
        super();
        this.Header = Header;
        this.Display = Display;
        this.Sort = Sort;
        this.Select = Select;
        this.Key = Key;
        this.Disabled = Disabled;
    }
}
function $120450cd5ed2b836$export$d41e5e34e9971770(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.View.Table.Column`2", [
        gen0,
        gen1
    ], $120450cd5ed2b836$export$b25f3f4236d22958, ()=>[
            [
                "Header",
                (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.ReactElement", undefined)
            ],
            [
                "Display",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.ReactElement", undefined))
            ],
            [
                "Sort",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737), (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)))))
            ],
            [
                "Select",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$4b2f4351dd8f4737))), (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $7c6f80c5743180ba$export$4fe63bc224260a5b)(gen1), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8))))
            ],
            [
                "Key",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ],
            [
                "Disabled",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
function $120450cd5ed2b836$export$387f94866b17856(header, display, sort) {
    return new $120450cd5ed2b836$export$b25f3f4236d22958(header, display, sort, undefined, false, false);
}
function $120450cd5ed2b836$export$1fdf2c887552264f(header, display) {
    return $120450cd5ed2b836$export$387f94866b17856(header, display, undefined);
}
function $120450cd5ed2b836$export$69165d2e6bdf8dca(header, display, sortBy) {
    return $120450cd5ed2b836$export$387f94866b17856(header, display, (0, $kRS0m.uncurry3)((ascending)=>(0, $3699f71d1df66484$export$7c247520d7ef73eb)(sortBy, ascending)));
}
function $120450cd5ed2b836$export$bdeb69d37932a902(header, display, sortBy) {
    return $120450cd5ed2b836$export$387f94866b17856(header, display, (0, $kRS0m.uncurry3)((ascending)=>$120450cd5ed2b836$export$81714dda78efa120(sortBy, ascending)));
}
function $120450cd5ed2b836$export$1ca5cf930c58a1f5(header, value, display) {
    return $120450cd5ed2b836$export$387f94866b17856(header, (arg)=>display(value(arg)), (0, $kRS0m.uncurry3)((ascending)=>(0, $3699f71d1df66484$export$7c247520d7ef73eb)(value, ascending)));
}
function $120450cd5ed2b836$export$fdefd48fe55b79a7(header, value, display) {
    return $120450cd5ed2b836$export$387f94866b17856(header, (arg)=>display(value(arg)), (0, $kRS0m.uncurry3)((ascending)=>$120450cd5ed2b836$export$81714dda78efa120(value, ascending)));
}
function $120450cd5ed2b836$export$ec7cb4baac01f1f5(column) {
    return new $120450cd5ed2b836$export$b25f3f4236d22958(column.Header, column.Display, column.Sort, column.Select, true, column.Disabled);
}
function $120450cd5ed2b836$export$3dae70f9e1e31be6(disabled, column) {
    return new $120450cd5ed2b836$export$b25f3f4236d22958(column.Header, column.Display, column.Sort, column.Select, column.Key, disabled);
}
function $120450cd5ed2b836$export$5c7b7ab3ca28c5c8(selected, dispatch, column) {
    return new $120450cd5ed2b836$export$b25f3f4236d22958(column.Header, column.Display, column.Sort, [
        selected,
        dispatch
    ], column.Key, column.Disabled);
}
function $120450cd5ed2b836$var$tableHeader(key, columns, items, sortCol, ascending, sortDispatch) {
    let children;
    const children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children = (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, column)=>{
        const i_1 = i >>> 0;
        const active = sortCol === i_1;
        const sortable = column.Sort != null;
        const xs_3 = [
            (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((tupledArg)=>{
                let elems;
                const patternInput = (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((acc, item)=>{
                    const key_1 = key(item);
                    return (0, $42cbcefff7323768$export$93e2b83da34ff82a)((tupledArg_1, selected_1)=>[
                            tupledArg_1[0] && selected_1,
                            (0, $70b963136d0d9ffe$export$e16d8520af44a096)(key_1, tupledArg_1[1])
                        ], acc, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(tupledArg[0](key_1)));
                }, [
                    true,
                    (0, $70b963136d0d9ffe$export$6e22c362a0406a2c)({
                        Compare: (0, $kRS0m.compare)
                    })
                ], items);
                const keys_1 = patternInput[1];
                return /*#__PURE__*/ (0, $hURbM.createElement)("th", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    [
                        "scope",
                        "col"
                    ],
                    [
                        "className",
                        (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)("column-select"), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>column.Disabled ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)("disabled") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))
                    ],
                    (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $70b963136d0d9ffe$export$7980136274876327)(keys_1) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $2bc91fecd0c77f83$export$94bb27baab8fb67d)("Select All", false, (value_4)=>{})) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $2bc91fecd0c77f83$export$94bb27baab8fb67d)("Select All", patternInput[0], (arg)=>{
                            let tupledArg_2;
                            tupledArg[1]((tupledArg_2 = [
                                keys_1,
                                arg
                            ], new (0, $7c6f80c5743180ba$export$304072893c6c33e4)(1, [
                                tupledArg_2[0],
                                tupledArg_2[1]
                            ])));
                        })))), [
                        "children",
                        (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                    ])
                ])));
            }, column.Select),
            /*#__PURE__*/ (0, $hURbM.createElement)("th", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "scope",
                    "col"
                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "className",
                        (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(sortable ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)("column-sort") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>column.Disabled ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)("disabled") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))
                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(sortable && active ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "aria-sort",
                            ascending ? "ascending" : "descending"
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            let elems_1;
                            return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems_1 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>sortable ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("button", {
                                    onClick: (_arg)=>{
                                        sortDispatch([
                                            i_1,
                                            active ? !ascending : true
                                        ]);
                                    },
                                    "aria-pressed": active,
                                    children: column.Header
                                })) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)(column.Header))), [
                                "children",
                                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_1))
                            ]));
                        }))))))))))
        ];
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_3);
    }, columns), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    })));
    return /*#__PURE__*/ (0, $hURbM.createElement)("thead", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
    });
}
function $120450cd5ed2b836$var$tableBody(key, columns, items, rowDisabled) {
    const children = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((item)=>{
        const key_1 = key(item);
        return /*#__PURE__*/ (0, $hURbM.createElement)("tr", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "key",
                (0, $eATN7.toString)(key_1)
            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(rowDisabled(item) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "className",
                    "disabled"
                ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                    let elems;
                    return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((column)=>{
                        const xs_3 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((tupledArg)=>/*#__PURE__*/ (0, $hURbM.createElement)("td", {
                                    className: (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)("column-select"), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>column.Disabled ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)("disabled") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)()))))),
                                    children: (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((selected_1)=>(0, $2bc91fecd0c77f83$export$94bb27baab8fb67d)("Select", selected_1, (arg)=>{
                                            let tupledArg_1;
                                            tupledArg[1]((tupledArg_1 = [
                                                key_1,
                                                arg
                                            ], new (0, $7c6f80c5743180ba$export$304072893c6c33e4)(0, [
                                                tupledArg_1[0],
                                                tupledArg_1[1]
                                            ])));
                                        }), tupledArg[0](key_1))
                                }), column.Select)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>column.Key ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("th", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "scope",
                                        "row"
                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(column.Disabled ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "className",
                                            "disabled"
                                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                "children",
                                                column.Display(item)
                                            ])))))))))) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("td", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(column.Disabled ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "className",
                                        "disabled"
                                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "children",
                                            column.Display(item)
                                        ]))))))))))));
                        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_3);
                    }, columns), [
                        "children",
                        (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                    ]));
                }))))))));
    }, items);
    return /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
function $120450cd5ed2b836$export$a6935ca84fb38638(rowDisabled, key, sortCol, ascending, sortDispatch, columns, items) {
    const items_2 = (0, $42cbcefff7323768$export$93e2b83da34ff82a)((items_1, sort)=>(0, $e5d9070e144b905e$export$a9e7d1a6fdcfefde)((0, $kRS0m.uncurry2)(sort(ascending)), items_1), items, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((col)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((0, $kRS0m.curry3), col.Sort), (0, $e5d9070e144b905e$export$3fe40c3a4d8cb094)(~~sortCol, columns))));
    const children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        $120450cd5ed2b836$var$tableHeader(key, columns, items_2, sortCol, ascending, sortDispatch),
        $120450cd5ed2b836$var$tableBody(key, columns, items_2, rowDisabled)
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("table", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
function $120450cd5ed2b836$export$dbe75ea921406f50(key, sort_, sort__1, sortDispatch, columns, items) {
    const sort = [
        sort_,
        sort__1
    ];
    return $120450cd5ed2b836$export$a6935ca84fb38638((arg10$0040)=>false, key, sort[0], sort[1], sortDispatch, columns, items);
}
function $120450cd5ed2b836$var$collapseButton(expandLabel, collapseLabel, collapsed, setCollapsed) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("button", {
        className: "collapse-arrow",
        "aria-label": collapsed ? expandLabel : collapseLabel,
        "aria-pressed": !collapsed,
        onClick: (_arg)=>{
            setCollapsed(!collapsed);
        }
    });
}
function $120450cd5ed2b836$var$CollapsibleTableBody(props) {
    let elems, xs_2;
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState(props.Collapsed);
    const setCollapsed = patternInput[1];
    const collapsed = patternInput[0];
    const dependencies = [
        props.AllCollapsed
    ];
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        setCollapsed(props.AllCollapsed);
    }, dependencies);
    const children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        /*#__PURE__*/ (0, $hURbM.createElement)("tr", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                collapsed ? "collapsed" : "expanded"
            ],
            (elems = [
                /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                    children: [
                        $120450cd5ed2b836$var$collapseButton("Expand", "Collapse", collapsed, setCollapsed)
                    ]
                }),
                props.Header
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ]))),
        (xs_2 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((row)=>{
            const children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                /*#__PURE__*/ (0, $hURbM.createElement)("td", {}),
                row
            ]);
            return /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            });
        }, props.Rows), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2))
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
    });
}
function $120450cd5ed2b836$var$CollapsibleTable(props) {
    let children_2, children, xs_1;
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState(props.Collapsed);
    const collapsed = patternInput[0];
    const xs_2 = [
        (children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                children: [
                    $120450cd5ed2b836$var$collapseButton("Expand All", "Collapse All", collapsed, patternInput[1])
                ]
            }),
            props.Header
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }))), /*#__PURE__*/ (0, $hURbM.createElement)("thead", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        })),
        (xs_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
            let children_4;
            const header = tupledArg[1];
            const body = tupledArg[2];
            if (body.length === 0) {
                const children_6 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children_4 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {}),
                    header
                ]), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
                })));
                return /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_6))
                });
            } else return /*#__PURE__*/ (0, $hURbM.createElement)($120450cd5ed2b836$var$CollapsibleTableBody, {
                AllCollapsed: collapsed,
                Collapsed: props.Collapsed,
                Header: header,
                Rows: body,
                key: tupledArg[0]
            });
        }, props.Bodies), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
}
function $120450cd5ed2b836$export$f5ce6a8561c94ccd(collapsed, header, bodies) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($120450cd5ed2b836$var$CollapsibleTable, {
        Bodies: bodies,
        Collapsed: collapsed,
        Header: header
    });
}




parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");
const $50fe856f5e8f5256$export$6d9c69b0de29b591 = (getDisposable)=>{
    (0, $bNI4e.useEffect)(()=>{
        const disposable = getDisposable();
        return ()=>{
            disposable.Dispose();
        };
    });
};
const $50fe856f5e8f5256$export$1b1f5fe435e7ba46 = (getDisposable, deps)=>{
    (0, $bNI4e.useEffect)(()=>{
        const disposable = getDisposable();
        return ()=>{
            disposable.Dispose();
        };
    }, deps);
};
const $50fe856f5e8f5256$export$e5c5a5f917a5871c = (getDisposable)=>{
    (0, $bNI4e.useLayoutEffect)(()=>{
        const disposable = getDisposable();
        return ()=>{
            disposable.Dispose();
        };
    });
};
const $50fe856f5e8f5256$export$f2cdda7e9eca2b4e = (getDisposable, deps)=>{
    (0, $bNI4e.useLayoutEffect)(()=>{
        const disposable = getDisposable();
        return ()=>{
            disposable.Dispose();
        };
    }, deps);
};
const $50fe856f5e8f5256$export$dc8fbce3eb94dc1e = (value, formatter)=>(0, $bNI4e.useDebugValue)(value, formatter);






var $kRS0m = parcelRequire("kRS0m");



var $kRS0m = parcelRequire("kRS0m");

function $a2ae0c725e258b91$export$75d86969badc6a8a(disposeOption) {
    return {
        Dispose () {
            (0, $42cbcefff7323768$export$c1a059043cc9c119)((d)=>{
                let copyOfStruct = d;
                (0, $kRS0m.disposeSafe)(copyOfStruct);
            }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(disposeOption));
        }
    };
}



var $eATN7 = parcelRequire("eATN7");
class $e7c6c1bf42f1ef53$export$9fd6763ef90dc41a {
    constructor(cancelled = false){
        this._id = 0;
        this._cancelled = cancelled;
        this._listeners = new Map();
    }
    get isCancelled() {
        return this._cancelled;
    }
    cancel() {
        if (!this._cancelled) {
            this._cancelled = true;
            for (const [, listener] of this._listeners)listener();
        }
    }
    addListener(f) {
        const id = this._id;
        this._listeners.set(this._id++, f);
        return id;
    }
    removeListener(id) {
        return this._listeners.delete(id);
    }
    register(f, state) {
        const $ = this;
        const id = this.addListener(state == null ? f : ()=>f(state));
        return {
            Dispose () {
                $.removeListener(id);
            }
        };
    }
    Dispose() {
    // Implement IDisposable for compatibility but do nothing
    // According to docs, calling Dispose does not trigger cancellation
    // https://docs.microsoft.com/en-us/dotnet/api/system.threading.cancellationtokensource.dispose?view=net-6.0
    }
}
class $e7c6c1bf42f1ef53$export$f0cb925494fb2481 extends Error {
    constructor(){
        super("The operation was canceled");
        Object.setPrototypeOf(this, $e7c6c1bf42f1ef53$export$f0cb925494fb2481.prototype);
    }
}
class $e7c6c1bf42f1ef53$export$1da5fb575e356ed {
    static get maxTrampolineCallCount() {
        return 2000;
    }
    constructor(){
        this.callCount = 0;
    }
    incrementAndCheck() {
        return this.callCount++ > $e7c6c1bf42f1ef53$export$1da5fb575e356ed.maxTrampolineCallCount;
    }
    hijack(f) {
        this.callCount = 0;
        setTimeout(f, 0);
    }
}
function $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233(f) {
    return (ctx)=>{
        if (ctx.cancelToken.isCancelled) ctx.onCancel(new $e7c6c1bf42f1ef53$export$f0cb925494fb2481());
        else if (ctx.trampoline.incrementAndCheck()) ctx.trampoline.hijack(()=>{
            try {
                f(ctx);
            } catch (err) {
                ctx.onError((0, $eATN7.ensureErrorOrException)(err));
            }
        });
        else try {
            f(ctx);
        } catch (err) {
            ctx.onError((0, $eATN7.ensureErrorOrException)(err));
        }
    };
}
function $e7c6c1bf42f1ef53$export$85fb2bb30d9b59b4(computation, binder) {
    return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>{
        computation({
            onSuccess: (x)=>{
                try {
                    binder(x)(ctx);
                } catch (err) {
                    ctx.onError((0, $eATN7.ensureErrorOrException)(err));
                }
            },
            onError: ctx.onError,
            onCancel: ctx.onCancel,
            cancelToken: ctx.cancelToken,
            trampoline: ctx.trampoline
        });
    });
}
function $e7c6c1bf42f1ef53$export$514a89518aadac63(value) {
    return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>ctx.onSuccess(value));
}
class $e7c6c1bf42f1ef53$export$ea673e181b6356d7 {
    Bind(computation, binder) {
        return $e7c6c1bf42f1ef53$export$85fb2bb30d9b59b4(computation, binder);
    }
    Combine(computation1, computation2) {
        return this.Bind(computation1, ()=>computation2);
    }
    Delay(generator) {
        return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>generator()(ctx));
    }
    For(sequence, body) {
        const iter = sequence[Symbol.iterator]();
        let cur = iter.next();
        return this.While(()=>!cur.done, this.Delay(()=>{
            const res = body(cur.value);
            cur = iter.next();
            return res;
        }));
    }
    Return(value) {
        return $e7c6c1bf42f1ef53$export$514a89518aadac63(value);
    }
    ReturnFrom(computation) {
        return computation;
    }
    TryFinally(computation, compensation) {
        return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>{
            computation({
                onSuccess: (x)=>{
                    compensation();
                    ctx.onSuccess(x);
                },
                onError: (x)=>{
                    compensation();
                    ctx.onError(x);
                },
                onCancel: (x)=>{
                    compensation();
                    ctx.onCancel(x);
                },
                cancelToken: ctx.cancelToken,
                trampoline: ctx.trampoline
            });
        });
    }
    TryWith(computation, catchHandler) {
        return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>{
            computation({
                onSuccess: ctx.onSuccess,
                onCancel: ctx.onCancel,
                cancelToken: ctx.cancelToken,
                trampoline: ctx.trampoline,
                onError: (ex)=>{
                    try {
                        catchHandler(ex)(ctx);
                    } catch (err) {
                        ctx.onError((0, $eATN7.ensureErrorOrException)(err));
                    }
                }
            });
        });
    }
    Using(resource, binder) {
        return this.TryFinally(binder(resource), ()=>resource.Dispose());
    }
    While(guard, computation) {
        if (guard()) return this.Bind(computation, ()=>this.While(guard, computation));
        else return this.Return(void 0);
    }
    Zero() {
        return $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233((ctx)=>ctx.onSuccess(void 0));
    }
}
const $e7c6c1bf42f1ef53$export$439306a4dcaafbb9 = new $e7c6c1bf42f1ef53$export$ea673e181b6356d7();



var $eATN7 = parcelRequire("eATN7");


function $5eb55d943c3c909d$export$b4f66f6d70f8ac38(Item) {
    return new $5eb55d943c3c909d$export$484d5b3e6aba851a(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$374b265826c6d7dd(Item) {
    return new $5eb55d943c3c909d$export$484d5b3e6aba851a(1, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$484d5b3e6aba851a extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of2",
            "Choice2Of2"
        ];
    }
}
function $5eb55d943c3c909d$export$77c45bcc58baf036(gen0, gen1) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`2", [
        gen0,
        gen1
    ], $5eb55d943c3c909d$export$484d5b3e6aba851a, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$174fe22824d43bdd(Item) {
    return new $5eb55d943c3c909d$export$640dfe501650609f(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$3c7263e39f3a626a(Item) {
    return new $5eb55d943c3c909d$export$640dfe501650609f(1, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$e792acbc2e019da0(Item) {
    return new $5eb55d943c3c909d$export$640dfe501650609f(2, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$640dfe501650609f extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of3",
            "Choice2Of3",
            "Choice3Of3"
        ];
    }
}
function $5eb55d943c3c909d$export$bc29e0da78001c0d(gen0, gen1, gen2) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`3", [
        gen0,
        gen1,
        gen2
    ], $5eb55d943c3c909d$export$640dfe501650609f, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen2
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$7c90076c24541240(Item) {
    return new $5eb55d943c3c909d$export$fc603fe06eb633f4(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$385b3114710d1f9a(Item) {
    return new $5eb55d943c3c909d$export$fc603fe06eb633f4(1, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$3d3e3066dd9d54ff(Item) {
    return new $5eb55d943c3c909d$export$fc603fe06eb633f4(2, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$6cca02a1ef3e54f9(Item) {
    return new $5eb55d943c3c909d$export$fc603fe06eb633f4(3, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$fc603fe06eb633f4 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of4",
            "Choice2Of4",
            "Choice3Of4",
            "Choice4Of4"
        ];
    }
}
function $5eb55d943c3c909d$export$d490d1555100b757(gen0, gen1, gen2, gen3) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`4", [
        gen0,
        gen1,
        gen2,
        gen3
    ], $5eb55d943c3c909d$export$fc603fe06eb633f4, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen2
                ]
            ],
            [
                [
                    "Item",
                    gen3
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$bbe5d2f7443b0e12(Item) {
    return new $5eb55d943c3c909d$export$b849e53644eac778(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$f4be06e7b79f1a6e(Item) {
    return new $5eb55d943c3c909d$export$b849e53644eac778(1, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$ff5dbc09c32958a6(Item) {
    return new $5eb55d943c3c909d$export$b849e53644eac778(2, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$540e8238c8530f3f(Item) {
    return new $5eb55d943c3c909d$export$b849e53644eac778(3, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$6c2718edb314f832(Item) {
    return new $5eb55d943c3c909d$export$b849e53644eac778(4, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$b849e53644eac778 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of5",
            "Choice2Of5",
            "Choice3Of5",
            "Choice4Of5",
            "Choice5Of5"
        ];
    }
}
function $5eb55d943c3c909d$export$6fbb436ae75f37de(gen0, gen1, gen2, gen3, gen4) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`5", [
        gen0,
        gen1,
        gen2,
        gen3,
        gen4
    ], $5eb55d943c3c909d$export$b849e53644eac778, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen2
                ]
            ],
            [
                [
                    "Item",
                    gen3
                ]
            ],
            [
                [
                    "Item",
                    gen4
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$9f05b3d9740fb520(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$4bbd9cf06aaba4dc(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(1, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$4b3a30b4257402bf(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(2, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$4aa235c564ad990c(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(3, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$97dc1e153b26f5e0(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(4, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$26247362102554c6(Item) {
    return new $5eb55d943c3c909d$export$70b88d057c3abe09(5, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$70b88d057c3abe09 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of6",
            "Choice2Of6",
            "Choice3Of6",
            "Choice4Of6",
            "Choice5Of6",
            "Choice6Of6"
        ];
    }
}
function $5eb55d943c3c909d$export$8d956ca706f0539b(gen0, gen1, gen2, gen3, gen4, gen5) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`6", [
        gen0,
        gen1,
        gen2,
        gen3,
        gen4,
        gen5
    ], $5eb55d943c3c909d$export$70b88d057c3abe09, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen2
                ]
            ],
            [
                [
                    "Item",
                    gen3
                ]
            ],
            [
                [
                    "Item",
                    gen4
                ]
            ],
            [
                [
                    "Item",
                    gen5
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$e6819de628f8d966(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(0, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$e697c61e6ca6442d(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(1, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$9b0dbe3d8d65c200(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(2, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$a6ac0d6930d08559(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(3, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$2c76e417afb6b862(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(4, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$22a4b87599924bf6(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(5, [
        Item
    ]);
}
function $5eb55d943c3c909d$export$3a2f48a1f9a59405(Item) {
    return new $5eb55d943c3c909d$export$c2035ba26358a0fd(6, [
        Item
    ]);
}
class $5eb55d943c3c909d$export$c2035ba26358a0fd extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Choice1Of7",
            "Choice2Of7",
            "Choice3Of7",
            "Choice4Of7",
            "Choice5Of7",
            "Choice6Of7",
            "Choice7Of7"
        ];
    }
}
function $5eb55d943c3c909d$export$eab2f0caff506969(gen0, gen1, gen2, gen3, gen4, gen5, gen6) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("FSharp.Core.FSharpChoice`7", [
        gen0,
        gen1,
        gen2,
        gen3,
        gen4,
        gen5,
        gen6
    ], $5eb55d943c3c909d$export$c2035ba26358a0fd, ()=>[
            [
                [
                    "Item",
                    gen0
                ]
            ],
            [
                [
                    "Item",
                    gen1
                ]
            ],
            [
                [
                    "Item",
                    gen2
                ]
            ],
            [
                [
                    "Item",
                    gen3
                ]
            ],
            [
                [
                    "Item",
                    gen4
                ]
            ],
            [
                [
                    "Item",
                    gen5
                ]
            ],
            [
                [
                    "Item",
                    gen6
                ]
            ]
        ]);
}
function $5eb55d943c3c909d$export$52444e6d9591052(x) {
    return $5eb55d943c3c909d$export$b4f66f6d70f8ac38(x);
}
function $5eb55d943c3c909d$export$541b81e0821a2307(x) {
    return $5eb55d943c3c909d$export$374b265826c6d7dd(x);
}
function $5eb55d943c3c909d$export$fa1662153a0f8ae0(x) {
    if (x.tag === /* Choice1Of2 */ 0) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(x.fields[0]);
    else return undefined;
}
function $5eb55d943c3c909d$export$98a79814ad2a35f(x) {
    if (x.tag === /* Choice2Of2 */ 1) return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(x.fields[0]);
    else return undefined;
}



var $eATN7 = parcelRequire("eATN7");
class $96d5842c72bb03a5$export$10d154b6b236ce89 extends (0, $eATN7.Exception) {
}
class $96d5842c72bb03a5$export$d44996a575b7764 extends $96d5842c72bb03a5$export$10d154b6b236ce89 {
}


function $763a759a208c993b$var$emptyContinuation(_x) {
// NOP
}
// see AsyncBuilder.Delay
function $763a759a208c993b$var$delay(generator) {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>generator()(ctx));
}
function $763a759a208c993b$export$e79fe265c93d7719(body) {
    return body;
}
function $763a759a208c993b$export$468cda29b159ee5d(computation, ctx) {
    return computation(ctx);
}
function $763a759a208c993b$export$be6d5a124b3b1b0d(ctx, result1, part2) {
    return part2(result1)(ctx);
}
function $763a759a208c993b$export$2385a24977818dd0(ctx, part1, part2) {
    return (0, $e7c6c1bf42f1ef53$export$85fb2bb30d9b59b4)(part1, part2)(ctx);
}
function $763a759a208c993b$export$eac027797b968991(arg) {
    const token = new (0, $e7c6c1bf42f1ef53$export$9fd6763ef90dc41a)(typeof arg === "boolean" ? arg : false);
    if (typeof arg === "number") setTimeout(()=>{
        token.cancel();
    }, arg);
    return token;
}
function $763a759a208c993b$export$70b61ad426ddbe54(token) {
    token.cancel();
}
function $763a759a208c993b$export$a671b0cf6bd36886(token, ms) {
    setTimeout(()=>{
        token.cancel();
    }, ms);
}
function $763a759a208c993b$export$bd18e5308636fee0(token) {
    return token != null && token.isCancelled;
}
function $763a759a208c993b$export$9d7eba8351130119(token) {
    if (token != null && token.isCancelled) throw new Error("Operation is cancelled");
}
function $763a759a208c993b$var$throwAfter(millisecondsDueTime) {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>{
        let tokenId;
        const timeoutId = setTimeout(()=>{
            ctx.cancelToken.removeListener(tokenId);
            ctx.onError(new (0, $96d5842c72bb03a5$export$d44996a575b7764)());
        }, millisecondsDueTime);
        tokenId = ctx.cancelToken.addListener(()=>{
            clearTimeout(timeoutId);
            ctx.onCancel(new (0, $e7c6c1bf42f1ef53$export$f0cb925494fb2481)());
        });
    });
}
function $763a759a208c993b$export$23a6a2f0de1fb119(computation, ms) {
    if (ms) {
        const computationWithTimeout = (0, $e7c6c1bf42f1ef53$export$85fb2bb30d9b59b4)($763a759a208c993b$var$parallel2(computation, $763a759a208c993b$var$throwAfter(ms)), (xs)=>(0, $e7c6c1bf42f1ef53$export$514a89518aadac63)(xs[0]));
        return $763a759a208c993b$export$23a6a2f0de1fb119(computationWithTimeout);
    }
    const promise = $763a759a208c993b$export$f842df3d0ff382b3(computation);
    // JS Promises are hot, computation has already started
    // but we delay returning the result
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>(0, $e7c6c1bf42f1ef53$export$514a89518aadac63)($763a759a208c993b$export$c5ab927018e48ed7(promise))(ctx));
}
function $763a759a208c993b$export$c5ab927018e48ed7(p) {
    return $763a759a208c993b$export$3d3fefc2eafa9652((conts)=>p.then(conts[0]).catch((err)=>(err instanceof (0, $e7c6c1bf42f1ef53$export$f0cb925494fb2481) ? conts[2] : conts[1])(err)));
}
function $763a759a208c993b$export$f26e1be181d521ea() {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>ctx.onSuccess(ctx.cancelToken));
}
const $763a759a208c993b$export$9dce437591028fdf = new (0, $e7c6c1bf42f1ef53$export$9fd6763ef90dc41a)();
function $763a759a208c993b$export$e56abc4807b7b2e6(work) {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>{
        work({
            onSuccess: (x)=>ctx.onSuccess((0, $5eb55d943c3c909d$export$52444e6d9591052)(x)),
            onError: (ex)=>ctx.onSuccess((0, $5eb55d943c3c909d$export$541b81e0821a2307)(ex)),
            onCancel: ctx.onCancel,
            cancelToken: ctx.cancelToken,
            trampoline: ctx.trampoline
        });
    });
}
function $763a759a208c993b$export$3d3fefc2eafa9652(f) {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>f([
            ctx.onSuccess,
            ctx.onError,
            ctx.onCancel
        ]));
}
function $763a759a208c993b$export$738b109e247a462c(computation) {
    return (0, $e7c6c1bf42f1ef53$export$85fb2bb30d9b59b4)(computation, (_x)=>(0, $e7c6c1bf42f1ef53$export$514a89518aadac63)(void 0));
}
function $763a759a208c993b$export$451942af9381149c(computations) {
    return $763a759a208c993b$var$delay(()=>$763a759a208c993b$export$c5ab927018e48ed7(Promise.all(Array.from(computations, (w)=>$763a759a208c993b$export$f842df3d0ff382b3(w)))));
}
function $763a759a208c993b$var$parallel2(a, b) {
    return $763a759a208c993b$var$delay(()=>$763a759a208c993b$export$c5ab927018e48ed7(Promise.all([
            $763a759a208c993b$export$f842df3d0ff382b3(a),
            $763a759a208c993b$export$f842df3d0ff382b3(b)
        ])));
}
function $763a759a208c993b$export$3c7b24ce1c81e349(computations) {
    function _sequential(computations) {
        let pr = Promise.resolve([]);
        for (const c of computations)pr = pr.then((results)=>$763a759a208c993b$export$f842df3d0ff382b3(c).then((r)=>results.concat([
                    r
                ])));
        return pr;
    }
    return $763a759a208c993b$var$delay(()=>$763a759a208c993b$export$c5ab927018e48ed7(_sequential(computations)));
}
function $763a759a208c993b$export$e772c8ff12451969(millisecondsDueTime) {
    return (0, $e7c6c1bf42f1ef53$export$b4ce65e0fbdd4233)((ctx)=>{
        let tokenId;
        const timeoutId = setTimeout(()=>{
            ctx.cancelToken.removeListener(tokenId);
            ctx.onSuccess(void 0);
        }, millisecondsDueTime);
        tokenId = ctx.cancelToken.addListener(()=>{
            clearTimeout(timeoutId);
            ctx.onCancel(new (0, $e7c6c1bf42f1ef53$export$f0cb925494fb2481)());
        });
    });
}
function $763a759a208c993b$export$b3571188c770cc5a(computation, cancellationToken) {
    return $763a759a208c993b$export$c99394f546aa6601(computation, $763a759a208c993b$var$emptyContinuation, function(err) {
        throw err;
    }, $763a759a208c993b$var$emptyContinuation, cancellationToken);
}
function $763a759a208c993b$export$c0ab9605f4365dec(computation, cancellationToken) {
    return $763a759a208c993b$export$b3571188c770cc5a(computation, cancellationToken);
}
function $763a759a208c993b$export$c99394f546aa6601(computation, continuation, exceptionContinuation, cancellationContinuation, cancelToken) {
    const trampoline = new (0, $e7c6c1bf42f1ef53$export$1da5fb575e356ed)();
    computation({
        onSuccess: continuation ? continuation : $763a759a208c993b$var$emptyContinuation,
        onError: exceptionContinuation,
        onCancel: cancellationContinuation,
        cancelToken: cancelToken ? cancelToken : $763a759a208c993b$export$9dce437591028fdf,
        trampoline: trampoline
    });
}
function $763a759a208c993b$export$f842df3d0ff382b3(computation, cancellationToken) {
    return new Promise((resolve, reject)=>$763a759a208c993b$export$c99394f546aa6601(computation, resolve, reject, reject, cancellationToken ? cancellationToken : $763a759a208c993b$export$9dce437591028fdf));
}


function $75dce49cc9589db1$export$235adea68e838dd0(withKey, props) {
    if (withKey == null) return props;
    else {
        const f = withKey;
        props.key = f(props);
        return props;
    }
}
function $75dce49cc9589db1$export$c5e53e1216ec3b51(renderElement, name, withKey) {
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((name_1)=>{
        renderElement.displayName = name_1;
    }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(name));
    return (props)=>{
        const props_2 = $75dce49cc9589db1$export$235adea68e838dd0(withKey, props);
        return (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement(renderElement, props_2);
    };
}
function $75dce49cc9589db1$export$7c73462e0d25e514(renderElement, name, areEqual, withKey) {
    const memoElementType = (0, $f559a3d33a977349$export$88214af1db8f02e1).memo(renderElement, (0, $kRS0m.uncurry2)((0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((0, $kRS0m.curry2), areEqual), (0, $kRS0m.defaultOf)())));
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((name_1)=>{
        renderElement.displayName = name_1;
    }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(name));
    return (props)=>{
        const props_2 = $75dce49cc9589db1$export$235adea68e838dd0(withKey, props);
        return (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement(memoElementType, props_2);
    };
}
function $75dce49cc9589db1$export$55b4707f0a98ae6e(dispose) {
    return {
        Dispose () {
            dispose();
        }
    };
}
function $75dce49cc9589db1$export$2813ec42d6658cc6(dispose) {
    const dependencies_1 = [
        dispose
    ];
    return (0, $f559a3d33a977349$export$88214af1db8f02e1).useMemo(()=>$75dce49cc9589db1$export$55b4707f0a98ae6e(dispose), dependencies_1);
}
function $75dce49cc9589db1$export$b558662bb0641046(effect) {
    const calledOnce = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(false);
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        if (!calledOnce.current) {
            calledOnce.current = true;
            effect();
        }
    }, []);
}
function $75dce49cc9589db1$export$e734312daa349fcb(effect) {
    const destroyFunc = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(undefined);
    const calledOnce = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(false);
    const renderAfterCalled = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(false);
    if (calledOnce.current) renderAfterCalled.current = true;
    (0, $50fe856f5e8f5256$export$1b1f5fe435e7ba46)(()=>(0, $a2ae0c725e258b91$export$75d86969badc6a8a)(calledOnce.current ? undefined : (calledOnce.current = true, destroyFunc.current = (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(effect()), renderAfterCalled.current ? destroyFunc.current : undefined)), []);
}
function $75dce49cc9589db1$export$4149a27d7ca961b8(effect) {
    const destroyFunc = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(undefined);
    const calledOnce = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(false);
    const renderAfterCalled = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(false);
    if (calledOnce.current) renderAfterCalled.current = true;
    (0, $50fe856f5e8f5256$export$1b1f5fe435e7ba46)(()=>(0, $a2ae0c725e258b91$export$75d86969badc6a8a)(calledOnce.current ? undefined : (calledOnce.current = true, destroyFunc.current = effect(), renderAfterCalled.current ? destroyFunc.current : undefined)), []);
}
function $75dce49cc9589db1$export$fd42f52fd3ae1109(name, defaultValue) {
    const contextObject = (0, $f559a3d33a977349$export$88214af1db8f02e1).createContext((0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(defaultValue, void 0));
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((name_1)=>{
        contextObject.displayName = name_1;
    }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(name));
    return contextObject;
}
function $75dce49cc9589db1$export$25bec8c6f54ee79a(callback) {
    const lastRenderCallbackRef = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(callback);
    const callbackRef = (0, $f559a3d33a977349$export$88214af1db8f02e1).useCallback((arg)=>lastRenderCallbackRef.current(arg), []);
    (0, $50fe856f5e8f5256$export$e5c5a5f917a5871c)((_arg)=>{
        lastRenderCallbackRef.current = callback;
        return $75dce49cc9589db1$export$55b4707f0a98ae6e(()=>{});
    });
    return callbackRef;
}
function $75dce49cc9589db1$export$257a8862b851cb5b(render) {
    const forwardRefType = (0, $f559a3d33a977349$export$88214af1db8f02e1).forwardRef((props, ref)=>render([
            props,
            ref
        ]));
    return (tupledArg)=>{
        const propsObj = Object.assign({}, tupledArg[0]);
        propsObj.ref = tupledArg[1];
        return (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement(forwardRefType, propsObj);
    };
}
function $75dce49cc9589db1$export$a451ead950c2249b(name, render) {
    const forwardRefType = (0, $f559a3d33a977349$export$88214af1db8f02e1).forwardRef((props, ref)=>render([
            props,
            ref
        ]));
    render.displayName = name;
    return (tupledArg)=>{
        const propsObj = Object.assign({}, tupledArg[0]);
        propsObj.ref = tupledArg[1];
        return (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement(forwardRefType, propsObj);
    };
}
function $75dce49cc9589db1$export$f3b8ec29b35b37f1() {
    let cts;
    const initialValue = (0, $763a759a208c993b$export$eac027797b968991)();
    cts = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(initialValue);
    let token;
    const initialValue_1 = cts.current;
    token = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(initialValue_1);
    $75dce49cc9589db1$export$e734312daa349fcb(()=>$75dce49cc9589db1$export$55b4707f0a98ae6e(()=>{
            (0, $763a759a208c993b$export$70b61ad426ddbe54)(cts.current);
        }));
    return token;
}



var $kRS0m = parcelRequire("kRS0m");





function $f2f828056f038bf6$var$Dialog(props) {
    let elems, children;
    const ref = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(undefined);
    (0, $50fe856f5e8f5256$export$e5c5a5f917a5871c)((_arg)=>{
        let m;
        const matchValue = ref.current;
        let matchResult, m_1;
        if (matchValue != null) {
            if (m = matchValue, !m.open) {
                matchResult = 0;
                m_1 = matchValue;
            } else matchResult = 1;
        } else matchResult = 1;
        switch(matchResult){
            case 0:
                m_1.showModal();
                break;
        }
        return (0, $75dce49cc9589db1$export$55b4707f0a98ae6e)(()=>{});
    });
    return /*#__PURE__*/ (0, $hURbM.createElement)("dialog", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "ref",
            ref
        ],
        [
            "aria-labelledby",
            (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                "dialog-title"
            ])
        ],
        [
            "onClose",
            (_arg_1)=>{
                props.Close(false);
            }
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("h1", {
                id: "dialog-title",
                children: props.Title
            }),
            props.Children(()=>{
                (0, $42cbcefff7323768$export$c1a059043cc9c119)((m_2)=>{
                    m_2.close();
                }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(ref.current));
            }),
            (children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(props.Cancel ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("button", {
                    className: "cancel",
                    onClick: (_arg_2)=>{
                        props.Close(false);
                    },
                    "aria-label": "Cancel"
                })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("button", {
                        className: "ok",
                        onClick: (_arg_3)=>{
                            props.Close(true);
                        },
                        "aria-label": "Ok"
                    })))))), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            }))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $f2f828056f038bf6$var$EditDialogToggle(props) {
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState(undefined);
    const setState = patternInput[1];
    const xs = [
        props.Toggle(()=>{
            setState((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(props.State));
        }),
        (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((state_1)=>/*#__PURE__*/ (0, $hURbM.createElement)($f2f828056f038bf6$var$Dialog, {
                Cancel: true,
                Children: (close)=>props.Children(close, state_1, (arg)=>{
                        setState((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(arg));
                    }),
                Close: (ok)=>{
                    if (ok) props.Dispatch(state_1);
                    setState(undefined);
                },
                Title: props.Title
            }), patternInput[0])
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $f2f828056f038bf6$var$toggleButton(css, label, toggle) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("button", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            css
        ],
        [
            "aria-haspopup",
            "dialog"
        ],
        [
            "onClick",
            (arg)=>{
                toggle(void 0);
            }
        ],
        label
    ])));
}
function $f2f828056f038bf6$export$6bbef08489b3f96e(buttonText, title, state, dispatch, children) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($f2f828056f038bf6$var$EditDialogToggle, {
        Children: children,
        Dispatch: dispatch,
        State: state,
        Title: title,
        Toggle: (toggle)=>$f2f828056f038bf6$var$toggleButton("button", [
                "children",
                buttonText
            ], toggle)
    });
}
function $f2f828056f038bf6$export$6abb1e551b9b2a9f(title, state, dispatch, children) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($f2f828056f038bf6$var$EditDialogToggle, {
        Children: children,
        Dispatch: dispatch,
        State: state,
        Title: title,
        Toggle: (toggle)=>$f2f828056f038bf6$var$toggleButton("edit", [
                "aria-label",
                "Edit"
            ], toggle)
    });
}
function $f2f828056f038bf6$export$71edf76f07903b9c(buttonText, title, dispatch, children) {
    return $f2f828056f038bf6$export$6bbef08489b3f96e(buttonText, title, undefined, dispatch, (_arg, unitVar, _arg_1)=>children);
}





var $eATN7 = parcelRequire("eATN7");

parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $kRS0m = parcelRequire("kRS0m");
function $d4ba2fe09a393e3c$export$69df705c2317ff94(value, e) {
    if (!(e == null) && e.value !== value) e.value = value;
}
class $d4ba2fe09a393e3c$export$dcb5c892f61d2e0d extends (0, $eATN7.Record) {
    constructor(model, render, equal){
        super();
        this.model = model;
        this.render = render;
        this.equal = equal;
    }
}
function $d4ba2fe09a393e3c$export$10446c89fe91a82b(gen0) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("Elmish.React.LazyProps`1", [
        gen0
    ], $d4ba2fe09a393e3c$export$dcb5c892f61d2e0d, ()=>[
            [
                "model",
                gen0
            ],
            [
                "render",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$ffcad4a7b72710d8), (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.ReactElement", undefined))
            ],
            [
                "equal",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)))
            ]
        ]);
}
class $d4ba2fe09a393e3c$export$1fad77593676747f extends (0, $hURbM.Component) {
    constructor(props){
        super(props);
    }
    shouldComponentUpdate(nextProps, _nextState) {
        const this$ = this;
        return !this$.props.equal(this$.props.model, nextProps.model);
    }
    render() {
        const this$ = this;
        return this$.props.render();
    }
}
function $d4ba2fe09a393e3c$export$60268591632d8b09(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Elmish.React.Components.LazyView`1", [
        gen0
    ], $d4ba2fe09a393e3c$export$1fad77593676747f, (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Fable.React.Component`2", [
        $d4ba2fe09a393e3c$export$10446c89fe91a82b(gen0),
        (0, $3921efb06a31e9cc$export$e63caa28a27bc62e)
    ], (0, $hURbM.Component)));
}
function $d4ba2fe09a393e3c$export$7464f05c0b8ea1b7(props) {
    return new $d4ba2fe09a393e3c$export$1fad77593676747f(props);
}
function $d4ba2fe09a393e3c$export$be92c158cfc976fe(equal, view, state) {
    const props = new $d4ba2fe09a393e3c$export$dcb5c892f61d2e0d(state, ()=>view(state), equal);
    return /*#__PURE__*/ $hURbM.createElement($d4ba2fe09a393e3c$export$1fad77593676747f, props);
}
function $d4ba2fe09a393e3c$export$c1ca94126b5caa96(equal, view, state, dispatch) {
    const props = new $d4ba2fe09a393e3c$export$dcb5c892f61d2e0d(state, ()=>view(state, dispatch), equal);
    return /*#__PURE__*/ $hURbM.createElement($d4ba2fe09a393e3c$export$1fad77593676747f, props);
}
function $d4ba2fe09a393e3c$export$47670ffaaf1bab62(equal, view, state1, state2, dispatch) {
    const props = new $d4ba2fe09a393e3c$export$dcb5c892f61d2e0d([
        state1,
        state2
    ], ()=>view(state1, state2, dispatch), equal);
    return /*#__PURE__*/ $hURbM.createElement($d4ba2fe09a393e3c$export$1fad77593676747f, props);
}
function $d4ba2fe09a393e3c$export$309c36585e87dfea(view) {
    return (state)=>$d4ba2fe09a393e3c$export$be92c158cfc976fe((0, $kRS0m.equals), view, state);
}
function $d4ba2fe09a393e3c$export$7335aaba4c95dfb(view) {
    return (state)=>(dispatch)=>$d4ba2fe09a393e3c$export$c1ca94126b5caa96((0, $kRS0m.equals), view, state, dispatch);
}
function $d4ba2fe09a393e3c$export$ccbbfe3e8f80da38(view) {
    return (state)=>(state_1)=>(dispatch)=>$d4ba2fe09a393e3c$export$47670ffaaf1bab62((0, $kRS0m.equalArrays), view, state, state_1, dispatch);
}





var $eATN7 = parcelRequire("eATN7");





var $kRS0m = parcelRequire("kRS0m");












/**
 * Returns a `Constraint` that specifies something should be less than or equal to `value`.
 * Equivalent to `{ max: value }`.
 */ const $113dc42df8fd0649$export$d6fe668f8d2afbf1 = (value)=>({
        max: value
    });
const $113dc42df8fd0649$export$a114ae8ee9d5b87b = (value)=>({
        min: value
    });
const $113dc42df8fd0649$export$bdcdec1f91f16dff = (value)=>({
        equal: value
    });
const $113dc42df8fd0649$export$ddf89a9c5af38f94 = (lower, upper)=>({
        min: lower,
        max: upper
    });

const $803875751dd544a0$export$b610b8812bbcded9 = (tableau, row, col)=>tableau.matrix[Math.imul(row, tableau.width) + col];
const $803875751dd544a0$export$722fbec263ad908a = (tableau, row, col, value)=>{
    tableau.matrix[Math.imul(row, tableau.width) + col] = value;
};
const $803875751dd544a0$var$convertToIterable = (seq)=>typeof seq[Symbol.iterator] === "function" // eslint-disable-line
     ? seq : Object.entries(seq);
// prettier-ignore
const $803875751dd544a0$var$convertToSet = (set)=>set === true ? true : set === false ? new Set() : set instanceof Set ? set : new Set(set);
const $803875751dd544a0$export$5775ac136be60802 = (model)=>{
    const { direction: direction, objective: objective, integers: integers, binaries: binaries } = model;
    const sign = direction === "minimize" ? -1 : 1.0;
    const constraintsIter = $803875751dd544a0$var$convertToIterable(model.constraints);
    const variablesIter = $803875751dd544a0$var$convertToIterable(model.variables);
    const variables = Array.isArray(variablesIter) ? variablesIter : Array.from(variablesIter);
    const binaryConstraintCol = [];
    const ints = [];
    if (integers != null || binaries != null) {
        const binaryVariables = $803875751dd544a0$var$convertToSet(binaries);
        const integerVariables = binaryVariables === true ? true : $803875751dd544a0$var$convertToSet(integers);
        for(let i = 1; i <= variables.length; i++){
            const [key] = variables[i - 1];
            if (binaryVariables === true || binaryVariables.has(key)) {
                binaryConstraintCol.push(i);
                ints.push(i);
            } else if (integerVariables === true || integerVariables.has(key)) ints.push(i);
        }
    }
    const constraints = new Map();
    for (const [key, constraint] of constraintsIter){
        const bounds = constraints.get(key) ?? {
            row: NaN,
            lower: -Infinity,
            upper: Infinity
        };
        bounds.lower = Math.max(bounds.lower, constraint.equal ?? constraint.min ?? -Infinity);
        bounds.upper = Math.min(bounds.upper, constraint.equal ?? constraint.max ?? Infinity);
        // if (rows.lower > rows.upper) return ["infeasible", NaN]
        if (!constraints.has(key)) constraints.set(key, bounds);
    }
    let numConstraints = 1;
    for (const constraint of constraints.values()){
        constraint.row = numConstraints;
        numConstraints += (Number.isFinite(constraint.lower) ? 1 : 0) + (Number.isFinite(constraint.upper) ? 1 : 0);
    }
    const width = variables.length + 1;
    const height = numConstraints + binaryConstraintCol.length;
    const numVars = width + height;
    const matrix = new Float64Array(width * height);
    const positionOfVariable = new Int32Array(numVars);
    const variableAtPosition = new Int32Array(numVars);
    const tableau = {
        matrix: matrix,
        width: width,
        height: height,
        positionOfVariable: positionOfVariable,
        variableAtPosition: variableAtPosition
    };
    for(let i = 0; i < numVars; i++){
        positionOfVariable[i] = i;
        variableAtPosition[i] = i;
    }
    for(let c = 1; c < width; c++)for (const [constraint, coef] of $803875751dd544a0$var$convertToIterable(variables[c - 1][1])){
        if (constraint === objective) $803875751dd544a0$export$722fbec263ad908a(tableau, 0, c, sign * coef);
        const bounds = constraints.get(constraint);
        if (bounds != null) {
            if (Number.isFinite(bounds.upper)) {
                $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row, c, coef);
                if (Number.isFinite(bounds.lower)) $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row + 1, c, -coef);
            } else if (Number.isFinite(bounds.lower)) $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row, c, -coef);
        }
    }
    for (const bounds of constraints.values()){
        if (Number.isFinite(bounds.upper)) {
            $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row, 0, bounds.upper);
            if (Number.isFinite(bounds.lower)) $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row + 1, 0, -bounds.lower);
        } else if (Number.isFinite(bounds.lower)) $803875751dd544a0$export$722fbec263ad908a(tableau, bounds.row, 0, -bounds.lower);
    }
    for(let b = 0; b < binaryConstraintCol.length; b++){
        const row = numConstraints + b;
        $803875751dd544a0$export$722fbec263ad908a(tableau, row, 0, 1.0);
        $803875751dd544a0$export$722fbec263ad908a(tableau, row, binaryConstraintCol[b], 1.0);
    }
    return {
        tableau: tableau,
        sign: sign,
        variables: variables,
        integers: ints
    };
};


const $18594427043c9181$export$b485511e5cd71305 = (num, precision)=>{
    const rounding = Math.round(1.0 / precision);
    return Math.round((num + Number.EPSILON) * rounding) / rounding;
};




const $627afe5f9ad6d845$var$pivot = (tableau, row, col)=>{
    const quotient = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, col);
    const leaving = tableau.variableAtPosition[tableau.width + row];
    const entering = tableau.variableAtPosition[col];
    tableau.variableAtPosition[tableau.width + row] = entering;
    tableau.variableAtPosition[col] = leaving;
    tableau.positionOfVariable[leaving] = col;
    tableau.positionOfVariable[entering] = tableau.width + row;
    const nonZeroColumns = [];
    // (1 / quotient) * R_pivot -> R_pivot
    for(let c = 0; c < tableau.width; c++){
        const value = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, c);
        if (Math.abs(value) > 1e-16) {
            (0, $803875751dd544a0$export$722fbec263ad908a)(tableau, row, c, value / quotient);
            nonZeroColumns.push(c);
        } else (0, $803875751dd544a0$export$722fbec263ad908a)(tableau, row, c, 0.0);
    }
    (0, $803875751dd544a0$export$722fbec263ad908a)(tableau, row, col, 1.0 / quotient);
    // -M[r, col] * R_pivot + R_r -> R_r
    for(let r = 0; r < tableau.height; r++){
        if (r === row) continue;
        const coef = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, r, col);
        if (Math.abs(coef) > 1e-16) {
            for(let i = 0; i < nonZeroColumns.length; i++){
                const c = nonZeroColumns[i];
                (0, $803875751dd544a0$export$722fbec263ad908a)(tableau, r, c, (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, r, c) - coef * (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, c));
            }
            (0, $803875751dd544a0$export$722fbec263ad908a)(tableau, r, col, -coef / quotient);
        }
    }
};
// Checks if the simplex method has encountered a cycle.
const $627afe5f9ad6d845$var$hasCycle = (history, tableau, row, col)=>{
    // This whole function seems somewhat inefficient,
    // but there was no? noticeable impact in the benchmarks.
    history.push([
        tableau.variableAtPosition[tableau.width + row],
        tableau.variableAtPosition[col]
    ]);
    // the minimum length of a cycle is 6
    for(let length = 6; length <= Math.trunc(history.length / 2); length++){
        let cycle = true;
        for(let i = 0; i < length; i++){
            const item = history.length - 1 - i;
            const [row1, col1] = history[item];
            const [row2, col2] = history[item - length];
            if (row1 !== row2 || col1 !== col2) {
                cycle = false;
                break;
            }
        }
        if (cycle) return true;
    }
    return false;
};
// Finds the optimal solution given some basic feasible solution.
const $627afe5f9ad6d845$var$phase2 = (tableau, options)=>{
    const pivotHistory = [];
    const { precision: precision, maxPivots: maxPivots, checkCycles: checkCycles } = options;
    for(let iter = 0; iter < maxPivots; iter++){
        // Find the entering column/variable
        let col = 0;
        let value = precision;
        for(let c = 1; c < tableau.width; c++){
            const reducedCost = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, 0, c);
            if (reducedCost > value) {
                value = reducedCost;
                col = c;
            }
        }
        if (col === 0) return [
            "optimal",
            (0, $18594427043c9181$export$b485511e5cd71305)((0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, 0, 0), precision)
        ];
        // Find the leaving row/variable
        let row = 0;
        let minRatio = Infinity;
        for(let r = 1; r < tableau.height; r++){
            const value = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, r, col);
            if (value <= precision) continue; // pivot entry must be positive
            const rhs = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, r, 0);
            const ratio = rhs / value;
            if (ratio < minRatio) {
                row = r;
                minRatio = ratio;
                if (ratio <= precision) break; // ratio is 0, lowest possible
            }
        }
        if (row === 0) return [
            "unbounded",
            col
        ];
        if (checkCycles && $627afe5f9ad6d845$var$hasCycle(pivotHistory, tableau, row, col)) return [
            "cycled",
            NaN
        ];
        $627afe5f9ad6d845$var$pivot(tableau, row, col);
    }
    return [
        "cycled",
        NaN
    ];
};
// Transforms a tableau into a basic feasible solution.
const $627afe5f9ad6d845$export$cdff0fdd5b0f2742 = (tableau, options)=>{
    const pivotHistory = [];
    const { precision: precision, maxPivots: maxPivots, checkCycles: checkCycles } = options;
    for(let iter = 0; iter < maxPivots; iter++){
        // Find the leaving row/variable
        let row = 0;
        let rhs = -precision;
        for(let r = 1; r < tableau.height; r++){
            const value = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, r, 0);
            if (value < rhs) {
                rhs = value;
                row = r;
            }
        }
        if (row === 0) return $627afe5f9ad6d845$var$phase2(tableau, options);
        // Find the entering column/variable
        let col = 0;
        let maxRatio = -Infinity;
        for(let c = 1; c < tableau.width; c++){
            const coefficient = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, c);
            if (coefficient < -precision) {
                const ratio = -(0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, 0, c) / coefficient;
                if (ratio > maxRatio) {
                    maxRatio = ratio;
                    col = c;
                }
            }
        }
        if (col === 0) return [
            "infeasible",
            NaN
        ];
        if (checkCycles && $627afe5f9ad6d845$var$hasCycle(pivotHistory, tableau, row, col)) return [
            "cycled",
            NaN
        ];
        $627afe5f9ad6d845$var$pivot(tableau, row, col);
    }
    return [
        "cycled",
        NaN
    ];
};




var $4efc8698f2c97fa4$exports = {};

$4efc8698f2c97fa4$exports = (parcelRequire("dzMiD"));


const $aa74e8cb208dba4e$var$buffer = (matrixLength, posVarLength)=>({
        matrix: new Float64Array(matrixLength),
        positionOfVariable: new Int32Array(posVarLength),
        variableAtPosition: new Int32Array(posVarLength)
    });
// Creates a new tableau with additional cut constraints from a buffer.
const $aa74e8cb208dba4e$var$applyCuts = (tableau, { matrix: matrix, positionOfVariable: positionOfVariable, variableAtPosition: variableAtPosition }, cuts)=>{
    const { width: width, height: height } = tableau;
    matrix.set(tableau.matrix);
    for(let i = 0; i < cuts.length; i++){
        const [sign, variable, value] = cuts[i];
        const r = (height + i) * width;
        const pos = tableau.positionOfVariable[variable];
        if (pos < width) {
            matrix[r] = sign * value;
            matrix.fill(0.0, r + 1, r + width);
            matrix[r + pos] = sign;
        } else {
            const row = (pos - width) * width;
            matrix[r] = sign * (value - matrix[row]);
            for(let c = 1; c < width; c++)matrix[r + c] = -sign * matrix[row + c];
        }
    }
    positionOfVariable.set(tableau.positionOfVariable);
    variableAtPosition.set(tableau.variableAtPosition);
    const length = width + height + cuts.length;
    for(let i = width + height; i < length; i++){
        positionOfVariable[i] = i;
        variableAtPosition[i] = i;
    }
    return {
        matrix: matrix.subarray(0, tableau.matrix.length + width * cuts.length),
        width: width,
        height: height + cuts.length,
        positionOfVariable: positionOfVariable.subarray(0, length),
        variableAtPosition: variableAtPosition.subarray(0, length)
    };
};
// Finds the integer variable with the most fractional value.
const $aa74e8cb208dba4e$var$mostFractionalVar = (tableau, intVars)=>{
    let highestFrac = 0.0;
    let variable = 0;
    let value = 0.0;
    for(let i = 0; i < intVars.length; i++){
        const intVar = intVars[i];
        const row = tableau.positionOfVariable[intVar] - tableau.width;
        if (row < 0) continue;
        const val = (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, 0);
        const frac = Math.abs(val - Math.round(val));
        if (frac > highestFrac) {
            highestFrac = frac;
            variable = intVar;
            value = val;
        }
    }
    return [
        variable,
        value,
        highestFrac
    ];
};
const $aa74e8cb208dba4e$export$ecbfccb5730dd058 = (tabmod, initResult, options)=>{
    const { tableau: tableau, sign: sign, integers: integers } = tabmod;
    const { precision: precision, maxIterations: maxIterations, tolerance: tolerance, timeout: timeout } = options;
    const [initVariable, initValue, initFrac] = $aa74e8cb208dba4e$var$mostFractionalVar(tableau, integers);
    // Wow, the initial solution is integer
    if (initFrac <= precision) return [
        tabmod,
        "optimal",
        initResult
    ];
    const branches = new (0, (/*@__PURE__*/$parcel$interopDefault($4efc8698f2c97fa4$exports)))((x, y)=>x[0] - y[0]);
    branches.push([
        initResult,
        [
            [
                -1,
                initVariable,
                Math.ceil(initValue)
            ]
        ]
    ]);
    branches.push([
        initResult,
        [
            [
                1,
                initVariable,
                Math.floor(initValue)
            ]
        ]
    ]);
    // Set aside arrays/buffers to be reused over the course of the algorithm.
    // One set of buffers stores the state of the current best solution.
    // The other is used to solve the current candidate solution.
    // The two buffers are "swapped" once a new best solution is found.
    const maxExtraRows = integers.length * 2;
    const matrixLength = tableau.matrix.length + maxExtraRows * tableau.width;
    const posVarLength = tableau.positionOfVariable.length + maxExtraRows;
    let candidateBuffer = $aa74e8cb208dba4e$var$buffer(matrixLength, posVarLength);
    let solutionBuffer = $aa74e8cb208dba4e$var$buffer(matrixLength, posVarLength);
    const optimalThreshold = initResult * (1.0 - sign * tolerance);
    const stopTime = timeout + Date.now();
    let timedout = Date.now() >= stopTime; // in case options.timeout <= 0
    let solutionFound = false;
    let bestEval = Infinity;
    let bestTableau = tableau;
    let iter = 0;
    while(iter < maxIterations && !branches.empty() && bestEval >= optimalThreshold && !timedout){
        const [relaxedEval, cuts] = branches.pop();
        if (relaxedEval > bestEval) break; // the remaining branches are worse than the current best solution
        const currentTableau = $aa74e8cb208dba4e$var$applyCuts(tableau, candidateBuffer, cuts);
        const [status, result] = (0, $627afe5f9ad6d845$export$cdff0fdd5b0f2742)(currentTableau, options);
        // The initial tableau is not unbounded and adding more cuts/constraints cannot make it become unbounded
        // assert(status !== "unbounded")
        if (status === "optimal" && result < bestEval) {
            const [variable, value, frac] = $aa74e8cb208dba4e$var$mostFractionalVar(currentTableau, integers);
            if (frac <= precision) {
                // The solution is integer
                solutionFound = true;
                bestEval = result;
                bestTableau = currentTableau;
                const temp = solutionBuffer;
                solutionBuffer = candidateBuffer;
                candidateBuffer = temp;
            } else {
                const cutsUpper = [];
                const cutsLower = [];
                for(let i = 0; i < cuts.length; i++){
                    const cut = cuts[i];
                    const [dir, v] = cut;
                    if (v === variable) dir < 0 ? cutsLower.push(cut) : cutsUpper.push(cut);
                    else {
                        cutsUpper.push(cut);
                        cutsLower.push(cut);
                    }
                }
                cutsLower.push([
                    1,
                    variable,
                    Math.floor(value)
                ]);
                cutsUpper.push([
                    -1,
                    variable,
                    Math.ceil(value)
                ]);
                branches.push([
                    result,
                    cutsUpper
                ]);
                branches.push([
                    result,
                    cutsLower
                ]);
            }
        }
        // Otherwise, this branch's result is worse than the current best solution.
        // This could be because this branch is infeasible or cycled.
        // Either way, skip this branch and see if any other branches have a valid, better solution.
        timedout = Date.now() >= stopTime;
        iter++;
    }
    // Did the solver "timeout"?
    const unfinished = (timedout || iter >= maxIterations) && !branches.empty() && bestEval >= optimalThreshold;
    // prettier-ignore
    const status = unfinished ? "timedout" : !solutionFound ? "infeasible" : "optimal";
    return [
        {
            ...tabmod,
            tableau: bestTableau
        },
        status,
        solutionFound ? bestEval : NaN
    ];
};


// Creates a solution object representing the optimal solution (if any).
const $ee30d3058756a18e$var$solution = ({ tableau: tableau, sign: sign, variables: vars }, status, result, { precision: precision, includeZeroVariables: includeZeroVariables })=>{
    if (status === "optimal" || status === "timedout" && !Number.isNaN(result)) {
        const variables = [];
        for(let i = 0; i < vars.length; i++){
            const [variable] = vars[i];
            const row = tableau.positionOfVariable[i + 1] - tableau.width;
            const value = row >= 0 ? (0, $803875751dd544a0$export$b610b8812bbcded9)(tableau, row, 0) : 0.0;
            if (value > precision) variables.push([
                variable,
                (0, $18594427043c9181$export$b485511e5cd71305)(value, precision)
            ]);
            else if (includeZeroVariables) variables.push([
                variable,
                0.0
            ]);
        }
        return {
            status: status,
            result: -sign * result,
            variables: variables
        };
    } else if (status === "unbounded") {
        const variable = tableau.variableAtPosition[result] - 1;
        return {
            status: "unbounded",
            result: sign * Infinity,
            // prettier-ignore
            variables: 0 <= variable && variable < vars.length ? [
                [
                    vars[variable][0],
                    Infinity
                ]
            ] : []
        };
    } else // infeasible | cycled | (timedout and result is NaN)
    return {
        status: status,
        result: NaN,
        variables: []
    };
};
const $ee30d3058756a18e$var$defaultOptionValues = {
    precision: 1e-8,
    checkCycles: false,
    maxPivots: 8192,
    tolerance: 0,
    timeout: Infinity,
    maxIterations: 32768,
    includeZeroVariables: false
};
const $ee30d3058756a18e$export$ba43bf67f3d48107 = {
    ...$ee30d3058756a18e$var$defaultOptionValues
};
const $ee30d3058756a18e$export$2865df1f26e73f8e = (model, options)=>{
    const tabmod = (0, $803875751dd544a0$export$5775ac136be60802)(model);
    const opt = {
        ...$ee30d3058756a18e$var$defaultOptionValues,
        ...options
    };
    const [status, result] = (0, $627afe5f9ad6d845$export$cdff0fdd5b0f2742)(tabmod.tableau, opt);
    if (tabmod.integers.length === 0 || status !== "optimal") // If a non-integer problem, return the simplex result.
    // Otherwise, the problem has integer variables, but the initial solution is either:
    // 1) unbounded | infeasible => all branches will also be unbounded | infeasible
    // 2) cycled => cannot get an initial solution, return invalid solution
    return $ee30d3058756a18e$var$solution(tabmod, status, result, opt);
    else {
        // Integer problem and an optimal non-integer solution was found
        const [intTabmod, intStatus, intResult] = (0, $aa74e8cb208dba4e$export$ecbfccb5730dd058)(tabmod, result, opt);
        return $ee30d3058756a18e$var$solution(intTabmod, intStatus, intResult, opt);
    }
};



class $9495a8d2b9c5bb89$export$5210f617d8edacc0 extends (0, $eATN7.Record) {
    constructor(StartSeason, EndSeason, TotalDays, GrowthTime, Harvests){
        super();
        this.StartSeason = StartSeason | 0;
        this.EndSeason = EndSeason | 0;
        this.TotalDays = TotalDays;
        this.GrowthTime = GrowthTime;
        this.Harvests = Harvests;
    }
}
function $9495a8d2b9c5bb89$export$2a4de16ebb77efdf() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.GrowthSpan", [], $9495a8d2b9c5bb89$export$5210f617d8edacc0, ()=>[
            [
                "StartSeason",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ])
            ],
            [
                "EndSeason",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ])
            ],
            [
                "TotalDays",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "GrowthTime",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Harvests",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ]
        ]);
}
function $9495a8d2b9c5bb89$var$consecutiveInSeasonDays(startDate, endDate, seasons) {
    const nthSeason = (0, $e189d4fb2d038fab$export$641f31a913d47020)(startDate.Season, endDate.Season);
    const days = (0, $e189d4fb2d038fab$export$ade24b166187735c)(startDate, endDate);
    const nextSeason = (start_1_mut, finish_1_mut, totalDays_mut, list_mut)=>{
        nextSeason: while(true){
            const start_1 = start_1_mut, finish_1 = finish_1_mut, totalDays = totalDays_mut, list = list_mut;
            if (finish_1 < nthSeason.length && (0, $e189d4fb2d038fab$export$17231478d9f68f3b)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(finish_1, nthSeason), seasons)) {
                start_1_mut = start_1;
                finish_1_mut = finish_1 + 1;
                totalDays_mut = totalDays + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(finish_1, days);
                list_mut = list;
                continue nextSeason;
            } else {
                const list_1 = totalDays === 0 ? list : (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                    [
                        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(start_1, nthSeason),
                        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(finish_1 - 1, nthSeason)
                    ],
                    totalDays
                ], list);
                if (finish_1 < nthSeason.length) {
                    start_1_mut = finish_1 + 1;
                    finish_1_mut = finish_1 + 1;
                    totalDays_mut = 0;
                    list_mut = list_1;
                    continue nextSeason;
                } else return list_1;
            }
            break;
        }
    };
    return (0, $e08834e1786645d9$export$45b10814cc054894)(nextSeason(0, 0, 0, (0, $e08834e1786645d9$export$6e22c362a0406a2c)()));
}
function $9495a8d2b9c5bb89$export$c230577c82088908(vars, fertilizer, crop) {
    const consecutiveDays = (0, $kRS0m.equals)(vars.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? $9495a8d2b9c5bb89$var$consecutiveInSeasonDays(vars.StartDate, vars.EndDate, (0, $e189d4fb2d038fab$export$b5a6878176d48f7f)(crop)) : [
        [
            [
                vars.StartDate.Season,
                vars.EndDate.Season
            ],
            (0, $e189d4fb2d038fab$export$76d2bde4e6058336)(vars.StartDate, vars.EndDate)
        ]
    ];
    if (consecutiveDays.length === 0) return undefined;
    else {
        const time = (0, $a117bb35793377d5$export$3302572d20aa94ca)(vars, fertilizer, crop);
        let patternInput;
        (0, $e5d9070e144b905e$export$9a2c8f31e984c6d5)((tuple)=>tuple[1], consecutiveDays, {
            Compare: (0, $kRS0m.comparePrimitives)
        });
        patternInput = (0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((a, b)=>(0, $3699f71d1df66484$export$1f1fcf30eadb9697)((tuple_1)=>tuple_1[1], a, b), (tupledArg)=>{
            const days = tupledArg[1];
            return [
                [
                    tupledArg[0],
                    days
                ],
                (0, $e189d4fb2d038fab$export$afe58414eb6e822)((0, $e189d4fb2d038fab$export$93f201b907e0b82c)(crop), time, days)
            ];
        }, consecutiveDays);
        const harvests = patternInput[1];
        if (harvests === 0) return undefined;
        else return new $9495a8d2b9c5bb89$export$5210f617d8edacc0(patternInput[0][0][0], patternInput[0][0][1], patternInput[0][1], time, harvests);
    }
}
function $9495a8d2b9c5bb89$export$b47c33e087d871e9(growthSpan, crop, _arg) {
    switch(_arg.tag){
        case 1:
            return (0, $e189d4fb2d038fab$export$540e37fd0d22453b)((0, $e189d4fb2d038fab$export$93f201b907e0b82c)(crop), growthSpan.GrowthTime, growthSpan.Harvests);
        case 2:
            return growthSpan.TotalDays / 28;
        default:
            return 1;
    }
}
function $9495a8d2b9c5bb89$export$eab7a6e44ba71d7b(settings, crop) {
    if (settings.Profit.PayForDestroyedFertilizer) return (0, $a117bb35793377d5$export$af075c3b0643dbbc)(settings.Game, crop);
    else return 0;
}
function $9495a8d2b9c5bb89$export$3ef76ca07b2cf109(data, settings, vendor, seed) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((_arg_1)=>(0, $a117bb35793377d5$export$818344e214fe839e)(data, settings.Game, seed, _arg_1), (0, $0ef027050085b17b$export$cc62f3272162c107)(vendor, (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.SeedPrices.fields[0], seed)));
}
function $9495a8d2b9c5bb89$export$4f606b351a0e05bd(quality, price, preserveQuality) {
    if (preserveQuality) {
        const value_2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, (0, $7bbf2c7402328604$export$54fd8b3fc157341a).fields[0]) * price;
        return value_2 >>> 0;
    } else return price;
}
function $9495a8d2b9c5bb89$export$435ae3e6eb1dbda2(price, preserveQuality) {
    if (preserveQuality) return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((mult)=>{
        const value_2 = mult * price;
        return value_2 >>> 0;
    }, (0, $7bbf2c7402328604$export$54fd8b3fc157341a).fields[0], Uint32Array));
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Uint32Array(4), 0, 4, price));
}
function $9495a8d2b9c5bb89$var$Selected_mapSelected(table, selected) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(table.fields[0], key), selected);
}
function $9495a8d2b9c5bb89$var$Selected_mapSelectedPrices(prices, selected) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((vendor)=>[
            vendor,
            (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(prices.fields[0], vendor)
        ], selected);
}
function $9495a8d2b9c5bb89$export$93cf6ebe330c0d(data, settings) {
    return $9495a8d2b9c5bb89$var$Selected_mapSelected(data.Fertilizers, settings.Selected.Fertilizers);
}
function $9495a8d2b9c5bb89$export$bfed76964c7008b8(data, settings) {
    const source_2 = (0, $42cbcefff7323768$export$871de8747c9eaa88)((Value)=>Value, $9495a8d2b9c5bb89$export$93cf6ebe330c0d(data, settings));
    return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>settings.Selected.NoFertilizer ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(undefined) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())), source_2);
}
function $9495a8d2b9c5bb89$export$70d6551fd1a592cd(data, settings, fertilizer) {
    const selected = (0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.FertilizerPrices, fertilizer);
    return $9495a8d2b9c5bb89$var$Selected_mapSelectedPrices((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.FertilizerPrices.fields[0], fertilizer), selected);
}
function $9495a8d2b9c5bb89$export$340f764bec7a4a15(data, settings, fertilizer) {
    const selected = (0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.FertilizerPrices, fertilizer);
    return $9495a8d2b9c5bb89$var$Selected_mapSelected((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.FertilizerPrices.fields[0], fertilizer), selected);
}
function $9495a8d2b9c5bb89$export$b7b057e94657b817(data, settings) {
    return $9495a8d2b9c5bb89$var$Selected_mapSelected(data.Crops, settings.Selected.Crops);
}
function $9495a8d2b9c5bb89$export$98f73a3fc1e1b415(data, settings) {
    return (0, $a117bb35793377d5$export$ccac27a3f7dbc48b)(settings.Game, $9495a8d2b9c5bb89$export$b7b057e94657b817(data, settings));
}
function $9495a8d2b9c5bb89$export$fe2c23bd3d9065d2(settings, seed) {
    if (!(0, $70b963136d0d9ffe$export$7980136274876327)((0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.SeedPrices, seed))) return true;
    else return (0, $3699f71d1df66484$export$96a0df907279b51f)(seed, settings.Selected.CustomSeedPrices) != null;
}
function $9495a8d2b9c5bb89$export$da499424a4dc82(data, settings, seed) {
    const selected = (0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.SeedPrices, seed);
    return $9495a8d2b9c5bb89$var$Selected_mapSelectedPrices((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.SeedPrices.fields[0], seed), selected);
}
function $9495a8d2b9c5bb89$export$23f6f216b5e94c5d(data, settings, seed) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>[
            tupledArg[0],
            (0, $a117bb35793377d5$export$818344e214fe839e)(data, settings.Game, seed, tupledArg[1])
        ], $9495a8d2b9c5bb89$export$da499424a4dc82(data, settings, seed));
}
function $9495a8d2b9c5bb89$export$4b1d481f4d1fdbb3(data, settings, seed) {
    const selected = (0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.SeedPrices, seed);
    return $9495a8d2b9c5bb89$var$Selected_mapSelected((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.SeedPrices.fields[0], seed), selected);
}
function $9495a8d2b9c5bb89$export$2327c3fab9f3ec6e(data, settings, seed) {
    return (0, $42cbcefff7323768$export$871de8747c9eaa88)((_arg)=>(0, $a117bb35793377d5$export$818344e214fe839e)(data, settings.Game, seed, _arg), $9495a8d2b9c5bb89$export$4b1d481f4d1fdbb3(data, settings, seed));
}
function $9495a8d2b9c5bb89$export$665fcfd50343855c(data, settings, item) {
    const selected = (0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.Products, item);
    const array = (0, $a117bb35793377d5$export$a8beba8a53794dfa)(data, item);
    return array.filter((product)=>{
        if ((0, $a117bb35793377d5$export$7eeef82a43679c9e)(data, settings.Game)(product)) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(selected, (0, $cdb0798a49937e52$export$3b5fd34b2463eb68)(product));
        else return false;
    });
}
function $9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, crop) {
    if ((0, $a117bb35793377d5$export$8b1f176e807e6ab4)(data, settings.Game, "Seed Maker") && (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseSeedMaker, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop))) return (0, $e189d4fb2d038fab$export$9a6d33d4fe8fe14)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), crop);
    else return false;
}
function $9495a8d2b9c5bb89$export$f72149ac5e8d2236(settings, crop) {
    if ((0, $a117bb35793377d5$export$ef4eb9bf41e48f4a)(settings.Game, crop)) return [
        (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.SellRaw, (0, $e189d4fb2d038fab$export$62ea73f630367ff4)(crop)),
        (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseForageSeeds, crop.Seed)
    ];
    else return [
        false,
        false
    ];
}
function $9495a8d2b9c5bb89$export$7f026a93e2ebcde8(settings, crop) {
    const patternInput = $9495a8d2b9c5bb89$export$f72149ac5e8d2236(settings, crop);
    if (patternInput[0]) return true;
    else return patternInput[1];
}
function $9495a8d2b9c5bb89$export$66784705e4af7e07(settings, seed, item) {
    if (seed === item) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseHarvestedSeeds, seed);
    else return false;
}
function $9495a8d2b9c5bb89$var$Price_minVendorAndPrice(selectedPrices, data, settings, customPrices, key) {
    let prices, patternInput;
    return (0, $3699f71d1df66484$export$de7d922902dff7f1)((a, b)=>(0, $3699f71d1df66484$export$7c8963ce39fc29c)((tuple_1)=>tuple_1[1], a, b), (prices = Array.from(selectedPrices(data, settings, key)), prices.length === 0 ? undefined : (patternInput = (0, $e5d9070e144b905e$export$8c826aa0fa59ac68)((tuple)=>tuple[1], prices, {
        Compare: (0, $kRS0m.compare)
    }), [
        new (0, $3699f71d1df66484$export$12e6ad755a4a86f9)(0, [
            patternInput[0]
        ]),
        patternInput[1]
    ])), (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((price_2)=>[
            new (0, $3699f71d1df66484$export$12e6ad755a4a86f9)(1, [
                undefined
            ]),
            price_2
        ], (0, $3699f71d1df66484$export$96a0df907279b51f)(key, customPrices)));
}
function $9495a8d2b9c5bb89$var$Price_minPrice(selectedPriceValues, data, settings, customPrices, key) {
    const prices = Array.from(selectedPriceValues(data, settings, key));
    const b = prices.length === 0 ? undefined : (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$96ec731ed4dcb222)(prices, {
        Compare: (0, $kRS0m.compare)
    }));
    return (0, $3699f71d1df66484$export$de7d922902dff7f1)((e, e_1)=>(0, $kRS0m.min)((0, $kRS0m.compare), e, e_1), (0, $3699f71d1df66484$export$96a0df907279b51f)(key, customPrices), b);
}
function $9495a8d2b9c5bb89$export$bd79d4c70e4a627b(data, settings, fertilizer) {
    return $9495a8d2b9c5bb89$var$Price_minVendorAndPrice($9495a8d2b9c5bb89$export$70d6551fd1a592cd, data, settings, settings.Selected.CustomFertilizerPrices, fertilizer);
}
function $9495a8d2b9c5bb89$export$a960ff6e57439a25(data, settings, fertilizer) {
    return $9495a8d2b9c5bb89$var$Price_minPrice($9495a8d2b9c5bb89$export$340f764bec7a4a15, data, settings, settings.Selected.CustomFertilizerPrices, fertilizer);
}
function $9495a8d2b9c5bb89$export$15514148d320a778(data, settings, seed) {
    return $9495a8d2b9c5bb89$var$Price_minVendorAndPrice($9495a8d2b9c5bb89$export$23f6f216b5e94c5d, data, settings, settings.Selected.CustomSeedPrices, seed);
}
function $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, seed) {
    return $9495a8d2b9c5bb89$var$Price_minPrice($9495a8d2b9c5bb89$export$2327c3fab9f3ec6e, data, settings, settings.Selected.CustomSeedPrices, seed);
}
function $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceBy(projection, data, settings, item, quality) {
    const products = $9495a8d2b9c5bb89$export$665fcfd50343855c(data, settings, item);
    if (products.length === 0) return undefined;
    else return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((e, e_1)=>(0, $kRS0m.max)((0, $kRS0m.compare), e, e_1), (0, $kRS0m.curry4)(projection)(data)(settings.Game)(quality), products));
}
function $9495a8d2b9c5bb89$export$cfacc8d6420cfb56(data, settings, item, quality) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceBy((0, $a117bb35793377d5$export$b2525098505c1744), data, settings, item, quality);
}
function $9495a8d2b9c5bb89$export$dff060dca23d7ea1(data, settings, item, quality) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceBy((0, $a117bb35793377d5$export$d2085a6d61ca5031), data, settings, item, quality);
}
function $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceByQualityBy(projection, data, settings, item) {
    let prices;
    const array = $9495a8d2b9c5bb89$export$665fcfd50343855c(data, settings, item);
    prices = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((0, $kRS0m.curry3)(projection)(data)(settings.Game), array);
    if (prices.length === 0) return undefined;
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$2a47f398eeff8b01)(4, (arg)=>(0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((e, e_1)=>(0, $kRS0m.max)((0, $kRS0m.compare), e, e_1), (arg10$0040)=>(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(arg, arg10$0040.fields[0]), prices)));
}
function $9495a8d2b9c5bb89$export$9f1faff963ff51e8(data, settings, item) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceByQualityBy((0, $a117bb35793377d5$export$9cf000d4259784ff), data, settings, item);
}
function $9495a8d2b9c5bb89$export$65da21fd7764752f(data, settings, item) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductPriceByQualityBy((0, $a117bb35793377d5$export$1de53ee5c74c2816), data, settings, item);
}
function $9495a8d2b9c5bb89$var$Price_itemSelectedRawPriceValue(data, settings, seed, item, quality) {
    if ((0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.SellRaw, item)) return (0, $a117bb35793377d5$export$9f54cc0163ec0391)(settings.Game, (0, $e189d4fb2d038fab$export$a6e0eedf3a1bd082)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed)), (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item), quality);
    else return undefined;
}
function $9495a8d2b9c5bb89$var$Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item) {
    if ((0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.SellRaw, item)) return (0, $a117bb35793377d5$export$dcb147af0f4b8d20)(settings.Game, (0, $e189d4fb2d038fab$export$a6e0eedf3a1bd082)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed)), (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item));
    else return undefined;
}
function $9495a8d2b9c5bb89$var$Price_selectedCustomSellPriceValue(selected, item, quality) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg)=>$9495a8d2b9c5bb89$export$4f606b351a0e05bd(quality, tupledArg[0], tupledArg[1]), (0, $3699f71d1df66484$export$96a0df907279b51f)(item, selected.CustomSellPrices));
}
function $9495a8d2b9c5bb89$var$Price_selectedCustomSellPriceValueByQuality(selected, item) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg)=>$9495a8d2b9c5bb89$export$435ae3e6eb1dbda2(tupledArg[0], tupledArg[1]), (0, $3699f71d1df66484$export$96a0df907279b51f)(item, selected.CustomSellPrices));
}
function $9495a8d2b9c5bb89$export$26ab458c772643e9(data, settings, seed, item, quality) {
    let b_2;
    const b = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((value)=>value, $9495a8d2b9c5bb89$var$Price_itemSelectedRawPriceValue(data, settings, seed, item, quality));
    b_2 = (0, $3699f71d1df66484$export$de7d922902dff7f1)((0, $5ce0fb420d4fadad$export$8960430cfd85939f), $9495a8d2b9c5bb89$export$dff060dca23d7ea1(data, settings, item, quality), b);
    return (0, $3699f71d1df66484$export$de7d922902dff7f1)((0, $5ce0fb420d4fadad$export$8960430cfd85939f), (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((value_1)=>value_1, $9495a8d2b9c5bb89$var$Price_selectedCustomSellPriceValue(settings.Selected, item, quality)), b_2);
}
function $9495a8d2b9c5bb89$export$b2edbfa42dc6c7d3(data, settings, seed, item) {
    let b_1;
    return (0, $3699f71d1df66484$export$de7d922902dff7f1)((arg10$0040_3, arg20$0040_1)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$5be556bf484c4f10)((0, $5ce0fb420d4fadad$export$8960430cfd85939f), arg10$0040_3.fields[0], arg20$0040_1.fields[0], Float64Array)), (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arg10$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((value)=>value, arg10$0040.fields[0], Float64Array)), $9495a8d2b9c5bb89$var$Price_selectedCustomSellPriceValueByQuality(settings.Selected, item)), (b_1 = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arg10$0040_1)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((value_1)=>value_1, arg10$0040_1.fields[0], Float64Array)), $9495a8d2b9c5bb89$var$Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item)), (0, $3699f71d1df66484$export$de7d922902dff7f1)((arg10$0040_2, arg20$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$5be556bf484c4f10)((0, $5ce0fb420d4fadad$export$8960430cfd85939f), arg10$0040_2.fields[0], arg20$0040.fields[0], Float64Array)), $9495a8d2b9c5bb89$export$65da21fd7764752f(data, settings, item), b_1)));
}
function $9495a8d2b9c5bb89$var$Price_itemMaxProductAndPriceByQualityBy(projection, data, settings, item) {
    const products = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((product)=>[
            product,
            projection(data, settings.Game, product)
        ], $9495a8d2b9c5bb89$export$665fcfd50343855c(data, settings, item));
    if (products.length === 0) return undefined;
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$2a47f398eeff8b01)(4, (arg)=>(0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((a, b)=>(0, $3699f71d1df66484$export$1f1fcf30eadb9697)((tuple)=>tuple[1], a, b), (tupledArg)=>[
                tupledArg[0],
                (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(arg, tupledArg[1].fields[0])
            ], products)));
}
function $9495a8d2b9c5bb89$export$56a8578ef64ec123(data, settings, item) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductAndPriceByQualityBy((0, $a117bb35793377d5$export$9cf000d4259784ff), data, settings, item);
}
function $9495a8d2b9c5bb89$export$e0aa7acb060b1241(data, settings, item) {
    return $9495a8d2b9c5bb89$var$Price_itemMaxProductAndPriceByQualityBy((0, $a117bb35793377d5$export$1de53ee5c74c2816), data, settings, item);
}
function $9495a8d2b9c5bb89$export$ebcb30292c1548d9(data, settings, seed, item) {
    const sellAs = (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((x)=>x, [
        (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arg10$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((price)=>[
                    undefined,
                    price
                ], arg10$0040.fields[0])), $9495a8d2b9c5bb89$var$Price_itemSelectedRawPriceValueByQuality(data, settings, seed, item)),
        (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((custom)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((price_2)=>[
                    new (0, $3699f71d1df66484$export$12e6ad755a4a86f9)(1, [
                        custom
                    ]),
                    price_2
                ], $9495a8d2b9c5bb89$export$435ae3e6eb1dbda2(custom[0], custom[1]).fields[0])), (0, $3699f71d1df66484$export$96a0df907279b51f)(item, settings.Selected.CustomSellPrices)),
        (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((arg10$0040_2)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>[
                    new (0, $3699f71d1df66484$export$12e6ad755a4a86f9)(0, [
                        tupledArg[0]
                    ]),
                    tupledArg[1]
                ], arg10$0040_2.fields[0])), $9495a8d2b9c5bb89$export$e0aa7acb060b1241(data, settings, item))
    ]);
    if (sellAs.length === 0) return undefined;
    else return new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$2a47f398eeff8b01)(4, (arg)=>(0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((a, b)=>(0, $3699f71d1df66484$export$1f1fcf30eadb9697)((tuple)=>tuple[1], a, b), (arg10$0040_3)=>(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(arg, arg10$0040_3.fields[0]), sellAs)));
}
function $9495a8d2b9c5bb89$export$fcd25d15dcb4980c(data, settings, fertilizer) {
    if (settings.Profit.PayForFertilizer) return $9495a8d2b9c5bb89$export$a960ff6e57439a25(data, settings, fertilizer);
    else return 0;
}
function $9495a8d2b9c5bb89$export$cdc2eb88a8e1410b(data, settings) {
    return (_arg)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (fertilizer)=>$9495a8d2b9c5bb89$export$fcd25d15dcb4980c(data, settings, fertilizer), _arg);
}
function $9495a8d2b9c5bb89$var$fertilizerRelevantVendorAndPrice(data, settings, fertilizer) {
    if (fertilizer != null) {
        if (!settings.Profit.PayForFertilizer) return undefined;
        else {
            const fertilizer_1 = fertilizer;
            return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)($9495a8d2b9c5bb89$export$bd79d4c70e4a627b(data, settings, fertilizer_1.Name));
        }
    } else return undefined;
}
function $9495a8d2b9c5bb89$var$invalidReasons(hasOneHarvest, hasFertilierPrice, hasEnoughSeeds) {
    return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
        (hasOneHarvest ? 0 : 1) | (hasFertilierPrice ? 0 : 2) | (hasEnoughSeeds ? 0 : 4)
    ]);
}
function $9495a8d2b9c5bb89$var$farmCropMaxNonBoughtSeeds(data, settings, crop) {
    let mainItemQuantity, matchValue, quantity, item_1, quantity_1;
    return (mainItemQuantity = (0, $a117bb35793377d5$export$7424f280c9568769)(settings.Game, crop), $9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
        crop
    ])) ? (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(crop.Seed) * mainItemQuantity : $9495a8d2b9c5bb89$export$66784705e4af7e07(settings, crop.Seed, crop.Item) ? mainItemQuantity : 0) + (matchValue = crop.ExtraItem, matchValue != null ? (quantity = matchValue[1], $9495a8d2b9c5bb89$export$66784705e4af7e07(settings, crop.Seed, matchValue[0])) ? (item_1 = matchValue[0], quantity_1 = matchValue[1], quantity_1) : 0 : 0);
}
function $9495a8d2b9c5bb89$var$forageCropMaxNonBoughtSeeds(data, settings, crop) {
    return (0, $5ce0fb420d4fadad$export$8960430cfd85939f)($9495a8d2b9c5bb89$export$f72149ac5e8d2236(settings, crop)[1] ? 10 : 0, $9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(1, [
        crop
    ])) ? (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(crop.Seed) : 0) * (0, $a117bb35793377d5$export$fa8566c54ebcfb81)(settings.Game, crop);
}
function $9495a8d2b9c5bb89$var$maxNonBoughtSeeds(data, settings, crop) {
    if (crop.tag === 1) return $9495a8d2b9c5bb89$var$forageCropMaxNonBoughtSeeds(data, settings, crop.fields[0]);
    else return $9495a8d2b9c5bb89$var$farmCropMaxNonBoughtSeeds(data, settings, crop.fields[0]);
}
function $9495a8d2b9c5bb89$export$1e59367b04e8e57b(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch(matchValue.tag){
        case 0:
            return $9495a8d2b9c5bb89$export$fe2c23bd3d9065d2(settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop));
        case 1:
            if ($9495a8d2b9c5bb89$export$fe2c23bd3d9065d2(settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop))) return true;
            else return $9495a8d2b9c5bb89$var$maxNonBoughtSeeds(data, settings, crop) >= 1;
        default:
            return true;
    }
}
class $9495a8d2b9c5bb89$export$5293b7a0ea060e9 extends (0, $eATN7.Record) {
    constructor(ProfitPerHarvest, HarvestsForMinCost, MinCost, Cost){
        super();
        this.ProfitPerHarvest = ProfitPerHarvest;
        this.HarvestsForMinCost = HarvestsForMinCost;
        this.MinCost = MinCost;
        this.Cost = Cost;
    }
}
function $9495a8d2b9c5bb89$export$405409b154a2a773() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.RegrowCropProfitData", [], $9495a8d2b9c5bb89$export$5293b7a0ea060e9, ()=>[
            [
                "ProfitPerHarvest",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "HarvestsForMinCost",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "MinCost",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "Cost",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$8ff85e1c626cc255))
            ]
        ]);
}
function $9495a8d2b9c5bb89$var$Profit_constantRegrowData(profit, seedCost) {
    return new $9495a8d2b9c5bb89$export$5293b7a0ea060e9(profit, 1, seedCost, (arg10$0040)=>seedCost);
}
function $9495a8d2b9c5bb89$var$Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, crop, prices, quantities) {
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
    const seedCostsAndQuantity = [];
    const seedPriceValue = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(Infinity, (value)=>value, seedPrice);
    const addCostAndQuantity = (item, seedsPerInput)=>{
        const prices_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(item, prices);
        const quantities_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(item, quantities);
        for(let i = 0; i <= 3; i++){
            const cost = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, prices_1.fields[0]) / seedsPerInput;
            const seeds = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, quantities_1.fields[0]) * seedsPerInput;
            if (cost < seedPriceValue && seeds > 0) seedCostsAndQuantity.push([
                cost,
                seeds
            ]);
        }
    };
    if ($9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, crop)) addCostAndQuantity(0, (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(seed));
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((i_1)=>{
        addCostAndQuantity(i_1, 1);
    }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $e5d9070e144b905e$export$5c13475397a61429)((item_1)=>$9495a8d2b9c5bb89$export$66784705e4af7e07(settings, seed, item_1), (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop))));
    seedCostsAndQuantity.sort((delegateArg, delegateArg_1)=>(0, $3699f71d1df66484$export$c90542dabcef4ab1)((tuple)=>tuple[0], delegateArg, delegateArg_1));
    return seedCostsAndQuantity;
}
function $9495a8d2b9c5bb89$var$Profit_seedCostCalc(seedPrice, opportunityCostsAndSeedsPerHarvest, harvests) {
    let seedsLeft = 1;
    let totalCost = 0;
    let i = 0;
    while(i < opportunityCostsAndSeedsPerHarvest.length && seedsLeft > 0){
        const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, opportunityCostsAndSeedsPerHarvest);
        const seedsMade = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(seedsLeft, patternInput[1] * harvests);
        totalCost = totalCost + patternInput[0] * seedsMade;
        seedsLeft = seedsLeft - seedsMade;
        i = i + 1 | 0;
    }
    if (seedPrice == null) {
        if (seedsLeft === 0) return totalCost;
        else return undefined;
    } else {
        const price = seedPrice;
        return totalCost + price * seedsLeft;
    }
}
function $9495a8d2b9c5bb89$var$Profit_trySeedCost(data, settings, seedPrice, crop, prices, quantities, harvests) {
    return $9495a8d2b9c5bb89$var$Profit_seedCostCalc(seedPrice, $9495a8d2b9c5bb89$var$Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, crop, prices, quantities), harvests);
}
function $9495a8d2b9c5bb89$var$Profit_farmCropTrySeedCost(data, settings, seedPrice, crop, prices) {
    if (seedPrice == null && $9495a8d2b9c5bb89$var$farmCropMaxNonBoughtSeeds(data, settings, crop) < 1) return undefined;
    else return (quantities)=>(harvests)=>(0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($9495a8d2b9c5bb89$var$Profit_trySeedCost(data, settings, seedPrice, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                crop
            ]), prices, quantities, harvests));
}
function $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, quantities) {
    return (0, $3699f71d1df66484$export$9f397f7c51499c56)((x, y)=>x + y, (0, $7bbf2c7402328604$export$a50d46369ca5fbd2), prices, quantities);
}
function $9495a8d2b9c5bb89$var$Profit_forageCropProfitPerHarvestCalc(prices, quantities) {
    return (0, $e5d9070e144b905e$export$9e8299ab977385a3)((b)=>(0, $7bbf2c7402328604$export$a50d46369ca5fbd2)(quantities, b), prices, {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    });
}
function $9495a8d2b9c5bb89$var$Profit_cropItemNormalizedPricesByQuality(data, settings, seed, items) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg)=>(0, $22d1a4cfc5fba7ce$export$37721a79838ca038)($9495a8d2b9c5bb89$export$b2edbfa42dc6c7d3(data, settings, seed, arg), (0, $7bbf2c7402328604$export$127ff803a92644c)), items);
}
function $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop) {
    return $9495a8d2b9c5bb89$var$Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, (0, $e189d4fb2d038fab$export$c18dcc1cdb869855)(crop));
}
class $9495a8d2b9c5bb89$var$Profit_Variable extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "BoughtSeeds",
            "SoldItem",
            "MadeSeeds",
            "UsedToCraftForageSeeds",
            "SoldForageSeeds",
            "UsedForageSeeds"
        ];
    }
}
function $9495a8d2b9c5bb89$var$Profit_Variable_$reflection() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Query.Profit.Variable", [], $9495a8d2b9c5bb89$var$Profit_Variable, ()=>[
            [],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Silver",
                            1
                        ],
                        [
                            "Gold",
                            2
                        ],
                        [
                            "Iridium",
                            3
                        ]
                    ])
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Silver",
                            1
                        ],
                        [
                            "Gold",
                            2
                        ],
                        [
                            "Iridium",
                            3
                        ]
                    ])
                ]
            ],
            [
                [
                    "Item1",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Silver",
                            1
                        ],
                        [
                            "Gold",
                            2
                        ],
                        [
                            "Iridium",
                            3
                        ]
                    ])
                ]
            ],
            [],
            []
        ]);
}
function $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitSolution(data, settings, crop, seedTarget, seedPrice, prices, quantities) {
    let price, tupledArg_1, tupledArg_2;
    const patternInput = $9495a8d2b9c5bb89$export$f72149ac5e8d2236(settings, crop);
    let validQualities;
    const array = (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
        [
            "Normal",
            0
        ],
        [
            "Silver",
            1
        ],
        [
            "Gold",
            2
        ],
        [
            "Iridium",
            3
        ]
    ]));
    validQualities = array.filter((q)=>(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(q, quantities.fields[0]) > 0);
    const allocatedToForageSeeds = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((item)=>item.toString() + "@Forage Seeds", crop.Foragables);
    const constraints = (0, $e5d9070e144b905e$export$ee1b3e54f0441b22)([
        [
            [
                "Seeds",
                (0, $113dc42df8fd0649$export$bdcdec1f91f16dff)(seedTarget)
            ]
        ],
        (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
            const quality_2 = tupledArg[1] | 0;
            return [
                tupledArg[0].toString() + ("@" + (0, $kRS0m.int32ToString)(quality_2)),
                (0, $113dc42df8fd0649$export$d6fe668f8d2afbf1)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality_2, quantities.fields[0]))
            ];
        }, (0, $e5d9070e144b905e$export$8016484fb8238078)(crop.Foragables, validQualities)),
        (0, $e5d9070e144b905e$export$871de8747c9eaa88)((quantity)=>[
                quantity,
                (0, $113dc42df8fd0649$export$bdcdec1f91f16dff)(0)
            ], allocatedToForageSeeds)
    ]);
    const variables = [];
    let matchResult, price_1;
    if (seedPrice != null) {
        if (price = seedPrice, seedTarget > 0) {
            matchResult = 0;
            price_1 = seedPrice;
        } else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            variables.push([
                new $9495a8d2b9c5bb89$var$Profit_Variable(0, []),
                [
                    [
                        "Profit",
                        -price_1
                    ],
                    [
                        "Seeds",
                        1
                    ]
                ]
            ]);
            break;
    }
    for(let i = 0; i <= crop.Foragables.length - 1; i++){
        const item_2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, crop.Foragables);
        const prices_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, prices);
        const forageSeedsAllocation = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, allocatedToForageSeeds);
        for(let idx = 0; idx <= validQualities.length - 1; idx++){
            const quality_5 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, validQualities) | 0;
            const oneItem = [
                item_2.toString() + ("@" + (0, $kRS0m.int32ToString)(quality_5)),
                1
            ];
            const itemQuality = [
                item_2,
                quality_5
            ];
            variables.push([
                (tupledArg_1 = itemQuality, new $9495a8d2b9c5bb89$var$Profit_Variable(1, [
                    tupledArg_1[0],
                    tupledArg_1[1]
                ])),
                [
                    [
                        "Profit",
                        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality_5, prices_1.fields[0])
                    ],
                    oneItem
                ]
            ]);
            variables.push([
                (tupledArg_2 = itemQuality, new $9495a8d2b9c5bb89$var$Profit_Variable(3, [
                    tupledArg_2[0],
                    tupledArg_2[1]
                ])),
                [
                    [
                        forageSeedsAllocation,
                        1
                    ],
                    oneItem
                ]
            ]);
        }
    }
    if (seedTarget > 0 && $9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(1, [
        crop
    ]))) {
        const item_3 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, crop.Foragables);
        const quantity_1 = (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(crop.Seed);
        for(let idx_1 = 0; idx_1 <= validQualities.length - 1; idx_1++){
            const quality_8 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx_1, validQualities) | 0;
            variables.push([
                new $9495a8d2b9c5bb89$var$Profit_Variable(2, [
                    item_3,
                    quality_8
                ]),
                [
                    [
                        "Seeds",
                        quantity_1
                    ],
                    [
                        item_3.toString() + ("@" + (0, $kRS0m.int32ToString)(quality_8)),
                        1
                    ]
                ]
            ]);
        }
    }
    const oneOfEachItemUsed = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((quantity_2)=>[
            quantity_2,
            -1
        ], allocatedToForageSeeds);
    if (patternInput[0]) {
        const price_2 = (0, $a117bb35793377d5$export$6de4f019aaca4b93)(data, settings.Game, crop.Seed);
        variables.push([
            new $9495a8d2b9c5bb89$var$Profit_Variable(4, []),
            (0, $e5d9070e144b905e$export$10d8903dec122b9d)([
                [
                    "Profit",
                    10 * price_2
                ]
            ], oneOfEachItemUsed)
        ]);
    }
    if (seedTarget > 0 && patternInput[1]) variables.push([
        new $9495a8d2b9c5bb89$var$Profit_Variable(5, []),
        (0, $e5d9070e144b905e$export$10d8903dec122b9d)([
            [
                "Seeds",
                10
            ]
        ], oneOfEachItemUsed)
    ]);
    return (0, $ee30d3058756a18e$export$2865df1f26e73f8e)({
        constraints: constraints,
        direction: "maximize",
        objective: "Profit",
        variables: variables
    }, undefined);
}
function $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitPerHarvest(data, settings, crop, seedPrice) {
    const prices = $9495a8d2b9c5bb89$var$Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, crop.Foragables);
    const quantities = (0, $a117bb35793377d5$export$3f1fefec7d4e8a64)(settings.Game, crop);
    if ($9495a8d2b9c5bb89$export$7f026a93e2ebcde8(settings, crop)) {
        const solution = $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitSolution(data, settings, crop, 1, seedPrice, prices, quantities);
        return solution.result;
    } else return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((cost)=>$9495a8d2b9c5bb89$var$Profit_forageCropProfitPerHarvestCalc(prices, quantities) - cost, $9495a8d2b9c5bb89$var$Profit_trySeedCost(data, settings, seedPrice, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(1, [
        crop
    ]), prices, [
        quantities
    ], 1));
}
function $9495a8d2b9c5bb89$var$Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    const prices = $9495a8d2b9c5bb89$var$Profit_cropItemNormalizedPricesByQuality(data, settings, crop.Seed, crop.Foragables);
    const quantities = (0, $a117bb35793377d5$export$3f1fefec7d4e8a64)(settings.Game, crop);
    if ($9495a8d2b9c5bb89$export$f72149ac5e8d2236(settings, crop)[0]) {
        const solution = $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitSolution(data, settings, crop, 0, undefined, prices, quantities);
        return solution.result;
    } else return $9495a8d2b9c5bb89$var$Profit_forageCropProfitPerHarvestCalc(prices, quantities);
}
function $9495a8d2b9c5bb89$var$Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    const prices = $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop);
    return (fertilizer)=>$9495a8d2b9c5bb89$var$Profit_profitCalc(prices, (0, $a117bb35793377d5$export$eba3ec6aec8588b3)(settings.Game, fertilizer, crop));
}
function $9495a8d2b9c5bb89$var$Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop) {
    if (crop.tag === 1) {
        const x = $9495a8d2b9c5bb89$var$Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
        return (arg10$0040)=>x;
    } else return $9495a8d2b9c5bb89$var$Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
}
function $9495a8d2b9c5bb89$var$Profit_cropProfitAndSeedPrice(data, settings, crop) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((seedPrice)=>{
        const profitPerHarvest = $9495a8d2b9c5bb89$var$Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
        return (fertilizer)=>[
                profitPerHarvest(fertilizer),
                seedPrice
            ];
    }, $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop)));
}
function $9495a8d2b9c5bb89$var$Profit_nonRegrowCropStockpileSeedsProfitPerHarvest(data, settings, crop) {
    const seedPrice = $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop));
    if (crop.tag === 1) return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((x)=>(arg10$0040)=>x, $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
    else {
        const crop_1 = crop.fields[0];
        const prices = $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop_1);
        return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((seedCost)=>(fertilizer)=>{
                const quantities = (0, $a117bb35793377d5$export$eba3ec6aec8588b3)(settings.Game, fertilizer, crop_1);
                return $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, quantities) - seedCost(quantities)(1);
            }, $9495a8d2b9c5bb89$var$Profit_farmCropTrySeedCost(data, settings, seedPrice, crop_1, prices));
    }
}
function $9495a8d2b9c5bb89$var$Profit_regrowDataStockpileSeeds(data, settings, crop) {
    const seedPrice = $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, crop.Seed);
    const prices = $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop);
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((_arg)=>(fertilizer)=>{
            let value_1, value;
            const quantities = (0, $a117bb35793377d5$export$eba3ec6aec8588b3)(settings.Game, fertilizer, crop);
            const profit = $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, quantities);
            const costsAndLimits = $9495a8d2b9c5bb89$var$Profit_seedOpportunityCostsAndQuantityPerHarvest(data, settings, seedPrice, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                crop
            ]), prices, quantities);
            const matchValue = (0, $e5d9070e144b905e$export$1acbe849d0cb723e)(costsAndLimits);
            if (matchValue != null) {
                const cost = matchValue[0];
                return new $9495a8d2b9c5bb89$export$5293b7a0ea060e9(profit, (value_1 = (value = 1 / matchValue[1], Math.ceil(value)), value_1 >>> 0), cost, (arg)=>(0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($9495a8d2b9c5bb89$var$Profit_seedCostCalc(seedPrice, costsAndLimits, arg)));
            } else return $9495a8d2b9c5bb89$var$Profit_constantRegrowData(profit, (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(seedPrice));
        }, $9495a8d2b9c5bb89$var$Profit_farmCropTrySeedCost(data, settings, seedPrice, crop, prices));
}
function $9495a8d2b9c5bb89$var$Profit_nonRegrowCropProfitPerHarvest(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch(matchValue.tag){
        case 1:
            return $9495a8d2b9c5bb89$var$Profit_nonRegrowCropStockpileSeedsProfitPerHarvest(data, settings, crop);
        case 0:
            return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((profitAndPrice)=>(fertilizer)=>{
                    const patternInput = profitAndPrice(fertilizer);
                    return patternInput[0] - patternInput[1];
                }, $9495a8d2b9c5bb89$var$Profit_cropProfitAndSeedPrice(data, settings, crop));
        default:
            return $9495a8d2b9c5bb89$var$Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
    }
}
function $9495a8d2b9c5bb89$var$Profit_regrowCropProfitData(data, settings, crop) {
    const matchValue = settings.Profit.SeedStrategy;
    switch(matchValue.tag){
        case 1:
            return $9495a8d2b9c5bb89$var$Profit_regrowDataStockpileSeeds(data, settings, crop);
        case 0:
            return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((profitAndPrice)=>(fertilizer_1)=>{
                    const tupledArg = profitAndPrice(fertilizer_1);
                    return $9495a8d2b9c5bb89$var$Profit_constantRegrowData(tupledArg[0], tupledArg[1]);
                }, $9495a8d2b9c5bb89$var$Profit_cropProfitAndSeedPrice(data, settings, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                crop
            ])));
        default:
            {
                const profit = $9495a8d2b9c5bb89$var$Profit_farmCropIgnoreSeedsProfitPerHarvest(data, settings, crop);
                return (fertilizer)=>$9495a8d2b9c5bb89$var$Profit_constantRegrowData(profit(fertilizer), 0);
            }
    }
}
function $9495a8d2b9c5bb89$var$Profit_ignoreSeeds(data, settings, crop) {
    const profit = $9495a8d2b9c5bb89$var$Profit_cropIgnoreSeedsProfitPerHarvest(data, settings, crop);
    return (fertilizer)=>(harvests)=>profit(fertilizer) * harvests;
}
function $9495a8d2b9c5bb89$var$Profit_stockpileSeeds(data, settings, crop) {
    const seedPrice = $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop));
    if (crop.tag === 1) return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((net)=>(_arg)=>(harvests_1)=>net * harvests_1, $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
    else {
        const crop_1 = crop.fields[0];
        const prices = $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop_1);
        return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((seedCost)=>(fertilizer)=>(harvests)=>{
                    const quantities = (0, $a117bb35793377d5$export$eba3ec6aec8588b3)(settings.Game, fertilizer, crop_1);
                    const patternInput = crop_1.RegrowTime != null ? [
                        harvests,
                        1
                    ] : [
                        1,
                        harvests
                    ];
                    return $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, quantities) * harvests - seedCost(quantities)(patternInput[0]) * patternInput[1];
                }, $9495a8d2b9c5bb89$var$Profit_farmCropTrySeedCost(data, settings, seedPrice, crop_1, prices));
    }
}
function $9495a8d2b9c5bb89$var$Profit_buyFirstSeed(data, settings, crop, seedPrice) {
    if (crop.tag === 1) {
        const profit_1 = $9495a8d2b9c5bb89$var$Profit_forageCropIgnoreSeedsProfitPerHarvest(data, settings, crop.fields[0]);
        const net = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($9495a8d2b9c5bb89$var$Profit_forageCropNetProfitPerHarvest(data, settings, crop.fields[0], seedPrice));
        return (_arg)=>(harvests_2)=>profit_1 + net * (harvests_2 - 1);
    } else if (crop.fields[0].RegrowTime != null) return $9495a8d2b9c5bb89$var$Profit_ignoreSeeds(data, settings, crop);
    else {
        const prices = $9495a8d2b9c5bb89$var$Profit_farmCropItemNormalizedPricesByQuality(data, settings, crop.fields[0]);
        return (fertilizer)=>(harvests_1)=>{
                const quantities_1 = (0, $a117bb35793377d5$export$eba3ec6aec8588b3)(settings.Game, fertilizer, crop.fields[0]);
                return $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, quantities_1) * harvests_1 - (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)($9495a8d2b9c5bb89$var$Profit_trySeedCost(data, settings, seedPrice, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                    crop.fields[0]
                ]), prices, quantities_1, 1)) * (harvests_1 - 1);
            };
    }
}
function $9495a8d2b9c5bb89$var$Profit_mapData(mapping, data, settings, timeNormalization, crop) {
    let seedPriceAndProfit;
    const matchValue = settings.Profit.SeedStrategy;
    seedPriceAndProfit = matchValue.tag === 1 ? (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((profit)=>[
            0,
            profit
        ], $9495a8d2b9c5bb89$var$Profit_stockpileSeeds(data, settings, crop)) : matchValue.tag === 0 ? (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((price)=>[
            price,
            $9495a8d2b9c5bb89$var$Profit_buyFirstSeed(data, settings, crop, price)
        ], $9495a8d2b9c5bb89$export$d9528ce49add42(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop))) : [
        0,
        $9495a8d2b9c5bb89$var$Profit_ignoreSeeds(data, settings, crop)
    ];
    return (arg)=>{
        let fertilizer, growthSpan, fertCost, fertCost_1, profit_1, seedPrice, span, replacementCost, divisor, investment;
        return mapping((fertilizer = arg, growthSpan = $9495a8d2b9c5bb89$export$c230577c82088908(settings.Game, fertilizer, crop), fertCost = $9495a8d2b9c5bb89$export$cdc2eb88a8e1410b(data, settings)((0, $7bbf2c7402328604$export$70921c9a086f6004)(fertilizer)), growthSpan != null ? seedPriceAndProfit != null ? fertCost != null ? (fertCost_1 = fertCost, profit_1 = seedPriceAndProfit[1], seedPrice = seedPriceAndProfit[0], span = growthSpan, replacementCost = fertCost_1 * $9495a8d2b9c5bb89$export$eab7a6e44ba71d7b(settings, crop) * (span.Harvests - 1), divisor = $9495a8d2b9c5bb89$export$b47c33e087d871e9(span, crop, timeNormalization), investment = seedPrice + fertCost_1, new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
            [
                profit_1(fertilizer)(span.Harvests) - replacementCost - investment,
                investment,
                divisor
            ]
        ])) : $9495a8d2b9c5bb89$var$invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null) : $9495a8d2b9c5bb89$var$invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null) : $9495a8d2b9c5bb89$var$invalidReasons(growthSpan != null, fertCost != null, seedPriceAndProfit != null)));
    };
}
function $9495a8d2b9c5bb89$var$XP_nonRegrowCropXpPerHarvest(data, settings, crop) {
    if (!$9495a8d2b9c5bb89$export$1e59367b04e8e57b(data, settings, crop)) return undefined;
    else return (0, $a117bb35793377d5$export$9a7a916d4806bc7f)(data, settings.Game, crop);
}
function $9495a8d2b9c5bb89$var$XP_regrowCropXpData(data, settings, crop) {
    const crop_1 = new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
        crop
    ]);
    if (!$9495a8d2b9c5bb89$export$1e59367b04e8e57b(data, settings, crop_1)) return undefined;
    else return new $9495a8d2b9c5bb89$export$5293b7a0ea060e9((0, $a117bb35793377d5$export$9a7a916d4806bc7f)(data, settings.Game, crop_1), 1, 0, (arg10$0040)=>0);
}
class $9495a8d2b9c5bb89$export$a99fc57ca5dea88f extends (0, $eATN7.Record) {
    constructor(Item, Quality, Price, Quantity, Custom){
        super();
        this.Item = Item;
        this.Quality = Quality | 0;
        this.Price = Price;
        this.Quantity = Quantity;
        this.Custom = Custom;
    }
}
function $9495a8d2b9c5bb89$export$62ed72c9f787e9d6() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.SoldItemSummary", [], $9495a8d2b9c5bb89$export$a99fc57ca5dea88f, ()=>[
            [
                "Item",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Quality",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Silver",
                        1
                    ],
                    [
                        "Gold",
                        2
                    ],
                    [
                        "Iridium",
                        3
                    ]
                ])
            ],
            [
                "Price",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Quantity",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "Custom",
                (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)
            ]
        ]);
}
class $9495a8d2b9c5bb89$export$d8b3b6292b98ba27 extends (0, $eATN7.Record) {
    constructor(Product, Quality, Price, Quantity, ConsumedItemQuantities){
        super();
        this.Product = Product;
        this.Quality = Quality | 0;
        this.Price = Price;
        this.Quantity = Quantity;
        this.ConsumedItemQuantities = ConsumedItemQuantities;
    }
}
function $9495a8d2b9c5bb89$export$d88b8a67107ddbdf() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.SoldProductSummary", [], $9495a8d2b9c5bb89$export$d8b3b6292b98ba27, ()=>[
            [
                "Product",
                (0, $cdb0798a49937e52$export$dad5cd665e3081d1)()
            ],
            [
                "Quality",
                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Silver",
                        1
                    ],
                    [
                        "Gold",
                        2
                    ],
                    [
                        "Iridium",
                        3
                    ]
                ])
            ],
            [
                "Price",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Quantity",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ConsumedItemQuantities",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Silver",
                        1
                    ],
                    [
                        "Gold",
                        2
                    ],
                    [
                        "Iridium",
                        3
                    ]
                ])), (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)))
            ]
        ]);
}
class $9495a8d2b9c5bb89$export$6dea9c4ecbcc6059 extends (0, $eATN7.Record) {
    constructor(Crop, Harvests, ReplacedFertilizer, SeedPrice, UnsoldItems, SoldItems, SoldProducts, SeedsUsed, SeedsBought, ForageSeedsSold, ForageSeedsUsed, NetProfit){
        super();
        this.Crop = Crop;
        this.Harvests = Harvests;
        this.ReplacedFertilizer = ReplacedFertilizer;
        this.SeedPrice = SeedPrice;
        this.UnsoldItems = UnsoldItems;
        this.SoldItems = SoldItems;
        this.SoldProducts = SoldProducts;
        this.SeedsUsed = SeedsUsed;
        this.SeedsBought = SeedsBought;
        this.ForageSeedsSold = ForageSeedsSold;
        this.ForageSeedsUsed = ForageSeedsUsed;
        this.NetProfit = NetProfit;
    }
}
function $9495a8d2b9c5bb89$export$a7321c619ab1076b() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.CropProfitSummary", [], $9495a8d2b9c5bb89$export$6dea9c4ecbcc6059, ()=>[
            [
                "Crop",
                (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)()
            ],
            [
                "Harvests",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "ReplacedFertilizer",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "SeedPrice",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3699f71d1df66484$export$71cbeed5e0d6df07)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ],
            [
                "UnsoldItems",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $7bbf2c7402328604$export$dd69cde14303022b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))))
            ],
            [
                "SoldItems",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)($9495a8d2b9c5bb89$export$62ed72c9f787e9d6())
            ],
            [
                "SoldProducts",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)($9495a8d2b9c5bb89$export$d88b8a67107ddbdf())
            ],
            [
                "SeedsUsed",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $7bbf2c7402328604$export$dd69cde14303022b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))))
            ],
            [
                "SeedsBought",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ForageSeedsSold",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ForageSeedsUsed",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "NetProfit",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))
            ]
        ]);
}
class $9495a8d2b9c5bb89$export$8c91d97d9cb55f21 extends (0, $eATN7.Record) {
    constructor(Fertilizer, FertilizerPrice, CropSummaries, NetProfit, TimeNormalization){
        super();
        this.Fertilizer = Fertilizer;
        this.FertilizerPrice = FertilizerPrice;
        this.CropSummaries = CropSummaries;
        this.NetProfit = NetProfit;
        this.TimeNormalization = TimeNormalization;
    }
}
function $9495a8d2b9c5bb89$export$91943bb4faeaa786() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.ProfitSummary", [], $9495a8d2b9c5bb89$export$8c91d97d9cb55f21, ()=>[
            [
                "Fertilizer",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "FertilizerPrice",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3699f71d1df66484$export$71cbeed5e0d6df07)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539))))
            ],
            [
                "CropSummaries",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)($9495a8d2b9c5bb89$export$a7321c619ab1076b())
            ],
            [
                "NetProfit",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))
            ],
            [
                "TimeNormalization",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ]
        ]);
}
function $9495a8d2b9c5bb89$export$a7b20f6704c76c50(buyFirstSeed, summary) {
    const fertPrice = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (option)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple)=>tuple[1], option), summary.FertilizerPrice);
    const seedPrice = buyFirstSeed ? (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple_1)=>tuple_1[1], (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, summary.CropSummaries).SeedPrice) : 0;
    const matchValue = summary.NetProfit;
    let matchResult, fertPrice_1, net, seedPrice_1;
    if (matchValue != null) {
        if (fertPrice != null) {
            if (seedPrice != null) {
                matchResult = 0;
                fertPrice_1 = fertPrice;
                net = matchValue;
                seedPrice_1 = seedPrice;
            } else matchResult = 1;
        } else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            {
                const investment = fertPrice_1 + seedPrice_1;
                return [
                    investment,
                    investment === 0 ? undefined : net / investment
                ];
            }
        default:
            return [
                undefined,
                undefined
            ];
    }
}
class $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary extends (0, $eATN7.Record) {
    constructor(Profit, SoldQuantities, SeedsUsed, SeedsBought, ForageSeedsSold, ForageSeedsUsed){
        super();
        this.Profit = Profit;
        this.SoldQuantities = SoldQuantities;
        this.SeedsUsed = SeedsUsed;
        this.SeedsBought = SeedsBought;
        this.ForageSeedsSold = ForageSeedsSold;
        this.ForageSeedsUsed = ForageSeedsUsed;
    }
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary_$reflection() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.ProfitSummaryCalc.ItemAndSeedSummary", [], $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary, ()=>[
            [
                "Profit",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))
            ],
            [
                "SoldQuantities",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $7bbf2c7402328604$export$dd69cde14303022b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255)))
            ],
            [
                "SeedsUsed",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $7bbf2c7402328604$export$dd69cde14303022b)((0, $3921efb06a31e9cc$export$8ff85e1c626cc255))))
            ],
            [
                "SeedsBought",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ForageSeedsSold",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "ForageSeedsUsed",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ]
        ]);
}
const $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummaryModule_zero = new $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary(0, [], [], 0, 0, 0);
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_seedCostAndQuantityData(data, settings, crop, seedPrice, items, prices, quantities) {
    const seedCostAndQuantity = [];
    const seedPriceValue = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(Infinity, (value)=>value, seedPrice);
    const addCostAndQuantity = (item, seedsPerItem)=>{
        const prices_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(item, prices);
        const quantities_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(item, quantities);
        for(let i = 0; i <= 3; i++){
            const quality = i | 0;
            const cost = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, prices_1.fields[0]) / seedsPerItem;
            const quantities_2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, quantities_1.fields[0]);
            if (cost < seedPriceValue && quantities_2 > 0) seedCostAndQuantity.push({
                ItemIndex: item,
                OpportunityCostPerSeed: cost,
                Quality: quality,
                Quantity: quantities_2,
                SeedsPerConsumedItem: seedsPerItem
            });
        }
    };
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
    if ($9495a8d2b9c5bb89$export$39895f4267c0fc5c(data, settings, crop)) addCostAndQuantity(0, (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(seed));
    (0, $42cbcefff7323768$export$c1a059043cc9c119)((i_1)=>{
        addCostAndQuantity(i_1, 1);
    }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $e5d9070e144b905e$export$5c13475397a61429)((item_1)=>$9495a8d2b9c5bb89$export$66784705e4af7e07(settings, seed, item_1), items)));
    const seedCostAndQuantity_1 = seedCostAndQuantity;
    seedCostAndQuantity_1.sort((a, b)=>(0, $3699f71d1df66484$export$c90542dabcef4ab1)((_arg_3)=>_arg_3.OpportunityCostPerSeed, a, b));
    return seedCostAndQuantity_1;
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_partitionQuantitiesForSeeds(data, settings, crop, seedPrice, prices, quantities, harvests) {
    let array_4;
    const items = (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop);
    const seedCostAndQuantity = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_seedCostAndQuantityData(data, settings, crop, seedPrice, items, prices, quantities);
    const quantitiesConsumedForSeeds = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((_arg)=>new Float64Array(4), items);
    let seedsLeft = (0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f)(crop) ? 1 : harvests;
    let i = 0;
    while(i < seedCostAndQuantity.length && seedsLeft > 0){
        const data_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, seedCostAndQuantity);
        const seedsMade = (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(seedsLeft, data_1.Quantity * data_1.SeedsPerConsumedItem);
        (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(data_1.ItemIndex, quantitiesConsumedForSeeds)[data_1.Quality] = seedsMade / data_1.SeedsPerConsumedItem;
        seedsLeft = seedsLeft - seedsMade;
        i = i + 1 | 0;
    }
    const quantitiesConsumedForSeeds_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arr)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)(arr), quantitiesConsumedForSeeds);
    return [
        (0, $e5d9070e144b905e$export$5be556bf484c4f10)((arg10$0040, arg20$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$5be556bf484c4f10)((x, y)=>x - y, arg10$0040.fields[0], arg20$0040.fields[0], Float64Array)), quantities, quantitiesConsumedForSeeds_1),
        (array_4 = (0, $e5d9070e144b905e$export$8901015135f2fb22)(items, quantitiesConsumedForSeeds_1), array_4.filter((tupledArg)=>!(0, $kRS0m.equals)(tupledArg[1], (0, $7bbf2c7402328604$export$127ff803a92644c)))),
        seedsLeft
    ];
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_nonForageItemAndSeedSummary(makeSeeds, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const quantities_1 = harvests === 1 ? quantities : (0, $e5d9070e144b905e$export$871de8747c9eaa88)((qualities)=>(0, $7bbf2c7402328604$export$a324e82014c2a7ef)(harvests, qualities), quantities);
    const patternInput = makeSeeds ? $9495a8d2b9c5bb89$var$ProfitSummaryCalc_partitionQuantitiesForSeeds(data, settings, crop, seedPrice, prices, quantities_1, harvests) : [
        quantities_1,
        [],
        0
    ];
    const soldQuantities = patternInput[0];
    const seedsBought = patternInput[2];
    const profit = $9495a8d2b9c5bb89$var$Profit_profitCalc(prices, soldQuantities);
    const bind$0040 = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummaryModule_zero;
    return new $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary(seedPrice == null ? seedsBought === 0 ? profit : undefined : profit - seedPrice * seedsBought, soldQuantities, patternInput[1], seedsBought, bind$0040.ForageSeedsSold, bind$0040.ForageSeedsUsed);
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_itemQuantities(harvests, variableFilter, solution) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
        const usage = tupledArg[1];
        const quantities = new Float64Array(4);
        for(let idx = 0; idx <= usage.length - 1; idx++){
            const forLoopVar = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(idx, usage);
            (0, $e5d9070e144b905e$export$8a8216c44337cd5)(quantities, forLoopVar[1][0], forLoopVar[1][1] * harvests);
        }
        return [
            tupledArg[0],
            new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)(quantities)
        ];
    }, (0, $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe)((tuple)=>tuple[0], (0, $e5d9070e144b905e$export$7877a478dd30fd3d)(variableFilter, solution.variables), {
        Equals: (0, $kRS0m.equals),
        GetHashCode: (0, $kRS0m.structuralHash)
    }));
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_variableCount(variable, harvests, solution) {
    return (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (tuple_1)=>tuple_1[1], (0, $e5d9070e144b905e$export$d65cb303b863e3bf)((arg)=>(0, $kRS0m.equals)(variable, arg[0]), solution.variables)) * harvests;
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_forageCropItemAndSeedSummary(makeSeeds, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const seedTarget = makeSeeds ? (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(1, $9495a8d2b9c5bb89$var$forageCropMaxNonBoughtSeeds(data, settings, crop)) : 0;
    const solution = $9495a8d2b9c5bb89$var$Profit_forageCropNetProfitSolution(data, settings, crop, seedTarget, seedPrice, prices, quantities);
    const soldQuantities = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_itemQuantities(harvests, (_arg)=>{
        if (_arg[0].tag === 1) return [
            _arg[0].fields[0],
            [
                _arg[0].fields[1],
                _arg[1]
            ]
        ];
        else return undefined;
    }, solution);
    const soldsoldQuantities = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((item_1)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)((0, $7bbf2c7402328604$export$127ff803a92644c), (tuple_1)=>tuple_1[1], (0, $e5d9070e144b905e$export$d65cb303b863e3bf)((arg)=>item_1 === arg[0], soldQuantities)), crop.Foragables);
    const seedsUsed = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_itemQuantities(harvests, (_arg_2)=>{
        if (_arg_2[0].tag === 2) return [
            _arg_2[0].fields[0],
            [
                _arg_2[0].fields[1],
                _arg_2[1]
            ]
        ];
        else return undefined;
    }, solution);
    const seedsBought = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_variableCount(new $9495a8d2b9c5bb89$var$Profit_Variable(0, []), harvests, solution);
    return new $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary((!makeSeeds ? true : seedTarget === 1) ? solution.result * harvests : undefined, soldsoldQuantities, seedsUsed, seedPrice == null ? seedsBought === 0 ? 0 : (1 - seedTarget) * harvests : seedsBought, 10 * $9495a8d2b9c5bb89$var$ProfitSummaryCalc_variableCount(new $9495a8d2b9c5bb89$var$Profit_Variable(4, []), harvests, solution), 10 * $9495a8d2b9c5bb89$var$ProfitSummaryCalc_variableCount(new $9495a8d2b9c5bb89$var$Profit_Variable(5, []), harvests, solution));
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_soldItemsAndProducts(data, settings, items, sellAs, soldQuantities) {
    const unsoldItems = [];
    const soldItems = [];
    const soldProducts = [];
    for(let i = 0; i <= items.length - 1; i++){
        const item = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, items);
        const quantities = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, soldQuantities);
        const matchValue = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, sellAs);
        if (matchValue != null) {
            const sellAs_1 = matchValue;
            for(let i_1 = 0; i_1 <= 3; i_1++){
                const quality = i_1 | 0;
                const quantity = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, quantities.fields[0]);
                if (quantity === 0) ;
                else {
                    const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(quality, sellAs_1.fields[0]);
                    const sellAs_2 = patternInput[0];
                    let matchResult, product;
                    if (sellAs_2 != null) {
                        if (sellAs_2.tag === 0) {
                            matchResult = 1;
                            product = sellAs_2.fields[0];
                        } else matchResult = 0;
                    } else matchResult = 0;
                    switch(matchResult){
                        case 0:
                            soldItems.push(new $9495a8d2b9c5bb89$export$a99fc57ca5dea88f(item, quality, patternInput[1] >>> 0, quantity, sellAs_2 != null));
                            break;
                        case 1:
                            {
                                const patternInput_1 = (0, $a117bb35793377d5$export$dd97a9a222eebe8)(data, settings.Game, quality, product);
                                soldProducts.push([
                                    [
                                        [
                                            item,
                                            quality
                                        ],
                                        quantity
                                    ],
                                    [
                                        product,
                                        patternInput_1[1],
                                        patternInput_1[0]
                                    ]
                                ]);
                                break;
                            }
                    }
                }
            }
        } else unsoldItems.push([
            item,
            quantities
        ]);
    }
    return [
        unsoldItems,
        soldItems,
        (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
            const _arg_2 = tupledArg[0];
            const product_1 = _arg_2[0];
            const items_2 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tuple_1)=>tuple_1[0], tupledArg[1]);
            return new $9495a8d2b9c5bb89$export$d8b3b6292b98ba27(product_1, _arg_2[1], _arg_2[2], (0, $e5d9070e144b905e$export$9e8299ab977385a3)((tuple_2)=>tuple_2[1], items_2, {
                GetZero: ()=>0,
                Add: (x_1, y_1)=>x_1 + y_1
            }) * (0, $cdb0798a49937e52$export$209a37fa913f613e)(product_1), items_2);
        }, (0, $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe)((tuple)=>tuple[1], soldProducts, {
            Equals: (0, $kRS0m.equalArrays),
            GetHashCode: (0, $kRS0m.arrayHash)
        }))
    ];
}
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_harvestSummary(forageItemAndSeedSummary, nonForageItemAndSeedSummary, data, settings, fertilizerPrice, fertilizer, lastCrop, crop, harvests) {
    let matchValue, profit, profit_2, cost, profit_1;
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
    const seedVendorAndPrice = $9495a8d2b9c5bb89$export$15514148d320a778(data, settings, seed);
    const seedPrice = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple)=>tuple[1], seedVendorAndPrice);
    const replacedFertilizer = $9495a8d2b9c5bb89$export$eab7a6e44ba71d7b(settings, crop) * (harvests - (lastCrop ? 1 : 0));
    const sellAs = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((item)=>$9495a8d2b9c5bb89$export$ebcb30292c1548d9(data, settings, seed, item), (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop));
    const prices = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((_arg_2)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)((0, $7bbf2c7402328604$export$127ff803a92644c), (arg10$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((tuple_1)=>tuple_1[1], arg10$0040.fields[0], Float64Array)), _arg_2), sellAs);
    const summary = crop.tag === 1 ? $9495a8d2b9c5bb89$export$7f026a93e2ebcde8(settings, crop.fields[0]) ? forageItemAndSeedSummary(data, settings, crop.fields[0], seedPrice, prices, (0, $a117bb35793377d5$export$3f1fefec7d4e8a64)(settings.Game, crop.fields[0]), harvests) : nonForageItemAndSeedSummary(data, settings, crop, seedPrice, prices, (0, $a117bb35793377d5$export$e92e56ca8bfa8dc7)(settings.Game, fertilizer, crop), harvests) : nonForageItemAndSeedSummary(data, settings, crop, seedPrice, prices, (0, $a117bb35793377d5$export$e92e56ca8bfa8dc7)(settings.Game, fertilizer, crop), harvests);
    const patternInput = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_soldItemsAndProducts(data, settings, (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop), sellAs, summary.SoldQuantities);
    return new $9495a8d2b9c5bb89$export$6dea9c4ecbcc6059(crop, harvests, replacedFertilizer, seedVendorAndPrice, patternInput[0], patternInput[1], patternInput[2], summary.SeedsUsed, summary.SeedsBought, summary.ForageSeedsSold, summary.ForageSeedsUsed, (matchValue = summary.Profit, matchValue != null ? fertilizerPrice == null ? (profit = matchValue, replacedFertilizer === 0) ? (profit_2 = matchValue, profit_2) : undefined : (cost = fertilizerPrice, profit_1 = matchValue, profit_1 - cost * replacedFertilizer) : undefined));
}
const $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ignoreSeeds = (data_2)=>(settings_2)=>(fertilizerPrice)=>(fertilizer)=>(lastCrop)=>(crop_2)=>(harvests_2)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_forageCropItemAndSeedSummary(false, data, settings, crop, seedPrice, prices, quantities, harvests), (data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_nonForageItemAndSeedSummary(false, data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1), data_2, settings_2, fertilizerPrice, fertilizer, lastCrop, crop_2, harvests_2);
const $9495a8d2b9c5bb89$var$ProfitSummaryCalc_stockpileSeeds = (data_2)=>(settings_2)=>(fertilizerPrice)=>(fertilizer)=>(lastCrop)=>(crop_2)=>(harvests_2)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_forageCropItemAndSeedSummary(true, data, settings, crop, seedPrice, prices, quantities, harvests), (data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_nonForageItemAndSeedSummary(true, data_1, settings_1, crop_1, seedPrice_1, prices_1, quantities_1, harvests_1), data_2, settings_2, fertilizerPrice, fertilizer, lastCrop, crop_2, harvests_2);
function $9495a8d2b9c5bb89$var$ProfitSummaryCalc_buyFirstSeedItemSummary(itemAndSeedSummary, data, settings, crop, seedPrice, prices, quantities, harvests) {
    const firstSummary = itemAndSeedSummary(false, data, settings, crop, seedPrice, prices, quantities, 1);
    const summary = itemAndSeedSummary(true, data, settings, crop, seedPrice, prices, quantities, harvests - 1);
    return new $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary((0, $22d1a4cfc5fba7ce$export$f7389512af34c855)((seedPrice_1, firstProfit, profit)=>firstProfit + profit - seedPrice_1, seedPrice, firstSummary.Profit, summary.Profit), (0, $e5d9070e144b905e$export$5be556bf484c4f10)((arg10$0040, arg20$0040)=>new (0, $7bbf2c7402328604$export$e7a5f882b7c87870)((0, $e5d9070e144b905e$export$5be556bf484c4f10)((x, y)=>x + y, arg10$0040.fields[0], arg20$0040.fields[0], Float64Array)), firstSummary.SoldQuantities, summary.SoldQuantities), summary.SeedsUsed, summary.SeedsBought + 1, firstSummary.ForageSeedsSold + summary.ForageSeedsSold, summary.ForageSeedsUsed);
}
const $9495a8d2b9c5bb89$var$ProfitSummaryCalc_buyFirstSeed = (data_4)=>(settings_4)=>(fertilizerPrice)=>(fertilizer)=>(lastCrop)=>(crop_4)=>(harvests_4)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_harvestSummary((data, settings, crop, seedPrice, prices, quantities, harvests)=>$9495a8d2b9c5bb89$var$ProfitSummaryCalc_buyFirstSeedItemSummary($9495a8d2b9c5bb89$var$ProfitSummaryCalc_forageCropItemAndSeedSummary, data, settings, crop, seedPrice, prices, quantities, harvests), (data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2)=>{
                                if ((0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f)(crop_2)) {
                                    const summary = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_nonForageItemAndSeedSummary(false, data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2);
                                    return new $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ItemAndSeedSummary((0, $22d1a4cfc5fba7ce$export$5be556bf484c4f10)((profit, seedPrice_3)=>profit - seedPrice_3, summary.Profit, seedPrice_2), summary.SoldQuantities, summary.SeedsUsed, 1, summary.ForageSeedsSold, summary.ForageSeedsUsed);
                                } else return $9495a8d2b9c5bb89$var$ProfitSummaryCalc_buyFirstSeedItemSummary($9495a8d2b9c5bb89$var$ProfitSummaryCalc_nonForageItemAndSeedSummary, data_2, settings_2, crop_2, seedPrice_2, prices_2, quantities_2, harvests_2);
                            }, data_4, settings_4, fertilizerPrice, fertilizer, lastCrop, crop_4, harvests_4);
class $9495a8d2b9c5bb89$export$a20ae6c78eb68ad2 extends (0, $eATN7.Record) {
    constructor(Crop, Harvests, XpPerItem, ItemQuantity){
        super();
        this.Crop = Crop;
        this.Harvests = Harvests;
        this.XpPerItem = XpPerItem;
        this.ItemQuantity = ItemQuantity;
    }
}
function $9495a8d2b9c5bb89$export$bcdc55e99127c507() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.CropXpSummary", [], $9495a8d2b9c5bb89$export$a20ae6c78eb68ad2, ()=>[
            [
                "Crop",
                (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)()
            ],
            [
                "Harvests",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "XpPerItem",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "ItemQuantity",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ]
        ]);
}
function $9495a8d2b9c5bb89$export$6857d00de00a0931(summary) {
    return summary.XpPerItem * summary.ItemQuantity;
}
class $9495a8d2b9c5bb89$export$435d9ecf99283e52 extends (0, $eATN7.Record) {
    constructor(Fertilizer, CropSummaries, Xp, TimeNormalization){
        super();
        this.Fertilizer = Fertilizer;
        this.CropSummaries = CropSummaries;
        this.Xp = Xp;
        this.TimeNormalization = TimeNormalization;
    }
}
function $9495a8d2b9c5bb89$export$b144e217f5ab25d2() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Query.XpSummary", [], $9495a8d2b9c5bb89$export$435d9ecf99283e52, ()=>[
            [
                "Fertilizer",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "CropSummaries",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)($9495a8d2b9c5bb89$export$bcdc55e99127c507())
            ],
            [
                "Xp",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ],
            [
                "TimeNormalization",
                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
            ]
        ]);
}
function $9495a8d2b9c5bb89$var$cropXpSummary(data, settings, crop, harvests) {
    return new $9495a8d2b9c5bb89$export$a20ae6c78eb68ad2(crop, harvests, (0, $a117bb35793377d5$export$666269e000cfb462)(data, crop), (0, $a117bb35793377d5$export$ac54dd2c8c89eb30)(settings.Game, crop) * harvests);
}
const $9495a8d2b9c5bb89$export$12ee10de7b55efda = (data)=>(settings)=>(timeNormalization)=>(crop)=>$9495a8d2b9c5bb89$var$Profit_mapData((result)=>(0, $d06a0138b761f217$export$7eb72553d53998e3)((tupledArg)=>tupledArg[0] / tupledArg[2], result), data, settings, timeNormalization, crop);
const $9495a8d2b9c5bb89$export$ccd20dc5b668d321 = (data)=>(settings)=>(timeNormalization)=>(crop)=>$9495a8d2b9c5bb89$var$Profit_mapData((result)=>(0, $d06a0138b761f217$export$231ecfcfaf6b3fe)((tupledArg)=>{
                        const investment = tupledArg[1];
                        if (investment === 0) return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(1, [
                            8
                        ]);
                        else return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                            tupledArg[0] / investment / tupledArg[2]
                        ]);
                    }, result), data, settings, timeNormalization, crop);
function $9495a8d2b9c5bb89$export$9fa696f05e0351a7(data, settings, timeNorm, crop) {
    const enoughSeeds = $9495a8d2b9c5bb89$export$1e59367b04e8e57b(data, settings, crop);
    return (fertilizer)=>{
        let span;
        const hasFertPrice = $9495a8d2b9c5bb89$export$cdc2eb88a8e1410b(data, settings)((0, $7bbf2c7402328604$export$70921c9a086f6004)(fertilizer)) != null;
        const matchValue = $9495a8d2b9c5bb89$export$c230577c82088908(settings.Game, fertilizer, crop);
        let matchResult, span_1, span_2;
        if (matchValue != null) {
            if (span = matchValue, hasFertPrice && enoughSeeds) {
                matchResult = 0;
                span_1 = matchValue;
            } else {
                matchResult = 1;
                span_2 = matchValue;
            }
        } else {
            matchResult = 1;
            span_2 = matchValue;
        }
        switch(matchResult){
            case 0:
                return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    (0, $a117bb35793377d5$export$9a7a916d4806bc7f)(data, settings.Game, crop) * span_1.Harvests / $9495a8d2b9c5bb89$export$b47c33e087d871e9(span_1, crop, timeNorm)
                ]);
            default:
                return $9495a8d2b9c5bb89$var$invalidReasons(span_2 != null, hasFertPrice, enoughSeeds);
        }
    };
}
function $9495a8d2b9c5bb89$export$d137f0bc0e5a8b6d(_arg) {
    switch(_arg.tag){
        case 1:
            return $9495a8d2b9c5bb89$export$ccd20dc5b668d321;
        case 2:
            return (data)=>(settings)=>(timeNorm)=>(crop)=>$9495a8d2b9c5bb89$export$9fa696f05e0351a7(data, settings, timeNorm, crop);
        default:
            return $9495a8d2b9c5bb89$export$12ee10de7b55efda;
    }
}
function $9495a8d2b9c5bb89$export$91808cc6b5084119(data, settings, timeNormalization, fertilizer, crop) {
    return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((span)=>{
        const fertilizerVendorAndPrice = $9495a8d2b9c5bb89$var$fertilizerRelevantVendorAndPrice(data, settings, fertilizer);
        const fertCost = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (option)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple)=>tuple[1], option), fertilizerVendorAndPrice);
        let summary;
        const matchValue = settings.Profit.SeedStrategy;
        summary = matchValue.tag === 1 ? $9495a8d2b9c5bb89$var$ProfitSummaryCalc_stockpileSeeds(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests) : matchValue.tag === 0 ? $9495a8d2b9c5bb89$var$ProfitSummaryCalc_buyFirstSeed(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests) : $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer)(true)(crop)(span.Harvests);
        return new $9495a8d2b9c5bb89$export$8c91d97d9cb55f21(fertilizer, fertilizerVendorAndPrice, [
            summary
        ], (0, $22d1a4cfc5fba7ce$export$5be556bf484c4f10)((profit, fertCost_1)=>profit - fertCost_1, summary.NetProfit, fertCost), $9495a8d2b9c5bb89$export$b47c33e087d871e9(span, crop, timeNormalization));
    }, $9495a8d2b9c5bb89$export$c230577c82088908(settings.Game, fertilizer, crop));
}
function $9495a8d2b9c5bb89$export$81451efddcc2e254(data, settings, timeNorm, fertilizer, crop) {
    let span;
    const hasFertPrice = $9495a8d2b9c5bb89$export$cdc2eb88a8e1410b(data, settings)((0, $7bbf2c7402328604$export$70921c9a086f6004)(fertilizer)) != null;
    const enoughSeeds = $9495a8d2b9c5bb89$export$1e59367b04e8e57b(data, settings, crop);
    const matchValue = $9495a8d2b9c5bb89$export$c230577c82088908(settings.Game, fertilizer, crop);
    let matchResult, span_1, span_2;
    if (matchValue != null) {
        if (span = matchValue, hasFertPrice && enoughSeeds) {
            matchResult = 0;
            span_1 = matchValue;
        } else {
            matchResult = 1;
            span_2 = matchValue;
        }
    } else {
        matchResult = 1;
        span_2 = matchValue;
    }
    switch(matchResult){
        case 0:
            {
                const summary = $9495a8d2b9c5bb89$var$cropXpSummary(data, settings, crop, span_1.Harvests);
                return new (0, $d06a0138b761f217$export$450bb352655ebd9b)(0, [
                    new $9495a8d2b9c5bb89$export$435d9ecf99283e52(fertilizer, [
                        summary
                    ], summary.XpPerItem * summary.ItemQuantity, $9495a8d2b9c5bb89$export$b47c33e087d871e9(span_1, crop, timeNorm))
                ]);
            }
        default:
            return $9495a8d2b9c5bb89$var$invalidReasons(span_2 != null, hasFertPrice, enoughSeeds);
    }
}
const $9495a8d2b9c5bb89$export$e6827ecb22c95961 = (data)=>(settings)=>(crop)=>$9495a8d2b9c5bb89$var$Profit_nonRegrowCropProfitPerHarvest(data, settings, crop);
const $9495a8d2b9c5bb89$export$99b27ba3b6bb7c80 = (data)=>(settings)=>(crop)=>$9495a8d2b9c5bb89$var$Profit_regrowCropProfitData(data, settings, crop);
const $9495a8d2b9c5bb89$export$3a84a4b0e1d41b08 = (data)=>(settings)=>(crop)=>$9495a8d2b9c5bb89$var$XP_nonRegrowCropXpPerHarvest(data, settings, crop);
const $9495a8d2b9c5bb89$export$86ebbcbdacc1461f = (data)=>(settings)=>(crop)=>$9495a8d2b9c5bb89$var$XP_regrowCropXpData(data, settings, crop);
function $9495a8d2b9c5bb89$export$845204756513b8b(data, settings, fertilizer, cropHarvests) {
    const fertilizerVendorAndPrice = $9495a8d2b9c5bb89$var$fertilizerRelevantVendorAndPrice(data, settings, fertilizer);
    const fertCost = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (option)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple)=>tuple[1], option), fertilizerVendorAndPrice);
    let harvestSummary;
    const matchValue = settings.Profit.SeedStrategy;
    harvestSummary = matchValue.tag === 1 ? $9495a8d2b9c5bb89$var$ProfitSummaryCalc_stockpileSeeds(data)(settings)(fertCost)(fertilizer) : matchValue.tag === 0 ? (lastCrop)=>(crop)=>(harvests)=>{
                const summary = $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer)(lastCrop)(crop)(harvests);
                const seedsBought = (0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f)(crop) ? 1 : harvests;
                return new $9495a8d2b9c5bb89$export$6dea9c4ecbcc6059(summary.Crop, summary.Harvests, summary.ReplacedFertilizer, summary.SeedPrice, summary.UnsoldItems, summary.SoldItems, summary.SoldProducts, summary.SeedsUsed, seedsBought, summary.ForageSeedsSold, summary.ForageSeedsUsed, (0, $22d1a4cfc5fba7ce$export$5be556bf484c4f10)((profit, tupledArg)=>profit - tupledArg[1] * seedsBought, summary.NetProfit, summary.SeedPrice));
            } : $9495a8d2b9c5bb89$var$ProfitSummaryCalc_ignoreSeeds(data)(settings)(fertCost)(fertilizer);
    const summaries = (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, tupledArg_1)=>harvestSummary(i === cropHarvests.length - 1)(tupledArg_1[0])(tupledArg_1[1]), cropHarvests);
    return new $9495a8d2b9c5bb89$export$8c91d97d9cb55f21(fertilizer, fertilizerVendorAndPrice, summaries, (0, $3699f71d1df66484$export$7b1a35e5f2abf04a)((option_3, option_4)=>(0, $22d1a4cfc5fba7ce$export$5be556bf484c4f10)((x, y)=>x + y, option_3, option_4), (summary_1)=>summary_1.NetProfit, summaries), 1);
}
function $9495a8d2b9c5bb89$export$5fbcfbe62c207568(data, settings, fertilizer, cropHarvests) {
    const summaries = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>$9495a8d2b9c5bb89$var$cropXpSummary(data, settings, tupledArg[0], tupledArg[1]), cropHarvests);
    return new $9495a8d2b9c5bb89$export$435d9ecf99283e52(fertilizer, summaries, (0, $e5d9070e144b905e$export$9e8299ab977385a3)((summary)=>summary.XpPerItem * summary.ItemQuantity, summaries, {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    }), 1);
}





parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $kRS0m = parcelRequire("kRS0m");











function $64dfd908a2c26bb7$export$6ee504a1863bf69(initialState, inputRef, props, state, setState) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "select-control"
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("input", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "ref",
                    inputRef
                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "aria-multiline",
                        false
                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(state.Hover != null ? (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "aria-controls",
                            (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                                "select-list"
                            ])
                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "aria-activedescendant",
                                "selected-option"
                            ]))) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "onBlur",
                                (_arg)=>{
                                    setState(initialState);
                                }
                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                                const matchValue = props.DisplayString;
                                if (matchValue == null) return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                    "type",
                                    "text"
                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "inputMode",
                                        "none"
                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "readOnly",
                                            true
                                        ])))));
                                else {
                                    const toString = matchValue;
                                    return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "type",
                                        "search"
                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "placeholder",
                                            " "
                                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                "aria-autocomplete",
                                                "list"
                                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                    "value",
                                                    state.Search
                                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                        "onChange",
                                                        (ev)=>{
                                                            const str = ev.target.value;
                                                            let options_1;
                                                            let predicate;
                                                            let f2_1;
                                                            const text = str.toLocaleLowerCase();
                                                            f2_1 = (str_4)=>str_4.indexOf(text) >= 0;
                                                            predicate = (arg_1)=>{
                                                                let str_1;
                                                                return f2_1((str_1 = toString(arg_1), str_1.toLocaleLowerCase()));
                                                            };
                                                            options_1 = props.Options.filter(predicate);
                                                            setState({
                                                                Hover: (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (index)=>(0, $d28ec4fb6293f25e$export$cdbb71092bf28e30)(options_1, index), state.Hover),
                                                                Options: options_1,
                                                                Scroll: state.Scroll,
                                                                Search: str
                                                            });
                                                        }
                                                    ])))))))));
                                }
                            })))))))))))),
            /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                style: {
                    width: props.Width
                },
                children: props.Display(props.Selected)
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $64dfd908a2c26bb7$export$77ea3627d4da002a(listRef, clearHover, props, state, setState, hover) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("ul", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "className",
            "select-list"
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "id",
                "select-list"
            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                    "role",
                    (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                        "listbox"
                    ])
                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        "ref",
                        listRef
                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "onMouseDown",
                            (event)=>{
                                (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(event);
                            }
                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            let elems, elems_1;
                            return state.Options.length === 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = [
                                /*#__PURE__*/ (0, $hURbM.createElement)("li", {
                                    className: "empty",
                                    "aria-hidden": true,
                                    children: "No results found..."
                                })
                            ], [
                                "children",
                                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                            ])) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems_1 = (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, opt)=>{
                                const active = hover === i;
                                return /*#__PURE__*/ (0, $hURbM.createElement)("li", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(active ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "id",
                                        "selected-option"
                                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "role",
                                            (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                                                "option"
                                            ])
                                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                "aria-selected",
                                                active
                                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                    "onMouseDown",
                                                    (e)=>{
                                                        if (e.button === 0) {
                                                            props.Dispatch(opt);
                                                            clearHover(e);
                                                        }
                                                    }
                                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                        "onMouseMove",
                                                        (_arg)=>{
                                                            if (!(0, $kRS0m.equals)(state.Hover, i)) setState({
                                                                Hover: i,
                                                                Options: state.Options,
                                                                Scroll: false,
                                                                Search: state.Search
                                                            });
                                                        }
                                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                                            "children",
                                                            props.Display(opt)
                                                        ])))))))))))))));
                            }, state.Options), [
                                "children",
                                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_1))
                            ]));
                        }))))))))))))));
}
function $64dfd908a2c26bb7$var$Select(props) {
    let elems, children;
    const selectedIndex = (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)((0, $e5d9070e144b905e$export$5c13475397a61429)((y)=>(0, $kRS0m.equals)(props.Selected, y), props.Options), 0) | 0;
    const selectOffset = (e, offset)=>{
        (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(e);
        const index_1 = (0, $d28ec4fb6293f25e$export$cdbb71092bf28e30)(props.Options, selectedIndex + offset) | 0;
        if (index_1 !== selectedIndex) props.Dispatch((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(index_1, props.Options));
    };
    const initialState = {
        Options: props.Options,
        Scroll: false,
        Search: ""
    };
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState([
        initialState,
        initialState
    ]);
    const state = patternInput[0][1];
    const prev = patternInput[0][0];
    const setState_1 = (next)=>{
        patternInput[1]([
            state,
            next
        ]);
    };
    const inputRef = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(undefined);
    const listRef = (0, $f559a3d33a977349$export$88214af1db8f02e1).useRef(undefined);
    const dependencies = [
        props.Options
    ];
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        setState_1({
            Hover: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(initialState.Hover),
            Options: props.Options,
            Scroll: initialState.Scroll,
            Search: initialState.Search
        });
    }, dependencies);
    (0, $50fe856f5e8f5256$export$e5c5a5f917a5871c)((_arg)=>{
        let list, i;
        const matchValue_2 = inputRef.current;
        let matchResult, input;
        if (prev.Hover == null) {
            if (state.Hover != null) {
                if (matchValue_2 != null) {
                    matchResult = 0;
                    input = matchValue_2;
                } else matchResult = 1;
            } else matchResult = 1;
        } else matchResult = 1;
        switch(matchResult){
            case 0:
                input.focus();
                break;
        }
        const matchValue_5 = state.Hover;
        const matchValue_6 = listRef.current;
        let matchResult_1, list_1, i_1, list_2;
        if (prev.Hover != null) {
            if (matchValue_5 != null) {
                if (matchValue_6 != null) {
                    if (list = matchValue_6, i = matchValue_5 | 0, state.Scroll) {
                        matchResult_1 = 1;
                        i_1 = matchValue_5;
                        list_2 = matchValue_6;
                    } else matchResult_1 = 2;
                } else matchResult_1 = 2;
            } else matchResult_1 = 2;
        } else if (matchValue_5 != null) {
            if (matchValue_6 != null) {
                matchResult_1 = 0;
                list_1 = matchValue_6;
            } else matchResult_1 = 2;
        } else matchResult_1 = 2;
        switch(matchResult_1){
            case 0:
                (0, $42cbcefff7323768$export$c1a059043cc9c119)((elm)=>{
                    const listBounds = list_1.getBoundingClientRect();
                    const itemBounds = elm.getBoundingClientRect();
                    list_1.scrollTop = itemBounds.top - listBounds.top - (listBounds.height - itemBounds.height) / 2;
                }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(list_1.children.item(selectedIndex)));
                break;
            case 1:
                (0, $42cbcefff7323768$export$c1a059043cc9c119)((elm_1)=>{
                    const listBounds_1 = list_2.getBoundingClientRect();
                    const itemBounds_1 = elm_1.getBoundingClientRect();
                    if (itemBounds_1.top < listBounds_1.top) list_2.scrollBy(0, itemBounds_1.top - listBounds_1.top);
                    else if (itemBounds_1.bottom > listBounds_1.bottom) list_2.scrollBy(0, itemBounds_1.bottom - listBounds_1.bottom);
                }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(list_2.children.item(i_1)));
                break;
        }
        return (0, $75dce49cc9589db1$export$55b4707f0a98ae6e)(()=>{});
    });
    const setHover = (e_1, index_2)=>{
        (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(e_1);
        const index_3 = index_2;
        if (!(0, $kRS0m.equals)(state.Hover, index_3)) setState_1({
            Hover: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(index_3),
            Options: state.Options,
            Scroll: true,
            Search: state.Search
        });
    };
    const setHoverOffset = (e_2, hover, offset_1)=>{
        setHover(e_2, (0, $d28ec4fb6293f25e$export$cdbb71092bf28e30)(state.Options, hover + offset_1));
    };
    const clearHover = (e_3)=>{
        (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(e_3);
        setState_1(initialState);
    };
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "select"
        ],
        [
            "role",
            (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                "combobox"
            ])
        ],
        [
            "aria-expanded",
            state.Hover != null
        ],
        [
            "onMouseDown",
            (e_4)=>{
                if (e_4.button === 0) {
                    if (state.Hover != null) clearHover(e_4);
                    else setHover(e_4, selectedIndex);
                }
            }
        ],
        [
            "onKeyDown",
            (e_5)=>{
                const matchValue_8 = e_5.key;
                const matchValue_9 = state.Hover;
                let matchResult_2, hover_1;
                switch(matchValue_8){
                    case "Escape":
                        if (matchValue_9 != null) matchResult_2 = 0;
                        else matchResult_2 = 16;
                        break;
                    case " ":
                        if (matchValue_9 == null) matchResult_2 = 8;
                        else {
                            matchResult_2 = 1;
                            hover_1 = matchValue_9;
                        }
                        break;
                    case "Enter":
                        if (matchValue_9 == null) matchResult_2 = 8;
                        else {
                            matchResult_2 = 1;
                            hover_1 = matchValue_9;
                        }
                        break;
                    case "Tab":
                        if (matchValue_9 != null) {
                            matchResult_2 = 1;
                            hover_1 = matchValue_9;
                        } else matchResult_2 = 16;
                        break;
                    case "ArrowUp":
                        if (matchValue_9 == null) matchResult_2 = 9;
                        else matchResult_2 = 2;
                        break;
                    case "ArrowDown":
                        if (matchValue_9 == null) matchResult_2 = 8;
                        else matchResult_2 = 3;
                        break;
                    case "PageUp":
                        if (matchValue_9 == null) matchResult_2 = 12;
                        else matchResult_2 = 4;
                        break;
                    case "PageDown":
                        if (matchValue_9 == null) matchResult_2 = 13;
                        else matchResult_2 = 5;
                        break;
                    case "Home":
                        if (matchValue_9 == null) matchResult_2 = 14;
                        else matchResult_2 = 6;
                        break;
                    case "End":
                        if (matchValue_9 == null) matchResult_2 = 15;
                        else matchResult_2 = 7;
                        break;
                    case "ArrowLeft":
                        if (matchValue_9 == null) matchResult_2 = 10;
                        else matchResult_2 = 16;
                        break;
                    case "ArrowRight":
                        if (matchValue_9 == null) matchResult_2 = 11;
                        else matchResult_2 = 16;
                        break;
                    default:
                        matchResult_2 = 16;
                }
                switch(matchResult_2){
                    case 0:
                        clearHover(e_5);
                        break;
                    case 1:
                        if (e_5.key !== " " ? true : props.DisplayString == null) {
                            (0, $42cbcefff7323768$export$c1a059043cc9c119)(props.Dispatch, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $e5d9070e144b905e$export$3fe40c3a4d8cb094)(hover_1, state.Options)));
                            clearHover(e_5);
                        }
                        break;
                    case 2:
                        {
                            const arg_6 = matchValue_9 | 0;
                            setHoverOffset(e_5, arg_6, -1);
                            break;
                        }
                    case 3:
                        {
                            const arg_9 = matchValue_9 | 0;
                            setHoverOffset(e_5, arg_9, 1);
                            break;
                        }
                    case 4:
                        {
                            const arg_12 = matchValue_9 | 0;
                            const arg_13 = (0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(10) | 0;
                            setHoverOffset(e_5, arg_12, arg_13);
                            break;
                        }
                    case 5:
                        {
                            const arg_15 = matchValue_9 | 0;
                            setHoverOffset(e_5, arg_15, 10);
                            break;
                        }
                    case 6:
                        {
                            const arg_18 = matchValue_9 | 0;
                            const arg_19 = (0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(state.Options.length) | 0;
                            setHoverOffset(e_5, arg_18, arg_19);
                            break;
                        }
                    case 7:
                        {
                            const arg_21 = matchValue_9 | 0;
                            const arg_22 = state.Options.length | 0;
                            setHoverOffset(e_5, arg_21, arg_22);
                            break;
                        }
                    case 8:
                        if (e_5.key !== " " ? true : props.DisplayString == null) setHover(e_5, selectedIndex);
                        break;
                    case 9:
                        setHover(e_5, 0);
                        break;
                    case 10:
                        selectOffset(e_5, -1);
                        break;
                    case 11:
                        selectOffset(e_5, 1);
                        break;
                    case 12:
                        {
                            const arg_32 = (0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(10) | 0;
                            selectOffset(e_5, arg_32);
                            break;
                        }
                    case 13:
                        selectOffset(e_5, 10);
                        break;
                    case 14:
                        {
                            const arg_36 = (0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(props.Options.length) | 0;
                            selectOffset(e_5, arg_36);
                            break;
                        }
                    case 15:
                        {
                            const arg_38 = props.Options.length | 0;
                            selectOffset(e_5, arg_38);
                            break;
                        }
                    case 16:
                        break;
                }
            }
        ],
        (elems = [
            (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                $64dfd908a2c26bb7$export$6ee504a1863bf69(initialState, inputRef, props, state, setState_1),
                (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((hover_8)=>$64dfd908a2c26bb7$export$77ea3627d4da002a(listRef, (arg_39)=>{
                        clearHover(arg_39);
                    }, props, state, setState_1, hover_8), state.Hover)
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            })),
            /*#__PURE__*/ (0, $hURbM.createElement)("img", {
                alt: ""
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $64dfd908a2c26bb7$var$ignoreSame(selected, dispatch, value) {
    if (!(0, $kRS0m.equals)(selected, value)) dispatch(value);
}
function $64dfd908a2c26bb7$export$d76128d007d19019(width, toString, display, options_1, selected, dispatch) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($64dfd908a2c26bb7$var$Select, {
        Dispatch: (value)=>{
            $64dfd908a2c26bb7$var$ignoreSame(selected, dispatch, value);
        },
        Display: display,
        DisplayString: toString,
        Options: options_1,
        Selected: selected,
        Width: width
    });
}
function $64dfd908a2c26bb7$export$41c562ebe57d11e2(width, display, options_1, selected, dispatch) {
    return /*#__PURE__*/ (0, $hURbM.createElement)($64dfd908a2c26bb7$var$Select, {
        Dispatch: (value)=>{
            $64dfd908a2c26bb7$var$ignoreSame(selected, dispatch, value);
        },
        Display: display,
        Options: options_1,
        Selected: selected,
        Width: width
    });
}




var $kRS0m = parcelRequire("kRS0m");


var $c7lrN = parcelRequire("c7lrN");

var $fzAFM = parcelRequire("fzAFM");
function $c7733b1bbdc2597b$export$574b10e6b1a419(step, stop, zero, add) {
    const stepComparedWithZero = (0, $kRS0m.compare)(step, zero) | 0;
    if (stepComparedWithZero === 0) throw new Error("The step of a range cannot be zero");
    const stepGreaterThanZero = stepComparedWithZero > 0;
    return (x)=>{
        const comparedWithLast = (0, $kRS0m.compare)(x, stop) | 0;
        return (stepGreaterThanZero && comparedWithLast <= 0 ? true : !stepGreaterThanZero && comparedWithLast >= 0) ? [
            x,
            add(x, step)
        ] : undefined;
    };
}
function $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, zero, add) {
    const stepFn = $c7733b1bbdc2597b$export$574b10e6b1a419(step, stop, zero, add);
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$c48e357c1a89b78d)(stepFn, start));
}
function $c7733b1bbdc2597b$export$cae5558698c2b5f1(start, step, stop) {
    return $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, (0, $c7lrN.fromZero)(), (0, $c7lrN.op_Addition));
}
function $c7733b1bbdc2597b$export$97b885d43f12828f(start, step, stop) {
    return $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, (0, $fzAFM.fromParts)(0, 0, 0, false, 0), (0, $fzAFM.op_Addition));
}
function $c7733b1bbdc2597b$export$b4822f0c51847685(start, step, stop) {
    return $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, 0, (x, y)=>x + y);
}
function $c7733b1bbdc2597b$export$870714c90c7cf225(start, step, stop) {
    return $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, 0n, (x, y)=>(0, $c7lrN.toInt64)((0, $c7lrN.op_Addition)(x, y)));
}
function $c7733b1bbdc2597b$export$feffc2a4234a827c(start, step, stop) {
    return $c7733b1bbdc2597b$export$5ed6871edc0c752e(start, step, stop, 0n, (x, y)=>(0, $c7lrN.toUInt64)((0, $c7lrN.op_Addition)(x, y)));
}
function $c7733b1bbdc2597b$export$da3127bd831ad6a0(start, stop) {
    const intStop = ~~stop.charCodeAt(0) | 0;
    return (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$c48e357c1a89b78d)((c)=>{
            if (c <= intStop) return [
                String.fromCharCode(c),
                c + 1
            ];
            else return undefined;
        }, ~~start.charCodeAt(0)));
}



function $a56e1de91baad685$export$2567eacf9de48882(qualities) {
    let elems;
    const mapQualities = (content)=>{
        const children = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
            let str;
            const quality = tupledArg[0] | 0;
            const prob = tupledArg[1];
            return /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                className: (str = (0, $7bbf2c7402328604$export$125e96caa9d3db22)(quality), str.toLocaleLowerCase()),
                style: {
                    flexGrow: prob
                },
                children: content(quality)(prob)
            });
        }, (0, $7bbf2c7402328604$export$a0d475150deff27c)(qualities));
        return /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        });
    };
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "crop-qualities"
        ],
        (elems = [
            mapQualities((_arg)=>(_arg_1)=>(0, $kRS0m.defaultOf)()),
            mapQualities((quality_2)=>(prob_1)=>{
                    const xs_2 = [
                        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                            className: "label-hidden",
                            children: (0, $7bbf2c7402328604$export$125e96caa9d3db22)(quality_2)
                        }),
                        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                            children: [
                                prob_1 === 0 ? "" : (0, $d28ec4fb6293f25e$export$2ae0f0836c569eb0)(prob_1)
                            ]
                        })
                    ];
                    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
                })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$var$payForFertilizerSettings(profit, dispatch) {
    const xs_1 = [
        (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Pay for Fertilizer", profit.PayForFertilizer, (arg)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2)(1, [
                arg
            ]));
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("span", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(!profit.PayForFertilizer ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "className",
                "disabled"
            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                let elems;
                return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = [
                    (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Pay for Destroyed Fertilizer", profit.PayForDestroyedFertilizer, (arg_1)=>{
                        dispatch(new (0, $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2)(2, [
                            arg_1
                        ]));
                    })
                ], [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ]));
            }))))))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$c8bd1f4166729020(price) {
    const xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        if (price == null) return (0, $42cbcefff7323768$export$439306a4dcaafbb9)("???");
        else {
            const source = price[0];
            const price_1 = price[1];
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(price_1.toString()), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                const matchValue = source;
                return matchValue.tag === 1 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $kRS0m.defaultOf)()) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$e9e0c573c240ebb3)(matchValue.fields[0]));
            }));
        }
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $a56e1de91baad685$var$sortKeysByHighestCount(table) {
    return Array.from((0, $42cbcefff7323768$export$871de8747c9eaa88)((tuple_1)=>tuple_1[0], (0, $42cbcefff7323768$export$ca6dab212df382f6)((tuple)=>tuple[1], (0, $2f87a1ba4ae7cb49$export$1d012a0dff3dab06)((x)=>x, (0, $42cbcefff7323768$export$bb44f104e3c54dae)((arg00$0040_1)=>arg00$0040_1.fields[0].keys(), table.fields[0].values()), {
        Equals: (0, $kRS0m.equals),
        GetHashCode: (0, $kRS0m.structuralHash)
    }), {
        Compare: (0, $kRS0m.comparePrimitives)
    })));
}
function $a56e1de91baad685$var$customColumn(viewValue, editValue, defaultValue, viewKey, key, selection, dispatch) {
    return (0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((key_6)=>{
        if ((0, $cee18de5b874f6d4$export$dbac7bf9c27882b)(selection.Values, key_6)) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(selection.Selected, key_6);
        else return undefined;
    }, (arg_2)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$dd429cf9e5006db2)(3, [
            arg_2
        ]));
    }, (0, $120450cd5ed2b836$export$bdeb69d37932a902)("Custom", (item)=>{
        let xs, f1, f;
        const key_1 = key(item);
        const value_1 = (0, $cee18de5b874f6d4$export$dabe6a04d430958f)(selection.Values, key_1);
        const xs_2 = [
            (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)(viewValue, value_1),
            (0, $f2f828056f038bf6$export$6abb1e551b9b2a9f)((xs = [
                "Custom Price For ",
                viewKey(key_1)
            ], /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs)), (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(value_1, defaultValue), (f1 = (f = value_1 != null ? (tupledArg)=>new (0, $7c6f80c5743180ba$export$dd429cf9e5006db2)(1, [
                    tupledArg[0],
                    tupledArg[1]
                ]) : (tupledArg_1)=>new (0, $7c6f80c5743180ba$export$dd429cf9e5006db2)(0, [
                    tupledArg_1[0],
                    tupledArg_1[1]
                ]), (b)=>f([
                    key_1,
                    b
                ])), (arg)=>{
                dispatch(f1(arg));
            }), (close, v, setValue)=>{
                const children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(editValue(v, setValue)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>value_1 != null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("button", {
                            className: "button",
                            onClick: (_arg)=>{
                                dispatch(new (0, $7c6f80c5743180ba$export$dd429cf9e5006db2)(2, [
                                    key_1
                                ]));
                                close();
                            },
                            children: "Delete"
                        })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)()))));
                return /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
                });
            })
        ];
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
    }, (arg_1)=>(0, $cee18de5b874f6d4$export$dabe6a04d430958f)(selection.Values, key(arg_1))));
}
function $a56e1de91baad685$var$customPriceColumn(viewKey, key, selection, dispatch) {
    return $a56e1de91baad685$var$customColumn((n)=>n.toString(), (value_2, setValue)=>(0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Price", (0, $2bc91fecd0c77f83$export$91c39a88397ac04b)("3em", undefined, undefined, value_2, setValue)), 0, viewKey, key, selection, dispatch);
}
function $a56e1de91baad685$var$priceColumns(prices, selected, custom, priceValue, icon, vendors, selectMsg, customMsg, dispatch) {
    const array_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((vendor)=>(0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((key)=>{
            let arg10$0040_1;
            if (arg10$0040_1 = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(prices.fields[0], key), arg10$0040_1.fields[0].has(vendor)) return (0, $70b963136d0d9ffe$export$2344b14b097df817)(vendor, (0, $cee18de5b874f6d4$export$71aa6c912b956294)(key, selected));
            else return undefined;
        }, (arg)=>{
            dispatch(selectMsg([
                vendor,
                arg
            ]));
        }, (0, $120450cd5ed2b836$export$fdefd48fe55b79a7)((0, $d28ec4fb6293f25e$export$e9e0c573c240ebb3)(vendor), (0, $kRS0m.curry2)(priceValue)(vendor), (option)=>(0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((n)=>n.toString(), option))), vendors);
    const value_2 = $a56e1de91baad685$var$customPriceColumn(icon, (x)=>x, custom, (arg_1)=>{
        dispatch(customMsg(arg_1));
    });
    const array_2 = array_1;
    return (0, $e5d9070e144b905e$export$9f200c4466975173)(array_2.length, value_2, array_2);
}
function $a56e1de91baad685$var$lazyTable(table, data, settings, sort, items, dispatch) {
    return (0, $d4ba2fe09a393e3c$export$7335aaba4c95dfb)((tupledArg, dispatch_1)=>table(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3], dispatch_1))([
        data,
        settings,
        sort,
        items
    ])(dispatch);
}
const $a56e1de91baad685$export$dac38bd9b4e156b4 = (0, $3699f71d1df66484$export$9749d42f85d96507)((data)=>$a56e1de91baad685$var$sortKeysByHighestCount(data.SeedPrices));
const $a56e1de91baad685$export$4d9d4194fe0158b3 = (0, $3699f71d1df66484$export$9749d42f85d96507)((data)=>Array.from((0, $42cbcefff7323768$export$a9e7d1a6fdcfefde)((a, b)=>(0, $3699f71d1df66484$export$b6076d49e7646d88)((key)=>(0, $0ef027050085b17b$export$cc62f3272162c107)(key, data.ProcessorUnlockLevel), a, b), (0, $2f87a1ba4ae7cb49$export$983a3b5fb2f7202e)((0, $42cbcefff7323768$export$10d8903dec122b9d)([
        "Preserves Jar",
        "Keg",
        "Seed Maker"
    ], (0, $42cbcefff7323768$export$bb44f104e3c54dae)((arg00$0040)=>arg00$0040.fields[0].keys(), data.Products.fields[0].values())), {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.stringHash)
    }))));
function $a56e1de91baad685$export$ee26815e7915f3a4(data, settings, cropSort_, cropSort__1, crops, dispatch) {
    const cropSort = [
        cropSort_,
        cropSort__1
    ];
    return (0, $120450cd5ed2b836$export$a6935ca84fb38638)((crop)=>!((0, $9495a8d2b9c5bb89$export$1e59367b04e8e57b)(data, settings, crop) && (0, $a117bb35793377d5$export$a3141f96ca725916)(settings.Game, crop)), (0, $e189d4fb2d038fab$export$f448f4dc09946ac4), cropSort[0], cropSort[1], (arg_5)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            new (0, $7c6f80c5743180ba$export$78428c3f899407d)(5, [
                new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(1, [
                    arg_5
                ])
            ])
        ]));
    }, [
        (0, $120450cd5ed2b836$export$ec7cb4baac01f1f5)((0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((arg_6)=>(0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.Crops, arg_6), (arg_2)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
                new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(2, [
                    new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(0, [
                        arg_2
                    ])
                ])
            ]));
        }, (0, $120450cd5ed2b836$export$69165d2e6bdf8dca)("Crop", (_arg)=>(0, $d28ec4fb6293f25e$export$b425e1f3273281be)(data, _arg), (_arg_2)=>(0, $e189d4fb2d038fab$export$f1b4c0d5ff03a35f)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), _arg_2)))),
        (0, $120450cd5ed2b836$export$bdeb69d37932a902)("Seed Price", (arg_8)=>$a56e1de91baad685$export$c8bd1f4166729020((0, $9495a8d2b9c5bb89$export$15514148d320a778)(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(arg_8))), (arg_9)=>(0, $9495a8d2b9c5bb89$export$d9528ce49add42)(data, settings, (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(arg_9))),
        (0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Days", (crop_1)=>(0, $a117bb35793377d5$export$3302572d20aa94ca)(settings.Game, undefined, crop_1), (n)=>n.toString()),
        (0, $120450cd5ed2b836$export$fdefd48fe55b79a7)("Regrow", (0, $e189d4fb2d038fab$export$93f201b907e0b82c), (option)=>(0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((n_3)=>n_3.toString(), option)),
        (0, $120450cd5ed2b836$export$387f94866b17856)("Seasons", (crop_2)=>{
            let elems;
            return /*#__PURE__*/ (0, $hURbM.createElement)("span", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "className",
                    "seasons"
                ],
                (elems = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((season)=>{
                    if ((0, $e189d4fb2d038fab$export$9cc23dda456089a)(season, crop_2)) return (0, $d28ec4fb6293f25e$export$53a8d1230ff4fe8f)(season);
                    else return /*#__PURE__*/ (0, $hURbM.createElement)("div", {});
                }, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ]))), [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ])
            ])));
        }, (0, $kRS0m.uncurry3)((ascending)=>{
            const compare = (c1, c2)=>{
                const matchValue = (0, $e189d4fb2d038fab$export$b5a6878176d48f7f)(c1) | 0;
                const matchValue_1 = (0, $e189d4fb2d038fab$export$b5a6878176d48f7f)(c2) | 0;
                if (matchValue === 0) {
                    if (matchValue_1 === 0) return 0;
                    else return 1;
                } else if (matchValue_1 === 0) return -1;
                else return (0, $e189d4fb2d038fab$export$2b0a192178337539)(matchValue, matchValue_1) | 0;
            };
            return ascending ? (a)=>(b)=>compare(a, b) : (a_1)=>(b_1)=>compare(b_1, a_1);
        }))
    ], crops);
}
function $a56e1de91baad685$export$e61f0c60e0539a52(data, settings, cropTab, crops, dispatch) {
    const cropTabDispatch = (arg_1)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            new (0, $7c6f80c5743180ba$export$78428c3f899407d)(5, [
                arg_1
            ])
        ]));
    };
    const selectDispatch = (arg_3)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
            new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(2, [
                arg_3
            ])
        ]));
    };
    const nonForageItems = (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((_arg)=>{
        if (_arg.tag === 1) return new Uint32Array([]);
        else return (0, $e189d4fb2d038fab$export$c18dcc1cdb869855)(_arg.fields[0]);
    }, crops, Uint32Array);
    const items = (0, $e5d9070e144b905e$export$b035e44d7bb4278f)((arg_4)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], arg_4).Name, (0, $2f87a1ba4ae7cb49$export$2fb09f0d977e5bc3)((0, $e5d9070e144b905e$export$10d8903dec122b9d)(nonForageItems, (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((_arg_1)=>{
        if (_arg_1.tag === 1) {
            const crop_1 = _arg_1.fields[0];
            return (0, $e5d9070e144b905e$export$9f200c4466975173)(0, (0, $e189d4fb2d038fab$export$62ea73f630367ff4)(crop_1), crop_1.Foragables, Uint32Array);
        } else return new Uint32Array([]);
    }, crops, Uint32Array), Uint32Array), {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    }), {
        Compare: (0, $kRS0m.comparePrimitives)
    });
    const nonForageItems_1 = (0, $70b963136d0d9ffe$export$cb197a913f6bb809)(nonForageItems, {
        Compare: (0, $kRS0m.comparePrimitives)
    });
    const productQuality = cropTab.ProductQuality | 0;
    const normalizedPrices = cropTab.NormalizeProductPrices;
    const xs_2 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        let elems;
        return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "settings-group"
            ],
            (elems = [
                (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Show Prices for Quality", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("4em", (arg_6)=>(0, $3921efb06a31e9cc$export$e1d90e20ad64402a)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "Normal",
                            0
                        ],
                        [
                            "Silver",
                            1
                        ],
                        [
                            "Gold",
                            2
                        ],
                        [
                            "Iridium",
                            3
                        ]
                    ]), arg_6), (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Quality", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Normal",
                        0
                    ],
                    [
                        "Silver",
                        1
                    ],
                    [
                        "Gold",
                        2
                    ],
                    [
                        "Iridium",
                        3
                    ]
                ])), productQuality, (arg_5)=>{
                    cropTabDispatch(new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(4, [
                        arg_5
                    ]));
                })),
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Show Normalized Prices", normalizedPrices, (arg_7)=>{
                    cropTabDispatch(new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(5, [
                        arg_7
                    ]));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ])))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let items_1, tupledArg;
            const price = normalizedPrices ? (product)=>(0, $a117bb35793377d5$export$d2085a6d61ca5031)(data, settings.Game, productQuality, product) : (arg_8)=>(0, $a117bb35793377d5$export$b2525098505c1744)(data, settings.Game, productQuality, arg_8);
            return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((items_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((key_5)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key_5), items), tupledArg = cropTab.ProductSort, (0, $120450cd5ed2b836$export$dbe75ea921406f50)((_arg_5)=>_arg_5.Id, tupledArg[0], tupledArg[1], (arg_9)=>{
                cropTabDispatch(new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(2, [
                    arg_9
                ]));
            }, (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $120450cd5ed2b836$export$ec7cb4baac01f1f5)((0, $120450cd5ed2b836$export$69165d2e6bdf8dca)("Item", (0, $d28ec4fb6293f25e$export$cf2a4a102a3813db), (_arg_6)=>_arg_6.Name))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((arg_10)=>(0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.SellRaw, arg_10), (arg_11)=>{
                        selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(5, [
                            arg_11
                        ]));
                    }, (0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Raw", (item_1)=>(0, $a117bb35793377d5$export$9f54cc0163ec0391)(settings.Game, !(0, $70b963136d0d9ffe$export$2344b14b097df817)(item_1.Id, nonForageItems_1), item_1, productQuality), (n)=>n.toString()))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((processor)=>{
                            const column_3 = (0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((item_3)=>{
                                if ((0, $a117bb35793377d5$export$323f73e82c9af216)(data, processor, item_3) != null) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)((0, $cee18de5b874f6d4$export$96f485bc49c6f699)(settings.Selected.Products, item_3), processor);
                                else return undefined;
                            }, (arg_14)=>{
                                let tupledArg_1;
                                selectDispatch((tupledArg_1 = [
                                    processor,
                                    arg_14
                                ], new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(6, [
                                    tupledArg_1[0],
                                    tupledArg_1[1]
                                ])));
                            }, (0, $120450cd5ed2b836$export$fdefd48fe55b79a7)((0, $d28ec4fb6293f25e$export$4e8c53e206dfbfdb)(processor), (arg_13)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)(price, (0, $a117bb35793377d5$export$323f73e82c9af216)(data, processor, arg_13.Id)), (option_1)=>(0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((x_3)=>x_3, option_1)));
                            return (0, $120450cd5ed2b836$export$3dae70f9e1e31be6)(!(0, $a117bb35793377d5$export$8b1f176e807e6ab4)(data, settings.Game, processor), column_3);
                        }, $a56e1de91baad685$export$4d9d4194fe0158b3(data)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)($a56e1de91baad685$var$customColumn((arg_15)=>{
                                let n_3;
                                const tupledArg_2 = arg_15;
                                n_3 = (0, $9495a8d2b9c5bb89$export$4f606b351a0e05bd)(productQuality, tupledArg_2[0], tupledArg_2[1]);
                                return n_3.toString();
                            }, (tupledArg_3, setState)=>{
                                const price_2 = tupledArg_3[0];
                                const preserveQuality_1 = tupledArg_3[1];
                                const xs_1 = [
                                    (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Price", (0, $2bc91fecd0c77f83$export$91c39a88397ac04b)("3em", undefined, undefined, price_2, (price_3)=>{
                                        setState([
                                            price_3,
                                            preserveQuality_1
                                        ]);
                                    })),
                                    (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Scale with quality", preserveQuality_1, (preserveQuality_2)=>{
                                        setState([
                                            price_2,
                                            preserveQuality_2
                                        ]);
                                    })
                                ];
                                return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
                            }, [
                                0,
                                false
                            ], (itemId)=>(0, $d28ec4fb6293f25e$export$be70ef43515665ec)(data, itemId), (_arg_8)=>_arg_8.Id, settings.Selected.CustomSellPrices, (arg_16)=>{
                                selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(12, [
                                    arg_16
                                ]));
                            })))))))))), items_1)));
        }));
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
}
function $a56e1de91baad685$export$64cd160ae3a30135(data, settings, seedSort_, seedSort__1, crops, dispatch) {
    let elems, items;
    const seedSort = [
        seedSort_,
        seedSort__1
    ];
    const settingsDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
            arg
        ]));
    };
    const selectDispatch = (arg_1)=>{
        settingsDispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(2, [
            arg_1
        ]));
    };
    const xs_1 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "settings-group"
            ],
            (elems = [
                (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Seed Strategy", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("5em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_1)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_1, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$43804ad8ff7cbd7)())), settings.Profit.SeedStrategy, (arg_3)=>{
                    settingsDispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(1, [
                        new (0, $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2)(0, [
                            arg_3
                        ])
                    ]));
                })),
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Joja Membership", settings.Game.JojaMembership, (arg_6)=>{
                    settingsDispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(0, [
                        new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(6, [
                            arg_6
                        ])
                    ]));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ]))),
        (items = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((0, $e189d4fb2d038fab$export$f448f4dc09946ac4), crops, Uint32Array), (0, $120450cd5ed2b836$export$dbe75ea921406f50)((x_2)=>x_2, seedSort[0], seedSort[1], (arg_9)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
                new (0, $7c6f80c5743180ba$export$78428c3f899407d)(5, [
                    new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(3, [
                        arg_9
                    ])
                ])
            ]));
        }, (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $120450cd5ed2b836$export$ec7cb4baac01f1f5)((0, $120450cd5ed2b836$export$69165d2e6bdf8dca)("Seed", (seed)=>(0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed), (arg_11)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], arg_11 * 1).Name))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)($a56e1de91baad685$var$priceColumns(data.SeedPrices, settings.Selected.SeedPrices, settings.Selected.CustomSeedPrices, (vendor, seed_3)=>(0, $9495a8d2b9c5bb89$export$3ef76ca07b2cf109)(data, settings, vendor, seed_3), (seed_4)=>(0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed_4), $a56e1de91baad685$export$dac38bd9b4e156b4(data), (tupledArg)=>new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(1, [
                        tupledArg[0],
                        tupledArg[1]
                    ]), (Item_11)=>new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(11, [
                        Item_11
                    ]), selectDispatch), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                    let column_2, x_3;
                    return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((column_2 = (0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((seed_5)=>{
                        if ((0, $e189d4fb2d038fab$export$9a6d33d4fe8fe14)((key_6)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key_6), (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed_5))) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseSeedMaker, seed_5);
                        else return undefined;
                    }, (arg_12)=>{
                        selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(8, [
                            arg_12
                        ]));
                    }, (0, $120450cd5ed2b836$export$1fdf2c887552264f)((0, $d28ec4fb6293f25e$export$4e8c53e206dfbfdb)("Seed Maker"), (x_3 = (0, $kRS0m.defaultOf)(), (arg10$0040_1)=>x_3))), (0, $120450cd5ed2b836$export$3dae70f9e1e31be6)(!(0, $a117bb35793377d5$export$8b1f176e807e6ab4)(data, settings.Game, "Seed Maker"), column_2))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                        let x_5;
                        return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((seed_6)=>{
                            if ((0, $e189d4fb2d038fab$export$518a79ca6e7bc25b)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed_6))) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseHarvestedSeeds, seed_6);
                            else return undefined;
                        }, (arg_13)=>{
                            selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(7, [
                                arg_13
                            ]));
                        }, (0, $120450cd5ed2b836$export$1fdf2c887552264f)("Raw", (x_5 = (0, $kRS0m.defaultOf)(), (arg10$0040_4)=>x_5)))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            let column_5, x_7;
                            return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((column_5 = (0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((seed_7)=>{
                                if ((0, $e189d4fb2d038fab$export$a6e0eedf3a1bd082)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed_7))) return (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.UseForageSeeds, seed_7);
                                else return undefined;
                            }, (arg_14)=>{
                                selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(9, [
                                    arg_14
                                ]));
                            }, (0, $120450cd5ed2b836$export$1fdf2c887552264f)("Forage", (x_7 = (0, $kRS0m.defaultOf)(), (arg10$0040_6)=>x_7))), (0, $120450cd5ed2b836$export$3dae70f9e1e31be6)(!(0, $42cbcefff7323768$export$f7e9f41ea797a17)((_arg_10)=>{
                                if (_arg_10.tag === 0) return false;
                                else return (0, $e189d4fb2d038fab$export$d8c874891ace1c01)(settings.Game.Skills, _arg_10.fields[0]);
                            }, crops), column_5)));
                        }));
                    }));
                })))))), items))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$var$Crops_filteredCrops(app) {
    let itemNameMatchesSearch;
    const data = app.Data;
    const patternInput = app.State;
    const filters = patternInput[1].CropTab.Filters;
    const optionFilter = (projection, filterValue)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((value)=>(arg)=>(0, $kRS0m.equals)(value, projection(arg)), filterValue);
    const filters_1 = (0, $e08834e1786645d9$export$7877a478dd30fd3d)((x)=>x, (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        filters.ItemNameSearch === "" ? undefined : (itemNameMatchesSearch = (name)=>{
            let str_3;
            const str = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], name).Name;
            str_3 = str.toLocaleLowerCase();
            const text = filters.ItemNameSearch.toLocaleLowerCase();
            return str_3.indexOf(text) >= 0;
        }, (crop)=>itemNameMatchesSearch((0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop) * 1) ? true : (0, $42cbcefff7323768$export$f7e9f41ea797a17)(itemNameMatchesSearch, (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop))),
        filters.InSeason ? (crop_1)=>(0, $a117bb35793377d5$export$a3141f96ca725916)(patternInput[0].Game, crop_1) : (_arg_3)=>(0, $e189d4fb2d038fab$export$4c2775d8781aa270)(filters.Seasons, _arg_3),
        optionFilter((0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f), filters.Regrows),
        optionFilter((0, $e189d4fb2d038fab$export$6d4b23de33bebe68), filters.Giant),
        optionFilter((0, $e189d4fb2d038fab$export$a6e0eedf3a1bd082), filters.Forage)
    ]));
    return Array.from((0, $42cbcefff7323768$export$3dea766d36a8935f)((crop_2)=>(0, $42cbcefff7323768$export$e5bd981f5eeebe3b)((predicate)=>predicate(crop_2), filters_1), data.Crops.fields[0].values()));
}
function $a56e1de91baad685$export$36d9d422425f26fb(data) {
    return (_arg_1)=>(0, $e189d4fb2d038fab$export$f1b4c0d5ff03a35f)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), _arg_1);
}
function $a56e1de91baad685$var$Crops_selectFilter(name, value, dispatch) {
    return (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)(name, (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("2em", (_arg)=>_arg == null ? "Any" : _arg ? "Yes" : "No", [
        true,
        false,
        undefined
    ], value, dispatch));
}
function $a56e1de91baad685$export$e5b9383c99f3eadc(filters, dispatch) {
    let children, children_2;
    const xs_3 = [
        (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Search", /*#__PURE__*/ (0, $hURbM.createElement)("input", {
            className: "input-box",
            placeholder: "Search...",
            type: "search",
            value: filters.ItemNameSearch,
            onChange: (ev)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(0, [
                    ev.target.value
                ]));
            }
        })),
        (children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("In Season", filters.InSeason, (arg_1)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(1, [
                    arg_1
                ]));
            })), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $e5d9070e144b905e$export$871de8747c9eaa88)((season_5)=>/*#__PURE__*/ (0, $hURbM.createElement)("span", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(filters.InSeason ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "className",
                            "disabled"
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            let elems, f1_3, f1_2, season;
                            return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = [
                                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)((0, $e189d4fb2d038fab$export$17d0dbcd198f4e3f)(season_5), (0, $e189d4fb2d038fab$export$17231478d9f68f3b)(season_5, filters.Seasons), (f1_3 = (f1_2 = (season = season_5 | 0, (selected)=>selected ? filters.Seasons | 1 << season : filters.Seasons & ~(1 << season)), (arg_2)=>new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(2, [
                                        f1_2(arg_2)
                                    ])), (arg_3)=>{
                                    dispatch(f1_3(arg_3));
                                }))
                            ], [
                                "children",
                                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                            ]));
                        })))))), (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ]))))))), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        })),
        (children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            $a56e1de91baad685$var$Crops_selectFilter("Regrows", filters.Regrows, (arg_4)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(3, [
                    arg_4
                ]));
            }),
            $a56e1de91baad685$var$Crops_selectFilter("Giant", filters.Giant, (arg_5)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(4, [
                    arg_5
                ]));
            }),
            $a56e1de91baad685$var$Crops_selectFilter("Forage", filters.Forage, (arg_6)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(5, [
                    arg_6
                ]));
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("button", {
                className: "button",
                onClick: (_arg)=>{
                    dispatch(new (0, $7c6f80c5743180ba$export$4e595afe15e5e4d6)(6, []));
                },
                children: "Clear"
            })
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        }))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_3);
}
function $a56e1de91baad685$export$8e7bd90b2ed3163a(app, dispatch) {
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const cropTab = ui.CropTab;
    const uiDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            arg
        ]));
    };
    let crops;
    const array = $a56e1de91baad685$var$Crops_filteredCrops(app);
    crops = (0, $e5d9070e144b905e$export$b035e44d7bb4278f)($a56e1de91baad685$export$36d9d422425f26fb(data), array, {
        Compare: (0, $kRS0m.comparePrimitives)
    });
    const xs = [
        (0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(0, []), "Filters", $a56e1de91baad685$export$e5b9383c99f3eadc(cropTab.Filters, (arg_2)=>{
            uiDispatch(new (0, $7c6f80c5743180ba$export$78428c3f899407d)(5, [
                new (0, $7c6f80c5743180ba$export$edd3bdc535d06a1)(0, [
                    arg_2
                ])
            ]));
        }), uiDispatch),
        (0, $d28ec4fb6293f25e$export$58335bbff18cfa1d)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(1, []), "Crops", ()=>$a56e1de91baad685$var$lazyTable((data_1, settings_1, tupledArg, crops_1, dispatch_1)=>$a56e1de91baad685$export$ee26815e7915f3a4(data_1, settings_1, tupledArg[0], tupledArg[1], crops_1, dispatch_1), data, settings, cropTab.CropSort, crops, dispatch), uiDispatch),
        (0, $d28ec4fb6293f25e$export$58335bbff18cfa1d)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(2, []), "Products", ()=>$a56e1de91baad685$var$lazyTable($a56e1de91baad685$export$e61f0c60e0539a52, data, settings, cropTab, crops, dispatch), uiDispatch),
        (0, $d28ec4fb6293f25e$export$58335bbff18cfa1d)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(3, []), "Seeds", ()=>$a56e1de91baad685$var$lazyTable((data_3, settings_3, tupledArg_1, crops_3, dispatch_3)=>$a56e1de91baad685$export$64cd160ae3a30135(data_3, settings_3, tupledArg_1[0], tupledArg_1[1], crops_3, dispatch_3), data, settings, cropTab.SeedSort, crops, dispatch), uiDispatch)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
const $a56e1de91baad685$export$5386d5c64efb31a5 = (0, $3699f71d1df66484$export$9749d42f85d96507)((data)=>$a56e1de91baad685$var$sortKeysByHighestCount(data.FertilizerPrices));
function $a56e1de91baad685$export$865f8837e10e7269(data, settings, fertSort_, fertSort__1, fertilizers, dispatch) {
    let elems;
    const fertSort = [
        fertSort_,
        fertSort__1
    ];
    const selectDispatch = (arg_2)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
            new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(2, [
                arg_2
            ])
        ]));
    };
    const xs_1 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "settings-group"
            ],
            (elems = [
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Allow No Fertilizer", settings.Selected.NoFertilizer, (arg_3)=>{
                    selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(2, [
                        arg_3
                    ]));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ]))),
        (0, $120450cd5ed2b836$export$a6935ca84fb38638)((arg_5)=>(0, $9495a8d2b9c5bb89$export$fcd25d15dcb4980c)(data, settings, arg_5.Name) == null, (_arg_1)=>_arg_1.Name, fertSort[0], fertSort[1], (arg_6)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
                new (0, $7c6f80c5743180ba$export$78428c3f899407d)(6, [
                    arg_6
                ])
            ]));
        }, [
            (0, $120450cd5ed2b836$export$ec7cb4baac01f1f5)((0, $120450cd5ed2b836$export$5c7b7ab3ca28c5c8)((arg_7)=>(0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(settings.Selected.Fertilizers, arg_7), (arg_8)=>{
                selectDispatch(new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(3, [
                    arg_8
                ]));
            }, (0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Fertilizer", (fertilizer_1)=>fertilizer_1.Name, (0, $d28ec4fb6293f25e$export$7feb6616db82ddb7)))),
            (0, $120450cd5ed2b836$export$bdeb69d37932a902)("Price", (arg_10)=>$a56e1de91baad685$export$c8bd1f4166729020((0, $9495a8d2b9c5bb89$export$bd79d4c70e4a627b)(data, settings, arg_10.Name)), (arg_11)=>(0, $9495a8d2b9c5bb89$export$a960ff6e57439a25)(data, settings, arg_11.Name)),
            (0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Growth Rate", (_arg_4)=>_arg_4.Speed, (0, $d28ec4fb6293f25e$export$626336c2cd4b14de)),
            (0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Crop Qualities", (_arg_5)=>_arg_5.Quality, (fertQuality)=>$a56e1de91baad685$export$2567eacf9de48882((0, $7bbf2c7402328604$export$448a53924e05a12a)(fertQuality, settings.Game.Skills)))
        ], fertilizers)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$bd58fe1cf49e76fd(data, settings, fertPriceSort_, fertPriceSort__1, fertilizers, dispatch) {
    const fertPriceSort = [
        fertPriceSort_,
        fertPriceSort__1
    ];
    const dispatch_1 = (arg_1)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
            arg_1
        ]));
    };
    const fertilizers_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((_arg)=>_arg.Name, fertilizers);
    const xs_1 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            className: "settings-group",
            children: $a56e1de91baad685$var$payForFertilizerSettings(settings.Profit, (arg_3)=>{
                dispatch_1(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(1, [
                    arg_3
                ]));
            })
        }),
        (0, $120450cd5ed2b836$export$dbe75ea921406f50)((x)=>x, fertPriceSort[0], fertPriceSort[1], (arg_4)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
                new (0, $7c6f80c5743180ba$export$78428c3f899407d)(7, [
                    arg_4
                ])
            ]));
        }, (0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $120450cd5ed2b836$export$ec7cb4baac01f1f5)((0, $120450cd5ed2b836$export$1ca5cf930c58a1f5)("Fertilizer", (x_1)=>x_1, (0, $d28ec4fb6293f25e$export$7feb6616db82ddb7)))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>$a56e1de91baad685$var$priceColumns(data.FertilizerPrices, settings.Selected.FertilizerPrices, settings.Selected.CustomFertilizerPrices, (vendor, arg_5)=>(0, $0ef027050085b17b$export$cc62f3272162c107)(vendor, (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.FertilizerPrices.fields[0], arg_5)), (0, $d28ec4fb6293f25e$export$7feb6616db82ddb7), $a56e1de91baad685$export$5386d5c64efb31a5(data), (tupledArg)=>new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(4, [
                        tupledArg[0],
                        tupledArg[1]
                    ]), (Item_7)=>new (0, $7c6f80c5743180ba$export$ae2c9c198ad166ff)(10, [
                        Item_7
                    ]), (arg_2)=>{
                    dispatch_1(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(2, [
                        arg_2
                    ]));
                }))))), fertilizers_1)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$70f0252d993ff8e1(app, dispatch) {
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const uiDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            arg
        ]));
    };
    const fertilizers = Array.from((0, $42cbcefff7323768$export$b035e44d7bb4278f)((_arg_1)=>_arg_1.Name, data.Fertilizers.fields[0].values(), {
        Compare: (0, $kRS0m.comparePrimitives)
    }));
    const xs = [
        (0, $d28ec4fb6293f25e$export$58335bbff18cfa1d)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(4, []), "Fertilizers", ()=>$a56e1de91baad685$var$lazyTable((data_1, settings_1, tupledArg, fertilizers_1, dispatch_1)=>$a56e1de91baad685$export$865f8837e10e7269(data_1, settings_1, tupledArg[0], tupledArg[1], fertilizers_1, dispatch_1), data, settings, ui.FertilizerSort, fertilizers, dispatch), uiDispatch),
        (0, $d28ec4fb6293f25e$export$58335bbff18cfa1d)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(5, []), "Prices", ()=>$a56e1de91baad685$var$lazyTable((data_2, settings_2, tupledArg_1, fertilizers_2, dispatch_2)=>$a56e1de91baad685$export$bd58fe1cf49e76fd(data_2, settings_2, tupledArg_1[0], tupledArg_1[1], fertilizers_2, dispatch_2), data, settings, ui.FertilizerPriceSort, fertilizers, dispatch), uiDispatch)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $a56e1de91baad685$var$Settings_date(label, otherDate, clamp, date, dispatch) {
    let elems;
    const clamp_1 = (season, day)=>{
        if (season === otherDate.Season) return clamp(otherDate.Day, day);
        else return day;
    };
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "date"
        ],
        (elems = [
            (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)(`${label} Date`, (0, $kRS0m.defaultOf)()),
            (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)(`${label} Season`, (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("4em", (arg)=>(0, $3921efb06a31e9cc$export$e1d90e20ad64402a)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                    [
                        "Spring",
                        0
                    ],
                    [
                        "Summer",
                        1
                    ],
                    [
                        "Fall",
                        2
                    ],
                    [
                        "Winter",
                        3
                    ]
                ]), arg), (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.Season", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                [
                    "Spring",
                    0
                ],
                [
                    "Summer",
                    1
                ],
                [
                    "Fall",
                    2
                ],
                [
                    "Winter",
                    3
                ]
            ])), date.Season, (season_1)=>{
                dispatch(new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(season_1, clamp_1(season_1, date.Day)));
            })),
            (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)(`${label} Day`, (0, $2bc91fecd0c77f83$export$91c39a88397ac04b)("1.5em", clamp_1(date.Season, 1), clamp_1(date.Season, 28), date.Day, (day_1)=>{
                dispatch(new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(date.Season, day_1));
            }))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$9ee962701e7d3aad(startDate, endDate, dispatch) {
    const xs = [
        $a56e1de91baad685$var$Settings_date("Start", endDate, (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222), startDate, (arg)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(0, [
                arg
            ]));
        }),
        $a56e1de91baad685$var$Settings_date("End", startDate, (0, $5ce0fb420d4fadad$export$8960430cfd85939f), endDate, (arg_1)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(1, [
                arg_1
            ]));
        })
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $a56e1de91baad685$export$b339448eaae5ad64(skills, profession, dispatch) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(!(0, $7bbf2c7402328604$export$48bd7047d7efb319)(profession, skills) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "className",
            "disabled"
        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let elems;
            return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = [
                (0, $2bc91fecd0c77f83$export$b44abdc670aa384b)((0, $d28ec4fb6293f25e$export$da2e6f014faedd47)(profession), (0, $70b963136d0d9ffe$export$5a6573e0052ad83f)(skills.Professions, profession), (arg)=>{
                    let tupledArg;
                    dispatch((tupledArg = [
                        profession,
                        arg
                    ], new (0, $7c6f80c5743180ba$export$bb5bb5912cca8d32)(2, [
                        tupledArg[0],
                        tupledArg[1]
                    ])));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ]));
        }))))));
}
function $a56e1de91baad685$export$439bbb9e23172eb3(skill, dispatch) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "skill-level"
        ],
        (elems = [
            (0, $2bc91fecd0c77f83$export$39d8cf33b76d38c6)("Level", "1.5em", 0, 10, skill.Level, (arg)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$641283dac61e9c0e)(0, [
                    arg
                ]));
            }),
            (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Buff", (0, $2bc91fecd0c77f83$export$91c39a88397ac04b)("1.5em", undefined, 999, skill.Buff, (arg_1)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$641283dac61e9c0e)(1, [
                    arg_1
                ]));
            }))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$b362871209984507(skills, skill, professions, qualities, icon, levelMsg, dispatch) {
    let elems_1, elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "skill"
        ],
        (elems_1 = [
            icon,
            $a56e1de91baad685$export$439bbb9e23172eb3(skill, (arg)=>{
                dispatch(levelMsg(arg));
            }),
            $a56e1de91baad685$export$2567eacf9de48882(qualities(skills)),
            /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "className",
                    "professions"
                ],
                (elems = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((prof)=>$a56e1de91baad685$export$b339448eaae5ad64(skills, prof, dispatch), professions), [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ])
            ])))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_1))
        ])
    ])));
}
function $a56e1de91baad685$export$c61e7b4b75823a02(skills, dispatch) {
    return $a56e1de91baad685$export$b362871209984507(skills, skills.Farming, (0, $7bbf2c7402328604$export$a24a89bf935f16be), (skills_1)=>(0, $7bbf2c7402328604$export$17f2a017346d4cdb)(undefined, skills_1), (0, $d28ec4fb6293f25e$export$14bb04b6b2668a74), (Item)=>new (0, $7c6f80c5743180ba$export$bb5bb5912cca8d32)(0, [
            Item
        ]), dispatch);
}
function $a56e1de91baad685$export$ab4b07880a6e60fb(skills, dispatch) {
    return $a56e1de91baad685$export$b362871209984507(skills, skills.Foraging, (0, $7bbf2c7402328604$export$ca2a686c637fb772), (0, $7bbf2c7402328604$export$7d37df9c03df61ad), (0, $d28ec4fb6293f25e$export$c3e6c39ff0428361), (Item)=>new (0, $7c6f80c5743180ba$export$bb5bb5912cca8d32)(1, [
            Item
        ]), dispatch);
}
function $a56e1de91baad685$export$f22a422adc5fe29b(skills, dispatch) {
    let children, elems;
    const xs_1 = [
        (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            $a56e1de91baad685$export$c61e7b4b75823a02(skills, dispatch),
            $a56e1de91baad685$export$ab4b07880a6e60fb(skills, dispatch)
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        })),
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "settings-group"
            ],
            (elems = [
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Ignore Skill Level Unlocks", skills.IgnoreSkillLevelRequirements, (arg)=>{
                    dispatch(new (0, $7c6f80c5743180ba$export$bb5bb5912cca8d32)(3, [
                        arg
                    ]));
                }),
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Ignore Profession Conflicts", skills.IgnoreProfessionConflicts, (arg_1)=>{
                    dispatch(new (0, $7c6f80c5743180ba$export$bb5bb5912cca8d32)(4, [
                        arg_1
                    ]));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ])))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$7789c8fb9a33a01d(multipliers, dispatch) {
    const xs = [
        (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Profit Margin", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("4em", (margin)=>margin === 1 ? "Normal" : (0, $d28ec4fb6293f25e$export$626336c2cd4b14de)(margin), (0, $42cbcefff7323768$export$45b10814cc054894)((0, $c7733b1bbdc2597b$export$b4822f0c51847685)(1, -0.25, 0.25)), multipliers.ProfitMargin, (arg)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$335e301269bc1503)(0, [
                arg
            ]));
        })),
        (0, $2bc91fecd0c77f83$export$b44abdc670aa384b)((0, $d28ec4fb6293f25e$export$80f83a8db8a2647f), multipliers.BearsKnowledge, (arg_1)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$335e301269bc1503)(1, [
                arg_1
            ]));
        }),
        (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Apply Tiller to Foraged Grapes and Blackberries", multipliers.TillerForForagedFruit, (arg_2)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$335e301269bc1503)(2, [
                arg_2
            ]));
        })
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $a56e1de91baad685$export$f515cbffa07b764c(profit, dispatch) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "settings-column"
        ],
        (elems = [
            (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Seed Strategy", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("5em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_1)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_1, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$43804ad8ff7cbd7)())), profit.SeedStrategy, (arg)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$7cb3e2d7ccbd06f2)(0, [
                    arg
                ]));
            })),
            $a56e1de91baad685$var$payForFertilizerSettings(profit, dispatch)
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$87887758a0468d2(game, profit, dispatch) {
    let elems_1, elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "settings-columns"
        ],
        (elems_1 = [
            $a56e1de91baad685$export$f515cbffa07b764c(profit, (arg)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(1, [
                    arg
                ]));
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "className",
                    "settings-column"
                ],
                (elems = [
                    $a56e1de91baad685$export$7789c8fb9a33a01d(game.Multipliers, (arg_2)=>{
                        dispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(0, [
                            new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(4, [
                                arg_2
                            ])
                        ]));
                    }),
                    (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Joja Membership", game.JojaMembership, (arg_4)=>{
                        dispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(0, [
                            new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(6, [
                                arg_4
                            ])
                        ]));
                    })
                ], [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ])
            ])))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_1))
        ])
    ])));
}
function $a56e1de91baad685$export$9eb4fb1285a593e2(irrigated, settings, settingsDispatch) {
    let elems;
    const dispatch = (arg)=>{
        settingsDispatch(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(5, [
            arg
        ]));
    };
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "settings-block"
        ],
        (elems = [
            (0, $2bc91fecd0c77f83$export$9456ea0ed272a8e8)("Average Giant Crop Orientations Per Tile", "4em", 0.001, 0, 9, settings.GiantCropOrientationsPerTile, (arg_1)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$795537fe84622889)(2, [
                    arg_1
                ]));
            }),
            (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Shaving Enchantment", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("4em", (arg_2)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)("None", (0, $e189d4fb2d038fab$export$5ec9284b921d00e4), arg_2), (0, $e5d9070e144b905e$export$9f200c4466975173)(0, undefined, (0, $e5d9070e144b905e$export$871de8747c9eaa88)((Value)=>Value, (0, $3921efb06a31e9cc$export$70a5d58ec00f3c11)((0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.ToolLevel", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                [
                    "Normal",
                    0
                ],
                [
                    "Copper",
                    1
                ],
                [
                    "Steel",
                    2
                ],
                [
                    "Gold",
                    3
                ],
                [
                    "Iridium",
                    4
                ]
            ])))), settings.ShavingToolLevel, (arg_3)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$795537fe84622889)(3, [
                    arg_3
                ]));
            })),
            (0, $d28ec4fb6293f25e$export$de51857dc0ef8573)("label-text", (0, $d28ec4fb6293f25e$export$d6b50c1760f9d6d), (0, $2bc91fecd0c77f83$export$91c39a88397ac04b)("2em", undefined, 1499, settings.LuckBuff, (arg_4)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$795537fe84622889)(1, [
                    arg_4
                ]));
            })),
            (0, $2bc91fecd0c77f83$export$b44abdc670aa384b)((0, $d28ec4fb6293f25e$export$eae2c00988c0b6ae), settings.SpecialCharm, (arg_5)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$795537fe84622889)(0, [
                    arg_5
                ]));
            }),
            (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Irrigated", irrigated, (arg_6)=>{
                settingsDispatch(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(7, [
                    arg_6
                ]));
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$cc265a26a6cdea90(qualityArtisanProducts, dispatch) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "settings-block"
        ],
        (elems = [
            (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Quality Artisan Products", qualityArtisanProducts, (arg)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(8, [
                    arg
                ]));
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$3d0e707712160a6c(openDetails, game, profit, dispatch) {
    let elems;
    const uiDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            arg
        ]));
    };
    const settingsDispatch = (arg_1)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(0, [
            arg_1
        ]));
    };
    const dispatch_1 = (arg_2)=>{
        settingsDispatch(new (0, $7c6f80c5743180ba$export$31d5215e225c155b)(0, [
            arg_2
        ]));
    };
    const xs_1 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "settings-group"
            ],
            (elems = [
                $a56e1de91baad685$export$9ee962701e7d3aad(game.StartDate, game.EndDate, dispatch_1),
                (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Location", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("6em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_1)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_1, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $a117bb35793377d5$export$4479c41f4f18ce99)())), game.Location, (arg_3)=>{
                    dispatch_1(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(2, [
                        arg_3
                    ]));
                }))
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ]))),
        (0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(6, []), "Skills", $a56e1de91baad685$export$f22a422adc5fe29b(game.Skills, (arg_5)=>{
            dispatch_1(new (0, $7c6f80c5743180ba$export$f2bb0c6a7b55dbf1)(3, [
                arg_5
            ]));
        }), uiDispatch),
        (0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(7, []), "Price Settings", $a56e1de91baad685$export$87887758a0468d2(game, profit, settingsDispatch), uiDispatch),
        (0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(8, []), "Crop Settings", $a56e1de91baad685$export$9eb4fb1285a593e2(game.Irrigated, game.CropAmount, dispatch_1), uiDispatch),
        (0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(9, []), "Mods", $a56e1de91baad685$export$cc265a26a6cdea90(game.QualityArtisanProducts, dispatch_1), uiDispatch)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$b8986dd63e32cb27(preset) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "preset"
        ],
        (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("span", {
                children: [
                    preset.Name
                ]
            })), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                if (preset.UniqueId != null) {
                    const startDate = preset.Settings.Game.StartDate;
                    return (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("span", {
                        children: [
                            `${(0, $e189d4fb2d038fab$export$17d0dbcd198f4e3f)(startDate.Season)} ${startDate.Day}`
                        ]
                    }));
                } else return (0, $42cbcefff7323768$export$6e22c362a0406a2c)();
            })))), [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$bc941374907fd2a1(save, setSave) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "file-input"
        ],
        (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let children_2, children;
            const loadFile = (file)=>{
                file.text().then((text)=>setSave([
                        file.name,
                        (0, $6107b71bda0f6ed5$export$6f99be9d94cb9e9d)(text)
                    ]));
            };
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    "Choose Save File",
                    /*#__PURE__*/ (0, $hURbM.createElement)("input", {
                        type: "file",
                        onChange: (ev)=>{
                            const files = ev.target.files;
                            if (!(files == null) && files.length > 0) loadFile(files.item(0));
                        },
                        autoFocus: true
                    })
                ]), /*#__PURE__*/ (0, $hURbM.createElement)("label", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
                })),
                (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)($a56e1de91baad685$export$b8986dd63e32cb27, save)
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
            }))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("div", {
                    "aria-hidden": true,
                    onDragOver: (event)=>{
                        (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(event);
                    },
                    onDrop: (e)=>{
                        (0, $d28ec4fb6293f25e$export$d6e5ca10785815df)(e);
                        if (e.dataTransfer.files.length > 0) loadFile(e.dataTransfer.files[0]);
                    },
                    children: "or drag the file here"
                }))));
        })), [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $a56e1de91baad685$export$e81647ecadd973db(presets, save) {
    return (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((tupledArg)=>{
        let elems;
        const fileName = tupledArg[0];
        return /*#__PURE__*/ (0, $hURbM.createElement)("ul", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "messages"
            ],
            (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(fileName !== "SaveGameInfo" ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                    children: [
                        (0, $d28ec4fb6293f25e$export$a59f727245974ec4)(`It appears you have chosen a file named "${fileName}". Please choose the file named "SaveGameInfo".`)
                    ]
                })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                    const matchValue = tupledArg[1];
                    if (matchValue != null) {
                        const missing = matchValue[1];
                        return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$f7e9f41ea797a17)((uniqueId)=>(0, $e08834e1786645d9$export$f7e9f41ea797a17)((preset_2)=>(0, $3699f71d1df66484$export$1f050c40b73d064f)(uniqueId, preset_2), presets), (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(matchValue[0].UniqueId)) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                            children: [
                                (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("This save game has been previously imported. Clicking \"Ok\" will update/overwrite the existing preset.")
                            ]
                        })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            let xs, children_1;
                            return missing.length > 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                                children: [
                                    (0, $d28ec4fb6293f25e$export$9a7b8ed73dd9e407)((xs = [
                                        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                                            children: [
                                                "Warning: failed to load the following data from the save game:"
                                            ]
                                        }),
                                        (children_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((children)=>/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                                                children: [
                                                    children
                                                ]
                                            }), missing), /*#__PURE__*/ (0, $hURbM.createElement)("ul", {
                                            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_1))
                                        })),
                                        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                                            children: [
                                                "Click \"Ok\" if you want to continue anyways."
                                            ]
                                        })
                                    ], /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs)))
                                ]
                            })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)();
                        }));
                    } else return (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$97fee0e1b1631f99)("Failed to load the save game.")
                        ]
                    }));
                })))), [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ])));
    }, save);
}
function $a56e1de91baad685$export$9a443bc5887bf3a2(presets, dispatch) {
    return (0, $f2f828056f038bf6$export$6bbef08489b3f96e)("Import Save", "Import Save Game", undefined, (arg_2)=>{
        (0, $42cbcefff7323768$export$c1a059043cc9c119)((arg_1)=>{
            dispatch(new (0, $7c6f80c5743180ba$export$decfa90875508c9d)(0, [
                arg_1[0]
            ]));
        }, (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((tuple)=>tuple[1], arg_2)));
    }, (_arg, save, setSave)=>{
        let children, str_1;
        const xs_1 = [
            (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                (str_1 = "\n              Please provide the \"SaveGameInfo\" file for the save you want to import.\n              Instructions for where to find this file can be found on the\n            ", str_1),
                /*#__PURE__*/ (0, $hURbM.createElement)("a", {
                    href: "https://stardewvalleywiki.com/Saves#Save_format",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: "Stardew Valley Wiki"
                }),
                "."
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("p", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            })),
            $a56e1de91baad685$export$bc941374907fd2a1((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tuple_3)=>tuple_3[0], (0, $22d1a4cfc5fba7ce$export$2385a24977818dd0)((tuple_2)=>tuple_2[1], save)), setSave),
            $a56e1de91baad685$export$e81647ecadd973db(presets, save)
        ];
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
    });
}
function $a56e1de91baad685$export$73abe46c91b8b074(dispatch) {
    let children;
    return (0, $f2f828056f038bf6$export$71edf76f07903b9c)("Nuclear Reset", (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("Nuclear Reset"), ()=>{
        dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(3, []));
    }, (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        "Warning: This will reset Stardew Valley Stonks to its default settings, ",
        /*#__PURE__*/ (0, $hURbM.createElement)("strong", {
            children: [
                "deleting"
            ]
        }),
        " all custom presets in the process."
    ]), /*#__PURE__*/ (0, $hURbM.createElement)("p", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    })));
}
function $a56e1de91baad685$export$8b701a7cbf14339(presets, loadDispatch, saveDispatch) {
    const presets_1 = (0, $e08834e1786645d9$export$dd1bc94b04021eeb)(presets) ? (0, $e08834e1786645d9$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
        className: "empty",
        "aria-hidden": true,
        children: "No presets..."
    })) : (0, $e08834e1786645d9$export$e5bd5b3b105c2a71)((i, preset)=>{
        let children;
        const children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            $a56e1de91baad685$export$b8986dd63e32cb27(preset),
            (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                /*#__PURE__*/ (0, $hURbM.createElement)("button", {
                    className: "button",
                    onClick: (_arg)=>{
                        loadDispatch(preset.Settings);
                    },
                    children: "Load"
                }),
                (0, $f2f828056f038bf6$export$6bbef08489b3f96e)("Edit", `Rename Preset '${preset.Name}'`, preset.Name, (arg)=>{
                    let tupledArg;
                    saveDispatch((tupledArg = [
                        i,
                        arg
                    ], new (0, $7c6f80c5743180ba$export$decfa90875508c9d)(2, [
                        tupledArg[0],
                        tupledArg[1]
                    ])));
                }, (_arg_1, name_4, setName)=>(0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Name", (0, $2bc91fecd0c77f83$export$6f093cfa640b7166)(name_4, setName))),
                /*#__PURE__*/ (0, $hURbM.createElement)("button", {
                    className: "button",
                    onClick: (_arg_2)=>{
                        saveDispatch(new (0, $7c6f80c5743180ba$export$decfa90875508c9d)(3, [
                            i
                        ]));
                    },
                    children: "Delete"
                })
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            }))
        ]);
        return /*#__PURE__*/ (0, $hURbM.createElement)("li", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        });
    }, presets);
    const children_6 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        /*#__PURE__*/ (0, $hURbM.createElement)("h1", {
            children: [
                "Presets"
            ]
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("ul", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(presets_1))
        })
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("section", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_6))
    });
}
function $a56e1de91baad685$export$3b23172aba849c9f(presets, settings, dispatch) {
    let children, children_2;
    const saveDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(1, [
            arg
        ]));
    };
    const loadDispatch = (arg_2)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(0, [
            new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(2, [
                arg_2
            ])
        ]));
    };
    const xs_1 = [
        $a56e1de91baad685$export$8b701a7cbf14339(presets, loadDispatch, saveDispatch),
        (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            (0, $f2f828056f038bf6$export$6bbef08489b3f96e)("Save Current Settings", "New Preset", "Untitled Preset", (name)=>{
                saveDispatch(new (0, $7c6f80c5743180ba$export$decfa90875508c9d)(1, [
                    name,
                    settings
                ]));
            }, (_arg, name_1, setName)=>(0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Name", (0, $2bc91fecd0c77f83$export$6f093cfa640b7166)(name_1, setName))),
            $a56e1de91baad685$export$9a443bc5887bf3a2(presets, saveDispatch)
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        })),
        (children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            /*#__PURE__*/ (0, $hURbM.createElement)("button", {
                className: "button",
                onClick: (_arg_1)=>{
                    loadDispatch((0, $6107b71bda0f6ed5$export$62680b65e63e14ec));
                },
                children: "Reset Settings"
            }),
            $a56e1de91baad685$export$73abe46c91b8b074(dispatch)
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        }))
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $a56e1de91baad685$export$fe2e36411d703b3d(app, dispatch) {
    let elems;
    const dispatch_1 = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(0, [
            arg
        ]));
    };
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    return /*#__PURE__*/ (0, $hURbM.createElement)("section", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "id",
            "settings"
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)((0, $d28ec4fb6293f25e$export$b2539bed5023c21c), {
                Current: ui.SettingsTab,
                Dispatch: (arg_2)=>{
                    dispatch_1(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
                        new (0, $7c6f80c5743180ba$export$78428c3f899407d)(3, [
                            arg_2
                        ])
                    ]));
                },
                Label: "Settings",
                Panel: (_arg)=>{
                    switch(_arg.tag){
                        case 1:
                            return $a56e1de91baad685$export$70f0252d993ff8e1(app, dispatch_1);
                        case 2:
                            return $a56e1de91baad685$export$3d0e707712160a6c(ui.OpenDetails, settings.Game, settings.Profit, dispatch_1);
                        case 3:
                            return $a56e1de91baad685$export$3b23172aba849c9f(app.Presets, settings, dispatch);
                        default:
                            return $a56e1de91baad685$export$8e7bd90b2ed3163a(app, dispatch_1);
                    }
                },
                Tabs: (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$ca496ce55ada41e0)()))
            })
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}






parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");
var $cc1z1 = parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");
'use client';
const $5b7a912ee26f9a3d$export$b16d9fb1a22de840 = (0, $hURbM.createContext)(null);
const $5b7a912ee26f9a3d$var$initialState = {
    didCatch: false,
    error: null
};
class $5b7a912ee26f9a3d$export$e926676385687eaf extends (0, $hURbM.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $5b7a912ee26f9a3d$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($5b7a912ee26f9a3d$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $5b7a912ee26f9a3d$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($5b7a912ee26f9a3d$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $hURbM.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $cc1z1.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $hURbM.createElement)($5b7a912ee26f9a3d$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $5b7a912ee26f9a3d$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $5b7a912ee26f9a3d$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $5b7a912ee26f9a3d$export$c052f6604b7d51fe() {
    const context = (0, $bNI4e.useContext)($5b7a912ee26f9a3d$export$b16d9fb1a22de840);
    $5b7a912ee26f9a3d$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $bNI4e.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $bNI4e.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $5b7a912ee26f9a3d$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $cc1z1.forwardRef)((props, ref)=>(0, $hURbM.createElement)($5b7a912ee26f9a3d$export$e926676385687eaf, errorBoundaryProps, (0, $hURbM.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}




parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");

var $kRS0m = parcelRequire("kRS0m");












var $kRS0m = parcelRequire("kRS0m");




var $eATN7 = parcelRequire("eATN7");











function $6f1b0d5bd41c85b6$var$fertilizerStrictlyWorse(fert1, cost1, fert2, cost2) {
    if (!(0, $kRS0m.equals)((0, $7bbf2c7402328604$export$70921c9a086f6004)(fert1), (0, $7bbf2c7402328604$export$70921c9a086f6004)(fert2)) && (0, $kRS0m.compare)(cost1, cost2) >= 0 && (0, $7bbf2c7402328604$export$4689e1bbdbf4db51)(fert1) <= (0, $7bbf2c7402328604$export$4689e1bbdbf4db51)(fert2)) return (0, $7bbf2c7402328604$export$12ba9d8c8c76f13f)(fert1) <= (0, $7bbf2c7402328604$export$12ba9d8c8c76f13f)(fert2);
    else return false;
}
function $6f1b0d5bd41c85b6$var$removeStrictlyWorseFertilizers(fertilizersAndCost) {
    return fertilizersAndCost.filter((fertCost)=>!fertilizersAndCost.some((tupledArg)=>$6f1b0d5bd41c85b6$var$fertilizerStrictlyWorse(fertCost[0], fertCost[1], tupledArg[0], tupledArg[1])));
}
function $6f1b0d5bd41c85b6$var$groupFertilizersBySpeed(fertilizersAndCost) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>[
            (0, $e5d9070e144b905e$export$8c826aa0fa59ac68)((tuple_1)=>tuple_1[1], tupledArg[1], {
                Compare: (0, $kRS0m.compare)
            })[0],
            0
        ], (0, $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe)((arg)=>(0, $7bbf2c7402328604$export$12ba9d8c8c76f13f)(arg[0]), fertilizersAndCost, {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    }));
}
class $6f1b0d5bd41c85b6$var$Variable extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "DayUsedForBridgeCrop",
            "DayUsedForRegrowCrop",
            "PlantCrop",
            "PlantBridgeCrop",
            "PlantCropUnreplacedFertilizer",
            "PlantRegrowCropFixedHarvests",
            "PlantRegrowCropFirstHarvests",
            "PlantRegrowCropRegrowHarvests"
        ];
    }
}
function $6f1b0d5bd41c85b6$var$Variable_$reflection() {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("StardewValleyStonks.WebApp.Optimizer.Variable", [], $6f1b0d5bd41c85b6$var$Variable, ()=>[
            [],
            [],
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)()
                ]
            ],
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$614a3506a98cbb0e)()
                ]
            ],
            [
                [
                    "Item1",
                    (0, $e189d4fb2d038fab$export$5eb9b2f9b0a5c405)()
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item1",
                    (0, $e189d4fb2d038fab$export$5eb9b2f9b0a5c405)()
                ],
                [
                    "Item2",
                    (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
                ]
            ],
            [
                [
                    "Item",
                    (0, $e189d4fb2d038fab$export$5eb9b2f9b0a5c405)()
                ]
            ]
        ]);
}
class $6f1b0d5bd41c85b6$var$FertilizerSpanRequest extends (0, $eATN7.Record) {
    constructor(Start, Stop, Fertilizer, FertilizerCost, Variables){
        super();
        this.Start = Start | 0;
        this.Stop = Stop | 0;
        this.Fertilizer = Fertilizer;
        this.FertilizerCost = FertilizerCost;
        this.Variables = Variables;
    }
}
function $6f1b0d5bd41c85b6$var$FertilizerSpanRequest_$reflection() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Optimizer.FertilizerSpanRequest", [], $6f1b0d5bd41c85b6$var$FertilizerSpanRequest, ()=>[
            [
                "Start",
                (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
            ],
            [
                "Stop",
                (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
            ],
            [
                "Fertilizer",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "FertilizerCost",
                (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)
            ],
            [
                "Variables",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), $6f1b0d5bd41c85b6$var$Variable_$reflection()))
            ]
        ]);
}
class $6f1b0d5bd41c85b6$export$b88652776e9771a9 extends (0, $eATN7.Record) {
    constructor(StartDate, EndDate, Fertilizer, CropHarvests, RegrowCrop){
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Fertilizer = Fertilizer;
        this.CropHarvests = CropHarvests;
        this.RegrowCrop = RegrowCrop;
    }
}
function $6f1b0d5bd41c85b6$export$2e9823d0627d8dbe() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.Optimizer.FertilizerDateSpan", [], $6f1b0d5bd41c85b6$export$b88652776e9771a9, ()=>[
            [
                "StartDate",
                (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
            ],
            [
                "EndDate",
                (0, $e189d4fb2d038fab$export$29a8a6e9851b7490)()
            ],
            [
                "Fertilizer",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)())
            ],
            [
                "CropHarvests",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $e189d4fb2d038fab$export$614a3506a98cbb0e)(), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)))
            ],
            [
                "RegrowCrop",
                (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), (0, $e189d4fb2d038fab$export$5eb9b2f9b0a5c405)(), (0, $3921efb06a31e9cc$export$173d14c9e9e1a539)))
            ]
        ]);
}
function $6f1b0d5bd41c85b6$var$bridgeCropVariables(settings, objectiveValue, season, fertilizer, fertCost, prevSeasonCrops) {
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
        const crop = tupledArg[0];
        return [
            [
                season,
                new $6f1b0d5bd41c85b6$var$Variable(3, [
                    crop
                ])
            ],
            [
                [
                    "Objective",
                    objectiveValue(crop, tupledArg[1], fertilizer, fertCost)
                ],
                [
                    "BridgeDays@" + (0, $eATN7.toString)(season),
                    (0, $a117bb35793377d5$export$3302572d20aa94ca)(settings.Game, fertilizer, crop)
                ],
                [
                    "BridgeHarvests@" + (0, $eATN7.toString)(season),
                    1
                ]
            ]
        ];
    }, prevSeasonCrops);
}
function $6f1b0d5bd41c85b6$var$regularCropVariables(settings, objectiveValue, season, fertilizer, fertCost, crops) {
    return (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>{
        const crop = tupledArg[0];
        const value = objectiveValue(crop, tupledArg[1], fertilizer, fertCost);
        if (value < 0) return undefined;
        else return [
            [
                season,
                new $6f1b0d5bd41c85b6$var$Variable(2, [
                    crop
                ])
            ],
            [
                [
                    "Objective",
                    value
                ],
                [
                    (0, $eATN7.toString)(season),
                    (0, $a117bb35793377d5$export$3302572d20aa94ca)(settings.Game, fertilizer, crop)
                ]
            ]
        ];
    }, crops);
}
function $6f1b0d5bd41c85b6$var$unreplacedFertilizerVariables(settings, season, fertilizer, fertCost, crops) {
    return (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>{
        const crop = tupledArg[0];
        if (fertCost === 0 ? true : (0, $9495a8d2b9c5bb89$export$eab7a6e44ba71d7b)(settings, crop) === 0) return undefined;
        else {
            const profit_1 = tupledArg[1](fertilizer);
            if (profit_1 < 0) return undefined;
            else return [
                [
                    season,
                    new $6f1b0d5bd41c85b6$var$Variable(4, [
                        crop
                    ])
                ],
                [
                    [
                        "Objective",
                        profit_1
                    ],
                    [
                        (0, $eATN7.toString)(season),
                        (0, $a117bb35793377d5$export$3302572d20aa94ca)(settings.Game, fertilizer, crop)
                    ],
                    [
                        "EndingCrop",
                        1
                    ]
                ]
            ];
        }
    }, crops);
}
function $6f1b0d5bd41c85b6$var$regrowVariablesAndConstraints(settings, season, prevDays, totalDays, fertIndex, fertilizer, regrowValues, constraints, regrowCrops) {
    if (regrowCrops.length === 0) return [
        constraints,
        []
    ];
    else {
        const patternInput = (0, $e5d9070e144b905e$export$93e2b83da34ff82a)((tupledArg, tupledArg_1)=>{
            const constraints_1 = tupledArg[0];
            const variables = tupledArg[1];
            const crop = tupledArg_1[0];
            const data_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(fertIndex, tupledArg_1[1]);
            const growthTime = (0, $a117bb35793377d5$export$3302572d20aa94ca)(settings.Game, fertilizer, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                crop
            ]));
            const minHarvests = (0, $e189d4fb2d038fab$export$afe58414eb6e822)(crop.RegrowTime, growthTime, prevDays);
            const maxHarvests = (0, $e189d4fb2d038fab$export$afe58414eb6e822)(crop.RegrowTime, growthTime, totalDays);
            const fixedVariables = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$bb44f104e3c54dae)((h)=>{
                    const cost = data_1.Cost(h);
                    const usedDays = (0, $e189d4fb2d038fab$export$540e37fd0d22453b)(crop.RegrowTime, growthTime, h);
                    return (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                        [
                            season,
                            new $6f1b0d5bd41c85b6$var$Variable(5, [
                                crop,
                                h
                            ])
                        ],
                        (0, $e5d9070e144b905e$export$10d8903dec122b9d)([
                            [
                                "Objective",
                                data_1.ProfitPerHarvest * h - cost
                            ],
                            [
                                (0, $eATN7.toString)(season),
                                prevDays > usedDays ? 0 : usedDays - prevDays
                            ]
                        ], regrowValues)
                    ]);
                }, (0, $c7733b1bbdc2597b$export$b4822f0c51847685)((0, $5ce0fb420d4fadad$export$8960430cfd85939f)(minHarvests, 1), 1, (0, $5ce0fb420d4fadad$export$96ec731ed4dcb222)(maxHarvests, data_1.HarvestsForMinCost - 1)))));
            if (maxHarvests >= data_1.HarvestsForMinCost) {
                const harvests = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(data_1.HarvestsForMinCost, minHarvests);
                const usedDays_1 = (0, $e189d4fb2d038fab$export$540e37fd0d22453b)(crop.RegrowTime, growthTime, harvests);
                const harvestsName = crop.Seed.toString() + "@" + (0, $eATN7.toString)(season);
                const firstVariable = [
                    [
                        season,
                        new $6f1b0d5bd41c85b6$var$Variable(6, [
                            crop,
                            harvests
                        ])
                    ],
                    (0, $e5d9070e144b905e$export$10d8903dec122b9d)([
                        [
                            "Objective",
                            data_1.ProfitPerHarvest * harvests - data_1.MinCost
                        ],
                        [
                            "RegrowDays@" + (0, $eATN7.toString)(season),
                            ~~usedDays_1 - ~~prevDays
                        ],
                        [
                            harvestsName,
                            -(maxHarvests - harvests)
                        ]
                    ], regrowValues)
                ];
                const regrowVariable = [
                    [
                        season,
                        new $6f1b0d5bd41c85b6$var$Variable(7, [
                            crop
                        ])
                    ],
                    [
                        [
                            "Objective",
                            data_1.ProfitPerHarvest
                        ],
                        [
                            harvestsName,
                            1
                        ],
                        [
                            "RegrowDays@" + (0, $eATN7.toString)(season),
                            (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(crop.RegrowTime)
                        ]
                    ]
                ];
                return [
                    (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                        harvestsName,
                        (0, $113dc42df8fd0649$export$d6fe668f8d2afbf1)(0)
                    ], constraints_1),
                    (0, $e08834e1786645d9$export$8327ebbef2a0ba76)((0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                        firstVariable,
                        regrowVariable
                    ], fixedVariables), variables)
                ];
            } else return [
                constraints_1,
                (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(fixedVariables, variables)
            ];
        }, [
            constraints,
            (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
        ], regrowCrops);
        const regrowDayVariable = [
            [
                season,
                new $6f1b0d5bd41c85b6$var$Variable(1, [])
            ],
            [
                [
                    (0, $eATN7.toString)(season),
                    1
                ],
                [
                    "RegrowDays@" + (0, $eATN7.toString)(season),
                    -1
                ]
            ]
        ];
        return [
            (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                "RegrowDays@" + (0, $eATN7.toString)(season),
                (0, $113dc42df8fd0649$export$bdcdec1f91f16dff)(0)
            ], patternInput[0]),
            Array.from((0, $42cbcefff7323768$export$ee1b3e54f0441b22)((0, $e08834e1786645d9$export$8327ebbef2a0ba76)((0, $e08834e1786645d9$export$439306a4dcaafbb9)(regrowDayVariable), patternInput[1])))
        ];
    }
}
function $6f1b0d5bd41c85b6$var$bridgeToNextSeason(settings, objectiveValue, season, nextSeason, days, bridgeCropsVars, fertilizerData, constraintsAndVariables) {
    return (0, $e5d9070e144b905e$export$5be556bf484c4f10)((tupledArg, tupledArg_1)=>{
        const variables = tupledArg[1];
        return [
            (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                [
                    (0, $eATN7.toString)(nextSeason),
                    (0, $113dc42df8fd0649$export$d6fe668f8d2afbf1)(days - 1)
                ],
                [
                    "BridgeDays@" + (0, $eATN7.toString)(nextSeason),
                    (0, $113dc42df8fd0649$export$bdcdec1f91f16dff)(1)
                ],
                [
                    "BridgeHarvests@" + (0, $eATN7.toString)(nextSeason),
                    (0, $113dc42df8fd0649$export$bdcdec1f91f16dff)(1)
                ]
            ], tupledArg[0]),
            bridgeCropsVars.length === 0 ? variables : (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                [
                    [
                        [
                            season,
                            new $6f1b0d5bd41c85b6$var$Variable(0, [])
                        ],
                        [
                            [
                                (0, $eATN7.toString)(season),
                                1
                            ],
                            [
                                "BridgeDays@" + (0, $eATN7.toString)(nextSeason),
                                -1
                            ]
                        ]
                    ],
                    [
                        [
                            nextSeason,
                            new $6f1b0d5bd41c85b6$var$Variable(0, [])
                        ],
                        [
                            [
                                (0, $eATN7.toString)(nextSeason),
                                1
                            ],
                            [
                                "BridgeDays@" + (0, $eATN7.toString)(nextSeason),
                                -1
                            ]
                        ]
                    ]
                ],
                $6f1b0d5bd41c85b6$var$bridgeCropVariables(settings, objectiveValue, nextSeason, tupledArg_1[0], tupledArg_1[1], bridgeCropsVars)
            ], variables)
        ];
    }, constraintsAndVariables, fertilizerData);
}
function $6f1b0d5bd41c85b6$var$bridgeRegrowToNextSeason(season, days, nextSeason, regrowValues) {
    return (0, $e5d9070e144b905e$export$10d8903dec122b9d)([
        [
            "BridgeDays@" + (0, $eATN7.toString)(nextSeason),
            1
        ],
        [
            "BridgeHarvests@" + (0, $eATN7.toString)(nextSeason),
            1
        ],
        [
            (0, $eATN7.toString)(season),
            days - 1
        ]
    ], regrowValues);
}
function $6f1b0d5bd41c85b6$var$createModels(startSeason, endSeason, constraintsAndVariables, fertilizerData) {
    return (0, $e5d9070e144b905e$export$5be556bf484c4f10)((tupledArg, tupledArg_1)=>{
        const variables_1 = (0, $e5d9070e144b905e$export$ee1b3e54f0441b22)(tupledArg[1]);
        return [
            new $6f1b0d5bd41c85b6$var$FertilizerSpanRequest(startSeason, endSeason, tupledArg_1[0], tupledArg_1[1], (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tuple)=>tuple[0], variables_1)),
            {
                constraints: (0, $e08834e1786645d9$export$45b10814cc054894)(tupledArg[0]),
                direction: "maximize",
                integers: true,
                objective: "Objective",
                variables: (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, tupledArg_2)=>[
                        i,
                        tupledArg_2[1]
                    ], variables_1)
            }
        ];
    }, constraintsAndVariables, fertilizerData);
}
function $6f1b0d5bd41c85b6$var$fertilizerAndCropData(data, settings, objective, seasons) {
    let f1, f1_1;
    const patternInput = objective.tag === 1 ? [
        $6f1b0d5bd41c85b6$var$groupFertilizersBySpeed,
        (_arg)=>(data_2)=>(fertilizer_1)=>(_arg_1)=>data_2(fertilizer_1),
        (f1 = (0, $9495a8d2b9c5bb89$export$3a84a4b0e1d41b08)(data)(settings), (arg)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((x)=>(arg10$0040)=>x, f1(arg))),
        (f1_1 = (0, $9495a8d2b9c5bb89$export$86ebbcbdacc1461f)(data)(settings), (arg_1)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((x_2)=>(arg10$0040_1)=>x_2, f1_1(arg_1)))
    ] : [
        $6f1b0d5bd41c85b6$var$removeStrictlyWorseFertilizers,
        (crop)=>(data_1)=>(fertilizer)=>(fertCost)=>data_1(fertilizer) - (0, $9495a8d2b9c5bb89$export$eab7a6e44ba71d7b)(settings, crop) * fertCost,
        (0, $9495a8d2b9c5bb89$export$e6827ecb22c95961)(data)(settings),
        (0, $9495a8d2b9c5bb89$export$99b27ba3b6bb7c80)(data)(settings)
    ];
    const fertilizerData = patternInput[0](Array.from((0, $42cbcefff7323768$export$7877a478dd30fd3d)((fertilizer_2)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((cost)=>[
                fertilizer_2,
                cost
            ], (0, $9495a8d2b9c5bb89$export$cdc2eb88a8e1410b)(data, settings)((0, $7bbf2c7402328604$export$70921c9a086f6004)(fertilizer_2))), (0, $9495a8d2b9c5bb89$export$bfed76964c7008b8)(data, settings))));
    const patternInput_1 = (0, $e5d9070e144b905e$export$b29f828819edca8d)((0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f), Array.from((0, $9495a8d2b9c5bb89$export$98f73a3fc1e1b415)(data, settings)));
    const cropData = (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((crop_1)=>(0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((objectiveValue_1)=>[
                crop_1,
                objectiveValue_1
            ], patternInput[2](crop_1)), patternInput_1[1]);
    const cropData_1 = (0, $kRS0m.equals)(settings.Game.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? (0, $e5d9070e144b905e$export$871de8747c9eaa88)((season)=>cropData.filter((arg_2)=>(0, $e189d4fb2d038fab$export$9cc23dda456089a)(season, arg_2[0])), seasons) : [
        cropData
    ];
    const regrowCropData_1 = (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((_arg_5)=>{
        if (_arg_5.tag === 1) return undefined;
        else {
            const crop_2 = _arg_5.fields[0];
            return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((data_3)=>[
                    crop_2,
                    (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg_3)=>data_3(arg_3[0]), fertilizerData)
                ], patternInput[3](crop_2));
        }
    }, patternInput_1[0]);
    return [
        fertilizerData,
        cropData_1,
        (0, $kRS0m.equals)(settings.Game.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? (0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, season_1)=>regrowCropData_1.filter((tupledArg)=>{
                const crop_3 = tupledArg[0];
                if ((0, $e189d4fb2d038fab$export$4f6ced0ca5ac5df1)(season_1, crop_3)) {
                    if (i === seasons.length - 1) return true;
                    else return !(0, $e189d4fb2d038fab$export$4f6ced0ca5ac5df1)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i + 1, seasons), crop_3);
                } else return false;
            }), seasons) : [
            regrowCropData_1
        ],
        patternInput[1]
    ];
}
function $6f1b0d5bd41c85b6$var$createRequests(data, settings, objective) {
    const patternInput = (0, $kRS0m.equals)(settings.Game.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? [
        (0, $e189d4fb2d038fab$export$641f31a913d47020)(settings.Game.StartDate.Season, settings.Game.EndDate.Season),
        (0, $e189d4fb2d038fab$export$ade24b166187735c)(settings.Game.StartDate, settings.Game.EndDate)
    ] : [
        new Int32Array([
            settings.Game.StartDate.Season
        ]),
        new Uint32Array([
            (0, $e189d4fb2d038fab$export$76d2bde4e6058336)(settings.Game.StartDate, settings.Game.EndDate)
        ])
    ];
    const seasons = patternInput[0];
    const days = patternInput[1];
    const patternInput_1 = $6f1b0d5bd41c85b6$var$fertilizerAndCropData(data, settings, objective, seasons);
    const objectiveValue = patternInput_1[3];
    const fertilizerData = patternInput_1[0];
    const cropData = patternInput_1[1];
    const nextSeasonModels = (prevDays_mut, startSeason_mut, endSeason_mut, regrowCropVars_mut, regrowValues_mut, constraintsAndVariables_mut, models_mut)=>{
        nextSeasonModels: while(true){
            const prevDays = prevDays_mut, startSeason = startSeason_mut, endSeason = endSeason_mut, regrowCropVars = regrowCropVars_mut, regrowValues = regrowValues_mut, constraintsAndVariables = constraintsAndVariables_mut, models = models_mut;
            const totalDays = prevDays + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(startSeason, days);
            const regularCropVars = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(startSeason, cropData);
            const constraintsAndVariables_1 = (0, $e5d9070e144b905e$export$aded800c294daba4)((fertIndex, tupledArg, tupledArg_1)=>{
                const fert = tupledArg_1[0];
                const regularVars = $6f1b0d5bd41c85b6$var$regularCropVariables(settings, (0, $kRS0m.uncurry4)(objectiveValue), startSeason, fert, tupledArg_1[1], regularCropVars);
                const patternInput_2 = $6f1b0d5bd41c85b6$var$regrowVariablesAndConstraints(settings, startSeason, prevDays, totalDays, fertIndex, fert, regrowValues, tupledArg[0], regrowCropVars);
                return [
                    patternInput_2[0],
                    (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                        regularVars,
                        patternInput_2[1]
                    ], tupledArg[1])
                ];
            }, constraintsAndVariables, fertilizerData);
            const models_1 = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)($6f1b0d5bd41c85b6$var$createModels(startSeason, endSeason, constraintsAndVariables_1, fertilizerData), models);
            if (startSeason === 0) return models_1;
            else {
                const nextSeason = startSeason - 1 | 0;
                let bridgeCropsVars;
                let predicate;
                let f2;
                const season = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(nextSeason, seasons) | 0;
                f2 = (_arg)=>(0, $e189d4fb2d038fab$export$9cc23dda456089a)(season, _arg);
                predicate = (arg)=>f2(arg[0]);
                bridgeCropsVars = regularCropVars.filter(predicate);
                let regrowCropsVars;
                let predicate_1;
                let f2_1;
                const season_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(nextSeason, seasons) | 0;
                f2_1 = (crop)=>(0, $e189d4fb2d038fab$export$4f6ced0ca5ac5df1)(season_1, crop);
                predicate_1 = (arg_1)=>f2_1(arg_1[0]);
                regrowCropsVars = regrowCropVars.filter(predicate_1);
                if (bridgeCropsVars.length + regrowCropsVars.length === 0) return models_1;
                else {
                    const constraintsAndVariables_2 = $6f1b0d5bd41c85b6$var$bridgeToNextSeason(settings, (0, $kRS0m.uncurry4)(objectiveValue), startSeason, nextSeason, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(nextSeason, days), bridgeCropsVars, fertilizerData, constraintsAndVariables_1);
                    prevDays_mut = totalDays;
                    startSeason_mut = nextSeason;
                    endSeason_mut = endSeason;
                    regrowCropVars_mut = regrowCropsVars;
                    regrowValues_mut = $6f1b0d5bd41c85b6$var$bridgeRegrowToNextSeason(startSeason, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(startSeason, days), nextSeason, regrowValues);
                    constraintsAndVariables_mut = constraintsAndVariables_2;
                    models_mut = models_1;
                    continue nextSeasonModels;
                }
            }
            break;
        }
    };
    return (0, $e5d9070e144b905e$export$ee1b3e54f0441b22)((0, $42cbcefff7323768$export$ee1b3e54f0441b22)((0, $e5d9070e144b905e$export$2a47f398eeff8b01)(seasons.length, (endSeason_1)=>{
        const startingConstraints = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                (0, $kRS0m.int32ToString)(endSeason_1),
                (0, $113dc42df8fd0649$export$d6fe668f8d2afbf1)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(endSeason_1, days) - 1)
            ],
            [
                "EndingCrop",
                (0, $113dc42df8fd0649$export$d6fe668f8d2afbf1)(1)
            ]
        ]);
        const constraintsAndVariables_3 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg_2)=>[
                startingConstraints,
                (0, $e08834e1786645d9$export$439306a4dcaafbb9)($6f1b0d5bd41c85b6$var$unreplacedFertilizerVariables(settings, endSeason_1, tupledArg_2[0], tupledArg_2[1], (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(endSeason_1, cropData)))
            ], fertilizerData);
        return nextSeasonModels(0, endSeason_1, endSeason_1, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(endSeason_1, patternInput_1[2]), [
            [
                "EndingCrop",
                1
            ]
        ], constraintsAndVariables_3, (0, $e08834e1786645d9$export$6e22c362a0406a2c)());
    })));
}
function $6f1b0d5bd41c85b6$var$weightedIntervalSchedule(solvedRequests) {
    const bestDownTo = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(solvedRequests.length + 1), 0, solvedRequests.length + 1, [
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)(),
        0
    ]);
    (0, $e5d9070e144b905e$export$9a2c8f31e984c6d5)((tupledArg)=>tupledArg[0].Start, solvedRequests, {
        Compare: (0, $kRS0m.comparePrimitives)
    });
    for(let i = solvedRequests.length - 1; i >= 0; i--){
        const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i, solvedRequests);
        const solution = patternInput[1];
        const request_1 = patternInput[0];
        let j = i + 1;
        while(j < solvedRequests.length && request_1.Stop >= (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(j, solvedRequests)[0].Start)j = j + 1 | 0;
        const patternInput_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(j, bestDownTo);
        const value = solution.result - request_1.FertilizerCost + patternInput_1[1];
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(bestDownTo, i, (0, $3699f71d1df66484$export$1f1fcf30eadb9697)((tuple)=>tuple[1], (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i + 1, bestDownTo), [
            (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                request_1,
                solution
            ], patternInput_1[0]),
            value
        ]));
    }
    return (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, bestDownTo);
}
function $6f1b0d5bd41c85b6$var$sortAndPartitionVariables(vars, request, solution) {
    return (0, $e5d9070e144b905e$export$b29f828819edca8d)((arg_1)=>{
        const _arg = arg_1[1][0];
        switch(_arg.tag){
            case 5:
            case 6:
            case 7:
                return true;
            default:
                return false;
        }
    }, (0, $e5d9070e144b905e$export$b035e44d7bb4278f)((tuple)=>tuple[0], (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>{
        const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(tupledArg[0], request.Variables);
        const variable = patternInput[1];
        return (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg_1)=>[
                [
                    patternInput[0],
                    tupledArg_1[1],
                    (0, $a117bb35793377d5$export$3302572d20aa94ca)(vars, request.Fertilizer, tupledArg_1[0])
                ],
                [
                    variable,
                    tupledArg[1] >>> 0
                ]
            ], variable.tag === 0 ? undefined : variable.tag === 2 ? [
            variable.fields[0],
            0
        ] : variable.tag === 3 ? [
            variable.fields[0],
            1
        ] : variable.tag === 4 ? [
            variable.fields[0],
            2
        ] : variable.tag === 5 ? [
            new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                variable.fields[0]
            ]),
            3
        ] : variable.tag === 6 ? [
            new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                variable.fields[0]
            ]),
            3
        ] : variable.tag === 7 ? [
            new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                variable.fields[0]
            ]),
            4
        ] : undefined);
    }, solution.variables), {
        Compare: (0, $kRS0m.compareArrays)
    }));
}
function $6f1b0d5bd41c85b6$var$toDateSpans(vars, solvedRequests, totalValue) {
    const seasons = (0, $e189d4fb2d038fab$export$641f31a913d47020)(vars.StartDate.Season, vars.EndDate.Season);
    return [
        totalValue,
        Array.from((0, $42cbcefff7323768$export$871de8747c9eaa88)((tupledArg)=>{
            const request = tupledArg[0];
            const patternInput = $6f1b0d5bd41c85b6$var$sortAndPartitionVariables(vars, request, tupledArg[1]);
            const regrowVariables = patternInput[0];
            let regrowCrop;
            let matchResult, crop, harvests, n, season, crop_1, crop2, harvests_1, harvests2, n_1, season_1, season2, regrowVariables_1;
            if (!(0, $e5d9070e144b905e$export$9d4fa3538bf09487)((0, $kRS0m.equalArrays), regrowVariables, (0, $kRS0m.defaultOf)()) && regrowVariables.length === 1) {
                if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].tag === 5) {
                    matchResult = 0;
                    crop = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[0];
                    harvests = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[1];
                    n = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][1];
                    season = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[0][0];
                } else if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].tag === 6) {
                    matchResult = 0;
                    crop = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[0];
                    harvests = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[1];
                    n = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][1];
                    season = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[0][0];
                } else {
                    matchResult = 2;
                    regrowVariables_1 = regrowVariables;
                }
            } else if (!(0, $e5d9070e144b905e$export$9d4fa3538bf09487)((0, $kRS0m.equalArrays), regrowVariables, (0, $kRS0m.defaultOf)()) && regrowVariables.length === 2) {
                if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].tag === 6) {
                    if ((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, regrowVariables)[1][0].tag === 7) {
                        matchResult = 1;
                        crop_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[0];
                        crop2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, regrowVariables)[1][0].fields[0];
                        harvests_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][0].fields[1];
                        harvests2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, regrowVariables)[1][1];
                        n_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[1][1];
                        season_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, regrowVariables)[0][0];
                        season2 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(1, regrowVariables)[0][0];
                    } else {
                        matchResult = 2;
                        regrowVariables_1 = regrowVariables;
                    }
                } else {
                    matchResult = 2;
                    regrowVariables_1 = regrowVariables;
                }
            } else {
                matchResult = 2;
                regrowVariables_1 = regrowVariables;
            }
            switch(matchResult){
                case 0:
                    regrowCrop = [
                        season - request.Start,
                        crop,
                        harvests
                    ];
                    break;
                case 1:
                    regrowCrop = [
                        season_1 - request.Start,
                        crop_1,
                        harvests_1 + harvests2
                    ];
                    break;
                default:
                    regrowCrop = undefined;
            }
            const cropHarvests = (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((arg)=>{
                const _arg = arg[1];
                switch(_arg[0].tag){
                    case 2:
                        return [
                            _arg[0].fields[0],
                            _arg[1],
                            false
                        ];
                    case 3:
                        return [
                            _arg[0].fields[0],
                            1,
                            true
                        ];
                    case 4:
                        return [
                            _arg[0].fields[0],
                            1,
                            false
                        ];
                    default:
                        return undefined;
                }
            }, patternInput[1]);
            const patternInput_1 = (0, $kRS0m.equals)(vars.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? [
                new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(request.Start, seasons), request.Start === 0 ? vars.StartDate.Day : 1),
                new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(request.Stop, seasons), request.Stop === seasons.length - 1 ? vars.EndDate.Day : 28)
            ] : [
                vars.StartDate,
                vars.EndDate
            ];
            return new $6f1b0d5bd41c85b6$export$b88652776e9771a9(patternInput_1[0], patternInput_1[1], request.Fertilizer, cropHarvests, regrowCrop);
        }, solvedRequests))
    ];
}
var $8f7adc3f3e80f290$exports = {};
var $a1cc1e96390b35a0$exports = {};
"use strict";
$a1cc1e96390b35a0$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $8f7adc3f3e80f290$var$url = new URL(import.meta.resolve("eAskX"));
$8f7adc3f3e80f290$exports = $a1cc1e96390b35a0$exports($8f7adc3f3e80f290$var$url.toString(), $8f7adc3f3e80f290$var$url.origin, true);


function $6f1b0d5bd41c85b6$export$208cffe87ba62b51() {
    const worker = new Worker($8f7adc3f3e80f290$exports);
    let inProgressRequest = undefined;
    let nextRequest = undefined;
    const postWorker = (data, settings, objective)=>{
        const patternInput = (0, $e5d9070e144b905e$export$23c8d3f8757cab88)($6f1b0d5bd41c85b6$var$createRequests(data, settings, objective));
        inProgressRequest = [
            settings,
            patternInput[0]
        ];
        worker.postMessage(patternInput[1]);
    };
    return [
        (data_1)=>(settings_1)=>(objective_1)=>{
                    if (inProgressRequest == null) postWorker(data_1, settings_1, objective_1);
                    else nextRequest = [
                        data_1,
                        settings_1,
                        objective_1
                    ];
                },
        (dispatch)=>{
            worker.onmessage = (e)=>{
                let tupledArg_1, array_1;
                const matchValue = e.data;
                const inProgressRequest_1 = inProgressRequest;
                let matchResult, requests_1, settings_2, solutions;
                if ((0, $kRS0m.isArrayLike)(matchValue)) {
                    if (inProgressRequest_1 != null) {
                        matchResult = 0;
                        requests_1 = inProgressRequest_1[1];
                        settings_2 = inProgressRequest_1[0];
                        solutions = matchValue;
                    } else matchResult = 1;
                } else matchResult = 1;
                switch(matchResult){
                    case 0:
                        if (nextRequest == null) {
                            inProgressRequest = undefined;
                            dispatch((tupledArg_1 = $6f1b0d5bd41c85b6$var$weightedIntervalSchedule((array_1 = (0, $e5d9070e144b905e$export$8901015135f2fb22)(requests_1, solutions), array_1.filter((tupledArg)=>{
                                return tupledArg[1].status === "optimal";
                            }))), $6f1b0d5bd41c85b6$var$toDateSpans(settings_2.Game, tupledArg_1[0], tupledArg_1[1])));
                        } else {
                            const settings_3 = nextRequest[1];
                            const objective_2 = nextRequest[2];
                            const data_2 = nextRequest[0];
                            nextRequest = undefined;
                            postWorker(data_2, settings_3, objective_2);
                        }
                        break;
                    case 1:
                        break;
                }
            };
        }
    ];
}








var $eATN7 = parcelRequire("eATN7");





const $cd83631caaaa9fc0$var$Values_root = document.documentElement;
function $cd83631caaaa9fc0$var$Values_setVar(name, value) {
    return $cd83631caaaa9fc0$var$Values_root.style.setProperty(`--${name}`, value);
}
function $cd83631caaaa9fc0$var$Values_setPx(name, px) {
    return $cd83631caaaa9fc0$var$Values_setVar(name, `${Math.ceil(px)}px`);
}
const $cd83631caaaa9fc0$export$72958e90e02c3f99 = (()=>{
    const fontSize = window.getComputedStyle($cd83631caaaa9fc0$var$Values_root).getPropertyValue("font-size");
    const value_1 = (0, $5ce0fb420d4fadad$export$98e6a39c04603d36)((0, $7802b3aa01031554$export$662d3818631fba36)(fontSize, 0, fontSize.length - 2));
    return Math.ceil(value_1);
})();
$cd83631caaaa9fc0$var$Values_setPx("border-thin", (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1, $cd83631caaaa9fc0$export$72958e90e02c3f99 / 8));
$cd83631caaaa9fc0$var$Values_setPx("border-med", (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1.5, $cd83631caaaa9fc0$export$72958e90e02c3f99 / 6));




var $cc1z1 = parcelRequire("cc1z1");

var $cc1z1 = parcelRequire("cc1z1");
var $94f228f85e408a75$exports = {};
var $7b5e66b57ad8b66a$exports = {};
var $0b52bdb923279556$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $0b52bdb923279556$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$0b52bdb923279556$exports = $0b52bdb923279556$var$arrayPush;


var $e946206968c2c4f9$exports = {};
var $24222c5e026539d1$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Built-in value references. */ var $24222c5e026539d1$var$Symbol = $joIhc.Symbol;
$24222c5e026539d1$exports = $24222c5e026539d1$var$Symbol;


var $28c4d821de31f25d$exports = {};
var $c455b6f9d32b6617$exports = {};
var $a417b04763129f1c$exports = {};

var $d5a2c4cb9feb0d76$exports = {};

/** Used for built-in method references. */ var $d5a2c4cb9feb0d76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5a2c4cb9feb0d76$var$hasOwnProperty = $d5a2c4cb9feb0d76$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5a2c4cb9feb0d76$var$nativeObjectToString = $d5a2c4cb9feb0d76$var$objectProto.toString;
/** Built-in value references. */ var $d5a2c4cb9feb0d76$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d5a2c4cb9feb0d76$var$getRawTag(value) {
    var isOwn = $d5a2c4cb9feb0d76$var$hasOwnProperty.call(value, $d5a2c4cb9feb0d76$var$symToStringTag), tag = value[$d5a2c4cb9feb0d76$var$symToStringTag];
    try {
        value[$d5a2c4cb9feb0d76$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d5a2c4cb9feb0d76$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d5a2c4cb9feb0d76$var$symToStringTag] = tag;
        else delete value[$d5a2c4cb9feb0d76$var$symToStringTag];
    }
    return result;
}
$d5a2c4cb9feb0d76$exports = $d5a2c4cb9feb0d76$var$getRawTag;


var $b787ae3208ebc449$exports = {};
/** Used for built-in method references. */ var $b787ae3208ebc449$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b787ae3208ebc449$var$nativeObjectToString = $b787ae3208ebc449$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b787ae3208ebc449$var$objectToString(value) {
    return $b787ae3208ebc449$var$nativeObjectToString.call(value);
}
$b787ae3208ebc449$exports = $b787ae3208ebc449$var$objectToString;


/** `Object#toString` result references. */ var $a417b04763129f1c$var$nullTag = '[object Null]', $a417b04763129f1c$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a417b04763129f1c$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a417b04763129f1c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a417b04763129f1c$var$undefinedTag : $a417b04763129f1c$var$nullTag;
    return $a417b04763129f1c$var$symToStringTag && $a417b04763129f1c$var$symToStringTag in Object(value) ? $d5a2c4cb9feb0d76$exports(value) : $b787ae3208ebc449$exports(value);
}
$a417b04763129f1c$exports = $a417b04763129f1c$var$baseGetTag;


var $34a8c8cbd9ebf965$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $34a8c8cbd9ebf965$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$34a8c8cbd9ebf965$exports = $34a8c8cbd9ebf965$var$isObjectLike;


/** `Object#toString` result references. */ var $c455b6f9d32b6617$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c455b6f9d32b6617$var$baseIsArguments(value) {
    return $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $c455b6f9d32b6617$var$argsTag;
}
$c455b6f9d32b6617$exports = $c455b6f9d32b6617$var$baseIsArguments;



/** Used for built-in method references. */ var $28c4d821de31f25d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28c4d821de31f25d$var$hasOwnProperty = $28c4d821de31f25d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $28c4d821de31f25d$var$propertyIsEnumerable = $28c4d821de31f25d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $28c4d821de31f25d$var$isArguments = $c455b6f9d32b6617$exports(function() {
    return arguments;
}()) ? $c455b6f9d32b6617$exports : function(value) {
    return $34a8c8cbd9ebf965$exports(value) && $28c4d821de31f25d$var$hasOwnProperty.call(value, 'callee') && !$28c4d821de31f25d$var$propertyIsEnumerable.call(value, 'callee');
};
$28c4d821de31f25d$exports = $28c4d821de31f25d$var$isArguments;


var $0222e83d73c8b1f6$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0222e83d73c8b1f6$var$isArray = Array.isArray;
$0222e83d73c8b1f6$exports = $0222e83d73c8b1f6$var$isArray;


/** Built-in value references. */ var $e946206968c2c4f9$var$spreadableSymbol = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $e946206968c2c4f9$var$isFlattenable(value) {
    return $0222e83d73c8b1f6$exports(value) || $28c4d821de31f25d$exports(value) || !!($e946206968c2c4f9$var$spreadableSymbol && value && value[$e946206968c2c4f9$var$spreadableSymbol]);
}
$e946206968c2c4f9$exports = $e946206968c2c4f9$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7b5e66b57ad8b66a$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e946206968c2c4f9$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7b5e66b57ad8b66a$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $0b52bdb923279556$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$7b5e66b57ad8b66a$exports = $7b5e66b57ad8b66a$var$baseFlatten;


var $7dc34658fd9f8c45$exports = {};
var $6eb862b6f66dbf42$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6eb862b6f66dbf42$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$6eb862b6f66dbf42$exports = $6eb862b6f66dbf42$var$arrayMap;


var $627f7decb2c89946$exports = {};
var $de95a2d03308b340$exports = {};

var $d81f6afb793ec153$exports = {};

var $8b4462bc4faef8d5$exports = {};


/** `Object#toString` result references. */ var $8b4462bc4faef8d5$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8b4462bc4faef8d5$var$isSymbol(value) {
    return typeof value == 'symbol' || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $8b4462bc4faef8d5$var$symbolTag;
}
$8b4462bc4faef8d5$exports = $8b4462bc4faef8d5$var$isSymbol;


/** Used to match property names within property paths. */ var $d81f6afb793ec153$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $d81f6afb793ec153$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $d81f6afb793ec153$var$isKey(value, object) {
    if ($0222e83d73c8b1f6$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $8b4462bc4faef8d5$exports(value)) return true;
    return $d81f6afb793ec153$var$reIsPlainProp.test(value) || !$d81f6afb793ec153$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$d81f6afb793ec153$exports = $d81f6afb793ec153$var$isKey;


var $b06c2db4dc620790$exports = {};
var $da9969427fae598e$exports = {};
var $355f086439b65efb$exports = {};
var $7114986f3690d6bb$exports = {};
var $7edea9b855d2efe7$exports = {};
var $843ce0a50c0e8fd0$exports = {};
var $a3feb77dfaa74a8a$exports = {};
var $01a4bcb576291393$exports = {};
var $99c4ba84188f46b8$exports = {};
var $85cf571eb43ec6f7$exports = {};
var $3a2d755df4c00d46$exports = {};

var $1f672fed7efed57e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1f672fed7efed57e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$1f672fed7efed57e$exports = $1f672fed7efed57e$var$isObject;


/** `Object#toString` result references. */ var $3a2d755df4c00d46$var$asyncTag = '[object AsyncFunction]', $3a2d755df4c00d46$var$funcTag = '[object Function]', $3a2d755df4c00d46$var$genTag = '[object GeneratorFunction]', $3a2d755df4c00d46$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3a2d755df4c00d46$var$isFunction(value) {
    if (!$1f672fed7efed57e$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a417b04763129f1c$exports(value);
    return tag == $3a2d755df4c00d46$var$funcTag || tag == $3a2d755df4c00d46$var$genTag || tag == $3a2d755df4c00d46$var$asyncTag || tag == $3a2d755df4c00d46$var$proxyTag;
}
$3a2d755df4c00d46$exports = $3a2d755df4c00d46$var$isFunction;


var $5f7294f63a4d6e50$exports = {};
var $14e0ce709c02a3ed$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Used to detect overreaching core-js shims. */ var $14e0ce709c02a3ed$var$coreJsData = $joIhc["__core-js_shared__"];
$14e0ce709c02a3ed$exports = $14e0ce709c02a3ed$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5f7294f63a4d6e50$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($14e0ce709c02a3ed$exports && $14e0ce709c02a3ed$exports.keys && $14e0ce709c02a3ed$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5f7294f63a4d6e50$var$isMasked(func) {
    return !!$5f7294f63a4d6e50$var$maskSrcKey && $5f7294f63a4d6e50$var$maskSrcKey in func;
}
$5f7294f63a4d6e50$exports = $5f7294f63a4d6e50$var$isMasked;



var $0e86857f8765348f$exports = {};
/** Used for built-in method references. */ var $0e86857f8765348f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0e86857f8765348f$var$funcToString = $0e86857f8765348f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0e86857f8765348f$var$toSource(func) {
    if (func != null) {
        try {
            return $0e86857f8765348f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$0e86857f8765348f$exports = $0e86857f8765348f$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $85cf571eb43ec6f7$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $85cf571eb43ec6f7$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $85cf571eb43ec6f7$var$funcProto = Function.prototype, $85cf571eb43ec6f7$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $85cf571eb43ec6f7$var$funcToString = $85cf571eb43ec6f7$var$funcProto.toString;
/** Used to check objects for own properties. */ var $85cf571eb43ec6f7$var$hasOwnProperty = $85cf571eb43ec6f7$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $85cf571eb43ec6f7$var$reIsNative = RegExp('^' + $85cf571eb43ec6f7$var$funcToString.call($85cf571eb43ec6f7$var$hasOwnProperty).replace($85cf571eb43ec6f7$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $85cf571eb43ec6f7$var$baseIsNative(value) {
    if (!$1f672fed7efed57e$exports(value) || $5f7294f63a4d6e50$exports(value)) return false;
    var pattern = $3a2d755df4c00d46$exports(value) ? $85cf571eb43ec6f7$var$reIsNative : $85cf571eb43ec6f7$var$reIsHostCtor;
    return pattern.test($0e86857f8765348f$exports(value));
}
$85cf571eb43ec6f7$exports = $85cf571eb43ec6f7$var$baseIsNative;


var $970b8c440941f295$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $970b8c440941f295$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$970b8c440941f295$exports = $970b8c440941f295$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $99c4ba84188f46b8$var$getNative(object, key) {
    var value = $970b8c440941f295$exports(object, key);
    return $85cf571eb43ec6f7$exports(value) ? value : undefined;
}
$99c4ba84188f46b8$exports = $99c4ba84188f46b8$var$getNative;


/* Built-in method references that are verified to be native. */ var $01a4bcb576291393$var$nativeCreate = $99c4ba84188f46b8$exports(Object, 'create');
$01a4bcb576291393$exports = $01a4bcb576291393$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a3feb77dfaa74a8a$var$hashClear() {
    this.__data__ = $01a4bcb576291393$exports ? $01a4bcb576291393$exports(null) : {};
    this.size = 0;
}
$a3feb77dfaa74a8a$exports = $a3feb77dfaa74a8a$var$hashClear;


var $6bf6c867325d7420$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6bf6c867325d7420$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$6bf6c867325d7420$exports = $6bf6c867325d7420$var$hashDelete;


var $87b2b5ae8f2da186$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $87b2b5ae8f2da186$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $87b2b5ae8f2da186$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $87b2b5ae8f2da186$var$hasOwnProperty = $87b2b5ae8f2da186$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $87b2b5ae8f2da186$var$hashGet(key) {
    var data = this.__data__;
    if ($01a4bcb576291393$exports) {
        var result = data[key];
        return result === $87b2b5ae8f2da186$var$HASH_UNDEFINED ? undefined : result;
    }
    return $87b2b5ae8f2da186$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$87b2b5ae8f2da186$exports = $87b2b5ae8f2da186$var$hashGet;


var $efadf49f440438ed$exports = {};

/** Used for built-in method references. */ var $efadf49f440438ed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efadf49f440438ed$var$hasOwnProperty = $efadf49f440438ed$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $efadf49f440438ed$var$hashHas(key) {
    var data = this.__data__;
    return $01a4bcb576291393$exports ? data[key] !== undefined : $efadf49f440438ed$var$hasOwnProperty.call(data, key);
}
$efadf49f440438ed$exports = $efadf49f440438ed$var$hashHas;


var $431f2524acae7bda$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $431f2524acae7bda$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $431f2524acae7bda$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $01a4bcb576291393$exports && value === undefined ? $431f2524acae7bda$var$HASH_UNDEFINED : value;
    return this;
}
$431f2524acae7bda$exports = $431f2524acae7bda$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $843ce0a50c0e8fd0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$843ce0a50c0e8fd0$var$Hash.prototype.clear = $a3feb77dfaa74a8a$exports;
$843ce0a50c0e8fd0$var$Hash.prototype['delete'] = $6bf6c867325d7420$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.get = $87b2b5ae8f2da186$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.has = $efadf49f440438ed$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.set = $431f2524acae7bda$exports;
$843ce0a50c0e8fd0$exports = $843ce0a50c0e8fd0$var$Hash;


var $863fe6bcb1ee042f$exports = {};
var $3a0e7e6cef79d3f0$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3a0e7e6cef79d3f0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$3a0e7e6cef79d3f0$exports = $3a0e7e6cef79d3f0$var$listCacheClear;


var $be26bc847aadb2cf$exports = {};
var $dc88429c65a02b1f$exports = {};
var $4848ae3ccf4ff248$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4848ae3ccf4ff248$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$4848ae3ccf4ff248$exports = $4848ae3ccf4ff248$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $dc88429c65a02b1f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4848ae3ccf4ff248$exports(array[length][0], key)) return length;
    }
    return -1;
}
$dc88429c65a02b1f$exports = $dc88429c65a02b1f$var$assocIndexOf;


/** Used for built-in method references. */ var $be26bc847aadb2cf$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $be26bc847aadb2cf$var$splice = $be26bc847aadb2cf$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $be26bc847aadb2cf$var$listCacheDelete(key) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $be26bc847aadb2cf$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$be26bc847aadb2cf$exports = $be26bc847aadb2cf$var$listCacheDelete;


var $3f6c7c4e089edd0c$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f6c7c4e089edd0c$var$listCacheGet(key) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$3f6c7c4e089edd0c$exports = $3f6c7c4e089edd0c$var$listCacheGet;


var $d39a303519dea499$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d39a303519dea499$var$listCacheHas(key) {
    return $dc88429c65a02b1f$exports(this.__data__, key) > -1;
}
$d39a303519dea499$exports = $d39a303519dea499$var$listCacheHas;


var $b344e70b52862e5a$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b344e70b52862e5a$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b344e70b52862e5a$exports = $b344e70b52862e5a$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $863fe6bcb1ee042f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$863fe6bcb1ee042f$var$ListCache.prototype.clear = $3a0e7e6cef79d3f0$exports;
$863fe6bcb1ee042f$var$ListCache.prototype['delete'] = $be26bc847aadb2cf$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.get = $3f6c7c4e089edd0c$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.has = $d39a303519dea499$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.set = $b344e70b52862e5a$exports;
$863fe6bcb1ee042f$exports = $863fe6bcb1ee042f$var$ListCache;


var $9080706ebb9e67eb$exports = {};


var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $9080706ebb9e67eb$var$Map = $99c4ba84188f46b8$exports($joIhc, 'Map');
$9080706ebb9e67eb$exports = $9080706ebb9e67eb$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7edea9b855d2efe7$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $843ce0a50c0e8fd0$exports,
        'map': new ($9080706ebb9e67eb$exports || $863fe6bcb1ee042f$exports),
        'string': new $843ce0a50c0e8fd0$exports
    };
}
$7edea9b855d2efe7$exports = $7edea9b855d2efe7$var$mapCacheClear;


var $1c9b7ae2be76128b$exports = {};
var $e392cb91d1ada0e9$exports = {};
var $b4fa6cbc0b7701cd$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b4fa6cbc0b7701cd$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$b4fa6cbc0b7701cd$exports = $b4fa6cbc0b7701cd$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e392cb91d1ada0e9$var$getMapData(map, key) {
    var data = map.__data__;
    return $b4fa6cbc0b7701cd$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$e392cb91d1ada0e9$exports = $e392cb91d1ada0e9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1c9b7ae2be76128b$var$mapCacheDelete(key) {
    var result = $e392cb91d1ada0e9$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$1c9b7ae2be76128b$exports = $1c9b7ae2be76128b$var$mapCacheDelete;


var $5f90de34d8245763$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5f90de34d8245763$var$mapCacheGet(key) {
    return $e392cb91d1ada0e9$exports(this, key).get(key);
}
$5f90de34d8245763$exports = $5f90de34d8245763$var$mapCacheGet;


var $c3da1b384e2765d1$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c3da1b384e2765d1$var$mapCacheHas(key) {
    return $e392cb91d1ada0e9$exports(this, key).has(key);
}
$c3da1b384e2765d1$exports = $c3da1b384e2765d1$var$mapCacheHas;


var $ca7cee5355763bc3$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ca7cee5355763bc3$var$mapCacheSet(key, value) {
    var data = $e392cb91d1ada0e9$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$ca7cee5355763bc3$exports = $ca7cee5355763bc3$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7114986f3690d6bb$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7114986f3690d6bb$var$MapCache.prototype.clear = $7edea9b855d2efe7$exports;
$7114986f3690d6bb$var$MapCache.prototype['delete'] = $1c9b7ae2be76128b$exports;
$7114986f3690d6bb$var$MapCache.prototype.get = $5f90de34d8245763$exports;
$7114986f3690d6bb$var$MapCache.prototype.has = $c3da1b384e2765d1$exports;
$7114986f3690d6bb$var$MapCache.prototype.set = $ca7cee5355763bc3$exports;
$7114986f3690d6bb$exports = $7114986f3690d6bb$var$MapCache;


/** Error message constants. */ var $355f086439b65efb$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $355f086439b65efb$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($355f086439b65efb$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($355f086439b65efb$var$memoize.Cache || $7114986f3690d6bb$exports);
    return memoized;
}
// Expose `MapCache`.
$355f086439b65efb$var$memoize.Cache = $7114986f3690d6bb$exports;
$355f086439b65efb$exports = $355f086439b65efb$var$memoize;


/** Used as the maximum memoize cache size. */ var $da9969427fae598e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $da9969427fae598e$var$memoizeCapped(func) {
    var result = $355f086439b65efb$exports(func, function(key) {
        if (cache.size === $da9969427fae598e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$da9969427fae598e$exports = $da9969427fae598e$var$memoizeCapped;


/** Used to match property names within property paths. */ var $b06c2db4dc620790$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $b06c2db4dc620790$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $b06c2db4dc620790$var$stringToPath = $da9969427fae598e$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($b06c2db4dc620790$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($b06c2db4dc620790$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$b06c2db4dc620790$exports = $b06c2db4dc620790$var$stringToPath;


var $405e052344f77616$exports = {};
var $8770ec71dd25836e$exports = {};




/** Used as references for various `Number` constants. */ var $8770ec71dd25836e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $8770ec71dd25836e$var$symbolProto = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.prototype : undefined, $8770ec71dd25836e$var$symbolToString = $8770ec71dd25836e$var$symbolProto ? $8770ec71dd25836e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $8770ec71dd25836e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0222e83d73c8b1f6$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $6eb862b6f66dbf42$exports(value, $8770ec71dd25836e$var$baseToString) + '';
    if ($8b4462bc4faef8d5$exports(value)) return $8770ec71dd25836e$var$symbolToString ? $8770ec71dd25836e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$8770ec71dd25836e$var$INFINITY ? '-0' : result;
}
$8770ec71dd25836e$exports = $8770ec71dd25836e$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $405e052344f77616$var$toString(value) {
    return value == null ? '' : $8770ec71dd25836e$exports(value);
}
$405e052344f77616$exports = $405e052344f77616$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $de95a2d03308b340$var$castPath(value, object) {
    if ($0222e83d73c8b1f6$exports(value)) return value;
    return $d81f6afb793ec153$exports(value, object) ? [
        value
    ] : $b06c2db4dc620790$exports($405e052344f77616$exports(value));
}
$de95a2d03308b340$exports = $de95a2d03308b340$var$castPath;


var $501a45c3a7be0368$exports = {};

/** Used as references for various `Number` constants. */ var $501a45c3a7be0368$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $501a45c3a7be0368$var$toKey(value) {
    if (typeof value == 'string' || $8b4462bc4faef8d5$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$501a45c3a7be0368$var$INFINITY ? '-0' : result;
}
$501a45c3a7be0368$exports = $501a45c3a7be0368$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $627f7decb2c89946$var$baseGet(object, path) {
    path = $de95a2d03308b340$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$501a45c3a7be0368$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$627f7decb2c89946$exports = $627f7decb2c89946$var$baseGet;


var $a582a3ff9e0dc197$exports = {};
var $9feb3d4af5f6d622$exports = {};
var $75d011bfa214e1ee$exports = {};
var $d5e92bedd2d5ea11$exports = {};

var $98d32cbeed0a0919$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $98d32cbeed0a0919$var$stackClear() {
    this.__data__ = new $863fe6bcb1ee042f$exports;
    this.size = 0;
}
$98d32cbeed0a0919$exports = $98d32cbeed0a0919$var$stackClear;


var $b8d37ca77ce9a621$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b8d37ca77ce9a621$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$b8d37ca77ce9a621$exports = $b8d37ca77ce9a621$var$stackDelete;


var $d4417027767ba1dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d4417027767ba1dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$d4417027767ba1dc$exports = $d4417027767ba1dc$var$stackGet;


var $d5ed6eb79d8c7308$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d5ed6eb79d8c7308$var$stackHas(key) {
    return this.__data__.has(key);
}
$d5ed6eb79d8c7308$exports = $d5ed6eb79d8c7308$var$stackHas;


var $bdf776931c133b95$exports = {};



/** Used as the size to enable large array optimizations. */ var $bdf776931c133b95$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $bdf776931c133b95$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $863fe6bcb1ee042f$exports) {
        var pairs = data.__data__;
        if (!$9080706ebb9e67eb$exports || pairs.length < $bdf776931c133b95$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $7114986f3690d6bb$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$bdf776931c133b95$exports = $bdf776931c133b95$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d5e92bedd2d5ea11$var$Stack(entries) {
    var data = this.__data__ = new $863fe6bcb1ee042f$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d5e92bedd2d5ea11$var$Stack.prototype.clear = $98d32cbeed0a0919$exports;
$d5e92bedd2d5ea11$var$Stack.prototype['delete'] = $b8d37ca77ce9a621$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.get = $d4417027767ba1dc$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.has = $d5ed6eb79d8c7308$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.set = $bdf776931c133b95$exports;
$d5e92bedd2d5ea11$exports = $d5e92bedd2d5ea11$var$Stack;


var $2f3c512db6089049$exports = {};
var $28c7855f701c181d$exports = {};

var $3458ba824fc19b82$exports = {};
var $cd6ee8e094d9e61f$exports = {};

var $bf9c8dd0891f8f36$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $bf9c8dd0891f8f36$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $bf9c8dd0891f8f36$var$setCacheAdd(value) {
    this.__data__.set(value, $bf9c8dd0891f8f36$var$HASH_UNDEFINED);
    return this;
}
$bf9c8dd0891f8f36$exports = $bf9c8dd0891f8f36$var$setCacheAdd;


var $62099ef7d114057c$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $62099ef7d114057c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$62099ef7d114057c$exports = $62099ef7d114057c$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cd6ee8e094d9e61f$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $7114986f3690d6bb$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cd6ee8e094d9e61f$var$SetCache.prototype.add = $cd6ee8e094d9e61f$var$SetCache.prototype.push = $bf9c8dd0891f8f36$exports;
$cd6ee8e094d9e61f$var$SetCache.prototype.has = $62099ef7d114057c$exports;
$cd6ee8e094d9e61f$exports = $cd6ee8e094d9e61f$var$SetCache;


var $7d370f035a2f41ae$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7d370f035a2f41ae$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$7d370f035a2f41ae$exports = $7d370f035a2f41ae$var$arraySome;


var $c699d87c7e600909$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c699d87c7e600909$var$cacheHas(cache, key) {
    return cache.has(key);
}
$c699d87c7e600909$exports = $c699d87c7e600909$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $3458ba824fc19b82$var$COMPARE_PARTIAL_FLAG = 1, $3458ba824fc19b82$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3458ba824fc19b82$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3458ba824fc19b82$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3458ba824fc19b82$var$COMPARE_UNORDERED_FLAG ? new $cd6ee8e094d9e61f$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$7d370f035a2f41ae$exports(other, function(othValue, othIndex) {
                if (!$c699d87c7e600909$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$3458ba824fc19b82$exports = $3458ba824fc19b82$var$equalArrays;


var $f4730f3956ea6c19$exports = {};

var $86c3dc68dadedaa9$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Built-in value references. */ var $86c3dc68dadedaa9$var$Uint8Array = $joIhc.Uint8Array;
$86c3dc68dadedaa9$exports = $86c3dc68dadedaa9$var$Uint8Array;




var $70c3ee0ebaf1e74f$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $70c3ee0ebaf1e74f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$70c3ee0ebaf1e74f$exports = $70c3ee0ebaf1e74f$var$mapToArray;


var $f806c2008611bc31$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $f806c2008611bc31$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$f806c2008611bc31$exports = $f806c2008611bc31$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $f4730f3956ea6c19$var$COMPARE_PARTIAL_FLAG = 1, $f4730f3956ea6c19$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $f4730f3956ea6c19$var$boolTag = '[object Boolean]', $f4730f3956ea6c19$var$dateTag = '[object Date]', $f4730f3956ea6c19$var$errorTag = '[object Error]', $f4730f3956ea6c19$var$mapTag = '[object Map]', $f4730f3956ea6c19$var$numberTag = '[object Number]', $f4730f3956ea6c19$var$regexpTag = '[object RegExp]', $f4730f3956ea6c19$var$setTag = '[object Set]', $f4730f3956ea6c19$var$stringTag = '[object String]', $f4730f3956ea6c19$var$symbolTag = '[object Symbol]';
var $f4730f3956ea6c19$var$arrayBufferTag = '[object ArrayBuffer]', $f4730f3956ea6c19$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $f4730f3956ea6c19$var$symbolProto = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.prototype : undefined, $f4730f3956ea6c19$var$symbolValueOf = $f4730f3956ea6c19$var$symbolProto ? $f4730f3956ea6c19$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f4730f3956ea6c19$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $f4730f3956ea6c19$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $f4730f3956ea6c19$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $86c3dc68dadedaa9$exports(object), new $86c3dc68dadedaa9$exports(other))) return false;
            return true;
        case $f4730f3956ea6c19$var$boolTag:
        case $f4730f3956ea6c19$var$dateTag:
        case $f4730f3956ea6c19$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $4848ae3ccf4ff248$exports(+object, +other);
        case $f4730f3956ea6c19$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $f4730f3956ea6c19$var$regexpTag:
        case $f4730f3956ea6c19$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $f4730f3956ea6c19$var$mapTag:
            var convert = $70c3ee0ebaf1e74f$exports;
        case $f4730f3956ea6c19$var$setTag:
            var isPartial = bitmask & $f4730f3956ea6c19$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $f806c2008611bc31$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $f4730f3956ea6c19$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $3458ba824fc19b82$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $f4730f3956ea6c19$var$symbolTag:
            if ($f4730f3956ea6c19$var$symbolValueOf) return $f4730f3956ea6c19$var$symbolValueOf.call(object) == $f4730f3956ea6c19$var$symbolValueOf.call(other);
    }
    return false;
}
$f4730f3956ea6c19$exports = $f4730f3956ea6c19$var$equalByTag;


var $a4bbafa8f5cc893b$exports = {};
var $79f1183b97c1983e$exports = {};
var $8ae32784d5206c16$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8ae32784d5206c16$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0222e83d73c8b1f6$exports(object) ? result : $0b52bdb923279556$exports(result, symbolsFunc(object));
}
$8ae32784d5206c16$exports = $8ae32784d5206c16$var$baseGetAllKeys;


var $7645ee0579cc4970$exports = {};
var $8ba05d4c32a9dcff$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $8ba05d4c32a9dcff$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$8ba05d4c32a9dcff$exports = $8ba05d4c32a9dcff$var$arrayFilter;


var $521fc14e88eda714$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $521fc14e88eda714$var$stubArray() {
    return [];
}
$521fc14e88eda714$exports = $521fc14e88eda714$var$stubArray;


/** Used for built-in method references. */ var $7645ee0579cc4970$var$objectProto = Object.prototype;
/** Built-in value references. */ var $7645ee0579cc4970$var$propertyIsEnumerable = $7645ee0579cc4970$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7645ee0579cc4970$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $7645ee0579cc4970$var$getSymbols = !$7645ee0579cc4970$var$nativeGetSymbols ? $521fc14e88eda714$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8ba05d4c32a9dcff$exports($7645ee0579cc4970$var$nativeGetSymbols(object), function(symbol) {
        return $7645ee0579cc4970$var$propertyIsEnumerable.call(object, symbol);
    });
};
$7645ee0579cc4970$exports = $7645ee0579cc4970$var$getSymbols;


var $31472ad28d4bee36$exports = {};
var $b1ae9769a1c9d88e$exports = {};
var $fbc6683ade31ba90$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $fbc6683ade31ba90$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$fbc6683ade31ba90$exports = $fbc6683ade31ba90$var$baseTimes;





var $6FHvm = parcelRequire("6FHvm");
var $1360731602f19189$exports = {};
/** Used as references for various `Number` constants. */ var $1360731602f19189$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1360731602f19189$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1360731602f19189$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1360731602f19189$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $1360731602f19189$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1360731602f19189$exports = $1360731602f19189$var$isIndex;


var $77d8992c4d6343fc$exports = {};
var $6cba791471d26f8f$exports = {};

var $9acf46d15a35c301$exports = {};
/** Used as references for various `Number` constants. */ var $9acf46d15a35c301$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9acf46d15a35c301$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $9acf46d15a35c301$var$MAX_SAFE_INTEGER;
}
$9acf46d15a35c301$exports = $9acf46d15a35c301$var$isLength;



/** `Object#toString` result references. */ var $6cba791471d26f8f$var$argsTag = '[object Arguments]', $6cba791471d26f8f$var$arrayTag = '[object Array]', $6cba791471d26f8f$var$boolTag = '[object Boolean]', $6cba791471d26f8f$var$dateTag = '[object Date]', $6cba791471d26f8f$var$errorTag = '[object Error]', $6cba791471d26f8f$var$funcTag = '[object Function]', $6cba791471d26f8f$var$mapTag = '[object Map]', $6cba791471d26f8f$var$numberTag = '[object Number]', $6cba791471d26f8f$var$objectTag = '[object Object]', $6cba791471d26f8f$var$regexpTag = '[object RegExp]', $6cba791471d26f8f$var$setTag = '[object Set]', $6cba791471d26f8f$var$stringTag = '[object String]', $6cba791471d26f8f$var$weakMapTag = '[object WeakMap]';
var $6cba791471d26f8f$var$arrayBufferTag = '[object ArrayBuffer]', $6cba791471d26f8f$var$dataViewTag = '[object DataView]', $6cba791471d26f8f$var$float32Tag = '[object Float32Array]', $6cba791471d26f8f$var$float64Tag = '[object Float64Array]', $6cba791471d26f8f$var$int8Tag = '[object Int8Array]', $6cba791471d26f8f$var$int16Tag = '[object Int16Array]', $6cba791471d26f8f$var$int32Tag = '[object Int32Array]', $6cba791471d26f8f$var$uint8Tag = '[object Uint8Array]', $6cba791471d26f8f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $6cba791471d26f8f$var$uint16Tag = '[object Uint16Array]', $6cba791471d26f8f$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $6cba791471d26f8f$var$typedArrayTags = {};
$6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$float32Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$float64Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int8Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int16Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int32Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint8Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint8ClampedTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint16Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint32Tag] = true;
$6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$argsTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$arrayTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$arrayBufferTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$boolTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$dataViewTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$dateTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$errorTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$funcTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$mapTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$numberTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$objectTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$regexpTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$setTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$stringTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6cba791471d26f8f$var$baseIsTypedArray(value) {
    return $34a8c8cbd9ebf965$exports(value) && $9acf46d15a35c301$exports(value.length) && !!$6cba791471d26f8f$var$typedArrayTags[$a417b04763129f1c$exports(value)];
}
$6cba791471d26f8f$exports = $6cba791471d26f8f$var$baseIsTypedArray;


var $10179b7ab4d6a4cf$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $10179b7ab4d6a4cf$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$10179b7ab4d6a4cf$exports = $10179b7ab4d6a4cf$var$baseUnary;



var $9f4Zz = parcelRequire("9f4Zz");
/* Node.js helper references. */ var $77d8992c4d6343fc$var$nodeIsTypedArray = $9f4Zz && $9f4Zz.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $77d8992c4d6343fc$var$isTypedArray = $77d8992c4d6343fc$var$nodeIsTypedArray ? $10179b7ab4d6a4cf$exports($77d8992c4d6343fc$var$nodeIsTypedArray) : $6cba791471d26f8f$exports;
$77d8992c4d6343fc$exports = $77d8992c4d6343fc$var$isTypedArray;


/** Used for built-in method references. */ var $b1ae9769a1c9d88e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b1ae9769a1c9d88e$var$hasOwnProperty = $b1ae9769a1c9d88e$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b1ae9769a1c9d88e$var$arrayLikeKeys(value, inherited) {
    var isArr = $0222e83d73c8b1f6$exports(value), isArg = !isArr && $28c4d821de31f25d$exports(value), isBuff = !isArr && !isArg && $6FHvm(value), isType = !isArr && !isArg && !isBuff && $77d8992c4d6343fc$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fbc6683ade31ba90$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b1ae9769a1c9d88e$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $1360731602f19189$exports(key, length)))) result.push(key);
    return result;
}
$b1ae9769a1c9d88e$exports = $b1ae9769a1c9d88e$var$arrayLikeKeys;


var $f94b53cf594c0ae5$exports = {};
var $48d2914fd2666d71$exports = {};
/** Used for built-in method references. */ var $48d2914fd2666d71$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $48d2914fd2666d71$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $48d2914fd2666d71$var$objectProto;
    return value === proto;
}
$48d2914fd2666d71$exports = $48d2914fd2666d71$var$isPrototype;


var $f7abc845405e5d1a$exports = {};
var $0085f28775c6c6c3$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0085f28775c6c6c3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$0085f28775c6c6c3$exports = $0085f28775c6c6c3$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $f7abc845405e5d1a$var$nativeKeys = $0085f28775c6c6c3$exports(Object.keys, Object);
$f7abc845405e5d1a$exports = $f7abc845405e5d1a$var$nativeKeys;


/** Used for built-in method references. */ var $f94b53cf594c0ae5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f94b53cf594c0ae5$var$hasOwnProperty = $f94b53cf594c0ae5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f94b53cf594c0ae5$var$baseKeys(object) {
    if (!$48d2914fd2666d71$exports(object)) return $f7abc845405e5d1a$exports(object);
    var result = [];
    for(var key in Object(object))if ($f94b53cf594c0ae5$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$f94b53cf594c0ae5$exports = $f94b53cf594c0ae5$var$baseKeys;


var $1dea69b96520dc48$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1dea69b96520dc48$var$isArrayLike(value) {
    return value != null && $9acf46d15a35c301$exports(value.length) && !$3a2d755df4c00d46$exports(value);
}
$1dea69b96520dc48$exports = $1dea69b96520dc48$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $31472ad28d4bee36$var$keys(object) {
    return $1dea69b96520dc48$exports(object) ? $b1ae9769a1c9d88e$exports(object) : $f94b53cf594c0ae5$exports(object);
}
$31472ad28d4bee36$exports = $31472ad28d4bee36$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $79f1183b97c1983e$var$getAllKeys(object) {
    return $8ae32784d5206c16$exports(object, $31472ad28d4bee36$exports, $7645ee0579cc4970$exports);
}
$79f1183b97c1983e$exports = $79f1183b97c1983e$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a4bbafa8f5cc893b$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a4bbafa8f5cc893b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a4bbafa8f5cc893b$var$hasOwnProperty = $a4bbafa8f5cc893b$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a4bbafa8f5cc893b$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a4bbafa8f5cc893b$var$COMPARE_PARTIAL_FLAG, objProps = $79f1183b97c1983e$exports(object), objLength = objProps.length, othProps = $79f1183b97c1983e$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a4bbafa8f5cc893b$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$a4bbafa8f5cc893b$exports = $a4bbafa8f5cc893b$var$equalObjects;


var $f4f4abd68d0a6fcc$exports = {};
var $0f0536569f54a24c$exports = {};


var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $0f0536569f54a24c$var$DataView = $99c4ba84188f46b8$exports($joIhc, 'DataView');
$0f0536569f54a24c$exports = $0f0536569f54a24c$var$DataView;



var $b3795086c1ed7bf3$exports = {};


var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $b3795086c1ed7bf3$var$Promise = $99c4ba84188f46b8$exports($joIhc, 'Promise');
$b3795086c1ed7bf3$exports = $b3795086c1ed7bf3$var$Promise;


var $5c6fefa8e3385cb2$exports = {};


var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $5c6fefa8e3385cb2$var$Set = $99c4ba84188f46b8$exports($joIhc, 'Set');
$5c6fefa8e3385cb2$exports = $5c6fefa8e3385cb2$var$Set;


var $9472a5c32922f0a8$exports = {};


var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $9472a5c32922f0a8$var$WeakMap = $99c4ba84188f46b8$exports($joIhc, 'WeakMap');
$9472a5c32922f0a8$exports = $9472a5c32922f0a8$var$WeakMap;




/** `Object#toString` result references. */ var $f4f4abd68d0a6fcc$var$mapTag = '[object Map]', $f4f4abd68d0a6fcc$var$objectTag = '[object Object]', $f4f4abd68d0a6fcc$var$promiseTag = '[object Promise]', $f4f4abd68d0a6fcc$var$setTag = '[object Set]', $f4f4abd68d0a6fcc$var$weakMapTag = '[object WeakMap]';
var $f4f4abd68d0a6fcc$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $f4f4abd68d0a6fcc$var$dataViewCtorString = $0e86857f8765348f$exports($0f0536569f54a24c$exports), $f4f4abd68d0a6fcc$var$mapCtorString = $0e86857f8765348f$exports($9080706ebb9e67eb$exports), $f4f4abd68d0a6fcc$var$promiseCtorString = $0e86857f8765348f$exports($b3795086c1ed7bf3$exports), $f4f4abd68d0a6fcc$var$setCtorString = $0e86857f8765348f$exports($5c6fefa8e3385cb2$exports), $f4f4abd68d0a6fcc$var$weakMapCtorString = $0e86857f8765348f$exports($9472a5c32922f0a8$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $f4f4abd68d0a6fcc$var$getTag = $a417b04763129f1c$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($0f0536569f54a24c$exports && $f4f4abd68d0a6fcc$var$getTag(new $0f0536569f54a24c$exports(new ArrayBuffer(1))) != $f4f4abd68d0a6fcc$var$dataViewTag || $9080706ebb9e67eb$exports && $f4f4abd68d0a6fcc$var$getTag(new $9080706ebb9e67eb$exports) != $f4f4abd68d0a6fcc$var$mapTag || $b3795086c1ed7bf3$exports && $f4f4abd68d0a6fcc$var$getTag($b3795086c1ed7bf3$exports.resolve()) != $f4f4abd68d0a6fcc$var$promiseTag || $5c6fefa8e3385cb2$exports && $f4f4abd68d0a6fcc$var$getTag(new $5c6fefa8e3385cb2$exports) != $f4f4abd68d0a6fcc$var$setTag || $9472a5c32922f0a8$exports && $f4f4abd68d0a6fcc$var$getTag(new $9472a5c32922f0a8$exports) != $f4f4abd68d0a6fcc$var$weakMapTag) $f4f4abd68d0a6fcc$var$getTag = function(value) {
    var result = $a417b04763129f1c$exports(value), Ctor = result == $f4f4abd68d0a6fcc$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $0e86857f8765348f$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $f4f4abd68d0a6fcc$var$dataViewCtorString:
            return $f4f4abd68d0a6fcc$var$dataViewTag;
        case $f4f4abd68d0a6fcc$var$mapCtorString:
            return $f4f4abd68d0a6fcc$var$mapTag;
        case $f4f4abd68d0a6fcc$var$promiseCtorString:
            return $f4f4abd68d0a6fcc$var$promiseTag;
        case $f4f4abd68d0a6fcc$var$setCtorString:
            return $f4f4abd68d0a6fcc$var$setTag;
        case $f4f4abd68d0a6fcc$var$weakMapCtorString:
            return $f4f4abd68d0a6fcc$var$weakMapTag;
    }
    return result;
};
$f4f4abd68d0a6fcc$exports = $f4f4abd68d0a6fcc$var$getTag;




var $6FHvm = parcelRequire("6FHvm");

/** Used to compose bitmasks for value comparisons. */ var $28c7855f701c181d$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $28c7855f701c181d$var$argsTag = '[object Arguments]', $28c7855f701c181d$var$arrayTag = '[object Array]', $28c7855f701c181d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $28c7855f701c181d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28c7855f701c181d$var$hasOwnProperty = $28c7855f701c181d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $28c7855f701c181d$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0222e83d73c8b1f6$exports(object), othIsArr = $0222e83d73c8b1f6$exports(other), objTag = objIsArr ? $28c7855f701c181d$var$arrayTag : $f4f4abd68d0a6fcc$exports(object), othTag = othIsArr ? $28c7855f701c181d$var$arrayTag : $f4f4abd68d0a6fcc$exports(other);
    objTag = objTag == $28c7855f701c181d$var$argsTag ? $28c7855f701c181d$var$objectTag : objTag;
    othTag = othTag == $28c7855f701c181d$var$argsTag ? $28c7855f701c181d$var$objectTag : othTag;
    var objIsObj = objTag == $28c7855f701c181d$var$objectTag, othIsObj = othTag == $28c7855f701c181d$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $6FHvm(object)) {
        if (!$6FHvm(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $d5e92bedd2d5ea11$exports);
        return objIsArr || $77d8992c4d6343fc$exports(object) ? $3458ba824fc19b82$exports(object, other, bitmask, customizer, equalFunc, stack) : $f4730f3956ea6c19$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $28c7855f701c181d$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $28c7855f701c181d$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $28c7855f701c181d$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $d5e92bedd2d5ea11$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $d5e92bedd2d5ea11$exports);
    return $a4bbafa8f5cc893b$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$28c7855f701c181d$exports = $28c7855f701c181d$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2f3c512db6089049$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$34a8c8cbd9ebf965$exports(value) && !$34a8c8cbd9ebf965$exports(other)) return value !== value && other !== other;
    return $28c7855f701c181d$exports(value, other, bitmask, customizer, $2f3c512db6089049$var$baseIsEqual, stack);
}
$2f3c512db6089049$exports = $2f3c512db6089049$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $75d011bfa214e1ee$var$COMPARE_PARTIAL_FLAG = 1, $75d011bfa214e1ee$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $75d011bfa214e1ee$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $d5e92bedd2d5ea11$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $2f3c512db6089049$exports(srcValue, objValue, $75d011bfa214e1ee$var$COMPARE_PARTIAL_FLAG | $75d011bfa214e1ee$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$75d011bfa214e1ee$exports = $75d011bfa214e1ee$var$baseIsMatch;


var $42776de1e00967f9$exports = {};
var $2b8623973cfc0cd6$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $2b8623973cfc0cd6$var$isStrictComparable(value) {
    return value === value && !$1f672fed7efed57e$exports(value);
}
$2b8623973cfc0cd6$exports = $2b8623973cfc0cd6$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $42776de1e00967f9$var$getMatchData(object) {
    var result = $31472ad28d4bee36$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $2b8623973cfc0cd6$exports(value)
        ];
    }
    return result;
}
$42776de1e00967f9$exports = $42776de1e00967f9$var$getMatchData;


var $82aed22878da3c1f$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $82aed22878da3c1f$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$82aed22878da3c1f$exports = $82aed22878da3c1f$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9feb3d4af5f6d622$var$baseMatches(source) {
    var matchData = $42776de1e00967f9$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $82aed22878da3c1f$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $75d011bfa214e1ee$exports(object, source, matchData);
    };
}
$9feb3d4af5f6d622$exports = $9feb3d4af5f6d622$var$baseMatches;


var $6f91756feaaf84e1$exports = {};

var $16b92812f3a40098$exports = {};

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $16b92812f3a40098$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $627f7decb2c89946$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$16b92812f3a40098$exports = $16b92812f3a40098$var$get;


var $40cea94834df8b54$exports = {};
var $a30ec33e82711a4f$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a30ec33e82711a4f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$a30ec33e82711a4f$exports = $a30ec33e82711a4f$var$baseHasIn;


var $a76572fa30fd3a94$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $a76572fa30fd3a94$var$hasPath(object, path, hasFunc) {
    path = $de95a2d03308b340$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $501a45c3a7be0368$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $9acf46d15a35c301$exports(length) && $1360731602f19189$exports(key, length) && ($0222e83d73c8b1f6$exports(object) || $28c4d821de31f25d$exports(object));
}
$a76572fa30fd3a94$exports = $a76572fa30fd3a94$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $40cea94834df8b54$var$hasIn(object, path) {
    return object != null && $a76572fa30fd3a94$exports(object, path, $a30ec33e82711a4f$exports);
}
$40cea94834df8b54$exports = $40cea94834df8b54$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $6f91756feaaf84e1$var$COMPARE_PARTIAL_FLAG = 1, $6f91756feaaf84e1$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $6f91756feaaf84e1$var$baseMatchesProperty(path, srcValue) {
    if ($d81f6afb793ec153$exports(path) && $2b8623973cfc0cd6$exports(srcValue)) return $82aed22878da3c1f$exports($501a45c3a7be0368$exports(path), srcValue);
    return function(object) {
        var objValue = $16b92812f3a40098$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $40cea94834df8b54$exports(object, path) : $2f3c512db6089049$exports(srcValue, objValue, $6f91756feaaf84e1$var$COMPARE_PARTIAL_FLAG | $6f91756feaaf84e1$var$COMPARE_UNORDERED_FLAG);
    };
}
$6f91756feaaf84e1$exports = $6f91756feaaf84e1$var$baseMatchesProperty;


var $a01605c0b9170e37$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a01605c0b9170e37$var$identity(value) {
    return value;
}
$a01605c0b9170e37$exports = $a01605c0b9170e37$var$identity;



var $83e0e17406eb7c46$exports = {};
var $0af260deaf435b4e$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $0af260deaf435b4e$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$0af260deaf435b4e$exports = $0af260deaf435b4e$var$baseProperty;


var $da424926e2e6de0e$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $da424926e2e6de0e$var$basePropertyDeep(path) {
    return function(object) {
        return $627f7decb2c89946$exports(object, path);
    };
}
$da424926e2e6de0e$exports = $da424926e2e6de0e$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $83e0e17406eb7c46$var$property(path) {
    return $d81f6afb793ec153$exports(path) ? $0af260deaf435b4e$exports($501a45c3a7be0368$exports(path)) : $da424926e2e6de0e$exports(path);
}
$83e0e17406eb7c46$exports = $83e0e17406eb7c46$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $a582a3ff9e0dc197$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $a01605c0b9170e37$exports;
    if (typeof value == 'object') return $0222e83d73c8b1f6$exports(value) ? $6f91756feaaf84e1$exports(value[0], value[1]) : $9feb3d4af5f6d622$exports(value);
    return $83e0e17406eb7c46$exports(value);
}
$a582a3ff9e0dc197$exports = $a582a3ff9e0dc197$var$baseIteratee;


var $dbf52a6dafa521e4$exports = {};
var $a648ffa9738c6555$exports = {};
var $c94d2cf1ef821fdb$exports = {};
var $bfe3f3461232eafe$exports = {};
var $b96851c7fe087daf$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b96851c7fe087daf$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$b96851c7fe087daf$exports = $b96851c7fe087daf$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bfe3f3461232eafe$var$baseFor = $b96851c7fe087daf$exports();
$bfe3f3461232eafe$exports = $bfe3f3461232eafe$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $c94d2cf1ef821fdb$var$baseForOwn(object, iteratee) {
    return object && $bfe3f3461232eafe$exports(object, iteratee, $31472ad28d4bee36$exports);
}
$c94d2cf1ef821fdb$exports = $c94d2cf1ef821fdb$var$baseForOwn;


var $7c7428c7d5e6e47e$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7c7428c7d5e6e47e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$1dea69b96520dc48$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$7c7428c7d5e6e47e$exports = $7c7428c7d5e6e47e$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $a648ffa9738c6555$var$baseEach = $7c7428c7d5e6e47e$exports($c94d2cf1ef821fdb$exports);
$a648ffa9738c6555$exports = $a648ffa9738c6555$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $dbf52a6dafa521e4$var$baseMap(collection, iteratee) {
    var index = -1, result = $1dea69b96520dc48$exports(collection) ? Array(collection.length) : [];
    $a648ffa9738c6555$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$dbf52a6dafa521e4$exports = $dbf52a6dafa521e4$var$baseMap;


var $a41ec0f490443774$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $a41ec0f490443774$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$a41ec0f490443774$exports = $a41ec0f490443774$var$baseSortBy;



var $b8456188d418e1e3$exports = {};
var $08268c95c15e7ea0$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $08268c95c15e7ea0$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8b4462bc4faef8d5$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8b4462bc4faef8d5$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$08268c95c15e7ea0$exports = $08268c95c15e7ea0$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b8456188d418e1e3$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $08268c95c15e7ea0$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$b8456188d418e1e3$exports = $b8456188d418e1e3$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $7dc34658fd9f8c45$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $6eb862b6f66dbf42$exports(iteratees, function(iteratee) {
        if ($0222e83d73c8b1f6$exports(iteratee)) return function(value) {
            return $627f7decb2c89946$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $a01605c0b9170e37$exports
    ];
    var index = -1;
    iteratees = $6eb862b6f66dbf42$exports(iteratees, $10179b7ab4d6a4cf$exports($a582a3ff9e0dc197$exports));
    var result = $dbf52a6dafa521e4$exports(collection, function(value, key, collection) {
        var criteria = $6eb862b6f66dbf42$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $a41ec0f490443774$exports(result, function(object, other) {
        return $b8456188d418e1e3$exports(object, other, orders);
    });
}
$7dc34658fd9f8c45$exports = $7dc34658fd9f8c45$var$baseOrderBy;


var $d54bc3387ae0143f$exports = {};

var $402fb9ee710cffc6$exports = {};
var $b36f5643ed95091a$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $b36f5643ed95091a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$b36f5643ed95091a$exports = $b36f5643ed95091a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $402fb9ee710cffc6$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $402fb9ee710cffc6$var$overRest(func, start, transform) {
    start = $402fb9ee710cffc6$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $402fb9ee710cffc6$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $b36f5643ed95091a$exports(func, this, otherArgs);
    };
}
$402fb9ee710cffc6$exports = $402fb9ee710cffc6$var$overRest;


var $9c5f9147b3854162$exports = {};
var $4656e540f2f73d29$exports = {};
var $90a720beacf17532$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $90a720beacf17532$var$constant(value) {
    return function() {
        return value;
    };
}
$90a720beacf17532$exports = $90a720beacf17532$var$constant;


var $1ce0cf72dd2e5e9c$exports = {};

var $1ce0cf72dd2e5e9c$var$defineProperty = function() {
    try {
        var func = $99c4ba84188f46b8$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$1ce0cf72dd2e5e9c$exports = $1ce0cf72dd2e5e9c$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4656e540f2f73d29$var$baseSetToString = !$1ce0cf72dd2e5e9c$exports ? $a01605c0b9170e37$exports : function(func, string) {
    return $1ce0cf72dd2e5e9c$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $90a720beacf17532$exports(string),
        'writable': true
    });
};
$4656e540f2f73d29$exports = $4656e540f2f73d29$var$baseSetToString;


var $3631767a021b93d9$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $3631767a021b93d9$var$HOT_COUNT = 800, $3631767a021b93d9$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3631767a021b93d9$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $3631767a021b93d9$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $3631767a021b93d9$var$nativeNow(), remaining = $3631767a021b93d9$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $3631767a021b93d9$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$3631767a021b93d9$exports = $3631767a021b93d9$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9c5f9147b3854162$var$setToString = $3631767a021b93d9$exports($4656e540f2f73d29$exports);
$9c5f9147b3854162$exports = $9c5f9147b3854162$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d54bc3387ae0143f$var$baseRest(func, start) {
    return $9c5f9147b3854162$exports($402fb9ee710cffc6$exports(func, start, $a01605c0b9170e37$exports), func + '');
}
$d54bc3387ae0143f$exports = $d54bc3387ae0143f$var$baseRest;


var $ff4b2aa90f11886d$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $ff4b2aa90f11886d$var$isIterateeCall(value, index, object) {
    if (!$1f672fed7efed57e$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $1dea69b96520dc48$exports(object) && $1360731602f19189$exports(index, object.length) : type == 'string' && index in object) return $4848ae3ccf4ff248$exports(object[index], value);
    return false;
}
$ff4b2aa90f11886d$exports = $ff4b2aa90f11886d$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $94f228f85e408a75$var$sortBy = $d54bc3387ae0143f$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $ff4b2aa90f11886d$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $ff4b2aa90f11886d$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $7dc34658fd9f8c45$exports(collection, $7b5e66b57ad8b66a$exports(iteratees, 1), []);
});
$94f228f85e408a75$exports = $94f228f85e408a75$var$sortBy;


var $4c326af0091dea95$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $4c326af0091dea95$var$isNil(value) {
    return value == null;
}
$4c326af0091dea95$exports = $4c326af0091dea95$var$isNil;


function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;


var $16fa8ba01192b4c0$exports = {};



/** `Object#toString` result references. */ var $16fa8ba01192b4c0$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $16fa8ba01192b4c0$var$isString(value) {
    return typeof value == 'string' || !$0222e83d73c8b1f6$exports(value) && $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $16fa8ba01192b4c0$var$stringTag;
}
$16fa8ba01192b4c0$exports = $16fa8ba01192b4c0$var$isString;


var $8672b9db6ee461d3$exports = {};
var $37811de5ea7fe4ba$exports = {};


/** `Object#toString` result references. */ var $37811de5ea7fe4ba$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $37811de5ea7fe4ba$var$isNumber(value) {
    return typeof value == 'number' || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $37811de5ea7fe4ba$var$numberTag;
}
$37811de5ea7fe4ba$exports = $37811de5ea7fe4ba$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $8672b9db6ee461d3$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $37811de5ea7fe4ba$exports(value) && value != +value;
}
$8672b9db6ee461d3$exports = $8672b9db6ee461d3$var$isNaN;




var $147f5ef07a9ae0e2$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $147f5ef07a9ae0e2$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $147f5ef07a9ae0e2$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($37811de5ea7fe4ba$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($8672b9db6ee461d3$exports)))(value);
};
var $147f5ef07a9ae0e2$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $147f5ef07a9ae0e2$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(value);
};
var $147f5ef07a9ae0e2$var$idCounter = 0;
var $147f5ef07a9ae0e2$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$147f5ef07a9ae0e2$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $147f5ef07a9ae0e2$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$147f5ef07a9ae0e2$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(percent)) return defaultValue;
    var value;
    if ($147f5ef07a9ae0e2$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8672b9db6ee461d3$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $147f5ef07a9ae0e2$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $147f5ef07a9ae0e2$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $147f5ef07a9ae0e2$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($147f5ef07a9ae0e2$export$7e4aa119212bc614(numberA) && $147f5ef07a9ae0e2$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $147f5ef07a9ae0e2$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $147f5ef07a9ae0e2$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $afceda1048d105c9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afceda1048d105c9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afceda1048d105c9$var$_typeof(o);
}
function $afceda1048d105c9$var$_slicedToArray(arr, i) {
    return $afceda1048d105c9$var$_arrayWithHoles(arr) || $afceda1048d105c9$var$_iterableToArrayLimit(arr, i) || $afceda1048d105c9$var$_unsupportedIterableToArray(arr, i) || $afceda1048d105c9$var$_nonIterableRest();
}
function $afceda1048d105c9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $afceda1048d105c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $afceda1048d105c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $afceda1048d105c9$var$_arrayLikeToArray(o, minLen);
}
function $afceda1048d105c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $afceda1048d105c9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $afceda1048d105c9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $afceda1048d105c9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afceda1048d105c9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afceda1048d105c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $afceda1048d105c9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afceda1048d105c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afceda1048d105c9$var$_defineProperty(obj, key, value) {
    key = $afceda1048d105c9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afceda1048d105c9$var$_toPropertyKey(arg) {
    var key = $afceda1048d105c9$var$_toPrimitive(arg, "string");
    return $afceda1048d105c9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $afceda1048d105c9$var$_toPrimitive(input, hint) {
    if ($afceda1048d105c9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($afceda1048d105c9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $afceda1048d105c9$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(value[0]) && (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $afceda1048d105c9$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($94f228f85e408a75$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $afceda1048d105c9$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $afceda1048d105c9$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $afceda1048d105c9$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, $cc1z1.default).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, $cc1z1.default).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, $cc1z1.default).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, $cc1z1.default).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, $cc1z1.default).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, $cc1z1.default).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $afceda1048d105c9$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $afceda1048d105c9$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, $cc1z1.default).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, $cc1z1.default).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $cc1z1 = parcelRequire("cc1z1");

var $cc1z1 = parcelRequire("cc1z1");

var $4RND8 = parcelRequire("4RND8");
var $fadab19baf6defbe$exports = {};
(function(global, factory) {
    factory($fadab19baf6defbe$exports);
})($fadab19baf6defbe$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual, unknownTagComparators = _a.unknownTagComparators;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                var unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    var shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $443399b196e549c4$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $443399b196e549c4$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $443399b196e549c4$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $fec305178615f413$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fec305178615f413$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fec305178615f413$var$_typeof(obj);
}
function $fec305178615f413$var$_toArray(arr) {
    return $fec305178615f413$var$_arrayWithHoles(arr) || $fec305178615f413$var$_iterableToArray(arr) || $fec305178615f413$var$_unsupportedIterableToArray(arr) || $fec305178615f413$var$_nonIterableRest();
}
function $fec305178615f413$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fec305178615f413$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fec305178615f413$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fec305178615f413$var$_arrayLikeToArray(o, minLen);
}
function $fec305178615f413$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fec305178615f413$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $fec305178615f413$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fec305178615f413$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $fec305178615f413$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $443399b196e549c4$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $443399b196e549c4$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($fec305178615f413$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $e7d9931f686cb7c8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e7d9931f686cb7c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e7d9931f686cb7c8$var$_typeof(obj);
}
function $e7d9931f686cb7c8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e7d9931f686cb7c8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e7d9931f686cb7c8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e7d9931f686cb7c8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e7d9931f686cb7c8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e7d9931f686cb7c8$var$_defineProperty(obj, key, value) {
    key = $e7d9931f686cb7c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e7d9931f686cb7c8$var$_toPropertyKey(arg) {
    var key = $e7d9931f686cb7c8$var$_toPrimitive(arg, "string");
    return $e7d9931f686cb7c8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e7d9931f686cb7c8$var$_toPrimitive(input, hint) {
    if ($e7d9931f686cb7c8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e7d9931f686cb7c8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $e7d9931f686cb7c8$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $e7d9931f686cb7c8$var$IN_LINE_PREFIX_LIST = [
    '-webkit-',
    '-moz-',
    '-o-',
    '-ms-'
];
var $e7d9931f686cb7c8$var$IN_COMPATIBLE_PROPERTY = [
    'transform',
    'transformOrigin',
    'transition'
];
var $e7d9931f686cb7c8$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $e7d9931f686cb7c8$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $e7d9931f686cb7c8$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $e7d9931f686cb7c8$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($e7d9931f686cb7c8$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $e7d9931f686cb7c8$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === 'transition';
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $e7d9931f686cb7c8$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($e7d9931f686cb7c8$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $e7d9931f686cb7c8$var$_objectSpread($e7d9931f686cb7c8$var$_objectSpread({}, result), {}, $e7d9931f686cb7c8$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $e7d9931f686cb7c8$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $e7d9931f686cb7c8$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $e7d9931f686cb7c8$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $e7d9931f686cb7c8$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $e7d9931f686cb7c8$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $e7d9931f686cb7c8$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $e7d9931f686cb7c8$var$_objectSpread($e7d9931f686cb7c8$var$_objectSpread({}, res), {}, $e7d9931f686cb7c8$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $e7d9931f686cb7c8$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $e7d9931f686cb7c8$var$_objectSpread($e7d9931f686cb7c8$var$_objectSpread({}, res), $e7d9931f686cb7c8$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $e7d9931f686cb7c8$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $e7d9931f686cb7c8$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $e7d9931f686cb7c8$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($e7d9931f686cb7c8$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $e7d9931f686cb7c8$var$isDev = false;
var $e7d9931f686cb7c8$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($e7d9931f686cb7c8$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $9a2862a18bddf5a6$var$_slicedToArray(arr, i) {
    return $9a2862a18bddf5a6$var$_arrayWithHoles(arr) || $9a2862a18bddf5a6$var$_iterableToArrayLimit(arr, i) || $9a2862a18bddf5a6$var$_unsupportedIterableToArray(arr, i) || $9a2862a18bddf5a6$var$_nonIterableRest();
}
function $9a2862a18bddf5a6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a2862a18bddf5a6$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $9a2862a18bddf5a6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9a2862a18bddf5a6$var$_toConsumableArray(arr) {
    return $9a2862a18bddf5a6$var$_arrayWithoutHoles(arr) || $9a2862a18bddf5a6$var$_iterableToArray(arr) || $9a2862a18bddf5a6$var$_unsupportedIterableToArray(arr) || $9a2862a18bddf5a6$var$_nonIterableSpread();
}
function $9a2862a18bddf5a6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a2862a18bddf5a6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9a2862a18bddf5a6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9a2862a18bddf5a6$var$_arrayLikeToArray(o, minLen);
}
function $9a2862a18bddf5a6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9a2862a18bddf5a6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9a2862a18bddf5a6$var$_arrayLikeToArray(arr);
}
function $9a2862a18bddf5a6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9a2862a18bddf5a6$var$ACCURACY = 1e-4;
var $9a2862a18bddf5a6$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $9a2862a18bddf5a6$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $9a2862a18bddf5a6$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $9a2862a18bddf5a6$var$cubicBezierFactor(c1, c2);
        return $9a2862a18bddf5a6$var$multyTime(params, t);
    };
};
var $9a2862a18bddf5a6$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $9a2862a18bddf5a6$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($9a2862a18bddf5a6$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $9a2862a18bddf5a6$var$multyTime(newParams, t);
    };
};
var $9a2862a18bddf5a6$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $9a2862a18bddf5a6$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $e7d9931f686cb7c8$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $e7d9931f686cb7c8$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $9a2862a18bddf5a6$var$cubicBezier(x1, x2);
    var curveY = $9a2862a18bddf5a6$var$cubicBezier(y1, y2);
    var derCurveX = $9a2862a18bddf5a6$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $9a2862a18bddf5a6$var$ACCURACY || derVal < $9a2862a18bddf5a6$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $9a2862a18bddf5a6$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $9a2862a18bddf5a6$var$ACCURACY && Math.abs(newV) < $9a2862a18bddf5a6$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $9a2862a18bddf5a6$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $9a2862a18bddf5a6$export$56c51296f72f0592(easing);
        case 'spring':
            return $9a2862a18bddf5a6$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $9a2862a18bddf5a6$export$56c51296f72f0592(easing);
            (0, $e7d9931f686cb7c8$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $e7d9931f686cb7c8$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $6ade0e6da4e8f1ce$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6ade0e6da4e8f1ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6ade0e6da4e8f1ce$var$_typeof(obj);
}
function $6ade0e6da4e8f1ce$var$_toConsumableArray(arr) {
    return $6ade0e6da4e8f1ce$var$_arrayWithoutHoles(arr) || $6ade0e6da4e8f1ce$var$_iterableToArray(arr) || $6ade0e6da4e8f1ce$var$_unsupportedIterableToArray(arr) || $6ade0e6da4e8f1ce$var$_nonIterableSpread();
}
function $6ade0e6da4e8f1ce$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ade0e6da4e8f1ce$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6ade0e6da4e8f1ce$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6ade0e6da4e8f1ce$var$_arrayLikeToArray(arr);
}
function $6ade0e6da4e8f1ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6ade0e6da4e8f1ce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6ade0e6da4e8f1ce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6ade0e6da4e8f1ce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6ade0e6da4e8f1ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6ade0e6da4e8f1ce$var$_defineProperty(obj, key, value) {
    key = $6ade0e6da4e8f1ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6ade0e6da4e8f1ce$var$_toPropertyKey(arg) {
    var key = $6ade0e6da4e8f1ce$var$_toPrimitive(arg, "string");
    return $6ade0e6da4e8f1ce$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6ade0e6da4e8f1ce$var$_toPrimitive(input, hint) {
    if ($6ade0e6da4e8f1ce$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6ade0e6da4e8f1ce$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6ade0e6da4e8f1ce$var$_slicedToArray(arr, i) {
    return $6ade0e6da4e8f1ce$var$_arrayWithHoles(arr) || $6ade0e6da4e8f1ce$var$_iterableToArrayLimit(arr, i) || $6ade0e6da4e8f1ce$var$_unsupportedIterableToArray(arr, i) || $6ade0e6da4e8f1ce$var$_nonIterableRest();
}
function $6ade0e6da4e8f1ce$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6ade0e6da4e8f1ce$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6ade0e6da4e8f1ce$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6ade0e6da4e8f1ce$var$_arrayLikeToArray(o, minLen);
}
function $6ade0e6da4e8f1ce$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6ade0e6da4e8f1ce$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $6ade0e6da4e8f1ce$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6ade0e6da4e8f1ce$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $6ade0e6da4e8f1ce$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $6ade0e6da4e8f1ce$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $e7d9931f686cb7c8$export$d6051a0f7a227332)(function(key, val) {
        if ($6ade0e6da4e8f1ce$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $6ade0e6da4e8f1ce$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $e7d9931f686cb7c8$export$d6051a0f7a227332)(function(key, val) {
        if ($6ade0e6da4e8f1ce$var$needContinue(val)) return $6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, val), {}, {
            velocity: $6ade0e6da4e8f1ce$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $6ade0e6da4e8f1ce$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$6ade0e6da4e8f1ce$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $e7d9931f686cb7c8$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, res), {}, $6ade0e6da4e8f1ce$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, res), {}, $6ade0e6da4e8f1ce$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $e7d9931f686cb7c8$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($6ade0e6da4e8f1ce$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $6ade0e6da4e8f1ce$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $e7d9931f686cb7c8$export$d6051a0f7a227332)(function(key, val) {
            return $6ade0e6da4e8f1ce$var$alpha.apply(void 0, $6ade0e6da4e8f1ce$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $e7d9931f686cb7c8$export$d6051a0f7a227332)(function(key, val) {
                return $6ade0e6da4e8f1ce$var$alpha.apply(void 0, $6ade0e6da4e8f1ce$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread($6ade0e6da4e8f1ce$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $8d319822851299e5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8d319822851299e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8d319822851299e5$var$_typeof(obj);
}
var $8d319822851299e5$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $8d319822851299e5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8d319822851299e5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8d319822851299e5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8d319822851299e5$var$_toConsumableArray(arr) {
    return $8d319822851299e5$var$_arrayWithoutHoles(arr) || $8d319822851299e5$var$_iterableToArray(arr) || $8d319822851299e5$var$_unsupportedIterableToArray(arr) || $8d319822851299e5$var$_nonIterableSpread();
}
function $8d319822851299e5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8d319822851299e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8d319822851299e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8d319822851299e5$var$_arrayLikeToArray(o, minLen);
}
function $8d319822851299e5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8d319822851299e5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8d319822851299e5$var$_arrayLikeToArray(arr);
}
function $8d319822851299e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8d319822851299e5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8d319822851299e5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8d319822851299e5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8d319822851299e5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8d319822851299e5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8d319822851299e5$var$_defineProperty(obj, key, value) {
    key = $8d319822851299e5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8d319822851299e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8d319822851299e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8d319822851299e5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8d319822851299e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8d319822851299e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8d319822851299e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8d319822851299e5$var$_toPropertyKey(arg) {
    var key = $8d319822851299e5$var$_toPrimitive(arg, "string");
    return $8d319822851299e5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8d319822851299e5$var$_toPrimitive(input, hint) {
    if ($8d319822851299e5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8d319822851299e5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8d319822851299e5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8d319822851299e5$var$_setPrototypeOf(subClass, superClass);
}
function $8d319822851299e5$var$_setPrototypeOf(o, p) {
    $8d319822851299e5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8d319822851299e5$var$_setPrototypeOf(o, p);
}
function $8d319822851299e5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8d319822851299e5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8d319822851299e5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8d319822851299e5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8d319822851299e5$var$_possibleConstructorReturn(this, result);
    };
}
function $8d319822851299e5$var$_possibleConstructorReturn(self, call) {
    if (call && ($8d319822851299e5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8d319822851299e5$var$_assertThisInitialized(self);
}
function $8d319822851299e5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8d319822851299e5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8d319822851299e5$var$_getPrototypeOf(o) {
    $8d319822851299e5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8d319822851299e5$var$_getPrototypeOf(o);
}
var $8d319822851299e5$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $8d319822851299e5$var$_inherits(Animate, _PureComponent);
    var _super = $8d319822851299e5$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $8d319822851299e5$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($8d319822851299e5$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($8d319822851299e5$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $8d319822851299e5$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $8d319822851299e5$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $8d319822851299e5$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $8d319822851299e5$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $8d319822851299e5$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $fadab19baf6defbe$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $8d319822851299e5$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $6ade0e6da4e8f1ce$export$2e2bcd8739ae039)(from, to, (0, $9a2862a18bddf5a6$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($8d319822851299e5$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $e7d9931f686cb7c8$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($8d319822851299e5$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $e7d9931f686cb7c8$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($8d319822851299e5$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $fec305178615f413$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $8d319822851299e5$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $e7d9931f686cb7c8$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $8d319822851299e5$var$_objectWithoutProperties(_this$props4, $8d319822851299e5$var$_excluded);
                var count = (0, $cc1z1.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $e7d9931f686cb7c8$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $cc1z1.cloneElement)(container, $8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread({}, others), {}, {
                        style: $8d319822851299e5$var$_objectSpread($8d319822851299e5$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $cc1z1.Children).only(children));
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("div", null, (0, $cc1z1.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $cc1z1.PureComponent));
$8d319822851299e5$var$Animate.displayName = 'Animate';
$8d319822851299e5$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$8d319822851299e5$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
};
var $8d319822851299e5$export$2e2bcd8739ae039 = $8d319822851299e5$var$Animate;





var $cc1z1 = parcelRequire("cc1z1");
var $4377bbe8d485e508$exports = {};
"use strict";

var $4377bbe8d485e508$var$_CSSTransition = $4377bbe8d485e508$var$_interopRequireDefault((parcelRequire("k7IBq")));

var $4377bbe8d485e508$var$_ReplaceTransition = $4377bbe8d485e508$var$_interopRequireDefault((parcelRequire("gtbYb")));

var $4377bbe8d485e508$var$_TransitionGroup = $4377bbe8d485e508$var$_interopRequireDefault((parcelRequire("5EpX4")));

var $4377bbe8d485e508$var$_Transition = $4377bbe8d485e508$var$_interopRequireDefault((parcelRequire("iJjgK")));
function $4377bbe8d485e508$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$4377bbe8d485e508$exports = {
    Transition: $4377bbe8d485e508$var$_Transition.default,
    TransitionGroup: $4377bbe8d485e508$var$_TransitionGroup.default,
    ReplaceTransition: $4377bbe8d485e508$var$_ReplaceTransition.default,
    CSSTransition: $4377bbe8d485e508$var$_CSSTransition.default
};



var $4RND8 = parcelRequire("4RND8");

var $cc1z1 = parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");


var $4RND8 = parcelRequire("4RND8");

var $6c94ad2375ddb3b5$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $6c94ad2375ddb3b5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6c94ad2375ddb3b5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6c94ad2375ddb3b5$var$_typeof(obj);
}
function $6c94ad2375ddb3b5$var$_extends() {
    $6c94ad2375ddb3b5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c94ad2375ddb3b5$var$_extends.apply(this, arguments);
}
function $6c94ad2375ddb3b5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6c94ad2375ddb3b5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6c94ad2375ddb3b5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6c94ad2375ddb3b5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6c94ad2375ddb3b5$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6c94ad2375ddb3b5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6c94ad2375ddb3b5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6c94ad2375ddb3b5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6c94ad2375ddb3b5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6c94ad2375ddb3b5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6c94ad2375ddb3b5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6c94ad2375ddb3b5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6c94ad2375ddb3b5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c94ad2375ddb3b5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6c94ad2375ddb3b5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6c94ad2375ddb3b5$var$_setPrototypeOf(subClass, superClass);
}
function $6c94ad2375ddb3b5$var$_setPrototypeOf(o, p) {
    $6c94ad2375ddb3b5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6c94ad2375ddb3b5$var$_setPrototypeOf(o, p);
}
function $6c94ad2375ddb3b5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6c94ad2375ddb3b5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6c94ad2375ddb3b5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6c94ad2375ddb3b5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6c94ad2375ddb3b5$var$_possibleConstructorReturn(this, result);
    };
}
function $6c94ad2375ddb3b5$var$_possibleConstructorReturn(self, call) {
    if (call && ($6c94ad2375ddb3b5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6c94ad2375ddb3b5$var$_assertThisInitialized(self);
}
function $6c94ad2375ddb3b5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6c94ad2375ddb3b5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6c94ad2375ddb3b5$var$_getPrototypeOf(o) {
    $6c94ad2375ddb3b5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6c94ad2375ddb3b5$var$_getPrototypeOf(o);
}
function $6c94ad2375ddb3b5$var$_defineProperty(obj, key, value) {
    key = $6c94ad2375ddb3b5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6c94ad2375ddb3b5$var$_toPropertyKey(arg) {
    var key = $6c94ad2375ddb3b5$var$_toPrimitive(arg, "string");
    return $6c94ad2375ddb3b5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6c94ad2375ddb3b5$var$_toPrimitive(input, hint) {
    if ($6c94ad2375ddb3b5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6c94ad2375ddb3b5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value);
};
var $6c94ad2375ddb3b5$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $6c94ad2375ddb3b5$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $6c94ad2375ddb3b5$var$_inherits(AnimateGroupChild, _Component);
    var _super = $6c94ad2375ddb3b5$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $6c94ad2375ddb3b5$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $6c94ad2375ddb3b5$var$_defineProperty($6c94ad2375ddb3b5$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $6c94ad2375ddb3b5$var$_defineProperty($6c94ad2375ddb3b5$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $6c94ad2375ddb3b5$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($6c94ad2375ddb3b5$var$_objectSpread($6c94ad2375ddb3b5$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $6c94ad2375ddb3b5$var$parseDurationOfSingleTransition(appearOptions) + $6c94ad2375ddb3b5$var$parseDurationOfSingleTransition(enterOptions) + $6c94ad2375ddb3b5$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $6c94ad2375ddb3b5$var$_objectWithoutProperties(_this$props3, $6c94ad2375ddb3b5$var$_excluded);
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $4377bbe8d485e508$exports.Transition), $6c94ad2375ddb3b5$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $8d319822851299e5$export$2e2bcd8739ae039), _this2.state, (0, $cc1z1.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $hURbM.Component));
$6c94ad2375ddb3b5$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).element
};
var $6c94ad2375ddb3b5$export$2e2bcd8739ae039 = $6c94ad2375ddb3b5$var$AnimateGroupChild;


function $941ec9393b6a5e40$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $4377bbe8d485e508$exports.TransitionGroup), {
        component: component
    }, (0, $cc1z1.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6c94ad2375ddb3b5$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$941ec9393b6a5e40$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).any
};
$941ec9393b6a5e40$var$AnimateGroup.defaultProps = {
    component: 'span'
};
var $941ec9393b6a5e40$export$2e2bcd8739ae039 = $941ec9393b6a5e40$var$AnimateGroup;


var $6f0a4edbaa8d1116$export$2e2bcd8739ae039 = (0, $8d319822851299e5$export$2e2bcd8739ae039);





function $22ad863bf35da492$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $22ad863bf35da492$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $22ad863bf35da492$var$_typeof(o);
}
function $22ad863bf35da492$var$_defineProperty(obj, key, value) {
    key = $22ad863bf35da492$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $22ad863bf35da492$var$_toPropertyKey(arg) {
    var key = $22ad863bf35da492$var$_toPrimitive(arg, "string");
    return $22ad863bf35da492$var$_typeof(key) === "symbol" ? key : String(key);
}
function $22ad863bf35da492$var$_toPrimitive(input, hint) {
    if ($22ad863bf35da492$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($22ad863bf35da492$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $22ad863bf35da492$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $22ad863bf35da492$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $22ad863bf35da492$export$46aee7ef09f78756(_ref) {
    var _clsx;
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)($22ad863bf35da492$var$CSS_CLASS_PREFIX, (_clsx = {}, $22ad863bf35da492$var$_defineProperty(_clsx, "".concat($22ad863bf35da492$var$CSS_CLASS_PREFIX, "-right"), (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $22ad863bf35da492$var$_defineProperty(_clsx, "".concat($22ad863bf35da492$var$CSS_CLASS_PREFIX, "-left"), (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(translateX) && coordinate && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $22ad863bf35da492$var$_defineProperty(_clsx, "".concat($22ad863bf35da492$var$CSS_CLASS_PREFIX, "-bottom"), (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $22ad863bf35da492$var$_defineProperty(_clsx, "".concat($22ad863bf35da492$var$CSS_CLASS_PREFIX, "-top"), (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(translateY) && coordinate && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _clsx));
}
function $22ad863bf35da492$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $22ad863bf35da492$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return (0, $e7d9931f686cb7c8$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    });
}
function $22ad863bf35da492$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $22ad863bf35da492$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $22ad863bf35da492$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $22ad863bf35da492$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $22ad863bf35da492$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $22ad863bf35da492$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $c6198ba8aef8e18f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c6198ba8aef8e18f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c6198ba8aef8e18f$var$_typeof(o);
}
function $c6198ba8aef8e18f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6198ba8aef8e18f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6198ba8aef8e18f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c6198ba8aef8e18f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6198ba8aef8e18f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c6198ba8aef8e18f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c6198ba8aef8e18f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c6198ba8aef8e18f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c6198ba8aef8e18f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c6198ba8aef8e18f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c6198ba8aef8e18f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c6198ba8aef8e18f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c6198ba8aef8e18f$var$_setPrototypeOf(subClass, superClass);
}
function $c6198ba8aef8e18f$var$_setPrototypeOf(o, p) {
    $c6198ba8aef8e18f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c6198ba8aef8e18f$var$_setPrototypeOf(o, p);
}
function $c6198ba8aef8e18f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c6198ba8aef8e18f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c6198ba8aef8e18f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c6198ba8aef8e18f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c6198ba8aef8e18f$var$_possibleConstructorReturn(this, result);
    };
}
function $c6198ba8aef8e18f$var$_possibleConstructorReturn(self, call) {
    if (call && ($c6198ba8aef8e18f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c6198ba8aef8e18f$var$_assertThisInitialized(self);
}
function $c6198ba8aef8e18f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c6198ba8aef8e18f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c6198ba8aef8e18f$var$_getPrototypeOf(o) {
    $c6198ba8aef8e18f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c6198ba8aef8e18f$var$_getPrototypeOf(o);
}
function $c6198ba8aef8e18f$var$_defineProperty(obj, key, value) {
    key = $c6198ba8aef8e18f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c6198ba8aef8e18f$var$_toPropertyKey(arg) {
    var key = $c6198ba8aef8e18f$var$_toPrimitive(arg, "string");
    return $c6198ba8aef8e18f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c6198ba8aef8e18f$var$_toPrimitive(input, hint) {
    if ($c6198ba8aef8e18f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c6198ba8aef8e18f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c6198ba8aef8e18f$var$EPSILON = 1;
var $c6198ba8aef8e18f$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $c6198ba8aef8e18f$var$_inherits(TooltipBoundingBox, _PureComponent);
    var _super = $c6198ba8aef8e18f$var$_createSuper(TooltipBoundingBox);
    function TooltipBoundingBox() {
        var _this;
        $c6198ba8aef8e18f$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c6198ba8aef8e18f$var$_defineProperty($c6198ba8aef8e18f$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $c6198ba8aef8e18f$var$_defineProperty($c6198ba8aef8e18f$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        $c6198ba8aef8e18f$var$_defineProperty($c6198ba8aef8e18f$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $c6198ba8aef8e18f$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $c6198ba8aef8e18f$var$EPSILON || Math.abs(box.height - this.lastBoundingBox.height) > $c6198ba8aef8e18f$var$EPSILON) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $22ad863bf35da492$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: {
                        height: this.lastBoundingBox.height,
                        width: this.lastBoundingBox.width
                    },
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $c6198ba8aef8e18f$var$_objectSpread($c6198ba8aef8e18f$var$_objectSpread($c6198ba8aef8e18f$var$_objectSpread({}, isAnimationActive && active && (0, $e7d9931f686cb7c8$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, $cc1z1.default).createElement("div", {
                    tabIndex: -1,
                    role: "dialog",
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $cc1z1.PureComponent));


var $d71a8156ac4ac220$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $d71a8156ac4ac220$export$98f03c5d19621d70 = {
    isSsr: $d71a8156ac4ac220$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $d71a8156ac4ac220$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $d71a8156ac4ac220$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $d71a8156ac4ac220$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};


var $7e0cfb84cc381956$exports = {};

var $dde1661a61810cfa$exports = {};

var $ee36e43d941ad934$exports = {};
var $d33aef5ccce4576b$exports = {};
var $63657c705aa6a1df$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $63657c705aa6a1df$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$63657c705aa6a1df$exports = $63657c705aa6a1df$var$baseFindIndex;


var $2ac5db1ac39bad12$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $2ac5db1ac39bad12$var$baseIsNaN(value) {
    return value !== value;
}
$2ac5db1ac39bad12$exports = $2ac5db1ac39bad12$var$baseIsNaN;


var $588ce6dc6e1defc1$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $588ce6dc6e1defc1$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$588ce6dc6e1defc1$exports = $588ce6dc6e1defc1$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d33aef5ccce4576b$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $588ce6dc6e1defc1$exports(array, value, fromIndex) : $63657c705aa6a1df$exports(array, $2ac5db1ac39bad12$exports, fromIndex);
}
$d33aef5ccce4576b$exports = $d33aef5ccce4576b$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ee36e43d941ad934$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $d33aef5ccce4576b$exports(array, value, 0) > -1;
}
$ee36e43d941ad934$exports = $ee36e43d941ad934$var$arrayIncludes;


var $aa8d5870b4d28c45$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $aa8d5870b4d28c45$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$aa8d5870b4d28c45$exports = $aa8d5870b4d28c45$var$arrayIncludesWith;



var $4bd66f45c3d60c4a$exports = {};

var $52b9ed02a639eb1a$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $52b9ed02a639eb1a$var$noop() {
// No operation performed.
}
$52b9ed02a639eb1a$exports = $52b9ed02a639eb1a$var$noop;



/** Used as references for various `Number` constants. */ var $4bd66f45c3d60c4a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $4bd66f45c3d60c4a$var$createSet = !($5c6fefa8e3385cb2$exports && 1 / $f806c2008611bc31$exports(new $5c6fefa8e3385cb2$exports([
    ,
    -0
]))[1] == $4bd66f45c3d60c4a$var$INFINITY) ? $52b9ed02a639eb1a$exports : function(values) {
    return new $5c6fefa8e3385cb2$exports(values);
};
$4bd66f45c3d60c4a$exports = $4bd66f45c3d60c4a$var$createSet;



/** Used as the size to enable large array optimizations. */ var $dde1661a61810cfa$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $dde1661a61810cfa$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ee36e43d941ad934$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $aa8d5870b4d28c45$exports;
    } else if (length >= $dde1661a61810cfa$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4bd66f45c3d60c4a$exports(array);
        if (set) return $f806c2008611bc31$exports(set);
        isCommon = false;
        includes = $c699d87c7e600909$exports;
        seen = new $cd6ee8e094d9e61f$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$dde1661a61810cfa$exports = $dde1661a61810cfa$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $7e0cfb84cc381956$var$uniqBy(array, iteratee) {
    return array && array.length ? $dde1661a61810cfa$exports(array, $a582a3ff9e0dc197$exports(iteratee, 2)) : [];
}
$7e0cfb84cc381956$exports = $7e0cfb84cc381956$var$uniqBy;



function $9a656273db1543d8$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($7e0cfb84cc381956$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($7e0cfb84cc381956$exports)))(payload, option);
    return payload;
}


function $7c198dcf6108b117$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7c198dcf6108b117$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7c198dcf6108b117$var$_typeof(o);
}
function $7c198dcf6108b117$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c198dcf6108b117$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c198dcf6108b117$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7c198dcf6108b117$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c198dcf6108b117$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7c198dcf6108b117$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7c198dcf6108b117$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7c198dcf6108b117$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7c198dcf6108b117$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7c198dcf6108b117$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7c198dcf6108b117$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7c198dcf6108b117$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7c198dcf6108b117$var$_setPrototypeOf(subClass, superClass);
}
function $7c198dcf6108b117$var$_setPrototypeOf(o, p) {
    $7c198dcf6108b117$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7c198dcf6108b117$var$_setPrototypeOf(o, p);
}
function $7c198dcf6108b117$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7c198dcf6108b117$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7c198dcf6108b117$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7c198dcf6108b117$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7c198dcf6108b117$var$_possibleConstructorReturn(this, result);
    };
}
function $7c198dcf6108b117$var$_possibleConstructorReturn(self, call) {
    if (call && ($7c198dcf6108b117$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7c198dcf6108b117$var$_assertThisInitialized(self);
}
function $7c198dcf6108b117$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7c198dcf6108b117$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7c198dcf6108b117$var$_getPrototypeOf(o) {
    $7c198dcf6108b117$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7c198dcf6108b117$var$_getPrototypeOf(o);
}
function $7c198dcf6108b117$var$_defineProperty(obj, key, value) {
    key = $7c198dcf6108b117$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7c198dcf6108b117$var$_toPropertyKey(arg) {
    var key = $7c198dcf6108b117$var$_toPrimitive(arg, "string");
    return $7c198dcf6108b117$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7c198dcf6108b117$var$_toPrimitive(input, hint) {
    if ($7c198dcf6108b117$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7c198dcf6108b117$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7c198dcf6108b117$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $7c198dcf6108b117$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(content)) return /*#__PURE__*/ (0, $cc1z1.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, $cc1z1.default).createElement(content, props);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $afceda1048d105c9$export$6fe33945eebf9ac8), props);
}
var $7c198dcf6108b117$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $7c198dcf6108b117$var$_inherits(Tooltip, _PureComponent);
    var _super = $7c198dcf6108b117$var$_createSuper(Tooltip);
    function Tooltip() {
        $7c198dcf6108b117$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $7c198dcf6108b117$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $9a656273db1543d8$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null;
                }), payloadUniqBy, $7c198dcf6108b117$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $c6198ba8aef8e18f$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $7c198dcf6108b117$var$renderContent(content, $7c198dcf6108b117$var$_objectSpread($7c198dcf6108b117$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $cc1z1.PureComponent));
$7c198dcf6108b117$var$_defineProperty($7c198dcf6108b117$export$28c660c63b792dea, "displayName", 'Tooltip');
$7c198dcf6108b117$var$_defineProperty($7c198dcf6108b117$export$28c660c63b792dea, "defaultProps", {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $d71a8156ac4ac220$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});


var $cc1z1 = parcelRequire("cc1z1");


var $0e8f7400a8be2107$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0e8f7400a8be2107$var$isEqual(value, other) {
    return $2f3c512db6089049$exports(value, other);
}
$0e8f7400a8be2107$exports = $0e8f7400a8be2107$var$isEqual;




var $cc1z1 = parcelRequire("cc1z1");







var $cc1z1 = parcelRequire("cc1z1");
var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));



function $a7f0dcba3c7ed6d9$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $cc1z1 = parcelRequire("cc1z1");

function $657f06ff92323a96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $657f06ff92323a96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $657f06ff92323a96$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $657f06ff92323a96$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $657f06ff92323a96$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $657f06ff92323a96$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $657f06ff92323a96$export$2b22758266a6fa48 = {
    svg: $657f06ff92323a96$var$SVGContainerPropKeys,
    polygon: $657f06ff92323a96$var$PolyElementKeys,
    polyline: $657f06ff92323a96$var$PolyElementKeys
};
var $657f06ff92323a96$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $657f06ff92323a96$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($657f06ff92323a96$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $657f06ff92323a96$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $657f06ff92323a96$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(props) || $657f06ff92323a96$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($657f06ff92323a96$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $657f06ff92323a96$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $b1f8f02c080083dc$var$_excluded = [
    "children"
], $b1f8f02c080083dc$var$_excluded2 = [
    "children"
];
function $b1f8f02c080083dc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b1f8f02c080083dc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b1f8f02c080083dc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b1f8f02c080083dc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b1f8f02c080083dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b1f8f02c080083dc$var$_typeof(o);
}
var $b1f8f02c080083dc$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart'
};
var $b1f8f02c080083dc$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $b1f8f02c080083dc$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $b1f8f02c080083dc$export$59a4d7d024cf1025 = [
    'none'
];
var $b1f8f02c080083dc$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $b1f8f02c080083dc$var$lastChildren = null;
var $b1f8f02c080083dc$var$lastResult = null;
var $b1f8f02c080083dc$export$45b10814cc054894 = function toArray(children) {
    if (children === $b1f8f02c080083dc$var$lastChildren && Array.isArray($b1f8f02c080083dc$var$lastResult)) return $b1f8f02c080083dc$var$lastResult;
    var result = [];
    (0, $cc1z1.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(child)) return;
        if ((0, $6df612c424d59fc3$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $b1f8f02c080083dc$var$lastResult = result;
    $b1f8f02c080083dc$var$lastChildren = children;
    return result;
};
function $b1f8f02c080083dc$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $b1f8f02c080083dc$export$be63e0664592e141(t);
    });
    else types = [
        $b1f8f02c080083dc$export$be63e0664592e141(type)
    ];
    $b1f8f02c080083dc$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $b1f8f02c080083dc$export$64c61536a2b72e0f(children, type) {
    var result = $b1f8f02c080083dc$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $b1f8f02c080083dc$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $b1f8f02c080083dc$export$be63e0664592e141(t);
    });
    else types = [
        $b1f8f02c080083dc$export$be63e0664592e141(type)
    ];
    $b1f8f02c080083dc$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $b1f8f02c080083dc$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $b1f8f02c080083dc$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $b1f8f02c080083dc$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(child.type) && $b1f8f02c080083dc$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $b1f8f02c080083dc$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $b1f8f02c080083dc$var$_typeof(dot) === 'object' && 'cx' in dot && 'cy' in dot && 'r' in dot;
};
var $b1f8f02c080083dc$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $657f06ff92323a96$export$2b22758266a6fa48) === null || (0, $657f06ff92323a96$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $657f06ff92323a96$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $657f06ff92323a96$export$190f430946f96110).includes(key)) || includeEvents && (0, $657f06ff92323a96$export$f30789245f2c4d11).includes(key);
};
var $b1f8f02c080083dc$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $b1f8f02c080083dc$export$45b10814cc054894(children).forEach(function(entry) {
        if ($b1f8f02c080083dc$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $b1f8f02c080083dc$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($b1f8f02c080083dc$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $b1f8f02c080083dc$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $cc1z1.Children).count(nextChildren);
    if (count !== (0, $cc1z1.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $b1f8f02c080083dc$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$b1f8f02c080083dc$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $b1f8f02c080083dc$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $b1f8f02c080083dc$var$_objectWithoutProperties(_ref, $b1f8f02c080083dc$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $b1f8f02c080083dc$var$_objectWithoutProperties(_ref2, $b1f8f02c080083dc$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(nextProps, prevProps) && $b1f8f02c080083dc$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $b1f8f02c080083dc$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $b1f8f02c080083dc$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($b1f8f02c080083dc$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $b1f8f02c080083dc$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $b1f8f02c080083dc$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $b1f8f02c080083dc$var$REACT_BROWSER_EVENT_MAP[type]) return $b1f8f02c080083dc$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $b1f8f02c080083dc$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $b1f8f02c080083dc$export$45b10814cc054894(children).indexOf(child);
};


var $ed1bcafbb483d3fc$var$_excluded = [
    "children",
    "className"
];
function $ed1bcafbb483d3fc$var$_extends() {
    $ed1bcafbb483d3fc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed1bcafbb483d3fc$var$_extends.apply(this, arguments);
}
function $ed1bcafbb483d3fc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed1bcafbb483d3fc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed1bcafbb483d3fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ed1bcafbb483d3fc$export$936d0764594b6eb3 = /*#__PURE__*/ (0, $cc1z1.default).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $ed1bcafbb483d3fc$var$_objectWithoutProperties(props, $ed1bcafbb483d3fc$var$_excluded);
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-layer', className);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("g", $ed1bcafbb483d3fc$var$_extends({
        className: layerClass
    }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $cc1z1 = parcelRequire("cc1z1");


var $494eec35962a5568$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $494eec35962a5568$var$_extends() {
    $494eec35962a5568$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $494eec35962a5568$var$_extends.apply(this, arguments);
}
function $494eec35962a5568$var$_slicedToArray(arr, i) {
    return $494eec35962a5568$var$_arrayWithHoles(arr) || $494eec35962a5568$var$_iterableToArrayLimit(arr, i) || $494eec35962a5568$var$_unsupportedIterableToArray(arr, i) || $494eec35962a5568$var$_nonIterableRest();
}
function $494eec35962a5568$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $494eec35962a5568$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $494eec35962a5568$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $494eec35962a5568$var$_arrayLikeToArray(o, minLen);
}
function $494eec35962a5568$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $494eec35962a5568$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $494eec35962a5568$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $494eec35962a5568$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $494eec35962a5568$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $494eec35962a5568$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $494eec35962a5568$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $494eec35962a5568$var$_objectWithoutProperties(props, $494eec35962a5568$var$_excluded);
    var svgProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $494eec35962a5568$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === 'vertical') {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === 'horizontal') {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), $494eec35962a5568$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, $cc1z1.default).createElement("line", $494eec35962a5568$var$_extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$494eec35962a5568$export$4f4d7676bdf949e5.defaultProps = {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
};
$494eec35962a5568$export$4f4d7676bdf949e5.displayName = 'ErrorBar';


/**
 * @fileOverview Cross
 */ var $42007edcf77c4e67$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$42007edcf77c4e67$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $cc1z1 = parcelRequire("cc1z1");



var $57b78d271a66dba0$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $57b78d271a66dba0$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$57b78d271a66dba0$exports = $57b78d271a66dba0$var$last;



var $cc1z1 = parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");




parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");
var $cc1z1 = parcelRequire("cc1z1");






function $98bad4436ed1bf96$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $98bad4436ed1bf96$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98bad4436ed1bf96$var$_typeof(o);
}
function $98bad4436ed1bf96$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98bad4436ed1bf96$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98bad4436ed1bf96$var$ownKeys(Object(t), !0).forEach(function(r) {
            $98bad4436ed1bf96$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98bad4436ed1bf96$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $98bad4436ed1bf96$var$_defineProperty(obj, key, value) {
    key = $98bad4436ed1bf96$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98bad4436ed1bf96$var$_toPropertyKey(arg) {
    var key = $98bad4436ed1bf96$var$_toPrimitive(arg, "string");
    return $98bad4436ed1bf96$var$_typeof(key) === "symbol" ? key : String(key);
}
function $98bad4436ed1bf96$var$_toPrimitive(input, hint) {
    if ($98bad4436ed1bf96$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($98bad4436ed1bf96$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $98bad4436ed1bf96$var$_toConsumableArray(arr) {
    return $98bad4436ed1bf96$var$_arrayWithoutHoles(arr) || $98bad4436ed1bf96$var$_iterableToArray(arr) || $98bad4436ed1bf96$var$_unsupportedIterableToArray(arr) || $98bad4436ed1bf96$var$_nonIterableSpread();
}
function $98bad4436ed1bf96$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $98bad4436ed1bf96$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $98bad4436ed1bf96$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $98bad4436ed1bf96$var$_arrayLikeToArray(o, minLen);
}
function $98bad4436ed1bf96$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $98bad4436ed1bf96$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $98bad4436ed1bf96$var$_arrayLikeToArray(arr);
}
function $98bad4436ed1bf96$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $98bad4436ed1bf96$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $98bad4436ed1bf96$var$MAX_CACHE_NUM = 2000;
var $98bad4436ed1bf96$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $98bad4436ed1bf96$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $98bad4436ed1bf96$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $98bad4436ed1bf96$var$autoCompleteStyle(name, value) {
    if ($98bad4436ed1bf96$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $98bad4436ed1bf96$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($98bad4436ed1bf96$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($98bad4436ed1bf96$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $98bad4436ed1bf96$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($98bad4436ed1bf96$var$camelToMiddleLine(s), ":").concat($98bad4436ed1bf96$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $98bad4436ed1bf96$var$removeInvalidKeys(obj) {
    var copyObj = $98bad4436ed1bf96$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $98bad4436ed1bf96$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $d71a8156ac4ac220$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $98bad4436ed1bf96$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($98bad4436ed1bf96$var$stringCache.widthCache[cacheKey]) return $98bad4436ed1bf96$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($98bad4436ed1bf96$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $98bad4436ed1bf96$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $98bad4436ed1bf96$var$_objectSpread($98bad4436ed1bf96$var$_objectSpread({}, $98bad4436ed1bf96$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $98bad4436ed1bf96$var$stringCache.widthCache[cacheKey] = result;
        if (++$98bad4436ed1bf96$var$stringCache.cacheCount > $98bad4436ed1bf96$var$MAX_CACHE_NUM) {
            $98bad4436ed1bf96$var$stringCache.cacheCount = 0;
            $98bad4436ed1bf96$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $98bad4436ed1bf96$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $f54895d2e4c56ed1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f54895d2e4c56ed1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f54895d2e4c56ed1$var$_typeof(o);
}
function $f54895d2e4c56ed1$var$_slicedToArray(arr, i) {
    return $f54895d2e4c56ed1$var$_arrayWithHoles(arr) || $f54895d2e4c56ed1$var$_iterableToArrayLimit(arr, i) || $f54895d2e4c56ed1$var$_unsupportedIterableToArray(arr, i) || $f54895d2e4c56ed1$var$_nonIterableRest();
}
function $f54895d2e4c56ed1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f54895d2e4c56ed1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f54895d2e4c56ed1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f54895d2e4c56ed1$var$_arrayLikeToArray(o, minLen);
}
function $f54895d2e4c56ed1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f54895d2e4c56ed1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f54895d2e4c56ed1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f54895d2e4c56ed1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f54895d2e4c56ed1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f54895d2e4c56ed1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f54895d2e4c56ed1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f54895d2e4c56ed1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f54895d2e4c56ed1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f54895d2e4c56ed1$var$_toPropertyKey(arg) {
    var key = $f54895d2e4c56ed1$var$_toPrimitive(arg, "string");
    return $f54895d2e4c56ed1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f54895d2e4c56ed1$var$_toPrimitive(input, hint) {
    if ($f54895d2e4c56ed1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f54895d2e4c56ed1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f54895d2e4c56ed1$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f54895d2e4c56ed1$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $f54895d2e4c56ed1$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $f54895d2e4c56ed1$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $f54895d2e4c56ed1$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $f54895d2e4c56ed1$var$FIXED_CSS_LENGTH_UNITS = Object.keys($f54895d2e4c56ed1$var$CONVERSION_RATES);
var $f54895d2e4c56ed1$var$STR_NAN = 'NaN';
function $f54895d2e4c56ed1$var$convertToPx(value, unit) {
    return value * $f54895d2e4c56ed1$var$CONVERSION_RATES[unit];
}
var $f54895d2e4c56ed1$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $f54895d2e4c56ed1$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$f54895d2e4c56ed1$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($f54895d2e4c56ed1$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $f54895d2e4c56ed1$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    $f54895d2e4c56ed1$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $f54895d2e4c56ed1$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $f54895d2e4c56ed1$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
    return DecimalCSS;
}();
function $f54895d2e4c56ed1$var$calculateArithmetic(expr) {
    if (expr.includes($f54895d2e4c56ed1$var$STR_NAN)) return $f54895d2e4c56ed1$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $f54895d2e4c56ed1$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $f54895d2e4c56ed1$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $f54895d2e4c56ed1$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $f54895d2e4c56ed1$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $f54895d2e4c56ed1$var$STR_NAN;
        newExpr = newExpr.replace($f54895d2e4c56ed1$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $f54895d2e4c56ed1$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $f54895d2e4c56ed1$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $f54895d2e4c56ed1$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $f54895d2e4c56ed1$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $f54895d2e4c56ed1$var$STR_NAN;
        newExpr = newExpr.replace($f54895d2e4c56ed1$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $f54895d2e4c56ed1$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $f54895d2e4c56ed1$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $f54895d2e4c56ed1$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $f54895d2e4c56ed1$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($f54895d2e4c56ed1$var$PARENTHESES_REGEX, $f54895d2e4c56ed1$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $f54895d2e4c56ed1$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $f54895d2e4c56ed1$var$calculateParentheses(newExpr);
    newExpr = $f54895d2e4c56ed1$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $f54895d2e4c56ed1$export$c891f73c9c6d00c9(expression) {
    try {
        return $f54895d2e4c56ed1$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $f54895d2e4c56ed1$var$STR_NAN;
    }
}
function $f54895d2e4c56ed1$export$254eac204f89fd7d(expression) {
    var result = $f54895d2e4c56ed1$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $f54895d2e4c56ed1$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $2e68399382b2db06$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $2e68399382b2db06$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $2e68399382b2db06$var$_extends() {
    $2e68399382b2db06$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e68399382b2db06$var$_extends.apply(this, arguments);
}
function $2e68399382b2db06$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2e68399382b2db06$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2e68399382b2db06$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2e68399382b2db06$var$_slicedToArray(arr, i) {
    return $2e68399382b2db06$var$_arrayWithHoles(arr) || $2e68399382b2db06$var$_iterableToArrayLimit(arr, i) || $2e68399382b2db06$var$_unsupportedIterableToArray(arr, i) || $2e68399382b2db06$var$_nonIterableRest();
}
function $2e68399382b2db06$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2e68399382b2db06$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2e68399382b2db06$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2e68399382b2db06$var$_arrayLikeToArray(o, minLen);
}
function $2e68399382b2db06$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2e68399382b2db06$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2e68399382b2db06$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2e68399382b2db06$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $2e68399382b2db06$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($2e68399382b2db06$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $98bad4436ed1bf96$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $98bad4436ed1bf96$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $2e68399382b2db06$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $2e68399382b2db06$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $2e68399382b2db06$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $2e68399382b2db06$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $2e68399382b2db06$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(children) ? children.toString().split($2e68399382b2db06$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $2e68399382b2db06$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $d71a8156ac4ac220$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $2e68399382b2db06$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $2e68399382b2db06$var$getWordsWithoutCalculate(children);
        return $2e68399382b2db06$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $2e68399382b2db06$var$getWordsWithoutCalculate(children);
};
var $2e68399382b2db06$var$DEFAULT_FILL = '#808080';
var $2e68399382b2db06$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $2e68399382b2db06$var$DEFAULT_FILL : _ref5$fill, props = $2e68399382b2db06$var$_objectWithoutProperties(_ref5, $2e68399382b2db06$var$_excluded);
    var wordsByLines = (0, $bNI4e.useMemo)(function() {
        return $2e68399382b2db06$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $2e68399382b2db06$var$_objectWithoutProperties(props, $2e68399382b2db06$var$_excluded2);
    if (!(0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(propsX) || !(0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $f54895d2e4c56ed1$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $f54895d2e4c56ed1$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $f54895d2e4c56ed1$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("text", $2e68399382b2db06$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $2e68399382b2db06$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return /*#__PURE__*/ (0, $cc1z1.default).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};






var $022293936b79bb8c$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$022293936b79bb8c$exports = (parcelRequire("dFdXR"));


var $fa6e68063d1269cb$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$fa6e68063d1269cb$exports = (parcelRequire("1NVAl"));


var $c5775412b2b86797$exports = {};
var $ec8077fd32e47748$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $ec8077fd32e47748$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8b4462bc4faef8d5$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$ec8077fd32e47748$exports = $ec8077fd32e47748$var$baseExtremum;


var $5380b285fa604042$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $5380b285fa604042$var$baseGt(value, other) {
    return value > other;
}
$5380b285fa604042$exports = $5380b285fa604042$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $c5775412b2b86797$var$max(array) {
    return array && array.length ? $ec8077fd32e47748$exports(array, $a01605c0b9170e37$exports, $5380b285fa604042$exports) : undefined;
}
$c5775412b2b86797$exports = $c5775412b2b86797$var$max;


var $b031a9f603845483$exports = {};

var $b8066e65c6b81f99$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $b8066e65c6b81f99$var$baseLt(value, other) {
    return value < other;
}
$b8066e65c6b81f99$exports = $b8066e65c6b81f99$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $b031a9f603845483$var$min(array) {
    return array && array.length ? $ec8077fd32e47748$exports(array, $a01605c0b9170e37$exports, $b8066e65c6b81f99$exports) : undefined;
}
$b031a9f603845483$exports = $b031a9f603845483$var$min;






var $bb36b29820e0ab34$exports = {};

var $f1eba2a77eb2763a$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $f1eba2a77eb2763a$var$map(collection, iteratee) {
    var func = $0222e83d73c8b1f6$exports(collection) ? $6eb862b6f66dbf42$exports : $dbf52a6dafa521e4$exports;
    return func(collection, $a582a3ff9e0dc197$exports(iteratee, 3));
}
$f1eba2a77eb2763a$exports = $f1eba2a77eb2763a$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $bb36b29820e0ab34$var$flatMap(collection, iteratee) {
    return $7b5e66b57ad8b66a$exports($f1eba2a77eb2763a$exports(collection, iteratee), 1);
}
$bb36b29820e0ab34$exports = $bb36b29820e0ab34$var$flatMap;



var $70049ad970d2f01c$exports = {};
var $9b142c9f898be072$exports = {};
var $6b563d1e6e25e9fa$exports = {};
var $d3b2c8d9eaaa6665$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $d3b2c8d9eaaa6665$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$d3b2c8d9eaaa6665$exports = $d3b2c8d9eaaa6665$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $6b563d1e6e25e9fa$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $d3b2c8d9eaaa6665$exports(array, start, end);
}
$6b563d1e6e25e9fa$exports = $6b563d1e6e25e9fa$var$castSlice;


var $bf80999351f927bb$exports = {};
/** Used to compose unicode character classes. */ var $bf80999351f927bb$var$rsAstralRange = '\\ud800-\\udfff', $bf80999351f927bb$var$rsComboMarksRange = '\\u0300-\\u036f', $bf80999351f927bb$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $bf80999351f927bb$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $bf80999351f927bb$var$rsComboRange = $bf80999351f927bb$var$rsComboMarksRange + $bf80999351f927bb$var$reComboHalfMarksRange + $bf80999351f927bb$var$rsComboSymbolsRange, $bf80999351f927bb$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $bf80999351f927bb$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $bf80999351f927bb$var$reHasUnicode = RegExp('[' + $bf80999351f927bb$var$rsZWJ + $bf80999351f927bb$var$rsAstralRange + $bf80999351f927bb$var$rsComboRange + $bf80999351f927bb$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $bf80999351f927bb$var$hasUnicode(string) {
    return $bf80999351f927bb$var$reHasUnicode.test(string);
}
$bf80999351f927bb$exports = $bf80999351f927bb$var$hasUnicode;


var $08c681c24d7024ab$exports = {};
var $c1b212a2c51620b1$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c1b212a2c51620b1$var$asciiToArray(string) {
    return string.split('');
}
$c1b212a2c51620b1$exports = $c1b212a2c51620b1$var$asciiToArray;



var $7b41c20079904c36$exports = {};
/** Used to compose unicode character classes. */ var $7b41c20079904c36$var$rsAstralRange = '\\ud800-\\udfff', $7b41c20079904c36$var$rsComboMarksRange = '\\u0300-\\u036f', $7b41c20079904c36$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7b41c20079904c36$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7b41c20079904c36$var$rsComboRange = $7b41c20079904c36$var$rsComboMarksRange + $7b41c20079904c36$var$reComboHalfMarksRange + $7b41c20079904c36$var$rsComboSymbolsRange, $7b41c20079904c36$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7b41c20079904c36$var$rsAstral = '[' + $7b41c20079904c36$var$rsAstralRange + ']', $7b41c20079904c36$var$rsCombo = '[' + $7b41c20079904c36$var$rsComboRange + ']', $7b41c20079904c36$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7b41c20079904c36$var$rsModifier = '(?:' + $7b41c20079904c36$var$rsCombo + '|' + $7b41c20079904c36$var$rsFitz + ')', $7b41c20079904c36$var$rsNonAstral = '[^' + $7b41c20079904c36$var$rsAstralRange + ']', $7b41c20079904c36$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7b41c20079904c36$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7b41c20079904c36$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7b41c20079904c36$var$reOptMod = $7b41c20079904c36$var$rsModifier + '?', $7b41c20079904c36$var$rsOptVar = '[' + $7b41c20079904c36$var$rsVarRange + ']?', $7b41c20079904c36$var$rsOptJoin = '(?:' + $7b41c20079904c36$var$rsZWJ + '(?:' + [
    $7b41c20079904c36$var$rsNonAstral,
    $7b41c20079904c36$var$rsRegional,
    $7b41c20079904c36$var$rsSurrPair
].join('|') + ')' + $7b41c20079904c36$var$rsOptVar + $7b41c20079904c36$var$reOptMod + ')*', $7b41c20079904c36$var$rsSeq = $7b41c20079904c36$var$rsOptVar + $7b41c20079904c36$var$reOptMod + $7b41c20079904c36$var$rsOptJoin, $7b41c20079904c36$var$rsSymbol = '(?:' + [
    $7b41c20079904c36$var$rsNonAstral + $7b41c20079904c36$var$rsCombo + '?',
    $7b41c20079904c36$var$rsCombo,
    $7b41c20079904c36$var$rsRegional,
    $7b41c20079904c36$var$rsSurrPair,
    $7b41c20079904c36$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7b41c20079904c36$var$reUnicode = RegExp($7b41c20079904c36$var$rsFitz + '(?=' + $7b41c20079904c36$var$rsFitz + ')|' + $7b41c20079904c36$var$rsSymbol + $7b41c20079904c36$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7b41c20079904c36$var$unicodeToArray(string) {
    return string.match($7b41c20079904c36$var$reUnicode) || [];
}
$7b41c20079904c36$exports = $7b41c20079904c36$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $08c681c24d7024ab$var$stringToArray(string) {
    return $bf80999351f927bb$exports(string) ? $7b41c20079904c36$exports(string) : $c1b212a2c51620b1$exports(string);
}
$08c681c24d7024ab$exports = $08c681c24d7024ab$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $9b142c9f898be072$var$createCaseFirst(methodName) {
    return function(string) {
        string = $405e052344f77616$exports(string);
        var strSymbols = $bf80999351f927bb$exports(string) ? $08c681c24d7024ab$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $6b563d1e6e25e9fa$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$9b142c9f898be072$exports = $9b142c9f898be072$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $70049ad970d2f01c$var$upperFirst = $9b142c9f898be072$exports('toUpperCase');
$70049ad970d2f01c$exports = $70049ad970d2f01c$var$upperFirst;




var $532334add61a05ec$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($532334add61a05ec$exports) $532334add61a05ec$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($532334add61a05ec$exports);


function $419019cb38132445$var$_toConsumableArray(arr) {
    return $419019cb38132445$var$_arrayWithoutHoles(arr) || $419019cb38132445$var$_iterableToArray(arr) || $419019cb38132445$var$_unsupportedIterableToArray(arr) || $419019cb38132445$var$_nonIterableSpread();
}
function $419019cb38132445$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $419019cb38132445$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $419019cb38132445$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $419019cb38132445$var$_arrayLikeToArray(o, minLen);
}
function $419019cb38132445$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $419019cb38132445$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $419019cb38132445$var$_arrayLikeToArray(arr);
}
function $419019cb38132445$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $419019cb38132445$var$identity = function identity(i) {
    return i;
};
var $419019cb38132445$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $419019cb38132445$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $419019cb38132445$export$ca73b6d700d0505;
};
var $419019cb38132445$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $419019cb38132445$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $419019cb38132445$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $419019cb38132445$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $419019cb38132445$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $419019cb38132445$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $419019cb38132445$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $419019cb38132445$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $419019cb38132445$export$c3095a23b368d1f2 = function curry(fn) {
    return $419019cb38132445$var$curryN(fn.length, fn);
};
var $419019cb38132445$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $419019cb38132445$export$871de8747c9eaa88 = $419019cb38132445$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $419019cb38132445$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $419019cb38132445$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $419019cb38132445$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $419019cb38132445$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $5524d450465dc78c$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $5524d450465dc78c$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $5524d450465dc78c$var$interpolateNumber = (0, $419019cb38132445$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $5524d450465dc78c$var$uninterpolateNumber = (0, $419019cb38132445$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $5524d450465dc78c$var$uninterpolateTruncation = (0, $419019cb38132445$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $5524d450465dc78c$export$2e2bcd8739ae039 = {
    rangeStep: $5524d450465dc78c$var$rangeStep,
    getDigitCount: $5524d450465dc78c$var$getDigitCount,
    interpolateNumber: $5524d450465dc78c$var$interpolateNumber,
    uninterpolateNumber: $5524d450465dc78c$var$uninterpolateNumber,
    uninterpolateTruncation: $5524d450465dc78c$var$uninterpolateTruncation
};


function $627e38b519297aac$var$_toConsumableArray(arr) {
    return $627e38b519297aac$var$_arrayWithoutHoles(arr) || $627e38b519297aac$var$_iterableToArray(arr) || $627e38b519297aac$var$_unsupportedIterableToArray(arr) || $627e38b519297aac$var$_nonIterableSpread();
}
function $627e38b519297aac$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $627e38b519297aac$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $627e38b519297aac$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $627e38b519297aac$var$_arrayLikeToArray(arr);
}
function $627e38b519297aac$var$_slicedToArray(arr, i) {
    return $627e38b519297aac$var$_arrayWithHoles(arr) || $627e38b519297aac$var$_iterableToArrayLimit(arr, i) || $627e38b519297aac$var$_unsupportedIterableToArray(arr, i) || $627e38b519297aac$var$_nonIterableRest();
}
function $627e38b519297aac$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $627e38b519297aac$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $627e38b519297aac$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $627e38b519297aac$var$_arrayLikeToArray(o, minLen);
}
function $627e38b519297aac$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $627e38b519297aac$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $627e38b519297aac$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $627e38b519297aac$var$getValidInterval(_ref) {
    var _ref2 = $627e38b519297aac$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $627e38b519297aac$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0);
    var digitCount = (0, $5524d450465dc78c$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $627e38b519297aac$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(10).pow((0, $5524d450465dc78c$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $419019cb38132445$export$f672e0b6f7222cd7)((0, $419019cb38132445$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $419019cb38132445$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $627e38b519297aac$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $627e38b519297aac$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $627e38b519297aac$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $627e38b519297aac$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $627e38b519297aac$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $627e38b519297aac$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $627e38b519297aac$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($627e38b519297aac$var$_toConsumableArray((0, $419019cb38132445$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($627e38b519297aac$var$_toConsumableArray((0, $419019cb38132445$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $419019cb38132445$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $627e38b519297aac$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $627e38b519297aac$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $5524d450465dc78c$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $419019cb38132445$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $627e38b519297aac$var$getTickValuesFn(_ref5) {
    var _ref6 = $627e38b519297aac$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $627e38b519297aac$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $627e38b519297aac$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $627e38b519297aac$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $627e38b519297aac$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $419019cb38132445$export$f672e0b6f7222cd7)((0, $419019cb38132445$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(n).mul(step)).toNumber();
    }), (0, $419019cb38132445$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $419019cb38132445$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $627e38b519297aac$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $627e38b519297aac$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $627e38b519297aac$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $627e38b519297aac$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $627e38b519297aac$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($627e38b519297aac$var$_toConsumableArray((0, $5524d450465dc78c$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($532334add61a05ec$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $419019cb38132445$export$66c1ae025e96b4bc)(values) : values;
}
var $627e38b519297aac$export$b84e75ccbfe6a612 = (0, $419019cb38132445$export$fc10aeed3a532e2a)($627e38b519297aac$var$getNiceTickValuesFn);
var $627e38b519297aac$export$4cc7a216492b1f53 = (0, $419019cb38132445$export$fc10aeed3a532e2a)($627e38b519297aac$var$getTickValuesFn);
var $627e38b519297aac$export$e9d28da780436e98 = (0, $419019cb38132445$export$fc10aeed3a532e2a)($627e38b519297aac$var$getTickValuesFixedDomainFn);








var $cc1z1 = parcelRequire("cc1z1");

var $cc1z1 = parcelRequire("cc1z1");


/* eslint no-console: 0 */ var $487ff3b439f3c4cb$var$isDev = false;
var $487ff3b439f3c4cb$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($487ff3b439f3c4cb$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $cc1z1 = parcelRequire("cc1z1");


var $7d40de5656ef76d3$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $7d40de5656ef76d3$var$_extends() {
    $7d40de5656ef76d3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d40de5656ef76d3$var$_extends.apply(this, arguments);
}
function $7d40de5656ef76d3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7d40de5656ef76d3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7d40de5656ef76d3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7d40de5656ef76d3$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $7d40de5656ef76d3$var$_objectWithoutProperties(props, $7d40de5656ef76d3$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-surface', className);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("svg", $7d40de5656ef76d3$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, $cc1z1.default).createElement("title", null, title), /*#__PURE__*/ (0, $cc1z1.default).createElement("desc", null, desc), children);
}



var $cc1z1 = parcelRequire("cc1z1");




function $3c9f4907410ce0bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c9f4907410ce0bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c9f4907410ce0bb$var$_typeof(o);
}
var $3c9f4907410ce0bb$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $3c9f4907410ce0bb$var$_extends() {
    $3c9f4907410ce0bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c9f4907410ce0bb$var$_extends.apply(this, arguments);
}
function $3c9f4907410ce0bb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c9f4907410ce0bb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c9f4907410ce0bb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3c9f4907410ce0bb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c9f4907410ce0bb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c9f4907410ce0bb$var$_defineProperty(obj, key, value) {
    key = $3c9f4907410ce0bb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c9f4907410ce0bb$var$_toPropertyKey(arg) {
    var key = $3c9f4907410ce0bb$var$_toPrimitive(arg, "string");
    return $3c9f4907410ce0bb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3c9f4907410ce0bb$var$_toPrimitive(input, hint) {
    if ($3c9f4907410ce0bb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3c9f4907410ce0bb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3c9f4907410ce0bb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3c9f4907410ce0bb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3c9f4907410ce0bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3c9f4907410ce0bb$var$symbolFactories = {
    symbolCircle: (0, $fa6e68063d1269cb$exports.symbolCircle),
    symbolCross: (0, $fa6e68063d1269cb$exports.symbolCross),
    symbolDiamond: (0, $fa6e68063d1269cb$exports.symbolDiamond),
    symbolSquare: (0, $fa6e68063d1269cb$exports.symbolSquare),
    symbolStar: (0, $fa6e68063d1269cb$exports.symbolStar),
    symbolTriangle: (0, $fa6e68063d1269cb$exports.symbolTriangle),
    symbolWye: (0, $fa6e68063d1269cb$exports.symbolWye)
};
var $3c9f4907410ce0bb$var$RADIAN = Math.PI / 180;
var $3c9f4907410ce0bb$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($70049ad970d2f01c$exports)))(type));
    return $3c9f4907410ce0bb$var$symbolFactories[name] || (0, $fa6e68063d1269cb$exports.symbolCircle);
};
var $3c9f4907410ce0bb$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $3c9f4907410ce0bb$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $3c9f4907410ce0bb$var$registerSymbol = function registerSymbol(key, factory) {
    $3c9f4907410ce0bb$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($70049ad970d2f01c$exports)))(key))] = factory;
};
var $3c9f4907410ce0bb$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $3c9f4907410ce0bb$var$_objectWithoutProperties(_ref, $3c9f4907410ce0bb$var$_excluded);
    var props = $3c9f4907410ce0bb$var$_objectSpread($3c9f4907410ce0bb$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $3c9f4907410ce0bb$var$getSymbolFactory(type);
        var symbol = (0, $fa6e68063d1269cb$exports.symbol)().type(symbolFactory).size($3c9f4907410ce0bb$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $3c9f4907410ce0bb$var$_extends({}, filteredProps, {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$3c9f4907410ce0bb$export$fa456266707bf4e4.registerSymbol = $3c9f4907410ce0bb$var$registerSymbol;



function $7d91d609b48fa53f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d91d609b48fa53f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d91d609b48fa53f$var$_typeof(o);
}
function $7d91d609b48fa53f$var$_extends() {
    $7d91d609b48fa53f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d91d609b48fa53f$var$_extends.apply(this, arguments);
}
function $7d91d609b48fa53f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d91d609b48fa53f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d91d609b48fa53f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7d91d609b48fa53f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d91d609b48fa53f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d91d609b48fa53f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d91d609b48fa53f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d91d609b48fa53f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d91d609b48fa53f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d91d609b48fa53f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d91d609b48fa53f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d91d609b48fa53f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7d91d609b48fa53f$var$_setPrototypeOf(subClass, superClass);
}
function $7d91d609b48fa53f$var$_setPrototypeOf(o, p) {
    $7d91d609b48fa53f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d91d609b48fa53f$var$_setPrototypeOf(o, p);
}
function $7d91d609b48fa53f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7d91d609b48fa53f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7d91d609b48fa53f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7d91d609b48fa53f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7d91d609b48fa53f$var$_possibleConstructorReturn(this, result);
    };
}
function $7d91d609b48fa53f$var$_possibleConstructorReturn(self, call) {
    if (call && ($7d91d609b48fa53f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7d91d609b48fa53f$var$_assertThisInitialized(self);
}
function $7d91d609b48fa53f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7d91d609b48fa53f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7d91d609b48fa53f$var$_getPrototypeOf(o) {
    $7d91d609b48fa53f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7d91d609b48fa53f$var$_getPrototypeOf(o);
}
function $7d91d609b48fa53f$var$_defineProperty(obj, key, value) {
    key = $7d91d609b48fa53f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d91d609b48fa53f$var$_toPropertyKey(arg) {
    var key = $7d91d609b48fa53f$var$_toPrimitive(arg, "string");
    return $7d91d609b48fa53f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7d91d609b48fa53f$var$_toPrimitive(input, hint) {
    if ($7d91d609b48fa53f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7d91d609b48fa53f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7d91d609b48fa53f$var$SIZE = 32;
var $7d91d609b48fa53f$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $7d91d609b48fa53f$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $7d91d609b48fa53f$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $7d91d609b48fa53f$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $7d91d609b48fa53f$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $7d91d609b48fa53f$var$SIZE / 2;
                var sixthSize = $7d91d609b48fa53f$var$SIZE / 6;
                var thirdSize = $7d91d609b48fa53f$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, $cc1z1.default).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $7d91d609b48fa53f$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($7d91d609b48fa53f$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($7d91d609b48fa53f$var$SIZE / 8, "h").concat($7d91d609b48fa53f$var$SIZE, "v").concat($7d91d609b48fa53f$var$SIZE * 3 / 4, "h").concat(-$7d91d609b48fa53f$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(data.legendIcon)) {
                    var iconProps = $7d91d609b48fa53f$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, $cc1z1.default).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $3c9f4907410ce0bb$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $7d91d609b48fa53f$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $7d91d609b48fa53f$var$SIZE,
                    height: $7d91d609b48fa53f$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _clsx;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)((_clsx = {
                        'recharts-legend-item': true
                    }, $7d91d609b48fa53f$var$_defineProperty(_clsx, "legend-item-".concat(i), true), $7d91d609b48fa53f$var$_defineProperty(_clsx, "inactive", entry.inactive), _clsx));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(entry.value) ? entry.value : null;
                    (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement("li", $7d91d609b48fa53f$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $657f06ff92323a96$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7d40de5656ef76d3$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, $cc1z1.default).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $cc1z1.PureComponent));
$7d91d609b48fa53f$var$_defineProperty($7d91d609b48fa53f$export$99f8d96ed0cededa, "displayName", 'Legend');
$7d91d609b48fa53f$var$_defineProperty($7d91d609b48fa53f$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});




function $5cdde4f7478aafc0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5cdde4f7478aafc0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5cdde4f7478aafc0$var$_typeof(o);
}
var $5cdde4f7478aafc0$var$_excluded = [
    "ref"
];
function $5cdde4f7478aafc0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cdde4f7478aafc0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cdde4f7478aafc0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5cdde4f7478aafc0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cdde4f7478aafc0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5cdde4f7478aafc0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5cdde4f7478aafc0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5cdde4f7478aafc0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5cdde4f7478aafc0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5cdde4f7478aafc0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5cdde4f7478aafc0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5cdde4f7478aafc0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5cdde4f7478aafc0$var$_setPrototypeOf(subClass, superClass);
}
function $5cdde4f7478aafc0$var$_setPrototypeOf(o, p) {
    $5cdde4f7478aafc0$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5cdde4f7478aafc0$var$_setPrototypeOf(o, p);
}
function $5cdde4f7478aafc0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5cdde4f7478aafc0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5cdde4f7478aafc0$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5cdde4f7478aafc0$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5cdde4f7478aafc0$var$_possibleConstructorReturn(this, result);
    };
}
function $5cdde4f7478aafc0$var$_possibleConstructorReturn(self, call) {
    if (call && ($5cdde4f7478aafc0$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5cdde4f7478aafc0$var$_assertThisInitialized(self);
}
function $5cdde4f7478aafc0$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5cdde4f7478aafc0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5cdde4f7478aafc0$var$_getPrototypeOf(o) {
    $5cdde4f7478aafc0$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5cdde4f7478aafc0$var$_getPrototypeOf(o);
}
function $5cdde4f7478aafc0$var$_defineProperty(obj, key, value) {
    key = $5cdde4f7478aafc0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5cdde4f7478aafc0$var$_toPropertyKey(arg) {
    var key = $5cdde4f7478aafc0$var$_toPrimitive(arg, "string");
    return $5cdde4f7478aafc0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5cdde4f7478aafc0$var$_toPrimitive(input, hint) {
    if ($5cdde4f7478aafc0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5cdde4f7478aafc0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5cdde4f7478aafc0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5cdde4f7478aafc0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5cdde4f7478aafc0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5cdde4f7478aafc0$var$defaultUniqBy(entry) {
    return entry.value;
}
function $5cdde4f7478aafc0$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(content)) return /*#__PURE__*/ (0, $cc1z1.default).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, $cc1z1.default).createElement(content, props);
    var ref = props.ref, otherProps = $5cdde4f7478aafc0$var$_objectWithoutProperties(props, $5cdde4f7478aafc0$var$_excluded);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7d91d609b48fa53f$export$99f8d96ed0cededa), otherProps);
}
var $5cdde4f7478aafc0$var$EPS = 1;
var $5cdde4f7478aafc0$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $5cdde4f7478aafc0$var$_inherits(Legend, _PureComponent);
    var _super = $5cdde4f7478aafc0$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $5cdde4f7478aafc0$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5cdde4f7478aafc0$var$_defineProperty($5cdde4f7478aafc0$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $5cdde4f7478aafc0$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box.width - this.lastBoundingBox.width) > $5cdde4f7478aafc0$var$EPS || Math.abs(_box.height - this.lastBoundingBox.height) > $5cdde4f7478aafc0$var$EPS) {
                        this.lastBoundingBox.width = _box.width;
                        this.lastBoundingBox.height = _box.height;
                        if (onBBoxUpdate) onBBoxUpdate(_box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $5cdde4f7478aafc0$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $5cdde4f7478aafc0$var$_objectSpread($5cdde4f7478aafc0$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $5cdde4f7478aafc0$var$_objectSpread($5cdde4f7478aafc0$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $5cdde4f7478aafc0$var$renderContent(content, $5cdde4f7478aafc0$var$_objectSpread($5cdde4f7478aafc0$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $9a656273db1543d8$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $5cdde4f7478aafc0$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === 'vertical' && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $cc1z1.PureComponent));
$5cdde4f7478aafc0$var$_defineProperty($5cdde4f7478aafc0$export$ed247974535929c7, "displayName", 'Legend');
$5cdde4f7478aafc0$var$_defineProperty($5cdde4f7478aafc0$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $0062722651e9e5c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0062722651e9e5c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0062722651e9e5c8$var$_typeof(o);
}
function $0062722651e9e5c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0062722651e9e5c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0062722651e9e5c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0062722651e9e5c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0062722651e9e5c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0062722651e9e5c8$var$_defineProperty(obj, key, value) {
    key = $0062722651e9e5c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0062722651e9e5c8$var$_toPropertyKey(arg) {
    var key = $0062722651e9e5c8$var$_toPrimitive(arg, "string");
    return $0062722651e9e5c8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0062722651e9e5c8$var$_toPrimitive(input, hint) {
    if ($0062722651e9e5c8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0062722651e9e5c8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0062722651e9e5c8$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $5cdde4f7478aafc0$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || 'square',
            color: (0, $bf3ae02ac3b2bcdf$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $0062722651e9e5c8$var$_objectSpread($0062722651e9e5c8$var$_objectSpread($0062722651e9e5c8$var$_objectSpread({}, legendItem.props), (0, $5cdde4f7478aafc0$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $bf3ae02ac3b2bcdf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bf3ae02ac3b2bcdf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bf3ae02ac3b2bcdf$var$_typeof(o);
}
function $bf3ae02ac3b2bcdf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf3ae02ac3b2bcdf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf3ae02ac3b2bcdf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bf3ae02ac3b2bcdf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf3ae02ac3b2bcdf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bf3ae02ac3b2bcdf$var$_defineProperty(obj, key, value) {
    key = $bf3ae02ac3b2bcdf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf3ae02ac3b2bcdf$var$_toPropertyKey(arg) {
    var key = $bf3ae02ac3b2bcdf$var$_toPrimitive(arg, "string");
    return $bf3ae02ac3b2bcdf$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bf3ae02ac3b2bcdf$var$_toPrimitive(input, hint) {
    if ($bf3ae02ac3b2bcdf$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bf3ae02ac3b2bcdf$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bf3ae02ac3b2bcdf$var$_toConsumableArray(arr) {
    return $bf3ae02ac3b2bcdf$var$_arrayWithoutHoles(arr) || $bf3ae02ac3b2bcdf$var$_iterableToArray(arr) || $bf3ae02ac3b2bcdf$var$_unsupportedIterableToArray(arr) || $bf3ae02ac3b2bcdf$var$_nonIterableSpread();
}
function $bf3ae02ac3b2bcdf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bf3ae02ac3b2bcdf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bf3ae02ac3b2bcdf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bf3ae02ac3b2bcdf$var$_arrayLikeToArray(o, minLen);
}
function $bf3ae02ac3b2bcdf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bf3ae02ac3b2bcdf$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bf3ae02ac3b2bcdf$var$_arrayLikeToArray(arr);
}
function $bf3ae02ac3b2bcdf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(dataKey)) return defaultValue;
    if ((0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($bb36b29820e0ab34$exports)))(data, function(entry) {
        return $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($b031a9f603845483$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($c5775412b2b86797$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $bf3ae02ac3b2bcdf$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(cur - before) !== (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(after - cur) === (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $bf3ae02ac3b2bcdf$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $bf3ae02ac3b2bcdf$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $b1f8f02c080083dc$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $bf3ae02ac3b2bcdf$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($bf3ae02ac3b2bcdf$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($bf3ae02ac3b2bcdf$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $bf3ae02ac3b2bcdf$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $0062722651e9e5c8$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(offset[align])) return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, offset), {}, $bf3ae02ac3b2bcdf$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(offset[verticalAlign])) return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, offset), {}, $bf3ae02ac3b2bcdf$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $bf3ae02ac3b2bcdf$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $bf3ae02ac3b2bcdf$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $494eec35962a5568$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $bf3ae02ac3b2bcdf$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($b031a9f603845483$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($c5775412b2b86797$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $bf3ae02ac3b2bcdf$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $bf3ae02ac3b2bcdf$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $bf3ae02ac3b2bcdf$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $bf3ae02ac3b2bcdf$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $bf3ae02ac3b2bcdf$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $bf3ae02ac3b2bcdf$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($8672b9db6ee461d3$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $bf3ae02ac3b2bcdf$var$handlerWeakMap = new WeakMap();
var $bf3ae02ac3b2bcdf$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$bf3ae02ac3b2bcdf$var$handlerWeakMap.has(defaultHandler)) $bf3ae02ac3b2bcdf$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $bf3ae02ac3b2bcdf$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $bf3ae02ac3b2bcdf$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $022293936b79bb8c$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $022293936b79bb8c$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $022293936b79bb8c$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $022293936b79bb8c$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $022293936b79bb8c$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($16fa8ba01192b4c0$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($70049ad970d2f01c$exports)))(scale));
        return {
            scale: ($022293936b79bb8c$exports[name] || $022293936b79bb8c$exports.scalePoint)(),
            realScaleType: $022293936b79bb8c$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $022293936b79bb8c$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $bf3ae02ac3b2bcdf$var$EPS = 1e-4;
var $bf3ae02ac3b2bcdf$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $bf3ae02ac3b2bcdf$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $bf3ae02ac3b2bcdf$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $bf3ae02ac3b2bcdf$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $bf3ae02ac3b2bcdf$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(domain[0]) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $bf3ae02ac3b2bcdf$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8672b9db6ee461d3$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $bf3ae02ac3b2bcdf$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8672b9db6ee461d3$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $bf3ae02ac3b2bcdf$var$STACK_OFFSET_MAP = {
    sign: $bf3ae02ac3b2bcdf$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $fa6e68063d1269cb$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $fa6e68063d1269cb$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $fa6e68063d1269cb$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $fa6e68063d1269cb$exports.stackOffsetWiggle),
    positive: $bf3ae02ac3b2bcdf$export$9f2c6ead70935022
};
var $bf3ae02ac3b2bcdf$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $bf3ae02ac3b2bcdf$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $fa6e68063d1269cb$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$bf3ae02ac3b2bcdf$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $fa6e68063d1269cb$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $bf3ae02ac3b2bcdf$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $147f5ef07a9ae0e2$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, result), {}, $bf3ae02ac3b2bcdf$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, res), {}, $bf3ae02ac3b2bcdf$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $bf3ae02ac3b2bcdf$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, result), {}, $bf3ae02ac3b2bcdf$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $bf3ae02ac3b2bcdf$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $627e38b519297aac$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($b031a9f603845483$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($c5775412b2b86797$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $627e38b519297aac$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $bf3ae02ac3b2bcdf$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $147f5ef07a9ae0e2$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(value) ? axis.scale(value) : null;
};
var $bf3ae02ac3b2bcdf$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $bf3ae02ac3b2bcdf$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $bf3ae02ac3b2bcdf$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $bf3ae02ac3b2bcdf$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($b031a9f603845483$exports)))(entry.concat([
                result[0]
            ]).filter((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($c5775412b2b86797$exports)))(entry.concat([
                result[1]
            ]).filter((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $bf3ae02ac3b2bcdf$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $bf3ae02ac3b2bcdf$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $bf3ae02ac3b2bcdf$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $bf3ae02ac3b2bcdf$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $bf3ae02ac3b2bcdf$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($bf3ae02ac3b2bcdf$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$bf3ae02ac3b2bcdf$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($bf3ae02ac3b2bcdf$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$bf3ae02ac3b2bcdf$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $bf3ae02ac3b2bcdf$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($94f228f85e408a75$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $bf3ae02ac3b2bcdf$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0e8f7400a8be2107$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $bf3ae02ac3b2bcdf$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $bf3ae02ac3b2bcdf$var$_objectSpread($bf3ae02ac3b2bcdf$var$_objectSpread({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $bf3ae02ac3b2bcdf$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $bf3ae02ac3b2bcdf$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $6e0fc928c0e2bfed$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e0fc928c0e2bfed$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e0fc928c0e2bfed$var$_typeof(o);
}
function $6e0fc928c0e2bfed$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e0fc928c0e2bfed$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e0fc928c0e2bfed$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6e0fc928c0e2bfed$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e0fc928c0e2bfed$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6e0fc928c0e2bfed$var$_defineProperty(obj, key, value) {
    key = $6e0fc928c0e2bfed$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e0fc928c0e2bfed$var$_toPropertyKey(arg) {
    var key = $6e0fc928c0e2bfed$var$_toPrimitive(arg, "string");
    return $6e0fc928c0e2bfed$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6e0fc928c0e2bfed$var$_toPrimitive(input, hint) {
    if ($6e0fc928c0e2bfed$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6e0fc928c0e2bfed$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6e0fc928c0e2bfed$var$_slicedToArray(arr, i) {
    return $6e0fc928c0e2bfed$var$_arrayWithHoles(arr) || $6e0fc928c0e2bfed$var$_iterableToArrayLimit(arr, i) || $6e0fc928c0e2bfed$var$_unsupportedIterableToArray(arr, i) || $6e0fc928c0e2bfed$var$_nonIterableRest();
}
function $6e0fc928c0e2bfed$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e0fc928c0e2bfed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e0fc928c0e2bfed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e0fc928c0e2bfed$var$_arrayLikeToArray(o, minLen);
}
function $6e0fc928c0e2bfed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6e0fc928c0e2bfed$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6e0fc928c0e2bfed$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6e0fc928c0e2bfed$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $6e0fc928c0e2bfed$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $6e0fc928c0e2bfed$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $6e0fc928c0e2bfed$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$6e0fc928c0e2bfed$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$6e0fc928c0e2bfed$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $6e0fc928c0e2bfed$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $6e0fc928c0e2bfed$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $6e0fc928c0e2bfed$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $6e0fc928c0e2bfed$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $bf3ae02ac3b2bcdf$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $bf3ae02ac3b2bcdf$export$9d80152e23bae434)(scale);
        var ticks = (0, $bf3ae02ac3b2bcdf$export$ac086aaa4358d590)(scale, $6e0fc928c0e2bfed$var$_objectSpread($6e0fc928c0e2bfed$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $6e0fc928c0e2bfed$var$_objectSpread($6e0fc928c0e2bfed$var$_objectSpread($6e0fc928c0e2bfed$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $6e0fc928c0e2bfed$var$_objectSpread($6e0fc928c0e2bfed$var$_objectSpread({}, result), {}, $6e0fc928c0e2bfed$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $6e0fc928c0e2bfed$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $6e0fc928c0e2bfed$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $6e0fc928c0e2bfed$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $6e0fc928c0e2bfed$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $6e0fc928c0e2bfed$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $6e0fc928c0e2bfed$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $6e0fc928c0e2bfed$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $6e0fc928c0e2bfed$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $6e0fc928c0e2bfed$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $6e0fc928c0e2bfed$var$_objectSpread($6e0fc928c0e2bfed$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $6e0fc928c0e2bfed$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $cd26824173997fc5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cd26824173997fc5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cd26824173997fc5$var$_typeof(o);
}
var $cd26824173997fc5$var$_excluded = [
    "offset"
];
function $cd26824173997fc5$var$_toConsumableArray(arr) {
    return $cd26824173997fc5$var$_arrayWithoutHoles(arr) || $cd26824173997fc5$var$_iterableToArray(arr) || $cd26824173997fc5$var$_unsupportedIterableToArray(arr) || $cd26824173997fc5$var$_nonIterableSpread();
}
function $cd26824173997fc5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cd26824173997fc5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cd26824173997fc5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cd26824173997fc5$var$_arrayLikeToArray(o, minLen);
}
function $cd26824173997fc5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cd26824173997fc5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cd26824173997fc5$var$_arrayLikeToArray(arr);
}
function $cd26824173997fc5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cd26824173997fc5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cd26824173997fc5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cd26824173997fc5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cd26824173997fc5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd26824173997fc5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd26824173997fc5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd26824173997fc5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd26824173997fc5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd26824173997fc5$var$_defineProperty(obj, key, value) {
    key = $cd26824173997fc5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cd26824173997fc5$var$_toPropertyKey(arg) {
    var key = $cd26824173997fc5$var$_toPrimitive(arg, "string");
    return $cd26824173997fc5$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cd26824173997fc5$var$_toPrimitive(input, hint) {
    if ($cd26824173997fc5$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cd26824173997fc5$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cd26824173997fc5$var$_extends() {
    $cd26824173997fc5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cd26824173997fc5$var$_extends.apply(this, arguments);
}
var $cd26824173997fc5$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(formatter)) return formatter(label);
    return label;
};
var $cd26824173997fc5$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $cd26824173997fc5$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $cd26824173997fc5$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(labelProps.id) ? (0, $147f5ef07a9ae0e2$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("text", $cd26824173997fc5$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, $cc1z1.default).createElement("defs", null, /*#__PURE__*/ (0, $cc1z1.default).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, $cc1z1.default).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $cd26824173997fc5$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $cd26824173997fc5$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $cd26824173997fc5$var$_objectSpread($cd26824173997fc5$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $cd26824173997fc5$var$_objectSpread($cd26824173997fc5$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $cd26824173997fc5$var$_objectSpread($cd26824173997fc5$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $cd26824173997fc5$var$_objectSpread($cd26824173997fc5$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $cd26824173997fc5$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $cd26824173997fc5$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $cd26824173997fc5$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $cd26824173997fc5$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $cd26824173997fc5$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $cd26824173997fc5$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $cd26824173997fc5$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $cd26824173997fc5$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(position) && ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(position.x) || (0, $147f5ef07a9ae0e2$export$e50269385c77c348)(position.x)) && ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(position.y) || (0, $147f5ef07a9ae0e2$export$e50269385c77c348)(position.y))) return $cd26824173997fc5$var$_objectSpread({
        x: x + (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $cd26824173997fc5$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $cd26824173997fc5$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(viewBox.cx);
};
function $cd26824173997fc5$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $cd26824173997fc5$var$_objectWithoutProperties(_ref4, $cd26824173997fc5$var$_excluded);
    var props = $cd26824173997fc5$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(children) && !/*#__PURE__*/ (0, $cc1z1.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(content)) return /*#__PURE__*/ (0, $cc1z1.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(content)) {
        label = /*#__PURE__*/ (0, $hURbM.createElement)(content, props);
        if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(label)) return label;
    } else label = $cd26824173997fc5$var$getLabel(props);
    var isPolarLabel = $cd26824173997fc5$var$isPolar(viewBox);
    var attrs = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $cd26824173997fc5$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $cd26824173997fc5$var$getAttrsOfPolarLabel(props) : $cd26824173997fc5$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $2e68399382b2db06$export$5f1af8db9871e1d6), $cd26824173997fc5$var$_extends({
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$cd26824173997fc5$export$b04be29aa201d4f5.displayName = 'Label';
var $cd26824173997fc5$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(width) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(height)) {
        if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(x) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(top) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(x) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(cx) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $cd26824173997fc5$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, $cc1z1.default).createElement($cd26824173997fc5$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, $cc1z1.default).createElement($cd26824173997fc5$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(label)) {
        if (label.type === $cd26824173997fc5$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $cc1z1.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, $cc1z1.default).createElement($cd26824173997fc5$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(label)) return /*#__PURE__*/ (0, $cc1z1.default).createElement($cd26824173997fc5$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(label)) return /*#__PURE__*/ (0, $cc1z1.default).createElement($cd26824173997fc5$export$b04be29aa201d4f5, $cd26824173997fc5$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $cd26824173997fc5$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $cd26824173997fc5$var$parseViewBox(parentProps);
    var explicitChildren = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, $cd26824173997fc5$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $cc1z1.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $cd26824173997fc5$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($cd26824173997fc5$var$_toConsumableArray(explicitChildren));
};
$cd26824173997fc5$export$b04be29aa201d4f5.parseViewBox = $cd26824173997fc5$var$parseViewBox;
$cd26824173997fc5$export$b04be29aa201d4f5.renderCallByParent = $cd26824173997fc5$var$renderCallByParent;





function $6e269cf1f0cccf21$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e269cf1f0cccf21$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e269cf1f0cccf21$var$_typeof(o);
}
var $6e269cf1f0cccf21$var$_excluded = [
    "valueAccessor"
], $6e269cf1f0cccf21$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $6e269cf1f0cccf21$var$_toConsumableArray(arr) {
    return $6e269cf1f0cccf21$var$_arrayWithoutHoles(arr) || $6e269cf1f0cccf21$var$_iterableToArray(arr) || $6e269cf1f0cccf21$var$_unsupportedIterableToArray(arr) || $6e269cf1f0cccf21$var$_nonIterableSpread();
}
function $6e269cf1f0cccf21$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e269cf1f0cccf21$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e269cf1f0cccf21$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e269cf1f0cccf21$var$_arrayLikeToArray(o, minLen);
}
function $6e269cf1f0cccf21$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6e269cf1f0cccf21$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6e269cf1f0cccf21$var$_arrayLikeToArray(arr);
}
function $6e269cf1f0cccf21$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6e269cf1f0cccf21$var$_extends() {
    $6e269cf1f0cccf21$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e269cf1f0cccf21$var$_extends.apply(this, arguments);
}
function $6e269cf1f0cccf21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e269cf1f0cccf21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e269cf1f0cccf21$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6e269cf1f0cccf21$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e269cf1f0cccf21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6e269cf1f0cccf21$var$_defineProperty(obj, key, value) {
    key = $6e269cf1f0cccf21$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e269cf1f0cccf21$var$_toPropertyKey(arg) {
    var key = $6e269cf1f0cccf21$var$_toPrimitive(arg, "string");
    return $6e269cf1f0cccf21$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6e269cf1f0cccf21$var$_toPrimitive(input, hint) {
    if ($6e269cf1f0cccf21$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6e269cf1f0cccf21$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6e269cf1f0cccf21$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6e269cf1f0cccf21$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6e269cf1f0cccf21$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6e269cf1f0cccf21$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($57b78d271a66dba0$exports)))(entry.value) : entry.value;
};
function $6e269cf1f0cccf21$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $6e269cf1f0cccf21$var$defaultAccessor : _ref$valueAccessor, restProps = $6e269cf1f0cccf21$var$_objectWithoutProperties(_ref, $6e269cf1f0cccf21$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $6e269cf1f0cccf21$var$_objectWithoutProperties(restProps, $6e269cf1f0cccf21$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $bf3ae02ac3b2bcdf$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $cd26824173997fc5$export$b04be29aa201d4f5), $6e269cf1f0cccf21$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $cd26824173997fc5$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(clockWise) ? entry : $6e269cf1f0cccf21$var$_objectSpread($6e269cf1f0cccf21$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$6e269cf1f0cccf21$export$835fcf23ab7bf88.displayName = 'LabelList';
function $6e269cf1f0cccf21$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, $cc1z1.default).createElement($6e269cf1f0cccf21$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(label)) return /*#__PURE__*/ (0, $cc1z1.default).createElement($6e269cf1f0cccf21$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1f672fed7efed57e$exports)))(label)) return /*#__PURE__*/ (0, $cc1z1.default).createElement($6e269cf1f0cccf21$export$835fcf23ab7bf88, $6e269cf1f0cccf21$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $6e269cf1f0cccf21$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, $6e269cf1f0cccf21$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $cc1z1.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $6e269cf1f0cccf21$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($6e269cf1f0cccf21$var$_toConsumableArray(explicitChildren));
}
$6e269cf1f0cccf21$export$835fcf23ab7bf88.renderCallByParent = $6e269cf1f0cccf21$var$renderCallByParent;








var $cc1z1 = parcelRequire("cc1z1");

var $cc1z1 = parcelRequire("cc1z1");

var $280d7aca2b2fc458$exports = {};

var $cb22bd8c4deddb0f$exports = {};

/** Built-in value references. */ var $cb22bd8c4deddb0f$var$getPrototype = $0085f28775c6c6c3$exports(Object.getPrototypeOf, Object);
$cb22bd8c4deddb0f$exports = $cb22bd8c4deddb0f$var$getPrototype;



/** `Object#toString` result references. */ var $280d7aca2b2fc458$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $280d7aca2b2fc458$var$funcProto = Function.prototype, $280d7aca2b2fc458$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $280d7aca2b2fc458$var$funcToString = $280d7aca2b2fc458$var$funcProto.toString;
/** Used to check objects for own properties. */ var $280d7aca2b2fc458$var$hasOwnProperty = $280d7aca2b2fc458$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $280d7aca2b2fc458$var$objectCtorString = $280d7aca2b2fc458$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $280d7aca2b2fc458$var$isPlainObject(value) {
    if (!$34a8c8cbd9ebf965$exports(value) || $a417b04763129f1c$exports(value) != $280d7aca2b2fc458$var$objectTag) return false;
    var proto = $cb22bd8c4deddb0f$exports(value);
    if (proto === null) return true;
    var Ctor = $280d7aca2b2fc458$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $280d7aca2b2fc458$var$funcToString.call(Ctor) == $280d7aca2b2fc458$var$objectCtorString;
}
$280d7aca2b2fc458$exports = $280d7aca2b2fc458$var$isPlainObject;


var $46df106f4bdb7fb2$exports = {};


/** `Object#toString` result references. */ var $46df106f4bdb7fb2$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $46df106f4bdb7fb2$var$isBoolean(value) {
    return value === true || value === false || $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $46df106f4bdb7fb2$var$boolTag;
}
$46df106f4bdb7fb2$exports = $46df106f4bdb7fb2$var$isBoolean;



parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");
var $cc1z1 = parcelRequire("cc1z1");



function $7bc81dcaebe45bdb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7bc81dcaebe45bdb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7bc81dcaebe45bdb$var$_typeof(o);
}
function $7bc81dcaebe45bdb$var$_extends() {
    $7bc81dcaebe45bdb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7bc81dcaebe45bdb$var$_extends.apply(this, arguments);
}
function $7bc81dcaebe45bdb$var$_slicedToArray(arr, i) {
    return $7bc81dcaebe45bdb$var$_arrayWithHoles(arr) || $7bc81dcaebe45bdb$var$_iterableToArrayLimit(arr, i) || $7bc81dcaebe45bdb$var$_unsupportedIterableToArray(arr, i) || $7bc81dcaebe45bdb$var$_nonIterableRest();
}
function $7bc81dcaebe45bdb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7bc81dcaebe45bdb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7bc81dcaebe45bdb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7bc81dcaebe45bdb$var$_arrayLikeToArray(o, minLen);
}
function $7bc81dcaebe45bdb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7bc81dcaebe45bdb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7bc81dcaebe45bdb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7bc81dcaebe45bdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bc81dcaebe45bdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bc81dcaebe45bdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7bc81dcaebe45bdb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bc81dcaebe45bdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7bc81dcaebe45bdb$var$_defineProperty(obj, key, value) {
    key = $7bc81dcaebe45bdb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7bc81dcaebe45bdb$var$_toPropertyKey(arg) {
    var key = $7bc81dcaebe45bdb$var$_toPrimitive(arg, "string");
    return $7bc81dcaebe45bdb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7bc81dcaebe45bdb$var$_toPrimitive(input, hint) {
    if ($7bc81dcaebe45bdb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7bc81dcaebe45bdb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7bc81dcaebe45bdb$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $7bc81dcaebe45bdb$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $7bc81dcaebe45bdb$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $7bc81dcaebe45bdb$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $7bc81dcaebe45bdb$var$_objectSpread($7bc81dcaebe45bdb$var$_objectSpread({}, $7bc81dcaebe45bdb$var$defaultProps), rectangleProps);
    var pathRef = (0, $bNI4e.useRef)();
    var _useState = (0, $bNI4e.useState)(-1), _useState2 = $7bc81dcaebe45bdb$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $bNI4e.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $7bc81dcaebe45bdb$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $7bc81dcaebe45bdb$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6f0a4edbaa8d1116$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6f0a4edbaa8d1116$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $7bc81dcaebe45bdb$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $7bc81dcaebe45bdb$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};


parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");
var $cc1z1 = parcelRequire("cc1z1");



function $c2b95303d7700213$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c2b95303d7700213$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c2b95303d7700213$var$_typeof(o);
}
function $c2b95303d7700213$var$_extends() {
    $c2b95303d7700213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c2b95303d7700213$var$_extends.apply(this, arguments);
}
function $c2b95303d7700213$var$_slicedToArray(arr, i) {
    return $c2b95303d7700213$var$_arrayWithHoles(arr) || $c2b95303d7700213$var$_iterableToArrayLimit(arr, i) || $c2b95303d7700213$var$_unsupportedIterableToArray(arr, i) || $c2b95303d7700213$var$_nonIterableRest();
}
function $c2b95303d7700213$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c2b95303d7700213$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c2b95303d7700213$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c2b95303d7700213$var$_arrayLikeToArray(o, minLen);
}
function $c2b95303d7700213$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c2b95303d7700213$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c2b95303d7700213$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c2b95303d7700213$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2b95303d7700213$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2b95303d7700213$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c2b95303d7700213$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2b95303d7700213$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2b95303d7700213$var$_defineProperty(obj, key, value) {
    key = $c2b95303d7700213$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2b95303d7700213$var$_toPropertyKey(arg) {
    var key = $c2b95303d7700213$var$_toPrimitive(arg, "string");
    return $c2b95303d7700213$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c2b95303d7700213$var$_toPrimitive(input, hint) {
    if ($c2b95303d7700213$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c2b95303d7700213$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c2b95303d7700213$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $c2b95303d7700213$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $c2b95303d7700213$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $c2b95303d7700213$var$_objectSpread($c2b95303d7700213$var$_objectSpread({}, $c2b95303d7700213$var$defaultProps), props);
    var pathRef = (0, $bNI4e.useRef)();
    var _useState = (0, $bNI4e.useState)(-1), _useState2 = $c2b95303d7700213$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $bNI4e.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, $cc1z1.default).createElement("g", null, /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $c2b95303d7700213$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $c2b95303d7700213$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6f0a4edbaa8d1116$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6f0a4edbaa8d1116$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $c2b95303d7700213$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $c2b95303d7700213$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $cc1z1 = parcelRequire("cc1z1");




function $878a773490592f5c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $878a773490592f5c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $878a773490592f5c$var$_typeof(o);
}
function $878a773490592f5c$var$_extends() {
    $878a773490592f5c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $878a773490592f5c$var$_extends.apply(this, arguments);
}
function $878a773490592f5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $878a773490592f5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $878a773490592f5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $878a773490592f5c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $878a773490592f5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $878a773490592f5c$var$_defineProperty(obj, key, value) {
    key = $878a773490592f5c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $878a773490592f5c$var$_toPropertyKey(arg) {
    var key = $878a773490592f5c$var$_toPrimitive(arg, "string");
    return $878a773490592f5c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $878a773490592f5c$var$_toPrimitive(input, hint) {
    if ($878a773490592f5c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($878a773490592f5c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $878a773490592f5c$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $878a773490592f5c$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $6e0fc928c0e2bfed$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $6e0fc928c0e2bfed$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $878a773490592f5c$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $878a773490592f5c$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $878a773490592f5c$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $878a773490592f5c$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $878a773490592f5c$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $878a773490592f5c$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $878a773490592f5c$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $878a773490592f5c$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $878a773490592f5c$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $878a773490592f5c$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $878a773490592f5c$var$_objectSpread($878a773490592f5c$var$_objectSpread({}, $878a773490592f5c$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $878a773490592f5c$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $878a773490592f5c$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $878a773490592f5c$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $95724e5bd8f30255$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $95724e5bd8f30255$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $95724e5bd8f30255$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95724e5bd8f30255$var$_typeof(o);
}
function $95724e5bd8f30255$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $95724e5bd8f30255$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $95724e5bd8f30255$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $95724e5bd8f30255$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95724e5bd8f30255$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95724e5bd8f30255$var$ownKeys(Object(t), !0).forEach(function(r) {
            $95724e5bd8f30255$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95724e5bd8f30255$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $95724e5bd8f30255$var$_defineProperty(obj, key, value) {
    key = $95724e5bd8f30255$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $95724e5bd8f30255$var$_toPropertyKey(arg) {
    var key = $95724e5bd8f30255$var$_toPrimitive(arg, "string");
    return $95724e5bd8f30255$var$_typeof(key) === "symbol" ? key : String(key);
}
function $95724e5bd8f30255$var$_toPrimitive(input, hint) {
    if ($95724e5bd8f30255$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($95724e5bd8f30255$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $95724e5bd8f30255$var$defaultPropTransformer(option, props) {
    return $95724e5bd8f30255$var$_objectSpread($95724e5bd8f30255$var$_objectSpread({}, props), option);
}
function $95724e5bd8f30255$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $95724e5bd8f30255$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7bc81dcaebe45bdb$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $c2b95303d7700213$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $878a773490592f5c$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($95724e5bd8f30255$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $3c9f4907410ce0bb$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $95724e5bd8f30255$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(option)) return option.props;
    return option;
}
function $95724e5bd8f30255$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $95724e5bd8f30255$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $95724e5bd8f30255$var$_objectWithoutProperties(_ref2, $95724e5bd8f30255$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(option)) shape = /*#__PURE__*/ (0, $cc1z1.cloneElement)(option, $95724e5bd8f30255$var$_objectSpread($95724e5bd8f30255$var$_objectSpread({}, props), $95724e5bd8f30255$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($280d7aca2b2fc458$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($46df106f4bdb7fb2$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, $cc1z1.default).createElement($95724e5bd8f30255$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, $cc1z1.default).createElement($95724e5bd8f30255$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $95724e5bd8f30255$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $95724e5bd8f30255$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $95724e5bd8f30255$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $95724e5bd8f30255$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $95724e5bd8f30255$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $95724e5bd8f30255$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $95724e5bd8f30255$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($95724e5bd8f30255$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $95724e5bd8f30255$export$7c9a98b3f068686f;
    else if ($95724e5bd8f30255$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $95724e5bd8f30255$export$b356b51e8337a02f;
    else if ($95724e5bd8f30255$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $95724e5bd8f30255$export$559c3a78b4889350;
    return comparison;
}
function $95724e5bd8f30255$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($95724e5bd8f30255$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($95724e5bd8f30255$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($95724e5bd8f30255$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $95724e5bd8f30255$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($95724e5bd8f30255$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($95724e5bd8f30255$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($95724e5bd8f30255$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $95724e5bd8f30255$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $95724e5bd8f30255$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $95724e5bd8f30255$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($0e8f7400a8be2107$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $95724e5bd8f30255$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


function $0a71e33a6c616060$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0a71e33a6c616060$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a71e33a6c616060$var$_typeof(o);
}
var $0a71e33a6c616060$var$_excluded = [
    "x",
    "y"
];
function $0a71e33a6c616060$var$_extends() {
    $0a71e33a6c616060$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a71e33a6c616060$var$_extends.apply(this, arguments);
}
function $0a71e33a6c616060$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0a71e33a6c616060$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0a71e33a6c616060$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0a71e33a6c616060$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0a71e33a6c616060$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0a71e33a6c616060$var$_defineProperty(obj, key, value) {
    key = $0a71e33a6c616060$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a71e33a6c616060$var$_toPropertyKey(arg) {
    var key = $0a71e33a6c616060$var$_toPrimitive(arg, "string");
    return $0a71e33a6c616060$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0a71e33a6c616060$var$_toPrimitive(input, hint) {
    if ($0a71e33a6c616060$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0a71e33a6c616060$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0a71e33a6c616060$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0a71e33a6c616060$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0a71e33a6c616060$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, numbe, number, number]
function $0a71e33a6c616060$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $0a71e33a6c616060$var$_objectWithoutProperties(_ref, $0a71e33a6c616060$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $0a71e33a6c616060$var$_objectSpread($0a71e33a6c616060$var$_objectSpread($0a71e33a6c616060$var$_objectSpread($0a71e33a6c616060$var$_objectSpread($0a71e33a6c616060$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $0a71e33a6c616060$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $95724e5bd8f30255$export$6428a7f2611ef1fa), $0a71e33a6c616060$var$_extends({
        shapeType: "rectangle",
        propTransformer: $0a71e33a6c616060$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}


var $aeb13077dc0abc4b$var$_excluded = [
    "value",
    "background"
];
function $aeb13077dc0abc4b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aeb13077dc0abc4b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aeb13077dc0abc4b$var$_typeof(o);
}
function $aeb13077dc0abc4b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $aeb13077dc0abc4b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $aeb13077dc0abc4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $aeb13077dc0abc4b$var$_extends() {
    $aeb13077dc0abc4b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $aeb13077dc0abc4b$var$_extends.apply(this, arguments);
}
function $aeb13077dc0abc4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aeb13077dc0abc4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aeb13077dc0abc4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $aeb13077dc0abc4b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aeb13077dc0abc4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $aeb13077dc0abc4b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aeb13077dc0abc4b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $aeb13077dc0abc4b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $aeb13077dc0abc4b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aeb13077dc0abc4b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aeb13077dc0abc4b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $aeb13077dc0abc4b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $aeb13077dc0abc4b$var$_setPrototypeOf(subClass, superClass);
}
function $aeb13077dc0abc4b$var$_setPrototypeOf(o, p) {
    $aeb13077dc0abc4b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aeb13077dc0abc4b$var$_setPrototypeOf(o, p);
}
function $aeb13077dc0abc4b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $aeb13077dc0abc4b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $aeb13077dc0abc4b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $aeb13077dc0abc4b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $aeb13077dc0abc4b$var$_possibleConstructorReturn(this, result);
    };
}
function $aeb13077dc0abc4b$var$_possibleConstructorReturn(self, call) {
    if (call && ($aeb13077dc0abc4b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $aeb13077dc0abc4b$var$_assertThisInitialized(self);
}
function $aeb13077dc0abc4b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aeb13077dc0abc4b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $aeb13077dc0abc4b$var$_getPrototypeOf(o) {
    $aeb13077dc0abc4b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aeb13077dc0abc4b$var$_getPrototypeOf(o);
}
function $aeb13077dc0abc4b$var$_defineProperty(obj, key, value) {
    key = $aeb13077dc0abc4b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aeb13077dc0abc4b$var$_toPropertyKey(arg) {
    var key = $aeb13077dc0abc4b$var$_toPrimitive(arg, "string");
    return $aeb13077dc0abc4b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $aeb13077dc0abc4b$var$_toPrimitive(input, hint) {
    if ($aeb13077dc0abc4b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($aeb13077dc0abc4b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $aeb13077dc0abc4b$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $aeb13077dc0abc4b$var$_inherits(Bar, _PureComponent);
    var _super = $aeb13077dc0abc4b$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $aeb13077dc0abc4b$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$var$_assertThisInitialized(_this), "id", (0, $147f5ef07a9ae0e2$export$8b15d37bc3f197d4)('recharts-bar-'));
        $aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $aeb13077dc0abc4b$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), $aeb13077dc0abc4b$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $657f06ff92323a96$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $0a71e33a6c616060$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6f0a4edbaa8d1116$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $147f5ef07a9ae0e2$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($0e8f7400a8be2107$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $aeb13077dc0abc4b$var$_objectWithoutProperties(entry, $aeb13077dc0abc4b$var$_excluded);
                    if (!background) return null;
                    var props = $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $657f06ff92323a96$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $0a71e33a6c616060$export$f19074a6842f9217), $aeb13077dc0abc4b$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $494eec35962a5568$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $bf3ae02ac3b2bcdf$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, $cc1z1.default).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, $cc1z1.default).createElement("defs", null, /*#__PURE__*/ (0, $cc1z1.default).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, $cc1z1.default).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $6e269cf1f0cccf21$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $cc1z1.PureComponent));
$aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: true,
    isAnimationActive: !(0, $d71a8156ac4ac220$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $aeb13077dc0abc4b$var$_defineProperty($aeb13077dc0abc4b$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $bf3ae02ac3b2bcdf$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $bf3ae02ac3b2bcdf$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $42007edcf77c4e67$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $bf3ae02ac3b2bcdf$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $bf3ae02ac3b2bcdf$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $bf3ae02ac3b2bcdf$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $bf3ae02ac3b2bcdf$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread($aeb13077dc0abc4b$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $bf3ae02ac3b2bcdf$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $aeb13077dc0abc4b$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Y Axis
 */ var $01d9da6491cd127c$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$01d9da6491cd127c$export$f96c4024c52de8f4.displayName = 'YAxis';
$01d9da6491cd127c$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
};

/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $cd537e8f063d7b4e$export$ea77231de273b52d = function XAxis() {
    return null;
};
$cd537e8f063d7b4e$export$ea77231de273b52d.displayName = 'XAxis';
$cd537e8f063d7b4e$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
};


var $cc1z1 = parcelRequire("cc1z1");



var $8b89cc2109850edc$exports = {};
var $9d810cf51136e250$exports = {};
var $6cfe9f883520c352$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6cfe9f883520c352$var$nativeCeil = Math.ceil, $6cfe9f883520c352$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $6cfe9f883520c352$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $6cfe9f883520c352$var$nativeMax($6cfe9f883520c352$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$6cfe9f883520c352$exports = $6cfe9f883520c352$var$baseRange;



var $3c9bcf8fd7cc4d1e$exports = {};
var $185374bfa30f0a8e$exports = {};
var $ca1ef1e21735539c$exports = {};
var $3e113ae5edd4a751$exports = {};
/** Used to match a single whitespace character. */ var $3e113ae5edd4a751$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3e113ae5edd4a751$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3e113ae5edd4a751$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$3e113ae5edd4a751$exports = $3e113ae5edd4a751$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $ca1ef1e21735539c$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $ca1ef1e21735539c$var$baseTrim(string) {
    return string ? string.slice(0, $3e113ae5edd4a751$exports(string) + 1).replace($ca1ef1e21735539c$var$reTrimStart, '') : string;
}
$ca1ef1e21735539c$exports = $ca1ef1e21735539c$var$baseTrim;




/** Used as references for various `Number` constants. */ var $185374bfa30f0a8e$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $185374bfa30f0a8e$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $185374bfa30f0a8e$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $185374bfa30f0a8e$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $185374bfa30f0a8e$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $185374bfa30f0a8e$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8b4462bc4faef8d5$exports(value)) return $185374bfa30f0a8e$var$NAN;
    if ($1f672fed7efed57e$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $1f672fed7efed57e$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $ca1ef1e21735539c$exports(value);
    var isBinary = $185374bfa30f0a8e$var$reIsBinary.test(value);
    return isBinary || $185374bfa30f0a8e$var$reIsOctal.test(value) ? $185374bfa30f0a8e$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $185374bfa30f0a8e$var$reIsBadHex.test(value) ? $185374bfa30f0a8e$var$NAN : +value;
}
$185374bfa30f0a8e$exports = $185374bfa30f0a8e$var$toNumber;


/** Used as references for various `Number` constants. */ var $3c9bcf8fd7cc4d1e$var$INFINITY = 1 / 0, $3c9bcf8fd7cc4d1e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $3c9bcf8fd7cc4d1e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $185374bfa30f0a8e$exports(value);
    if (value === $3c9bcf8fd7cc4d1e$var$INFINITY || value === -$3c9bcf8fd7cc4d1e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $3c9bcf8fd7cc4d1e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$3c9bcf8fd7cc4d1e$exports = $3c9bcf8fd7cc4d1e$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9d810cf51136e250$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $ff4b2aa90f11886d$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $3c9bcf8fd7cc4d1e$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $3c9bcf8fd7cc4d1e$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $3c9bcf8fd7cc4d1e$exports(step);
        return $6cfe9f883520c352$exports(start, end, step, fromRight);
    };
}
$9d810cf51136e250$exports = $9d810cf51136e250$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $8b89cc2109850edc$var$range = $9d810cf51136e250$exports();
$8b89cc2109850edc$exports = $8b89cc2109850edc$var$range;






function $0b25e7336bae42fc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0b25e7336bae42fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0b25e7336bae42fc$var$_typeof(o);
}
function $0b25e7336bae42fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b25e7336bae42fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b25e7336bae42fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0b25e7336bae42fc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b25e7336bae42fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0b25e7336bae42fc$var$_defineProperty(obj, key, value) {
    key = $0b25e7336bae42fc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0b25e7336bae42fc$var$_toPropertyKey(arg) {
    var key = $0b25e7336bae42fc$var$_toPrimitive(arg, "string");
    return $0b25e7336bae42fc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0b25e7336bae42fc$var$_toPrimitive(input, hint) {
    if ($0b25e7336bae42fc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0b25e7336bae42fc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0b25e7336bae42fc$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $0b25e7336bae42fc$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $0b25e7336bae42fc$var$PREFIX_LIST.reduce(function(res, entry) {
        return $0b25e7336bae42fc$var$_objectSpread($0b25e7336bae42fc$var$_objectSpread({}, res), {}, $0b25e7336bae42fc$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $18c313093ff88748$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $18c313093ff88748$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $18c313093ff88748$var$_typeof(o);
}
function $18c313093ff88748$var$_extends() {
    $18c313093ff88748$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18c313093ff88748$var$_extends.apply(this, arguments);
}
function $18c313093ff88748$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $18c313093ff88748$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $18c313093ff88748$var$ownKeys(Object(t), !0).forEach(function(r) {
            $18c313093ff88748$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $18c313093ff88748$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $18c313093ff88748$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $18c313093ff88748$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $18c313093ff88748$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $18c313093ff88748$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $18c313093ff88748$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $18c313093ff88748$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $18c313093ff88748$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $18c313093ff88748$var$_setPrototypeOf(subClass, superClass);
}
function $18c313093ff88748$var$_setPrototypeOf(o, p) {
    $18c313093ff88748$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $18c313093ff88748$var$_setPrototypeOf(o, p);
}
function $18c313093ff88748$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $18c313093ff88748$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $18c313093ff88748$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $18c313093ff88748$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $18c313093ff88748$var$_possibleConstructorReturn(this, result);
    };
}
function $18c313093ff88748$var$_possibleConstructorReturn(self, call) {
    if (call && ($18c313093ff88748$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $18c313093ff88748$var$_assertThisInitialized(self);
}
function $18c313093ff88748$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $18c313093ff88748$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $18c313093ff88748$var$_getPrototypeOf(o) {
    $18c313093ff88748$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $18c313093ff88748$var$_getPrototypeOf(o);
}
function $18c313093ff88748$var$_defineProperty(obj, key, value) {
    key = $18c313093ff88748$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $18c313093ff88748$var$_toPropertyKey(arg) {
    var key = $18c313093ff88748$var$_toPrimitive(arg, "string");
    return $18c313093ff88748$var$_typeof(key) === "symbol" ? key : String(key);
}
function $18c313093ff88748$var$_toPrimitive(input, hint) {
    if ($18c313093ff88748$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($18c313093ff88748$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $18c313093ff88748$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $022293936b79bb8c$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($8b89cc2109850edc$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $18c313093ff88748$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $18c313093ff88748$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $18c313093ff88748$var$_inherits(Brush, _PureComponent);
    var _super = $18c313093ff88748$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $18c313093ff88748$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $18c313093ff88748$var$_defineProperty($18c313093ff88748$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $18c313093ff88748$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($18c313093ff88748$var$_assertThisInitialized(_this), 'startX'),
            endX: _this.handleTravellerDragStart.bind($18c313093ff88748$var$_assertThisInitialized(_this), 'endX')
        };
        _this.state = {};
        return _this;
    }
    $18c313093ff88748$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $bf3ae02ac3b2bcdf$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $18c313093ff88748$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $18c313093ff88748$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $18c313093ff88748$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($18c313093ff88748$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $cc1z1.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, $cc1z1.default).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $18c313093ff88748$var$_objectSpread($18c313093ff88748$var$_objectSpread({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat(data[startIndex].name, ", Max value: ").concat(data[endIndex].name);
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $2e68399382b2db06$export$5f1af8db9871e1d6), $18c313093ff88748$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $2e68399382b2db06$export$5f1af8db9871e1d6), $18c313093ff88748$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(x) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(y) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(width) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-brush', className);
                var isPanoramic = (0, $cc1z1.default).Children.count(children) === 1;
                var style = (0, $0b25e7336bae42fc$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $cc1z1.default).Fragment, null, /*#__PURE__*/ (0, $cc1z1.default).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, $cc1z1.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, $cc1z1.default).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(option)) rectangle = /*#__PURE__*/ (0, $cc1z1.default).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $18c313093ff88748$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $18c313093ff88748$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $cc1z1.PureComponent));
$18c313093ff88748$var$_defineProperty($18c313093ff88748$export$59bc2e3533b384a0, "displayName", 'Brush');
$18c313093ff88748$var$_defineProperty($18c313093ff88748$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});

/**
 * @fileOverview Bar Chart
 */ 
var $cc1z1 = parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");





var $e1f518da076acbcd$exports = {};
var $bde177b748eb2687$exports = {};

var $ff73c6230a06e510$exports = {};

var $joIhc = parcelRequire("joIhc");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ff73c6230a06e510$var$now = function() {
    return $joIhc.Date.now();
};
$ff73c6230a06e510$exports = $ff73c6230a06e510$var$now;



/** Error message constants. */ var $bde177b748eb2687$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bde177b748eb2687$var$nativeMax = Math.max, $bde177b748eb2687$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $bde177b748eb2687$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($bde177b748eb2687$var$FUNC_ERROR_TEXT);
    wait = $185374bfa30f0a8e$exports(wait) || 0;
    if ($1f672fed7efed57e$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $bde177b748eb2687$var$nativeMax($185374bfa30f0a8e$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $bde177b748eb2687$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ff73c6230a06e510$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ff73c6230a06e510$exports());
    }
    function debounced() {
        var time = $ff73c6230a06e510$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$bde177b748eb2687$exports = $bde177b748eb2687$var$debounce;



/** Error message constants. */ var $e1f518da076acbcd$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $e1f518da076acbcd$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($e1f518da076acbcd$var$FUNC_ERROR_TEXT);
    if ($1f672fed7efed57e$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $bde177b748eb2687$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$e1f518da076acbcd$exports = $e1f518da076acbcd$var$throttle;


var $b9b2bb7082a7ae7f$exports = {};
var $7fac2126da2935f4$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $7fac2126da2935f4$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$1dea69b96520dc48$exports(collection)) {
            var iteratee = $a582a3ff9e0dc197$exports(predicate, 3);
            collection = $31472ad28d4bee36$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$7fac2126da2935f4$exports = $7fac2126da2935f4$var$createFind;


var $81cbe09637d7c092$exports = {};


var $6db2b3698d80e86d$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $6db2b3698d80e86d$var$toInteger(value) {
    var result = $3c9bcf8fd7cc4d1e$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$6db2b3698d80e86d$exports = $6db2b3698d80e86d$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $81cbe09637d7c092$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $81cbe09637d7c092$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $6db2b3698d80e86d$exports(fromIndex);
    if (index < 0) index = $81cbe09637d7c092$var$nativeMax(length + index, 0);
    return $63657c705aa6a1df$exports(array, $a582a3ff9e0dc197$exports(predicate, 3), index);
}
$81cbe09637d7c092$exports = $81cbe09637d7c092$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $b9b2bb7082a7ae7f$var$find = $7fac2126da2935f4$exports($81cbe09637d7c092$exports);
$b9b2bb7082a7ae7f$exports = $b9b2bb7082a7ae7f$var$find;


var $05802c61eae177ba$exports = {};
var $47576f45d2e7cacb$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $47576f45d2e7cacb$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$47576f45d2e7cacb$exports = $47576f45d2e7cacb$var$arrayEvery;


var $7b4d4f23f0fe77f7$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $7b4d4f23f0fe77f7$var$baseEvery(collection, predicate) {
    var result = true;
    $a648ffa9738c6555$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$7b4d4f23f0fe77f7$exports = $7b4d4f23f0fe77f7$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $05802c61eae177ba$var$every(collection, predicate, guard) {
    var func = $0222e83d73c8b1f6$exports(collection) ? $47576f45d2e7cacb$exports : $7b4d4f23f0fe77f7$exports;
    if (guard && $ff4b2aa90f11886d$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $a582a3ff9e0dc197$exports(predicate, 3));
}
$05802c61eae177ba$exports = $05802c61eae177ba$var$every;



var $7a3ddb66cda07bbd$var$isProduction = true;
var $7a3ddb66cda07bbd$var$prefix = 'Invariant failed';
function $7a3ddb66cda07bbd$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($7a3ddb66cda07bbd$var$isProduction) throw new Error($7a3ddb66cda07bbd$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($7a3ddb66cda07bbd$var$prefix, ": ").concat(provided) : $7a3ddb66cda07bbd$var$prefix;
    throw new Error(value);
}



function $c2c296fb8786fe06$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}






var $17a4d3933f7cb405$exports = {};
var $756cf19440863941$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $756cf19440863941$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $1ce0cf72dd2e5e9c$exports) $1ce0cf72dd2e5e9c$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$756cf19440863941$exports = $756cf19440863941$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17a4d3933f7cb405$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $a582a3ff9e0dc197$exports(iteratee, 3);
    $c94d2cf1ef821fdb$exports(object, function(value, key, object) {
        $756cf19440863941$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$17a4d3933f7cb405$exports = $17a4d3933f7cb405$var$mapValues;







function $c9842abf639410a7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c9842abf639410a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c9842abf639410a7$var$_typeof(o);
}
function $c9842abf639410a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c9842abf639410a7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c9842abf639410a7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c9842abf639410a7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c9842abf639410a7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c9842abf639410a7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c9842abf639410a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9842abf639410a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9842abf639410a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c9842abf639410a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9842abf639410a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c9842abf639410a7$var$_defineProperty(obj, key, value) {
    key = $c9842abf639410a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c9842abf639410a7$var$_toPropertyKey(arg) {
    var key = $c9842abf639410a7$var$_toPrimitive(arg, "string");
    return $c9842abf639410a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c9842abf639410a7$var$_toPrimitive(input, hint) {
    if ($c9842abf639410a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c9842abf639410a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c9842abf639410a7$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $aeb13077dc0abc4b$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
            if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === 'no-gap') {
                var gap = (0, $147f5ef07a9ae0e2$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $bf3ae02ac3b2bcdf$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $bf3ae02ac3b2bcdf$export$9d80152e23bae434)(scale);
        var ticks = (0, $bf3ae02ac3b2bcdf$export$ac086aaa4358d590)(scale, $c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $bf3ae02ac3b2bcdf$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread({}, result), {}, $c9842abf639410a7$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $c9842abf639410a7$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $c9842abf639410a7$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $c9842abf639410a7$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $c9842abf639410a7$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $c9842abf639410a7$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $c9842abf639410a7$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$c9842abf639410a7$var$_defineProperty($c9842abf639410a7$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $c9842abf639410a7$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread({}, res), {}, $c9842abf639410a7$var$_defineProperty({}, key, $c9842abf639410a7$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $c9842abf639410a7$var$_objectSpread($c9842abf639410a7$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($17a4d3933f7cb405$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($05802c61eae177ba$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $c9842abf639410a7$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $c9842abf639410a7$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $c9842abf639410a7$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $ee8d87f73fa91e76$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $dbc976d71f5cb0d3$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $c9842abf639410a7$export$3ee78d51cffc2b68)(size, angle);
}
function $dbc976d71f5cb0d3$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $dbc976d71f5cb0d3$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $dbc976d71f5cb0d3$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $ee8d87f73fa91e76$export$41514b9f058a6886)(ticks, interval + 1);
}




function $b1b8c87046229f34$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $ee8d87f73fa91e76$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $dbc976d71f5cb0d3$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $83a9578f9da45222$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $83a9578f9da45222$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $83a9578f9da45222$var$_typeof(o);
}
function $83a9578f9da45222$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $83a9578f9da45222$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $83a9578f9da45222$var$ownKeys(Object(t), !0).forEach(function(r) {
            $83a9578f9da45222$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $83a9578f9da45222$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $83a9578f9da45222$var$_defineProperty(obj, key, value) {
    key = $83a9578f9da45222$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $83a9578f9da45222$var$_toPropertyKey(arg) {
    var key = $83a9578f9da45222$var$_toPrimitive(arg, "string");
    return $83a9578f9da45222$var$_typeof(key) === "symbol" ? key : String(key);
}
function $83a9578f9da45222$var$_toPrimitive(input, hint) {
    if ($83a9578f9da45222$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($83a9578f9da45222$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $83a9578f9da45222$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $dbc976d71f5cb0d3$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $83a9578f9da45222$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $dbc976d71f5cb0d3$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $dbc976d71f5cb0d3$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $83a9578f9da45222$var$_objectSpread($83a9578f9da45222$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $83a9578f9da45222$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(interval) || (0, $d71a8156ac4ac220$export$98f03c5d19621d70).isSsr) return (0, $dbc976d71f5cb0d3$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $98bad4436ed1bf96$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $dbc976d71f5cb0d3$export$a1966f4ad955c82b)((0, $98bad4436ed1bf96$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $98bad4436ed1bf96$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $147f5ef07a9ae0e2$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $dbc976d71f5cb0d3$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $b1b8c87046229f34$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $83a9578f9da45222$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $83a9578f9da45222$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}







var $cc1z1 = parcelRequire("cc1z1");







function $0ac5787e1b21abd2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0ac5787e1b21abd2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0ac5787e1b21abd2$var$_typeof(o);
}
function $0ac5787e1b21abd2$var$_extends() {
    $0ac5787e1b21abd2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ac5787e1b21abd2$var$_extends.apply(this, arguments);
}
function $0ac5787e1b21abd2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ac5787e1b21abd2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ac5787e1b21abd2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0ac5787e1b21abd2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ac5787e1b21abd2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ac5787e1b21abd2$var$_defineProperty(obj, key, value) {
    key = $0ac5787e1b21abd2$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ac5787e1b21abd2$var$_toPropertyKey(arg) {
    var key = $0ac5787e1b21abd2$var$_toPrimitive(arg, "string");
    return $0ac5787e1b21abd2$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0ac5787e1b21abd2$var$_toPrimitive(input, hint) {
    if ($0ac5787e1b21abd2$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0ac5787e1b21abd2$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0ac5787e1b21abd2$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $fa6e68063d1269cb$exports.curveBasisClosed),
    curveBasisOpen: (0, $fa6e68063d1269cb$exports.curveBasisOpen),
    curveBasis: (0, $fa6e68063d1269cb$exports.curveBasis),
    curveBumpX: (0, $fa6e68063d1269cb$exports.curveBumpX),
    curveBumpY: (0, $fa6e68063d1269cb$exports.curveBumpY),
    curveLinearClosed: (0, $fa6e68063d1269cb$exports.curveLinearClosed),
    curveLinear: (0, $fa6e68063d1269cb$exports.curveLinear),
    curveMonotoneX: (0, $fa6e68063d1269cb$exports.curveMonotoneX),
    curveMonotoneY: (0, $fa6e68063d1269cb$exports.curveMonotoneY),
    curveNatural: (0, $fa6e68063d1269cb$exports.curveNatural),
    curveStep: (0, $fa6e68063d1269cb$exports.curveStep),
    curveStepAfter: (0, $fa6e68063d1269cb$exports.curveStepAfter),
    curveStepBefore: (0, $fa6e68063d1269cb$exports.curveStepBefore)
};
var $0ac5787e1b21abd2$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $0ac5787e1b21abd2$var$getX = function getX(p) {
    return p.x;
};
var $0ac5787e1b21abd2$var$getY = function getY(p) {
    return p.y;
};
var $0ac5787e1b21abd2$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($70049ad970d2f01c$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $0ac5787e1b21abd2$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $0ac5787e1b21abd2$var$CURVE_FACTORIES[name] || (0, $fa6e68063d1269cb$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $0ac5787e1b21abd2$var$getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $0ac5787e1b21abd2$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $0ac5787e1b21abd2$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $0ac5787e1b21abd2$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $0ac5787e1b21abd2$var$_objectSpread($0ac5787e1b21abd2$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $fa6e68063d1269cb$exports.area)().y($0ac5787e1b21abd2$var$getY).x1($0ac5787e1b21abd2$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $fa6e68063d1269cb$exports.area)().x($0ac5787e1b21abd2$var$getX).y1($0ac5787e1b21abd2$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($0ac5787e1b21abd2$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $fa6e68063d1269cb$exports.area)().y($0ac5787e1b21abd2$var$getY).x1($0ac5787e1b21abd2$var$getX).x0(baseLine);
    else if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $fa6e68063d1269cb$exports.area)().x($0ac5787e1b21abd2$var$getX).y1($0ac5787e1b21abd2$var$getY).y0(baseLine);
    else lineFunction = (0, $fa6e68063d1269cb$exports.line)().x($0ac5787e1b21abd2$var$getX).y($0ac5787e1b21abd2$var$getY);
    lineFunction.defined($0ac5787e1b21abd2$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $0ac5787e1b21abd2$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $0ac5787e1b21abd2$var$getPath(props) : path;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $0ac5787e1b21abd2$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props), (0, $657f06ff92323a96$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $cc1z1 = parcelRequire("cc1z1");



function $14ab8df44298e55a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $14ab8df44298e55a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $14ab8df44298e55a$var$_typeof(o);
}
var $14ab8df44298e55a$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $14ab8df44298e55a$var$_extends() {
    $14ab8df44298e55a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14ab8df44298e55a$var$_extends.apply(this, arguments);
}
function $14ab8df44298e55a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14ab8df44298e55a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14ab8df44298e55a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $14ab8df44298e55a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14ab8df44298e55a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14ab8df44298e55a$var$_defineProperty(obj, key, value) {
    key = $14ab8df44298e55a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14ab8df44298e55a$var$_toPropertyKey(arg) {
    var key = $14ab8df44298e55a$var$_toPrimitive(arg, "string");
    return $14ab8df44298e55a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $14ab8df44298e55a$var$_toPrimitive(input, hint) {
    if ($14ab8df44298e55a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($14ab8df44298e55a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $14ab8df44298e55a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $14ab8df44298e55a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $14ab8df44298e55a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $14ab8df44298e55a$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $14ab8df44298e55a$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $14ab8df44298e55a$var$_objectWithoutProperties(_ref, $14ab8df44298e55a$var$_excluded);
    var props = $14ab8df44298e55a$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(x) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(y) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(width) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(height) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(top) || !(0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("path", $14ab8df44298e55a$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true), {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-cross', className),
        d: $14ab8df44298e55a$var$getPath(x, y, width, height, top, left)
    }));
};




var $cc1z1 = parcelRequire("cc1z1");



function $d67c0c9d3a215d1a$var$_extends() {
    $d67c0c9d3a215d1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d67c0c9d3a215d1a$var$_extends.apply(this, arguments);
}
var $d67c0c9d3a215d1a$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, $cc1z1.default).createElement("circle", $d67c0c9d3a215d1a$var$_extends({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props), (0, $657f06ff92323a96$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $cc1z1 = parcelRequire("cc1z1");
var $hURbM = parcelRequire("hURbM");











var $6aac8a90771af86b$var$_excluded = [
    "viewBox"
], $6aac8a90771af86b$var$_excluded2 = [
    "viewBox"
], $6aac8a90771af86b$var$_excluded3 = [
    "ticks"
];
function $6aac8a90771af86b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6aac8a90771af86b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6aac8a90771af86b$var$_typeof(o);
}
function $6aac8a90771af86b$var$_extends() {
    $6aac8a90771af86b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6aac8a90771af86b$var$_extends.apply(this, arguments);
}
function $6aac8a90771af86b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6aac8a90771af86b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6aac8a90771af86b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6aac8a90771af86b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6aac8a90771af86b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6aac8a90771af86b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6aac8a90771af86b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6aac8a90771af86b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6aac8a90771af86b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6aac8a90771af86b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6aac8a90771af86b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6aac8a90771af86b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6aac8a90771af86b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6aac8a90771af86b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6aac8a90771af86b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6aac8a90771af86b$var$_setPrototypeOf(subClass, superClass);
}
function $6aac8a90771af86b$var$_setPrototypeOf(o, p) {
    $6aac8a90771af86b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6aac8a90771af86b$var$_setPrototypeOf(o, p);
}
function $6aac8a90771af86b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6aac8a90771af86b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6aac8a90771af86b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6aac8a90771af86b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6aac8a90771af86b$var$_possibleConstructorReturn(this, result);
    };
}
function $6aac8a90771af86b$var$_possibleConstructorReturn(self, call) {
    if (call && ($6aac8a90771af86b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6aac8a90771af86b$var$_assertThisInitialized(self);
}
function $6aac8a90771af86b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6aac8a90771af86b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6aac8a90771af86b$var$_getPrototypeOf(o) {
    $6aac8a90771af86b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6aac8a90771af86b$var$_getPrototypeOf(o);
}
function $6aac8a90771af86b$var$_defineProperty(obj, key, value) {
    key = $6aac8a90771af86b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6aac8a90771af86b$var$_toPropertyKey(arg) {
    var key = $6aac8a90771af86b$var$_toPrimitive(arg, "string");
    return $6aac8a90771af86b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6aac8a90771af86b$var$_toPrimitive(input, hint) {
    if ($6aac8a90771af86b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6aac8a90771af86b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6aac8a90771af86b$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $6aac8a90771af86b$var$_inherits(CartesianAxis, _Component);
    var _super = $6aac8a90771af86b$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $6aac8a90771af86b$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $6aac8a90771af86b$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $6aac8a90771af86b$var$_objectWithoutProperties(_ref, $6aac8a90771af86b$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $6aac8a90771af86b$var$_objectWithoutProperties(_this$props, $6aac8a90771af86b$var$_excluded2);
                return !(0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({}, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(this.props)), (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("line", $6aac8a90771af86b$var$_extends({}, props, {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $83a9578f9da45222$export$3d27d42b1034de5c)($6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(tick);
                var tickLineProps = $6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread($6aac8a90771af86b$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), $6aac8a90771af86b$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $657f06ff92323a96$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, $cc1z1.default).createElement("line", $6aac8a90771af86b$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, $cc1z1.default).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $6aac8a90771af86b$var$_objectWithoutProperties(_this$props8, $6aac8a90771af86b$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
                    className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $cd26824173997fc5$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(option)) tickItem = /*#__PURE__*/ (0, $cc1z1.default).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $2e68399382b2db06$export$5f1af8db9871e1d6), $6aac8a90771af86b$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $hURbM.Component));
$6aac8a90771af86b$var$_defineProperty($6aac8a90771af86b$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$6aac8a90771af86b$var$_defineProperty($6aac8a90771af86b$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});







var $cc1z1 = parcelRequire("cc1z1");






var $4d5944c7dc95c907$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};





function $3bf021f355aa6a25$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3bf021f355aa6a25$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3bf021f355aa6a25$var$_typeof(o);
}
function $3bf021f355aa6a25$var$_extends() {
    $3bf021f355aa6a25$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3bf021f355aa6a25$var$_extends.apply(this, arguments);
}
function $3bf021f355aa6a25$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bf021f355aa6a25$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bf021f355aa6a25$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3bf021f355aa6a25$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bf021f355aa6a25$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3bf021f355aa6a25$var$_defineProperty(obj, key, value) {
    key = $3bf021f355aa6a25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3bf021f355aa6a25$var$_toPropertyKey(arg) {
    var key = $3bf021f355aa6a25$var$_toPrimitive(arg, "string");
    return $3bf021f355aa6a25$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3bf021f355aa6a25$var$_toPrimitive(input, hint) {
    if ($3bf021f355aa6a25$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3bf021f355aa6a25$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3bf021f355aa6a25$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $c9842abf639410a7$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
function $3bf021f355aa6a25$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(x);
    var isY = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(y);
    (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $3bf021f355aa6a25$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $3bf021f355aa6a25$var$_objectSpread($3bf021f355aa6a25$var$_objectSpread({
        clipPath: clipPath
    }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-reference-dot', className)
    }, $3bf021f355aa6a25$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $cd26824173997fc5$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$3bf021f355aa6a25$export$aa7f0b0106bff39.displayName = 'ReferenceDot';
$3bf021f355aa6a25$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
};
$3bf021f355aa6a25$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(option)) dot = /*#__PURE__*/ (0, $cc1z1.default).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $d67c0c9d3a215d1a$export$d046b3c4a416f60d), $3bf021f355aa6a25$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $cc1z1 = parcelRequire("cc1z1");

var $38a9a4dcef533637$exports = {};


var $4e2a8ec47daf84e2$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $4e2a8ec47daf84e2$var$baseSome(collection, predicate) {
    var result;
    $a648ffa9738c6555$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$4e2a8ec47daf84e2$exports = $4e2a8ec47daf84e2$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $38a9a4dcef533637$var$some(collection, predicate, guard) {
    var func = $0222e83d73c8b1f6$exports(collection) ? $7d370f035a2f41ae$exports : $4e2a8ec47daf84e2$exports;
    if (guard && $ff4b2aa90f11886d$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $a582a3ff9e0dc197$exports(predicate, 3));
}
$38a9a4dcef533637$exports = $38a9a4dcef533637$var$some;










function $c443bd229ceb7dde$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c443bd229ceb7dde$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c443bd229ceb7dde$var$_typeof(o);
}
function $c443bd229ceb7dde$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c443bd229ceb7dde$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c443bd229ceb7dde$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c443bd229ceb7dde$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c443bd229ceb7dde$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c443bd229ceb7dde$var$_defineProperty(obj, key, value) {
    key = $c443bd229ceb7dde$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c443bd229ceb7dde$var$_toPropertyKey(arg) {
    var key = $c443bd229ceb7dde$var$_toPrimitive(arg, "string");
    return $c443bd229ceb7dde$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c443bd229ceb7dde$var$_toPrimitive(input, hint) {
    if ($c443bd229ceb7dde$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c443bd229ceb7dde$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c443bd229ceb7dde$var$_slicedToArray(arr, i) {
    return $c443bd229ceb7dde$var$_arrayWithHoles(arr) || $c443bd229ceb7dde$var$_iterableToArrayLimit(arr, i) || $c443bd229ceb7dde$var$_unsupportedIterableToArray(arr, i) || $c443bd229ceb7dde$var$_nonIterableRest();
}
function $c443bd229ceb7dde$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c443bd229ceb7dde$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c443bd229ceb7dde$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c443bd229ceb7dde$var$_arrayLikeToArray(o, minLen);
}
function $c443bd229ceb7dde$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c443bd229ceb7dde$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c443bd229ceb7dde$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c443bd229ceb7dde$var$_extends() {
    $c443bd229ceb7dde$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c443bd229ceb7dde$var$_extends.apply(this, arguments);
}
var $c443bd229ceb7dde$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(option)) line = /*#__PURE__*/ (0, $cc1z1.default).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, $cc1z1.default).createElement("line", $c443bd229ceb7dde$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $c443bd229ceb7dde$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($38a9a4dcef533637$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $c443bd229ceb7dde$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $c9842abf639410a7$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(fixedX);
    var isY = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $c443bd229ceb7dde$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $c443bd229ceb7dde$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $c443bd229ceb7dde$var$_objectSpread($c443bd229ceb7dde$var$_objectSpread({
        clipPath: clipPath
    }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-reference-line', className)
    }, $c443bd229ceb7dde$var$renderLine(shape, lineProps), (0, $cd26824173997fc5$export$b04be29aa201d4f5).renderCallByParent(props, (0, $c9842abf639410a7$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$c443bd229ceb7dde$export$b2f28e248e7838eb.displayName = 'ReferenceLine';
$c443bd229ceb7dde$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
};



var $cc1z1 = parcelRequire("cc1z1");










function $90b435ac1c2ce782$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $90b435ac1c2ce782$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $90b435ac1c2ce782$var$_typeof(o);
}
function $90b435ac1c2ce782$var$_extends() {
    $90b435ac1c2ce782$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $90b435ac1c2ce782$var$_extends.apply(this, arguments);
}
function $90b435ac1c2ce782$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $90b435ac1c2ce782$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $90b435ac1c2ce782$var$ownKeys(Object(t), !0).forEach(function(r) {
            $90b435ac1c2ce782$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $90b435ac1c2ce782$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $90b435ac1c2ce782$var$_defineProperty(obj, key, value) {
    key = $90b435ac1c2ce782$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $90b435ac1c2ce782$var$_toPropertyKey(arg) {
    var key = $90b435ac1c2ce782$var$_toPrimitive(arg, "string");
    return $90b435ac1c2ce782$var$_typeof(key) === "symbol" ? key : String(key);
}
function $90b435ac1c2ce782$var$_toPrimitive(input, hint) {
    if ($90b435ac1c2ce782$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($90b435ac1c2ce782$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $90b435ac1c2ce782$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $c9842abf639410a7$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $c9842abf639410a7$export$c7964a5b9439ae62)(p1, p2);
};
function $90b435ac1c2ce782$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $147f5ef07a9ae0e2$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $90b435ac1c2ce782$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $4d5944c7dc95c907$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-reference-area', className)
    }, $90b435ac1c2ce782$export$b4ec4f050ce240b9.renderRect(shape, $90b435ac1c2ce782$var$_objectSpread($90b435ac1c2ce782$var$_objectSpread({
        clipPath: clipPath
    }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(props, true)), rect)), (0, $cd26824173997fc5$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$90b435ac1c2ce782$export$b4ec4f050ce240b9.displayName = 'ReferenceArea';
$90b435ac1c2ce782$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
};
$90b435ac1c2ce782$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, $cc1z1.default).isValidElement(option)) rect = /*#__PURE__*/ (0, $cc1z1.default).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7bc81dcaebe45bdb$export$4617fb02663045ef), $90b435ac1c2ce782$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $bdca0c941d7d7d5d$var$_toConsumableArray(arr) {
    return $bdca0c941d7d7d5d$var$_arrayWithoutHoles(arr) || $bdca0c941d7d7d5d$var$_iterableToArray(arr) || $bdca0c941d7d7d5d$var$_unsupportedIterableToArray(arr) || $bdca0c941d7d7d5d$var$_nonIterableSpread();
}
function $bdca0c941d7d7d5d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bdca0c941d7d7d5d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bdca0c941d7d7d5d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bdca0c941d7d7d5d$var$_arrayLikeToArray(o, minLen);
}
function $bdca0c941d7d7d5d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bdca0c941d7d7d5d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bdca0c941d7d7d5d$var$_arrayLikeToArray(arr);
}
function $bdca0c941d7d7d5d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $bdca0c941d7d7d5d$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $c443bd229ceb7dde$export$b2f28e248e7838eb));
    var dots = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $3bf021f355aa6a25$export$aa7f0b0106bff39));
    var elements = [].concat($bdca0c941d7d7d5d$var$_toConsumableArray(lines), $bdca0c941d7d7d5d$var$_toConsumableArray(dots));
    var areas = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, (0, $90b435ac1c2ce782$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $4d5944c7dc95c907$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $4d5944c7dc95c907$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(el.props[key1]) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $1543bee13b19bcd1$exports = {};
'use strict';
var $1543bee13b19bcd1$var$has = Object.prototype.hasOwnProperty, $1543bee13b19bcd1$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $1543bee13b19bcd1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $1543bee13b19bcd1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $1543bee13b19bcd1$var$Events().__proto__) $1543bee13b19bcd1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $1543bee13b19bcd1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $1543bee13b19bcd1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $1543bee13b19bcd1$var$EE(fn, context || emitter, once), evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $1543bee13b19bcd1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $1543bee13b19bcd1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $1543bee13b19bcd1$var$EventEmitter() {
    this._events = new $1543bee13b19bcd1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($1543bee13b19bcd1$var$has.call(events, name)) names.push($1543bee13b19bcd1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $1543bee13b19bcd1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $1543bee13b19bcd1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $1543bee13b19bcd1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $1543bee13b19bcd1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $1543bee13b19bcd1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $1543bee13b19bcd1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $1543bee13b19bcd1$var$prefix ? $1543bee13b19bcd1$var$prefix + event : event;
        if (this._events[evt]) $1543bee13b19bcd1$var$clearEvent(this, evt);
    } else {
        this._events = new $1543bee13b19bcd1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$1543bee13b19bcd1$var$EventEmitter.prototype.off = $1543bee13b19bcd1$var$EventEmitter.prototype.removeListener;
$1543bee13b19bcd1$var$EventEmitter.prototype.addListener = $1543bee13b19bcd1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$1543bee13b19bcd1$var$EventEmitter.prefixed = $1543bee13b19bcd1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$1543bee13b19bcd1$var$EventEmitter.EventEmitter = $1543bee13b19bcd1$var$EventEmitter;
$1543bee13b19bcd1$exports = $1543bee13b19bcd1$var$EventEmitter;


var $ef5b552b7d860121$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($1543bee13b19bcd1$exports)))();
var $ef5b552b7d860121$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $11b9d75d241683f7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $11b9d75d241683f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $11b9d75d241683f7$var$_typeof(o);
}
function $11b9d75d241683f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11b9d75d241683f7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $11b9d75d241683f7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $11b9d75d241683f7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $11b9d75d241683f7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b9d75d241683f7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $11b9d75d241683f7$var$_defineProperty(obj, key, value) {
    key = $11b9d75d241683f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11b9d75d241683f7$var$_toPropertyKey(arg) {
    var key = $11b9d75d241683f7$var$_toPrimitive(arg, "string");
    return $11b9d75d241683f7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $11b9d75d241683f7$var$_toPrimitive(input, hint) {
    if ($11b9d75d241683f7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($11b9d75d241683f7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $11b9d75d241683f7$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $11b9d75d241683f7$var$_classCallCheck(this, AccessibilityManager);
        $11b9d75d241683f7$var$_defineProperty(this, "activeIndex", 0);
        $11b9d75d241683f7$var$_defineProperty(this, "coordinateList", []);
        $11b9d75d241683f7$var$_defineProperty(this, "layout", 'horizontal');
    }
    $11b9d75d241683f7$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $513d471df9b7af65$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(domainStart) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}





function $2e3ccb219508743b$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $c2c296fb8786fe06$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}


function $9bed2307dbf66f39$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}


var $3bc50bdd5c30e812$var$_excluded = [
    "item"
], $3bc50bdd5c30e812$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $3bc50bdd5c30e812$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3bc50bdd5c30e812$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3bc50bdd5c30e812$var$_typeof(o);
}
function $3bc50bdd5c30e812$var$_slicedToArray(arr, i) {
    return $3bc50bdd5c30e812$var$_arrayWithHoles(arr) || $3bc50bdd5c30e812$var$_iterableToArrayLimit(arr, i) || $3bc50bdd5c30e812$var$_unsupportedIterableToArray(arr, i) || $3bc50bdd5c30e812$var$_nonIterableRest();
}
function $3bc50bdd5c30e812$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3bc50bdd5c30e812$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3bc50bdd5c30e812$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3bc50bdd5c30e812$var$_extends() {
    $3bc50bdd5c30e812$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3bc50bdd5c30e812$var$_extends.apply(this, arguments);
}
function $3bc50bdd5c30e812$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3bc50bdd5c30e812$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3bc50bdd5c30e812$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3bc50bdd5c30e812$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3bc50bdd5c30e812$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3bc50bdd5c30e812$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3bc50bdd5c30e812$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3bc50bdd5c30e812$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3bc50bdd5c30e812$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3bc50bdd5c30e812$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3bc50bdd5c30e812$var$_setPrototypeOf(subClass, superClass);
}
function $3bc50bdd5c30e812$var$_setPrototypeOf(o, p) {
    $3bc50bdd5c30e812$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3bc50bdd5c30e812$var$_setPrototypeOf(o, p);
}
function $3bc50bdd5c30e812$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3bc50bdd5c30e812$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3bc50bdd5c30e812$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3bc50bdd5c30e812$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3bc50bdd5c30e812$var$_possibleConstructorReturn(this, result);
    };
}
function $3bc50bdd5c30e812$var$_possibleConstructorReturn(self, call) {
    if (call && ($3bc50bdd5c30e812$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3bc50bdd5c30e812$var$_assertThisInitialized(self);
}
function $3bc50bdd5c30e812$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3bc50bdd5c30e812$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3bc50bdd5c30e812$var$_getPrototypeOf(o) {
    $3bc50bdd5c30e812$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3bc50bdd5c30e812$var$_getPrototypeOf(o);
}
function $3bc50bdd5c30e812$var$_toConsumableArray(arr) {
    return $3bc50bdd5c30e812$var$_arrayWithoutHoles(arr) || $3bc50bdd5c30e812$var$_iterableToArray(arr) || $3bc50bdd5c30e812$var$_unsupportedIterableToArray(arr) || $3bc50bdd5c30e812$var$_nonIterableSpread();
}
function $3bc50bdd5c30e812$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3bc50bdd5c30e812$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3bc50bdd5c30e812$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3bc50bdd5c30e812$var$_arrayLikeToArray(o, minLen);
}
function $3bc50bdd5c30e812$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3bc50bdd5c30e812$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3bc50bdd5c30e812$var$_arrayLikeToArray(arr);
}
function $3bc50bdd5c30e812$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3bc50bdd5c30e812$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3bc50bdd5c30e812$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3bc50bdd5c30e812$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3bc50bdd5c30e812$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3bc50bdd5c30e812$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3bc50bdd5c30e812$var$_defineProperty(obj, key, value) {
    key = $3bc50bdd5c30e812$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3bc50bdd5c30e812$var$_toPropertyKey(arg) {
    var key = $3bc50bdd5c30e812$var$_toPrimitive(arg, "string");
    return $3bc50bdd5c30e812$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3bc50bdd5c30e812$var$_toPrimitive(input, hint) {
    if ($3bc50bdd5c30e812$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3bc50bdd5c30e812$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3bc50bdd5c30e812$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $3bc50bdd5c30e812$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $3bc50bdd5c30e812$var$originCoordinate = {
    x: 0,
    y: 0
};
var $3bc50bdd5c30e812$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $3bc50bdd5c30e812$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, rangeObj), (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, rangeObj), (0, $6e0fc928c0e2bfed$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $3bc50bdd5c30e812$var$originCoordinate;
};
var $3bc50bdd5c30e812$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($3bc50bdd5c30e812$var$_toConsumableArray(result), $3bc50bdd5c30e812$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(dataStartIndex) && (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $3bc50bdd5c30e812$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $3bc50bdd5c30e812$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $3bc50bdd5c30e812$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        var hide = child.props.hide;
        if (hide) return result;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $147f5ef07a9ae0e2$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($3bc50bdd5c30e812$var$_toConsumableArray(result), [
            (0, $bf3ae02ac3b2bcdf$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $3bc50bdd5c30e812$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $3bc50bdd5c30e812$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $bf3ae02ac3b2bcdf$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $3bc50bdd5c30e812$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $3bc50bdd5c30e812$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $3bc50bdd5c30e812$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $bf3ae02ac3b2bcdf$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $3bc50bdd5c30e812$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $513d471df9b7af65$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $bf3ae02ac3b2bcdf$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $3bc50bdd5c30e812$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $147f5ef07a9ae0e2$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($8b89cc2109850edc$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $bf3ae02ac3b2bcdf$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($3bc50bdd5c30e812$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $bf3ae02ac3b2bcdf$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(entry) ? finalDomain : [].concat($3bc50bdd5c30e812$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $bf3ae02ac3b2bcdf$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $bf3ae02ac3b2bcdf$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($8b89cc2109850edc$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $bf3ae02ac3b2bcdf$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $bf3ae02ac3b2bcdf$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $bdca0c941d7d7d5d$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $bf3ae02ac3b2bcdf$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, $3bc50bdd5c30e812$var$_defineProperty({}, axisId, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $3bc50bdd5c30e812$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $3bc50bdd5c30e812$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $bf3ae02ac3b2bcdf$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $3bc50bdd5c30e812$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($8b89cc2109850edc$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $bf3ae02ac3b2bcdf$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $bdca0c941d7d7d5d$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $bf3ae02ac3b2bcdf$export$a0bc8660980558a0)(originalDomain, (0, $bf3ae02ac3b2bcdf$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $bdca0c941d7d7d5d$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, $3bc50bdd5c30e812$var$_defineProperty({}, axisId, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))($3bc50bdd5c30e812$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $3bc50bdd5c30e812$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $3bc50bdd5c30e812$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $3bc50bdd5c30e812$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $3bc50bdd5c30e812$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($94f228f85e408a75$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $bf3ae02ac3b2bcdf$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $3bc50bdd5c30e812$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $18c313093ff88748$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $3bc50bdd5c30e812$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $b1f8f02c080083dc$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $3bc50bdd5c30e812$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $3bc50bdd5c30e812$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $18c313093ff88748$export$59bc2e3533b384a0));
    var legendItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $5cdde4f7478aafc0$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, $3bc50bdd5c30e812$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, $3bc50bdd5c30e812$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $18c313093ff88748$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $bf3ae02ac3b2bcdf$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
var $3bc50bdd5c30e812$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $3bc50bdd5c30e812$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $3bc50bdd5c30e812$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $bf3ae02ac3b2bcdf$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $3bc50bdd5c30e812$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type, _objectSpread6;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $7a3ddb66cda07bbd$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $3bc50bdd5c30e812$var$_defineProperty(_objectSpread6, entry.axisType, axis), $3bc50bdd5c30e812$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $bf3ae02ac3b2bcdf$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $b1f8f02c080083dc$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $bf3ae02ac3b2bcdf$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $bf3ae02ac3b2bcdf$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $bf3ae02ac3b2bcdf$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, pos), {}, {
                        position: $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, composedFn($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $3bc50bdd5c30e812$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $3bc50bdd5c30e812$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $3bc50bdd5c30e812$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $b1f8f02c080083dc$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $b1f8f02c080083dc$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $3bc50bdd5c30e812$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $b1f8f02c080083dc$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $bf3ae02ac3b2bcdf$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, result), {}, $3bc50bdd5c30e812$var$_defineProperty({}, name, $3bc50bdd5c30e812$var$getAxisMap(props, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $3bc50bdd5c30e812$var$calculateOffset($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $3bc50bdd5c30e812$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $3bc50bdd5c30e812$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $3bc50bdd5c30e812$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $3bc50bdd5c30e812$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $11b9d75d241683f7$export$a2c2de1efa8671eb)());
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($3bc50bdd5c30e812$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $3bc50bdd5c30e812$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $b1f8f02c080083dc$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $ef5b552b7d860121$export$9bcdfe5f29bb33).emit((0, $ef5b552b7d860121$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($3bc50bdd5c30e812$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $3bc50bdd5c30e812$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $3bc50bdd5c30e812$var$originCoordinate;
                    _this.setState($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10, syncWithTicks) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $bf3ae02ac3b2bcdf$export$846dc5ac5fecff74)((0, $83a9578f9da45222$export$3d27d42b1034de5c)($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, (0, $6aac8a90771af86b$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width, syncWithTicks);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11, syncWithTicks) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $bf3ae02ac3b2bcdf$export$846dc5ac5fecff74)((0, $83a9578f9da45222$export$3d27d42b1034de5c)($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, (0, $6aac8a90771af86b$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height, syncWithTicks);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(axis, true);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $0ac5787e1b21abd2$export$b0e83c3ef8d2db1);
                if (chartName === 'ScatterChart') {
                    restProps = activeCoordinate;
                    cursorComp = (0, $14ab8df44298e55a$export$3c877bb842c36952);
                } else if (chartName === 'BarChart') {
                    restProps = (0, $9bed2307dbf66f39$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
                    cursorComp = (0, $7bc81dcaebe45bdb$export$4617fb02663045ef);
                } else if (layout === 'radial') {
                    var _getRadialCursorPoint = (0, $c2c296fb8786fe06$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $878a773490592f5c$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: (0, $2e3ccb219508743b$export$56e1305620ce5745)(layout, activeCoordinate, offset)
                    };
                    cursorComp = (0, $0ac5787e1b21abd2$export$b0e83c3ef8d2db1);
                }
                var key = element.key || '_recharts-cursor';
                var cursorProps = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                    stroke: '#ccc',
                    pointerEvents: 'none'
                }, offset), restProps), (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: 'recharts-tooltip-cursor'
                });
                return /*#__PURE__*/ (0, $cc1z1.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $cc1z1.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $hURbM.createElement)(cursorComp, cursorProps);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($16b92812f3a40098$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state4 = _this.state, xAxisMap = _this$state4.xAxisMap, yAxisMap = _this$state4.yAxisMap, offset = _this$state4.offset;
                var _this$props2 = _this.props, width = _this$props2.width, height = _this$props2.height;
                var xAxis = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($b9b2bb7082a7ae7f$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($05802c61eae177ba$exports)))(axis.domain, Number.isFinite);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, {
                    key: element.key || 'grid',
                    x: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state5 = _this.state, radiusAxisMap = _this$state5.radiusAxisMap, angleAxisMap = _this$state5.angleAxisMap;
                var radiusAxis = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $bf3ae02ac3b2bcdf$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props3 = _this.props, children = _this$props3.children, width = _this$props3.width, height = _this$props3.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $0062722651e9e5c8$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $3bc50bdd5c30e812$var$_objectWithoutProperties(props, $3bc50bdd5c30e812$var$_excluded);
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(item, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var children = _this.props.children;
                var tooltipItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $7c198dcf6108b117$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state6 = _this.state, isTooltipActive = _this$state6.isTooltipActive, activeCoordinate = _this$state6.activeCoordinate, activePayload = _this$state6.activePayload, activeLabel = _this$state6.activeLabel, offset = _this$state6.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(tooltipItem, {
                    viewBox: $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state7 = _this.state, offset = _this$state7.offset, dataStartIndex = _this$state7.dataStartIndex, dataEndIndex = _this$state7.dataEndIndex, updateId = _this$state7.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $bf3ae02ac3b2bcdf$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $147f5ef07a9ae0e2$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $3bc50bdd5c30e812$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state8 = _this.state, xAxisMap = _this$state8.xAxisMap, yAxisMap = _this$state8.yAxisMap, offset = _this$state8.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $bf3ae02ac3b2bcdf$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(activeDot)), (0, $657f06ff92323a96$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state9 = _this.state, isTooltipActive = _this$state9.isTooltipActive, tooltipAxis = _this$state9.tooltipAxis, activeTooltipIndex = _this$state9.activeTooltipIndex, activeLabel = _this$state9.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $7c198dcf6108b117$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $bf3ae02ac3b2bcdf$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $bf3ae02ac3b2bcdf$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $bf3ae02ac3b2bcdf$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $147f5ef07a9ae0e2$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $147f5ef07a9ae0e2$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($3bc50bdd5c30e812$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref13 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref13$graphicalItem = _ref13.graphicalItem, _ref13$graphicalItem$ = _ref13$graphicalItem.item, xyItem = _ref13$graphicalItem$ === void 0 ? element : _ref13$graphicalItem$, childIndex = _ref13$graphicalItem.childIndex;
                        var elementProps = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $cc1z1.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $cc1z1.cloneElement)(element, $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $3bc50bdd5c30e812$var$_defineProperty($3bc50bdd5c30e812$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: _this.renderGrid,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: _this.renderReferenceElement
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: _this.renderXAxis
                },
                YAxis: {
                    handler: _this.renderYAxis
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $147f5ef07a9ae0e2$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($e1f518da076acbcd$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $3bc50bdd5c30e812$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: // eslint-disable-next-line @typescript-eslint/no-empty-function
                function componentDidUpdate() {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(this.props.children, (0, $7c198dcf6108b117$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $98bad4436ed1bf96$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state10 = this.state, xAxisMap = _this$state10.xAxisMap, yAxisMap = _this$state10.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $3bc50bdd5c30e812$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state11 = this.state, angleAxisMap = _this$state11.angleAxisMap, radiusAxisMap = _this$state11.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $147f5ef07a9ae0e2$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $6e0fc928c0e2bfed$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $b1f8f02c080083dc$export$64c61536a2b72e0f)(children, (0, $7c198dcf6108b117$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $657f06ff92323a96$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $ef5b552b7d860121$export$9bcdfe5f29bb33).on((0, $ef5b552b7d860121$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $ef5b552b7d860121$export$9bcdfe5f29bb33).removeListener((0, $ef5b552b7d860121$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $b1f8f02c080083dc$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $6aac8a90771af86b$export$bdd99f2cdf352bae), $3bc50bdd5c30e812$var$_extends({}, axisOptions, {
                        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement("defs", null, /*#__PURE__*/ (0, $cc1z1.default).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, $cc1z1.default).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref14) {
                        var _ref15 = $3bc50bdd5c30e812$var$_slicedToArray(_ref14, 2), axisId = _ref15[0], axisProps = _ref15[1];
                        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, res), {}, $3bc50bdd5c30e812$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref16) {
                        var _ref17 = $3bc50bdd5c30e812$var$_slicedToArray(_ref16, 2), axisId = _ref17[0], axisProps = _ref17[1];
                        return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, res), {}, $3bc50bdd5c30e812$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state12 = this.state, formattedGraphicalItems = _this$state12.formattedGraphicalItems, activeItem = _this$state12.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $b1f8f02c080083dc$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $7bc81dcaebe45bdb$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $6e0fc928c0e2bfed$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $95724e5bd8f30255$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $95724e5bd8f30255$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $95724e5bd8f30255$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $95724e5bd8f30255$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $95724e5bd8f30255$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $b1f8f02c080083dc$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $3bc50bdd5c30e812$var$_objectWithoutProperties(_this$props6, $3bc50bdd5c30e812$var$_excluded2);
                    var attrs = (0, $b1f8f02c080083dc$export$d697c39a2985a4c)(others);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7d40de5656ef76d3$export$7b92b459e668cb21), $3bc50bdd5c30e812$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $b1f8f02c080083dc$export$a98d6da55570cb82)(children, this.renderMap));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'img';
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, $cc1z1.default).createElement("div", $3bc50bdd5c30e812$var$_extends({
                        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-wrapper', className),
                        style: $3bc50bdd5c30e812$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $7d40de5656ef76d3$export$7b92b459e668cb21), $3bc50bdd5c30e812$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $3bc50bdd5c30e812$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $b1f8f02c080083dc$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $hURbM.Component)), $3bc50bdd5c30e812$var$_defineProperty(_class, "displayName", chartName), $3bc50bdd5c30e812$var$_defineProperty(_class, "defaultProps", $3bc50bdd5c30e812$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps)), $3bc50bdd5c30e812$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if (prevState.updateId === undefined) {
            var defaultState = $3bc50bdd5c30e812$export$e5182fb58612e577(nextProps);
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $a7f0dcba3c7ed6d9$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $3bc50bdd5c30e812$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, $3bc50bdd5c30e812$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($3bc50bdd5c30e812$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $b1f8f02c080083dc$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($4c326af0091dea95$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($3bc50bdd5c30e812$var$_objectSpread($3bc50bdd5c30e812$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $3bc50bdd5c30e812$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $cc1z1.isValidElement)(option)) dot = /*#__PURE__*/ (0, $cc1z1.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($3a2d755df4c00d46$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $d67c0c9d3a215d1a$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, $cc1z1.default).createElement((0, $ed1bcafbb483d3fc$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};






var $46780f31747dd116$export$94aefc399ef206a9 = (0, $3bc50bdd5c30e812$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $aeb13077dc0abc4b$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $cd537e8f063d7b4e$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $01d9da6491cd127c$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $c9842abf639410a7$export$ece7de1383db5ac)
});



var $cc1z1 = parcelRequire("cc1z1");
var $bNI4e = parcelRequire("bNI4e");





function $8c3ba1fd4084c1fb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8c3ba1fd4084c1fb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8c3ba1fd4084c1fb$var$_typeof(o);
}
function $8c3ba1fd4084c1fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c3ba1fd4084c1fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c3ba1fd4084c1fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8c3ba1fd4084c1fb$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c3ba1fd4084c1fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c3ba1fd4084c1fb$var$_defineProperty(obj, key, value) {
    key = $8c3ba1fd4084c1fb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c3ba1fd4084c1fb$var$_toPropertyKey(arg) {
    var key = $8c3ba1fd4084c1fb$var$_toPrimitive(arg, "string");
    return $8c3ba1fd4084c1fb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8c3ba1fd4084c1fb$var$_toPrimitive(input, hint) {
    if ($8c3ba1fd4084c1fb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8c3ba1fd4084c1fb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8c3ba1fd4084c1fb$var$_slicedToArray(arr, i) {
    return $8c3ba1fd4084c1fb$var$_arrayWithHoles(arr) || $8c3ba1fd4084c1fb$var$_iterableToArrayLimit(arr, i) || $8c3ba1fd4084c1fb$var$_unsupportedIterableToArray(arr, i) || $8c3ba1fd4084c1fb$var$_nonIterableRest();
}
function $8c3ba1fd4084c1fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c3ba1fd4084c1fb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c3ba1fd4084c1fb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c3ba1fd4084c1fb$var$_arrayLikeToArray(o, minLen);
}
function $8c3ba1fd4084c1fb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8c3ba1fd4084c1fb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8c3ba1fd4084c1fb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8c3ba1fd4084c1fb$export$e60a4704009a0009 = /*#__PURE__*/ (0, $cc1z1.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $bNI4e.useRef)(null);
    var onResizeRef = (0, $bNI4e.useRef)();
    onResizeRef.current = onResize;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0, $bNI4e.useImperativeHandle)(ref, function() {
        return containerRef;
    });
    var _useState = (0, $bNI4e.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $8c3ba1fd4084c1fb$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $bNI4e.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $bNI4e.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($e1f518da076acbcd$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $bNI4e.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)((0, $147f5ef07a9ae0e2$export$e50269385c77c348)(width) || (0, $147f5ef07a9ae0e2$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $147f5ef07a9ae0e2$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $147f5ef07a9ae0e2$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $487ff3b439f3c4cb$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $6df612c424d59fc3$exports.isElement)(children) && (0, $b1f8f02c080083dc$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, $cc1z1.default).Children.map(children, function(child) {
            if ((0, $6df612c424d59fc3$exports.isElement)(child)) return /*#__PURE__*/ (0, $cc1z1.cloneElement)(child, $8c3ba1fd4084c1fb$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $8c3ba1fd4084c1fb$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, $cc1z1.default).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $ee9d4e7b280b4edb$export$2e2bcd8739ae039)('recharts-responsive-container', className),
        style: $8c3ba1fd4084c1fb$var$_objectSpread($8c3ba1fd4084c1fb$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});



var $kRS0m = parcelRequire("kRS0m");

function $f21a4d9d47114ab9$export$6d9d977b2dc588fb(keys, x) {
    return (0, $kRS0m.equals)(keys, (0, $42cbcefff7323768$export$effcdbd76139450)(Object.keys(x)));
}







function $7a6cdebd170bd837$export$34472eb5dc57f67f(settings, crop) {
    return (0, $d28ec4fb6293f25e$export$a59f727245974ec4)((0, $a117bb35793377d5$export$a3141f96ca725916)(settings.Game, crop) ? "No harvests possible." : "Crop is not in season.");
}
function $7a6cdebd170bd837$export$f28c71ecf4635bc5(settings, crop, reasons) {
    let elems;
    return /*#__PURE__*/ (0, $hURbM.createElement)("ul", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "messages"
        ],
        (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((reasons & 1) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                children: [
                    $7a6cdebd170bd837$export$34472eb5dc57f67f(settings, crop)
                ]
            })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((reasons & 4) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                    children: [
                        (0, $d28ec4fb6293f25e$export$a59f727245974ec4)((0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(0, [])) ? "No seed price." : "No seed source.")
                    ]
                })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((reasons & 2) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("No fertilizer price.")
                        ]
                    })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(reasons & 8) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                            children: [
                                (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("No investment.")
                            ]
                        })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))))), [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $7a6cdebd170bd837$var$GrowthCalendar_repeatCons(n_mut, items_mut, list_mut) {
    GrowthCalendar_repeatCons: while(true){
        const n = n_mut, items = items_mut, list = list_mut;
        if (n === 0) return list;
        else {
            n_mut = n - 1;
            items_mut = items;
            list_mut = (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(items, list);
            continue GrowthCalendar_repeatCons;
        }
        break;
    }
}
function $7a6cdebd170bd837$var$GrowthCalendar_nameItem(_arg) {
    if (_arg.tag === 1) return _arg.fields[0].Seed * 1;
    else return _arg.fields[0].Item;
}
function $7a6cdebd170bd837$export$eb5a277fdb9f13f5(seed, item, stage) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", {
        children: [
            (0, $d28ec4fb6293f25e$export$65829f8b026536c)(seed, item, stage)
        ]
    });
}
function $7a6cdebd170bd837$export$74a4fc482769b760(seed, item, stages) {
    return (0, $e5d9070e144b905e$export$c01875f616615628)((0, $e5d9070e144b905e$export$ee1b3e54f0441b22)((0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, stage)=>(0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(~~stage), 0, ~~stage, $7a6cdebd170bd837$export$eb5a277fdb9f13f5(seed, item, i)), stages)));
}
function $7a6cdebd170bd837$var$GrowthCalendar_regrowCropCalendarDays(data, settings, days, fertilizer, stageList, season, crop, harvests) {
    const totalDays = (0, $e5d9070e144b905e$export$8a63f25cc62965f1)(days.slice(season + 1, days.length), {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    });
    const patternInput = (0, $a117bb35793377d5$export$9686fb6378660d64)(settings.Game, fertilizer, new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
        crop
    ]));
    const usedDays = (0, $e189d4fb2d038fab$export$540e37fd0d22453b)(crop.RegrowTime, patternInput[1], harvests);
    const item = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], crop.Item);
    const stageImages = $7a6cdebd170bd837$export$74a4fc482769b760(crop.Seed, item, patternInput[0]);
    const harvestItem = /*#__PURE__*/ (0, $hURbM.createElement)("div", {
        children: [
            (0, $d28ec4fb6293f25e$export$665b4d28ae288326)(item)
        ]
    });
    let firstHarvest;
    const array_1 = stageImages;
    firstHarvest = (0, $e5d9070e144b905e$export$9f200c4466975173)(array_1.length, harvestItem, array_1);
    const regrow = (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(~~(0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(crop.RegrowTime)), 0, ~~(0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(crop.RegrowTime), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
        children: [
            (0, $d28ec4fb6293f25e$export$fc0d6d6a98e4de00)(crop.Seed, item)
        ]
    }));
    (0, $e5d9070e144b905e$export$8a8216c44337cd5)(regrow, regrow.length - 1, harvestItem);
    const filler = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(0, ~~totalDays - ~~usedDays) | 0;
    const stageList_2 = $7a6cdebd170bd837$var$GrowthCalendar_repeatCons(harvests - 1, regrow, (0, $e08834e1786645d9$export$8327ebbef2a0ba76)((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(filler), 0, filler, /*#__PURE__*/ (0, $hURbM.createElement)("div", {})), stageList));
    return [
        season,
        totalDays + (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(season, days) - usedDays - (filler >>> 0),
        (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(firstHarvest, stageList_2)
    ];
}
function $7a6cdebd170bd837$var$GrowthCalendar_fromDateSpan(data, settings, single, span) {
    let array_5;
    const stageList = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(~~(28 - span.EndDate.Day)), 0, ~~(28 - span.EndDate.Day), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
        className: "disabled"
    })));
    const days = !single && (0, $kRS0m.equals)(settings.Game.Location, new (0, $a117bb35793377d5$export$18a2be9195644f38)(0, [])) ? (0, $e189d4fb2d038fab$export$ade24b166187735c)(span.StartDate, span.EndDate) : new Uint32Array([
        (0, $e189d4fb2d038fab$export$76d2bde4e6058336)(span.StartDate, span.EndDate)
    ]);
    const patternInput = (0, $0ef027050085b17b$export$8b3fd701061a25a6)([
        days.length - 1,
        (0, $e5d9070e144b905e$export$4c7897fafd92b108)(days),
        stageList
    ], (tupledArg)=>$7a6cdebd170bd837$var$GrowthCalendar_regrowCropCalendarDays(data, settings, days, span.Fertilizer, stageList, tupledArg[0], tupledArg[1], tupledArg[2]), span.RegrowCrop);
    const patternInput_2 = (0, $e5d9070e144b905e$export$c38b8353041a4f48)((tupledArg_1, tupledArg_2)=>{
        const crop_1 = tupledArg_1[0];
        const harvests_1 = tupledArg_1[1];
        const season_2 = tupledArg_2[0] | 0;
        const remainingDays_1 = tupledArg_2[1] | 0;
        const stageList_2 = tupledArg_2[2];
        const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop_1);
        const item = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], $7a6cdebd170bd837$var$GrowthCalendar_nameItem(crop_1));
        const patternInput_1 = (0, $a117bb35793377d5$export$9686fb6378660d64)(settings.Game, span.Fertilizer, crop_1);
        const time = patternInput_1[1];
        const stages = patternInput_1[0];
        const stageImages = $7a6cdebd170bd837$export$74a4fc482769b760(seed, item, stages);
        const harvestItem = [
            /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                children: [
                    (0, $d28ec4fb6293f25e$export$be33bccc3dd6214)(data, (0, $e189d4fb2d038fab$export$e3cd08c7ffece832)(crop_1))
                ]
            })
        ];
        if (tupledArg_1[2]) {
            const filler = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(0, remainingDays_1 - ~~time) | 0;
            const season_3 = season_2 - 1 | 0;
            return [
                season_3,
                remainingDays_1 + ~~(0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(season_3, days) - ~~time - filler,
                (0, $e08834e1786645d9$export$2d23f4f67ce65296)([
                    stageImages,
                    (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(filler), 0, filler, $7a6cdebd170bd837$export$eb5a277fdb9f13f5(seed, item, stages.length)),
                    harvestItem
                ], stageList_2)
            ];
        } else return [
            season_2,
            remainingDays_1 - ~~(0, $e189d4fb2d038fab$export$540e37fd0d22453b)(undefined, time, harvests_1),
            $7a6cdebd170bd837$var$GrowthCalendar_repeatCons(harvests_1, (0, $e5d9070e144b905e$export$10d8903dec122b9d)(stageImages, harvestItem), stageList_2)
        ];
    }, span.CropHarvests, [
        patternInput[0],
        ~~patternInput[1],
        patternInput[2]
    ]);
    const days_2 = patternInput_2[1] | 0;
    const firstStage = (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((crop_4)=>$7a6cdebd170bd837$export$eb5a277fdb9f13f5((0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop_4), (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], $7a6cdebd170bd837$var$GrowthCalendar_nameItem(crop_4)), 0), (0, $e5d9070e144b905e$export$d944e5c60afb688e)((x)=>x, [
        (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg_3)=>tupledArg_3[0], (0, $e5d9070e144b905e$export$1acbe849d0cb723e)(span.CropHarvests)),
        (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg_4)=>new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                tupledArg_4[1]
            ]), span.RegrowCrop)
    ])));
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg_5)=>{
        let elems_2, elems;
        return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "calendar-season"
            ],
            (elems_2 = [
                /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    [
                        "className",
                        "calendar-header"
                    ],
                    (elems = [
                        (0, $d28ec4fb6293f25e$export$931c4b7e95b3cb50)(tupledArg_5[0]),
                        (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((0, $d28ec4fb6293f25e$export$e9f5ed6a6e06383b), span.Fertilizer)
                    ], [
                        "children",
                        (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                    ])
                ]))),
                /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                    className: "calendar-days",
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(tupledArg_5[1]))
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems_2))
            ])
        ])));
    }, (array_5 = (0, $e5d9070e144b905e$export$6302d00ba2848bf)(28, (0, $e5d9070e144b905e$export$ee1b3e54f0441b22)((0, $e08834e1786645d9$export$2d23f4f67ce65296)([
        (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(~~(span.StartDate.Day - 1)), 0, ~~(span.StartDate.Day - 1), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
            className: "disabled"
        })),
        (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array(days_2 - 1), 0, days_2 - 1, /*#__PURE__*/ (0, $hURbM.createElement)("div", {})),
        firstStage
    ], patternInput_2[2]))), (0, $e5d9070e144b905e$export$8901015135f2fb22)((0, $e189d4fb2d038fab$export$641f31a913d47020)(span.StartDate.Season, span.EndDate.Season), array_5)));
}
function $7a6cdebd170bd837$export$d163fbc5d9993dd(data, settings, dateSpan) {
    return $7a6cdebd170bd837$var$GrowthCalendar_fromDateSpan(data, settings, false, dateSpan);
}
function $7a6cdebd170bd837$export$1f8fbcca294430e6(data, settings, fertilizer, crop) {
    let elems;
    const matchValue = (0, $9495a8d2b9c5bb89$export$c230577c82088908)(settings.Game, fertilizer, crop);
    if (matchValue != null) {
        const span = matchValue;
        const patternInput = crop.tag === 0 ? crop.fields[0].RegrowTime != null ? [
            [],
            [
                0,
                crop.fields[0],
                span.Harvests
            ]
        ] : [
            [
                [
                    crop,
                    span.Harvests,
                    false
                ]
            ],
            undefined
        ] : [
            [
                [
                    crop,
                    span.Harvests,
                    false
                ]
            ],
            undefined
        ];
        return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "className",
                "calendar"
            ],
            (elems = $7a6cdebd170bd837$var$GrowthCalendar_fromDateSpan(data, settings, true, new (0, $6f1b0d5bd41c85b6$export$b88652776e9771a9)(new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(span.StartSeason, span.StartSeason === settings.Game.StartDate.Season ? settings.Game.StartDate.Day : 1), new (0, $e189d4fb2d038fab$export$37a247c0b17a17ff)(span.EndSeason, span.EndSeason === settings.Game.EndDate.Season ? settings.Game.EndDate.Day : 28), fertilizer, patternInput[0], patternInput[1])), [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ])));
    } else return $7a6cdebd170bd837$export$34472eb5dc57f67f(settings, crop);
}
function $7a6cdebd170bd837$var$fertilizerAndCrop(data, fertilizer, crop) {
    const xs_1 = [
        (0, $d28ec4fb6293f25e$export$b425e1f3273281be)(data, crop),
        (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((fertilizer_1)=>{
            const xs = [
                " with ",
                (0, $d28ec4fb6293f25e$export$e9f5ed6a6e06383b)(fertilizer_1)
            ];
            return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
        }, fertilizer)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $7a6cdebd170bd837$var$SummaryTable_toPrecision(value) {
    const rounded = (0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(value);
    if (rounded === 0) return (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%.2e"))(value);
    else return rounded.toString();
}
function $7a6cdebd170bd837$var$SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor) {
    return `${(0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(normDivisor)} ${(0, $d28ec4fb6293f25e$export$cefb40c9962541b5)((0, $3699f71d1df66484$export$61b794ced48389aa)(timeNorm))}`;
}
function $7a6cdebd170bd837$var$SummaryTable_formatNormalizedValue(format, normDivisor, value) {
    return (0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", (value_1)=>format(value_1 / normDivisor), value);
}
function $7a6cdebd170bd837$var$SummaryTable_rowCells(itemCell, unitValue, quantity, value, seeds) {
    return [
        /*#__PURE__*/ (0, $hURbM.createElement)("th", {
            scope: "row",
            children: itemCell
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("td", {
            children: [
                unitValue
            ]
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("td", {
            children: [
                quantity
            ]
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("td", {
            children: [
                value
            ]
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("td", {
            children: [
                seeds
            ]
        })
    ];
}
function $7a6cdebd170bd837$var$SummaryTable_significantRow(seeds, itemCell, price, quantity) {
    const profit = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(0, (tupledArg)=>(0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(tupledArg[0] * quantity * (tupledArg[1] ? -1 : 1)), price);
    if (profit === 0 && (0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(quantity) === 0) return undefined;
    else {
        const profit_1 = price == null ? (0, $kRS0m.defaultOf)() : (0, $d28ec4fb6293f25e$export$5b67fc450104cf2e)(profit);
        const price_2 = (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((arg_1)=>(0, $d28ec4fb6293f25e$export$c24201f7fe3571d8)(arg_1[0]), price);
        const quantity_1 = quantity === 0 ? (0, $kRS0m.defaultOf)() : $7a6cdebd170bd837$var$SummaryTable_toPrecision(quantity);
        return $7a6cdebd170bd837$var$SummaryTable_rowCells(itemCell, price_2, quantity_1, profit_1, seeds ? quantity_1 : (0, $kRS0m.defaultOf)());
    }
}
function $7a6cdebd170bd837$var$SummaryTable_seedRow(itemCell, quantity) {
    return $7a6cdebd170bd837$var$SummaryTable_significantRow(true, itemCell, undefined, quantity);
}
function $7a6cdebd170bd837$var$SummaryTable_profitRow(itemCell, price_, price__1, quantity) {
    return $7a6cdebd170bd837$var$SummaryTable_significantRow(false, itemCell, [
        price_,
        price__1
    ], quantity);
}
function $7a6cdebd170bd837$var$SummaryTable_unknownProfitRow(seeds, itemCell, quantity) {
    if (quantity === 0) return undefined;
    else {
        const quantity_1 = $7a6cdebd170bd837$var$SummaryTable_toPrecision(quantity);
        return $7a6cdebd170bd837$var$SummaryTable_rowCells(itemCell, "???", quantity_1, "???", seeds ? quantity_1 : (0, $kRS0m.defaultOf)());
    }
}
function $7a6cdebd170bd837$var$SummaryTable_boughtRow(seeds, priceAndVendor, quantity, icon) {
    let children;
    if (priceAndVendor == null) return $7a6cdebd170bd837$var$SummaryTable_unknownProfitRow(seeds, /*#__PURE__*/ (0, $hURbM.createElement)("span", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray([
            icon,
            " from ???"
        ])
    }), quantity);
    else {
        const vendor = priceAndVendor[0];
        const price = priceAndVendor[1];
        return $7a6cdebd170bd837$var$SummaryTable_significantRow(seeds, (children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(icon), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                const matchValue = vendor;
                return matchValue.tag === 1 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(" (Custom)") : (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(" from "), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$f99d6a82f56d73ea)(matchValue.fields[0]))));
            })))), /*#__PURE__*/ (0, $hURbM.createElement)("span", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        })), [
            price,
            true
        ], quantity);
    }
}
function $7a6cdebd170bd837$var$SummaryTable_itemCellWithInputs(data, itemCell, inputs) {
    let elems, children_4;
    return /*#__PURE__*/ (0, $hURbM.createElement)("details", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            "input-items"
        ],
        (elems = [
            /*#__PURE__*/ (0, $hURbM.createElement)("summary", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray([
                    itemCell
                ])
            }),
            (children_4 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>{
                const _arg = tupledArg[0];
                const quantity_1 = (0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(tupledArg[1]);
                if (quantity_1 === 0) return (0, $kRS0m.defaultOf)();
                else {
                    const children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        (0, $d28ec4fb6293f25e$export$45ec8428b410e378)(data, _arg[0], _arg[1]),
                        ` x ${quantity_1}`
                    ]);
                    return /*#__PURE__*/ (0, $hURbM.createElement)("li", {
                        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
                    });
                }
            }, inputs), /*#__PURE__*/ (0, $hURbM.createElement)("ul", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
            }))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $7a6cdebd170bd837$var$SummaryTable_fertilizerBoughtRow(replacement, fertilizer, price, quantity) {
    let xs;
    let matchResult, fertilizer_1, price_1;
    if (fertilizer != null) {
        if (price != null) {
            matchResult = 0;
            fertilizer_1 = fertilizer;
            price_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(price);
        } else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            return $7a6cdebd170bd837$var$SummaryTable_boughtRow(false, price_1, quantity, (xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(replacement ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)("Replacement ") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$e9f5ed6a6e06383b)(fertilizer_1)))))), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs)));
        default:
            return undefined;
    }
}
function $7a6cdebd170bd837$var$SummaryTable_harvestedSeedsRows(data, item, quantities) {
    return (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>$7a6cdebd170bd837$var$SummaryTable_seedRow((0, $d28ec4fb6293f25e$export$45ec8428b410e378)(data, item, tupledArg[0]), tupledArg[1]), (0, $7bbf2c7402328604$export$a0d475150deff27c)(quantities));
}
function $7a6cdebd170bd837$var$SummaryTable_seedMakerRows(data, crop, item, quantities) {
    let inputs, children;
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
    return (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)($7a6cdebd170bd837$var$SummaryTable_seedRow((inputs = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg)=>[
            [
                item,
                tupledArg[0]
            ],
            tupledArg[1]
        ], (0, $7bbf2c7402328604$export$a0d475150deff27c)(quantities)), $7a6cdebd170bd837$var$SummaryTable_itemCellWithInputs(data, (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        (0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed),
        " from ",
        (0, $d28ec4fb6293f25e$export$3a0f02ca583081c4)("Seed Maker")
    ]), /*#__PURE__*/ (0, $hURbM.createElement)("span", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    })), inputs)), (0, $cdb0798a49937e52$export$dcbc0b335ff6ede5)(seed) * (0, $e5d9070e144b905e$export$8a63f25cc62965f1)(quantities.fields[0], {
        GetZero: ()=>0,
        Add: (x, y)=>x + y
    })));
}
function $7a6cdebd170bd837$var$SummaryTable_forageSeedsRows(data, settings, items, seed, quantitySold, quantityUsed) {
    if (quantitySold === 0 && quantityUsed === 0) return new Array(0);
    else {
        const inputsCell = (quantity)=>{
            let children;
            const quantity_1 = quantity / 10;
            const inputs = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((item)=>[
                    [
                        item,
                        0
                    ],
                    quantity_1
                ], items);
            return $7a6cdebd170bd837$var$SummaryTable_itemCellWithInputs(data, (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                (0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed),
                " from Crafting"
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            })), inputs);
        };
        const price = (0, $a117bb35793377d5$export$6de4f019aaca4b93)(data, settings.Game, seed);
        return (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((0, $22d1a4cfc5fba7ce$export$45b10814cc054894), [
            $7a6cdebd170bd837$var$SummaryTable_seedRow(inputsCell(quantityUsed), quantityUsed),
            $7a6cdebd170bd837$var$SummaryTable_profitRow(inputsCell(quantitySold), price, false, quantitySold)
        ]);
    }
}
function $7a6cdebd170bd837$var$SummaryTable_unsoldItemRow(data, item, quantities) {
    return (0, $e5d9070e144b905e$export$7877a478dd30fd3d)((tupledArg)=>{
        const quantity = tupledArg[1];
        if (quantity === 0) return undefined;
        else {
            const quantity_1 = $7a6cdebd170bd837$var$SummaryTable_toPrecision(quantity);
            return $7a6cdebd170bd837$var$SummaryTable_rowCells((0, $d28ec4fb6293f25e$export$45ec8428b410e378)(data, item, tupledArg[0]), "???", quantity_1, (0, $kRS0m.defaultOf)(), (0, $kRS0m.defaultOf)());
        }
    }, (0, $7bbf2c7402328604$export$a0d475150deff27c)(quantities));
}
function $7a6cdebd170bd837$var$SummaryTable_soldItemRow(data, summary) {
    let xs;
    return $7a6cdebd170bd837$var$SummaryTable_profitRow((xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$45ec8428b410e378)(data, summary.Item, summary.Quality)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>summary.Custom ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(" (Custom)") : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs)), summary.Price, false, summary.Quantity);
}
function $7a6cdebd170bd837$var$SummaryTable_soldProductRow(data, summary) {
    return $7a6cdebd170bd837$var$SummaryTable_profitRow($7a6cdebd170bd837$var$SummaryTable_itemCellWithInputs(data, (0, $d28ec4fb6293f25e$export$66a32dfdff138951)(data, summary.Product, summary.Quality), summary.ConsumedItemQuantities), summary.Price, false, summary.Quantity);
}
function $7a6cdebd170bd837$var$SummaryTable_cropProfitSummaryRows(data, settings, fertilizer, fertilizerPrice, summary) {
    const crop = summary.Crop;
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop);
    return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((xs)=>/*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs), (0, $e5d9070e144b905e$export$ee1b3e54f0441b22)((0, $42cbcefff7323768$export$45b10814cc054894)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $22d1a4cfc5fba7ce$export$45b10814cc054894)($7a6cdebd170bd837$var$SummaryTable_boughtRow(true, summary.SeedPrice, summary.SeedsBought, (0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed)))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let seeds;
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)(!(0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(2, [])) ? (seeds = (0, $98d8e74a1fff5068$export$87c665ad90b41cb3)(~~((0, $e189d4fb2d038fab$export$52eb22f4c7e28f2f)(crop) ? 1 : summary.Harvests)) | 0, (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                $7a6cdebd170bd837$var$SummaryTable_rowCells(`${summary.Harvests} ${(0, $d28ec4fb6293f25e$export$1a5a2ebc3aaa9655)(summary.Harvests, "harvest")}`, (0, $kRS0m.defaultOf)(), (0, $kRS0m.defaultOf)(), (0, $kRS0m.defaultOf)(), seeds)
            ])) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $e5d9070e144b905e$export$bb44f104e3c54dae)((tupledArg)=>{
                    const item = tupledArg[0];
                    const quantities = tupledArg[1];
                    if (item === (0, $e189d4fb2d038fab$export$33d35c6548f3ff99)(crop)) return $7a6cdebd170bd837$var$SummaryTable_harvestedSeedsRows(data, item, quantities);
                    else if (item === (0, $e189d4fb2d038fab$export$e3cd08c7ffece832)(crop)) return $7a6cdebd170bd837$var$SummaryTable_seedMakerRows(data, crop, item, quantities);
                    else return new Array(0);
                }, summary.SeedsUsed)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_forageSeedsRows(data, settings, (0, $e189d4fb2d038fab$export$a873be80581d6a18)(crop), seed, summary.ForageSeedsSold, summary.ForageSeedsUsed)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $e5d9070e144b905e$export$bb44f104e3c54dae)((tupledArg_1)=>$7a6cdebd170bd837$var$SummaryTable_unsoldItemRow(data, tupledArg_1[0], tupledArg_1[1]), summary.UnsoldItems)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $e5d9070e144b905e$export$7877a478dd30fd3d)((summary_1)=>$7a6cdebd170bd837$var$SummaryTable_soldItemRow(data, summary_1), summary.SoldItems)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $e5d9070e144b905e$export$7877a478dd30fd3d)((summary_2)=>$7a6cdebd170bd837$var$SummaryTable_soldProductRow(data, summary_2), summary.SoldProducts)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $22d1a4cfc5fba7ce$export$45b10814cc054894)($7a6cdebd170bd837$var$SummaryTable_fertilizerBoughtRow(true, fertilizer, fertilizerPrice, summary.ReplacedFertilizer)))))))))))))));
        }))))));
}
function $7a6cdebd170bd837$var$SummaryTable_footerProfitRowCells(itemCell, profit, seeds) {
    return $7a6cdebd170bd837$var$SummaryTable_rowCells(itemCell, (0, $kRS0m.defaultOf)(), (0, $kRS0m.defaultOf)(), profit, seeds);
}
function $7a6cdebd170bd837$var$SummaryTable_totalRowCells(totalFormat, total, seeds) {
    return $7a6cdebd170bd837$var$SummaryTable_footerProfitRowCells("Total", (0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", totalFormat, total), seeds);
}
function $7a6cdebd170bd837$var$SummaryTable_thColWith(cell) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("th", {
        scope: "col",
        children: cell
    });
}
const $7a6cdebd170bd837$var$SummaryTable_thCol = $7a6cdebd170bd837$var$SummaryTable_thColWith;
function $7a6cdebd170bd837$var$SummaryTable_profitHeaderCells(itemCell, seeds) {
    const xs = [
        $7a6cdebd170bd837$var$SummaryTable_thCol(itemCell),
        $7a6cdebd170bd837$var$SummaryTable_thCol("Price"),
        $7a6cdebd170bd837$var$SummaryTable_thCol("Quantity"),
        $7a6cdebd170bd837$var$SummaryTable_thCol("Profit"),
        $7a6cdebd170bd837$var$SummaryTable_thColWith(seeds ? "Seeds" : (0, $kRS0m.defaultOf)())
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $7a6cdebd170bd837$var$SummaryTable_profitHeader(itemCell, seeds) {
    let children;
    const children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children = (0, $e08834e1786645d9$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_profitHeaderCells(itemCell, seeds)), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    })));
    return /*#__PURE__*/ (0, $hURbM.createElement)("thead", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_profitFooter(timeNorm, normDivisor, profit, seeds) {
    const children_6 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        let children;
        return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((children = $7a6cdebd170bd837$var$SummaryTable_totalRowCells((0, $d28ec4fb6293f25e$export$5b67fc450104cf2e), profit, seeds), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let children_2;
            return ((0, $kRS0m.equals)(timeNorm, new (0, $3699f71d1df66484$export$c525707b46ee8b45)(0, [])) ? true : normDivisor === 1) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $kRS0m.defaultOf)()) : (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((children_2 = $7a6cdebd170bd837$var$SummaryTable_footerProfitRowCells((0, $d28ec4fb6293f25e$export$1afd584f29b0f373)((0, $d28ec4fb6293f25e$export$cefb40c9962541b5)((0, $3699f71d1df66484$export$61b794ced48389aa)(timeNorm))), `${$7a6cdebd170bd837$var$SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor)}`, (0, $kRS0m.defaultOf)()), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
            }))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                let children_4, str_3;
                return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((children_4 = $7a6cdebd170bd837$var$SummaryTable_footerProfitRowCells(`Total ${(str_3 = (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(timeNorm), str_3.toLocaleLowerCase())}`, $7a6cdebd170bd837$var$SummaryTable_formatNormalizedValue((0, $d28ec4fb6293f25e$export$5b67fc450104cf2e), normDivisor, profit), (0, $kRS0m.defaultOf)()), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
                })));
            }));
        }));
    }));
    return /*#__PURE__*/ (0, $hURbM.createElement)("tfoot", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_6))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_rankerProfitSummary(data, settings, timeNorm, profitSummary) {
    const children_8 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_profitHeader("Item", !(0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(2, [])))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let children_6;
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((children_6 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((children)=>/*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
                    }), $7a6cdebd170bd837$var$SummaryTable_fertilizerBoughtRow(false, profitSummary.Fertilizer, profitSummary.FertilizerPrice, 1))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg)=>{
                        const children_3 = (0, $e5d9070e144b905e$export$439306a4dcaafbb9)(arg);
                        return /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_3))
                        });
                    }, $7a6cdebd170bd837$var$SummaryTable_cropProfitSummaryRows(data, settings, profitSummary.Fertilizer, profitSummary.FertilizerPrice, (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, profitSummary.CropSummaries))))))), /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_6))
            }))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_profitFooter(timeNorm, profitSummary.TimeNormalization, profitSummary.NetProfit, (0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(2, [])) ? (0, $kRS0m.defaultOf)() : 0..toString()))));
        }))));
    return /*#__PURE__*/ (0, $hURbM.createElement)("table", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_8))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_optimizerProfitSummary(data, settings, total, summaries) {
    let children_2, children;
    const header = $7a6cdebd170bd837$var$SummaryTable_profitHeaderCells("Crop / Item", !(0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(2, [])));
    let getCount;
    const counts = new Map([]);
    getCount = (seed)=>{
        let count;
        let matchValue;
        let outArg = 0;
        matchValue = [
            (0, $b5b450d1f3f8f266$export$8e0f4a40881f4a6f)(counts, seed, new (0, $eATN7.FSharpRef)(()=>outArg, (v)=>{
                outArg = v | 0;
            })),
            outArg
        ];
        count = matchValue[0] ? matchValue[1] : 0;
        counts.set(seed, count + 1);
        return count | 0;
    };
    const children_4 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        (0, $120450cd5ed2b836$export$f5ce6a8561c94ccd)(true, header, (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((profitSummary)=>(0, $e5d9070e144b905e$export$ee1b3e54f0441b22)([
                (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((row)=>[
                        "",
                        /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...row),
                        []
                    ], $7a6cdebd170bd837$var$SummaryTable_fertilizerBoughtRow(false, profitSummary.Fertilizer, profitSummary.FertilizerPrice, 1))),
                (0, $e5d9070e144b905e$export$871de8747c9eaa88)((summary)=>{
                    let seed_1, count_1, xs_1;
                    return [
                        (seed_1 = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(summary.Crop), count_1 = getCount(seed_1) | 0, seed_1.toString() + "@" + (0, $kRS0m.int32ToString)(count_1)),
                        (xs_1 = $7a6cdebd170bd837$var$SummaryTable_rowCells(/*#__PURE__*/ (0, $hURbM.createElement)("span", {
                            children: [
                                $7a6cdebd170bd837$var$fertilizerAndCrop(data, profitSummary.Fertilizer, summary.Crop)
                            ]
                        }), (0, $kRS0m.defaultOf)(), summary.Harvests.toString(), (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((0, $d28ec4fb6293f25e$export$5b67fc450104cf2e), summary.NetProfit), (0, $kRS0m.defaultOf)()), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1)),
                        $7a6cdebd170bd837$var$SummaryTable_cropProfitSummaryRows(data, settings, profitSummary.Fertilizer, profitSummary.FertilizerPrice, summary)
                    ];
                }, profitSummary.CropSummaries)
            ]), summaries)),
        (children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("td", {})), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>$7a6cdebd170bd837$var$SummaryTable_totalRowCells((0, $d28ec4fb6293f25e$export$5b67fc450104cf2e), total, (0, $kRS0m.defaultOf)()))))), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }))), /*#__PURE__*/ (0, $hURbM.createElement)("tfoot", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        }))
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("table", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_keyValue(key, valueCell) {
    const xs = [
        /*#__PURE__*/ (0, $hURbM.createElement)("dt", {
            children: [
                key
            ]
        }),
        /*#__PURE__*/ (0, $hURbM.createElement)("dd", {
            children: [
                valueCell
            ]
        })
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $7a6cdebd170bd837$var$SummaryTable_normalizationRows(key, valueFormat, timeNorm, normDivisor, value) {
    let str_2;
    if (normDivisor === 1) return (0, $kRS0m.defaultOf)();
    else {
        const xs = [
            $7a6cdebd170bd837$var$SummaryTable_keyValue((0, $d28ec4fb6293f25e$export$1afd584f29b0f373)((0, $d28ec4fb6293f25e$export$cefb40c9962541b5)((0, $3699f71d1df66484$export$61b794ced48389aa)(timeNorm))), $7a6cdebd170bd837$var$SummaryTable_formatNormalizationDivisor(timeNorm, normDivisor)),
            $7a6cdebd170bd837$var$SummaryTable_keyValue(`${key} ${(str_2 = (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed)(timeNorm), str_2.toLocaleLowerCase())}`, $7a6cdebd170bd837$var$SummaryTable_formatNormalizedValue(valueFormat, normDivisor, value))
        ];
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
    }
}
function $7a6cdebd170bd837$var$SummaryTable_roiSummary(settings, timeNorm, profitSummary) {
    const patternInput = (0, $9495a8d2b9c5bb89$export$a7b20f6704c76c50)((0, $kRS0m.equals)(settings.Profit.SeedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(0, [])), profitSummary);
    const roi = patternInput[1];
    const children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        $7a6cdebd170bd837$var$SummaryTable_keyValue("Investment", (0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", (0, $d28ec4fb6293f25e$export$c24201f7fe3571d8), patternInput[0])),
        $7a6cdebd170bd837$var$SummaryTable_keyValue("ROI", (0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", (0, $d28ec4fb6293f25e$export$2ae0f0836c569eb0), roi)),
        $7a6cdebd170bd837$var$SummaryTable_normalizationRows("ROI", (0, $d28ec4fb6293f25e$export$2ae0f0836c569eb0), timeNorm, profitSummary.TimeNormalization, roi)
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("dl", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_tooltipBoughtRow(itemCell, price, quantity) {
    return (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((children)=>/*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }), price == null ? $7a6cdebd170bd837$var$SummaryTable_unknownProfitRow(false, itemCell, quantity) : $7a6cdebd170bd837$var$SummaryTable_profitRow(itemCell, price[1], true, quantity));
}
function $7a6cdebd170bd837$var$SummaryTable_tooltipProfitRow(itemCell, price, quantity) {
    return (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((children)=>/*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }), $7a6cdebd170bd837$var$SummaryTable_profitRow(itemCell, price, false, quantity));
}
function $7a6cdebd170bd837$var$SummaryTable_profitTooltip(data, settings, timeNorm, profitSummary) {
    let children, xs, xs_1;
    const summary = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, profitSummary.CropSummaries);
    const seed = (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(summary.Crop);
    const children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        $7a6cdebd170bd837$var$SummaryTable_profitHeader("Item", false),
        (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((price)=>$7a6cdebd170bd837$var$SummaryTable_tooltipBoughtRow((0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((0, $d28ec4fb6293f25e$export$e9f5ed6a6e06383b), profitSummary.Fertilizer), price, 1 + summary.ReplacedFertilizer), profitSummary.FertilizerPrice),
            $7a6cdebd170bd837$var$SummaryTable_tooltipBoughtRow((0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed), summary.SeedPrice, summary.SeedsBought),
            $7a6cdebd170bd837$var$SummaryTable_tooltipProfitRow((0, $d28ec4fb6293f25e$export$7a33edf1c72aa43a)(data, seed), (0, $a117bb35793377d5$export$6de4f019aaca4b93)(data, settings.Game, seed), summary.ForageSeedsSold),
            (xs = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((summary_1)=>$7a6cdebd170bd837$var$SummaryTable_tooltipProfitRow((0, $d28ec4fb6293f25e$export$45ec8428b410e378)(data, summary_1.Item, summary_1.Quality), summary_1.Price, summary_1.Quantity), summary.SoldItems), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs)),
            (xs_1 = (0, $e5d9070e144b905e$export$871de8747c9eaa88)((summary_2)=>$7a6cdebd170bd837$var$SummaryTable_tooltipProfitRow((0, $d28ec4fb6293f25e$export$66a32dfdff138951)(data, summary_2.Product, summary_2.Quality), summary_2.Price, summary_2.Quantity), summary.SoldProducts), /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1))
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        })),
        $7a6cdebd170bd837$var$SummaryTable_profitFooter(timeNorm, profitSummary.TimeNormalization, profitSummary.NetProfit, (0, $kRS0m.defaultOf)())
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("table", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
    });
}
function $7a6cdebd170bd837$var$SummaryTable_mergeCropHarvests(dateSpan) {
    const regrowHarvests = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((tupledArg)=>[
            new (0, $e189d4fb2d038fab$export$8e58b6dc125f7f1b)(0, [
                tupledArg[1]
            ]),
            tupledArg[2]
        ], dateSpan.RegrowCrop);
    return (0, $e5d9070e144b905e$export$66c1ae025e96b4bc)((0, $e08834e1786645d9$export$45b10814cc054894)((0, $e5d9070e144b905e$export$93e2b83da34ff82a)((list, tupledArg_2)=>{
        const crop_2 = tupledArg_2[0];
        const harvests_2 = tupledArg_2[1];
        let matchResult, lastCrop_1, lastHarvests_1, list_2, list_3;
        if (!(0, $e08834e1786645d9$export$dd1bc94b04021eeb)(list)) {
            if ((0, $e189d4fb2d038fab$export$f448f4dc09946ac4)((0, $e08834e1786645d9$export$5fd5031fecdacec3)(list)[0]) === (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop_2)) {
                matchResult = 0;
                lastCrop_1 = (0, $e08834e1786645d9$export$5fd5031fecdacec3)(list)[0];
                lastHarvests_1 = (0, $e08834e1786645d9$export$5fd5031fecdacec3)(list)[1];
                list_2 = (0, $e08834e1786645d9$export$c01875f616615628)(list);
            } else {
                matchResult = 1;
                list_3 = list;
            }
        } else {
            matchResult = 1;
            list_3 = list;
        }
        switch(matchResult){
            case 0:
                return (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                    crop_2,
                    harvests_2 + lastHarvests_1
                ], list_2);
            default:
                return (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
                    crop_2,
                    harvests_2
                ], list_3);
        }
    }, (0, $e08834e1786645d9$export$6e22c362a0406a2c)(), (0, $e5d9070e144b905e$export$10d8903dec122b9d)((0, $e5d9070e144b905e$export$871de8747c9eaa88)((tupledArg_1)=>[
            tupledArg_1[0],
            tupledArg_1[1]
        ], dateSpan.CropHarvests), (0, $22d1a4cfc5fba7ce$export$45b10814cc054894)(regrowHarvests)))));
}
function $7a6cdebd170bd837$export$7b7364c939db10fd(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = (0, $9495a8d2b9c5bb89$export$91808cc6b5084119)(data, settings, timeNorm, fertilizer, crop);
    if (matchValue == null) return $7a6cdebd170bd837$export$34472eb5dc57f67f(settings, crop);
    else return $7a6cdebd170bd837$var$SummaryTable_rankerProfitSummary(data, settings, timeNorm, matchValue);
}
const $7a6cdebd170bd837$export$5eb99799e326e2a6 = (data)=>(settings)=>(timeNorm)=>(profitSummary)=>$7a6cdebd170bd837$var$SummaryTable_profitTooltip(data, settings, timeNorm, profitSummary);
function $7a6cdebd170bd837$export$2aeacf1f7b6a6342(data, settings, total, dateSpans) {
    return $7a6cdebd170bd837$var$SummaryTable_optimizerProfitSummary(data, settings, total, (0, $e5d9070e144b905e$export$871de8747c9eaa88)((dateSpan)=>(0, $9495a8d2b9c5bb89$export$845204756513b8b)(data, settings, dateSpan.Fertilizer, $7a6cdebd170bd837$var$SummaryTable_mergeCropHarvests(dateSpan)), dateSpans));
}
function $7a6cdebd170bd837$export$24b8311e7a182d66(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = (0, $9495a8d2b9c5bb89$export$91808cc6b5084119)(data, settings, timeNorm, fertilizer, crop);
    if (matchValue == null) return $7a6cdebd170bd837$export$34472eb5dc57f67f(settings, crop);
    else {
        const summary = matchValue;
        const xs = [
            $7a6cdebd170bd837$var$SummaryTable_rankerProfitSummary(data, settings, new (0, $3699f71d1df66484$export$c525707b46ee8b45)(0, []), summary),
            $7a6cdebd170bd837$var$SummaryTable_roiSummary(settings, timeNorm, summary)
        ];
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
    }
}
function $7a6cdebd170bd837$export$46f535d11214afd(data, settings, timeNorm, summary) {
    const xs = [
        $7a6cdebd170bd837$var$SummaryTable_profitTooltip(data, settings, new (0, $3699f71d1df66484$export$c525707b46ee8b45)(0, []), summary),
        $7a6cdebd170bd837$var$SummaryTable_roiSummary(settings, timeNorm, summary)
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $7a6cdebd170bd837$var$SummaryTable_XP_verticalSummary(includeHarvests, timeNorm, xpSummary) {
    const summary = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, xpSummary.CropSummaries);
    const children = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(includeHarvests ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_keyValue("Harvests", summary.Harvests.toString())) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_keyValue("XP", (0, $d28ec4fb6293f25e$export$10ee73951df888d5)(summary.XpPerItem))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_keyValue("Quantity", (0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(summary.ItemQuantity))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_keyValue("Total XP", (0, $d28ec4fb6293f25e$export$6a471d06cdf866ce)((0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(xpSummary.Xp)))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$SummaryTable_normalizationRows("XP", (arg)=>(0, $d28ec4fb6293f25e$export$6a471d06cdf866ce)((0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(arg)), timeNorm, xpSummary.TimeNormalization, xpSummary.Xp))))))))))));
    return /*#__PURE__*/ (0, $hURbM.createElement)("dl", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
function $7a6cdebd170bd837$export$332e3606e6f3dc9e(data, settings, timeNorm, fertilizer, crop) {
    const matchValue = (0, $9495a8d2b9c5bb89$export$81451efddcc2e254)(data, settings, timeNorm, fertilizer, crop);
    if (matchValue.tag === 1) return $7a6cdebd170bd837$export$f28c71ecf4635bc5(settings, crop, matchValue.fields[0]);
    else return $7a6cdebd170bd837$var$SummaryTable_XP_verticalSummary(true, timeNorm, matchValue.fields[0]);
}
const $7a6cdebd170bd837$export$638d4c14cba67990 = (timeNorm)=>(xpSummary)=>$7a6cdebd170bd837$var$SummaryTable_XP_verticalSummary(false, timeNorm, xpSummary);
function $7a6cdebd170bd837$var$SummaryTable_XP_tableSummary(data, total, summaries) {
    let children_2, children, children_6, children_10, children_8;
    const children_12 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        (children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            $7a6cdebd170bd837$var$SummaryTable_thCol("Crop"),
            $7a6cdebd170bd837$var$SummaryTable_thCol("Harvests"),
            $7a6cdebd170bd837$var$SummaryTable_thCol("XP"),
            $7a6cdebd170bd837$var$SummaryTable_thCol("Quantity"),
            $7a6cdebd170bd837$var$SummaryTable_thCol("Total XP"),
            $7a6cdebd170bd837$var$SummaryTable_thColWith((0, $kRS0m.defaultOf)())
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
        }))), /*#__PURE__*/ (0, $hURbM.createElement)("thead", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
        })),
        (children_6 = (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((xpSummary)=>(0, $e5d9070e144b905e$export$871de8747c9eaa88)((summary)=>{
                const children_4 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    /*#__PURE__*/ (0, $hURbM.createElement)("th", {
                        scope: "row",
                        children: /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                            children: [
                                $7a6cdebd170bd837$var$fertilizerAndCrop(data, xpSummary.Fertilizer, summary.Crop)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                        children: [
                            summary.Harvests.toString()
                        ]
                    }),
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$10ee73951df888d5)(summary.XpPerItem)
                        ]
                    }),
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(summary.ItemQuantity)
                        ]
                    }),
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$6a471d06cdf866ce)((0, $d28ec4fb6293f25e$export$4b9672654250d8bc)((0, $9495a8d2b9c5bb89$export$6857d00de00a0931)(summary)))
                        ]
                    }),
                    /*#__PURE__*/ (0, $hURbM.createElement)("td", {})
                ]);
                return /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
                });
            }, xpSummary.CropSummaries), summaries), /*#__PURE__*/ (0, $hURbM.createElement)("tbody", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_6))
        })),
        (children_10 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((children_8 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
            /*#__PURE__*/ (0, $hURbM.createElement)("th", {
                children: [
                    "Total"
                ]
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {}),
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {}),
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {}),
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {
                children: [
                    (0, $d28ec4fb6293f25e$export$6a471d06cdf866ce)((0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(total))
                ]
            }),
            /*#__PURE__*/ (0, $hURbM.createElement)("td", {})
        ]), /*#__PURE__*/ (0, $hURbM.createElement)("tr", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_8))
        }))), /*#__PURE__*/ (0, $hURbM.createElement)("tfoot", {
            children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_10))
        }))
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("table", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_12))
    });
}
function $7a6cdebd170bd837$export$f6520c7d3e113358(data, settings, total, dateSpans) {
    return $7a6cdebd170bd837$var$SummaryTable_XP_tableSummary(data, total, (0, $e5d9070e144b905e$export$871de8747c9eaa88)((dateSpan)=>(0, $9495a8d2b9c5bb89$export$5fbcfbe62c207568)(data, settings, dateSpan.Fertilizer, $7a6cdebd170bd837$var$SummaryTable_mergeCropHarvests(dateSpan)), dateSpans));
}
class $7a6cdebd170bd837$export$b62cb7d78ce9c7aa extends (0, $eATN7.Record) {
    constructor(Crops, Fertilizers, Pairs){
        super();
        this.Crops = Crops;
        this.Fertilizers = Fertilizers;
        this.Pairs = Pairs;
    }
}
function $7a6cdebd170bd837$export$a5c15911ab8dbf2a() {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("StardewValleyStonks.WebApp.View.Visualization.PairData", [], $7a6cdebd170bd837$export$b62cb7d78ce9c7aa, ()=>[
            [
                "Crops",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $e189d4fb2d038fab$export$614a3506a98cbb0e)())
            ],
            [
                "Fertilizers",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $7bbf2c7402328604$export$f389f59a8e9b39bf)()))
            ],
            [
                "Pairs",
                (0, $3921efb06a31e9cc$export$9242f430c61b672d)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$173d14c9e9e1a539), (0, $3921efb06a31e9cc$export$a0bfd80c70f2d46b)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734))), (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("Microsoft.FSharp.Core.FSharpResult`2", [
                    (0, $3921efb06a31e9cc$export$8ff85e1c626cc255),
                    (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.WebApp.Query.InvalidReasons", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                        [
                            "None",
                            0
                        ],
                        [
                            "NotEnoughDays",
                            1
                        ],
                        [
                            "NoFertilizerPrice",
                            2
                        ],
                        [
                            "NotEnoughSeeds",
                            4
                        ],
                        [
                            "NoInvestment",
                            8
                        ],
                        [
                            "All",
                            15
                        ]
                    ])
                ], (0, $d06a0138b761f217$export$450bb352655ebd9b), ()=>[
                        [
                            [
                                "ResultValue",
                                (0, $3921efb06a31e9cc$export$8ff85e1c626cc255)
                            ]
                        ],
                        [
                            [
                                "ErrorValue",
                                (0, $3921efb06a31e9cc$export$3120ec9ec286ab54)("StardewValleyStonks.WebApp.Query.InvalidReasons", (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a), [
                                    [
                                        "None",
                                        0
                                    ],
                                    [
                                        "NotEnoughDays",
                                        1
                                    ],
                                    [
                                        "NoFertilizerPrice",
                                        2
                                    ],
                                    [
                                        "NotEnoughSeeds",
                                        4
                                    ],
                                    [
                                        "NoInvestment",
                                        8
                                    ],
                                    [
                                        "All",
                                        15
                                    ]
                                ])
                            ]
                        ]
                    ])))
            ]
        ]);
}
function $7a6cdebd170bd837$var$pairData(metric, timeNorm, data, settings) {
    const crops = Array.from((0, $9495a8d2b9c5bb89$export$98f73a3fc1e1b415)(data, settings));
    const fertilizers = Array.from((0, $9495a8d2b9c5bb89$export$bfed76964c7008b8)(data, settings));
    const rankValue = (0, $9495a8d2b9c5bb89$export$d137f0bc0e5a8b6d)(metric);
    return new $7a6cdebd170bd837$export$b62cb7d78ce9c7aa(crops, fertilizers, (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((crop)=>{
        const profit = rankValue(data)(settings)(timeNorm)(crop);
        return (0, $e5d9070e144b905e$export$871de8747c9eaa88)((fert)=>[
                [
                    (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(crop),
                    (0, $7bbf2c7402328604$export$70921c9a086f6004)(fert)
                ],
                profit(fert)
            ], fertilizers);
    }, crops));
}
function $7a6cdebd170bd837$var$emptyPairData(pairData_1) {
    let elems;
    const noCrops = pairData_1.Crops.length === 0;
    const noFerts = pairData_1.Fertilizers.length === 0;
    return /*#__PURE__*/ (0, $hURbM.createElement)("ul", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "className",
            (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)(" ", [
                "messages",
                "messages-large"
            ])
        ],
        (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(noCrops ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                children: [
                    (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("No crops selected.")
                ]
            })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(noFerts ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                    children: [
                        (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("No fertilizers selected.")
                    ]
                })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>!(noCrops ? true : noFerts) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("li", {
                        children: [
                            (0, $d28ec4fb6293f25e$export$a59f727245974ec4)("No valid entries.")
                        ]
                    })) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))), [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $7a6cdebd170bd837$export$fc6934a143d103e5(label, metric, timeNorm, dispatchMetric, dispatchTimeNorm) {
    const children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        label,
        (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Metric", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("3em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_1)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_1, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$a74b6a5c4e0a0ce2)())), metric, dispatchMetric)),
        (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Time Normalization", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("6em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_3)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_3, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$75ade4344f3555a8)())), timeNorm, dispatchTimeNorm))
    ]);
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", {
        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
    });
}
const $7a6cdebd170bd837$var$Ranker_iconSize = (0, $kRS0m.round)((0, $cd83631caaaa9fc0$export$72958e90e02c3f99) * 1.5);
const $7a6cdebd170bd837$var$Ranker_iconGap = (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(1, (0, $kRS0m.round)((0, $cd83631caaaa9fc0$export$72958e90e02c3f99) * 0.25));
const $7a6cdebd170bd837$var$Ranker_barGap = $7a6cdebd170bd837$var$Ranker_iconGap;
function $7a6cdebd170bd837$var$Ranker_pairImage(pairs, data, props) {
    let elements;
    const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(props.payload.value, pairs);
    const item = (0, $e189d4fb2d038fab$export$e3cd08c7ffece832)((0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], patternInput[0]));
    const xs_2 = [
        /*#__PURE__*/ (0, $hURbM.createElement)("image", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "href",
                (0, $d28ec4fb6293f25e$export$afd779920dce460f)(item)
            ],
            [
                "x",
                props.x - $7a6cdebd170bd837$var$Ranker_iconSize / 2
            ],
            [
                "y",
                props.y + $7a6cdebd170bd837$var$Ranker_iconGap
            ],
            [
                "width",
                $7a6cdebd170bd837$var$Ranker_iconSize
            ],
            [
                "height",
                $7a6cdebd170bd837$var$Ranker_iconSize
            ],
            (elements = (0, $e08834e1786645d9$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("title", {
                children: [
                    (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], item).Name
                ]
            })), [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elements))
            ])
        ]))),
        (0, $d28ec4fb6293f25e$export$d347d69f75548a2f)((fert_1)=>{
            let elements_1;
            return /*#__PURE__*/ (0, $hURbM.createElement)("image", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "href",
                    (0, $d28ec4fb6293f25e$export$e8d5d03e106a89)(fert_1)
                ],
                [
                    "width",
                    $7a6cdebd170bd837$var$Ranker_iconSize
                ],
                [
                    "height",
                    $7a6cdebd170bd837$var$Ranker_iconSize
                ],
                [
                    "x",
                    props.x - $7a6cdebd170bd837$var$Ranker_iconSize / 2
                ],
                [
                    "y",
                    props.y + $7a6cdebd170bd837$var$Ranker_iconSize + $7a6cdebd170bd837$var$Ranker_iconGap * 2
                ],
                (elements_1 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("title", {
                    children: [
                        fert_1
                    ]
                })), [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elements_1))
                ])
            ])));
        }, patternInput[1])
    ];
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
}
function $7a6cdebd170bd837$var$Ranker_harvestsText(harvests) {
    return /*#__PURE__*/ (0, $hURbM.createElement)("span", {
        children: [
            ` (${harvests} ${(0, $d28ec4fb6293f25e$export$1a5a2ebc3aaa9655)(harvests, "harvest")})`
        ]
    });
}
function $7a6cdebd170bd837$var$Ranker_chartProfitTooltip(data, settings, timeNorm, roi, fertilizer, crop, profit) {
    const xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const matchValue = (0, $9495a8d2b9c5bb89$export$91808cc6b5084119)(data, settings, timeNorm, fertilizer, crop);
        if (matchValue == null) {
            const matchValue_2 = profit;
            if (matchValue_2.tag === 1) return (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$f28c71ecf4635bc5(settings, crop, matchValue_2.fields[0]));
            else return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $kRS0m.defaultOf)());
        } else {
            const profitSummary = matchValue;
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$Ranker_harvestsText((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, profitSummary.CropSummaries).Harvests)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                let matchValue_1;
                return (0, $42cbcefff7323768$export$10d8903dec122b9d)((matchValue_1 = profit, matchValue_1.tag === 1 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$f28c71ecf4635bc5(settings, crop, matchValue_1.fields[0])) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $kRS0m.defaultOf)())), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>roi ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$46f535d11214afd(data, settings, timeNorm, profitSummary)) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$5eb99799e326e2a6(data)(settings)(timeNorm)(profitSummary))));
            }));
        }
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $7a6cdebd170bd837$var$Ranker_chartXPTooltip(data, settings, timeNorm, fertilizer, crop) {
    const xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        const matchValue = (0, $9495a8d2b9c5bb89$export$81451efddcc2e254)(data, settings, timeNorm, fertilizer, crop);
        if (matchValue.tag === 1) return (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$f28c71ecf4635bc5(settings, crop, matchValue.fields[0]));
        else {
            const summary = matchValue.fields[0];
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$Ranker_harvestsText((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, summary.CropSummaries).Harvests)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$export$638d4c14cba67990(timeNorm)(summary))));
        }
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
}
function $7a6cdebd170bd837$var$Ranker_chartTooltip(pairs, data, settings, timeNorm, rankItem, props) {
    let elems, payload;
    const matchValue = props.payload;
    let matchResult, payload_1;
    if (matchValue != null) {
        if (payload = matchValue, payload.length > 0 && props.active) {
            matchResult = 0;
            payload_1 = matchValue;
        } else matchResult = 1;
    } else matchResult = 1;
    switch(matchResult){
        case 0:
            {
                const patternInput = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(0, payload_1).payload;
                const patternInput_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(patternInput[0], pairs);
                const crop = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], patternInput_1[0]);
                const fertilizer_1 = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((key_2)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Fertilizers.fields[0], key_2), patternInput_1[1]);
                return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    [
                        "id",
                        "chart-tooltip"
                    ],
                    (elems = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("h1", {
                            children: [
                                $7a6cdebd170bd837$var$fertilizerAndCrop(data, fertilizer_1, crop)
                            ]
                        })), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                            const matchValue_1 = rankItem;
                            switch(matchValue_1.tag){
                                case 2:
                                    return (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$Ranker_chartXPTooltip(data, settings, timeNorm, fertilizer_1, crop));
                                default:
                                    return (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$Ranker_chartProfitTooltip(data, settings, timeNorm, (0, $kRS0m.equals)(rankItem, new (0, $3699f71d1df66484$export$f79c53f8fc5ad0e)(1, [])), fertilizer_1, crop, patternInput[1]));
                            }
                        })))), [
                        "children",
                        (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                    ])
                ])));
            }
        default:
            return (0, $kRS0m.defaultOf)();
    }
}
function $7a6cdebd170bd837$var$Ranker_svgRectPath(x, y, width, height) {
    return `M ${x},${y} h ${width} v ${height} h -${width} Z`;
}
function $7a6cdebd170bd837$var$Ranker_barBackground(selectPair, props) {
    const x = props.x;
    const y = props.y;
    const width = props.width;
    const height = props.height;
    const i = props.payload[0] | 0;
    return /*#__PURE__*/ (0, $hURbM.createElement)("path", {
        onClick: (_arg)=>{
            selectPair(i);
        },
        x: x,
        y: y,
        width: width,
        height: height,
        d: $7a6cdebd170bd837$var$Ranker_svgRectPath(x, y, width, height)
    });
}
function $7a6cdebd170bd837$var$Ranker_errorBar(data, seedStrategy, metric, pairs, props) {
    const x = props.x;
    const y = props.y;
    const width = props.width;
    const height = props.height;
    const patternInput = props.payload;
    const value = patternInput[1];
    const patternInput_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(patternInput[0], pairs);
    const seed = patternInput_1[0];
    const fert = patternInput_1[1];
    const cropDesc = (0, $e189d4fb2d038fab$export$f1b4c0d5ff03a35f)((key)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key), (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed));
    const fertDesc = (0, $0ef027050085b17b$export$8b3fd701061a25a6)("", (fert_1)=>` with ${fert_1}`, fert);
    const valueDesc = (0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", (value_1)=>`${(0, $d28ec4fb6293f25e$export$4b9672654250d8bc)(value_1 * ((0, $kRS0m.equals)(metric, new (0, $3699f71d1df66484$export$f79c53f8fc5ad0e)(1, [])) ? 100 : 1))}${(0, $3699f71d1df66484$export$d5ab4692440e2f4a)(metric)}`, (0, $3699f71d1df66484$export$635a5682a4ff6ef0)(value));
    const xs_3 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("title", {
            children: [
                `${cropDesc}${fertDesc}: ${valueDesc}`
            ]
        })), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let elements_1;
            const matchValue = value;
            if (matchValue.tag === 1) {
                const flags = matchValue.fields[0] | 0;
                const gap = width / 4;
                const maxHeight = width * 3 + gap * 2;
                const y_1 = props.background.height - maxHeight;
                return (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("g", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    [
                        "tabIndex",
                        0
                    ],
                    [
                        "onFocus",
                        (value_17)=>{}
                    ],
                    (elements_1 = (0, $e08834e1786645d9$export$e5bd5b3b105c2a71)((i, tupledArg)=>{
                        let elements;
                        return /*#__PURE__*/ (0, $hURbM.createElement)("image", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                            [
                                "href",
                                tupledArg[0]
                            ],
                            [
                                "x",
                                x
                            ],
                            [
                                "y",
                                y_1 + (width + gap) * (2 - i)
                            ],
                            [
                                "width",
                                width
                            ],
                            [
                                "height",
                                width
                            ],
                            (elements = (0, $e08834e1786645d9$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("title", {
                                children: [
                                    tupledArg[1]
                                ]
                            })), [
                                "children",
                                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elements))
                            ])
                        ])));
                    }, (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((flags & 2) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            (0, $d28ec4fb6293f25e$export$e8d5d03e106a89)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(fert)),
                            "No fertilizer price"
                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((flags & 4) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                (0, $d28ec4fb6293f25e$export$afd779920dce460f)(seed * 1),
                                (0, $kRS0m.equals)(seedStrategy, new (0, $3699f71d1df66484$export$a588ef89de95aa8f)(0, [])) ? "No seed price" : "No seed source"
                            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((flags & 1) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                    "img/Time.webp",
                                    "No harvests possible"
                                ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(flags & 8) !== 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "img/Gold.webp",
                                        "No investment"
                                    ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)()))))))))), [
                        "children",
                        (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elements_1))
                    ])
                ]))));
            } else return (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("path", {
                radius: 0,
                x: x,
                y: y,
                width: width,
                height: height,
                d: $7a6cdebd170bd837$var$Ranker_svgRectPath(x, y, width, height),
                tabIndex: 0,
                onFocus: (value_14)=>{}
            }));
        }))));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_3);
}
function $7a6cdebd170bd837$var$Ranker_chart(ranker, data, settings, pairs, dispatch) {
    let properties_5, right, elements, properties_1, properties_2, properties_3, properties_4;
    const patternInput = (0, $e5d9070e144b905e$export$23c8d3f8757cab88)((0, $e5d9070e144b905e$export$e5bd5b3b105c2a71)((i, tupledArg)=>[
            tupledArg[0],
            [
                i,
                tupledArg[1]
            ]
        ], pairs));
    const pairs_1 = patternInput[0];
    const selectPair = (i_1)=>{
        let matchValue;
        const patternInput_1 = (0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(i_1, pairs_1);
        const fert = patternInput_1[1];
        const crop = patternInput_1[0];
        dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(5, [
            (matchValue = ranker.RankItem, matchValue.tag === 1 ? [
                crop,
                undefined
            ] : matchValue.tag === 2 ? [
                undefined,
                (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(fert)
            ] : [
                crop,
                (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(fert)
            ])
        ]));
    };
    const properties_6 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "debounce",
            100
        ],
        [
            "children",
            (properties_5 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "data",
                    patternInput[1]
                ],
                [
                    "barGap",
                    $7a6cdebd170bd837$var$Ranker_barGap
                ],
                (right = ~~(0, $cd83631caaaa9fc0$export$72958e90e02c3f99) * 2, [
                    "margin",
                    {
                        top: (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(0, 0),
                        right: (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(right, 0),
                        left: (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(0, 0),
                        bottom: (0, $22d1a4cfc5fba7ce$export$37721a79838ca038)(0, 0)
                    }
                ]),
                (elements = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $7c198dcf6108b117$export$28c660c63b792dea), {
                        content: (props)=>$7a6cdebd170bd837$var$Ranker_chartTooltip(pairs_1, data, settings, ranker.TimeNormalization, ranker.RankMetric, props)
                    }),
                    (properties_1 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        [
                            "dataKey",
                            (arg)=>(0, $3699f71d1df66484$export$a3bcc1b465b448b9)(0, arg[1])
                        ],
                        [
                            "barSize",
                            ~~(0, $kRS0m.round)($7a6cdebd170bd837$var$Ranker_iconSize * 1.5)
                        ],
                        [
                            "onClick",
                            (eventArgs)=>{
                                if (eventArgs == null ? true : (0, $f21a4d9d47114ab9$export$6d9d977b2dc588fb)((0, $e08834e1786645d9$export$439306a4dcaafbb9)("isTooltipActive"), eventArgs)) ;
                                else selectPair(eventArgs.payload[0]);
                            }
                        ],
                        [
                            "shape",
                            (props_2)=>$7a6cdebd170bd837$var$Ranker_errorBar(data, settings.Profit.SeedStrategy, ranker.RankMetric, pairs_1, props_2)
                        ],
                        [
                            "activeBar",
                            (props_3)=>$7a6cdebd170bd837$var$Ranker_errorBar(data, settings.Profit.SeedStrategy, ranker.RankMetric, pairs_1, props_3)
                        ],
                        [
                            "background",
                            (props_4)=>$7a6cdebd170bd837$var$Ranker_barBackground(selectPair, props_4)
                        ]
                    ]), (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $aeb13077dc0abc4b$export$bbc6c6369b38e3d1), (0, $kRS0m.createObj)(properties_1))),
                    (properties_2 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                            "unit",
                            (0, $3699f71d1df66484$export$d5ab4692440e2f4a)(ranker.RankMetric)
                        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                "domain",
                                [
                                    0,
                                    "auto"
                                ]
                            ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                    "width",
                                    (0, $cd83631caaaa9fc0$export$72958e90e02c3f99) * 5
                                ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                        "tickSize",
                                        (0, $cd83631caaaa9fc0$export$72958e90e02c3f99) / 2
                                    ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $kRS0m.equals)(ranker.RankMetric, new (0, $3699f71d1df66484$export$f79c53f8fc5ad0e)(1, [])) ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                                            "tickFormatter",
                                            (x)=>x * 100
                                        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)())))))))))), (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $01d9da6491cd127c$export$f96c4024c52de8f4), (0, $kRS0m.createObj)(properties_2))),
                    (properties_3 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        [
                            "dataKey",
                            (tuple_2)=>tuple_2[0]
                        ],
                        [
                            "tick",
                            (props_5)=>$7a6cdebd170bd837$var$Ranker_pairImage(pairs_1, data, props_5)
                        ],
                        [
                            "interval",
                            0
                        ],
                        [
                            "height",
                            $7a6cdebd170bd837$var$Ranker_iconSize * 2 + $7a6cdebd170bd837$var$Ranker_iconGap * 3 + 10
                        ],
                        [
                            "tickSize",
                            0
                        ]
                    ]), (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $cd537e8f063d7b4e$export$ea77231de273b52d), (0, $kRS0m.createObj)(properties_3))),
                    (properties_4 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        [
                            "startIndex",
                            (0, $d28ec4fb6293f25e$export$cdbb71092bf28e30)(pairs_1, ~~ranker.BrushSpan[0])
                        ],
                        [
                            "endIndex",
                            (0, $d28ec4fb6293f25e$export$cdbb71092bf28e30)(pairs_1, ~~ranker.BrushSpan[1])
                        ],
                        [
                            "height",
                            ~~(0, $cd83631caaaa9fc0$export$72958e90e02c3f99) * 2
                        ],
                        [
                            "travellerWidth",
                            (0, $cd83631caaaa9fc0$export$72958e90e02c3f99) / 2
                        ],
                        [
                            "onChange",
                            (i_2)=>{
                                dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(4, [
                                    i_2.startIndex,
                                    i_2.endIndex
                                ]));
                            }
                        ]
                    ]), (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $18c313093ff88748$export$59bc2e3533b384a0), (0, $kRS0m.createObj)(properties_4)))
                ]), [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elements))
                ])
            ]), (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $46780f31747dd116$export$94aefc399ef206a9), (0, $kRS0m.createObj)(properties_5)))
        ]
    ]);
    return (0, $f559a3d33a977349$export$88214af1db8f02e1).createElement((0, $8c3ba1fd4084c1fb$export$e60a4704009a0009), (0, $kRS0m.createObj)(properties_6));
}
function $7a6cdebd170bd837$export$9677bedee5c30a85(ranker, data, settings, dispatch) {
    const pairData_1 = $7a6cdebd170bd837$var$pairData(ranker.RankMetric, ranker.TimeNormalization, data, settings);
    let pairs;
    const matchValue = ranker.RankItem;
    pairs = matchValue.tag === 1 ? (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg_2)=>(0, $e5d9070e144b905e$export$ad1963a493908da4)((arg_1)=>(0, $3699f71d1df66484$export$635a5682a4ff6ef0)(arg_1[1]), arg_2[1], {
            Compare: (0, $kRS0m.compare)
        }), (0, $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe)((arg)=>arg[0][0], pairData_1.Pairs, {
        Equals: (x, y)=>x === y,
        GetHashCode: (0, $kRS0m.numberHash)
    })) : matchValue.tag === 2 ? (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg_5)=>(0, $e5d9070e144b905e$export$ad1963a493908da4)((arg_4)=>(0, $3699f71d1df66484$export$635a5682a4ff6ef0)(arg_4[1]), arg_5[1], {
            Compare: (0, $kRS0m.compare)
        }), (0, $2f87a1ba4ae7cb49$export$c8e34cfb94f73afe)((arg_3)=>arg_3[0][1], pairData_1.Pairs, {
        Equals: (0, $kRS0m.equals),
        GetHashCode: (0, $kRS0m.structuralHash)
    })) : pairData_1.Pairs;
    const pairs_1 = ranker.ShowInvalid ? pairs : pairs.filter((arg_6)=>(0, $3699f71d1df66484$export$c53496e1eeb7cd06)(arg_6[1]));
    pairs_1.sort((a, b)=>{
        const matchValue_2 = b[1];
        const copyOfStruct = a[1];
        if (copyOfStruct.tag === 1) {
            const copyOfStruct_1 = matchValue_2;
            if (copyOfStruct_1.tag === 1) return (0, $0ef027050085b17b$export$1a35e60cc07e6f13)(copyOfStruct.fields[0], copyOfStruct_1.fields[0]) | 0;
            else return 1;
        } else {
            const copyOfStruct_2 = matchValue_2;
            if (copyOfStruct_2.tag === 1) return -1;
            else return (0, $kRS0m.comparePrimitives)(copyOfStruct_2.fields[0], copyOfStruct.fields[0]) | 0;
        }
    });
    const xs_2 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        let elems, children_2, children;
        return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
            [
                "id",
                "chart-controls"
            ],
            (elems = [
                (children_2 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                    (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        "Rank",
                        (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)("Rank Item", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("5em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_5)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_5, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$1824d3b6bd68574d)())), ranker.RankItem, (arg_7)=>{
                            dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(0, [
                                arg_7
                            ]));
                        }))
                    ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
                    })),
                    $7a6cdebd170bd837$export$fc6934a143d103e5("By", ranker.RankMetric, ranker.TimeNormalization, (arg_9)=>{
                        dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(1, [
                            arg_9
                        ]));
                    }, (arg_10)=>{
                        dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(2, [
                            arg_10
                        ]));
                    })
                ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                    children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
                })),
                (0, $2bc91fecd0c77f83$export$b07e517d22efa1ca)("Show Invalid", ranker.ShowInvalid, (arg_11)=>{
                    dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(3, [
                        arg_11
                    ]));
                })
            ], [
                "children",
                (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
            ])
        ])))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>pairs_1.length === 0 ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$emptyPairData(pairData_1)) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("div", {
                id: "chart",
                children: (0, $d4ba2fe09a393e3c$export$ccbbfe3e8f80da38)((arg10$0040, pairs_2, dispatch_2)=>$7a6cdebd170bd837$var$Ranker_chart(ranker, data, settings, pairs_2, dispatch_2))(ranker.RankMetric)(pairs_1)(dispatch)
            }))));
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
}
function $7a6cdebd170bd837$var$selectSpecificOrBest(name, length, toString, viewItem, items, selected, dispatch) {
    return (0, $d28ec4fb6293f25e$export$de3f5e0fbb46ff22)(name, (0, $64dfd908a2c26bb7$export$d76128d007d19019)(length, (_arg)=>{
        let item;
        return _arg.tag === 1 ? _arg.fields[0] == null ? "???" : (item = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(_arg.fields[0]), toString(item)) : toString(_arg.fields[0]);
    }, (opt)=>{
        const xs = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>opt.tag === 1 ? (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(`Best ${name}: `), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $0ef027050085b17b$export$8b3fd701061a25a6)("???", viewItem, opt.fields[0])))) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)(viewItem(opt.fields[0]))));
        return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
    }, items, selected, dispatch));
}
function $7a6cdebd170bd837$export$e05ef57e85bf487b(props) {
    const app = props.App;
    const seed = props.Seed;
    const fertName = props.Fertilizer;
    const uiDispatch = props.Dispatch;
    const dispatch = (arg)=>{
        props.Dispatch(new (0, $7c6f80c5743180ba$export$78428c3f899407d)(1, [
            arg
        ]));
    };
    const selectDispatch = (arg_2)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(5, [
            arg_2
        ]));
    };
    const data = app.Data;
    const patternInput = app.State;
    const ui = patternInput[1];
    const settings = patternInput[0];
    const ranker = ui.Ranker;
    const patternInput_1 = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState([
        ranker.RankMetric,
        ranker.TimeNormalization
    ]);
    const timeNorm = patternInput_1[0][1];
    const setState = patternInput_1[1];
    const metric = patternInput_1[0][0];
    const pairData_1 = $7a6cdebd170bd837$var$pairData(metric, timeNorm, data, settings);
    let patternInput_4;
    const pairs = pairData_1.Pairs;
    let patternInput_3;
    if (pairs.length === 0) patternInput_3 = [
        undefined,
        undefined
    ];
    else {
        const patternInput_2 = (0, $e5d9070e144b905e$export$ad1963a493908da4)((arg_3)=>(0, $3699f71d1df66484$export$635a5682a4ff6ef0)(arg_3[1]), pairs, {
            Compare: (0, $kRS0m.compare)
        })[0];
        patternInput_3 = [
            (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], patternInput_2[0]),
            (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((key_2)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Fertilizers.fields[0], key_2), patternInput_2[1]))
        ];
    }
    const metricValue = (0, $9495a8d2b9c5bb89$export$d137f0bc0e5a8b6d)(metric);
    patternInput_4 = [
        new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(1, [
            (0, $0ef027050085b17b$export$8b3fd701061a25a6)(patternInput_3[0], (fert_1)=>{
                const fert_2 = (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((key_5)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Fertilizers.fields[0], key_5), fert_1);
                if (pairData_1.Crops.length === 0) return undefined;
                else return (0, $e5d9070e144b905e$export$ad1963a493908da4)((crop_1)=>(0, $3699f71d1df66484$export$635a5682a4ff6ef0)(metricValue(data)(settings)(timeNorm)(crop_1)(fert_2)), pairData_1.Crops, {
                    Compare: (0, $kRS0m.compare)
                });
            }, fertName)
        ]),
        new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(1, [
            (0, $0ef027050085b17b$export$8b3fd701061a25a6)(patternInput_3[1], (seed_1)=>{
                const crop_2 = (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], seed_1);
                if (pairData_1.Fertilizers.length === 0) return undefined;
                else {
                    const profit = metricValue(data)(settings)(timeNorm)(crop_2);
                    return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$ad1963a493908da4)((arg_4)=>(0, $3699f71d1df66484$export$635a5682a4ff6ef0)(profit(arg_4)), pairData_1.Fertilizers, {
                        Compare: (0, $kRS0m.compare)
                    }));
                }
            }, seed)
        ])
    ];
    const bestFert_2 = patternInput_4[1];
    const bestCrop_2 = patternInput_4[0];
    const cropOptions = (0, $e5d9070e144b905e$export$9f200c4466975173)(0, bestCrop_2, (0, $e5d9070e144b905e$export$871de8747c9eaa88)((Item_2)=>new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(0, [
            Item_2
        ]), (0, $e5d9070e144b905e$export$b035e44d7bb4278f)((0, $a56e1de91baad685$export$36d9d422425f26fb)(data), pairData_1.Crops, {
        Compare: (0, $kRS0m.comparePrimitives)
    })));
    const fertilizerOptions = (0, $e5d9070e144b905e$export$9f200c4466975173)(0, bestFert_2, (0, $e5d9070e144b905e$export$871de8747c9eaa88)((arg_6)=>new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(0, [
            (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(arg_6)
        ]), (0, $e5d9070e144b905e$export$b035e44d7bb4278f)((arg_5)=>(0, $7bbf2c7402328604$export$70921c9a086f6004)((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(arg_5)), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd), pairData_1.Fertilizers), {
        Compare: (0, $kRS0m.compare)
    })));
    const crop_3 = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(bestCrop_2, (arg_7)=>new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(0, [
            (0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Crops.fields[0], arg_7)
        ]), seed);
    const fert_3 = (0, $0ef027050085b17b$export$8b3fd701061a25a6)(bestFert_2, (arg_8)=>new (0, $5eb55d943c3c909d$export$484d5b3e6aba851a)(0, [
            (0, $22d1a4cfc5fba7ce$export$871de8747c9eaa88)((key_13)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Fertilizers.fields[0], key_13), arg_8)
        ]), fertName);
    const xs_2 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("button", {
            className: "back",
            onClick: (_arg_13)=>{
                dispatch(new (0, $7c6f80c5743180ba$export$6ae9f6bb93c8d52f)(5, [
                    undefined
                ]));
            },
            children: "Back"
        })), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
            let elems, children;
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)(/*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                [
                    "id",
                    "summary-controls"
                ],
                (elems = [
                    (children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        $7a6cdebd170bd837$var$selectSpecificOrBest("Crop", "12em", (_arg_15)=>(0, $e189d4fb2d038fab$export$f1b4c0d5ff03a35f)((key_20)=>(0, $b5b450d1f3f8f266$export$6e0d12c66f82a152)(data.Items.fields[0], key_20), _arg_15), (_arg_16)=>(0, $d28ec4fb6293f25e$export$b425e1f3273281be)(data, _arg_16), cropOptions, crop_3, (opt)=>{
                            selectDispatch([
                                opt.tag === 1 ? undefined : (0, $e189d4fb2d038fab$export$f448f4dc09946ac4)(opt.fields[0]),
                                fertName
                            ]);
                        }),
                        /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                            children: [
                                " with "
                            ]
                        }),
                        $7a6cdebd170bd837$var$selectSpecificOrBest("Fertilizer", "15em", (0, $3699f71d1df66484$export$b16bf5d4b63332b6), (_arg_17)=>(0, $0ef027050085b17b$export$8b3fd701061a25a6)("No Fertilizer", (0, $d28ec4fb6293f25e$export$e9f5ed6a6e06383b), _arg_17), fertilizerOptions, fert_3, (opt_1)=>{
                            selectDispatch([
                                seed,
                                opt_1.tag === 1 ? undefined : (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $7bbf2c7402328604$export$70921c9a086f6004)(opt_1.fields[0]))
                            ]);
                        })
                    ]), /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                        children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
                    })),
                    $7a6cdebd170bd837$export$fc6934a143d103e5(/*#__PURE__*/ (0, $hURbM.createElement)("span", {
                        children: [
                            "Show"
                        ]
                    }), metric, timeNorm, (metric_1)=>{
                        setState([
                            metric_1,
                            timeNorm
                        ]);
                    }, (timeNorm_1)=>{
                        setState([
                            metric,
                            timeNorm_1
                        ]);
                    })
                ], [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ])
            ])))), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                let crop_5, fert_6;
                return crop_3.tag === 1 ? crop_3.fields[0] != null ? fert_3.tag === 1 ? fert_3.fields[0] != null ? (crop_5 = crop_3.fields[0], fert_6 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(fert_3.fields[0]), (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(11, []), "Summary", metric.tag === 1 ? $7a6cdebd170bd837$export$24b8311e7a182d66(data, settings, timeNorm, fert_6, crop_5) : metric.tag === 2 ? $7a6cdebd170bd837$export$332e3606e6f3dc9e(data, settings, timeNorm, fert_6, crop_5) : $7a6cdebd170bd837$export$7b7364c939db10fd(data, settings, timeNorm, fert_6, crop_5), uiDispatch)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(10, []), "Growth Calendar", $7a6cdebd170bd837$export$1f8fbcca294430e6(data, settings, fert_6, crop_5), uiDispatch))))) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$emptyPairData(pairData_1)) : (crop_5 = crop_3.fields[0], (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(11, []), "Summary", metric.tag === 1 ? $7a6cdebd170bd837$export$24b8311e7a182d66(data, settings, timeNorm, fert_3.fields[0], crop_5) : metric.tag === 2 ? $7a6cdebd170bd837$export$332e3606e6f3dc9e(data, settings, timeNorm, fert_3.fields[0], crop_5) : $7a6cdebd170bd837$export$7b7364c939db10fd(data, settings, timeNorm, fert_3.fields[0], crop_5), uiDispatch)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(10, []), "Growth Calendar", $7a6cdebd170bd837$export$1f8fbcca294430e6(data, settings, fert_3.fields[0], crop_5), uiDispatch))))) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$emptyPairData(pairData_1)) : fert_3.tag === 1 ? fert_3.fields[0] != null ? (fert_6 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(fert_3.fields[0]), (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(11, []), "Summary", metric.tag === 1 ? $7a6cdebd170bd837$export$24b8311e7a182d66(data, settings, timeNorm, fert_6, crop_3.fields[0]) : metric.tag === 2 ? $7a6cdebd170bd837$export$332e3606e6f3dc9e(data, settings, timeNorm, fert_6, crop_3.fields[0]) : $7a6cdebd170bd837$export$7b7364c939db10fd(data, settings, timeNorm, fert_6, crop_3.fields[0]), uiDispatch)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(10, []), "Growth Calendar", $7a6cdebd170bd837$export$1f8fbcca294430e6(data, settings, fert_6, crop_3.fields[0]), uiDispatch))))) : (0, $42cbcefff7323768$export$439306a4dcaafbb9)($7a6cdebd170bd837$var$emptyPairData(pairData_1)) : (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(11, []), "Summary", metric.tag === 1 ? $7a6cdebd170bd837$export$24b8311e7a182d66(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0]) : metric.tag === 2 ? $7a6cdebd170bd837$export$332e3606e6f3dc9e(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0]) : $7a6cdebd170bd837$export$7b7364c939db10fd(data, settings, timeNorm, fert_3.fields[0], crop_3.fields[0]), uiDispatch)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(ui.OpenDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(10, []), "Growth Calendar", $7a6cdebd170bd837$export$1f8fbcca294430e6(data, settings, fert_3.fields[0], crop_3.fields[0]), uiDispatch))));
            }));
        }))));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_2);
}
function $7a6cdebd170bd837$export$42e1d47c4da371c2(app, dispatch) {
    const patternInput = app.State;
    const ranker = patternInput[1].Ranker;
    const matchValue = ranker.SelectedCropAndFertilizer;
    if (matchValue == null) return (0, $d4ba2fe09a393e3c$export$ccbbfe3e8f80da38)((ranker_1, tupledArg, dispatch_1)=>$7a6cdebd170bd837$export$9677bedee5c30a85(ranker_1, tupledArg[0], tupledArg[1], dispatch_1))(ranker)([
        app.Data,
        patternInput[0]
    ])((arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$78428c3f899407d)(1, [
            arg
        ]));
    });
    else return /*#__PURE__*/ (0, $hURbM.createElement)($7a6cdebd170bd837$export$e05ef57e85bf487b, {
        App: app,
        Dispatch: dispatch,
        Fertilizer: matchValue[1],
        Seed: (0, $22d1a4cfc5fba7ce$export$debb760848ca95a)(matchValue[0])
    });
}
const $7a6cdebd170bd837$export$249b86c029777721 = (0, $6f1b0d5bd41c85b6$export$208cffe87ba62b51)();
const $7a6cdebd170bd837$var$workerSubscribe = $7a6cdebd170bd837$export$249b86c029777721[1];
const $7a6cdebd170bd837$var$workerQueue = $7a6cdebd170bd837$export$249b86c029777721[0];
function $7a6cdebd170bd837$var$optimizerSummary(openDetails, data, settings, dispatch, objective, solution) {
    const xs_1 = (0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
        if (solution == null) return (0, $42cbcefff7323768$export$439306a4dcaafbb9)("Loading...");
        else {
            const solution_1 = solution;
            return (0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(13, []), "Summary", (0, $d4ba2fe09a393e3c$export$309c36585e87dfea)((tupledArg)=>{
                const _arg = tupledArg[1];
                const total = _arg[0];
                const dateSpans = _arg[1];
                return tupledArg[0].tag === 1 ? $7a6cdebd170bd837$export$f6520c7d3e113358(data, settings, total, dateSpans) : $7a6cdebd170bd837$export$2aeacf1f7b6a6342(data, settings, total, dateSpans);
            })([
                objective,
                solution_1
            ]), dispatch)), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$c46d4dde2384c4e1)(openDetails, new (0, $3699f71d1df66484$export$688dd1dfb49cf808)(12, []), "Growth Calendar", (0, $d4ba2fe09a393e3c$export$309c36585e87dfea)((dateSpans_1)=>{
                    let elems;
                    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
                        [
                            "className",
                            "calendar"
                        ],
                        (elems = (0, $e5d9070e144b905e$export$bb44f104e3c54dae)((dateSpan)=>$7a6cdebd170bd837$export$d163fbc5d9993dd(data, settings, dateSpan), dateSpans_1), [
                            "children",
                            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                        ])
                    ])));
                })(solution_1[1]), dispatch))));
        }
    }));
    return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs_1);
}
function $7a6cdebd170bd837$export$69ae9293516e70f0(props) {
    const data = props.Data;
    const settings = props.Settings;
    const objective = props.Objective;
    const patternInput = (0, $f559a3d33a977349$export$88214af1db8f02e1).useState([
        undefined,
        false
    ]);
    const solution = patternInput[0][0];
    const setState = patternInput[1];
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        $7a6cdebd170bd837$var$workerSubscribe((solution_1)=>{
            setState([
                solution_1,
                false
            ]);
        });
    }, []);
    const dependencies_2 = [
        data,
        settings,
        objective
    ];
    (0, $f559a3d33a977349$export$88214af1db8f02e1).useEffect(()=>{
        setState([
            solution,
            true
        ]);
        $7a6cdebd170bd837$var$workerQueue(data)(settings)(objective);
    }, dependencies_2);
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)(patternInput[0][1] ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "className",
            "disabled"
        ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "children",
                $7a6cdebd170bd837$var$optimizerSummary(props.OpenDetails, data, settings, props.Dispatch, objective, solution)
            ])))))));
}
function $7a6cdebd170bd837$export$fe2e36411d703b3d(app, dispatch) {
    const patternInput = app.State;
    const ui = patternInput[1];
    const uiDispatch = (arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
            arg
        ]));
    };
    return /*#__PURE__*/ (0, $hURbM.createElement)("section", (0, $kRS0m.createObj)((0, $42cbcefff7323768$export$effcdbd76139450)((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$439306a4dcaafbb9)([
            "id",
            "visualization"
        ]), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $kRS0m.equals)(ui.Mode, new (0, $3699f71d1df66484$export$e5d97828673c2a38)(0, [])) && ui.Ranker.SelectedCropAndFertilizer == null ? (0, $42cbcefff7323768$export$439306a4dcaafbb9)([
                "className",
                "visualization-chart"
            ]) : (0, $42cbcefff7323768$export$6e22c362a0406a2c)(), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>{
                let elems;
                return (0, $42cbcefff7323768$export$439306a4dcaafbb9)((elems = [
                    /*#__PURE__*/ (0, $hURbM.createElement)((0, $d28ec4fb6293f25e$export$b2539bed5023c21c), {
                        Current: ui.Mode,
                        Dispatch: (arg_1)=>{
                            uiDispatch(new (0, $7c6f80c5743180ba$export$78428c3f899407d)(0, [
                                arg_1
                            ]));
                        },
                        Label: "Visualization",
                        Panel: (_arg)=>{
                            if (_arg.tag === 1) {
                                const xs = [
                                    (0, $d28ec4fb6293f25e$export$645889107ac6ca1b)("Maximize", (0, $64dfd908a2c26bb7$export$41c562ebe57d11e2)("3em", (0, $3921efb06a31e9cc$export$b1398297ef8fc3ed), (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_1)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_1, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$f84cde22303e6288)())), ui.OptimizationObjective, (arg_2)=>{
                                        uiDispatch(new (0, $7c6f80c5743180ba$export$78428c3f899407d)(2, [
                                            arg_2
                                        ]));
                                    })),
                                    /*#__PURE__*/ (0, $hURbM.createElement)($7a6cdebd170bd837$export$69ae9293516e70f0, {
                                        Data: app.Data,
                                        Dispatch: (arg_4)=>{
                                            dispatch(new (0, $7c6f80c5743180ba$export$7c34fbaae8d281c1)(1, [
                                                arg_4
                                            ]));
                                        },
                                        Objective: ui.OptimizationObjective,
                                        OpenDetails: ui.OpenDetails,
                                        Settings: patternInput[0]
                                    })
                                ];
                                return /*#__PURE__*/ $hURbM.createElement($hURbM.Fragment, {}, ...xs);
                            } else return $7a6cdebd170bd837$export$42e1d47c4da371c2(app, uiDispatch);
                        },
                        Tabs: (0, $e5d9070e144b905e$export$871de8747c9eaa88)((x_2)=>(0, $3921efb06a31e9cc$export$e56a6584f93e6957)(x_2, []), (0, $3921efb06a31e9cc$export$9842ee3eadac7211)((0, $3699f71d1df66484$export$34e880ca4a41811a)()))
                    })
                ], [
                    "children",
                    (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
                ]));
            }))))))));
}



var $eATN7 = parcelRequire("eATN7");




var $kRS0m = parcelRequire("kRS0m");

function $1f163c9372977765$export$503101ab93268db0() {
    return (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
}
function $1f163c9372977765$export$a1e0b83b8f1a2416(subs) {
    return (0, $e08834e1786645d9$export$ee1b3e54f0441b22)(subs);
}
function $1f163c9372977765$export$89168cd59c58fe27(idPrefix, f, sub) {
    return (0, $e08834e1786645d9$export$871de8747c9eaa88)((tupledArg)=>[
            (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(idPrefix, tupledArg[0]),
            (dispatch)=>tupledArg[1]((arg)=>{
                    dispatch(f(arg));
                })
        ], sub);
}
function $1f163c9372977765$export$4bb225175fa9bdd7(subId) {
    return (0, $7802b3aa01031554$export$f7e2c8231c57a8bd)("/", subId);
}
function $1f163c9372977765$export$18cfeb019de32239(onError, subId) {
    const ex = new Error("Duplicate SubId");
    return onError([
        "Duplicate SubId: " + $1f163c9372977765$export$4bb225175fa9bdd7(subId),
        ex
    ]);
}
function $1f163c9372977765$export$8654eed44dc7b86b(onError, subId, sub) {
    try {
        (0, $kRS0m.disposeSafe)(sub);
    } catch (ex) {
        onError([
            "Error stopping subscription: " + $1f163c9372977765$export$4bb225175fa9bdd7(subId),
            ex
        ]);
    }
}
function $1f163c9372977765$export$bded3cf2f5de993e(onError, dispatch, subId, start) {
    try {
        return [
            subId,
            start(dispatch)
        ];
    } catch (ex) {
        onError([
            "Error starting subscription: " + $1f163c9372977765$export$4bb225175fa9bdd7(subId),
            ex
        ]);
        return undefined;
    }
}
function $1f163c9372977765$export$c6a1f2ebad4c6a34(onError, subs) {
    (0, $e08834e1786645d9$export$c1a059043cc9c119)((tupledArg)=>{
        $1f163c9372977765$export$8654eed44dc7b86b(onError, tupledArg[0], tupledArg[1]);
    }, subs);
}
function $1f163c9372977765$export$83c32da7c8127c7c(onError, dispatch, dupes, toStop, toKeep, toStart) {
    (0, $e08834e1786645d9$export$c1a059043cc9c119)((subId)=>{
        $1f163c9372977765$export$18cfeb019de32239(onError, subId);
    }, dupes);
    (0, $e08834e1786645d9$export$c1a059043cc9c119)((tupledArg)=>{
        $1f163c9372977765$export$8654eed44dc7b86b(onError, tupledArg[0], tupledArg[1]);
    }, toStop);
    return (0, $e08834e1786645d9$export$10d8903dec122b9d)(toKeep, (0, $e08834e1786645d9$export$7877a478dd30fd3d)((tupledArg_1)=>$1f163c9372977765$export$bded3cf2f5de993e(onError, dispatch, tupledArg_1[0], tupledArg_1[1]), toStart));
}
function $1f163c9372977765$export$487d55045c36844b() {
    return [
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)(),
        (0, $70b963136d0d9ffe$export$6e22c362a0406a2c)({
            Compare: (0, $kRS0m.compare)
        }),
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
    ];
}
function $1f163c9372977765$export$c0c575b56e582161() {
    return $1f163c9372977765$export$487d55045c36844b()[2];
}
function $1f163c9372977765$export$24ee529ecc8a7a30() {
    return $1f163c9372977765$export$487d55045c36844b()[1];
}
function $1f163c9372977765$export$4950448789aecf1b() {
    return $1f163c9372977765$export$487d55045c36844b()[0];
}
function $1f163c9372977765$export$7d58835922496979(subId, start, dupes, newKeys, newSubs) {
    if ((0, $70b963136d0d9ffe$export$2344b14b097df817)(subId, newKeys)) return [
        (0, $e08834e1786645d9$export$8327ebbef2a0ba76)(subId, dupes),
        newKeys,
        newSubs
    ];
    else return [
        dupes,
        (0, $70b963136d0d9ffe$export$e16d8520af44a096)(subId, newKeys),
        (0, $e08834e1786645d9$export$8327ebbef2a0ba76)([
            subId,
            start
        ], newSubs)
    ];
}
function $1f163c9372977765$export$50af4eacfecece73(subs) {
    return (0, $e08834e1786645d9$export$c38b8353041a4f48)((tupledArg, tupledArg_1)=>$1f163c9372977765$export$7d58835922496979(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1], tupledArg_1[2]), subs, $1f163c9372977765$export$487d55045c36844b());
}
const $1f163c9372977765$export$14b5df1a6aa38338 = (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
function $1f163c9372977765$export$5a36da169440fb98(activeSubs, sub) {
    const keys = (0, $70b963136d0d9ffe$export$97ef4da51e4fceb3)((0, $e08834e1786645d9$export$871de8747c9eaa88)((tuple)=>tuple[0], activeSubs), {
        Compare: (0, $kRS0m.compare)
    });
    const patternInput = $1f163c9372977765$export$50af4eacfecece73(sub);
    const newKeys = patternInput[1];
    const dupes = patternInput[0];
    if (keys.Equals(newKeys)) return [
        dupes,
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)(),
        activeSubs,
        (0, $e08834e1786645d9$export$6e22c362a0406a2c)()
    ];
    else {
        const patternInput_1 = (0, $e08834e1786645d9$export$b29f828819edca8d)((tupledArg)=>(0, $70b963136d0d9ffe$export$2344b14b097df817)(tupledArg[0], newKeys), activeSubs);
        return [
            dupes,
            patternInput_1[1],
            patternInput_1[0],
            (0, $e08834e1786645d9$export$3dea766d36a8935f)((tupledArg_1)=>!(0, $70b963136d0d9ffe$export$2344b14b097df817)(tupledArg_1[0], keys), patternInput[2])
        ];
    }
}



var $kRS0m = parcelRequire("kRS0m");



class $428bca6c07064d08$export$c1cbdee04e18ea8b {
    constructor(onNext, onError, onCompleted){
        this.OnNext = onNext;
        this.OnError = onError || ((_e)=>{
            return;
        });
        this.OnCompleted = onCompleted || (()=>{
            return;
        });
    }
}
class $428bca6c07064d08$var$Observable {
    constructor(subscribe){
        this.Subscribe = subscribe;
    }
}
function $428bca6c07064d08$var$protect(f, succeed, fail) {
    try {
        return succeed(f());
    } catch (e) {
        fail(e);
    }
}
function $428bca6c07064d08$export$e16d8520af44a096(callback, source) {
    source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b(callback));
}
function $428bca6c07064d08$export$7877a478dd30fd3d(chooser, source) {
    return new $428bca6c07064d08$var$Observable((observer)=>source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((t)=>$428bca6c07064d08$var$protect(()=>chooser(t), (u)=>{
                if (u != null) observer.OnNext((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(u));
            }, observer.OnError), observer.OnError, observer.OnCompleted)));
}
function $428bca6c07064d08$export$3dea766d36a8935f(predicate, source) {
    return $428bca6c07064d08$export$7877a478dd30fd3d((x)=>predicate(x) ? x : void 0, source);
}
function $428bca6c07064d08$export$871de8747c9eaa88(mapping, source) {
    return new $428bca6c07064d08$var$Observable((observer)=>source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((t)=>{
            $428bca6c07064d08$var$protect(()=>mapping(t), observer.OnNext, observer.OnError);
        }, observer.OnError, observer.OnCompleted)));
}
function $428bca6c07064d08$export$4950aa0f605343fb(source1, source2) {
    return new $428bca6c07064d08$var$Observable((observer)=>{
        let stopped = false;
        let completed1 = false;
        let completed2 = false;
        const h1 = source1.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((v)=>{
            if (!stopped) observer.OnNext(v);
        }, (e)=>{
            if (!stopped) {
                stopped = true;
                observer.OnError(e);
            }
        }, ()=>{
            if (!stopped) {
                completed1 = true;
                if (completed2) {
                    stopped = true;
                    observer.OnCompleted();
                }
            }
        }));
        const h2 = source2.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((v)=>{
            if (!stopped) observer.OnNext(v);
        }, (e)=>{
            if (!stopped) {
                stopped = true;
                observer.OnError(e);
            }
        }, ()=>{
            if (!stopped) {
                completed2 = true;
                if (completed1) {
                    stopped = true;
                    observer.OnCompleted();
                }
            }
        }));
        return {
            Dispose () {
                h1.Dispose();
                h2.Dispose();
            }
        };
    });
}
function $428bca6c07064d08$export$8f9d79d42bff1aac(source) {
    return new $428bca6c07064d08$var$Observable((observer)=>{
        let last;
        return source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((next)=>{
            if (last != null) observer.OnNext([
                last,
                next
            ]);
            last = next;
        }, observer.OnError, observer.OnCompleted));
    });
}
function $428bca6c07064d08$export$b29f828819edca8d(predicate, source) {
    return [
        $428bca6c07064d08$export$3dea766d36a8935f(predicate, source),
        $428bca6c07064d08$export$3dea766d36a8935f((x)=>!predicate(x), source)
    ];
}
function $428bca6c07064d08$export$c87d910e63d22ed6(collector, state, source) {
    return new $428bca6c07064d08$var$Observable((observer)=>{
        return source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b((t)=>{
            $428bca6c07064d08$var$protect(()=>collector(state, t), (u)=>{
                state = u;
                observer.OnNext(u);
            }, observer.OnError);
        }, observer.OnError, observer.OnCompleted));
    });
}
function $428bca6c07064d08$export$65980d18b75784e2(splitter, source) {
    return [
        $428bca6c07064d08$export$7877a478dd30fd3d((v)=>(0, $5eb55d943c3c909d$export$fa1662153a0f8ae0)(splitter(v)), source),
        $428bca6c07064d08$export$7877a478dd30fd3d((v)=>(0, $5eb55d943c3c909d$export$98a79814ad2a35f)(splitter(v)), source)
    ];
}
function $428bca6c07064d08$export$ec068583843480e7(callback, source) {
    return source.Subscribe(new $428bca6c07064d08$export$c1cbdee04e18ea8b(callback));
}




class $5a35727ba12fdf8d$export$9a985b200af78b9a {
    constructor(){
        this.delegates = [];
    }
    _add(d) {
        this.delegates.push(d);
    }
    _remove(d) {
        const index = this.delegates.indexOf(d);
        if (index > -1) this.delegates.splice(index, 1);
    }
    get Publish() {
        return $5a35727ba12fdf8d$export$c30017717ce2168e((h)=>{
            this._add(h);
        }, (h)=>{
            this._remove(h);
        });
    }
    Trigger(senderOrValue, valueOrUndefined) {
        let sender = null;
        const value = valueOrUndefined === undefined ? senderOrValue : (sender = senderOrValue, valueOrUndefined);
        this.delegates.forEach((f)=>{
            f(sender, value);
        });
    }
}
class $5a35727ba12fdf8d$export$d61e24a684f9e51 extends $5a35727ba12fdf8d$export$9a985b200af78b9a {
}
function $5a35727ba12fdf8d$export$e16d8520af44a096(callback, sourceEvent) {
    (0, $428bca6c07064d08$export$ec068583843480e7)(callback, sourceEvent);
}
function $5a35727ba12fdf8d$export$7877a478dd30fd3d(chooser, sourceEvent) {
    const ev = new $5a35727ba12fdf8d$export$d61e24a684f9e51();
    $5a35727ba12fdf8d$export$e16d8520af44a096((t)=>{
        const u = chooser(t);
        if (u != null) ev.Trigger((0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(u));
    }, sourceEvent);
    return ev.Publish;
}
function $5a35727ba12fdf8d$export$3dea766d36a8935f(predicate, sourceEvent) {
    return $5a35727ba12fdf8d$export$7877a478dd30fd3d((x)=>predicate(x) ? (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(x) : undefined, sourceEvent);
}
function $5a35727ba12fdf8d$export$871de8747c9eaa88(mapping, sourceEvent) {
    const ev = new $5a35727ba12fdf8d$export$d61e24a684f9e51();
    $5a35727ba12fdf8d$export$e16d8520af44a096((t)=>ev.Trigger(mapping(t)), sourceEvent);
    return ev.Publish;
}
function $5a35727ba12fdf8d$export$4950aa0f605343fb(event1, event2) {
    const ev = new $5a35727ba12fdf8d$export$d61e24a684f9e51();
    const fn = (x)=>ev.Trigger(x);
    $5a35727ba12fdf8d$export$e16d8520af44a096(fn, event1);
    $5a35727ba12fdf8d$export$e16d8520af44a096(fn, event2);
    return ev.Publish;
}
function $5a35727ba12fdf8d$export$8f9d79d42bff1aac(sourceEvent) {
    const ev = new $5a35727ba12fdf8d$export$d61e24a684f9e51();
    let last;
    let haveLast = false;
    $5a35727ba12fdf8d$export$e16d8520af44a096((next)=>{
        if (haveLast) ev.Trigger([
            last,
            next
        ]);
        last = next;
        haveLast = true;
    }, sourceEvent);
    return ev.Publish;
}
function $5a35727ba12fdf8d$export$b29f828819edca8d(predicate, sourceEvent) {
    return [
        $5a35727ba12fdf8d$export$3dea766d36a8935f(predicate, sourceEvent),
        $5a35727ba12fdf8d$export$3dea766d36a8935f((x)=>!predicate(x), sourceEvent)
    ];
}
function $5a35727ba12fdf8d$export$c87d910e63d22ed6(collector, state, sourceEvent) {
    return $5a35727ba12fdf8d$export$871de8747c9eaa88((t)=>state = collector(state, t), sourceEvent);
}
function $5a35727ba12fdf8d$export$65980d18b75784e2(splitter, sourceEvent) {
    return [
        $5a35727ba12fdf8d$export$7877a478dd30fd3d((v)=>(0, $5eb55d943c3c909d$export$fa1662153a0f8ae0)(splitter(v)), sourceEvent),
        $5a35727ba12fdf8d$export$7877a478dd30fd3d((v)=>(0, $5eb55d943c3c909d$export$98a79814ad2a35f)(splitter(v)), sourceEvent)
    ];
}
function $5a35727ba12fdf8d$export$c30017717ce2168e(addHandler, removeHandler) {
    return {
        AddHandler (h) {
            addHandler(h);
        },
        RemoveHandler (h) {
            removeHandler(h);
        },
        Subscribe (r) {
            const h = (_, args)=>r.OnNext(args);
            addHandler(h);
            return {
                Dispose () {
                    removeHandler(h);
                }
            };
        }
    };
}


class $7b0c0796ef064b1f$export$c57e9b2d8b9e4de {
    constructor(interval){
        this._enabled = false;
        this._isDisposed = false;
        this._intervalId = 0;
        this._timeoutId = 0;
        this.Interval = interval && interval > 0 ? interval : 100;
        this.AutoReset = true;
        this._elapsed = new (0, $5a35727ba12fdf8d$export$d61e24a684f9e51)();
    }
    Elapsed() {
        return this._elapsed.Publish;
    }
    get Enabled() {
        return this._enabled;
    }
    set Enabled(x) {
        if (!this._isDisposed && this._enabled !== x) {
            this._enabled = x;
            if (this._enabled) {
                if (this.AutoReset) this._intervalId = setInterval(()=>{
                    if (!this.AutoReset) this.Enabled = false;
                    this._elapsed.Trigger(new Date());
                }, this.Interval);
                else this._timeoutId = setTimeout(()=>{
                    this.Enabled = false;
                    this._timeoutId = 0;
                    if (this.AutoReset) this.Enabled = true;
                    this._elapsed.Trigger(new Date());
                }, this.Interval);
            } else {
                if (this._timeoutId) {
                    clearTimeout(this._timeoutId);
                    this._timeoutId = 0;
                }
                if (this._intervalId) {
                    clearInterval(this._intervalId);
                    this._intervalId = 0;
                }
            }
        }
    }
    Dispose() {
        this.Enabled = false;
        this._isDisposed = true;
    }
    Close() {
        this.Dispose();
    }
    Start() {
        this.Enabled = true;
    }
    Stop() {
        this.Enabled = false;
    }
}
var $7b0c0796ef064b1f$export$2e2bcd8739ae039 = $7b0c0796ef064b1f$export$c57e9b2d8b9e4de;




function $8c6d366d4187f1a7$export$8b5266efefde31a6(text, ex) {
    console.error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(text), ex);
}
function $8c6d366d4187f1a7$export$ad0e6b941a4b3b3f(text, o) {
    console.log((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(text), o);
}
function $8c6d366d4187f1a7$export$19a39a990a42c417(interval, callback) {
    let t;
    let returnVal = new (0, $7b0c0796ef064b1f$export$2e2bcd8739ae039)(interval);
    returnVal.AutoReset = false;
    t = returnVal;
    (0, $428bca6c07064d08$export$e16d8520af44a096)(callback, t.Elapsed());
    t.Enabled = true;
    t.Start();
}
function $8c6d366d4187f1a7$export$801df9dd92c5d622(x) {
    $8c6d366d4187f1a7$export$19a39a990a42c417(1, (_arg)=>{
        (0, $763a759a208c993b$export$c0ab9605f4365dec)(x);
    });
}






function $c9419b5080a79599$export$87b90e3fbd3ddb94(onError, dispatch, cmd) {
    (0, $e08834e1786645d9$export$c1a059043cc9c119)((call)=>{
        try {
            call(dispatch);
        } catch (ex) {
            onError(ex);
        }
    }, cmd);
}
function $c9419b5080a79599$export$c1c85bb23ed90365() {
    return (0, $e08834e1786645d9$export$6e22c362a0406a2c)();
}
function $c9419b5080a79599$export$65566ec9a374113b(f, cmd) {
    return (0, $e08834e1786645d9$export$871de8747c9eaa88)((g)=>(arg_1)=>{
            g((arg)=>{
                arg_1(f(arg));
            });
        }, cmd);
}
function $c9419b5080a79599$export$7e5e7d6bb47890be(cmds) {
    return (0, $e08834e1786645d9$export$ee1b3e54f0441b22)(cmds);
}
function $c9419b5080a79599$export$e9e89ebd334bbd20(effect) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)(effect);
}
function $c9419b5080a79599$export$14dc1387c233ef54(task, arg, ofSuccess, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            dispatch(ofSuccess(task(arg)));
        } catch (x) {
            dispatch(ofError(x));
        }
    });
}
function $c9419b5080a79599$export$41e72375358bf579(task, arg, ofSuccess) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            dispatch(ofSuccess(task(arg)));
        } catch (matchValue) {}
    });
}
function $c9419b5080a79599$export$d927850ffbeb637e(task, arg, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            task(arg);
        } catch (x) {
            dispatch(ofError(x));
        }
    });
}
function $c9419b5080a79599$export$a165c3f4cedbc7e(start, task, arg, ofSuccess, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((arg_1)=>{
        let dispatch;
        start((dispatch = arg_1, (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).TryWith((0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Bind(task(arg), (_arg)=>{
                    dispatch(ofSuccess(_arg));
                    return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
                })), (_arg_1)=>{
                dispatch(ofError(_arg_1));
                return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
            }))));
    });
}
function $c9419b5080a79599$export$f28a73ce8ba369ca(start, task, arg, ofSuccess) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((arg_1)=>{
        start((0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).TryWith((0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Bind(task(arg), (_arg)=>{
                    arg_1(ofSuccess(_arg));
                    return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
                })), (_arg_1)=>{
                return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
            })));
    });
}
function $c9419b5080a79599$export$854e8ceed5ba9a13(start, task, arg, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((arg_1)=>{
        start((0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).TryWith((0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Delay(()=>(0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Bind(task(arg), (_arg)=>{
                    return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
                })), (_arg_1)=>{
                arg_1(ofError(_arg_1));
                return (0, $e7c6c1bf42f1ef53$export$439306a4dcaafbb9).Zero();
            })));
    });
}
function $c9419b5080a79599$export$aebe06d04b6cb237(x) {
    (0, $8c6d366d4187f1a7$export$19a39a990a42c417)(1, (_arg)=>{
        (0, $763a759a208c993b$export$c0ab9605f4365dec)(x);
    });
}
function $c9419b5080a79599$export$35db8626bda3d841(task, arg, ofSuccess, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            task(arg).then((arg_3)=>{
                dispatch(ofSuccess(arg_3));
            }).catch((arg_2)=>{
                dispatch(ofError(arg_2));
            });
        } catch (x) {
            dispatch(ofError(x));
        }
    });
}
function $c9419b5080a79599$export$e26ca5d5c1321760(task, arg, ofSuccess) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            task(arg).then((arg_1)=>dispatch(ofSuccess(arg_1)));
        } catch (matchValue) {}
    });
}
function $c9419b5080a79599$export$cfa7c798b301eadd(task, arg, ofError) {
    return (0, $e08834e1786645d9$export$439306a4dcaafbb9)((dispatch)=>{
        try {
            task(arg).catch((arg_2)=>{
                dispatch(ofError(arg_2));
            });
        } catch (x) {
            dispatch(ofError(x));
        }
    });
}




var $eATN7 = parcelRequire("eATN7");






var $kRS0m = parcelRequire("kRS0m");

class $49f94544e08d5b32$export$b9a5a3b23239a594 extends (0, $eATN7.Union) {
    constructor(tag, fields){
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return [
            "Writable",
            "ReadWritable"
        ];
    }
}
function $49f94544e08d5b32$export$72a32a1c73a129c2(gen0) {
    return (0, $3921efb06a31e9cc$export$1ae0dd948e267c6b)("Elmish.RingState`1", [
        gen0
    ], $49f94544e08d5b32$export$b9a5a3b23239a594, ()=>[
            [
                [
                    "wx",
                    (0, $3921efb06a31e9cc$export$9242f430c61b672d)(gen0)
                ],
                [
                    "ix",
                    (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
                ]
            ],
            [
                [
                    "rw",
                    (0, $3921efb06a31e9cc$export$9242f430c61b672d)(gen0)
                ],
                [
                    "wix",
                    (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
                ],
                [
                    "rix",
                    (0, $3921efb06a31e9cc$export$d5481a1dd0e3648a)
                ]
            ]
        ]);
}
class $49f94544e08d5b32$export$e506074cbaa8a80 {
    constructor(size){
        this.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(0, [
            (0, $e5d9070e144b905e$export$9563e054e6f787fb)(new Array((0, $5ce0fb420d4fadad$export$8960430cfd85939f)(size, 10)), 0, (0, $5ce0fb420d4fadad$export$8960430cfd85939f)(size, 10), null),
            0
        ]);
    }
}
function $49f94544e08d5b32$export$b9b21bdd99045e0c(gen0) {
    return (0, $3921efb06a31e9cc$export$8547d5acd31924e)("Elmish.RingBuffer`1", [
        gen0
    ], $49f94544e08d5b32$export$e506074cbaa8a80);
}
function $49f94544e08d5b32$export$d525a227b3900912(size) {
    return new $49f94544e08d5b32$export$e506074cbaa8a80(size);
}
function $49f94544e08d5b32$export$8db6c49124991eed(__) {
    const matchValue = __.state;
    if (matchValue.tag === 1) {
        const wix = matchValue.fields[1] | 0;
        const rix = matchValue.fields[2] | 0;
        const items = matchValue.fields[0];
        const rix$0027 = (rix + 1) % items.length | 0;
        if (rix$0027 === wix) __.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(0, [
            items,
            wix
        ]);
        else __.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(1, [
            items,
            wix,
            rix$0027
        ]);
        return (0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)((0, $e5d9070e144b905e$export$7061c75fc5af8b7e)(rix, items));
    } else return undefined;
}
function $49f94544e08d5b32$export$f7571d77fa89f376(__, item) {
    const matchValue = __.state;
    if (matchValue.tag === 1) {
        const wix_1 = matchValue.fields[1] | 0;
        const rix = matchValue.fields[2] | 0;
        const items_1 = matchValue.fields[0];
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(items_1, wix_1, item);
        const wix$0027 = (wix_1 + 1) % items_1.length | 0;
        if (wix$0027 === rix) __.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(1, [
            $49f94544e08d5b32$export$4b26cee19b2f73f6(__, rix, items_1),
            items_1.length,
            0
        ]);
        else __.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(1, [
            items_1,
            wix$0027,
            rix
        ]);
    } else {
        const ix = matchValue.fields[1] | 0;
        const items = matchValue.fields[0];
        (0, $e5d9070e144b905e$export$8a8216c44337cd5)(items, ix, item);
        const wix = (ix + 1) % items.length | 0;
        __.state = new $49f94544e08d5b32$export$b9a5a3b23239a594(1, [
            items,
            wix,
            ix
        ]);
    }
}
function $49f94544e08d5b32$export$4b26cee19b2f73f6(this$, ix, items) {
    return Array.from((0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$955fc4a6c4be454d)(ix, items), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$10d8903dec122b9d)((0, $42cbcefff7323768$export$b7df5d561049483a)(ix, items), (0, $42cbcefff7323768$export$1391212d75b2ee65)(()=>(0, $42cbcefff7323768$export$bb44f104e3c54dae)((matchValue)=>(0, $42cbcefff7323768$export$439306a4dcaafbb9)((0, $kRS0m.defaultOf)()), (0, $c7733b1bbdc2597b$export$b4822f0c51847685)(0, 1, items.length))))))));
}




class $94ef8c33912f1c43$export$e5f12ed22b8c4ce1 extends (0, $eATN7.Record) {
    constructor(init, update, subscribe, view, setState, onError, termination){
        super();
        this.init = init;
        this.update = update;
        this.subscribe = subscribe;
        this.view = view;
        this.setState = setState;
        this.onError = onError;
        this.termination = termination;
    }
}
function $94ef8c33912f1c43$export$43bb82e191693a3a(gen0, gen1, gen2, gen3) {
    return (0, $3921efb06a31e9cc$export$d341dea990ee4af6)("Elmish.Program`4", [
        gen0,
        gen1,
        gen2,
        gen3
    ], $94ef8c33912f1c43$export$e5f12ed22b8c4ce1, ()=>[
            [
                "init",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen0, (0, $3921efb06a31e9cc$export$2163aa004254c8ff)(gen1, (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)))))
            ],
            [
                "update",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$2163aa004254c8ff)(gen1, (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8))))))
            ],
            [
                "subscribe",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$5fe717259b8d6105)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734)), (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$8547d5acd31924e)("System.IDisposable")))))
            ],
            [
                "view",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), gen3))
            ],
            [
                "setState",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)))
            ],
            [
                "onError",
                (0, $3921efb06a31e9cc$export$14857d36df600d23)((0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$36bbd56a39d3f734), (0, $3921efb06a31e9cc$export$8547d5acd31924e)("System.Exception")), (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8))
            ],
            [
                "termination",
                (0, $3921efb06a31e9cc$export$2163aa004254c8ff)((0, $3921efb06a31e9cc$export$14857d36df600d23)(gen2, (0, $3921efb06a31e9cc$export$4b2f4351dd8f4737)), (0, $3921efb06a31e9cc$export$14857d36df600d23)(gen1, (0, $3921efb06a31e9cc$export$ffcad4a7b72710d8)))
            ]
        ]);
}
function $94ef8c33912f1c43$export$9749e7898815168a(init, update, view) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(init, update, (_arg)=>(0, $1f163c9372977765$export$503101ab93268db0)(), view, (0, $kRS0m.uncurry2)((model)=>{
        const f1 = (0, $kRS0m.curry2)(view)(model);
        return (arg)=>{
            f1(arg);
        };
    }), (tupledArg)=>{
        (0, $8c6d366d4187f1a7$export$8b5266efefde31a6)(tupledArg[0], tupledArg[1]);
    }, [
        (_arg_1)=>false,
        (value_1)=>{}
    ]);
}
function $94ef8c33912f1c43$export$4e9ed9c262e4f494(init, update, view) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1((arg)=>[
            init(arg),
            (0, $c9419b5080a79599$export$c1c85bb23ed90365)()
        ], (0, $kRS0m.uncurry2)((msg)=>{
        const f1_1 = (0, $kRS0m.curry2)(update)(msg);
        return (arg_1)=>[
                f1_1(arg_1),
                (0, $c9419b5080a79599$export$c1c85bb23ed90365)()
            ];
    }), (_arg)=>(0, $1f163c9372977765$export$503101ab93268db0)(), view, (0, $kRS0m.uncurry2)((model)=>{
        const f1_2 = (0, $kRS0m.curry2)(view)(model);
        return (arg_2)=>{
            f1_2(arg_2);
        };
    }), (tupledArg)=>{
        (0, $8c6d366d4187f1a7$export$8b5266efefde31a6)(tupledArg[0], tupledArg[1]);
    }, [
        (_arg_1)=>false,
        (value_1)=>{}
    ]);
}
function $94ef8c33912f1c43$export$5f45d655e6682635(subscribe, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, subscribe, program.view, program.setState, program.onError, program.termination);
}
function $94ef8c33912f1c43$export$d3a3aea856afff96(map, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, (0, $kRS0m.curry2)(map)(program.subscribe), program.view, program.setState, program.onError, program.termination);
}
function $94ef8c33912f1c43$export$bf8086399086782a(program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1((arg)=>{
        const patternInput = program.init(arg);
        const initModel = patternInput[0];
        (0, $8c6d366d4187f1a7$export$ad0e6b941a4b3b3f)("Initial state:", initModel);
        return [
            initModel,
            patternInput[1]
        ];
    }, (msg, model)=>{
        (0, $8c6d366d4187f1a7$export$ad0e6b941a4b3b3f)("New message:", msg);
        const patternInput_1 = program.update(msg, model);
        const newModel = patternInput_1[0];
        (0, $8c6d366d4187f1a7$export$ad0e6b941a4b3b3f)("Updated state:", newModel);
        return [
            newModel,
            patternInput_1[1]
        ];
    }, (model_1)=>{
        const sub = program.subscribe(model_1);
        (0, $8c6d366d4187f1a7$export$ad0e6b941a4b3b3f)("Updated subs:", (0, $e08834e1786645d9$export$871de8747c9eaa88)((tuple)=>tuple[0], sub));
        return sub;
    }, program.view, program.setState, program.onError, program.termination);
}
function $94ef8c33912f1c43$export$175cc65bbfe0745f(trace, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, (msg, model)=>{
        const patternInput = program.update(msg, model);
        const state = patternInput[0];
        trace(msg, state, (0, $e08834e1786645d9$export$871de8747c9eaa88)((tuple)=>tuple[0], program.subscribe(state)));
        return [
            state,
            patternInput[1]
        ];
    }, program.subscribe, program.view, program.setState, program.onError, program.termination);
}
function $94ef8c33912f1c43$export$4338a2efe643dfa3(onError, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, program.subscribe, program.view, program.setState, onError, program.termination);
}
function $94ef8c33912f1c43$export$55e26b07c1a9d894(predicate, terminate, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, program.subscribe, program.view, program.setState, program.onError, [
        predicate,
        terminate
    ]);
}
function $94ef8c33912f1c43$export$256ebf7815de6bf4(map, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, program.subscribe, program.view, program.setState, program.onError, map(program.termination));
}
function $94ef8c33912f1c43$export$c4cef55bf41fb8d5(map, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, program.subscribe, program.view, program.setState, (0, $kRS0m.curry2)(map)(program.onError), program.termination);
}
function $94ef8c33912f1c43$export$1d92b010d49ca3f8(program) {
    return program.onError;
}
function $94ef8c33912f1c43$export$94c509df74a3b363(setState, program) {
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(program.init, program.update, program.subscribe, program.view, setState, program.onError, program.termination);
}
function $94ef8c33912f1c43$export$781e67079c7385c8(program) {
    return (0, $kRS0m.curry2)(program.setState);
}
function $94ef8c33912f1c43$export$5acf115f7e181dad(program) {
    return (0, $kRS0m.curry2)(program.view);
}
function $94ef8c33912f1c43$export$959935b7abfcf6c5(program) {
    return program.init;
}
function $94ef8c33912f1c43$export$390c8e87918206f8(program) {
    return (0, $kRS0m.curry2)(program.update);
}
function $94ef8c33912f1c43$export$2cf8c6fc73672882(mapInit, mapUpdate, mapView, mapSetState, mapSubscribe, mapTermination, program) {
    const init = (0, $kRS0m.curry2)(mapInit)(program.init);
    const update = (0, $kRS0m.curry3)(mapUpdate)((0, $kRS0m.curry2)(program.update));
    const view = (0, $kRS0m.curry3)(mapView)((0, $kRS0m.curry2)(program.view));
    const setState = (0, $kRS0m.curry3)(mapSetState)((0, $kRS0m.curry2)(program.setState));
    return new $94ef8c33912f1c43$export$e5f12ed22b8c4ce1(init, (0, $kRS0m.uncurry2)(update), (0, $kRS0m.curry2)(mapSubscribe)(program.subscribe), (0, $kRS0m.uncurry2)(view), (0, $kRS0m.uncurry2)(setState), program.onError, mapTermination(program.termination));
}
function $94ef8c33912f1c43$export$78d685716d75b0ed(syncDispatch, arg, program) {
    let tupledArg_1;
    const patternInput = program.init(arg);
    const model = patternInput[0];
    const sub = program.subscribe(model);
    const patternInput_1 = program.termination;
    const rb = (0, $49f94544e08d5b32$export$d525a227b3900912)(10);
    let reentered = false;
    let state = model;
    let activeSubs = (0, $1f163c9372977765$export$14b5df1a6aa38338);
    let terminated = false;
    const dispatch = (msg)=>{
        if (!terminated) {
            (0, $49f94544e08d5b32$export$f7571d77fa89f376)(rb, msg);
            if (!reentered) {
                reentered = true;
                processMsgs();
                reentered = false;
            }
        }
    };
    const dispatch$0027 = (0, $kRS0m.curry2)(syncDispatch)(dispatch);
    const processMsgs = ()=>{
        let tupledArg;
        let nextMsg = (0, $49f94544e08d5b32$export$8db6c49124991eed)(rb);
        while(!terminated && nextMsg != null){
            const msg_1 = (0, $22d1a4cfc5fba7ce$export$2ab9a8f9f1186f14)(nextMsg);
            try {
                if (patternInput_1[0](msg_1)) {
                    (0, $1f163c9372977765$export$c6a1f2ebad4c6a34)(program.onError, activeSubs);
                    patternInput_1[1](state);
                    terminated = true;
                } else {
                    const patternInput_2 = program.update(msg_1, state);
                    const model$0027 = patternInput_2[0];
                    const sub$0027 = program.subscribe(model$0027);
                    program.setState(model$0027, dispatch$0027);
                    activeSubs = (tupledArg = (0, $1f163c9372977765$export$5a36da169440fb98)(activeSubs, sub$0027), (0, $1f163c9372977765$export$83c32da7c8127c7c)(program.onError, dispatch$0027, tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]));
                    (0, $c9419b5080a79599$export$87b90e3fbd3ddb94)((ex)=>{
                        program.onError([
                            (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Error handling the message: %A"))(msg_1),
                            ex
                        ]);
                    }, dispatch$0027, patternInput_2[1]);
                    state = model$0027;
                }
            } catch (ex_1) {
                program.onError([
                    (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Unable to process the message: %A"))(msg_1),
                    ex_1
                ]);
            }
            nextMsg = (0, $49f94544e08d5b32$export$8db6c49124991eed)(rb);
        }
    };
    reentered = true;
    program.setState(model, dispatch$0027);
    activeSubs = (tupledArg_1 = (0, $1f163c9372977765$export$5a36da169440fb98)(activeSubs, sub), (0, $1f163c9372977765$export$83c32da7c8127c7c)(program.onError, dispatch$0027, tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3]));
    (0, $c9419b5080a79599$export$87b90e3fbd3ddb94)((ex_2)=>{
        program.onError([
            (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("Error intitializing:")),
            ex_2
        ]);
    }, dispatch$0027, patternInput[1]);
    processMsgs();
    reentered = false;
}
function $94ef8c33912f1c43$export$c67cadbb4ffc7d9e(arg, program) {
    $94ef8c33912f1c43$export$78d685716d75b0ed((0, $kRS0m.uncurry2)((x)=>x), arg, program);
}
function $94ef8c33912f1c43$export$bf201e6f292f34fd(program) {
    $94ef8c33912f1c43$export$c67cadbb4ffc7d9e(undefined, program);
}




var $kRS0m = parcelRequire("kRS0m");
var $cbaa8c06f9f2e7f3$export$882461b6382ed46c;
var $cbaa8c06f9f2e7f3$export$757ceba2d55c277e;

var $cc1z1 = parcelRequire("cc1z1");
var $cbaa8c06f9f2e7f3$require$render = $cc1z1.render;
var $cbaa8c06f9f2e7f3$require$hydrate = $cc1z1.hydrate;
var $cbaa8c06f9f2e7f3$require$unmountComponentAtNode = $cc1z1.unmountComponentAtNode;
function $cbaa8c06f9f2e7f3$var$createRoot(container) {
    return {
        // eslint-disable-next-line
        render: function(children) {
            $cbaa8c06f9f2e7f3$require$render(children, container);
        },
        // eslint-disable-next-line
        unmount: function() {
            $cbaa8c06f9f2e7f3$require$unmountComponentAtNode(container);
        }
    };
}
$cbaa8c06f9f2e7f3$export$882461b6382ed46c = $cbaa8c06f9f2e7f3$var$createRoot;
$cbaa8c06f9f2e7f3$export$757ceba2d55c277e = function(container, children) {
    $cbaa8c06f9f2e7f3$require$hydrate(children, container);
    return $cbaa8c06f9f2e7f3$var$createRoot(container);
};



function $59ff45db8a5d7670$export$f7cd346b76ebdeb7(lazyView2With, placeholderId, program) {
    let lastRequest, root;
    return (0, $94ef8c33912f1c43$export$94c509df74a3b363)((0, $kRS0m.uncurry2)((lastRequest = undefined, root = $cbaa8c06f9f2e7f3$export$882461b6382ed46c(document.getElementById(placeholderId)), (model)=>(dispatch)=>{
            if (lastRequest != null) {
                const r = lastRequest;
                window.cancelAnimationFrame(r);
            }
            lastRequest = window.requestAnimationFrame((_arg)=>{
                root.render(lazyView2With((x)=>(y)=>x === y, (0, $94ef8c33912f1c43$export$5acf115f7e181dad)(program), model, dispatch));
            });
        })), program);
}
function $59ff45db8a5d7670$export$c3db57ce2d479607(lazyView2With, placeholderId, program) {
    let root;
    return (0, $94ef8c33912f1c43$export$94c509df74a3b363)((0, $kRS0m.uncurry2)((root = $cbaa8c06f9f2e7f3$export$882461b6382ed46c(document.getElementById(placeholderId)), (model)=>(dispatch)=>{
            root.render(lazyView2With((x)=>(y)=>x === y, (0, $94ef8c33912f1c43$export$5acf115f7e181dad)(program), model, dispatch));
        })), program);
}
function $59ff45db8a5d7670$export$41a9cc914525bee5(lazyView2With, placeholderId, program) {
    let root;
    return (0, $94ef8c33912f1c43$export$94c509df74a3b363)((0, $kRS0m.uncurry2)((root = undefined, (model)=>(dispatch)=>{
            if (root != null) {
                const root_1 = root;
                root_1.render(lazyView2With((x_1)=>(y_1)=>x_1 === y_1, (0, $94ef8c33912f1c43$export$5acf115f7e181dad)(program), model, dispatch));
            } else root = $cbaa8c06f9f2e7f3$export$757ceba2d55c277e(document.getElementById(placeholderId), lazyView2With((x)=>(y)=>x === y, (0, $94ef8c33912f1c43$export$5acf115f7e181dad)(program), model, dispatch));
        })), program);
}
function $59ff45db8a5d7670$export$a7b1b77d240c0203(placeholderId, program) {
    return $59ff45db8a5d7670$export$f7cd346b76ebdeb7((equal, view, state, dispatch)=>(0, $d4ba2fe09a393e3c$export$c1ca94126b5caa96)((0, $kRS0m.uncurry2)(equal), (0, $kRS0m.uncurry2)(view), state, dispatch), placeholderId, program);
}
function $59ff45db8a5d7670$export$eb041fa74866fdee(placeholderId, program) {
    return $59ff45db8a5d7670$export$c3db57ce2d479607((equal, view, state, dispatch)=>(0, $d4ba2fe09a393e3c$export$c1ca94126b5caa96)((0, $kRS0m.uncurry2)(equal), (0, $kRS0m.uncurry2)(view), state, dispatch), placeholderId, program);
}
function $59ff45db8a5d7670$export$8da882178c68e9aa(placeholderId, program) {
    return $59ff45db8a5d7670$export$41a9cc914525bee5((equal, view, state, dispatch)=>(0, $d4ba2fe09a393e3c$export$c1ca94126b5caa96)((0, $kRS0m.uncurry2)(equal), (0, $kRS0m.uncurry2)(view), state, dispatch), placeholderId, program);
}


const $256f9899b89282e9$export$fb931cd598921492 = (0, $d28ec4fb6293f25e$export$12bf26cb720cb002)(100, (tupledArg)=>{
    (0, $6107b71bda0f6ed5$export$520eda09f56bd178)(tupledArg[0], tupledArg[1]);
});
const $256f9899b89282e9$export$68cfa81e36b6a2f4 = (0, $d28ec4fb6293f25e$export$12bf26cb720cb002)(100, (presets)=>{
    (0, $6107b71bda0f6ed5$export$7c05abc0fc70f420)(presets);
});
function $256f9899b89282e9$export$722fbec263ad908a(msg, app) {
    switch(msg.tag){
        case 1:
            {
                const presets_1 = (0, $7c6f80c5743180ba$export$7afd9c1079ecedf7)(msg.fields[0], app.Presets);
                $256f9899b89282e9$export$68cfa81e36b6a2f4(presets_1);
                return new (0, $3699f71d1df66484$export$86fbec116b87613f)(app.Data, presets_1, app.State);
            }
        case 2:
            return new (0, $3699f71d1df66484$export$86fbec116b87613f)(app.Data, msg.fields[0], app.State);
        case 3:
            localStorage.clear();
            window.location.reload();
            return app;
        default:
            {
                let state;
                const tupledArg = app.State;
                state = (0, $7c6f80c5743180ba$export$ca000e230c0caa3e)(msg.fields[0], app.Data, tupledArg[0], tupledArg[1]);
                $256f9899b89282e9$export$fb931cd598921492(state);
                return new (0, $3699f71d1df66484$export$86fbec116b87613f)(app.Data, app.Presets, state);
            }
    }
}
function $256f9899b89282e9$export$4dfed9b4d2d19ef6(e, dispatch) {
    let elems, children_2, children, str, children_4;
    return /*#__PURE__*/ (0, $hURbM.createElement)("div", (0, $kRS0m.createObj)((0, $e08834e1786645d9$export$cb197a913f6bb809)([
        [
            "id",
            "app-error"
        ],
        (elems = [
            (children_2 = (0, $e08834e1786645d9$export$439306a4dcaafbb9)((0, $d28ec4fb6293f25e$export$382c1e24b4db459f)((children = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                (str = "\r\n          Whoops, something went wrong. Please try reloading the page.\r\n          If this message remains after reloading the page, try doing a\r\n        ", str),
                (0, $a56e1de91baad685$export$73abe46c91b8b074)(dispatch)
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children))
            })))), /*#__PURE__*/ (0, $hURbM.createElement)("span", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_2))
            })),
            (children_4 = (0, $e08834e1786645d9$export$cb197a913f6bb809)([
                /*#__PURE__*/ (0, $hURbM.createElement)("summary", {
                    children: [
                        "Error Message"
                    ]
                }),
                /*#__PURE__*/ (0, $hURbM.createElement)("div", {
                    children: [
                        (0, $7802b3aa01031554$export$598ff36d54604b81)((0, $7802b3aa01031554$export$d1317194012d6b34)("%A"))(e)
                    ]
                })
            ]), /*#__PURE__*/ (0, $hURbM.createElement)("details", {
                children: (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(children_4))
            }))
        ], [
            "children",
            (0, $f559a3d33a977349$export$88214af1db8f02e1).Children.toArray(Array.from(elems))
        ])
    ])));
}
function $256f9899b89282e9$export$c4ddc81c7b2c8d7a(app, dispatch) {
    try {
        return /*#__PURE__*/ (0, $hURbM.createElement)((0, $5b7a912ee26f9a3d$export$e926676385687eaf), {
            fallbackRender: (e)=>$256f9899b89282e9$export$4dfed9b4d2d19ef6(e.error, dispatch),
            children: [
                (0, $7a6cdebd170bd837$export$fe2e36411d703b3d)(app, (arg)=>{
                    dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(0, [
                        arg
                    ]));
                }),
                (0, $a56e1de91baad685$export$fe2e36411d703b3d)(app, dispatch)
            ]
        });
    } catch (e_1) {
        (0, $3699f71d1df66484$export$15e20ddeb406d406).log((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(e_1));
        return $256f9899b89282e9$export$4dfed9b4d2d19ef6(e_1, dispatch);
    }
}
function $256f9899b89282e9$export$8beb66979af2698c(dispatch) {
    (0, $6107b71bda0f6ed5$export$150ab4375b03de9b)((arg)=>{
        dispatch(new (0, $7c6f80c5743180ba$export$da423d5c8ff19e85)(2, [
            arg
        ]));
    });
    return {
        Dispose () {}
    };
}
(0, $94ef8c33912f1c43$export$bf201e6f292f34fd)((0, $59ff45db8a5d7670$export$eb041fa74866fdee)("app", (0, $94ef8c33912f1c43$export$5f45d655e6682635)((_arg)=>(0, $e08834e1786645d9$export$439306a4dcaafbb9)([
        (0, $e08834e1786645d9$export$439306a4dcaafbb9)("localStorage"),
        $256f9899b89282e9$export$8beb66979af2698c
    ]), (0, $94ef8c33912f1c43$export$4338a2efe643dfa3)((tupledArg)=>{
    (0, $3699f71d1df66484$export$15e20ddeb406d406).error((0, $22d1a4cfc5fba7ce$export$ad14ef4001db2bcd)(new Error(tupledArg[0], {
        cause: tupledArg[1]
    })));
}, (0, $94ef8c33912f1c43$export$4e9ed9c262e4f494)((0, $6107b71bda0f6ed5$export$ce646708c34d95b6), $256f9899b89282e9$export$722fbec263ad908a, $256f9899b89282e9$export$c4ddc81c7b2c8d7a)))));


//# sourceMappingURL=public.d3a775ef.js.map
